/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		52:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + ({"0":"index","2":"terms","4":"main","51":"register"}[chunkId]||chunkId) + "-" + {"0":"1786d181c4cffea7e98b","1":"8e6d0e2209cbc493c663","2":"9a177ef1edbe6a48688e","3":"3b2aaff6588189c2cc07","4":"09da34c3190020ae7f3f","5":"85e690f019603f0cd1c3","6":"114f4e84dff145786c4d","7":"fe145ef567bef07a45af","8":"38f7f90a12ddd54bb2e3","9":"dbf8aa878eb26880d9f2","10":"05c63233796295f13d88","11":"4cdf3d552b77bfdc37b5","12":"f1c564ef5d283e0780c1","13":"2b36388ffe539a1d5eeb","14":"2f5ba3f33eef6d419efb","15":"d640d15fa2a43c363b74","16":"8bd330be1b6bc4a99b87","17":"912d7c129d7bdaef1b69","18":"7e5bd6b6290ce4e59c03","19":"01bb6dd007a13c853c3b","20":"bad8a16d6855ee359b91","21":"aa67d1544aa87805906e","22":"0a4722f25964ad7271ee","23":"d09052ea15dd10d4c663","24":"908783b960e4a368bc44","25":"df490bd0948f05806d44","26":"81df764bac4a74807812","27":"b6010d7c580d594b9545","28":"3e4a1f191e270152feec","29":"74c208dfe3f108cac7b3","30":"d639acfc1790d3161726","31":"71a07be95400335eff54","32":"865932f68eb35738bf58","33":"6e8df8b8b490a0f780f2","34":"3536db97946fa3f3bf28","35":"16e6736e5cd40070eb0b","36":"8540065868f72e047bfb","37":"262c3d111beb9b206e61","38":"3ac32db4300b8c729b72","39":"2525a96c169241a4ae1e","40":"35e7142898418b1f1886","41":"a30c67c727ea5247e582","42":"91fd7aeb3c67113e87ac","43":"ce0ffc93bd42bd9273c6","44":"7cd49411d5d09a6fc011","45":"1479ef99542d9c0f1192","46":"e5ddf3bb13608cd7f2a1","47":"e57794073a553511d28f","48":"fd06352791f2ed02ce42","49":"5caa0b8b2692a264c46e","50":"c67494aef1f95db880ba","51":"e004d3e470e2895cfa0a"}[chunkId] + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(2);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$q"] = __webpack_require__(3);
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v1.8.3
	 * http://jquery.com/
	 *
	 * Includes Sizzle.js
	 * http://sizzlejs.com/
	 *
	 * Copyright 2012 jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: Tue Nov 13 2012 08:20:33 GMT-0500 (Eastern Standard Time)
	 */
	(function( window, undefined ) {
	var
	        // A central reference to the root jQuery(document)
	        rootjQuery,
	
	        // The deferred used on DOM ready
	        readyList,
	
	        // Use the correct document accordingly with window argument (sandbox)
	        document = window.document,
	        location = window.location,
	        navigator = window.navigator,
	
	        // Map over jQuery in case of overwrite
	        _jQuery = window.jQuery,
	
	        // Map over the $ in case of overwrite
	        _$ = window.$,
	
	        // Save a reference to some core methods
	        core_push = Array.prototype.push,
	        core_slice = Array.prototype.slice,
	        core_indexOf = Array.prototype.indexOf,
	        core_toString = Object.prototype.toString,
	        core_hasOwn = Object.prototype.hasOwnProperty,
	        core_trim = String.prototype.trim,
	
	        // Define a local copy of jQuery
	        jQuery = function( selector, context ) {
	                // The jQuery object is actually just the init constructor 'enhanced'
	                return new jQuery.fn.init( selector, context, rootjQuery );
	        },
	
	        // Used for matching numbers
	        core_pnum = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source,
	
	        // Used for detecting and trimming whitespace
	        core_rnotwhite = /\S/,
	        core_rspace = /\s+/,
	
	        // Make sure we trim BOM and NBSP (here's looking at you, Safari 5.0 and IE)
	        rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
	        // A simple way to check for HTML strings
	        // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	        rquickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/,
	
	        // Match a standalone tag
	        rsingleTag = /^<(\w+)\s*\/?>(?:<\/\1>|)$/,
	
	        // JSON RegExp
	        rvalidchars = /^[\],:{}\s]*$/,
	        rvalidbraces = /(?:^|:|,)(?:\s*\[)+/g,
	        rvalidescape = /\\(?:["\\\/bfnrt]|u[\da-fA-F]{4})/g,
	        rvalidtokens = /"[^"\\\r\n]*"|true|false|null|-?(?:\d\d*\.|)\d+(?:[eE][\-+]?\d+|)/g,
	
	        // Matches dashed string for camelizing
	        rmsPrefix = /^-ms-/,
	        rdashAlpha = /-([\da-z])/gi,
	
	        // Used by jQuery.camelCase as callback to replace()
	        fcamelCase = function( all, letter ) {
	                return ( letter + "" ).toUpperCase();
	        },
	
	        // The ready event handler and self cleanup method
	        DOMContentLoaded = function() {
	                if ( document.addEventListener ) {
	                        document.removeEventListener( "DOMContentLoaded", DOMContentLoaded, false );
	                        jQuery.ready();
	                } else if ( document.readyState === "complete" ) {
	                        // we're here because readyState === "complete" in oldIE
	                        // which is good enough for us to call the dom ready!
	                        document.detachEvent( "onreadystatechange", DOMContentLoaded );
	                        jQuery.ready();
	                }
	        },
	
	        // [[Class]] -> type pairs
	        class2type = {};
	
	jQuery.fn = jQuery.prototype = {
	        constructor: jQuery,
	        init: function( selector, context, rootjQuery ) {
	                var match, elem, ret, doc;
	
	                // Handle $(""), $(null), $(undefined), $(false)
	                if ( !selector ) {
	                        return this;
	                }
	
	                // Handle $(DOMElement)
	                if ( selector.nodeType ) {
	                        this.context = this[0] = selector;
	                        this.length = 1;
	                        return this;
	                }
	
	                // Handle HTML strings
	                if ( typeof selector === "string" ) {
	                        if ( selector.charAt(0) === "<" && selector.charAt( selector.length - 1 ) === ">" && selector.length >= 3 ) {
	                                // Assume that strings that start and end with <> are HTML and skip the regex check
	                                match = [ null, selector, null ];
	
	                        } else {
	                                match = rquickExpr.exec( selector );
	                        }
	
	                        // Match html or make sure no context is specified for #id
	                        if ( match && (match[1] || !context) ) {
	
	                                // HANDLE: $(html) -> $(array)
	                                if ( match[1] ) {
	                                        context = context instanceof jQuery ? context[0] : context;
	                                        doc = ( context && context.nodeType ? context.ownerDocument || context : document );
	
	                                        // scripts is true for back-compat
	                                        selector = jQuery.parseHTML( match[1], doc, true );
	                                        if ( rsingleTag.test( match[1] ) && jQuery.isPlainObject( context ) ) {
	                                                this.attr.call( selector, context, true );
	                                        }
	
	                                        return jQuery.merge( this, selector );
	
	                                // HANDLE: $(#id)
	                                } else {
	                                        elem = document.getElementById( match[2] );
	
	                                        // Check parentNode to catch when Blackberry 4.6 returns
	                                        // nodes that are no longer in the document #6963
	                                        if ( elem && elem.parentNode ) {
	                                                // Handle the case where IE and Opera return items
	                                                // by name instead of ID
	                                                if ( elem.id !== match[2] ) {
	                                                        return rootjQuery.find( selector );
	                                                }
	
	                                                // Otherwise, we inject the element directly into the jQuery object
	                                                this.length = 1;
	                                                this[0] = elem;
	                                        }
	
	                                        this.context = document;
	                                        this.selector = selector;
	                                        return this;
	                                }
	
	                        // HANDLE: $(expr, $(...))
	                        } else if ( !context || context.jquery ) {
	                                return ( context || rootjQuery ).find( selector );
	
	                        // HANDLE: $(expr, context)
	                        // (which is just equivalent to: $(context).find(expr)
	                        } else {
	                                return this.constructor( context ).find( selector );
	                        }
	
	                // HANDLE: $(function)
	                // Shortcut for document ready
	                } else if ( jQuery.isFunction( selector ) ) {
	                        return rootjQuery.ready( selector );
	                }
	
	                if ( selector.selector !== undefined ) {
	                        this.selector = selector.selector;
	                        this.context = selector.context;
	                }
	
	                return jQuery.makeArray( selector, this );
	        },
	
	        // Start with an empty selector
	        selector: "",
	
	        // The current version of jQuery being used
	        jquery: "1.8.3",
	
	        // The default length of a jQuery object is 0
	        length: 0,
	
	        // The number of elements contained in the matched element set
	        size: function() {
	                return this.length;
	        },
	
	        toArray: function() {
	                return core_slice.call( this );
	        },
	
	        // Get the Nth element in the matched element set OR
	        // Get the whole matched element set as a clean array
	        get: function( num ) {
	                return num == null ?
	
	                        // Return a 'clean' array
	                        this.toArray() :
	
	                        // Return just the object
	                        ( num < 0 ? this[ this.length + num ] : this[ num ] );
	        },
	
	        // Take an array of elements and push it onto the stack
	        // (returning the new matched element set)
	        pushStack: function( elems, name, selector ) {
	
	                // Build a new jQuery matched element set
	                var ret = jQuery.merge( this.constructor(), elems );
	
	                // Add the old object onto the stack (as a reference)
	                ret.prevObject = this;
	
	                ret.context = this.context;
	
	                if ( name === "find" ) {
	                        ret.selector = this.selector + ( this.selector ? " " : "" ) + selector;
	                } else if ( name ) {
	                        ret.selector = this.selector + "." + name + "(" + selector + ")";
	                }
	
	                // Return the newly-formed element set
	                return ret;
	        },
	
	        // Execute a callback for every element in the matched set.
	        // (You can seed the arguments with an array of args, but this is
	        // only used internally.)
	        each: function( callback, args ) {
	                return jQuery.each( this, callback, args );
	        },
	
	        ready: function( fn ) {
	                // Add the callback
	                jQuery.ready.promise().done( fn );
	
	                return this;
	        },
	
	        eq: function( i ) {
	                i = +i;
	                return i === -1 ?
	                        this.slice( i ) :
	                        this.slice( i, i + 1 );
	        },
	
	        first: function() {
	                return this.eq( 0 );
	        },
	
	        last: function() {
	                return this.eq( -1 );
	        },
	
	        slice: function() {
	                return this.pushStack( core_slice.apply( this, arguments ),
	                        "slice", core_slice.call(arguments).join(",") );
	        },
	
	        map: function( callback ) {
	                return this.pushStack( jQuery.map(this, function( elem, i ) {
	                        return callback.call( elem, i, elem );
	                }));
	        },
	
	        end: function() {
	                return this.prevObject || this.constructor(null);
	        },
	
	        // For internal use only.
	        // Behaves like an Array's method, not like a jQuery method.
	        push: core_push,
	        sort: [].sort,
	        splice: [].splice
	};
	
	// Give the init function the jQuery prototype for later instantiation
	jQuery.fn.init.prototype = jQuery.fn;
	
	jQuery.extend = jQuery.fn.extend = function() {
	        var options, name, src, copy, copyIsArray, clone,
	                target = arguments[0] || {},
	                i = 1,
	                length = arguments.length,
	                deep = false;
	
	        // Handle a deep copy situation
	        if ( typeof target === "boolean" ) {
	                deep = target;
	                target = arguments[1] || {};
	                // skip the boolean and the target
	                i = 2;
	        }
	
	        // Handle case when target is a string or something (possible in deep copy)
	        if ( typeof target !== "object" && !jQuery.isFunction(target) ) {
	                target = {};
	        }
	
	        // extend jQuery itself if only one argument is passed
	        if ( length === i ) {
	                target = this;
	                --i;
	        }
	
	        for ( ; i < length; i++ ) {
	                // Only deal with non-null/undefined values
	                if ( (options = arguments[ i ]) != null ) {
	                        // Extend the base object
	                        for ( name in options ) {
	                                src = target[ name ];
	                                copy = options[ name ];
	
	                                // Prevent never-ending loop
	                                if ( target === copy ) {
	                                        continue;
	                                }
	
	                                // Recurse if we're merging plain objects or arrays
	                                if ( deep && copy && ( jQuery.isPlainObject(copy) || (copyIsArray = jQuery.isArray(copy)) ) ) {
	                                        if ( copyIsArray ) {
	                                                copyIsArray = false;
	                                                clone = src && jQuery.isArray(src) ? src : [];
	
	                                        } else {
	                                                clone = src && jQuery.isPlainObject(src) ? src : {};
	                                        }
	
	                                        // Never move original objects, clone them
	                                        target[ name ] = jQuery.extend( deep, clone, copy );
	
	                                // Don't bring in undefined values
	                                } else if ( copy !== undefined ) {
	                                        target[ name ] = copy;
	                                }
	                        }
	                }
	        }
	
	        // Return the modified object
	        return target;
	};
	
	jQuery.extend({
	        noConflict: function( deep ) {
	                if ( window.$ === jQuery ) {
	                        window.$ = _$;
	                }
	
	                if ( deep && window.jQuery === jQuery ) {
	                        window.jQuery = _jQuery;
	                }
	
	                return jQuery;
	        },
	
	        // Is the DOM ready to be used? Set to true once it occurs.
	        isReady: false,
	
	        // A counter to track how many items to wait for before
	        // the ready event fires. See #6781
	        readyWait: 1,
	
	        // Hold (or release) the ready event
	        holdReady: function( hold ) {
	                if ( hold ) {
	                        jQuery.readyWait++;
	                } else {
	                        jQuery.ready( true );
	                }
	        },
	
	        // Handle when the DOM is ready
	        ready: function( wait ) {
	
	                // Abort if there are pending holds or we're already ready
	                if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
	                        return;
	                }
	
	                // Make sure body exists, at least, in case IE gets a little overzealous (ticket #5443).
	                if ( !document.body ) {
	                        return setTimeout( jQuery.ready, 1 );
	                }
	
	                // Remember that the DOM is ready
	                jQuery.isReady = true;
	
	                // If a normal DOM Ready event fired, decrement, and wait if need be
	                if ( wait !== true && --jQuery.readyWait > 0 ) {
	                        return;
	                }
	
	                // If there are functions bound, to execute
	                readyList.resolveWith( document, [ jQuery ] );
	
	                // Trigger any bound ready events
	                if ( jQuery.fn.trigger ) {
	                        jQuery( document ).trigger("ready").off("ready");
	                }
	        },
	
	        // See test/unit/core.js for details concerning isFunction.
	        // Since version 1.3, DOM methods and functions like alert
	        // aren't supported. They return false on IE (#2968).
	        isFunction: function( obj ) {
	                return jQuery.type(obj) === "function";
	        },
	
	        isArray: Array.isArray || function( obj ) {
	                return jQuery.type(obj) === "array";
	        },
	
	        isWindow: function( obj ) {
	                return obj != null && obj == obj.window;
	        },
	
	        isNumeric: function( obj ) {
	                return !isNaN( parseFloat(obj) ) && isFinite( obj );
	        },
	
	        type: function( obj ) {
	                return obj == null ?
	                        String( obj ) :
	                        class2type[ core_toString.call(obj) ] || "object";
	        },
	
	        isPlainObject: function( obj ) {
	                // Must be an Object.
	                // Because of IE, we also have to check the presence of the constructor property.
	                // Make sure that DOM nodes and window objects don't pass through, as well
	                if ( !obj || jQuery.type(obj) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
	                        return false;
	                }
	
	                try {
	                        // Not own constructor property must be Object
	                        if ( obj.constructor &&
	                                !core_hasOwn.call(obj, "constructor") &&
	                                !core_hasOwn.call(obj.constructor.prototype, "isPrototypeOf") ) {
	                                return false;
	                        }
	                } catch ( e ) {
	                        // IE8,9 Will throw exceptions on certain host objects #9897
	                        return false;
	                }
	
	                // Own properties are enumerated firstly, so to speed up,
	                // if last one is own, then all properties are own.
	
	                var key;
	                for ( key in obj ) {}
	
	                return key === undefined || core_hasOwn.call( obj, key );
	        },
	
	        isEmptyObject: function( obj ) {
	                var name;
	                for ( name in obj ) {
	                        return false;
	                }
	                return true;
	        },
	
	        error: function( msg ) {
	                throw new Error( msg );
	        },
	
	        // data: string of html
	        // context (optional): If specified, the fragment will be created in this context, defaults to document
	        // scripts (optional): If true, will include scripts passed in the html string
	        parseHTML: function( data, context, scripts ) {
	                var parsed;
	                if ( !data || typeof data !== "string" ) {
	                        return null;
	                }
	                if ( typeof context === "boolean" ) {
	                        scripts = context;
	                        context = 0;
	                }
	                context = context || document;
	
	                // Single tag
	                if ( (parsed = rsingleTag.exec( data )) ) {
	                        return [ context.createElement( parsed[1] ) ];
	                }
	
	                parsed = jQuery.buildFragment( [ data ], context, scripts ? null : [] );
	                return jQuery.merge( [],
	                        (parsed.cacheable ? jQuery.clone( parsed.fragment ) : parsed.fragment).childNodes );
	        },
	
	        parseJSON: function( data ) {
	                if ( !data || typeof data !== "string") {
	                        return null;
	                }
	
	                // Make sure leading/trailing whitespace is removed (IE can't handle it)
	                data = jQuery.trim( data );
	
	                // Attempt to parse using the native JSON parser first
	                if ( window.JSON && window.JSON.parse ) {
	                        return window.JSON.parse( data );
	                }
	
	                // Make sure the incoming data is actual JSON
	                // Logic borrowed from http://json.org/json2.js
	                if ( rvalidchars.test( data.replace( rvalidescape, "@" )
	                        .replace( rvalidtokens, "]" )
	                        .replace( rvalidbraces, "")) ) {
	
	                        return ( new Function( "return " + data ) )();
	
	                }
	                jQuery.error( "Invalid JSON: " + data );
	        },
	
	        // Cross-browser xml parsing
	        parseXML: function( data ) {
	                var xml, tmp;
	                if ( !data || typeof data !== "string" ) {
	                        return null;
	                }
	                try {
	                        if ( window.DOMParser ) { // Standard
	                                tmp = new DOMParser();
	                                xml = tmp.parseFromString( data , "text/xml" );
	                        } else { // IE
	                                xml = new ActiveXObject( "Microsoft.XMLDOM" );
	                                xml.async = "false";
	                                xml.loadXML( data );
	                        }
	                } catch( e ) {
	                        xml = undefined;
	                }
	                if ( !xml || !xml.documentElement || xml.getElementsByTagName( "parsererror" ).length ) {
	                        jQuery.error( "Invalid XML: " + data );
	                }
	                return xml;
	        },
	
	        noop: function() {},
	
	        // Evaluates a script in a global context
	        // Workarounds based on findings by Jim Driscoll
	        // http://weblogs.java.net/blog/driscoll/archive/2009/09/08/eval-javascript-global-context
	        globalEval: function( data ) {
	                if ( data && core_rnotwhite.test( data ) ) {
	                        // We use execScript on Internet Explorer
	                        // We use an anonymous function so that context is window
	                        // rather than jQuery in Firefox
	                        ( window.execScript || function( data ) {
	                                window[ "eval" ].call( window, data );
	                        } )( data );
	                }
	        },
	
	        // Convert dashed to camelCase; used by the css and data modules
	        // Microsoft forgot to hump their vendor prefix (#9572)
	        camelCase: function( string ) {
	                return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	        },
	
	        nodeName: function( elem, name ) {
	                return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	        },
	
	        // args is for internal usage only
	        each: function( obj, callback, args ) {
	                var name,
	                        i = 0,
	                        length = obj.length,
	                        isObj = length === undefined || jQuery.isFunction( obj );
	
	                if ( args ) {
	                        if ( isObj ) {
	                                for ( name in obj ) {
	                                        if ( callback.apply( obj[ name ], args ) === false ) {
	                                                break;
	                                        }
	                                }
	                        } else {
	                                for ( ; i < length; ) {
	                                        if ( callback.apply( obj[ i++ ], args ) === false ) {
	                                                break;
	                                        }
	                                }
	                        }
	
	                // A special, fast, case for the most common use of each
	                } else {
	                        if ( isObj ) {
	                                for ( name in obj ) {
	                                        if ( callback.call( obj[ name ], name, obj[ name ] ) === false ) {
	                                                break;
	                                        }
	                                }
	                        } else {
	                                for ( ; i < length; ) {
	                                        if ( callback.call( obj[ i ], i, obj[ i++ ] ) === false ) {
	                                                break;
	                                        }
	                                }
	                        }
	                }
	
	                return obj;
	        },
	
	        // Use native String.trim function wherever possible
	        trim: core_trim && !core_trim.call("\uFEFF\xA0") ?
	                function( text ) {
	                        return text == null ?
	                                "" :
	                                core_trim.call( text );
	                } :
	
	                // Otherwise use our own trimming functionality
	                function( text ) {
	                        return text == null ?
	                                "" :
	                                ( text + "" ).replace( rtrim, "" );
	                },
	
	        // results is for internal usage only
	        makeArray: function( arr, results ) {
	                var type,
	                        ret = results || [];
	
	                if ( arr != null ) {
	                        // The window, strings (and functions) also have 'length'
	                        // Tweaked logic slightly to handle Blackberry 4.7 RegExp issues #6930
	                        type = jQuery.type( arr );
	
	                        if ( arr.length == null || type === "string" || type === "function" || type === "regexp" || jQuery.isWindow( arr ) ) {
	                                core_push.call( ret, arr );
	                        } else {
	                                jQuery.merge( ret, arr );
	                        }
	                }
	
	                return ret;
	        },
	
	        inArray: function( elem, arr, i ) {
	                var len;
	
	                if ( arr ) {
	                        if ( core_indexOf ) {
	                                return core_indexOf.call( arr, elem, i );
	                        }
	
	                        len = arr.length;
	                        i = i ? i < 0 ? Math.max( 0, len + i ) : i : 0;
	
	                        for ( ; i < len; i++ ) {
	                                // Skip accessing in sparse arrays
	                                if ( i in arr && arr[ i ] === elem ) {
	                                        return i;
	                                }
	                        }
	                }
	
	                return -1;
	        },
	
	        merge: function( first, second ) {
	                var l = second.length,
	                        i = first.length,
	                        j = 0;
	
	                if ( typeof l === "number" ) {
	                        for ( ; j < l; j++ ) {
	                                first[ i++ ] = second[ j ];
	                        }
	
	                } else {
	                        while ( second[j] !== undefined ) {
	                                first[ i++ ] = second[ j++ ];
	                        }
	                }
	
	                first.length = i;
	
	                return first;
	        },
	
	        grep: function( elems, callback, inv ) {
	                var retVal,
	                        ret = [],
	                        i = 0,
	                        length = elems.length;
	                inv = !!inv;
	
	                // Go through the array, only saving the items
	                // that pass the validator function
	                for ( ; i < length; i++ ) {
	                        retVal = !!callback( elems[ i ], i );
	                        if ( inv !== retVal ) {
	                                ret.push( elems[ i ] );
	                        }
	                }
	
	                return ret;
	        },
	
	        // arg is for internal usage only
	        map: function( elems, callback, arg ) {
	                var value, key,
	                        ret = [],
	                        i = 0,
	                        length = elems.length,
	                        // jquery objects are treated as arrays
	                        isArray = elems instanceof jQuery || length !== undefined && typeof length === "number" && ( ( length > 0 && elems[ 0 ] && elems[ length -1 ] ) || length === 0 || jQuery.isArray( elems ) ) ;
	
	                // Go through the array, translating each of the items to their
	                if ( isArray ) {
	                        for ( ; i < length; i++ ) {
	                                value = callback( elems[ i ], i, arg );
	
	                                if ( value != null ) {
	                                        ret[ ret.length ] = value;
	                                }
	                        }
	
	                // Go through every key on the object,
	                } else {
	                        for ( key in elems ) {
	                                value = callback( elems[ key ], key, arg );
	
	                                if ( value != null ) {
	                                        ret[ ret.length ] = value;
	                                }
	                        }
	                }
	
	                // Flatten any nested arrays
	                return ret.concat.apply( [], ret );
	        },
	
	        // A global GUID counter for objects
	        guid: 1,
	
	        // Bind a function to a context, optionally partially applying any
	        // arguments.
	        proxy: function( fn, context ) {
	                var tmp, args, proxy;
	
	                if ( typeof context === "string" ) {
	                        tmp = fn[ context ];
	                        context = fn;
	                        fn = tmp;
	                }
	
	                // Quick check to determine if target is callable, in the spec
	                // this throws a TypeError, but we will just return undefined.
	                if ( !jQuery.isFunction( fn ) ) {
	                        return undefined;
	                }
	
	                // Simulated bind
	                args = core_slice.call( arguments, 2 );
	                proxy = function() {
	                        return fn.apply( context, args.concat( core_slice.call( arguments ) ) );
	                };
	
	                // Set the guid of unique handler to the same of original handler, so it can be removed
	                proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
	                return proxy;
	        },
	
	        // Multifunctional method to get and set values of a collection
	        // The value/s can optionally be executed if it's a function
	        access: function( elems, fn, key, value, chainable, emptyGet, pass ) {
	                var exec,
	                        bulk = key == null,
	                        i = 0,
	                        length = elems.length;
	
	                // Sets many values
	                if ( key && typeof key === "object" ) {
	                        for ( i in key ) {
	                                jQuery.access( elems, fn, i, key[i], 1, emptyGet, value );
	                        }
	                        chainable = 1;
	
	                // Sets one value
	                } else if ( value !== undefined ) {
	                        // Optionally, function values get executed if exec is true
	                        exec = pass === undefined && jQuery.isFunction( value );
	
	                        if ( bulk ) {
	                                // Bulk operations only iterate when executing function values
	                                if ( exec ) {
	                                        exec = fn;
	                                        fn = function( elem, key, value ) {
	                                                return exec.call( jQuery( elem ), value );
	                                        };
	
	                                // Otherwise they run against the entire set
	                                } else {
	                                        fn.call( elems, value );
	                                        fn = null;
	                                }
	                        }
	
	                        if ( fn ) {
	                                for (; i < length; i++ ) {
	                                        fn( elems[i], key, exec ? value.call( elems[i], i, fn( elems[i], key ) ) : value, pass );
	                                }
	                        }
	
	                        chainable = 1;
	                }
	
	                return chainable ?
	                        elems :
	
	                        // Gets
	                        bulk ?
	                                fn.call( elems ) :
	                                length ? fn( elems[0], key ) : emptyGet;
	        },
	
	        now: function() {
	                return ( new Date() ).getTime();
	        }
	});
	
	jQuery.ready.promise = function( obj ) {
	        if ( !readyList ) {
	
	                readyList = jQuery.Deferred();
	
	                // Catch cases where $(document).ready() is called after the browser event has already occurred.
	                // we once tried to use readyState "interactive" here, but it caused issues like the one
	                // discovered by ChrisS here: http://bugs.jquery.com/ticket/12282#comment:15
	                if ( document.readyState === "complete" ) {
	                        // Handle it asynchronously to allow scripts the opportunity to delay ready
	                        setTimeout( jQuery.ready, 1 );
	
	                // Standards-based browsers support DOMContentLoaded
	                } else if ( document.addEventListener ) {
	                        // Use the handy event callback
	                        document.addEventListener( "DOMContentLoaded", DOMContentLoaded, false );
	
	                        // A fallback to window.onload, that will always work
	                        window.addEventListener( "load", jQuery.ready, false );
	
	                // If IE event model is used
	                } else {
	                        // Ensure firing before onload, maybe late but safe also for iframes
	                        document.attachEvent( "onreadystatechange", DOMContentLoaded );
	
	                        // A fallback to window.onload, that will always work
	                        window.attachEvent( "onload", jQuery.ready );
	
	                        // If IE and not a frame
	                        // continually check to see if the document is ready
	                        var top = false;
	
	                        try {
	                                top = window.frameElement == null && document.documentElement;
	                        } catch(e) {}
	
	                        if ( top && top.doScroll ) {
	                                (function doScrollCheck() {
	                                        if ( !jQuery.isReady ) {
	
	                                                try {
	                                                        // Use the trick by Diego Perini
	                                                        // http://javascript.nwbox.com/IEContentLoaded/
	                                                        top.doScroll("left");
	                                                } catch(e) {
	                                                        return setTimeout( doScrollCheck, 50 );
	                                                }
	
	                                                // and execute any waiting functions
	                                                jQuery.ready();
	                                        }
	                                })();
	                        }
	                }
	        }
	        return readyList.promise( obj );
	};
	
	// Populate the class2type map
	jQuery.each("Boolean Number String Function Array Date RegExp Object".split(" "), function(i, name) {
	        class2type[ "[object " + name + "]" ] = name.toLowerCase();
	});
	
	// All jQuery objects should point back to these
	rootjQuery = jQuery(document);
	// String to Object options format cache
	var optionsCache = {};
	
	// Convert String-formatted options into Object-formatted ones and store in cache
	function createOptions( options ) {
	        var object = optionsCache[ options ] = {};
	        jQuery.each( options.split( core_rspace ), function( _, flag ) {
	                object[ flag ] = true;
	        });
	        return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *      options: an optional list of space-separated options that will change how
	 *                      the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *      once:                   will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *      memory:                 will keep track of previous values and will call any callback added
	 *                                      after the list has been fired right away with the latest "memorized"
	 *                                      values (like a Deferred)
	 *
	 *      unique:                 will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *      stopOnFalse:    interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
	        // Convert options from String-formatted to Object-formatted if needed
	        // (we check in cache first)
	        options = typeof options === "string" ?
	                ( optionsCache[ options ] || createOptions( options ) ) :
	                jQuery.extend( {}, options );
	
	        var // Last fire value (for non-forgettable lists)
	                memory,
	                // Flag to know if list was already fired
	                fired,
	                // Flag to know if list is currently firing
	                firing,
	                // First callback to fire (used internally by add and fireWith)
	                firingStart,
	                // End of the loop when firing
	                firingLength,
	                // Index of currently firing callback (modified by remove if needed)
	                firingIndex,
	                // Actual callback list
	                list = [],
	                // Stack of fire calls for repeatable lists
	                stack = !options.once && [],
	                // Fire callbacks
	                fire = function( data ) {
	                        memory = options.memory && data;
	                        fired = true;
	                        firingIndex = firingStart || 0;
	                        firingStart = 0;
	                        firingLength = list.length;
	                        firing = true;
	                        for ( ; list && firingIndex < firingLength; firingIndex++ ) {
	                                if ( list[ firingIndex ].apply( data[ 0 ], data[ 1 ] ) === false && options.stopOnFalse ) {
	                                        memory = false; // To prevent further calls using add
	                                        break;
	                                }
	                        }
	                        firing = false;
	                        if ( list ) {
	                                if ( stack ) {
	                                        if ( stack.length ) {
	                                                fire( stack.shift() );
	                                        }
	                                } else if ( memory ) {
	                                        list = [];
	                                } else {
	                                        self.disable();
	                                }
	                        }
	                },
	                // Actual Callbacks object
	                self = {
	                        // Add a callback or a collection of callbacks to the list
	                        add: function() {
	                                if ( list ) {
	                                        // First, we save the current length
	                                        var start = list.length;
	                                        (function add( args ) {
	                                                jQuery.each( args, function( _, arg ) {
	                                                        var type = jQuery.type( arg );
	                                                        if ( type === "function" ) {
	                                                                if ( !options.unique || !self.has( arg ) ) {
	                                                                        list.push( arg );
	                                                                }
	                                                        } else if ( arg && arg.length && type !== "string" ) {
	                                                                // Inspect recursively
	                                                                add( arg );
	                                                        }
	                                                });
	                                        })( arguments );
	                                        // Do we need to add the callbacks to the
	                                        // current firing batch?
	                                        if ( firing ) {
	                                                firingLength = list.length;
	                                        // With memory, if we're not firing then
	                                        // we should call right away
	                                        } else if ( memory ) {
	                                                firingStart = start;
	                                                fire( memory );
	                                        }
	                                }
	                                return this;
	                        },
	                        // Remove a callback from the list
	                        remove: function() {
	                                if ( list ) {
	                                        jQuery.each( arguments, function( _, arg ) {
	                                                var index;
	                                                while( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
	                                                        list.splice( index, 1 );
	                                                        // Handle firing indexes
	                                                        if ( firing ) {
	                                                                if ( index <= firingLength ) {
	                                                                        firingLength--;
	                                                                }
	                                                                if ( index <= firingIndex ) {
	                                                                        firingIndex--;
	                                                                }
	                                                        }
	                                                }
	                                        });
	                                }
	                                return this;
	                        },
	                        // Control if a given callback is in the list
	                        has: function( fn ) {
	                                return jQuery.inArray( fn, list ) > -1;
	                        },
	                        // Remove all callbacks from the list
	                        empty: function() {
	                                list = [];
	                                return this;
	                        },
	                        // Have the list do nothing anymore
	                        disable: function() {
	                                list = stack = memory = undefined;
	                                return this;
	                        },
	                        // Is it disabled?
	                        disabled: function() {
	                                return !list;
	                        },
	                        // Lock the list in its current state
	                        lock: function() {
	                                stack = undefined;
	                                if ( !memory ) {
	                                        self.disable();
	                                }
	                                return this;
	                        },
	                        // Is it locked?
	                        locked: function() {
	                                return !stack;
	                        },
	                        // Call all callbacks with the given context and arguments
	                        fireWith: function( context, args ) {
	                                args = args || [];
	                                args = [ context, args.slice ? args.slice() : args ];
	                                if ( list && ( !fired || stack ) ) {
	                                        if ( firing ) {
	                                                stack.push( args );
	                                        } else {
	                                                fire( args );
	                                        }
	                                }
	                                return this;
	                        },
	                        // Call all the callbacks with the given arguments
	                        fire: function() {
	                                self.fireWith( this, arguments );
	                                return this;
	                        },
	                        // To know if the callbacks have already been called at least once
	                        fired: function() {
	                                return !!fired;
	                        }
	                };
	
	        return self;
	};
	jQuery.extend({
	
	        Deferred: function( func ) {
	                var tuples = [
	                                // action, add listener, listener list, final state
	                                [ "resolve", "done", jQuery.Callbacks("once memory"), "resolved" ],
	                                [ "reject", "fail", jQuery.Callbacks("once memory"), "rejected" ],
	                                [ "notify", "progress", jQuery.Callbacks("memory") ]
	                        ],
	                        state = "pending",
	                        promise = {
	                                state: function() {
	                                        return state;
	                                },
	                                always: function() {
	                                        deferred.done( arguments ).fail( arguments );
	                                        return this;
	                                },
	                                then: function( /* fnDone, fnFail, fnProgress */ ) {
	                                        var fns = arguments;
	                                        return jQuery.Deferred(function( newDefer ) {
	                                                jQuery.each( tuples, function( i, tuple ) {
	                                                        var action = tuple[ 0 ],
	                                                                fn = fns[ i ];
	                                                        // deferred[ done | fail | progress ] for forwarding actions to newDefer
	                                                        deferred[ tuple[1] ]( jQuery.isFunction( fn ) ?
	                                                                function() {
	                                                                        var returned = fn.apply( this, arguments );
	                                                                        if ( returned && jQuery.isFunction( returned.promise ) ) {
	                                                                                returned.promise()
	                                                                                        .done( newDefer.resolve )
	                                                                                        .fail( newDefer.reject )
	                                                                                        .progress( newDefer.notify );
	                                                                        } else {
	                                                                                newDefer[ action + "With" ]( this === deferred ? newDefer : this, [ returned ] );
	                                                                        }
	                                                                } :
	                                                                newDefer[ action ]
	                                                        );
	                                                });
	                                                fns = null;
	                                        }).promise();
	                                },
	                                // Get a promise for this deferred
	                                // If obj is provided, the promise aspect is added to the object
	                                promise: function( obj ) {
	                                        return obj != null ? jQuery.extend( obj, promise ) : promise;
	                                }
	                        },
	                        deferred = {};
	
	                // Keep pipe for back-compat
	                promise.pipe = promise.then;
	
	                // Add list-specific methods
	                jQuery.each( tuples, function( i, tuple ) {
	                        var list = tuple[ 2 ],
	                                stateString = tuple[ 3 ];
	
	                        // promise[ done | fail | progress ] = list.add
	                        promise[ tuple[1] ] = list.add;
	
	                        // Handle state
	                        if ( stateString ) {
	                                list.add(function() {
	                                        // state = [ resolved | rejected ]
	                                        state = stateString;
	
	                                // [ reject_list | resolve_list ].disable; progress_list.lock
	                                }, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
	                        }
	
	                        // deferred[ resolve | reject | notify ] = list.fire
	                        deferred[ tuple[0] ] = list.fire;
	                        deferred[ tuple[0] + "With" ] = list.fireWith;
	                });
	
	                // Make the deferred a promise
	                promise.promise( deferred );
	
	                // Call given func if any
	                if ( func ) {
	                        func.call( deferred, deferred );
	                }
	
	                // All done!
	                return deferred;
	        },
	
	        // Deferred helper
	        when: function( subordinate /* , ..., subordinateN */ ) {
	                var i = 0,
	                        resolveValues = core_slice.call( arguments ),
	                        length = resolveValues.length,
	
	                        // the count of uncompleted subordinates
	                        remaining = length !== 1 || ( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,
	
	                        // the master Deferred. If resolveValues consist of only a single Deferred, just use that.
	                        deferred = remaining === 1 ? subordinate : jQuery.Deferred(),
	
	                        // Update function for both resolve and progress values
	                        updateFunc = function( i, contexts, values ) {
	                                return function( value ) {
	                                        contexts[ i ] = this;
	                                        values[ i ] = arguments.length > 1 ? core_slice.call( arguments ) : value;
	                                        if( values === progressValues ) {
	                                                deferred.notifyWith( contexts, values );
	                                        } else if ( !( --remaining ) ) {
	                                                deferred.resolveWith( contexts, values );
	                                        }
	                                };
	                        },
	
	                        progressValues, progressContexts, resolveContexts;
	
	                // add listeners to Deferred subordinates; treat others as resolved
	                if ( length > 1 ) {
	                        progressValues = new Array( length );
	                        progressContexts = new Array( length );
	                        resolveContexts = new Array( length );
	                        for ( ; i < length; i++ ) {
	                                if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
	                                        resolveValues[ i ].promise()
	                                                .done( updateFunc( i, resolveContexts, resolveValues ) )
	                                                .fail( deferred.reject )
	                                                .progress( updateFunc( i, progressContexts, progressValues ) );
	                                } else {
	                                        --remaining;
	                                }
	                        }
	                }
	
	                // if we're not waiting on anything, resolve the master
	                if ( !remaining ) {
	                        deferred.resolveWith( resolveContexts, resolveValues );
	                }
	
	                return deferred.promise();
	        }
	});
	jQuery.support = (function() {
	
	        var support,
	                all,
	                a,
	                select,
	                opt,
	                input,
	                fragment,
	                eventName,
	                i,
	                isSupported,
	                clickFn,
	                div = document.createElement("div");
	
	        // Setup
	        div.setAttribute( "className", "t" );
	        div.innerHTML = "  <link/><table></table><a href='/a'>a</a><input type='checkbox'/>";
	
	        // Support tests won't run in some limited or non-browser environments
	        all = div.getElementsByTagName("*");
	        a = div.getElementsByTagName("a")[ 0 ];
	        if ( !all || !a || !all.length ) {
	                return {};
	        }
	
	        // First batch of tests
	        select = document.createElement("select");
	        opt = select.appendChild( document.createElement("option") );
	        input = div.getElementsByTagName("input")[ 0 ];
	
	        a.style.cssText = "top:1px;float:left;opacity:.5";
	        support = {
	                // IE strips leading whitespace when .innerHTML is used
	                leadingWhitespace: ( div.firstChild.nodeType === 3 ),
	
	                // Make sure that tbody elements aren't automatically inserted
	                // IE will insert them into empty tables
	                tbody: !div.getElementsByTagName("tbody").length,
	
	                // Make sure that link elements get serialized correctly by innerHTML
	                // This requires a wrapper element in IE
	                htmlSerialize: !!div.getElementsByTagName("link").length,
	
	                // Get the style information from getAttribute
	                // (IE uses .cssText instead)
	                style: /top/.test( a.getAttribute("style") ),
	
	                // Make sure that URLs aren't manipulated
	                // (IE normalizes it by default)
	                hrefNormalized: ( a.getAttribute("href") === "/a" ),
	
	                // Make sure that element opacity exists
	                // (IE uses filter instead)
	                // Use a regex to work around a WebKit issue. See #5145
	                opacity: /^0.5/.test( a.style.opacity ),
	
	                // Verify style float existence
	                // (IE uses styleFloat instead of cssFloat)
	                cssFloat: !!a.style.cssFloat,
	
	                // Make sure that if no value is specified for a checkbox
	                // that it defaults to "on".
	                // (WebKit defaults to "" instead)
	                checkOn: ( input.value === "on" ),
	
	                // Make sure that a selected-by-default option has a working selected property.
	                // (WebKit defaults to false instead of true, IE too, if it's in an optgroup)
	                optSelected: opt.selected,
	
	                // Test setAttribute on camelCase class. If it works, we need attrFixes when doing get/setAttribute (ie6/7)
	                getSetAttribute: div.className !== "t",
	
	                // Tests for enctype support on a form (#6743)
	                enctype: !!document.createElement("form").enctype,
	
	                // Makes sure cloning an html5 element does not cause problems
	                // Where outerHTML is undefined, this still works
	                html5Clone: document.createElement("nav").cloneNode( true ).outerHTML !== "<:nav></:nav>",
	
	                // jQuery.support.boxModel DEPRECATED in 1.8 since we don't support Quirks Mode
	                boxModel: ( document.compatMode === "CSS1Compat" ),
	
	                // Will be defined later
	                submitBubbles: true,
	                changeBubbles: true,
	                focusinBubbles: false,
	                deleteExpando: true,
	                noCloneEvent: true,
	                inlineBlockNeedsLayout: false,
	                shrinkWrapBlocks: false,
	                reliableMarginRight: true,
	                boxSizingReliable: true,
	                pixelPosition: false
	        };
	
	        // Make sure checked status is properly cloned
	        input.checked = true;
	        support.noCloneChecked = input.cloneNode( true ).checked;
	
	        // Make sure that the options inside disabled selects aren't marked as disabled
	        // (WebKit marks them as disabled)
	        select.disabled = true;
	        support.optDisabled = !opt.disabled;
	
	        // Test to see if it's possible to delete an expando from an element
	        // Fails in Internet Explorer
	        try {
	                delete div.test;
	        } catch( e ) {
	                support.deleteExpando = false;
	        }
	
	        if ( !div.addEventListener && div.attachEvent && div.fireEvent ) {
	                div.attachEvent( "onclick", clickFn = function() {
	                        // Cloning a node shouldn't copy over any
	                        // bound event handlers (IE does this)
	                        support.noCloneEvent = false;
	                });
	                div.cloneNode( true ).fireEvent("onclick");
	                div.detachEvent( "onclick", clickFn );
	        }
	
	        // Check if a radio maintains its value
	        // after being appended to the DOM
	        input = document.createElement("input");
	        input.value = "t";
	        input.setAttribute( "type", "radio" );
	        support.radioValue = input.value === "t";
	
	        input.setAttribute( "checked", "checked" );
	
	        // #11217 - WebKit loses check when the name is after the checked attribute
	        input.setAttribute( "name", "t" );
	
	        div.appendChild( input );
	        fragment = document.createDocumentFragment();
	        fragment.appendChild( div.lastChild );
	
	        // WebKit doesn't clone checked state correctly in fragments
	        support.checkClone = fragment.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
	        // Check if a disconnected checkbox will retain its checked
	        // value of true after appended to the DOM (IE6/7)
	        support.appendChecked = input.checked;
	
	        fragment.removeChild( input );
	        fragment.appendChild( div );
	
	        // Technique from Juriy Zaytsev
	        // http://perfectionkills.com/detecting-event-support-without-browser-sniffing/
	        // We only care about the case where non-standard event systems
	        // are used, namely in IE. Short-circuiting here helps us to
	        // avoid an eval call (in setAttribute) which can cause CSP
	        // to go haywire. See: https://developer.mozilla.org/en/Security/CSP
	        if ( div.attachEvent ) {
	                for ( i in {
	                        submit: true,
	                        change: true,
	                        focusin: true
	                }) {
	                        eventName = "on" + i;
	                        isSupported = ( eventName in div );
	                        if ( !isSupported ) {
	                                div.setAttribute( eventName, "return;" );
	                                isSupported = ( typeof div[ eventName ] === "function" );
	                        }
	                        support[ i + "Bubbles" ] = isSupported;
	                }
	        }
	
	        // Run tests that need a body at doc ready
	        jQuery(function() {
	                var container, div, tds, marginDiv,
	                        divReset = "padding:0;margin:0;border:0;display:block;overflow:hidden;",
	                        body = document.getElementsByTagName("body")[0];
	
	                if ( !body ) {
	                        // Return for frameset docs that don't have a body
	                        return;
	                }
	
	                container = document.createElement("div");
	                container.style.cssText = "visibility:hidden;border:0;width:0;height:0;position:static;top:0;margin-top:1px";
	                body.insertBefore( container, body.firstChild );
	
	                // Construct the test element
	                div = document.createElement("div");
	                container.appendChild( div );
	
	                // Check if table cells still have offsetWidth/Height when they are set
	                // to display:none and there are still other visible table cells in a
	                // table row; if so, offsetWidth/Height are not reliable for use when
	                // determining if an element has been hidden directly using
	                // display:none (it is still safe to use offsets if a parent element is
	                // hidden; don safety goggles and see bug #4512 for more information).
	                // (only IE 8 fails this test)
	                div.innerHTML = "<table><tr><td></td><td>t</td></tr></table>";
	                tds = div.getElementsByTagName("td");
	                tds[ 0 ].style.cssText = "padding:0;margin:0;border:0;display:none";
	                isSupported = ( tds[ 0 ].offsetHeight === 0 );
	
	                tds[ 0 ].style.display = "";
	                tds[ 1 ].style.display = "none";
	
	                // Check if empty table cells still have offsetWidth/Height
	                // (IE <= 8 fail this test)
	                support.reliableHiddenOffsets = isSupported && ( tds[ 0 ].offsetHeight === 0 );
	
	                // Check box-sizing and margin behavior
	                div.innerHTML = "";
	                div.style.cssText = "box-sizing:border-box;-moz-box-sizing:border-box;-webkit-box-sizing:border-box;padding:1px;border:1px;display:block;width:4px;margin-top:1%;position:absolute;top:1%;";
	                support.boxSizing = ( div.offsetWidth === 4 );
	                support.doesNotIncludeMarginInBodyOffset = ( body.offsetTop !== 1 );
	
	                // NOTE: To any future maintainer, we've window.getComputedStyle
	                // because jsdom on node.js will break without it.
	                if ( window.getComputedStyle ) {
	                        support.pixelPosition = ( window.getComputedStyle( div, null ) || {} ).top !== "1%";
	                        support.boxSizingReliable = ( window.getComputedStyle( div, null ) || { width: "4px" } ).width === "4px";
	
	                        // Check if div with explicit width and no margin-right incorrectly
	                        // gets computed margin-right based on width of container. For more
	                        // info see bug #3333
	                        // Fails in WebKit before Feb 2011 nightlies
	                        // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
	                        marginDiv = document.createElement("div");
	                        marginDiv.style.cssText = div.style.cssText = divReset;
	                        marginDiv.style.marginRight = marginDiv.style.width = "0";
	                        div.style.width = "1px";
	                        div.appendChild( marginDiv );
	                        support.reliableMarginRight =
	                                !parseFloat( ( window.getComputedStyle( marginDiv, null ) || {} ).marginRight );
	                }
	
	                if ( typeof div.style.zoom !== "undefined" ) {
	                        // Check if natively block-level elements act like inline-block
	                        // elements when setting their display to 'inline' and giving
	                        // them layout
	                        // (IE < 8 does this)
	                        div.innerHTML = "";
	                        div.style.cssText = divReset + "width:1px;padding:1px;display:inline;zoom:1";
	                        support.inlineBlockNeedsLayout = ( div.offsetWidth === 3 );
	
	                        // Check if elements with layout shrink-wrap their children
	                        // (IE 6 does this)
	                        div.style.display = "block";
	                        div.style.overflow = "visible";
	                        div.innerHTML = "<div></div>";
	                        div.firstChild.style.width = "5px";
	                        support.shrinkWrapBlocks = ( div.offsetWidth !== 3 );
	
	                        container.style.zoom = 1;
	                }
	
	                // Null elements to avoid leaks in IE
	                body.removeChild( container );
	                container = div = tds = marginDiv = null;
	        });
	
	        // Null elements to avoid leaks in IE
	        fragment.removeChild( div );
	        all = a = select = opt = input = fragment = div = null;
	
	        return support;
	})();
	var rbrace = /(?:\{[\s\S]*\}|\[[\s\S]*\])$/,
	        rmultiDash = /([A-Z])/g;
	
	jQuery.extend({
	        cache: {},
	
	        deletedIds: [],
	
	        // Remove at next major release (1.9/2.0)
	        uuid: 0,
	
	        // Unique for each copy of jQuery on the page
	        // Non-digits removed to match rinlinejQuery
	        expando: "jQuery" + ( jQuery.fn.jquery + Math.random() ).replace( /\D/g, "" ),
	
	        // The following elements throw uncatchable exceptions if you
	        // attempt to add expando properties to them.
	        noData: {
	                "embed": true,
	                // Ban all objects except for Flash (which handle expandos)
	                "object": "clsid:D27CDB6E-AE6D-11cf-96B8-444553540000",
	                "applet": true
	        },
	
	        hasData: function( elem ) {
	                elem = elem.nodeType ? jQuery.cache[ elem[jQuery.expando] ] : elem[ jQuery.expando ];
	                return !!elem && !isEmptyDataObject( elem );
	        },
	
	        data: function( elem, name, data, pvt /* Internal Use Only */ ) {
	                if ( !jQuery.acceptData( elem ) ) {
	                        return;
	                }
	
	                var thisCache, ret,
	                        internalKey = jQuery.expando,
	                        getByName = typeof name === "string",
	
	                        // We have to handle DOM nodes and JS objects differently because IE6-7
	                        // can't GC object references properly across the DOM-JS boundary
	                        isNode = elem.nodeType,
	
	                        // Only DOM nodes need the global jQuery cache; JS object data is
	                        // attached directly to the object so GC can occur automatically
	                        cache = isNode ? jQuery.cache : elem,
	
	                        // Only defining an ID for JS objects if its cache already exists allows
	                        // the code to shortcut on the same path as a DOM node with no cache
	                        id = isNode ? elem[ internalKey ] : elem[ internalKey ] && internalKey;
	
	                // Avoid doing any more work than we need to when trying to get data on an
	                // object that has no data at all
	                if ( (!id || !cache[id] || (!pvt && !cache[id].data)) && getByName && data === undefined ) {
	                        return;
	                }
	
	                if ( !id ) {
	                        // Only DOM nodes need a new unique ID for each element since their data
	                        // ends up in the global cache
	                        if ( isNode ) {
	                                elem[ internalKey ] = id = jQuery.deletedIds.pop() || jQuery.guid++;
	                        } else {
	                                id = internalKey;
	                        }
	                }
	
	                if ( !cache[ id ] ) {
	                        cache[ id ] = {};
	
	                        // Avoids exposing jQuery metadata on plain JS objects when the object
	                        // is serialized using JSON.stringify
	                        if ( !isNode ) {
	                                cache[ id ].toJSON = jQuery.noop;
	                        }
	                }
	
	                // An object can be passed to jQuery.data instead of a key/value pair; this gets
	                // shallow copied over onto the existing cache
	                if ( typeof name === "object" || typeof name === "function" ) {
	                        if ( pvt ) {
	                                cache[ id ] = jQuery.extend( cache[ id ], name );
	                        } else {
	                                cache[ id ].data = jQuery.extend( cache[ id ].data, name );
	                        }
	                }
	
	                thisCache = cache[ id ];
	
	                // jQuery data() is stored in a separate object inside the object's internal data
	                // cache in order to avoid key collisions between internal data and user-defined
	                // data.
	                if ( !pvt ) {
	                        if ( !thisCache.data ) {
	                                thisCache.data = {};
	                        }
	
	                        thisCache = thisCache.data;
	                }
	
	                if ( data !== undefined ) {
	                        thisCache[ jQuery.camelCase( name ) ] = data;
	                }
	
	                // Check for both converted-to-camel and non-converted data property names
	                // If a data property was specified
	                if ( getByName ) {
	
	                        // First Try to find as-is property data
	                        ret = thisCache[ name ];
	
	                        // Test for null|undefined property data
	                        if ( ret == null ) {
	
	                                // Try to find the camelCased property
	                                ret = thisCache[ jQuery.camelCase( name ) ];
	                        }
	                } else {
	                        ret = thisCache;
	                }
	
	                return ret;
	        },
	
	        removeData: function( elem, name, pvt /* Internal Use Only */ ) {
	                if ( !jQuery.acceptData( elem ) ) {
	                        return;
	                }
	
	                var thisCache, i, l,
	
	                        isNode = elem.nodeType,
	
	                        // See jQuery.data for more information
	                        cache = isNode ? jQuery.cache : elem,
	                        id = isNode ? elem[ jQuery.expando ] : jQuery.expando;
	
	                // If there is already no cache entry for this object, there is no
	                // purpose in continuing
	                if ( !cache[ id ] ) {
	                        return;
	                }
	
	                if ( name ) {
	
	                        thisCache = pvt ? cache[ id ] : cache[ id ].data;
	
	                        if ( thisCache ) {
	
	                                // Support array or space separated string names for data keys
	                                if ( !jQuery.isArray( name ) ) {
	
	                                        // try the string as a key before any manipulation
	                                        if ( name in thisCache ) {
	                                                name = [ name ];
	                                        } else {
	
	                                                // split the camel cased version by spaces unless a key with the spaces exists
	                                                name = jQuery.camelCase( name );
	                                                if ( name in thisCache ) {
	                                                        name = [ name ];
	                                                } else {
	                                                        name = name.split(" ");
	                                                }
	                                        }
	                                }
	
	                                for ( i = 0, l = name.length; i < l; i++ ) {
	                                        delete thisCache[ name[i] ];
	                                }
	
	                                // If there is no data left in the cache, we want to continue
	                                // and let the cache object itself get destroyed
	                                if ( !( pvt ? isEmptyDataObject : jQuery.isEmptyObject )( thisCache ) ) {
	                                        return;
	                                }
	                        }
	                }
	
	                // See jQuery.data for more information
	                if ( !pvt ) {
	                        delete cache[ id ].data;
	
	                        // Don't destroy the parent cache unless the internal data object
	                        // had been the only thing left in it
	                        if ( !isEmptyDataObject( cache[ id ] ) ) {
	                                return;
	                        }
	                }
	
	                // Destroy the cache
	                if ( isNode ) {
	                        jQuery.cleanData( [ elem ], true );
	
	                // Use delete when supported for expandos or `cache` is not a window per isWindow (#10080)
	                } else if ( jQuery.support.deleteExpando || cache != cache.window ) {
	                        delete cache[ id ];
	
	                // When all else fails, null
	                } else {
	                        cache[ id ] = null;
	                }
	        },
	
	        // For internal use only.
	        _data: function( elem, name, data ) {
	                return jQuery.data( elem, name, data, true );
	        },
	
	        // A method for determining if a DOM node can handle the data expando
	        acceptData: function( elem ) {
	                var noData = elem.nodeName && jQuery.noData[ elem.nodeName.toLowerCase() ];
	
	                // nodes accept data unless otherwise specified; rejection can be conditional
	                return !noData || noData !== true && elem.getAttribute("classid") === noData;
	        }
	});
	
	jQuery.fn.extend({
	        data: function( key, value ) {
	                var parts, part, attr, name, l,
	                        elem = this[0],
	                        i = 0,
	                        data = null;
	
	                // Gets all values
	                if ( key === undefined ) {
	                        if ( this.length ) {
	                                data = jQuery.data( elem );
	
	                                if ( elem.nodeType === 1 && !jQuery._data( elem, "parsedAttrs" ) ) {
	                                        attr = elem.attributes;
	                                        for ( l = attr.length; i < l; i++ ) {
	                                                name = attr[i].name;
	
	                                                if ( !name.indexOf( "data-" ) ) {
	                                                        name = jQuery.camelCase( name.substring(5) );
	
	                                                        dataAttr( elem, name, data[ name ] );
	                                                }
	                                        }
	                                        jQuery._data( elem, "parsedAttrs", true );
	                                }
	                        }
	
	                        return data;
	                }
	
	                // Sets multiple values
	                if ( typeof key === "object" ) {
	                        return this.each(function() {
	                                jQuery.data( this, key );
	                        });
	                }
	
	                parts = key.split( ".", 2 );
	                parts[1] = parts[1] ? "." + parts[1] : "";
	                part = parts[1] + "!";
	
	                return jQuery.access( this, function( value ) {
	
	                        if ( value === undefined ) {
	                                data = this.triggerHandler( "getData" + part, [ parts[0] ] );
	
	                                // Try to fetch any internally stored data first
	                                if ( data === undefined && elem ) {
	                                        data = jQuery.data( elem, key );
	                                        data = dataAttr( elem, key, data );
	                                }
	
	                                return data === undefined && parts[1] ?
	                                        this.data( parts[0] ) :
	                                        data;
	                        }
	
	                        parts[1] = value;
	                        this.each(function() {
	                                var self = jQuery( this );
	
	                                self.triggerHandler( "setData" + part, parts );
	                                jQuery.data( this, key, value );
	                                self.triggerHandler( "changeData" + part, parts );
	                        });
	                }, null, value, arguments.length > 1, null, false );
	        },
	
	        removeData: function( key ) {
	                return this.each(function() {
	                        jQuery.removeData( this, key );
	                });
	        }
	});
	
	function dataAttr( elem, key, data ) {
	        // If nothing was found internally, try to fetch any
	        // data from the HTML5 data-* attribute
	        if ( data === undefined && elem.nodeType === 1 ) {
	
	                var name = "data-" + key.replace( rmultiDash, "-$1" ).toLowerCase();
	
	                data = elem.getAttribute( name );
	
	                if ( typeof data === "string" ) {
	                        try {
	                                data = data === "true" ? true :
	                                data === "false" ? false :
	                                data === "null" ? null :
	                                // Only convert to a number if it doesn't change the string
	                                +data + "" === data ? +data :
	                                rbrace.test( data ) ? jQuery.parseJSON( data ) :
	                                        data;
	                        } catch( e ) {}
	
	                        // Make sure we set the data so it isn't changed later
	                        jQuery.data( elem, key, data );
	
	                } else {
	                        data = undefined;
	                }
	        }
	
	        return data;
	}
	
	// checks a cache object for emptiness
	function isEmptyDataObject( obj ) {
	        var name;
	        for ( name in obj ) {
	
	                // if the public data object is empty, the private is still empty
	                if ( name === "data" && jQuery.isEmptyObject( obj[name] ) ) {
	                        continue;
	                }
	                if ( name !== "toJSON" ) {
	                        return false;
	                }
	        }
	
	        return true;
	}
	jQuery.extend({
	        queue: function( elem, type, data ) {
	                var queue;
	
	                if ( elem ) {
	                        type = ( type || "fx" ) + "queue";
	                        queue = jQuery._data( elem, type );
	
	                        // Speed up dequeue by getting out quickly if this is just a lookup
	                        if ( data ) {
	                                if ( !queue || jQuery.isArray(data) ) {
	                                        queue = jQuery._data( elem, type, jQuery.makeArray(data) );
	                                } else {
	                                        queue.push( data );
	                                }
	                        }
	                        return queue || [];
	                }
	        },
	
	        dequeue: function( elem, type ) {
	                type = type || "fx";
	
	                var queue = jQuery.queue( elem, type ),
	                        startLength = queue.length,
	                        fn = queue.shift(),
	                        hooks = jQuery._queueHooks( elem, type ),
	                        next = function() {
	                                jQuery.dequeue( elem, type );
	                        };
	
	                // If the fx queue is dequeued, always remove the progress sentinel
	                if ( fn === "inprogress" ) {
	                        fn = queue.shift();
	                        startLength--;
	                }
	
	                if ( fn ) {
	
	                        // Add a progress sentinel to prevent the fx queue from being
	                        // automatically dequeued
	                        if ( type === "fx" ) {
	                                queue.unshift( "inprogress" );
	                        }
	
	                        // clear up the last queue stop function
	                        delete hooks.stop;
	                        fn.call( elem, next, hooks );
	                }
	
	                if ( !startLength && hooks ) {
	                        hooks.empty.fire();
	                }
	        },
	
	        // not intended for public consumption - generates a queueHooks object, or returns the current one
	        _queueHooks: function( elem, type ) {
	                var key = type + "queueHooks";
	                return jQuery._data( elem, key ) || jQuery._data( elem, key, {
	                        empty: jQuery.Callbacks("once memory").add(function() {
	                                jQuery.removeData( elem, type + "queue", true );
	                                jQuery.removeData( elem, key, true );
	                        })
	                });
	        }
	});
	
	jQuery.fn.extend({
	        queue: function( type, data ) {
	                var setter = 2;
	
	                if ( typeof type !== "string" ) {
	                        data = type;
	                        type = "fx";
	                        setter--;
	                }
	
	                if ( arguments.length < setter ) {
	                        return jQuery.queue( this[0], type );
	                }
	
	                return data === undefined ?
	                        this :
	                        this.each(function() {
	                                var queue = jQuery.queue( this, type, data );
	
	                                // ensure a hooks for this queue
	                                jQuery._queueHooks( this, type );
	
	                                if ( type === "fx" && queue[0] !== "inprogress" ) {
	                                        jQuery.dequeue( this, type );
	                                }
	                        });
	        },
	        dequeue: function( type ) {
	                return this.each(function() {
	                        jQuery.dequeue( this, type );
	                });
	        },
	        // Based off of the plugin by Clint Helfers, with permission.
	        // http://blindsignals.com/index.php/2009/07/jquery-delay/
	        delay: function( time, type ) {
	                time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	                type = type || "fx";
	
	                return this.queue( type, function( next, hooks ) {
	                        var timeout = setTimeout( next, time );
	                        hooks.stop = function() {
	                                clearTimeout( timeout );
	                        };
	                });
	        },
	        clearQueue: function( type ) {
	                return this.queue( type || "fx", [] );
	        },
	        // Get a promise resolved when queues of a certain type
	        // are emptied (fx is the type by default)
	        promise: function( type, obj ) {
	                var tmp,
	                        count = 1,
	                        defer = jQuery.Deferred(),
	                        elements = this,
	                        i = this.length,
	                        resolve = function() {
	                                if ( !( --count ) ) {
	                                        defer.resolveWith( elements, [ elements ] );
	                                }
	                        };
	
	                if ( typeof type !== "string" ) {
	                        obj = type;
	                        type = undefined;
	                }
	                type = type || "fx";
	
	                while( i-- ) {
	                        tmp = jQuery._data( elements[ i ], type + "queueHooks" );
	                        if ( tmp && tmp.empty ) {
	                                count++;
	                                tmp.empty.add( resolve );
	                        }
	                }
	                resolve();
	                return defer.promise( obj );
	        }
	});
	var nodeHook, boolHook, fixSpecified,
	        rclass = /[\t\r\n]/g,
	        rreturn = /\r/g,
	        rtype = /^(?:button|input)$/i,
	        rfocusable = /^(?:button|input|object|select|textarea)$/i,
	        rclickable = /^a(?:rea|)$/i,
	        rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
	        getSetAttribute = jQuery.support.getSetAttribute;
	
	jQuery.fn.extend({
	        attr: function( name, value ) {
	                return jQuery.access( this, jQuery.attr, name, value, arguments.length > 1 );
	        },
	
	        removeAttr: function( name ) {
	                return this.each(function() {
	                        jQuery.removeAttr( this, name );
	                });
	        },
	
	        prop: function( name, value ) {
	                return jQuery.access( this, jQuery.prop, name, value, arguments.length > 1 );
	        },
	
	        removeProp: function( name ) {
	                name = jQuery.propFix[ name ] || name;
	                return this.each(function() {
	                        // try/catch handles cases where IE balks (such as removing a property on window)
	                        try {
	                                this[ name ] = undefined;
	                                delete this[ name ];
	                        } catch( e ) {}
	                });
	        },
	
	        addClass: function( value ) {
	                var classNames, i, l, elem,
	                        setClass, c, cl;
	
	                if ( jQuery.isFunction( value ) ) {
	                        return this.each(function( j ) {
	                                jQuery( this ).addClass( value.call(this, j, this.className) );
	                        });
	                }
	
	                if ( value && typeof value === "string" ) {
	                        classNames = value.split( core_rspace );
	
	                        for ( i = 0, l = this.length; i < l; i++ ) {
	                                elem = this[ i ];
	
	                                if ( elem.nodeType === 1 ) {
	                                        if ( !elem.className && classNames.length === 1 ) {
	                                                elem.className = value;
	
	                                        } else {
	                                                setClass = " " + elem.className + " ";
	
	                                                for ( c = 0, cl = classNames.length; c < cl; c++ ) {
	                                                        if ( setClass.indexOf( " " + classNames[ c ] + " " ) < 0 ) {
	                                                                setClass += classNames[ c ] + " ";
	                                                        }
	                                                }
	                                                elem.className = jQuery.trim( setClass );
	                                        }
	                                }
	                        }
	                }
	
	                return this;
	        },
	
	        removeClass: function( value ) {
	                var removes, className, elem, c, cl, i, l;
	
	                if ( jQuery.isFunction( value ) ) {
	                        return this.each(function( j ) {
	                                jQuery( this ).removeClass( value.call(this, j, this.className) );
	                        });
	                }
	                if ( (value && typeof value === "string") || value === undefined ) {
	                        removes = ( value || "" ).split( core_rspace );
	
	                        for ( i = 0, l = this.length; i < l; i++ ) {
	                                elem = this[ i ];
	                                if ( elem.nodeType === 1 && elem.className ) {
	
	                                        className = (" " + elem.className + " ").replace( rclass, " " );
	
	                                        // loop over each item in the removal list
	                                        for ( c = 0, cl = removes.length; c < cl; c++ ) {
	                                                // Remove until there is nothing to remove,
	                                                while ( className.indexOf(" " + removes[ c ] + " ") >= 0 ) {
	                                                        className = className.replace( " " + removes[ c ] + " " , " " );
	                                                }
	                                        }
	                                        elem.className = value ? jQuery.trim( className ) : "";
	                                }
	                        }
	                }
	
	                return this;
	        },
	
	        toggleClass: function( value, stateVal ) {
	                var type = typeof value,
	                        isBool = typeof stateVal === "boolean";
	
	                if ( jQuery.isFunction( value ) ) {
	                        return this.each(function( i ) {
	                                jQuery( this ).toggleClass( value.call(this, i, this.className, stateVal), stateVal );
	                        });
	                }
	
	                return this.each(function() {
	                        if ( type === "string" ) {
	                                // toggle individual class names
	                                var className,
	                                        i = 0,
	                                        self = jQuery( this ),
	                                        state = stateVal,
	                                        classNames = value.split( core_rspace );
	
	                                while ( (className = classNames[ i++ ]) ) {
	                                        // check each className given, space separated list
	                                        state = isBool ? state : !self.hasClass( className );
	                                        self[ state ? "addClass" : "removeClass" ]( className );
	                                }
	
	                        } else if ( type === "undefined" || type === "boolean" ) {
	                                if ( this.className ) {
	                                        // store className if set
	                                        jQuery._data( this, "__className__", this.className );
	                                }
	
	                                // toggle whole className
	                                this.className = this.className || value === false ? "" : jQuery._data( this, "__className__" ) || "";
	                        }
	                });
	        },
	
	        hasClass: function( selector ) {
	                var className = " " + selector + " ",
	                        i = 0,
	                        l = this.length;
	                for ( ; i < l; i++ ) {
	                        if ( this[i].nodeType === 1 && (" " + this[i].className + " ").replace(rclass, " ").indexOf( className ) >= 0 ) {
	                                return true;
	                        }
	                }
	
	                return false;
	        },
	
	        val: function( value ) {
	                var hooks, ret, isFunction,
	                        elem = this[0];
	
	                if ( !arguments.length ) {
	                        if ( elem ) {
	                                hooks = jQuery.valHooks[ elem.type ] || jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
	                                if ( hooks && "get" in hooks && (ret = hooks.get( elem, "value" )) !== undefined ) {
	                                        return ret;
	                                }
	
	                                ret = elem.value;
	
	                                return typeof ret === "string" ?
	                                        // handle most common string cases
	                                        ret.replace(rreturn, "") :
	                                        // handle cases where value is null/undef or number
	                                        ret == null ? "" : ret;
	                        }
	
	                        return;
	                }
	
	                isFunction = jQuery.isFunction( value );
	
	                return this.each(function( i ) {
	                        var val,
	                                self = jQuery(this);
	
	                        if ( this.nodeType !== 1 ) {
	                                return;
	                        }
	
	                        if ( isFunction ) {
	                                val = value.call( this, i, self.val() );
	                        } else {
	                                val = value;
	                        }
	
	                        // Treat null/undefined as ""; convert numbers to string
	                        if ( val == null ) {
	                                val = "";
	                        } else if ( typeof val === "number" ) {
	                                val += "";
	                        } else if ( jQuery.isArray( val ) ) {
	                                val = jQuery.map(val, function ( value ) {
	                                        return value == null ? "" : value + "";
	                                });
	                        }
	
	                        hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
	                        // If set returns undefined, fall back to normal setting
	                        if ( !hooks || !("set" in hooks) || hooks.set( this, val, "value" ) === undefined ) {
	                                this.value = val;
	                        }
	                });
	        }
	});
	
	jQuery.extend({
	        valHooks: {
	                option: {
	                        get: function( elem ) {
	                                // attributes.value is undefined in Blackberry 4.7 but
	                                // uses .value. See #6932
	                                var val = elem.attributes.value;
	                                return !val || val.specified ? elem.value : elem.text;
	                        }
	                },
	                select: {
	                        get: function( elem ) {
	                                var value, option,
	                                        options = elem.options,
	                                        index = elem.selectedIndex,
	                                        one = elem.type === "select-one" || index < 0,
	                                        values = one ? null : [],
	                                        max = one ? index + 1 : options.length,
	                                        i = index < 0 ?
	                                                max :
	                                                one ? index : 0;
	
	                                // Loop through all the selected options
	                                for ( ; i < max; i++ ) {
	                                        option = options[ i ];
	
	                                        // oldIE doesn't update selected after form reset (#2551)
	                                        if ( ( option.selected || i === index ) &&
	                                                        // Don't return options that are disabled or in a disabled optgroup
	                                                        ( jQuery.support.optDisabled ? !option.disabled : option.getAttribute("disabled") === null ) &&
	                                                        ( !option.parentNode.disabled || !jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
	                                                // Get the specific value for the option
	                                                value = jQuery( option ).val();
	
	                                                // We don't need an array for one selects
	                                                if ( one ) {
	                                                        return value;
	                                                }
	
	                                                // Multi-Selects return an array
	                                                values.push( value );
	                                        }
	                                }
	
	                                return values;
	                        },
	
	                        set: function( elem, value ) {
	                                var values = jQuery.makeArray( value );
	
	                                jQuery(elem).find("option").each(function() {
	                                        this.selected = jQuery.inArray( jQuery(this).val(), values ) >= 0;
	                                });
	
	                                if ( !values.length ) {
	                                        elem.selectedIndex = -1;
	                                }
	                                return values;
	                        }
	                }
	        },
	
	        // Unused in 1.8, left in so attrFn-stabbers won't die; remove in 1.9
	        attrFn: {},
	
	        attr: function( elem, name, value, pass ) {
	                var ret, hooks, notxml,
	                        nType = elem.nodeType;
	
	                // don't get/set attributes on text, comment and attribute nodes
	                if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
	                        return;
	                }
	
	                if ( pass && jQuery.isFunction( jQuery.fn[ name ] ) ) {
	                        return jQuery( elem )[ name ]( value );
	                }
	
	                // Fallback to prop when attributes are not supported
	                if ( typeof elem.getAttribute === "undefined" ) {
	                        return jQuery.prop( elem, name, value );
	                }
	
	                notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
	                // All attributes are lowercase
	                // Grab necessary hook if one is defined
	                if ( notxml ) {
	                        name = name.toLowerCase();
	                        hooks = jQuery.attrHooks[ name ] || ( rboolean.test( name ) ? boolHook : nodeHook );
	                }
	
	                if ( value !== undefined ) {
	
	                        if ( value === null ) {
	                                jQuery.removeAttr( elem, name );
	                                return;
	
	                        } else if ( hooks && "set" in hooks && notxml && (ret = hooks.set( elem, value, name )) !== undefined ) {
	                                return ret;
	
	                        } else {
	                                elem.setAttribute( name, value + "" );
	                                return value;
	                        }
	
	                } else if ( hooks && "get" in hooks && notxml && (ret = hooks.get( elem, name )) !== null ) {
	                        return ret;
	
	                } else {
	
	                        ret = elem.getAttribute( name );
	
	                        // Non-existent attributes return null, we normalize to undefined
	                        return ret === null ?
	                                undefined :
	                                ret;
	                }
	        },
	
	        removeAttr: function( elem, value ) {
	                var propName, attrNames, name, isBool,
	                        i = 0;
	
	                if ( value && elem.nodeType === 1 ) {
	
	                        attrNames = value.split( core_rspace );
	
	                        for ( ; i < attrNames.length; i++ ) {
	                                name = attrNames[ i ];
	
	                                if ( name ) {
	                                        propName = jQuery.propFix[ name ] || name;
	                                        isBool = rboolean.test( name );
	
	                                        // See #9699 for explanation of this approach (setting first, then removal)
	                                        // Do not do this for boolean attributes (see #10870)
	                                        if ( !isBool ) {
	                                                jQuery.attr( elem, name, "" );
	                                        }
	                                        elem.removeAttribute( getSetAttribute ? name : propName );
	
	                                        // Set corresponding property to false for boolean attributes
	                                        if ( isBool && propName in elem ) {
	                                                elem[ propName ] = false;
	                                        }
	                                }
	                        }
	                }
	        },
	
	        attrHooks: {
	                type: {
	                        set: function( elem, value ) {
	                                // We can't allow the type property to be changed (since it causes problems in IE)
	                                if ( rtype.test( elem.nodeName ) && elem.parentNode ) {
	                                        jQuery.error( "type property can't be changed" );
	                                } else if ( !jQuery.support.radioValue && value === "radio" && jQuery.nodeName(elem, "input") ) {
	                                        // Setting the type on a radio button after the value resets the value in IE6-9
	                                        // Reset value to it's default in case type is set after value
	                                        // This is for element creation
	                                        var val = elem.value;
	                                        elem.setAttribute( "type", value );
	                                        if ( val ) {
	                                                elem.value = val;
	                                        }
	                                        return value;
	                                }
	                        }
	                },
	                // Use the value property for back compat
	                // Use the nodeHook for button elements in IE6/7 (#1954)
	                value: {
	                        get: function( elem, name ) {
	                                if ( nodeHook && jQuery.nodeName( elem, "button" ) ) {
	                                        return nodeHook.get( elem, name );
	                                }
	                                return name in elem ?
	                                        elem.value :
	                                        null;
	                        },
	                        set: function( elem, value, name ) {
	                                if ( nodeHook && jQuery.nodeName( elem, "button" ) ) {
	                                        return nodeHook.set( elem, value, name );
	                                }
	                                // Does not return so that setAttribute is also used
	                                elem.value = value;
	                        }
	                }
	        },
	
	        propFix: {
	                tabindex: "tabIndex",
	                readonly: "readOnly",
	                "for": "htmlFor",
	                "class": "className",
	                maxlength: "maxLength",
	                cellspacing: "cellSpacing",
	                cellpadding: "cellPadding",
	                rowspan: "rowSpan",
	                colspan: "colSpan",
	                usemap: "useMap",
	                frameborder: "frameBorder",
	                contenteditable: "contentEditable"
	        },
	
	        prop: function( elem, name, value ) {
	                var ret, hooks, notxml,
	                        nType = elem.nodeType;
	
	                // don't get/set properties on text, comment and attribute nodes
	                if ( !elem || nType === 3 || nType === 8 || nType === 2 ) {
	                        return;
	                }
	
	                notxml = nType !== 1 || !jQuery.isXMLDoc( elem );
	
	                if ( notxml ) {
	                        // Fix name and attach hooks
	                        name = jQuery.propFix[ name ] || name;
	                        hooks = jQuery.propHooks[ name ];
	                }
	
	                if ( value !== undefined ) {
	                        if ( hooks && "set" in hooks && (ret = hooks.set( elem, value, name )) !== undefined ) {
	                                return ret;
	
	                        } else {
	                                return ( elem[ name ] = value );
	                        }
	
	                } else {
	                        if ( hooks && "get" in hooks && (ret = hooks.get( elem, name )) !== null ) {
	                                return ret;
	
	                        } else {
	                                return elem[ name ];
	                        }
	                }
	        },
	
	        propHooks: {
	                tabIndex: {
	                        get: function( elem ) {
	                                // elem.tabIndex doesn't always return the correct value when it hasn't been explicitly set
	                                // http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
	                                var attributeNode = elem.getAttributeNode("tabindex");
	
	                                return attributeNode && attributeNode.specified ?
	                                        parseInt( attributeNode.value, 10 ) :
	                                        rfocusable.test( elem.nodeName ) || rclickable.test( elem.nodeName ) && elem.href ?
	                                                0 :
	                                                undefined;
	                        }
	                }
	        }
	});
	
	// Hook for boolean attributes
	boolHook = {
	        get: function( elem, name ) {
	                // Align boolean attributes with corresponding properties
	                // Fall back to attribute presence where some booleans are not supported
	                var attrNode,
	                        property = jQuery.prop( elem, name );
	                return property === true || typeof property !== "boolean" && ( attrNode = elem.getAttributeNode(name) ) && attrNode.nodeValue !== false ?
	                        name.toLowerCase() :
	                        undefined;
	        },
	        set: function( elem, value, name ) {
	                var propName;
	                if ( value === false ) {
	                        // Remove boolean attributes when set to false
	                        jQuery.removeAttr( elem, name );
	                } else {
	                        // value is true since we know at this point it's type boolean and not false
	                        // Set boolean attributes to the same name and set the DOM property
	                        propName = jQuery.propFix[ name ] || name;
	                        if ( propName in elem ) {
	                                // Only set the IDL specifically if it already exists on the element
	                                elem[ propName ] = true;
	                        }
	
	                        elem.setAttribute( name, name.toLowerCase() );
	                }
	                return name;
	        }
	};
	
	// IE6/7 do not support getting/setting some attributes with get/setAttribute
	if ( !getSetAttribute ) {
	
	        fixSpecified = {
	                name: true,
	                id: true,
	                coords: true
	        };
	
	        // Use this for any attribute in IE6/7
	        // This fixes almost every IE6/7 issue
	        nodeHook = jQuery.valHooks.button = {
	                get: function( elem, name ) {
	                        var ret;
	                        ret = elem.getAttributeNode( name );
	                        return ret && ( fixSpecified[ name ] ? ret.value !== "" : ret.specified ) ?
	                                ret.value :
	                                undefined;
	                },
	                set: function( elem, value, name ) {
	                        // Set the existing or create a new attribute node
	                        var ret = elem.getAttributeNode( name );
	                        if ( !ret ) {
	                                ret = document.createAttribute( name );
	                                elem.setAttributeNode( ret );
	                        }
	                        return ( ret.value = value + "" );
	                }
	        };
	
	        // Set width and height to auto instead of 0 on empty string( Bug #8150 )
	        // This is for removals
	        jQuery.each([ "width", "height" ], function( i, name ) {
	                jQuery.attrHooks[ name ] = jQuery.extend( jQuery.attrHooks[ name ], {
	                        set: function( elem, value ) {
	                                if ( value === "" ) {
	                                        elem.setAttribute( name, "auto" );
	                                        return value;
	                                }
	                        }
	                });
	        });
	
	        // Set contenteditable to false on removals(#10429)
	        // Setting to empty string throws an error as an invalid value
	        jQuery.attrHooks.contenteditable = {
	                get: nodeHook.get,
	                set: function( elem, value, name ) {
	                        if ( value === "" ) {
	                                value = "false";
	                        }
	                        nodeHook.set( elem, value, name );
	                }
	        };
	}
	
	
	// Some attributes require a special call on IE
	if ( !jQuery.support.hrefNormalized ) {
	        jQuery.each([ "href", "src", "width", "height" ], function( i, name ) {
	                jQuery.attrHooks[ name ] = jQuery.extend( jQuery.attrHooks[ name ], {
	                        get: function( elem ) {
	                                var ret = elem.getAttribute( name, 2 );
	                                return ret === null ? undefined : ret;
	                        }
	                });
	        });
	}
	
	if ( !jQuery.support.style ) {
	        jQuery.attrHooks.style = {
	                get: function( elem ) {
	                        // Return undefined in the case of empty string
	                        // Normalize to lowercase since IE uppercases css property names
	                        return elem.style.cssText.toLowerCase() || undefined;
	                },
	                set: function( elem, value ) {
	                        return ( elem.style.cssText = value + "" );
	                }
	        };
	}
	
	// Safari mis-reports the default selected property of an option
	// Accessing the parent's selectedIndex property fixes it
	if ( !jQuery.support.optSelected ) {
	        jQuery.propHooks.selected = jQuery.extend( jQuery.propHooks.selected, {
	                get: function( elem ) {
	                        var parent = elem.parentNode;
	
	                        if ( parent ) {
	                                parent.selectedIndex;
	
	                                // Make sure that it also works with optgroups, see #5701
	                                if ( parent.parentNode ) {
	                                        parent.parentNode.selectedIndex;
	                                }
	                        }
	                        return null;
	                }
	        });
	}
	
	// IE6/7 call enctype encoding
	if ( !jQuery.support.enctype ) {
	        jQuery.propFix.enctype = "encoding";
	}
	
	// Radios and checkboxes getter/setter
	if ( !jQuery.support.checkOn ) {
	        jQuery.each([ "radio", "checkbox" ], function() {
	                jQuery.valHooks[ this ] = {
	                        get: function( elem ) {
	                                // Handle the case where in Webkit "" is returned instead of "on" if a value isn't specified
	                                return elem.getAttribute("value") === null ? "on" : elem.value;
	                        }
	                };
	        });
	}
	jQuery.each([ "radio", "checkbox" ], function() {
	        jQuery.valHooks[ this ] = jQuery.extend( jQuery.valHooks[ this ], {
	                set: function( elem, value ) {
	                        if ( jQuery.isArray( value ) ) {
	                                return ( elem.checked = jQuery.inArray( jQuery(elem).val(), value ) >= 0 );
	                        }
	                }
	        });
	});
	var rformElems = /^(?:textarea|input|select)$/i,
	        rtypenamespace = /^([^\.]*|)(?:\.(.+)|)$/,
	        rhoverHack = /(?:^|\s)hover(\.\S+|)\b/,
	        rkeyEvent = /^key/,
	        rmouseEvent = /^(?:mouse|contextmenu)|click/,
	        rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	        hoverHack = function( events ) {
	                return jQuery.event.special.hover ? events : events.replace( rhoverHack, "mouseenter$1 mouseleave$1" );
	        };
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
	        add: function( elem, types, handler, data, selector ) {
	
	                var elemData, eventHandle, events,
	                        t, tns, type, namespaces, handleObj,
	                        handleObjIn, handlers, special;
	
	                // Don't attach events to noData or text/comment nodes (allow plain objects tho)
	                if ( elem.nodeType === 3 || elem.nodeType === 8 || !types || !handler || !(elemData = jQuery._data( elem )) ) {
	                        return;
	                }
	
	                // Caller can pass in an object of custom data in lieu of the handler
	                if ( handler.handler ) {
	                        handleObjIn = handler;
	                        handler = handleObjIn.handler;
	                        selector = handleObjIn.selector;
	                }
	
	                // Make sure that the handler has a unique ID, used to find/remove it later
	                if ( !handler.guid ) {
	                        handler.guid = jQuery.guid++;
	                }
	
	                // Init the element's event structure and main handler, if this is the first
	                events = elemData.events;
	                if ( !events ) {
	                        elemData.events = events = {};
	                }
	                eventHandle = elemData.handle;
	                if ( !eventHandle ) {
	                        elemData.handle = eventHandle = function( e ) {
	                                // Discard the second event of a jQuery.event.trigger() and
	                                // when an event is called after a page has unloaded
	                                return typeof jQuery !== "undefined" && (!e || jQuery.event.triggered !== e.type) ?
	                                        jQuery.event.dispatch.apply( eventHandle.elem, arguments ) :
	                                        undefined;
	                        };
	                        // Add elem as a property of the handle fn to prevent a memory leak with IE non-native events
	                        eventHandle.elem = elem;
	                }
	
	                // Handle multiple events separated by a space
	                // jQuery(...).bind("mouseover mouseout", fn);
	                types = jQuery.trim( hoverHack(types) ).split( " " );
	                for ( t = 0; t < types.length; t++ ) {
	
	                        tns = rtypenamespace.exec( types[t] ) || [];
	                        type = tns[1];
	                        namespaces = ( tns[2] || "" ).split( "." ).sort();
	
	                        // If event changes its type, use the special event handlers for the changed type
	                        special = jQuery.event.special[ type ] || {};
	
	                        // If selector defined, determine special event api type, otherwise given type
	                        type = ( selector ? special.delegateType : special.bindType ) || type;
	
	                        // Update special based on newly reset type
	                        special = jQuery.event.special[ type ] || {};
	
	                        // handleObj is passed to all event handlers
	                        handleObj = jQuery.extend({
	                                type: type,
	                                origType: tns[1],
	                                data: data,
	                                handler: handler,
	                                guid: handler.guid,
	                                selector: selector,
	                                needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
	                                namespace: namespaces.join(".")
	                        }, handleObjIn );
	
	                        // Init the event handler queue if we're the first
	                        handlers = events[ type ];
	                        if ( !handlers ) {
	                                handlers = events[ type ] = [];
	                                handlers.delegateCount = 0;
	
	                                // Only use addEventListener/attachEvent if the special events handler returns false
	                                if ( !special.setup || special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	                                        // Bind the global event handler to the element
	                                        if ( elem.addEventListener ) {
	                                                elem.addEventListener( type, eventHandle, false );
	
	                                        } else if ( elem.attachEvent ) {
	                                                elem.attachEvent( "on" + type, eventHandle );
	                                        }
	                                }
	                        }
	
	                        if ( special.add ) {
	                                special.add.call( elem, handleObj );
	
	                                if ( !handleObj.handler.guid ) {
	                                        handleObj.handler.guid = handler.guid;
	                                }
	                        }
	
	                        // Add to the element's handler list, delegates in front
	                        if ( selector ) {
	                                handlers.splice( handlers.delegateCount++, 0, handleObj );
	                        } else {
	                                handlers.push( handleObj );
	                        }
	
	                        // Keep track of which events have ever been used, for event optimization
	                        jQuery.event.global[ type ] = true;
	                }
	
	                // Nullify elem to prevent memory leaks in IE
	                elem = null;
	        },
	
	        global: {},
	
	        // Detach an event or set of events from an element
	        remove: function( elem, types, handler, selector, mappedTypes ) {
	
	                var t, tns, type, origType, namespaces, origCount,
	                        j, events, special, eventType, handleObj,
	                        elemData = jQuery.hasData( elem ) && jQuery._data( elem );
	
	                if ( !elemData || !(events = elemData.events) ) {
	                        return;
	                }
	
	                // Once for each type.namespace in types; type may be omitted
	                types = jQuery.trim( hoverHack( types || "" ) ).split(" ");
	                for ( t = 0; t < types.length; t++ ) {
	                        tns = rtypenamespace.exec( types[t] ) || [];
	                        type = origType = tns[1];
	                        namespaces = tns[2];
	
	                        // Unbind all events (on this namespace, if provided) for the element
	                        if ( !type ) {
	                                for ( type in events ) {
	                                        jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
	                                }
	                                continue;
	                        }
	
	                        special = jQuery.event.special[ type ] || {};
	                        type = ( selector? special.delegateType : special.bindType ) || type;
	                        eventType = events[ type ] || [];
	                        origCount = eventType.length;
	                        namespaces = namespaces ? new RegExp("(^|\\.)" + namespaces.split(".").sort().join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
	
	                        // Remove matching events
	                        for ( j = 0; j < eventType.length; j++ ) {
	                                handleObj = eventType[ j ];
	
	                                if ( ( mappedTypes || origType === handleObj.origType ) &&
	                                         ( !handler || handler.guid === handleObj.guid ) &&
	                                         ( !namespaces || namespaces.test( handleObj.namespace ) ) &&
	                                         ( !selector || selector === handleObj.selector || selector === "**" && handleObj.selector ) ) {
	                                        eventType.splice( j--, 1 );
	
	                                        if ( handleObj.selector ) {
	                                                eventType.delegateCount--;
	                                        }
	                                        if ( special.remove ) {
	                                                special.remove.call( elem, handleObj );
	                                        }
	                                }
	                        }
	
	                        // Remove generic event handler if we removed something and no more handlers exist
	                        // (avoids potential for endless recursion during removal of special event handlers)
	                        if ( eventType.length === 0 && origCount !== eventType.length ) {
	                                if ( !special.teardown || special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	                                        jQuery.removeEvent( elem, type, elemData.handle );
	                                }
	
	                                delete events[ type ];
	                        }
	                }
	
	                // Remove the expando if it's no longer used
	                if ( jQuery.isEmptyObject( events ) ) {
	                        delete elemData.handle;
	
	                        // removeData also checks for emptiness and clears the expando if empty
	                        // so use it instead of delete
	                        jQuery.removeData( elem, "events", true );
	                }
	        },
	
	        // Events that are safe to short-circuit if no handlers are attached.
	        // Native DOM events should not be added, they may have inline handlers.
	        customEvent: {
	                "getData": true,
	                "setData": true,
	                "changeData": true
	        },
	
	        trigger: function( event, data, elem, onlyHandlers ) {
	                // Don't do events on text and comment nodes
	                if ( elem && (elem.nodeType === 3 || elem.nodeType === 8) ) {
	                        return;
	                }
	
	                // Event object or event type
	                var cache, exclusive, i, cur, old, ontype, special, handle, eventPath, bubbleType,
	                        type = event.type || event,
	                        namespaces = [];
	
	                // focus/blur morphs to focusin/out; ensure we're not firing them right now
	                if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
	                        return;
	                }
	
	                if ( type.indexOf( "!" ) >= 0 ) {
	                        // Exclusive events trigger only for the exact event (no namespaces)
	                        type = type.slice(0, -1);
	                        exclusive = true;
	                }
	
	                if ( type.indexOf( "." ) >= 0 ) {
	                        // Namespaced trigger; create a regexp to match event type in handle()
	                        namespaces = type.split(".");
	                        type = namespaces.shift();
	                        namespaces.sort();
	                }
	
	                if ( (!elem || jQuery.event.customEvent[ type ]) && !jQuery.event.global[ type ] ) {
	                        // No jQuery handlers for this event type, and it can't have inline handlers
	                        return;
	                }
	
	                // Caller can pass in an Event, Object, or just an event type string
	                event = typeof event === "object" ?
	                        // jQuery.Event object
	                        event[ jQuery.expando ] ? event :
	                        // Object literal
	                        new jQuery.Event( type, event ) :
	                        // Just the event type (string)
	                        new jQuery.Event( type );
	
	                event.type = type;
	                event.isTrigger = true;
	                event.exclusive = exclusive;
	                event.namespace = namespaces.join( "." );
	                event.namespace_re = event.namespace? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
	                ontype = type.indexOf( ":" ) < 0 ? "on" + type : "";
	
	                // Handle a global trigger
	                if ( !elem ) {
	
	                        // TODO: Stop taunting the data cache; remove global events and always attach to document
	                        cache = jQuery.cache;
	                        for ( i in cache ) {
	                                if ( cache[ i ].events && cache[ i ].events[ type ] ) {
	                                        jQuery.event.trigger( event, data, cache[ i ].handle.elem, true );
	                                }
	                        }
	                        return;
	                }
	
	                // Clean up the event in case it is being reused
	                event.result = undefined;
	                if ( !event.target ) {
	                        event.target = elem;
	                }
	
	                // Clone any incoming data and prepend the event, creating the handler arg list
	                data = data != null ? jQuery.makeArray( data ) : [];
	                data.unshift( event );
	
	                // Allow special events to draw outside the lines
	                special = jQuery.event.special[ type ] || {};
	                if ( special.trigger && special.trigger.apply( elem, data ) === false ) {
	                        return;
	                }
	
	                // Determine event propagation path in advance, per W3C events spec (#9951)
	                // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
	                eventPath = [[ elem, special.bindType || type ]];
	                if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
	                        bubbleType = special.delegateType || type;
	                        cur = rfocusMorph.test( bubbleType + type ) ? elem : elem.parentNode;
	                        for ( old = elem; cur; cur = cur.parentNode ) {
	                                eventPath.push([ cur, bubbleType ]);
	                                old = cur;
	                        }
	
	                        // Only add window if we got to document (e.g., not plain obj or detached DOM)
	                        if ( old === (elem.ownerDocument || document) ) {
	                                eventPath.push([ old.defaultView || old.parentWindow || window, bubbleType ]);
	                        }
	                }
	
	                // Fire handlers on the event path
	                for ( i = 0; i < eventPath.length && !event.isPropagationStopped(); i++ ) {
	
	                        cur = eventPath[i][0];
	                        event.type = eventPath[i][1];
	
	                        handle = ( jQuery._data( cur, "events" ) || {} )[ event.type ] && jQuery._data( cur, "handle" );
	                        if ( handle ) {
	                                handle.apply( cur, data );
	                        }
	                        // Note that this is a bare JS function and not a jQuery handler
	                        handle = ontype && cur[ ontype ];
	                        if ( handle && jQuery.acceptData( cur ) && handle.apply && handle.apply( cur, data ) === false ) {
	                                event.preventDefault();
	                        }
	                }
	                event.type = type;
	
	                // If nobody prevented the default action, do it now
	                if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
	                        if ( (!special._default || special._default.apply( elem.ownerDocument, data ) === false) &&
	                                !(type === "click" && jQuery.nodeName( elem, "a" )) && jQuery.acceptData( elem ) ) {
	
	                                // Call a native DOM method on the target with the same name name as the event.
	                                // Can't use an .isFunction() check here because IE6/7 fails that test.
	                                // Don't do default actions on window, that's where global variables be (#6170)
	                                // IE<9 dies on focus/blur to hidden element (#1486)
	                                if ( ontype && elem[ type ] && ((type !== "focus" && type !== "blur") || event.target.offsetWidth !== 0) && !jQuery.isWindow( elem ) ) {
	
	                                        // Don't re-trigger an onFOO event when we call its FOO() method
	                                        old = elem[ ontype ];
	
	                                        if ( old ) {
	                                                elem[ ontype ] = null;
	                                        }
	
	                                        // Prevent re-triggering of the same event, since we already bubbled it above
	                                        jQuery.event.triggered = type;
	                                        elem[ type ]();
	                                        jQuery.event.triggered = undefined;
	
	                                        if ( old ) {
	                                                elem[ ontype ] = old;
	                                        }
	                                }
	                        }
	                }
	
	                return event.result;
	        },
	
	        dispatch: function( event ) {
	
	                // Make a writable jQuery.Event from the native event object
	                event = jQuery.event.fix( event || window.event );
	
	                var i, j, cur, ret, selMatch, matched, matches, handleObj, sel, related,
	                        handlers = ( (jQuery._data( this, "events" ) || {} )[ event.type ] || []),
	                        delegateCount = handlers.delegateCount,
	                        args = core_slice.call( arguments ),
	                        run_all = !event.exclusive && !event.namespace,
	                        special = jQuery.event.special[ event.type ] || {},
	                        handlerQueue = [];
	
	                // Use the fix-ed jQuery.Event rather than the (read-only) native event
	                args[0] = event;
	                event.delegateTarget = this;
	
	                // Call the preDispatch hook for the mapped type, and let it bail if desired
	                if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
	                        return;
	                }
	
	                // Determine handlers that should run if there are delegated events
	                // Avoid non-left-click bubbling in Firefox (#3861)
	                if ( delegateCount && !(event.button && event.type === "click") ) {
	
	                        for ( cur = event.target; cur != this; cur = cur.parentNode || this ) {
	
	                                // Don't process clicks (ONLY) on disabled elements (#6911, #8165, #11382, #11764)
	                                if ( cur.disabled !== true || event.type !== "click" ) {
	                                        selMatch = {};
	                                        matches = [];
	                                        for ( i = 0; i < delegateCount; i++ ) {
	                                                handleObj = handlers[ i ];
	                                                sel = handleObj.selector;
	
	                                                if ( selMatch[ sel ] === undefined ) {
	                                                        selMatch[ sel ] = handleObj.needsContext ?
	                                                                jQuery( sel, this ).index( cur ) >= 0 :
	                                                                jQuery.find( sel, this, null, [ cur ] ).length;
	                                                }
	                                                if ( selMatch[ sel ] ) {
	                                                        matches.push( handleObj );
	                                                }
	                                        }
	                                        if ( matches.length ) {
	                                                handlerQueue.push({ elem: cur, matches: matches });
	                                        }
	                                }
	                        }
	                }
	
	                // Add the remaining (directly-bound) handlers
	                if ( handlers.length > delegateCount ) {
	                        handlerQueue.push({ elem: this, matches: handlers.slice( delegateCount ) });
	                }
	
	                // Run delegates first; they may want to stop propagation beneath us
	                for ( i = 0; i < handlerQueue.length && !event.isPropagationStopped(); i++ ) {
	                        matched = handlerQueue[ i ];
	                        event.currentTarget = matched.elem;
	
	                        for ( j = 0; j < matched.matches.length && !event.isImmediatePropagationStopped(); j++ ) {
	                                handleObj = matched.matches[ j ];
	
	                                // Triggered event must either 1) be non-exclusive and have no namespace, or
	                                // 2) have namespace(s) a subset or equal to those in the bound event (both can have no namespace).
	                                if ( run_all || (!event.namespace && !handleObj.namespace) || event.namespace_re && event.namespace_re.test( handleObj.namespace ) ) {
	
	                                        event.data = handleObj.data;
	                                        event.handleObj = handleObj;
	
	                                        ret = ( (jQuery.event.special[ handleObj.origType ] || {}).handle || handleObj.handler )
	                                                        .apply( matched.elem, args );
	
	                                        if ( ret !== undefined ) {
	                                                event.result = ret;
	                                                if ( ret === false ) {
	                                                        event.preventDefault();
	                                                        event.stopPropagation();
	                                                }
	                                        }
	                                }
	                        }
	                }
	
	                // Call the postDispatch hook for the mapped type
	                if ( special.postDispatch ) {
	                        special.postDispatch.call( this, event );
	                }
	
	                return event.result;
	        },
	
	        // Includes some event props shared by KeyEvent and MouseEvent
	        // *** attrChange attrName relatedNode srcElement  are not normalized, non-W3C, deprecated, will be removed in 1.8 ***
	        props: "attrChange attrName relatedNode srcElement altKey bubbles cancelable ctrlKey currentTarget eventPhase metaKey relatedTarget shiftKey target timeStamp view which".split(" "),
	
	        fixHooks: {},
	
	        keyHooks: {
	                props: "char charCode key keyCode".split(" "),
	                filter: function( event, original ) {
	
	                        // Add which for key events
	                        if ( event.which == null ) {
	                                event.which = original.charCode != null ? original.charCode : original.keyCode;
	                        }
	
	                        return event;
	                }
	        },
	
	        mouseHooks: {
	                props: "button buttons clientX clientY fromElement offsetX offsetY pageX pageY screenX screenY toElement".split(" "),
	                filter: function( event, original ) {
	                        var eventDoc, doc, body,
	                                button = original.button,
	                                fromElement = original.fromElement;
	
	                        // Calculate pageX/Y if missing and clientX/Y available
	                        if ( event.pageX == null && original.clientX != null ) {
	                                eventDoc = event.target.ownerDocument || document;
	                                doc = eventDoc.documentElement;
	                                body = eventDoc.body;
	
	                                event.pageX = original.clientX + ( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) - ( doc && doc.clientLeft || body && body.clientLeft || 0 );
	                                event.pageY = original.clientY + ( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) - ( doc && doc.clientTop  || body && body.clientTop  || 0 );
	                        }
	
	                        // Add relatedTarget, if necessary
	                        if ( !event.relatedTarget && fromElement ) {
	                                event.relatedTarget = fromElement === event.target ? original.toElement : fromElement;
	                        }
	
	                        // Add which for click: 1 === left; 2 === middle; 3 === right
	                        // Note: button is not normalized, so don't use it
	                        if ( !event.which && button !== undefined ) {
	                                event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
	                        }
	
	                        return event;
	                }
	        },
	
	        fix: function( event ) {
	                if ( event[ jQuery.expando ] ) {
	                        return event;
	                }
	
	                // Create a writable copy of the event object and normalize some properties
	                var i, prop,
	                        originalEvent = event,
	                        fixHook = jQuery.event.fixHooks[ event.type ] || {},
	                        copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;
	
	                event = jQuery.Event( originalEvent );
	
	                for ( i = copy.length; i; ) {
	                        prop = copy[ --i ];
	                        event[ prop ] = originalEvent[ prop ];
	                }
	
	                // Fix target property, if necessary (#1925, IE 6/7/8 & Safari2)
	                if ( !event.target ) {
	                        event.target = originalEvent.srcElement || document;
	                }
	
	                // Target should not be a text node (#504, Safari)
	                if ( event.target.nodeType === 3 ) {
	                        event.target = event.target.parentNode;
	                }
	
	                // For mouse/key events, metaKey==false if it's undefined (#3368, #11328; IE6/7/8)
	                event.metaKey = !!event.metaKey;
	
	                return fixHook.filter? fixHook.filter( event, originalEvent ) : event;
	        },
	
	        special: {
	                load: {
	                        // Prevent triggered image.load events from bubbling to window.load
	                        noBubble: true
	                },
	
	                focus: {
	                        delegateType: "focusin"
	                },
	                blur: {
	                        delegateType: "focusout"
	                },
	
	                beforeunload: {
	                        setup: function( data, namespaces, eventHandle ) {
	                                // We only want to do this special case on windows
	                                if ( jQuery.isWindow( this ) ) {
	                                        this.onbeforeunload = eventHandle;
	                                }
	                        },
	
	                        teardown: function( namespaces, eventHandle ) {
	                                if ( this.onbeforeunload === eventHandle ) {
	                                        this.onbeforeunload = null;
	                                }
	                        }
	                }
	        },
	
	        simulate: function( type, elem, event, bubble ) {
	                // Piggyback on a donor event to simulate a different one.
	                // Fake originalEvent to avoid donor's stopPropagation, but if the
	                // simulated event prevents default then we do the same on the donor.
	                var e = jQuery.extend(
	                        new jQuery.Event(),
	                        event,
	                        { type: type,
	                                isSimulated: true,
	                                originalEvent: {}
	                        }
	                );
	                if ( bubble ) {
	                        jQuery.event.trigger( e, null, elem );
	                } else {
	                        jQuery.event.dispatch.call( elem, e );
	                }
	                if ( e.isDefaultPrevented() ) {
	                        event.preventDefault();
	                }
	        }
	};
	
	// Some plugins are using, but it's undocumented/deprecated and will be removed.
	// The 1.7 special event interface should provide all the hooks needed now.
	jQuery.event.handle = jQuery.event.dispatch;
	
	jQuery.removeEvent = document.removeEventListener ?
	        function( elem, type, handle ) {
	                if ( elem.removeEventListener ) {
	                        elem.removeEventListener( type, handle, false );
	                }
	        } :
	        function( elem, type, handle ) {
	                var name = "on" + type;
	
	                if ( elem.detachEvent ) {
	
	                        // #8545, #7054, preventing memory leaks for custom events in IE6-8
	                        // detachEvent needed property on element, by name of that event, to properly expose it to GC
	                        if ( typeof elem[ name ] === "undefined" ) {
	                                elem[ name ] = null;
	                        }
	
	                        elem.detachEvent( name, handle );
	                }
	        };
	
	jQuery.Event = function( src, props ) {
	        // Allow instantiation without the 'new' keyword
	        if ( !(this instanceof jQuery.Event) ) {
	                return new jQuery.Event( src, props );
	        }
	
	        // Event object
	        if ( src && src.type ) {
	                this.originalEvent = src;
	                this.type = src.type;
	
	                // Events bubbling up the document may have been marked as prevented
	                // by a handler lower down the tree; reflect the correct value.
	                this.isDefaultPrevented = ( src.defaultPrevented || src.returnValue === false ||
	                        src.getPreventDefault && src.getPreventDefault() ) ? returnTrue : returnFalse;
	
	        // Event type
	        } else {
	                this.type = src;
	        }
	
	        // Put explicitly provided properties onto the event object
	        if ( props ) {
	                jQuery.extend( this, props );
	        }
	
	        // Create a timestamp if incoming event doesn't have one
	        this.timeStamp = src && src.timeStamp || jQuery.now();
	
	        // Mark it as fixed
	        this[ jQuery.expando ] = true;
	};
	
	function returnFalse() {
	        return false;
	}
	function returnTrue() {
	        return true;
	}
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
	        preventDefault: function() {
	                this.isDefaultPrevented = returnTrue;
	
	                var e = this.originalEvent;
	                if ( !e ) {
	                        return;
	                }
	
	                // if preventDefault exists run it on the original event
	                if ( e.preventDefault ) {
	                        e.preventDefault();
	
	                // otherwise set the returnValue property of the original event to false (IE)
	                } else {
	                        e.returnValue = false;
	                }
	        },
	        stopPropagation: function() {
	                this.isPropagationStopped = returnTrue;
	
	                var e = this.originalEvent;
	                if ( !e ) {
	                        return;
	                }
	                // if stopPropagation exists run it on the original event
	                if ( e.stopPropagation ) {
	                        e.stopPropagation();
	                }
	                // otherwise set the cancelBubble property of the original event to true (IE)
	                e.cancelBubble = true;
	        },
	        stopImmediatePropagation: function() {
	                this.isImmediatePropagationStopped = returnTrue;
	                this.stopPropagation();
	        },
	        isDefaultPrevented: returnFalse,
	        isPropagationStopped: returnFalse,
	        isImmediatePropagationStopped: returnFalse
	};
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	jQuery.each({
	        mouseenter: "mouseover",
	        mouseleave: "mouseout"
	}, function( orig, fix ) {
	        jQuery.event.special[ orig ] = {
	                delegateType: fix,
	                bindType: fix,
	
	                handle: function( event ) {
	                        var ret,
	                                target = this,
	                                related = event.relatedTarget,
	                                handleObj = event.handleObj,
	                                selector = handleObj.selector;
	
	                        // For mousenter/leave call the handler if related is outside the target.
	                        // NB: No relatedTarget if the mouse left/entered the browser window
	                        if ( !related || (related !== target && !jQuery.contains( target, related )) ) {
	                                event.type = handleObj.origType;
	                                ret = handleObj.handler.apply( this, arguments );
	                                event.type = fix;
	                        }
	                        return ret;
	                }
	        };
	});
	
	// IE submit delegation
	if ( !jQuery.support.submitBubbles ) {
	
	        jQuery.event.special.submit = {
	                setup: function() {
	                        // Only need this for delegated form submit events
	                        if ( jQuery.nodeName( this, "form" ) ) {
	                                return false;
	                        }
	
	                        // Lazy-add a submit handler when a descendant form may potentially be submitted
	                        jQuery.event.add( this, "click._submit keypress._submit", function( e ) {
	                                // Node name check avoids a VML-related crash in IE (#9807)
	                                var elem = e.target,
	                                        form = jQuery.nodeName( elem, "input" ) || jQuery.nodeName( elem, "button" ) ? elem.form : undefined;
	                                if ( form && !jQuery._data( form, "_submit_attached" ) ) {
	                                        jQuery.event.add( form, "submit._submit", function( event ) {
	                                                event._submit_bubble = true;
	                                        });
	                                        jQuery._data( form, "_submit_attached", true );
	                                }
	                        });
	                        // return undefined since we don't need an event listener
	                },
	
	                postDispatch: function( event ) {
	                        // If form was submitted by the user, bubble the event up the tree
	                        if ( event._submit_bubble ) {
	                                delete event._submit_bubble;
	                                if ( this.parentNode && !event.isTrigger ) {
	                                        jQuery.event.simulate( "submit", this.parentNode, event, true );
	                                }
	                        }
	                },
	
	                teardown: function() {
	                        // Only need this for delegated form submit events
	                        if ( jQuery.nodeName( this, "form" ) ) {
	                                return false;
	                        }
	
	                        // Remove delegated handlers; cleanData eventually reaps submit handlers attached above
	                        jQuery.event.remove( this, "._submit" );
	                }
	        };
	}
	
	// IE change delegation and checkbox/radio fix
	if ( !jQuery.support.changeBubbles ) {
	
	        jQuery.event.special.change = {
	
	                setup: function() {
	
	                        if ( rformElems.test( this.nodeName ) ) {
	                                // IE doesn't fire change on a check/radio until blur; trigger it on click
	                                // after a propertychange. Eat the blur-change in special.change.handle.
	                                // This still fires onchange a second time for check/radio after blur.
	                                if ( this.type === "checkbox" || this.type === "radio" ) {
	                                        jQuery.event.add( this, "propertychange._change", function( event ) {
	                                                if ( event.originalEvent.propertyName === "checked" ) {
	                                                        this._just_changed = true;
	                                                }
	                                        });
	                                        jQuery.event.add( this, "click._change", function( event ) {
	                                                if ( this._just_changed && !event.isTrigger ) {
	                                                        this._just_changed = false;
	                                                }
	                                                // Allow triggered, simulated change events (#11500)
	                                                jQuery.event.simulate( "change", this, event, true );
	                                        });
	                                }
	                                return false;
	                        }
	                        // Delegated event; lazy-add a change handler on descendant inputs
	                        jQuery.event.add( this, "beforeactivate._change", function( e ) {
	                                var elem = e.target;
	
	                                if ( rformElems.test( elem.nodeName ) && !jQuery._data( elem, "_change_attached" ) ) {
	                                        jQuery.event.add( elem, "change._change", function( event ) {
	                                                if ( this.parentNode && !event.isSimulated && !event.isTrigger ) {
	                                                        jQuery.event.simulate( "change", this.parentNode, event, true );
	                                                }
	                                        });
	                                        jQuery._data( elem, "_change_attached", true );
	                                }
	                        });
	                },
	
	                handle: function( event ) {
	                        var elem = event.target;
	
	                        // Swallow native change events from checkbox/radio, we already triggered them above
	                        if ( this !== elem || event.isSimulated || event.isTrigger || (elem.type !== "radio" && elem.type !== "checkbox") ) {
	                                return event.handleObj.handler.apply( this, arguments );
	                        }
	                },
	
	                teardown: function() {
	                        jQuery.event.remove( this, "._change" );
	
	                        return !rformElems.test( this.nodeName );
	                }
	        };
	}
	
	// Create "bubbling" focus and blur events
	if ( !jQuery.support.focusinBubbles ) {
	        jQuery.each({ focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
	                // Attach a single capturing handler while someone wants focusin/focusout
	                var attaches = 0,
	                        handler = function( event ) {
	                                jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ), true );
	                        };
	
	                jQuery.event.special[ fix ] = {
	                        setup: function() {
	                                if ( attaches++ === 0 ) {
	                                        document.addEventListener( orig, handler, true );
	                                }
	                        },
	                        teardown: function() {
	                                if ( --attaches === 0 ) {
	                                        document.removeEventListener( orig, handler, true );
	                                }
	                        }
	                };
	        });
	}
	
	jQuery.fn.extend({
	
	        on: function( types, selector, data, fn, /*INTERNAL*/ one ) {
	                var origFn, type;
	
	                // Types can be a map of types/handlers
	                if ( typeof types === "object" ) {
	                        // ( types-Object, selector, data )
	                        if ( typeof selector !== "string" ) { // && selector != null
	                                // ( types-Object, data )
	                                data = data || selector;
	                                selector = undefined;
	                        }
	                        for ( type in types ) {
	                                this.on( type, selector, data, types[ type ], one );
	                        }
	                        return this;
	                }
	
	                if ( data == null && fn == null ) {
	                        // ( types, fn )
	                        fn = selector;
	                        data = selector = undefined;
	                } else if ( fn == null ) {
	                        if ( typeof selector === "string" ) {
	                                // ( types, selector, fn )
	                                fn = data;
	                                data = undefined;
	                        } else {
	                                // ( types, data, fn )
	                                fn = data;
	                                data = selector;
	                                selector = undefined;
	                        }
	                }
	                if ( fn === false ) {
	                        fn = returnFalse;
	                } else if ( !fn ) {
	                        return this;
	                }
	
	                if ( one === 1 ) {
	                        origFn = fn;
	                        fn = function( event ) {
	                                // Can use an empty set, since event contains the info
	                                jQuery().off( event );
	                                return origFn.apply( this, arguments );
	                        };
	                        // Use same guid so caller can remove using origFn
	                        fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	                }
	                return this.each( function() {
	                        jQuery.event.add( this, types, fn, data, selector );
	                });
	        },
	        one: function( types, selector, data, fn ) {
	                return this.on( types, selector, data, fn, 1 );
	        },
	        off: function( types, selector, fn ) {
	                var handleObj, type;
	                if ( types && types.preventDefault && types.handleObj ) {
	                        // ( event )  dispatched jQuery.Event
	                        handleObj = types.handleObj;
	                        jQuery( types.delegateTarget ).off(
	                                handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType,
	                                handleObj.selector,
	                                handleObj.handler
	                        );
	                        return this;
	                }
	                if ( typeof types === "object" ) {
	                        // ( types-object [, selector] )
	                        for ( type in types ) {
	                                this.off( type, selector, types[ type ] );
	                        }
	                        return this;
	                }
	                if ( selector === false || typeof selector === "function" ) {
	                        // ( types [, fn] )
	                        fn = selector;
	                        selector = undefined;
	                }
	                if ( fn === false ) {
	                        fn = returnFalse;
	                }
	                return this.each(function() {
	                        jQuery.event.remove( this, types, fn, selector );
	                });
	        },
	
	        bind: function( types, data, fn ) {
	                return this.on( types, null, data, fn );
	        },
	        unbind: function( types, fn ) {
	                return this.off( types, null, fn );
	        },
	
	        live: function( types, data, fn ) {
	                jQuery( this.context ).on( types, this.selector, data, fn );
	                return this;
	        },
	        die: function( types, fn ) {
	                jQuery( this.context ).off( types, this.selector || "**", fn );
	                return this;
	        },
	
	        delegate: function( selector, types, data, fn ) {
	                return this.on( types, selector, data, fn );
	        },
	        undelegate: function( selector, types, fn ) {
	                // ( namespace ) or ( selector, types [, fn] )
	                return arguments.length === 1 ? this.off( selector, "**" ) : this.off( types, selector || "**", fn );
	        },
	
	        trigger: function( type, data ) {
	                return this.each(function() {
	                        jQuery.event.trigger( type, data, this );
	                });
	        },
	        triggerHandler: function( type, data ) {
	                if ( this[0] ) {
	                        return jQuery.event.trigger( type, data, this[0], true );
	                }
	        },
	
	        toggle: function( fn ) {
	                // Save reference to arguments for access in closure
	                var args = arguments,
	                        guid = fn.guid || jQuery.guid++,
	                        i = 0,
	                        toggler = function( event ) {
	                                // Figure out which function to execute
	                                var lastToggle = ( jQuery._data( this, "lastToggle" + fn.guid ) || 0 ) % i;
	                                jQuery._data( this, "lastToggle" + fn.guid, lastToggle + 1 );
	
	                                // Make sure that clicks stop
	                                event.preventDefault();
	
	                                // and execute the function
	                                return args[ lastToggle ].apply( this, arguments ) || false;
	                        };
	
	                // link all the functions, so any of them can unbind this click handler
	                toggler.guid = guid;
	                while ( i < args.length ) {
	                        args[ i++ ].guid = guid;
	                }
	
	                return this.click( toggler );
	        },
	
	        hover: function( fnOver, fnOut ) {
	                return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	        }
	});
	
	jQuery.each( ("blur focus focusin focusout load resize scroll unload click dblclick " +
	        "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	        "change select submit keydown keypress keyup error contextmenu").split(" "), function( i, name ) {
	
	        // Handle event binding
	        jQuery.fn[ name ] = function( data, fn ) {
	                if ( fn == null ) {
	                        fn = data;
	                        data = null;
	                }
	
	                return arguments.length > 0 ?
	                        this.on( name, null, data, fn ) :
	                        this.trigger( name );
	        };
	
	        if ( rkeyEvent.test( name ) ) {
	                jQuery.event.fixHooks[ name ] = jQuery.event.keyHooks;
	        }
	
	        if ( rmouseEvent.test( name ) ) {
	                jQuery.event.fixHooks[ name ] = jQuery.event.mouseHooks;
	        }
	});
	/*!
	 * Sizzle CSS Selector Engine
	 * Copyright 2012 jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://sizzlejs.com/
	 */
	(function( window, undefined ) {
	
	var cachedruns,
	        assertGetIdNotName,
	        Expr,
	        getText,
	        isXML,
	        contains,
	        compile,
	        sortOrder,
	        hasDuplicate,
	        outermostContext,
	
	        baseHasDuplicate = true,
	        strundefined = "undefined",
	
	        expando = ( "sizcache" + Math.random() ).replace( ".", "" ),
	
	        Token = String,
	        document = window.document,
	        docElem = document.documentElement,
	        dirruns = 0,
	        done = 0,
	        pop = [].pop,
	        push = [].push,
	        slice = [].slice,
	        // Use a stripped-down indexOf if a native one is unavailable
	        indexOf = [].indexOf || function( elem ) {
	                var i = 0,
	                        len = this.length;
	                for ( ; i < len; i++ ) {
	                        if ( this[i] === elem ) {
	                                return i;
	                        }
	                }
	                return -1;
	        },
	
	        // Augment a function for special use by Sizzle
	        markFunction = function( fn, value ) {
	                fn[ expando ] = value == null || value;
	                return fn;
	        },
	
	        createCache = function() {
	                var cache = {},
	                        keys = [];
	
	                return markFunction(function( key, value ) {
	                        // Only keep the most recent entries
	                        if ( keys.push( key ) > Expr.cacheLength ) {
	                                delete cache[ keys.shift() ];
	                        }
	
	                        // Retrieve with (key + " ") to avoid collision with native Object.prototype properties (see Issue #157)
	                        return (cache[ key + " " ] = value);
	                }, cache );
	        },
	
	        classCache = createCache(),
	        tokenCache = createCache(),
	        compilerCache = createCache(),
	
	        // Regex
	
	        // Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace
	        whitespace = "[\\x20\\t\\r\\n\\f]",
	        // http://www.w3.org/TR/css3-syntax/#characters
	        characterEncoding = "(?:\\\\.|[-\\w]|[^\\x00-\\xa0])+",
	
	        // Loosely modeled on CSS identifier characters
	        // An unquoted value should be a CSS identifier (http://www.w3.org/TR/css3-selectors/#attribute-selectors)
	        // Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	        identifier = characterEncoding.replace( "w", "w#" ),
	
	        // Acceptable operators http://www.w3.org/TR/selectors/#attribute-selectors
	        operators = "([*^$|!~]?=)",
	        attributes = "\\[" + whitespace + "*(" + characterEncoding + ")" + whitespace +
	                "*(?:" + operators + whitespace + "*(?:(['\"])((?:\\\\.|[^\\\\])*?)\\3|(" + identifier + ")|)|)" + whitespace + "*\\]",
	
	        // Prefer arguments not in parens/brackets,
	        //   then attribute selectors and non-pseudos (denoted by :),
	        //   then anything else
	        // These preferences are here to reduce the number of selectors
	        //   needing tokenize in the PSEUDO preFilter
	        pseudos = ":(" + characterEncoding + ")(?:\\((?:(['\"])((?:\\\\.|[^\\\\])*?)\\2|([^()[\\]]*|(?:(?:" + attributes + ")|[^:]|\\\\.)*|.*))\\)|)",
	
	        // For matchExpr.POS and matchExpr.needsContext
	        pos = ":(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
	                "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)",
	
	        // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	        rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
	        rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	        rcombinators = new RegExp( "^" + whitespace + "*([\\x20\\t\\r\\n\\f>+~])" + whitespace + "*" ),
	        rpseudo = new RegExp( pseudos ),
	
	        // Easily-parseable/retrievable ID or TAG or CLASS selectors
	        rquickExpr = /^(?:#([\w\-]+)|(\w+)|\.([\w\-]+))$/,
	
	        rnot = /^:not/,
	        rsibling = /[\x20\t\r\n\f]*[+~]/,
	        rendsWithNot = /:not\($/,
	
	        rheader = /h\d/i,
	        rinputs = /input|select|textarea|button/i,
	
	        rbackslash = /\\(?!\\)/g,
	
	        matchExpr = {
	                "ID": new RegExp( "^#(" + characterEncoding + ")" ),
	                "CLASS": new RegExp( "^\\.(" + characterEncoding + ")" ),
	                "NAME": new RegExp( "^\\[name=['\"]?(" + characterEncoding + ")['\"]?\\]" ),
	                "TAG": new RegExp( "^(" + characterEncoding.replace( "w", "w*" ) + ")" ),
	                "ATTR": new RegExp( "^" + attributes ),
	                "PSEUDO": new RegExp( "^" + pseudos ),
	                "POS": new RegExp( pos, "i" ),
	                "CHILD": new RegExp( "^:(only|nth|first|last)-child(?:\\(" + whitespace +
	                        "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
	                        "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
	                // For use in libraries implementing .is()
	                "needsContext": new RegExp( "^" + whitespace + "*[>+~]|" + pos, "i" )
	        },
	
	        // Support
	
	        // Used for testing something on an element
	        assert = function( fn ) {
	                var div = document.createElement("div");
	
	                try {
	                        return fn( div );
	                } catch (e) {
	                        return false;
	                } finally {
	                        // release memory in IE
	                        div = null;
	                }
	        },
	
	        // Check if getElementsByTagName("*") returns only elements
	        assertTagNameNoComments = assert(function( div ) {
	                div.appendChild( document.createComment("") );
	                return !div.getElementsByTagName("*").length;
	        }),
	
	        // Check if getAttribute returns normalized href attributes
	        assertHrefNotNormalized = assert(function( div ) {
	                div.innerHTML = "<a href='#'></a>";
	                return div.firstChild && typeof div.firstChild.getAttribute !== strundefined &&
	                        div.firstChild.getAttribute("href") === "#";
	        }),
	
	        // Check if attributes should be retrieved by attribute nodes
	        assertAttributes = assert(function( div ) {
	                div.innerHTML = "<select></select>";
	                var type = typeof div.lastChild.getAttribute("multiple");
	                // IE8 returns a string for some attributes even when not present
	                return type !== "boolean" && type !== "string";
	        }),
	
	        // Check if getElementsByClassName can be trusted
	        assertUsableClassName = assert(function( div ) {
	                // Opera can't find a second classname (in 9.6)
	                div.innerHTML = "<div class='hidden e'></div><div class='hidden'></div>";
	                if ( !div.getElementsByClassName || !div.getElementsByClassName("e").length ) {
	                        return false;
	                }
	
	                // Safari 3.2 caches class attributes and doesn't catch changes
	                div.lastChild.className = "e";
	                return div.getElementsByClassName("e").length === 2;
	        }),
	
	        // Check if getElementById returns elements by name
	        // Check if getElementsByName privileges form controls or returns elements by ID
	        assertUsableName = assert(function( div ) {
	                // Inject content
	                div.id = expando + 0;
	                div.innerHTML = "<a name='" + expando + "'></a><div name='" + expando + "'></div>";
	                docElem.insertBefore( div, docElem.firstChild );
	
	                // Test
	                var pass = document.getElementsByName &&
	                        // buggy browsers will return fewer than the correct 2
	                        document.getElementsByName( expando ).length === 2 +
	                        // buggy browsers will return more than the correct 0
	                        document.getElementsByName( expando + 0 ).length;
	                assertGetIdNotName = !document.getElementById( expando );
	
	                // Cleanup
	                docElem.removeChild( div );
	
	                return pass;
	        });
	
	// If slice is not available, provide a backup
	try {
	        slice.call( docElem.childNodes, 0 )[0].nodeType;
	} catch ( e ) {
	        slice = function( i ) {
	                var elem,
	                        results = [];
	                for ( ; (elem = this[i]); i++ ) {
	                        results.push( elem );
	                }
	                return results;
	        };
	}
	
	function Sizzle( selector, context, results, seed ) {
	        results = results || [];
	        context = context || document;
	        var match, elem, xml, m,
	                nodeType = context.nodeType;
	
	        if ( !selector || typeof selector !== "string" ) {
	                return results;
	        }
	
	        if ( nodeType !== 1 && nodeType !== 9 ) {
	                return [];
	        }
	
	        xml = isXML( context );
	
	        if ( !xml && !seed ) {
	                if ( (match = rquickExpr.exec( selector )) ) {
	                        // Speed-up: Sizzle("#ID")
	                        if ( (m = match[1]) ) {
	                                if ( nodeType === 9 ) {
	                                        elem = context.getElementById( m );
	                                        // Check parentNode to catch when Blackberry 4.6 returns
	                                        // nodes that are no longer in the document #6963
	                                        if ( elem && elem.parentNode ) {
	                                                // Handle the case where IE, Opera, and Webkit return items
	                                                // by name instead of ID
	                                                if ( elem.id === m ) {
	                                                        results.push( elem );
	                                                        return results;
	                                                }
	                                        } else {
	                                                return results;
	                                        }
	                                } else {
	                                        // Context is not a document
	                                        if ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&
	                                                contains( context, elem ) && elem.id === m ) {
	                                                results.push( elem );
	                                                return results;
	                                        }
	                                }
	
	                        // Speed-up: Sizzle("TAG")
	                        } else if ( match[2] ) {
	                                push.apply( results, slice.call(context.getElementsByTagName( selector ), 0) );
	                                return results;
	
	                        // Speed-up: Sizzle(".CLASS")
	                        } else if ( (m = match[3]) && assertUsableClassName && context.getElementsByClassName ) {
	                                push.apply( results, slice.call(context.getElementsByClassName( m ), 0) );
	                                return results;
	                        }
	                }
	        }
	
	        // All others
	        return select( selector.replace( rtrim, "$1" ), context, results, seed, xml );
	}
	
	Sizzle.matches = function( expr, elements ) {
	        return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
	        return Sizzle( expr, null, null, [ elem ] ).length > 0;
	};
	
	// Returns a function to use in pseudos for input types
	function createInputPseudo( type ) {
	        return function( elem ) {
	                var name = elem.nodeName.toLowerCase();
	                return name === "input" && elem.type === type;
	        };
	}
	
	// Returns a function to use in pseudos for buttons
	function createButtonPseudo( type ) {
	        return function( elem ) {
	                var name = elem.nodeName.toLowerCase();
	                return (name === "input" || name === "button") && elem.type === type;
	        };
	}
	
	// Returns a function to use in pseudos for positionals
	function createPositionalPseudo( fn ) {
	        return markFunction(function( argument ) {
	                argument = +argument;
	                return markFunction(function( seed, matches ) {
	                        var j,
	                                matchIndexes = fn( [], seed.length, argument ),
	                                i = matchIndexes.length;
	
	                        // Match elements found at the specified indexes
	                        while ( i-- ) {
	                                if ( seed[ (j = matchIndexes[i]) ] ) {
	                                        seed[j] = !(matches[j] = seed[j]);
	                                }
	                        }
	                });
	        });
	}
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
	        var node,
	                ret = "",
	                i = 0,
	                nodeType = elem.nodeType;
	
	        if ( nodeType ) {
	                if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	                        // Use textContent for elements
	                        // innerText usage removed for consistency of new lines (see #11153)
	                        if ( typeof elem.textContent === "string" ) {
	                                return elem.textContent;
	                        } else {
	                                // Traverse its children
	                                for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
	                                        ret += getText( elem );
	                                }
	                        }
	                } else if ( nodeType === 3 || nodeType === 4 ) {
	                        return elem.nodeValue;
	                }
	                // Do not include comment or processing instruction nodes
	        } else {
	
	                // If no nodeType, this is expected to be an array
	                for ( ; (node = elem[i]); i++ ) {
	                        // Do not traverse comment nodes
	                        ret += getText( node );
	                }
	        }
	        return ret;
	};
	
	isXML = Sizzle.isXML = function( elem ) {
	        // documentElement is verified for cases where it doesn't yet exist
	        // (such as loading iframes in IE - #4833)
	        var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	        return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	// Element contains another
	contains = Sizzle.contains = docElem.contains ?
	        function( a, b ) {
	                var adown = a.nodeType === 9 ? a.documentElement : a,
	                        bup = b && b.parentNode;
	                return a === bup || !!( bup && bup.nodeType === 1 && adown.contains && adown.contains(bup) );
	        } :
	        docElem.compareDocumentPosition ?
	        function( a, b ) {
	                return b && !!( a.compareDocumentPosition( b ) & 16 );
	        } :
	        function( a, b ) {
	                while ( (b = b.parentNode) ) {
	                        if ( b === a ) {
	                                return true;
	                        }
	                }
	                return false;
	        };
	
	Sizzle.attr = function( elem, name ) {
	        var val,
	                xml = isXML( elem );
	
	        if ( !xml ) {
	                name = name.toLowerCase();
	        }
	        if ( (val = Expr.attrHandle[ name ]) ) {
	                return val( elem );
	        }
	        if ( xml || assertAttributes ) {
	                return elem.getAttribute( name );
	        }
	        val = elem.getAttributeNode( name );
	        return val ?
	                typeof elem[ name ] === "boolean" ?
	                        elem[ name ] ? name : null :
	                        val.specified ? val.value : null :
	                null;
	};
	
	Expr = Sizzle.selectors = {
	
	        // Can be adjusted by the user
	        cacheLength: 50,
	
	        createPseudo: markFunction,
	
	        match: matchExpr,
	
	        // IE6/7 return a modified href
	        attrHandle: assertHrefNotNormalized ?
	                {} :
	                {
	                        "href": function( elem ) {
	                                return elem.getAttribute( "href", 2 );
	                        },
	                        "type": function( elem ) {
	                                return elem.getAttribute("type");
	                        }
	                },
	
	        find: {
	                "ID": assertGetIdNotName ?
	                        function( id, context, xml ) {
	                                if ( typeof context.getElementById !== strundefined && !xml ) {
	                                        var m = context.getElementById( id );
	                                        // Check parentNode to catch when Blackberry 4.6 returns
	                                        // nodes that are no longer in the document #6963
	                                        return m && m.parentNode ? [m] : [];
	                                }
	                        } :
	                        function( id, context, xml ) {
	                                if ( typeof context.getElementById !== strundefined && !xml ) {
	                                        var m = context.getElementById( id );
	
	                                        return m ?
	                                                m.id === id || typeof m.getAttributeNode !== strundefined && m.getAttributeNode("id").value === id ?
	                                                        [m] :
	                                                        undefined :
	                                                [];
	                                }
	                        },
	
	                "TAG": assertTagNameNoComments ?
	                        function( tag, context ) {
	                                if ( typeof context.getElementsByTagName !== strundefined ) {
	                                        return context.getElementsByTagName( tag );
	                                }
	                        } :
	                        function( tag, context ) {
	                                var results = context.getElementsByTagName( tag );
	
	                                // Filter out possible comments
	                                if ( tag === "*" ) {
	                                        var elem,
	                                                tmp = [],
	                                                i = 0;
	
	                                        for ( ; (elem = results[i]); i++ ) {
	                                                if ( elem.nodeType === 1 ) {
	                                                        tmp.push( elem );
	                                                }
	                                        }
	
	                                        return tmp;
	                                }
	                                return results;
	                        },
	
	                "NAME": assertUsableName && function( tag, context ) {
	                        if ( typeof context.getElementsByName !== strundefined ) {
	                                return context.getElementsByName( name );
	                        }
	                },
	
	                "CLASS": assertUsableClassName && function( className, context, xml ) {
	                        if ( typeof context.getElementsByClassName !== strundefined && !xml ) {
	                                return context.getElementsByClassName( className );
	                        }
	                }
	        },
	
	        relative: {
	                ">": { dir: "parentNode", first: true },
	                " ": { dir: "parentNode" },
	                "+": { dir: "previousSibling", first: true },
	                "~": { dir: "previousSibling" }
	        },
	
	        preFilter: {
	                "ATTR": function( match ) {
	                        match[1] = match[1].replace( rbackslash, "" );
	
	                        // Move the given value to match[3] whether quoted or unquoted
	                        match[3] = ( match[4] || match[5] || "" ).replace( rbackslash, "" );
	
	                        if ( match[2] === "~=" ) {
	                                match[3] = " " + match[3] + " ";
	                        }
	
	                        return match.slice( 0, 4 );
	                },
	
	                "CHILD": function( match ) {
	                        /* matches from matchExpr["CHILD"]
	                                1 type (only|nth|...)
	                                2 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	                                3 xn-component of xn+y argument ([+-]?\d*n|)
	                                4 sign of xn-component
	                                5 x of xn-component
	                                6 sign of y-component
	                                7 y of y-component
	                        */
	                        match[1] = match[1].toLowerCase();
	
	                        if ( match[1] === "nth" ) {
	                                // nth-child requires argument
	                                if ( !match[2] ) {
	                                        Sizzle.error( match[0] );
	                                }
	
	                                // numeric x and y parameters for Expr.filter.CHILD
	                                // remember that false/true cast respectively to 0/1
	                                match[3] = +( match[3] ? match[4] + (match[5] || 1) : 2 * ( match[2] === "even" || match[2] === "odd" ) );
	                                match[4] = +( ( match[6] + match[7] ) || match[2] === "odd" );
	
	                        // other types prohibit arguments
	                        } else if ( match[2] ) {
	                                Sizzle.error( match[0] );
	                        }
	
	                        return match;
	                },
	
	                "PSEUDO": function( match ) {
	                        var unquoted, excess;
	                        if ( matchExpr["CHILD"].test( match[0] ) ) {
	                                return null;
	                        }
	
	                        if ( match[3] ) {
	                                match[2] = match[3];
	                        } else if ( (unquoted = match[4]) ) {
	                                // Only check arguments that contain a pseudo
	                                if ( rpseudo.test(unquoted) &&
	                                        // Get excess from tokenize (recursively)
	                                        (excess = tokenize( unquoted, true )) &&
	                                        // advance to the next closing parenthesis
	                                        (excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
	                                        // excess is a negative index
	                                        unquoted = unquoted.slice( 0, excess );
	                                        match[0] = match[0].slice( 0, excess );
	                                }
	                                match[2] = unquoted;
	                        }
	
	                        // Return only captures needed by the pseudo filter method (type and argument)
	                        return match.slice( 0, 3 );
	                }
	        },
	
	        filter: {
	                "ID": assertGetIdNotName ?
	                        function( id ) {
	                                id = id.replace( rbackslash, "" );
	                                return function( elem ) {
	                                        return elem.getAttribute("id") === id;
	                                };
	                        } :
	                        function( id ) {
	                                id = id.replace( rbackslash, "" );
	                                return function( elem ) {
	                                        var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
	                                        return node && node.value === id;
	                                };
	                        },
	
	                "TAG": function( nodeName ) {
	                        if ( nodeName === "*" ) {
	                                return function() { return true; };
	                        }
	                        nodeName = nodeName.replace( rbackslash, "" ).toLowerCase();
	
	                        return function( elem ) {
	                                return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	                        };
	                },
	
	                "CLASS": function( className ) {
	                        var pattern = classCache[ expando ][ className + " " ];
	
	                        return pattern ||
	                                (pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
	                                classCache( className, function( elem ) {
	                                        return pattern.test( elem.className || (typeof elem.getAttribute !== strundefined && elem.getAttribute("class")) || "" );
	                                });
	                },
	
	                "ATTR": function( name, operator, check ) {
	                        return function( elem, context ) {
	                                var result = Sizzle.attr( elem, name );
	
	                                if ( result == null ) {
	                                        return operator === "!=";
	                                }
	                                if ( !operator ) {
	                                        return true;
	                                }
	
	                                result += "";
	
	                                return operator === "=" ? result === check :
	                                        operator === "!=" ? result !== check :
	                                        operator === "^=" ? check && result.indexOf( check ) === 0 :
	                                        operator === "*=" ? check && result.indexOf( check ) > -1 :
	                                        operator === "$=" ? check && result.substr( result.length - check.length ) === check :
	                                        operator === "~=" ? ( " " + result + " " ).indexOf( check ) > -1 :
	                                        operator === "|=" ? result === check || result.substr( 0, check.length + 1 ) === check + "-" :
	                                        false;
	                        };
	                },
	
	                "CHILD": function( type, argument, first, last ) {
	
	                        if ( type === "nth" ) {
	                                return function( elem ) {
	                                        var node, diff,
	                                                parent = elem.parentNode;
	
	                                        if ( first === 1 && last === 0 ) {
	                                                return true;
	                                        }
	
	                                        if ( parent ) {
	                                                diff = 0;
	                                                for ( node = parent.firstChild; node; node = node.nextSibling ) {
	                                                        if ( node.nodeType === 1 ) {
	                                                                diff++;
	                                                                if ( elem === node ) {
	                                                                        break;
	                                                                }
	                                                        }
	                                                }
	                                        }
	
	                                        // Incorporate the offset (or cast to NaN), then check against cycle size
	                                        diff -= last;
	                                        return diff === first || ( diff % first === 0 && diff / first >= 0 );
	                                };
	                        }
	
	                        return function( elem ) {
	                                var node = elem;
	
	                                switch ( type ) {
	                                        case "only":
	                                        case "first":
	                                                while ( (node = node.previousSibling) ) {
	                                                        if ( node.nodeType === 1 ) {
	                                                                return false;
	                                                        }
	                                                }
	
	                                                if ( type === "first" ) {
	                                                        return true;
	                                                }
	
	                                                node = elem;
	
	                                                /* falls through */
	                                        case "last":
	                                                while ( (node = node.nextSibling) ) {
	                                                        if ( node.nodeType === 1 ) {
	                                                                return false;
	                                                        }
	                                                }
	
	                                                return true;
	                                }
	                        };
	                },
	
	                "PSEUDO": function( pseudo, argument ) {
	                        // pseudo-class names are case-insensitive
	                        // http://www.w3.org/TR/selectors/#pseudo-classes
	                        // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
	                        // Remember that setFilters inherits from pseudos
	                        var args,
	                                fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
	                                        Sizzle.error( "unsupported pseudo: " + pseudo );
	
	                        // The user may use createPseudo to indicate that
	                        // arguments are needed to create the filter function
	                        // just as Sizzle does
	                        if ( fn[ expando ] ) {
	                                return fn( argument );
	                        }
	
	                        // But maintain support for old signatures
	                        if ( fn.length > 1 ) {
	                                args = [ pseudo, pseudo, "", argument ];
	                                return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
	                                        markFunction(function( seed, matches ) {
	                                                var idx,
	                                                        matched = fn( seed, argument ),
	                                                        i = matched.length;
	                                                while ( i-- ) {
	                                                        idx = indexOf.call( seed, matched[i] );
	                                                        seed[ idx ] = !( matches[ idx ] = matched[i] );
	                                                }
	                                        }) :
	                                        function( elem ) {
	                                                return fn( elem, 0, args );
	                                        };
	                        }
	
	                        return fn;
	                }
	        },
	
	        pseudos: {
	                "not": markFunction(function( selector ) {
	                        // Trim the selector passed to compile
	                        // to avoid treating leading and trailing
	                        // spaces as combinators
	                        var input = [],
	                                results = [],
	                                matcher = compile( selector.replace( rtrim, "$1" ) );
	
	                        return matcher[ expando ] ?
	                                markFunction(function( seed, matches, context, xml ) {
	                                        var elem,
	                                                unmatched = matcher( seed, null, xml, [] ),
	                                                i = seed.length;
	
	                                        // Match elements unmatched by `matcher`
	                                        while ( i-- ) {
	                                                if ( (elem = unmatched[i]) ) {
	                                                        seed[i] = !(matches[i] = elem);
	                                                }
	                                        }
	                                }) :
	                                function( elem, context, xml ) {
	                                        input[0] = elem;
	                                        matcher( input, null, xml, results );
	                                        return !results.pop();
	                                };
	                }),
	
	                "has": markFunction(function( selector ) {
	                        return function( elem ) {
	                                return Sizzle( selector, elem ).length > 0;
	                        };
	                }),
	
	                "contains": markFunction(function( text ) {
	                        return function( elem ) {
	                                return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
	                        };
	                }),
	
	                "enabled": function( elem ) {
	                        return elem.disabled === false;
	                },
	
	                "disabled": function( elem ) {
	                        return elem.disabled === true;
	                },
	
	                "checked": function( elem ) {
	                        // In CSS3, :checked should return both checked and selected elements
	                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	                        var nodeName = elem.nodeName.toLowerCase();
	                        return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
	                },
	
	                "selected": function( elem ) {
	                        // Accessing this property makes selected-by-default
	                        // options in Safari work properly
	                        if ( elem.parentNode ) {
	                                elem.parentNode.selectedIndex;
	                        }
	
	                        return elem.selected === true;
	                },
	
	                "parent": function( elem ) {
	                        return !Expr.pseudos["empty"]( elem );
	                },
	
	                "empty": function( elem ) {
	                        // http://www.w3.org/TR/selectors/#empty-pseudo
	                        // :empty is only affected by element nodes and content nodes(including text(3), cdata(4)),
	                        //   not comment, processing instructions, or others
	                        // Thanks to Diego Perini for the nodeName shortcut
	                        //   Greater than "@" means alpha characters (specifically not starting with "#" or "?")
	                        var nodeType;
	                        elem = elem.firstChild;
	                        while ( elem ) {
	                                if ( elem.nodeName > "@" || (nodeType = elem.nodeType) === 3 || nodeType === 4 ) {
	                                        return false;
	                                }
	                                elem = elem.nextSibling;
	                        }
	                        return true;
	                },
	
	                "header": function( elem ) {
	                        return rheader.test( elem.nodeName );
	                },
	
	                "text": function( elem ) {
	                        var type, attr;
	                        // IE6 and 7 will map elem.type to 'text' for new HTML5 types (search, etc)
	                        // use getAttribute instead to test this case
	                        return elem.nodeName.toLowerCase() === "input" &&
	                                (type = elem.type) === "text" &&
	                                ( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === type );
	                },
	
	                // Input types
	                "radio": createInputPseudo("radio"),
	                "checkbox": createInputPseudo("checkbox"),
	                "file": createInputPseudo("file"),
	                "password": createInputPseudo("password"),
	                "image": createInputPseudo("image"),
	
	                "submit": createButtonPseudo("submit"),
	                "reset": createButtonPseudo("reset"),
	
	                "button": function( elem ) {
	                        var name = elem.nodeName.toLowerCase();
	                        return name === "input" && elem.type === "button" || name === "button";
	                },
	
	                "input": function( elem ) {
	                        return rinputs.test( elem.nodeName );
	                },
	
	                "focus": function( elem ) {
	                        var doc = elem.ownerDocument;
	                        return elem === doc.activeElement && (!doc.hasFocus || doc.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	                },
	
	                "active": function( elem ) {
	                        return elem === elem.ownerDocument.activeElement;
	                },
	
	                // Positional types
	                "first": createPositionalPseudo(function() {
	                        return [ 0 ];
	                }),
	
	                "last": createPositionalPseudo(function( matchIndexes, length ) {
	                        return [ length - 1 ];
	                }),
	
	                "eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
	                        return [ argument < 0 ? argument + length : argument ];
	                }),
	
	                "even": createPositionalPseudo(function( matchIndexes, length ) {
	                        for ( var i = 0; i < length; i += 2 ) {
	                                matchIndexes.push( i );
	                        }
	                        return matchIndexes;
	                }),
	
	                "odd": createPositionalPseudo(function( matchIndexes, length ) {
	                        for ( var i = 1; i < length; i += 2 ) {
	                                matchIndexes.push( i );
	                        }
	                        return matchIndexes;
	                }),
	
	                "lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
	                        for ( var i = argument < 0 ? argument + length : argument; --i >= 0; ) {
	                                matchIndexes.push( i );
	                        }
	                        return matchIndexes;
	                }),
	
	                "gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
	                        for ( var i = argument < 0 ? argument + length : argument; ++i < length; ) {
	                                matchIndexes.push( i );
	                        }
	                        return matchIndexes;
	                })
	        }
	};
	
	function siblingCheck( a, b, ret ) {
	        if ( a === b ) {
	                return ret;
	        }
	
	        var cur = a.nextSibling;
	
	        while ( cur ) {
	                if ( cur === b ) {
	                        return -1;
	                }
	
	                cur = cur.nextSibling;
	        }
	
	        return 1;
	}
	
	sortOrder = docElem.compareDocumentPosition ?
	        function( a, b ) {
	                if ( a === b ) {
	                        hasDuplicate = true;
	                        return 0;
	                }
	
	                return ( !a.compareDocumentPosition || !b.compareDocumentPosition ?
	                        a.compareDocumentPosition :
	                        a.compareDocumentPosition(b) & 4
	                ) ? -1 : 1;
	        } :
	        function( a, b ) {
	                // The nodes are identical, we can exit early
	                if ( a === b ) {
	                        hasDuplicate = true;
	                        return 0;
	
	                // Fallback to using sourceIndex (in IE) if it's available on both nodes
	                } else if ( a.sourceIndex && b.sourceIndex ) {
	                        return a.sourceIndex - b.sourceIndex;
	                }
	
	                var al, bl,
	                        ap = [],
	                        bp = [],
	                        aup = a.parentNode,
	                        bup = b.parentNode,
	                        cur = aup;
	
	                // If the nodes are siblings (or identical) we can do a quick check
	                if ( aup === bup ) {
	                        return siblingCheck( a, b );
	
	                // If no parents were found then the nodes are disconnected
	                } else if ( !aup ) {
	                        return -1;
	
	                } else if ( !bup ) {
	                        return 1;
	                }
	
	                // Otherwise they're somewhere else in the tree so we need
	                // to build up a full list of the parentNodes for comparison
	                while ( cur ) {
	                        ap.unshift( cur );
	                        cur = cur.parentNode;
	                }
	
	                cur = bup;
	
	                while ( cur ) {
	                        bp.unshift( cur );
	                        cur = cur.parentNode;
	                }
	
	                al = ap.length;
	                bl = bp.length;
	
	                // Start walking down the tree looking for a discrepancy
	                for ( var i = 0; i < al && i < bl; i++ ) {
	                        if ( ap[i] !== bp[i] ) {
	                                return siblingCheck( ap[i], bp[i] );
	                        }
	                }
	
	                // We ended someplace up the tree so do a sibling check
	                return i === al ?
	                        siblingCheck( a, bp[i], -1 ) :
	                        siblingCheck( ap[i], b, 1 );
	        };
	
	// Always assume the presence of duplicates if sort doesn't
	// pass them to our comparison function (as in Google Chrome).
	[0, 0].sort( sortOrder );
	baseHasDuplicate = !hasDuplicate;
	
	// Document sorting and removing duplicates
	Sizzle.uniqueSort = function( results ) {
	        var elem,
	                duplicates = [],
	                i = 1,
	                j = 0;
	
	        hasDuplicate = baseHasDuplicate;
	        results.sort( sortOrder );
	
	        if ( hasDuplicate ) {
	                for ( ; (elem = results[i]); i++ ) {
	                        if ( elem === results[ i - 1 ] ) {
	                                j = duplicates.push( i );
	                        }
	                }
	                while ( j-- ) {
	                        results.splice( duplicates[ j ], 1 );
	                }
	        }
	
	        return results;
	};
	
	Sizzle.error = function( msg ) {
	        throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	function tokenize( selector, parseOnly ) {
	        var matched, match, tokens, type,
	                soFar, groups, preFilters,
	                cached = tokenCache[ expando ][ selector + " " ];
	
	        if ( cached ) {
	                return parseOnly ? 0 : cached.slice( 0 );
	        }
	
	        soFar = selector;
	        groups = [];
	        preFilters = Expr.preFilter;
	
	        while ( soFar ) {
	
	                // Comma and first run
	                if ( !matched || (match = rcomma.exec( soFar )) ) {
	                        if ( match ) {
	                                // Don't consume trailing commas as valid
	                                soFar = soFar.slice( match[0].length ) || soFar;
	                        }
	                        groups.push( tokens = [] );
	                }
	
	                matched = false;
	
	                // Combinators
	                if ( (match = rcombinators.exec( soFar )) ) {
	                        tokens.push( matched = new Token( match.shift() ) );
	                        soFar = soFar.slice( matched.length );
	
	                        // Cast descendant combinators to space
	                        matched.type = match[0].replace( rtrim, " " );
	                }
	
	                // Filters
	                for ( type in Expr.filter ) {
	                        if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
	                                (match = preFilters[ type ]( match ))) ) {
	
	                                tokens.push( matched = new Token( match.shift() ) );
	                                soFar = soFar.slice( matched.length );
	                                matched.type = type;
	                                matched.matches = match;
	                        }
	                }
	
	                if ( !matched ) {
	                        break;
	                }
	        }
	
	        // Return the length of the invalid excess
	        // if we're just parsing
	        // Otherwise, throw an error or return tokens
	        return parseOnly ?
	                soFar.length :
	                soFar ?
	                        Sizzle.error( selector ) :
	                        // Cache the tokens
	                        tokenCache( selector, groups ).slice( 0 );
	}
	
	function addCombinator( matcher, combinator, base ) {
	        var dir = combinator.dir,
	                checkNonElements = base && combinator.dir === "parentNode",
	                doneName = done++;
	
	        return combinator.first ?
	                // Check against closest ancestor/preceding element
	                function( elem, context, xml ) {
	                        while ( (elem = elem[ dir ]) ) {
	                                if ( checkNonElements || elem.nodeType === 1  ) {
	                                        return matcher( elem, context, xml );
	                                }
	                        }
	                } :
	
	                // Check against all ancestor/preceding elements
	                function( elem, context, xml ) {
	                        // We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
	                        if ( !xml ) {
	                                var cache,
	                                        dirkey = dirruns + " " + doneName + " ",
	                                        cachedkey = dirkey + cachedruns;
	                                while ( (elem = elem[ dir ]) ) {
	                                        if ( checkNonElements || elem.nodeType === 1 ) {
	                                                if ( (cache = elem[ expando ]) === cachedkey ) {
	                                                        return elem.sizset;
	                                                } else if ( typeof cache === "string" && cache.indexOf(dirkey) === 0 ) {
	                                                        if ( elem.sizset ) {
	                                                                return elem;
	                                                        }
	                                                } else {
	                                                        elem[ expando ] = cachedkey;
	                                                        if ( matcher( elem, context, xml ) ) {
	                                                                elem.sizset = true;
	                                                                return elem;
	                                                        }
	                                                        elem.sizset = false;
	                                                }
	                                        }
	                                }
	                        } else {
	                                while ( (elem = elem[ dir ]) ) {
	                                        if ( checkNonElements || elem.nodeType === 1 ) {
	                                                if ( matcher( elem, context, xml ) ) {
	                                                        return elem;
	                                                }
	                                        }
	                                }
	                        }
	                };
	}
	
	function elementMatcher( matchers ) {
	        return matchers.length > 1 ?
	                function( elem, context, xml ) {
	                        var i = matchers.length;
	                        while ( i-- ) {
	                                if ( !matchers[i]( elem, context, xml ) ) {
	                                        return false;
	                                }
	                        }
	                        return true;
	                } :
	                matchers[0];
	}
	
	function condense( unmatched, map, filter, context, xml ) {
	        var elem,
	                newUnmatched = [],
	                i = 0,
	                len = unmatched.length,
	                mapped = map != null;
	
	        for ( ; i < len; i++ ) {
	                if ( (elem = unmatched[i]) ) {
	                        if ( !filter || filter( elem, context, xml ) ) {
	                                newUnmatched.push( elem );
	                                if ( mapped ) {
	                                        map.push( i );
	                                }
	                        }
	                }
	        }
	
	        return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	        if ( postFilter && !postFilter[ expando ] ) {
	                postFilter = setMatcher( postFilter );
	        }
	        if ( postFinder && !postFinder[ expando ] ) {
	                postFinder = setMatcher( postFinder, postSelector );
	        }
	        return markFunction(function( seed, results, context, xml ) {
	                var temp, i, elem,
	                        preMap = [],
	                        postMap = [],
	                        preexisting = results.length,
	
	                        // Get initial elements from seed or context
	                        elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
	                        // Prefilter to get matcher input, preserving a map for seed-results synchronization
	                        matcherIn = preFilter && ( seed || !selector ) ?
	                                condense( elems, preMap, preFilter, context, xml ) :
	                                elems,
	
	                        matcherOut = matcher ?
	                                // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
	                                postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
	                                        // ...intermediate processing is necessary
	                                        [] :
	
	                                        // ...otherwise use results directly
	                                        results :
	                                matcherIn;
	
	                // Find primary matches
	                if ( matcher ) {
	                        matcher( matcherIn, matcherOut, context, xml );
	                }
	
	                // Apply postFilter
	                if ( postFilter ) {
	                        temp = condense( matcherOut, postMap );
	                        postFilter( temp, [], context, xml );
	
	                        // Un-match failing elements by moving them back to matcherIn
	                        i = temp.length;
	                        while ( i-- ) {
	                                if ( (elem = temp[i]) ) {
	                                        matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
	                                }
	                        }
	                }
	
	                if ( seed ) {
	                        if ( postFinder || preFilter ) {
	                                if ( postFinder ) {
	                                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
	                                        temp = [];
	                                        i = matcherOut.length;
	                                        while ( i-- ) {
	                                                if ( (elem = matcherOut[i]) ) {
	                                                        // Restore matcherIn since elem is not yet a final match
	                                                        temp.push( (matcherIn[i] = elem) );
	                                                }
	                                        }
	                                        postFinder( null, (matcherOut = []), temp, xml );
	                                }
	
	                                // Move matched elements from seed to results to keep them synchronized
	                                i = matcherOut.length;
	                                while ( i-- ) {
	                                        if ( (elem = matcherOut[i]) &&
	                                                (temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {
	
	                                                seed[temp] = !(results[temp] = elem);
	                                        }
	                                }
	                        }
	
	                // Add elements to results, through postFinder if defined
	                } else {
	                        matcherOut = condense(
	                                matcherOut === results ?
	                                        matcherOut.splice( preexisting, matcherOut.length ) :
	                                        matcherOut
	                        );
	                        if ( postFinder ) {
	                                postFinder( null, results, matcherOut, xml );
	                        } else {
	                                push.apply( results, matcherOut );
	                        }
	                }
	        });
	}
	
	function matcherFromTokens( tokens ) {
	        var checkContext, matcher, j,
	                len = tokens.length,
	                leadingRelative = Expr.relative[ tokens[0].type ],
	                implicitRelative = leadingRelative || Expr.relative[" "],
	                i = leadingRelative ? 1 : 0,
	
	                // The foundational matcher ensures that elements are reachable from top-level context(s)
	                matchContext = addCombinator( function( elem ) {
	                        return elem === checkContext;
	                }, implicitRelative, true ),
	                matchAnyContext = addCombinator( function( elem ) {
	                        return indexOf.call( checkContext, elem ) > -1;
	                }, implicitRelative, true ),
	                matchers = [ function( elem, context, xml ) {
	                        return ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
	                                (checkContext = context).nodeType ?
	                                        matchContext( elem, context, xml ) :
	                                        matchAnyContext( elem, context, xml ) );
	                } ];
	
	        for ( ; i < len; i++ ) {
	                if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
	                        matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
	                } else {
	                        matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
	                        // Return special upon seeing a positional matcher
	                        if ( matcher[ expando ] ) {
	                                // Find the next relative operator (if any) for proper handling
	                                j = ++i;
	                                for ( ; j < len; j++ ) {
	                                        if ( Expr.relative[ tokens[j].type ] ) {
	                                                break;
	                                        }
	                                }
	                                return setMatcher(
	                                        i > 1 && elementMatcher( matchers ),
	                                        i > 1 && tokens.slice( 0, i - 1 ).join("").replace( rtrim, "$1" ),
	                                        matcher,
	                                        i < j && matcherFromTokens( tokens.slice( i, j ) ),
	                                        j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
	                                        j < len && tokens.join("")
	                                );
	                        }
	                        matchers.push( matcher );
	                }
	        }
	
	        return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	        var bySet = setMatchers.length > 0,
	                byElement = elementMatchers.length > 0,
	                superMatcher = function( seed, context, xml, results, expandContext ) {
	                        var elem, j, matcher,
	                                setMatched = [],
	                                matchedCount = 0,
	                                i = "0",
	                                unmatched = seed && [],
	                                outermost = expandContext != null,
	                                contextBackup = outermostContext,
	                                // We must always have either seed elements or context
	                                elems = seed || byElement && Expr.find["TAG"]( "*", expandContext && context.parentNode || context ),
	                                // Nested matchers should use non-integer dirruns
	                                dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.E);
	
	                        if ( outermost ) {
	                                outermostContext = context !== document && context;
	                                cachedruns = superMatcher.el;
	                        }
	
	                        // Add elements passing elementMatchers directly to results
	                        for ( ; (elem = elems[i]) != null; i++ ) {
	                                if ( byElement && elem ) {
	                                        for ( j = 0; (matcher = elementMatchers[j]); j++ ) {
	                                                if ( matcher( elem, context, xml ) ) {
	                                                        results.push( elem );
	                                                        break;
	                                                }
	                                        }
	                                        if ( outermost ) {
	                                                dirruns = dirrunsUnique;
	                                                cachedruns = ++superMatcher.el;
	                                        }
	                                }
	
	                                // Track unmatched elements for set filters
	                                if ( bySet ) {
	                                        // They will have gone through all possible matchers
	                                        if ( (elem = !matcher && elem) ) {
	                                                matchedCount--;
	                                        }
	
	                                        // Lengthen the array for every element, matched or not
	                                        if ( seed ) {
	                                                unmatched.push( elem );
	                                        }
	                                }
	                        }
	
	                        // Apply set filters to unmatched elements
	                        matchedCount += i;
	                        if ( bySet && i !== matchedCount ) {
	                                for ( j = 0; (matcher = setMatchers[j]); j++ ) {
	                                        matcher( unmatched, setMatched, context, xml );
	                                }
	
	                                if ( seed ) {
	                                        // Reintegrate element matches to eliminate the need for sorting
	                                        if ( matchedCount > 0 ) {
	                                                while ( i-- ) {
	                                                        if ( !(unmatched[i] || setMatched[i]) ) {
	                                                                setMatched[i] = pop.call( results );
	                                                        }
	                                                }
	                                        }
	
	                                        // Discard index placeholder values to get only actual matches
	                                        setMatched = condense( setMatched );
	                                }
	
	                                // Add matches to results
	                                push.apply( results, setMatched );
	
	                                // Seedless set matches succeeding multiple successful matchers stipulate sorting
	                                if ( outermost && !seed && setMatched.length > 0 &&
	                                        ( matchedCount + setMatchers.length ) > 1 ) {
	
	                                        Sizzle.uniqueSort( results );
	                                }
	                        }
	
	                        // Override manipulation of globals by nested matchers
	                        if ( outermost ) {
	                                dirruns = dirrunsUnique;
	                                outermostContext = contextBackup;
	                        }
	
	                        return unmatched;
	                };
	
	        superMatcher.el = 0;
	        return bySet ?
	                markFunction( superMatcher ) :
	                superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, group /* Internal Use Only */ ) {
	        var i,
	                setMatchers = [],
	                elementMatchers = [],
	                cached = compilerCache[ expando ][ selector + " " ];
	
	        if ( !cached ) {
	                // Generate a function of recursive functions that can be used to check each element
	                if ( !group ) {
	                        group = tokenize( selector );
	                }
	                i = group.length;
	                while ( i-- ) {
	                        cached = matcherFromTokens( group[i] );
	                        if ( cached[ expando ] ) {
	                                setMatchers.push( cached );
	                        } else {
	                                elementMatchers.push( cached );
	                        }
	                }
	
	                // Cache the compiled function
	                cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	        }
	        return cached;
	};
	
	function multipleContexts( selector, contexts, results ) {
	        var i = 0,
	                len = contexts.length;
	        for ( ; i < len; i++ ) {
	                Sizzle( selector, contexts[i], results );
	        }
	        return results;
	}
	
	function select( selector, context, results, seed, xml ) {
	        var i, tokens, token, type, find,
	                match = tokenize( selector ),
	                j = match.length;
	
	        if ( !seed ) {
	                // Try to minimize operations if there is only one group
	                if ( match.length === 1 ) {
	
	                        // Take a shortcut and set the context if the root selector is an ID
	                        tokens = match[0] = match[0].slice( 0 );
	                        if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
	                                        context.nodeType === 9 && !xml &&
	                                        Expr.relative[ tokens[1].type ] ) {
	
	                                context = Expr.find["ID"]( token.matches[0].replace( rbackslash, "" ), context, xml )[0];
	                                if ( !context ) {
	                                        return results;
	                                }
	
	                                selector = selector.slice( tokens.shift().length );
	                        }
	
	                        // Fetch a seed set for right-to-left matching
	                        for ( i = matchExpr["POS"].test( selector ) ? -1 : tokens.length - 1; i >= 0; i-- ) {
	                                token = tokens[i];
	
	                                // Abort if we hit a combinator
	                                if ( Expr.relative[ (type = token.type) ] ) {
	                                        break;
	                                }
	                                if ( (find = Expr.find[ type ]) ) {
	                                        // Search, expanding context for leading sibling combinators
	                                        if ( (seed = find(
	                                                token.matches[0].replace( rbackslash, "" ),
	                                                rsibling.test( tokens[0].type ) && context.parentNode || context,
	                                                xml
	                                        )) ) {
	
	                                                // If seed is empty or no tokens remain, we can return early
	                                                tokens.splice( i, 1 );
	                                                selector = seed.length && tokens.join("");
	                                                if ( !selector ) {
	                                                        push.apply( results, slice.call( seed, 0 ) );
	                                                        return results;
	                                                }
	
	                                                break;
	                                        }
	                                }
	                        }
	                }
	        }
	
	        // Compile and execute a filtering function
	        // Provide `match` to avoid retokenization if we modified the selector above
	        compile( selector, match )(
	                seed,
	                context,
	                xml,
	                results,
	                rsibling.test( selector )
	        );
	        return results;
	}
	
	if ( document.querySelectorAll ) {
	        (function() {
	                var disconnectedMatch,
	                        oldSelect = select,
	                        rescape = /'|\\/g,
	                        rattributeQuotes = /\=[\x20\t\r\n\f]*([^'"\]]*)[\x20\t\r\n\f]*\]/g,
	
	                        // qSa(:focus) reports false when true (Chrome 21), no need to also add to buggyMatches since matches checks buggyQSA
	                        // A support test would require too much code (would include document ready)
	                        rbuggyQSA = [ ":focus" ],
	
	                        // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	                        // A support test would require too much code (would include document ready)
	                        // just skip matchesSelector for :active
	                        rbuggyMatches = [ ":active" ],
	                        matches = docElem.matchesSelector ||
	                                docElem.mozMatchesSelector ||
	                                docElem.webkitMatchesSelector ||
	                                docElem.oMatchesSelector ||
	                                docElem.msMatchesSelector;
	
	                // Build QSA regex
	                // Regex strategy adopted from Diego Perini
	                assert(function( div ) {
	                        // Select is set to empty string on purpose
	                        // This is to test IE's treatment of not explictly
	                        // setting a boolean content attribute,
	                        // since its presence should be enough
	                        // http://bugs.jquery.com/ticket/12359
	                        div.innerHTML = "<select><option selected=''></option></select>";
	
	                        // IE8 - Some boolean attributes are not treated correctly
	                        if ( !div.querySelectorAll("[selected]").length ) {
	                                rbuggyQSA.push( "\\[" + whitespace + "*(?:checked|disabled|ismap|multiple|readonly|selected|value)" );
	                        }
	
	                        // Webkit/Opera - :checked should return selected option elements
	                        // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	                        // IE8 throws error here (do not put tests after this one)
	                        if ( !div.querySelectorAll(":checked").length ) {
	                                rbuggyQSA.push(":checked");
	                        }
	                });
	
	                assert(function( div ) {
	
	                        // Opera 10-12/IE9 - ^= $= *= and empty values
	                        // Should not select anything
	                        div.innerHTML = "<p test=''></p>";
	                        if ( div.querySelectorAll("[test^='']").length ) {
	                                rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:\"\"|'')" );
	                        }
	
	                        // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
	                        // IE8 throws error here (do not put tests after this one)
	                        div.innerHTML = "<input type='hidden'/>";
	                        if ( !div.querySelectorAll(":enabled").length ) {
	                                rbuggyQSA.push(":enabled", ":disabled");
	                        }
	                });
	
	                // rbuggyQSA always contains :focus, so no need for a length check
	                rbuggyQSA = /* rbuggyQSA.length && */ new RegExp( rbuggyQSA.join("|") );
	
	                select = function( selector, context, results, seed, xml ) {
	                        // Only use querySelectorAll when not filtering,
	                        // when this is not xml,
	                        // and when no QSA bugs apply
	                        if ( !seed && !xml && !rbuggyQSA.test( selector ) ) {
	                                var groups, i,
	                                        old = true,
	                                        nid = expando,
	                                        newContext = context,
	                                        newSelector = context.nodeType === 9 && selector;
	
	                                // qSA works strangely on Element-rooted queries
	                                // We can work around this by specifying an extra ID on the root
	                                // and working up from there (Thanks to Andrew Dupont for the technique)
	                                // IE 8 doesn't work on object elements
	                                if ( context.nodeType === 1 && context.nodeName.toLowerCase() !== "object" ) {
	                                        groups = tokenize( selector );
	
	                                        if ( (old = context.getAttribute("id")) ) {
	                                                nid = old.replace( rescape, "\\$&" );
	                                        } else {
	                                                context.setAttribute( "id", nid );
	                                        }
	                                        nid = "[id='" + nid + "'] ";
	
	                                        i = groups.length;
	                                        while ( i-- ) {
	                                                groups[i] = nid + groups[i].join("");
	                                        }
	                                        newContext = rsibling.test( selector ) && context.parentNode || context;
	                                        newSelector = groups.join(",");
	                                }
	
	                                if ( newSelector ) {
	                                        try {
	                                                push.apply( results, slice.call( newContext.querySelectorAll(
	                                                        newSelector
	                                                ), 0 ) );
	                                                return results;
	                                        } catch(qsaError) {
	                                        } finally {
	                                                if ( !old ) {
	                                                        context.removeAttribute("id");
	                                                }
	                                        }
	                                }
	                        }
	
	                        return oldSelect( selector, context, results, seed, xml );
	                };
	
	                if ( matches ) {
	                        assert(function( div ) {
	                                // Check to see if it's possible to do matchesSelector
	                                // on a disconnected node (IE 9)
	                                disconnectedMatch = matches.call( div, "div" );
	
	                                // This should fail with an exception
	                                // Gecko does not error, returns false instead
	                                try {
	                                        matches.call( div, "[test!='']:sizzle" );
	                                        rbuggyMatches.push( "!=", pseudos );
	                                } catch ( e ) {}
	                        });
	
	                        // rbuggyMatches always contains :active and :focus, so no need for a length check
	                        rbuggyMatches = /* rbuggyMatches.length && */ new RegExp( rbuggyMatches.join("|") );
	
	                        Sizzle.matchesSelector = function( elem, expr ) {
	                                // Make sure that attribute selectors are quoted
	                                expr = expr.replace( rattributeQuotes, "='$1']" );
	
	                                // rbuggyMatches always contains :active, so no need for an existence check
	                                if ( !isXML( elem ) && !rbuggyMatches.test( expr ) && !rbuggyQSA.test( expr ) ) {
	                                        try {
	                                                var ret = matches.call( elem, expr );
	
	                                                // IE 9's matchesSelector returns false on disconnected nodes
	                                                if ( ret || disconnectedMatch ||
	                                                                // As well, disconnected nodes are said to be in a document
	                                                                // fragment in IE 9
	                                                                elem.document && elem.document.nodeType !== 11 ) {
	                                                        return ret;
	                                                }
	                                        } catch(e) {}
	                                }
	
	                                return Sizzle( expr, null, null, [ elem ] ).length > 0;
	                        };
	                }
	        })();
	}
	
	// Deprecated
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Back-compat
	function setFilters() {}
	Expr.filters = setFilters.prototype = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	// Override sizzle attribute retrieval
	Sizzle.attr = jQuery.attr;
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	jQuery.expr[":"] = jQuery.expr.pseudos;
	jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	
	
	})( window );
	var runtil = /Until$/,
	        rparentsprev = /^(?:parents|prev(?:Until|All))/,
	        isSimple = /^.[^:#\[\.,]*$/,
	        rneedsContext = jQuery.expr.match.needsContext,
	        // methods guaranteed to produce a unique set when starting from a unique set
	        guaranteedUnique = {
	                children: true,
	                contents: true,
	                next: true,
	                prev: true
	        };
	
	jQuery.fn.extend({
	        find: function( selector ) {
	                var i, l, length, n, r, ret,
	                        self = this;
	
	                if ( typeof selector !== "string" ) {
	                        return jQuery( selector ).filter(function() {
	                                for ( i = 0, l = self.length; i < l; i++ ) {
	                                        if ( jQuery.contains( self[ i ], this ) ) {
	                                                return true;
	                                        }
	                                }
	                        });
	                }
	
	                ret = this.pushStack( "", "find", selector );
	
	                for ( i = 0, l = this.length; i < l; i++ ) {
	                        length = ret.length;
	                        jQuery.find( selector, this[i], ret );
	
	                        if ( i > 0 ) {
	                                // Make sure that the results are unique
	                                for ( n = length; n < ret.length; n++ ) {
	                                        for ( r = 0; r < length; r++ ) {
	                                                if ( ret[r] === ret[n] ) {
	                                                        ret.splice(n--, 1);
	                                                        break;
	                                                }
	                                        }
	                                }
	                        }
	                }
	
	                return ret;
	        },
	
	        has: function( target ) {
	                var i,
	                        targets = jQuery( target, this ),
	                        len = targets.length;
	
	                return this.filter(function() {
	                        for ( i = 0; i < len; i++ ) {
	                                if ( jQuery.contains( this, targets[i] ) ) {
	                                        return true;
	                                }
	                        }
	                });
	        },
	
	        not: function( selector ) {
	                return this.pushStack( winnow(this, selector, false), "not", selector);
	        },
	
	        filter: function( selector ) {
	                return this.pushStack( winnow(this, selector, true), "filter", selector );
	        },
	
	        is: function( selector ) {
	                return !!selector && (
	                        typeof selector === "string" ?
	                                // If this is a positional/relative selector, check membership in the returned set
	                                // so $("p:first").is("p:last") won't return true for a doc with two "p".
	                                rneedsContext.test( selector ) ?
	                                        jQuery( selector, this.context ).index( this[0] ) >= 0 :
	                                        jQuery.filter( selector, this ).length > 0 :
	                                this.filter( selector ).length > 0 );
	        },
	
	        closest: function( selectors, context ) {
	                var cur,
	                        i = 0,
	                        l = this.length,
	                        ret = [],
	                        pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
	                                jQuery( selectors, context || this.context ) :
	                                0;
	
	                for ( ; i < l; i++ ) {
	                        cur = this[i];
	
	                        while ( cur && cur.ownerDocument && cur !== context && cur.nodeType !== 11 ) {
	                                if ( pos ? pos.index(cur) > -1 : jQuery.find.matchesSelector(cur, selectors) ) {
	                                        ret.push( cur );
	                                        break;
	                                }
	                                cur = cur.parentNode;
	                        }
	                }
	
	                ret = ret.length > 1 ? jQuery.unique( ret ) : ret;
	
	                return this.pushStack( ret, "closest", selectors );
	        },
	
	        // Determine the position of an element within
	        // the matched set of elements
	        index: function( elem ) {
	
	                // No argument, return index in parent
	                if ( !elem ) {
	                        return ( this[0] && this[0].parentNode ) ? this.prevAll().length : -1;
	                }
	
	                // index in selector
	                if ( typeof elem === "string" ) {
	                        return jQuery.inArray( this[0], jQuery( elem ) );
	                }
	
	                // Locate the position of the desired element
	                return jQuery.inArray(
	                        // If it receives a jQuery object, the first element is used
	                        elem.jquery ? elem[0] : elem, this );
	        },
	
	        add: function( selector, context ) {
	                var set = typeof selector === "string" ?
	                                jQuery( selector, context ) :
	                                jQuery.makeArray( selector && selector.nodeType ? [ selector ] : selector ),
	                        all = jQuery.merge( this.get(), set );
	
	                return this.pushStack( isDisconnected( set[0] ) || isDisconnected( all[0] ) ?
	                        all :
	                        jQuery.unique( all ) );
	        },
	
	        addBack: function( selector ) {
	                return this.add( selector == null ?
	                        this.prevObject : this.prevObject.filter(selector)
	                );
	        }
	});
	
	jQuery.fn.andSelf = jQuery.fn.addBack;
	
	// A painfully simple check to see if an element is disconnected
	// from a document (should be improved, where feasible).
	function isDisconnected( node ) {
	        return !node || !node.parentNode || node.parentNode.nodeType === 11;
	}
	
	function sibling( cur, dir ) {
	        do {
	                cur = cur[ dir ];
	        } while ( cur && cur.nodeType !== 1 );
	
	        return cur;
	}
	
	jQuery.each({
	        parent: function( elem ) {
	                var parent = elem.parentNode;
	                return parent && parent.nodeType !== 11 ? parent : null;
	        },
	        parents: function( elem ) {
	                return jQuery.dir( elem, "parentNode" );
	        },
	        parentsUntil: function( elem, i, until ) {
	                return jQuery.dir( elem, "parentNode", until );
	        },
	        next: function( elem ) {
	                return sibling( elem, "nextSibling" );
	        },
	        prev: function( elem ) {
	                return sibling( elem, "previousSibling" );
	        },
	        nextAll: function( elem ) {
	                return jQuery.dir( elem, "nextSibling" );
	        },
	        prevAll: function( elem ) {
	                return jQuery.dir( elem, "previousSibling" );
	        },
	        nextUntil: function( elem, i, until ) {
	                return jQuery.dir( elem, "nextSibling", until );
	        },
	        prevUntil: function( elem, i, until ) {
	                return jQuery.dir( elem, "previousSibling", until );
	        },
	        siblings: function( elem ) {
	                return jQuery.sibling( ( elem.parentNode || {} ).firstChild, elem );
	        },
	        children: function( elem ) {
	                return jQuery.sibling( elem.firstChild );
	        },
	        contents: function( elem ) {
	                return jQuery.nodeName( elem, "iframe" ) ?
	                        elem.contentDocument || elem.contentWindow.document :
	                        jQuery.merge( [], elem.childNodes );
	        }
	}, function( name, fn ) {
	        jQuery.fn[ name ] = function( until, selector ) {
	                var ret = jQuery.map( this, fn, until );
	
	                if ( !runtil.test( name ) ) {
	                        selector = until;
	                }
	
	                if ( selector && typeof selector === "string" ) {
	                        ret = jQuery.filter( selector, ret );
	                }
	
	                ret = this.length > 1 && !guaranteedUnique[ name ] ? jQuery.unique( ret ) : ret;
	
	                if ( this.length > 1 && rparentsprev.test( name ) ) {
	                        ret = ret.reverse();
	                }
	
	                return this.pushStack( ret, name, core_slice.call( arguments ).join(",") );
	        };
	});
	
	jQuery.extend({
	        filter: function( expr, elems, not ) {
	                if ( not ) {
	                        expr = ":not(" + expr + ")";
	                }
	
	                return elems.length === 1 ?
	                        jQuery.find.matchesSelector(elems[0], expr) ? [ elems[0] ] : [] :
	                        jQuery.find.matches(expr, elems);
	        },
	
	        dir: function( elem, dir, until ) {
	                var matched = [],
	                        cur = elem[ dir ];
	
	                while ( cur && cur.nodeType !== 9 && (until === undefined || cur.nodeType !== 1 || !jQuery( cur ).is( until )) ) {
	                        if ( cur.nodeType === 1 ) {
	                                matched.push( cur );
	                        }
	                        cur = cur[dir];
	                }
	                return matched;
	        },
	
	        sibling: function( n, elem ) {
	                var r = [];
	
	                for ( ; n; n = n.nextSibling ) {
	                        if ( n.nodeType === 1 && n !== elem ) {
	                                r.push( n );
	                        }
	                }
	
	                return r;
	        }
	});
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, keep ) {
	
	        // Can't pass null or undefined to indexOf in Firefox 4
	        // Set to 0 to skip string check
	        qualifier = qualifier || 0;
	
	        if ( jQuery.isFunction( qualifier ) ) {
	                return jQuery.grep(elements, function( elem, i ) {
	                        var retVal = !!qualifier.call( elem, i, elem );
	                        return retVal === keep;
	                });
	
	        } else if ( qualifier.nodeType ) {
	                return jQuery.grep(elements, function( elem, i ) {
	                        return ( elem === qualifier ) === keep;
	                });
	
	        } else if ( typeof qualifier === "string" ) {
	                var filtered = jQuery.grep(elements, function( elem ) {
	                        return elem.nodeType === 1;
	                });
	
	                if ( isSimple.test( qualifier ) ) {
	                        return jQuery.filter(qualifier, filtered, !keep);
	                } else {
	                        qualifier = jQuery.filter( qualifier, filtered );
	                }
	        }
	
	        return jQuery.grep(elements, function( elem, i ) {
	                return ( jQuery.inArray( elem, qualifier ) >= 0 ) === keep;
	        });
	}
	function createSafeFragment( document ) {
	        var list = nodeNames.split( "|" ),
	        safeFrag = document.createDocumentFragment();
	
	        if ( safeFrag.createElement ) {
	                while ( list.length ) {
	                        safeFrag.createElement(
	                                list.pop()
	                        );
	                }
	        }
	        return safeFrag;
	}
	
	var nodeNames = "abbr|article|aside|audio|bdi|canvas|data|datalist|details|figcaption|figure|footer|" +
	                "header|hgroup|mark|meter|nav|output|progress|section|summary|time|video",
	        rinlinejQuery = / jQuery\d+="(?:null|\d+)"/g,
	        rleadingWhitespace = /^\s+/,
	        rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:]+)[^>]*)\/>/gi,
	        rtagName = /<([\w:]+)/,
	        rtbody = /<tbody/i,
	        rhtml = /<|&#?\w+;/,
	        rnoInnerhtml = /<(?:script|style|link)/i,
	        rnocache = /<(?:script|object|embed|option|style)/i,
	        rnoshimcache = new RegExp("<(?:" + nodeNames + ")[\\s/>]", "i"),
	        rcheckableType = /^(?:checkbox|radio)$/,
	        // checked="checked" or checked
	        rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	        rscriptType = /\/(java|ecma)script/i,
	        rcleanScript = /^\s*<!(?:\[CDATA\[|\-\-)|[\]\-]{2}>\s*$/g,
	        wrapMap = {
	                option: [ 1, "<select multiple='multiple'>", "</select>" ],
	                legend: [ 1, "<fieldset>", "</fieldset>" ],
	                thead: [ 1, "<table>", "</table>" ],
	                tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	                td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	                col: [ 2, "<table><tbody></tbody><colgroup>", "</colgroup></table>" ],
	                area: [ 1, "<map>", "</map>" ],
	                _default: [ 0, "", "" ]
	        },
	        safeFragment = createSafeFragment( document ),
	        fragmentDiv = safeFragment.appendChild( document.createElement("div") );
	
	wrapMap.optgroup = wrapMap.option;
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// IE6-8 can't serialize link, script, style, or any html5 (NoScope) tags,
	// unless wrapped in a div with non-breaking characters in front of it.
	if ( !jQuery.support.htmlSerialize ) {
	        wrapMap._default = [ 1, "X<div>", "</div>" ];
	}
	
	jQuery.fn.extend({
	        text: function( value ) {
	                return jQuery.access( this, function( value ) {
	                        return value === undefined ?
	                                jQuery.text( this ) :
	                                this.empty().append( ( this[0] && this[0].ownerDocument || document ).createTextNode( value ) );
	                }, null, value, arguments.length );
	        },
	
	        wrapAll: function( html ) {
	                if ( jQuery.isFunction( html ) ) {
	                        return this.each(function(i) {
	                                jQuery(this).wrapAll( html.call(this, i) );
	                        });
	                }
	
	                if ( this[0] ) {
	                        // The elements to wrap the target around
	                        var wrap = jQuery( html, this[0].ownerDocument ).eq(0).clone(true);
	
	                        if ( this[0].parentNode ) {
	                                wrap.insertBefore( this[0] );
	                        }
	
	                        wrap.map(function() {
	                                var elem = this;
	
	                                while ( elem.firstChild && elem.firstChild.nodeType === 1 ) {
	                                        elem = elem.firstChild;
	                                }
	
	                                return elem;
	                        }).append( this );
	                }
	
	                return this;
	        },
	
	        wrapInner: function( html ) {
	                if ( jQuery.isFunction( html ) ) {
	                        return this.each(function(i) {
	                                jQuery(this).wrapInner( html.call(this, i) );
	                        });
	                }
	
	                return this.each(function() {
	                        var self = jQuery( this ),
	                                contents = self.contents();
	
	                        if ( contents.length ) {
	                                contents.wrapAll( html );
	
	                        } else {
	                                self.append( html );
	                        }
	                });
	        },
	
	        wrap: function( html ) {
	                var isFunction = jQuery.isFunction( html );
	
	                return this.each(function(i) {
	                        jQuery( this ).wrapAll( isFunction ? html.call(this, i) : html );
	                });
	        },
	
	        unwrap: function() {
	                return this.parent().each(function() {
	                        if ( !jQuery.nodeName( this, "body" ) ) {
	                                jQuery( this ).replaceWith( this.childNodes );
	                        }
	                }).end();
	        },
	
	        append: function() {
	                return this.domManip(arguments, true, function( elem ) {
	                        if ( this.nodeType === 1 || this.nodeType === 11 ) {
	                                this.appendChild( elem );
	                        }
	                });
	        },
	
	        prepend: function() {
	                return this.domManip(arguments, true, function( elem ) {
	                        if ( this.nodeType === 1 || this.nodeType === 11 ) {
	                                this.insertBefore( elem, this.firstChild );
	                        }
	                });
	        },
	
	        before: function() {
	                if ( !isDisconnected( this[0] ) ) {
	                        return this.domManip(arguments, false, function( elem ) {
	                                this.parentNode.insertBefore( elem, this );
	                        });
	                }
	
	                if ( arguments.length ) {
	                        var set = jQuery.clean( arguments );
	                        return this.pushStack( jQuery.merge( set, this ), "before", this.selector );
	                }
	        },
	
	        after: function() {
	                if ( !isDisconnected( this[0] ) ) {
	                        return this.domManip(arguments, false, function( elem ) {
	                                this.parentNode.insertBefore( elem, this.nextSibling );
	                        });
	                }
	
	                if ( arguments.length ) {
	                        var set = jQuery.clean( arguments );
	                        return this.pushStack( jQuery.merge( this, set ), "after", this.selector );
	                }
	        },
	
	        // keepData is for internal use only--do not document
	        remove: function( selector, keepData ) {
	                var elem,
	                        i = 0;
	
	                for ( ; (elem = this[i]) != null; i++ ) {
	                        if ( !selector || jQuery.filter( selector, [ elem ] ).length ) {
	                                if ( !keepData && elem.nodeType === 1 ) {
	                                        jQuery.cleanData( elem.getElementsByTagName("*") );
	                                        jQuery.cleanData( [ elem ] );
	                                }
	
	                                if ( elem.parentNode ) {
	                                        elem.parentNode.removeChild( elem );
	                                }
	                        }
	                }
	
	                return this;
	        },
	
	        empty: function() {
	                var elem,
	                        i = 0;
	
	                for ( ; (elem = this[i]) != null; i++ ) {
	                        // Remove element nodes and prevent memory leaks
	                        if ( elem.nodeType === 1 ) {
	                                jQuery.cleanData( elem.getElementsByTagName("*") );
	                        }
	
	                        // Remove any remaining nodes
	                        while ( elem.firstChild ) {
	                                elem.removeChild( elem.firstChild );
	                        }
	                }
	
	                return this;
	        },
	
	        clone: function( dataAndEvents, deepDataAndEvents ) {
	                dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
	                deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
	                return this.map( function () {
	                        return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
	                });
	        },
	
	        html: function( value ) {
	                return jQuery.access( this, function( value ) {
	                        var elem = this[0] || {},
	                                i = 0,
	                                l = this.length;
	
	                        if ( value === undefined ) {
	                                return elem.nodeType === 1 ?
	                                        elem.innerHTML.replace( rinlinejQuery, "" ) :
	                                        undefined;
	                        }
	
	                        // See if we can take a shortcut and just use innerHTML
	                        if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
	                                ( jQuery.support.htmlSerialize || !rnoshimcache.test( value )  ) &&
	                                ( jQuery.support.leadingWhitespace || !rleadingWhitespace.test( value ) ) &&
	                                !wrapMap[ ( rtagName.exec( value ) || ["", ""] )[1].toLowerCase() ] ) {
	
	                                value = value.replace( rxhtmlTag, "<$1></$2>" );
	
	                                try {
	                                        for (; i < l; i++ ) {
	                                                // Remove element nodes and prevent memory leaks
	                                                elem = this[i] || {};
	                                                if ( elem.nodeType === 1 ) {
	                                                        jQuery.cleanData( elem.getElementsByTagName( "*" ) );
	                                                        elem.innerHTML = value;
	                                                }
	                                        }
	
	                                        elem = 0;
	
	                                // If using innerHTML throws an exception, use the fallback method
	                                } catch(e) {}
	                        }
	
	                        if ( elem ) {
	                                this.empty().append( value );
	                        }
	                }, null, value, arguments.length );
	        },
	
	        replaceWith: function( value ) {
	                if ( !isDisconnected( this[0] ) ) {
	                        // Make sure that the elements are removed from the DOM before they are inserted
	                        // this can help fix replacing a parent with child elements
	                        if ( jQuery.isFunction( value ) ) {
	                                return this.each(function(i) {
	                                        var self = jQuery(this), old = self.html();
	                                        self.replaceWith( value.call( this, i, old ) );
	                                });
	                        }
	
	                        if ( typeof value !== "string" ) {
	                                value = jQuery( value ).detach();
	                        }
	
	                        return this.each(function() {
	                                var next = this.nextSibling,
	                                        parent = this.parentNode;
	
	                                jQuery( this ).remove();
	
	                                if ( next ) {
	                                        jQuery(next).before( value );
	                                } else {
	                                        jQuery(parent).append( value );
	                                }
	                        });
	                }
	
	                return this.length ?
	                        this.pushStack( jQuery(jQuery.isFunction(value) ? value() : value), "replaceWith", value ) :
	                        this;
	        },
	
	        detach: function( selector ) {
	                return this.remove( selector, true );
	        },
	
	        domManip: function( args, table, callback ) {
	
	                // Flatten any nested arrays
	                args = [].concat.apply( [], args );
	
	                var results, first, fragment, iNoClone,
	                        i = 0,
	                        value = args[0],
	                        scripts = [],
	                        l = this.length;
	
	                // We can't cloneNode fragments that contain checked, in WebKit
	                if ( !jQuery.support.checkClone && l > 1 && typeof value === "string" && rchecked.test( value ) ) {
	                        return this.each(function() {
	                                jQuery(this).domManip( args, table, callback );
	                        });
	                }
	
	                if ( jQuery.isFunction(value) ) {
	                        return this.each(function(i) {
	                                var self = jQuery(this);
	                                args[0] = value.call( this, i, table ? self.html() : undefined );
	                                self.domManip( args, table, callback );
	                        });
	                }
	
	                if ( this[0] ) {
	                        results = jQuery.buildFragment( args, this, scripts );
	                        fragment = results.fragment;
	                        first = fragment.firstChild;
	
	                        if ( fragment.childNodes.length === 1 ) {
	                                fragment = first;
	                        }
	
	                        if ( first ) {
	                                table = table && jQuery.nodeName( first, "tr" );
	
	                                // Use the original fragment for the last item instead of the first because it can end up
	                                // being emptied incorrectly in certain situations (#8070).
	                                // Fragments from the fragment cache must always be cloned and never used in place.
	                                for ( iNoClone = results.cacheable || l - 1; i < l; i++ ) {
	                                        callback.call(
	                                                table && jQuery.nodeName( this[i], "table" ) ?
	                                                        findOrAppend( this[i], "tbody" ) :
	                                                        this[i],
	                                                i === iNoClone ?
	                                                        fragment :
	                                                        jQuery.clone( fragment, true, true )
	                                        );
	                                }
	                        }
	
	                        // Fix #11809: Avoid leaking memory
	                        fragment = first = null;
	
	                        if ( scripts.length ) {
	                                jQuery.each( scripts, function( i, elem ) {
	                                        if ( elem.src ) {
	                                                if ( jQuery.ajax ) {
	                                                        jQuery.ajax({
	                                                                url: elem.src,
	                                                                type: "GET",
	                                                                dataType: "script",
	                                                                async: false,
	                                                                global: false,
	                                                                "throws": true
	                                                        });
	                                                } else {
	                                                        jQuery.error("no ajax");
	                                                }
	                                        } else {
	                                                jQuery.globalEval( ( elem.text || elem.textContent || elem.innerHTML || "" ).replace( rcleanScript, "" ) );
	                                        }
	
	                                        if ( elem.parentNode ) {
	                                                elem.parentNode.removeChild( elem );
	                                        }
	                                });
	                        }
	                }
	
	                return this;
	        }
	});
	
	function findOrAppend( elem, tag ) {
	        return elem.getElementsByTagName( tag )[0] || elem.appendChild( elem.ownerDocument.createElement( tag ) );
	}
	
	function cloneCopyEvent( src, dest ) {
	
	        if ( dest.nodeType !== 1 || !jQuery.hasData( src ) ) {
	                return;
	        }
	
	        var type, i, l,
	                oldData = jQuery._data( src ),
	                curData = jQuery._data( dest, oldData ),
	                events = oldData.events;
	
	        if ( events ) {
	                delete curData.handle;
	                curData.events = {};
	
	                for ( type in events ) {
	                        for ( i = 0, l = events[ type ].length; i < l; i++ ) {
	                                jQuery.event.add( dest, type, events[ type ][ i ] );
	                        }
	                }
	        }
	
	        // make the cloned public data object a copy from the original
	        if ( curData.data ) {
	                curData.data = jQuery.extend( {}, curData.data );
	        }
	}
	
	function cloneFixAttributes( src, dest ) {
	        var nodeName;
	
	        // We do not need to do anything for non-Elements
	        if ( dest.nodeType !== 1 ) {
	                return;
	        }
	
	        // clearAttributes removes the attributes, which we don't want,
	        // but also removes the attachEvent events, which we *do* want
	        if ( dest.clearAttributes ) {
	                dest.clearAttributes();
	        }
	
	        // mergeAttributes, in contrast, only merges back on the
	        // original attributes, not the events
	        if ( dest.mergeAttributes ) {
	                dest.mergeAttributes( src );
	        }
	
	        nodeName = dest.nodeName.toLowerCase();
	
	        if ( nodeName === "object" ) {
	                // IE6-10 improperly clones children of object elements using classid.
	                // IE10 throws NoModificationAllowedError if parent is null, #12132.
	                if ( dest.parentNode ) {
	                        dest.outerHTML = src.outerHTML;
	                }
	
	                // This path appears unavoidable for IE9. When cloning an object
	                // element in IE9, the outerHTML strategy above is not sufficient.
	                // If the src has innerHTML and the destination does not,
	                // copy the src.innerHTML into the dest.innerHTML. #10324
	                if ( jQuery.support.html5Clone && (src.innerHTML && !jQuery.trim(dest.innerHTML)) ) {
	                        dest.innerHTML = src.innerHTML;
	                }
	
	        } else if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
	                // IE6-8 fails to persist the checked state of a cloned checkbox
	                // or radio button. Worse, IE6-7 fail to give the cloned element
	                // a checked appearance if the defaultChecked value isn't also set
	
	                dest.defaultChecked = dest.checked = src.checked;
	
	                // IE6-7 get confused and end up setting the value of a cloned
	                // checkbox/radio button to an empty string instead of "on"
	                if ( dest.value !== src.value ) {
	                        dest.value = src.value;
	                }
	
	        // IE6-8 fails to return the selected option to the default selected
	        // state when cloning options
	        } else if ( nodeName === "option" ) {
	                dest.selected = src.defaultSelected;
	
	        // IE6-8 fails to set the defaultValue to the correct value when
	        // cloning other types of input fields
	        } else if ( nodeName === "input" || nodeName === "textarea" ) {
	                dest.defaultValue = src.defaultValue;
	
	        // IE blanks contents when cloning scripts
	        } else if ( nodeName === "script" && dest.text !== src.text ) {
	                dest.text = src.text;
	        }
	
	        // Event data gets referenced instead of copied if the expando
	        // gets copied too
	        dest.removeAttribute( jQuery.expando );
	}
	
	jQuery.buildFragment = function( args, context, scripts ) {
	        var fragment, cacheable, cachehit,
	                first = args[ 0 ];
	
	        // Set context from what may come in as undefined or a jQuery collection or a node
	        // Updated to fix #12266 where accessing context[0] could throw an exception in IE9/10 &
	        // also doubles as fix for #8950 where plain objects caused createDocumentFragment exception
	        context = context || document;
	        context = !context.nodeType && context[0] || context;
	        context = context.ownerDocument || context;
	
	        // Only cache "small" (1/2 KB) HTML strings that are associated with the main document
	        // Cloning options loses the selected state, so don't cache them
	        // IE 6 doesn't like it when you put <object> or <embed> elements in a fragment
	        // Also, WebKit does not clone 'checked' attributes on cloneNode, so don't cache
	        // Lastly, IE6,7,8 will not correctly reuse cached fragments that were created from unknown elems #10501
	        if ( args.length === 1 && typeof first === "string" && first.length < 512 && context === document &&
	                first.charAt(0) === "<" && !rnocache.test( first ) &&
	                (jQuery.support.checkClone || !rchecked.test( first )) &&
	                (jQuery.support.html5Clone || !rnoshimcache.test( first )) ) {
	
	                // Mark cacheable and look for a hit
	                cacheable = true;
	                fragment = jQuery.fragments[ first ];
	                cachehit = fragment !== undefined;
	        }
	
	        if ( !fragment ) {
	                fragment = context.createDocumentFragment();
	                jQuery.clean( args, context, fragment, scripts );
	
	                // Update the cache, but only store false
	                // unless this is a second parsing of the same content
	                if ( cacheable ) {
	                        jQuery.fragments[ first ] = cachehit && fragment;
	                }
	        }
	
	        return { fragment: fragment, cacheable: cacheable };
	};
	
	jQuery.fragments = {};
	
	jQuery.each({
	        appendTo: "append",
	        prependTo: "prepend",
	        insertBefore: "before",
	        insertAfter: "after",
	        replaceAll: "replaceWith"
	}, function( name, original ) {
	        jQuery.fn[ name ] = function( selector ) {
	                var elems,
	                        i = 0,
	                        ret = [],
	                        insert = jQuery( selector ),
	                        l = insert.length,
	                        parent = this.length === 1 && this[0].parentNode;
	
	                if ( (parent == null || parent && parent.nodeType === 11 && parent.childNodes.length === 1) && l === 1 ) {
	                        insert[ original ]( this[0] );
	                        return this;
	                } else {
	                        for ( ; i < l; i++ ) {
	                                elems = ( i > 0 ? this.clone(true) : this ).get();
	                                jQuery( insert[i] )[ original ]( elems );
	                                ret = ret.concat( elems );
	                        }
	
	                        return this.pushStack( ret, name, insert.selector );
	                }
	        };
	});
	
	function getAll( elem ) {
	        if ( typeof elem.getElementsByTagName !== "undefined" ) {
	                return elem.getElementsByTagName( "*" );
	
	        } else if ( typeof elem.querySelectorAll !== "undefined" ) {
	                return elem.querySelectorAll( "*" );
	
	        } else {
	                return [];
	        }
	}
	
	// Used in clean, fixes the defaultChecked property
	function fixDefaultChecked( elem ) {
	        if ( rcheckableType.test( elem.type ) ) {
	                elem.defaultChecked = elem.checked;
	        }
	}
	
	jQuery.extend({
	        clone: function( elem, dataAndEvents, deepDataAndEvents ) {
	                var srcElements,
	                        destElements,
	                        i,
	                        clone;
	
	                if ( jQuery.support.html5Clone || jQuery.isXMLDoc(elem) || !rnoshimcache.test( "<" + elem.nodeName + ">" ) ) {
	                        clone = elem.cloneNode( true );
	
	                // IE<=8 does not properly clone detached, unknown element nodes
	                } else {
	                        fragmentDiv.innerHTML = elem.outerHTML;
	                        fragmentDiv.removeChild( clone = fragmentDiv.firstChild );
	                }
	
	                if ( (!jQuery.support.noCloneEvent || !jQuery.support.noCloneChecked) &&
	                                (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem) ) {
	                        // IE copies events bound via attachEvent when using cloneNode.
	                        // Calling detachEvent on the clone will also remove the events
	                        // from the original. In order to get around this, we use some
	                        // proprietary methods to clear the events. Thanks to MooTools
	                        // guys for this hotness.
	
	                        cloneFixAttributes( elem, clone );
	
	                        // Using Sizzle here is crazy slow, so we use getElementsByTagName instead
	                        srcElements = getAll( elem );
	                        destElements = getAll( clone );
	
	                        // Weird iteration because IE will replace the length property
	                        // with an element if you are cloning the body and one of the
	                        // elements on the page has a name or id of "length"
	                        for ( i = 0; srcElements[i]; ++i ) {
	                                // Ensure that the destination node is not null; Fixes #9587
	                                if ( destElements[i] ) {
	                                        cloneFixAttributes( srcElements[i], destElements[i] );
	                                }
	                        }
	                }
	
	                // Copy the events from the original to the clone
	                if ( dataAndEvents ) {
	                        cloneCopyEvent( elem, clone );
	
	                        if ( deepDataAndEvents ) {
	                                srcElements = getAll( elem );
	                                destElements = getAll( clone );
	
	                                for ( i = 0; srcElements[i]; ++i ) {
	                                        cloneCopyEvent( srcElements[i], destElements[i] );
	                                }
	                        }
	                }
	
	                srcElements = destElements = null;
	
	                // Return the cloned set
	                return clone;
	        },
	
	        clean: function( elems, context, fragment, scripts ) {
	                var i, j, elem, tag, wrap, depth, div, hasBody, tbody, len, handleScript, jsTags,
	                        safe = context === document && safeFragment,
	                        ret = [];
	
	                // Ensure that context is a document
	                if ( !context || typeof context.createDocumentFragment === "undefined" ) {
	                        context = document;
	                }
	
	                // Use the already-created safe fragment if context permits
	                for ( i = 0; (elem = elems[i]) != null; i++ ) {
	                        if ( typeof elem === "number" ) {
	                                elem += "";
	                        }
	
	                        if ( !elem ) {
	                                continue;
	                        }
	
	                        // Convert html string into DOM nodes
	                        if ( typeof elem === "string" ) {
	                                if ( !rhtml.test( elem ) ) {
	                                        elem = context.createTextNode( elem );
	                                } else {
	                                        // Ensure a safe container in which to render the html
	                                        safe = safe || createSafeFragment( context );
	                                        div = context.createElement("div");
	                                        safe.appendChild( div );
	
	                                        // Fix "XHTML"-style tags in all browsers
	                                        elem = elem.replace(rxhtmlTag, "<$1></$2>");
	
	                                        // Go to html and back, then peel off extra wrappers
	                                        tag = ( rtagName.exec( elem ) || ["", ""] )[1].toLowerCase();
	                                        wrap = wrapMap[ tag ] || wrapMap._default;
	                                        depth = wrap[0];
	                                        div.innerHTML = wrap[1] + elem + wrap[2];
	
	                                        // Move to the right depth
	                                        while ( depth-- ) {
	                                                div = div.lastChild;
	                                        }
	
	                                        // Remove IE's autoinserted <tbody> from table fragments
	                                        if ( !jQuery.support.tbody ) {
	
	                                                // String was a <table>, *may* have spurious <tbody>
	                                                hasBody = rtbody.test(elem);
	                                                        tbody = tag === "table" && !hasBody ?
	                                                                div.firstChild && div.firstChild.childNodes :
	
	                                                                // String was a bare <thead> or <tfoot>
	                                                                wrap[1] === "<table>" && !hasBody ?
	                                                                        div.childNodes :
	                                                                        [];
	
	                                                for ( j = tbody.length - 1; j >= 0 ; --j ) {
	                                                        if ( jQuery.nodeName( tbody[ j ], "tbody" ) && !tbody[ j ].childNodes.length ) {
	                                                                tbody[ j ].parentNode.removeChild( tbody[ j ] );
	                                                        }
	                                                }
	                                        }
	
	                                        // IE completely kills leading whitespace when innerHTML is used
	                                        if ( !jQuery.support.leadingWhitespace && rleadingWhitespace.test( elem ) ) {
	                                                div.insertBefore( context.createTextNode( rleadingWhitespace.exec(elem)[0] ), div.firstChild );
	                                        }
	
	                                        elem = div.childNodes;
	
	                                        // Take out of fragment container (we need a fresh div each time)
	                                        div.parentNode.removeChild( div );
	                                }
	                        }
	
	                        if ( elem.nodeType ) {
	                                ret.push( elem );
	                        } else {
	                                jQuery.merge( ret, elem );
	                        }
	                }
	
	                // Fix #11356: Clear elements from safeFragment
	                if ( div ) {
	                        elem = div = safe = null;
	                }
	
	                // Reset defaultChecked for any radios and checkboxes
	                // about to be appended to the DOM in IE 6/7 (#8060)
	                if ( !jQuery.support.appendChecked ) {
	                        for ( i = 0; (elem = ret[i]) != null; i++ ) {
	                                if ( jQuery.nodeName( elem, "input" ) ) {
	                                        fixDefaultChecked( elem );
	                                } else if ( typeof elem.getElementsByTagName !== "undefined" ) {
	                                        jQuery.grep( elem.getElementsByTagName("input"), fixDefaultChecked );
	                                }
	                        }
	                }
	
	                // Append elements to a provided document fragment
	                if ( fragment ) {
	                        // Special handling of each script element
	                        handleScript = function( elem ) {
	                                // Check if we consider it executable
	                                if ( !elem.type || rscriptType.test( elem.type ) ) {
	                                        // Detach the script and store it in the scripts array (if provided) or the fragment
	                                        // Return truthy to indicate that it has been handled
	                                        return scripts ?
	                                                scripts.push( elem.parentNode ? elem.parentNode.removeChild( elem ) : elem ) :
	                                                fragment.appendChild( elem );
	                                }
	                        };
	
	                        for ( i = 0; (elem = ret[i]) != null; i++ ) {
	                                // Check if we're done after handling an executable script
	                                if ( !( jQuery.nodeName( elem, "script" ) && handleScript( elem ) ) ) {
	                                        // Append to fragment and handle embedded scripts
	                                        fragment.appendChild( elem );
	                                        if ( typeof elem.getElementsByTagName !== "undefined" ) {
	                                                // handleScript alters the DOM, so use jQuery.merge to ensure snapshot iteration
	                                                jsTags = jQuery.grep( jQuery.merge( [], elem.getElementsByTagName("script") ), handleScript );
	
	                                                // Splice the scripts into ret after their former ancestor and advance our index beyond them
	                                                ret.splice.apply( ret, [i + 1, 0].concat( jsTags ) );
	                                                i += jsTags.length;
	                                        }
	                                }
	                        }
	                }
	
	                return ret;
	        },
	
	        cleanData: function( elems, /* internal */ acceptData ) {
	                var data, id, elem, type,
	                        i = 0,
	                        internalKey = jQuery.expando,
	                        cache = jQuery.cache,
	                        deleteExpando = jQuery.support.deleteExpando,
	                        special = jQuery.event.special;
	
	                for ( ; (elem = elems[i]) != null; i++ ) {
	
	                        if ( acceptData || jQuery.acceptData( elem ) ) {
	
	                                id = elem[ internalKey ];
	                                data = id && cache[ id ];
	
	                                if ( data ) {
	                                        if ( data.events ) {
	                                                for ( type in data.events ) {
	                                                        if ( special[ type ] ) {
	                                                                jQuery.event.remove( elem, type );
	
	                                                        // This is a shortcut to avoid jQuery.event.remove's overhead
	                                                        } else {
	                                                                jQuery.removeEvent( elem, type, data.handle );
	                                                        }
	                                                }
	                                        }
	
	                                        // Remove cache only if it was not already removed by jQuery.event.remove
	                                        if ( cache[ id ] ) {
	
	                                                delete cache[ id ];
	
	                                                // IE does not allow us to delete expando properties from nodes,
	                                                // nor does it have a removeAttribute function on Document nodes;
	                                                // we must handle all of these cases
	                                                if ( deleteExpando ) {
	                                                        delete elem[ internalKey ];
	
	                                                } else if ( elem.removeAttribute ) {
	                                                        elem.removeAttribute( internalKey );
	
	                                                } else {
	                                                        elem[ internalKey ] = null;
	                                                }
	
	                                                jQuery.deletedIds.push( id );
	                                        }
	                                }
	                        }
	                }
	        }
	});
	// Limit scope pollution from any deprecated API
	(function() {
	
	var matched, browser;
	
	// Use of jQuery.browser is frowned upon.
	// More details: http://api.jquery.com/jQuery.browser
	// jQuery.uaMatch maintained for back-compat
	jQuery.uaMatch = function( ua ) {
	        ua = ua.toLowerCase();
	
	        var match = /(chrome)[ \/]([\w.]+)/.exec( ua ) ||
	                /(webkit)[ \/]([\w.]+)/.exec( ua ) ||
	                /(opera)(?:.*version|)[ \/]([\w.]+)/.exec( ua ) ||
	                /(msie) ([\w.]+)/.exec( ua ) ||
	                ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec( ua ) ||
	                [];
	
	        return {
	                browser: match[ 1 ] || "",
	                version: match[ 2 ] || "0"
	        };
	};
	
	matched = jQuery.uaMatch( navigator.userAgent );
	browser = {};
	
	if ( matched.browser ) {
	        browser[ matched.browser ] = true;
	        browser.version = matched.version;
	}
	
	// Chrome is Webkit, but Webkit is also Safari.
	if ( browser.chrome ) {
	        browser.webkit = true;
	} else if ( browser.webkit ) {
	        browser.safari = true;
	}
	
	jQuery.browser = browser;
	
	jQuery.sub = function() {
	        function jQuerySub( selector, context ) {
	                return new jQuerySub.fn.init( selector, context );
	        }
	        jQuery.extend( true, jQuerySub, this );
	        jQuerySub.superclass = this;
	        jQuerySub.fn = jQuerySub.prototype = this();
	        jQuerySub.fn.constructor = jQuerySub;
	        jQuerySub.sub = this.sub;
	        jQuerySub.fn.init = function init( selector, context ) {
	                if ( context && context instanceof jQuery && !(context instanceof jQuerySub) ) {
	                        context = jQuerySub( context );
	                }
	
	                return jQuery.fn.init.call( this, selector, context, rootjQuerySub );
	        };
	        jQuerySub.fn.init.prototype = jQuerySub.fn;
	        var rootjQuerySub = jQuerySub(document);
	        return jQuerySub;
	};
	
	})();
	var curCSS, iframe, iframeDoc,
	        ralpha = /alpha\([^)]*\)/i,
	        ropacity = /opacity=([^)]*)/,
	        rposition = /^(top|right|bottom|left)$/,
	        // swappable if display is none or starts with table except "table", "table-cell", or "table-caption"
	        // see here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	        rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	        rmargin = /^margin/,
	        rnumsplit = new RegExp( "^(" + core_pnum + ")(.*)$", "i" ),
	        rnumnonpx = new RegExp( "^(" + core_pnum + ")(?!px)[a-z%]+$", "i" ),
	        rrelNum = new RegExp( "^([-+])=(" + core_pnum + ")", "i" ),
	        elemdisplay = { BODY: "block" },
	
	        cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	        cssNormalTransform = {
	                letterSpacing: 0,
	                fontWeight: 400
	        },
	
	        cssExpand = [ "Top", "Right", "Bottom", "Left" ],
	        cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	
	        eventsToggle = jQuery.fn.toggle;
	
	// return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( style, name ) {
	
	        // shortcut for names that are not vendor prefixed
	        if ( name in style ) {
	                return name;
	        }
	
	        // check for vendor prefixed names
	        var capName = name.charAt(0).toUpperCase() + name.slice(1),
	                origName = name,
	                i = cssPrefixes.length;
	
	        while ( i-- ) {
	                name = cssPrefixes[ i ] + capName;
	                if ( name in style ) {
	                        return name;
	                }
	        }
	
	        return origName;
	}
	
	function isHidden( elem, el ) {
	        elem = el || elem;
	        return jQuery.css( elem, "display" ) === "none" || !jQuery.contains( elem.ownerDocument, elem );
	}
	
	function showHide( elements, show ) {
	        var elem, display,
	                values = [],
	                index = 0,
	                length = elements.length;
	
	        for ( ; index < length; index++ ) {
	                elem = elements[ index ];
	                if ( !elem.style ) {
	                        continue;
	                }
	                values[ index ] = jQuery._data( elem, "olddisplay" );
	                if ( show ) {
	                        // Reset the inline display of this element to learn if it is
	                        // being hidden by cascaded rules or not
	                        if ( !values[ index ] && elem.style.display === "none" ) {
	                                elem.style.display = "";
	                        }
	
	                        // Set elements which have been overridden with display: none
	                        // in a stylesheet to whatever the default browser style is
	                        // for such an element
	                        if ( elem.style.display === "" && isHidden( elem ) ) {
	                                values[ index ] = jQuery._data( elem, "olddisplay", css_defaultDisplay(elem.nodeName) );
	                        }
	                } else {
	                        display = curCSS( elem, "display" );
	
	                        if ( !values[ index ] && display !== "none" ) {
	                                jQuery._data( elem, "olddisplay", display );
	                        }
	                }
	        }
	
	        // Set the display of most of the elements in a second loop
	        // to avoid the constant reflow
	        for ( index = 0; index < length; index++ ) {
	                elem = elements[ index ];
	                if ( !elem.style ) {
	                        continue;
	                }
	                if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
	                        elem.style.display = show ? values[ index ] || "" : "none";
	                }
	        }
	
	        return elements;
	}
	
	jQuery.fn.extend({
	        css: function( name, value ) {
	                return jQuery.access( this, function( elem, name, value ) {
	                        return value !== undefined ?
	                                jQuery.style( elem, name, value ) :
	                                jQuery.css( elem, name );
	                }, name, value, arguments.length > 1 );
	        },
	        show: function() {
	                return showHide( this, true );
	        },
	        hide: function() {
	                return showHide( this );
	        },
	        toggle: function( state, fn2 ) {
	                var bool = typeof state === "boolean";
	
	                if ( jQuery.isFunction( state ) && jQuery.isFunction( fn2 ) ) {
	                        return eventsToggle.apply( this, arguments );
	                }
	
	                return this.each(function() {
	                        if ( bool ? state : isHidden( this ) ) {
	                                jQuery( this ).show();
	                        } else {
	                                jQuery( this ).hide();
	                        }
	                });
	        }
	});
	
	jQuery.extend({
	        // Add in style property hooks for overriding the default
	        // behavior of getting and setting a style property
	        cssHooks: {
	                opacity: {
	                        get: function( elem, computed ) {
	                                if ( computed ) {
	                                        // We should always get a number back from opacity
	                                        var ret = curCSS( elem, "opacity" );
	                                        return ret === "" ? "1" : ret;
	
	                                }
	                        }
	                }
	        },
	
	        // Exclude the following css properties to add px
	        cssNumber: {
	                "fillOpacity": true,
	                "fontWeight": true,
	                "lineHeight": true,
	                "opacity": true,
	                "orphans": true,
	                "widows": true,
	                "zIndex": true,
	                "zoom": true
	        },
	
	        // Add in properties whose names you wish to fix before
	        // setting or getting the value
	        cssProps: {
	                // normalize float css property
	                "float": jQuery.support.cssFloat ? "cssFloat" : "styleFloat"
	        },
	
	        // Get and set the style property on a DOM Node
	        style: function( elem, name, value, extra ) {
	                // Don't set styles on text and comment nodes
	                if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
	                        return;
	                }
	
	                // Make sure that we're working with the right name
	                var ret, type, hooks,
	                        origName = jQuery.camelCase( name ),
	                        style = elem.style;
	
	                name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( style, origName ) );
	
	                // gets hook for the prefixed version
	                // followed by the unprefixed version
	                hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
	                // Check if we're setting a value
	                if ( value !== undefined ) {
	                        type = typeof value;
	
	                        // convert relative number strings (+= or -=) to relative numbers. #7345
	                        if ( type === "string" && (ret = rrelNum.exec( value )) ) {
	                                value = ( ret[1] + 1 ) * ret[2] + parseFloat( jQuery.css( elem, name ) );
	                                // Fixes bug #9237
	                                type = "number";
	                        }
	
	                        // Make sure that NaN and null values aren't set. See: #7116
	                        if ( value == null || type === "number" && isNaN( value ) ) {
	                                return;
	                        }
	
	                        // If a number was passed in, add 'px' to the (except for certain CSS properties)
	                        if ( type === "number" && !jQuery.cssNumber[ origName ] ) {
	                                value += "px";
	                        }
	
	                        // If a hook was provided, use that value, otherwise just set the specified value
	                        if ( !hooks || !("set" in hooks) || (value = hooks.set( elem, value, extra )) !== undefined ) {
	                                // Wrapped to prevent IE from throwing errors when 'invalid' values are provided
	                                // Fixes bug #5509
	                                try {
	                                        style[ name ] = value;
	                                } catch(e) {}
	                        }
	
	                } else {
	                        // If a hook was provided get the non-computed value from there
	                        if ( hooks && "get" in hooks && (ret = hooks.get( elem, false, extra )) !== undefined ) {
	                                return ret;
	                        }
	
	                        // Otherwise just get the value from the style object
	                        return style[ name ];
	                }
	        },
	
	        css: function( elem, name, numeric, extra ) {
	                var val, num, hooks,
	                        origName = jQuery.camelCase( name );
	
	                // Make sure that we're working with the right name
	                name = jQuery.cssProps[ origName ] || ( jQuery.cssProps[ origName ] = vendorPropName( elem.style, origName ) );
	
	                // gets hook for the prefixed version
	                // followed by the unprefixed version
	                hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
	                // If a hook was provided get the computed value from there
	                if ( hooks && "get" in hooks ) {
	                        val = hooks.get( elem, true, extra );
	                }
	
	                // Otherwise, if a way to get the computed value exists, use that
	                if ( val === undefined ) {
	                        val = curCSS( elem, name );
	                }
	
	                //convert "normal" to computed value
	                if ( val === "normal" && name in cssNormalTransform ) {
	                        val = cssNormalTransform[ name ];
	                }
	
	                // Return, converting to number if forced or a qualifier was provided and val looks numeric
	                if ( numeric || extra !== undefined ) {
	                        num = parseFloat( val );
	                        return numeric || jQuery.isNumeric( num ) ? num || 0 : val;
	                }
	                return val;
	        },
	
	        // A method for quickly swapping in/out CSS properties to get correct calculations
	        swap: function( elem, options, callback ) {
	                var ret, name,
	                        old = {};
	
	                // Remember the old values, and insert the new ones
	                for ( name in options ) {
	                        old[ name ] = elem.style[ name ];
	                        elem.style[ name ] = options[ name ];
	                }
	
	                ret = callback.call( elem );
	
	                // Revert the old values
	                for ( name in options ) {
	                        elem.style[ name ] = old[ name ];
	                }
	
	                return ret;
	        }
	});
	
	// NOTE: To any future maintainer, we've window.getComputedStyle
	// because jsdom on node.js will break without it.
	if ( window.getComputedStyle ) {
	        curCSS = function( elem, name ) {
	                var ret, width, minWidth, maxWidth,
	                        computed = window.getComputedStyle( elem, null ),
	                        style = elem.style;
	
	                if ( computed ) {
	
	                        // getPropertyValue is only needed for .css('filter') in IE9, see #12537
	                        ret = computed.getPropertyValue( name ) || computed[ name ];
	
	                        if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
	                                ret = jQuery.style( elem, name );
	                        }
	
	                        // A tribute to the "awesome hack by Dean Edwards"
	                        // Chrome < 17 and Safari 5.0 uses "computed value" instead of "used value" for margin-right
	                        // Safari 5.1.7 (at least) returns percentage for a larger set of values, but width seems to be reliably pixels
	                        // this is against the CSSOM draft spec: http://dev.w3.org/csswg/cssom/#resolved-values
	                        if ( rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	                                width = style.width;
	                                minWidth = style.minWidth;
	                                maxWidth = style.maxWidth;
	
	                                style.minWidth = style.maxWidth = style.width = ret;
	                                ret = computed.width;
	
	                                style.width = width;
	                                style.minWidth = minWidth;
	                                style.maxWidth = maxWidth;
	                        }
	                }
	
	                return ret;
	        };
	} else if ( document.documentElement.currentStyle ) {
	        curCSS = function( elem, name ) {
	                var left, rsLeft,
	                        ret = elem.currentStyle && elem.currentStyle[ name ],
	                        style = elem.style;
	
	                // Avoid setting ret to empty string here
	                // so we don't default to auto
	                if ( ret == null && style && style[ name ] ) {
	                        ret = style[ name ];
	                }
	
	                // From the awesome hack by Dean Edwards
	                // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	
	                // If we're not dealing with a regular pixel number
	                // but a number that has a weird ending, we need to convert it to pixels
	                // but not position css attributes, as those are proportional to the parent element instead
	                // and we can't measure the parent instead because it might trigger a "stacking dolls" problem
	                if ( rnumnonpx.test( ret ) && !rposition.test( name ) ) {
	
	                        // Remember the original values
	                        left = style.left;
	                        rsLeft = elem.runtimeStyle && elem.runtimeStyle.left;
	
	                        // Put in the new values to get a computed value out
	                        if ( rsLeft ) {
	                                elem.runtimeStyle.left = elem.currentStyle.left;
	                        }
	                        style.left = name === "fontSize" ? "1em" : ret;
	                        ret = style.pixelLeft + "px";
	
	                        // Revert the changed values
	                        style.left = left;
	                        if ( rsLeft ) {
	                                elem.runtimeStyle.left = rsLeft;
	                        }
	                }
	
	                return ret === "" ? "auto" : ret;
	        };
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	        var matches = rnumsplit.exec( value );
	        return matches ?
	                        Math.max( 0, matches[ 1 ] - ( subtract || 0 ) ) + ( matches[ 2 ] || "px" ) :
	                        value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox ) {
	        var i = extra === ( isBorderBox ? "border" : "content" ) ?
	                // If we already have the right measurement, avoid augmentation
	                4 :
	                // Otherwise initialize for horizontal or vertical properties
	                name === "width" ? 1 : 0,
	
	                val = 0;
	
	        for ( ; i < 4; i += 2 ) {
	                // both box models exclude margin, so add it if we want it
	                if ( extra === "margin" ) {
	                        // we use jQuery.css instead of curCSS here
	                        // because of the reliableMarginRight CSS hook!
	                        val += jQuery.css( elem, extra + cssExpand[ i ], true );
	                }
	
	                // From this point on we use curCSS for maximum performance (relevant in animations)
	                if ( isBorderBox ) {
	                        // border-box includes padding, so remove it if we want content
	                        if ( extra === "content" ) {
	                                val -= parseFloat( curCSS( elem, "padding" + cssExpand[ i ] ) ) || 0;
	                        }
	
	                        // at this point, extra isn't border nor margin, so remove border
	                        if ( extra !== "margin" ) {
	                                val -= parseFloat( curCSS( elem, "border" + cssExpand[ i ] + "Width" ) ) || 0;
	                        }
	                } else {
	                        // at this point, extra isn't content, so add padding
	                        val += parseFloat( curCSS( elem, "padding" + cssExpand[ i ] ) ) || 0;
	
	                        // at this point, extra isn't content nor padding, so add border
	                        if ( extra !== "padding" ) {
	                                val += parseFloat( curCSS( elem, "border" + cssExpand[ i ] + "Width" ) ) || 0;
	                        }
	                }
	        }
	
	        return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
	        // Start with offset property, which is equivalent to the border-box value
	        var val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
	                valueIsBorderBox = true,
	                isBorderBox = jQuery.support.boxSizing && jQuery.css( elem, "boxSizing" ) === "border-box";
	
	        // some non-html elements return undefined for offsetWidth, so check for null/undefined
	        // svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	        // MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	        if ( val <= 0 || val == null ) {
	                // Fall back to computed then uncomputed css if necessary
	                val = curCSS( elem, name );
	                if ( val < 0 || val == null ) {
	                        val = elem.style[ name ];
	                }
	
	                // Computed unit is not pixels. Stop here and return.
	                if ( rnumnonpx.test(val) ) {
	                        return val;
	                }
	
	                // we need the check for style in case a browser which returns unreliable values
	                // for getComputedStyle silently falls back to the reliable elem.style
	                valueIsBorderBox = isBorderBox && ( jQuery.support.boxSizingReliable || val === elem.style[ name ] );
	
	                // Normalize "", auto, and prepare for extra
	                val = parseFloat( val ) || 0;
	        }
	
	        // use the active box-sizing model to add/subtract irrelevant styles
	        return ( val +
	                augmentWidthOrHeight(
	                        elem,
	                        name,
	                        extra || ( isBorderBox ? "border" : "content" ),
	                        valueIsBorderBox
	                )
	        ) + "px";
	}
	
	
	// Try to determine the default display value of an element
	function css_defaultDisplay( nodeName ) {
	        if ( elemdisplay[ nodeName ] ) {
	                return elemdisplay[ nodeName ];
	        }
	
	        var elem = jQuery( "<" + nodeName + ">" ).appendTo( document.body ),
	                display = elem.css("display");
	        elem.remove();
	
	        // If the simple way fails,
	        // get element's real default display by attaching it to a temp iframe
	        if ( display === "none" || display === "" ) {
	                // Use the already-created iframe if possible
	                iframe = document.body.appendChild(
	                        iframe || jQuery.extend( document.createElement("iframe"), {
	                                frameBorder: 0,
	                                width: 0,
	                                height: 0
	                        })
	                );
	
	                // Create a cacheable copy of the iframe document on first call.
	                // IE and Opera will allow us to reuse the iframeDoc without re-writing the fake HTML
	                // document to it; WebKit & Firefox won't allow reusing the iframe document.
	                if ( !iframeDoc || !iframe.createElement ) {
	                        iframeDoc = ( iframe.contentWindow || iframe.contentDocument ).document;
	                        iframeDoc.write("<!doctype html><html><body>");
	                        iframeDoc.close();
	                }
	
	                elem = iframeDoc.body.appendChild( iframeDoc.createElement(nodeName) );
	
	                display = curCSS( elem, "display" );
	                document.body.removeChild( iframe );
	        }
	
	        // Store the correct default display
	        elemdisplay[ nodeName ] = display;
	
	        return display;
	}
	
	jQuery.each([ "height", "width" ], function( i, name ) {
	        jQuery.cssHooks[ name ] = {
	                get: function( elem, computed, extra ) {
	                        if ( computed ) {
	                                // certain elements can have dimension info if we invisibly show them
	                                // however, it must have a current display style that would benefit from this
	                                if ( elem.offsetWidth === 0 && rdisplayswap.test( curCSS( elem, "display" ) ) ) {
	                                        return jQuery.swap( elem, cssShow, function() {
	                                                return getWidthOrHeight( elem, name, extra );
	                                        });
	                                } else {
	                                        return getWidthOrHeight( elem, name, extra );
	                                }
	                        }
	                },
	
	                set: function( elem, value, extra ) {
	                        return setPositiveNumber( elem, value, extra ?
	                                augmentWidthOrHeight(
	                                        elem,
	                                        name,
	                                        extra,
	                                        jQuery.support.boxSizing && jQuery.css( elem, "boxSizing" ) === "border-box"
	                                ) : 0
	                        );
	                }
	        };
	});
	
	if ( !jQuery.support.opacity ) {
	        jQuery.cssHooks.opacity = {
	                get: function( elem, computed ) {
	                        // IE uses filters for opacity
	                        return ropacity.test( (computed && elem.currentStyle ? elem.currentStyle.filter : elem.style.filter) || "" ) ?
	                                ( 0.01 * parseFloat( RegExp.$1 ) ) + "" :
	                                computed ? "1" : "";
	                },
	
	                set: function( elem, value ) {
	                        var style = elem.style,
	                                currentStyle = elem.currentStyle,
	                                opacity = jQuery.isNumeric( value ) ? "alpha(opacity=" + value * 100 + ")" : "",
	                                filter = currentStyle && currentStyle.filter || style.filter || "";
	
	                        // IE has trouble with opacity if it does not have layout
	                        // Force it by setting the zoom level
	                        style.zoom = 1;
	
	                        // if setting opacity to 1, and no other filters exist - attempt to remove filter attribute #6652
	                        if ( value >= 1 && jQuery.trim( filter.replace( ralpha, "" ) ) === "" &&
	                                style.removeAttribute ) {
	
	                                // Setting style.filter to null, "" & " " still leave "filter:" in the cssText
	                                // if "filter:" is present at all, clearType is disabled, we want to avoid this
	                                // style.removeAttribute is IE Only, but so apparently is this code path...
	                                style.removeAttribute( "filter" );
	
	                                // if there there is no filter style applied in a css rule, we are done
	                                if ( currentStyle && !currentStyle.filter ) {
	                                        return;
	                                }
	                        }
	
	                        // otherwise, set new filter values
	                        style.filter = ralpha.test( filter ) ?
	                                filter.replace( ralpha, opacity ) :
	                                filter + " " + opacity;
	                }
	        };
	}
	
	// These hooks cannot be added until DOM ready because the support test
	// for it is not run until after DOM ready
	jQuery(function() {
	        if ( !jQuery.support.reliableMarginRight ) {
	                jQuery.cssHooks.marginRight = {
	                        get: function( elem, computed ) {
	                                // WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
	                                // Work around by temporarily setting element display to inline-block
	                                return jQuery.swap( elem, { "display": "inline-block" }, function() {
	                                        if ( computed ) {
	                                                return curCSS( elem, "marginRight" );
	                                        }
	                                });
	                        }
	                };
	        }
	
	        // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	        // getComputedStyle returns percent when specified for top/left/bottom/right
	        // rather than make the css module depend on the offset module, we just check for it here
	        if ( !jQuery.support.pixelPosition && jQuery.fn.position ) {
	                jQuery.each( [ "top", "left" ], function( i, prop ) {
	                        jQuery.cssHooks[ prop ] = {
	                                get: function( elem, computed ) {
	                                        if ( computed ) {
	                                                var ret = curCSS( elem, prop );
	                                                // if curCSS returns percentage, fallback to offset
	                                                return rnumnonpx.test( ret ) ? jQuery( elem ).position()[ prop ] + "px" : ret;
	                                        }
	                                }
	                        };
	                });
	        }
	
	});
	
	if ( jQuery.expr && jQuery.expr.filters ) {
	        jQuery.expr.filters.hidden = function( elem ) {
	                return ( elem.offsetWidth === 0 && elem.offsetHeight === 0 ) || (!jQuery.support.reliableHiddenOffsets && ((elem.style && elem.style.display) || curCSS( elem, "display" )) === "none");
	        };
	
	        jQuery.expr.filters.visible = function( elem ) {
	                return !jQuery.expr.filters.hidden( elem );
	        };
	}
	
	// These hooks are used by animate to expand properties
	jQuery.each({
	        margin: "",
	        padding: "",
	        border: "Width"
	}, function( prefix, suffix ) {
	        jQuery.cssHooks[ prefix + suffix ] = {
	                expand: function( value ) {
	                        var i,
	
	                                // assumes a single number if not a string
	                                parts = typeof value === "string" ? value.split(" ") : [ value ],
	                                expanded = {};
	
	                        for ( i = 0; i < 4; i++ ) {
	                                expanded[ prefix + cssExpand[ i ] + suffix ] =
	                                        parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
	                        }
	
	                        return expanded;
	                }
	        };
	
	        if ( !rmargin.test( prefix ) ) {
	                jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	        }
	});
	var r20 = /%20/g,
	        rbracket = /\[\]$/,
	        rCRLF = /\r?\n/g,
	        rinput = /^(?:color|date|datetime|datetime-local|email|hidden|month|number|password|range|search|tel|text|time|url|week)$/i,
	        rselectTextarea = /^(?:select|textarea)/i;
	
	jQuery.fn.extend({
	        serialize: function() {
	                return jQuery.param( this.serializeArray() );
	        },
	        serializeArray: function() {
	                return this.map(function(){
	                        return this.elements ? jQuery.makeArray( this.elements ) : this;
	                })
	                .filter(function(){
	                        return this.name && !this.disabled &&
	                                ( this.checked || rselectTextarea.test( this.nodeName ) ||
	                                        rinput.test( this.type ) );
	                })
	                .map(function( i, elem ){
	                        var val = jQuery( this ).val();
	
	                        return val == null ?
	                                null :
	                                jQuery.isArray( val ) ?
	                                        jQuery.map( val, function( val, i ){
	                                                return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
	                                        }) :
	                                        { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
	                }).get();
	        }
	});
	
	//Serialize an array of form elements or a set of
	//key/values into a query string
	jQuery.param = function( a, traditional ) {
	        var prefix,
	                s = [],
	                add = function( key, value ) {
	                        // If value is a function, invoke it and return its value
	                        value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
	                        s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
	                };
	
	        // Set traditional to true for jQuery <= 1.3.2 behavior.
	        if ( traditional === undefined ) {
	                traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	        }
	
	        // If an array was passed in, assume that it is an array of form elements.
	        if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	                // Serialize the form elements
	                jQuery.each( a, function() {
	                        add( this.name, this.value );
	                });
	
	        } else {
	                // If traditional, encode the "old" way (the way 1.3.2 or older
	                // did it), otherwise encode params recursively.
	                for ( prefix in a ) {
	                        buildParams( prefix, a[ prefix ], traditional, add );
	                }
	        }
	
	        // Return the resulting serialization
	        return s.join( "&" ).replace( r20, "+" );
	};
	
	function buildParams( prefix, obj, traditional, add ) {
	        var name;
	
	        if ( jQuery.isArray( obj ) ) {
	                // Serialize array item.
	                jQuery.each( obj, function( i, v ) {
	                        if ( traditional || rbracket.test( prefix ) ) {
	                                // Treat each array item as a scalar.
	                                add( prefix, v );
	
	                        } else {
	                                // If array item is non-scalar (array or object), encode its
	                                // numeric index to resolve deserialization ambiguity issues.
	                                // Note that rack (as of 1.0.0) can't currently deserialize
	                                // nested arrays properly, and attempting to do so may cause
	                                // a server error. Possible fixes are to modify rack's
	                                // deserialization algorithm or to provide an option or flag
	                                // to force array serialization to be shallow.
	                                buildParams( prefix + "[" + ( typeof v === "object" ? i : "" ) + "]", v, traditional, add );
	                        }
	                });
	
	        } else if ( !traditional && jQuery.type( obj ) === "object" ) {
	                // Serialize object item.
	                for ( name in obj ) {
	                        buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
	                }
	
	        } else {
	                // Serialize scalar item.
	                add( prefix, obj );
	        }
	}
	var
	        // Document location
	        ajaxLocParts,
	        ajaxLocation,
	
	        rhash = /#.*$/,
	        rheaders = /^(.*?):[ \t]*([^\r\n]*)\r?$/mg, // IE leaves an \r character at EOL
	        // #7653, #8125, #8152: local protocol detection
	        rlocalProtocol = /^(?:about|app|app\-storage|.+\-extension|file|res|widget):$/,
	        rnoContent = /^(?:GET|HEAD)$/,
	        rprotocol = /^\/\//,
	        rquery = /\?/,
	        rscript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi,
	        rts = /([?&])_=[^&]*/,
	        rurl = /^([\w\+\.\-]+:)(?:\/\/([^\/?#:]*)(?::(\d+)|)|)/,
	
	        // Keep a copy of the old load method
	        _load = jQuery.fn.load,
	
	        /* Prefilters
	         * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	         * 2) These are called:
	         *    - BEFORE asking for a transport
	         *    - AFTER param serialization (s.data is a string if s.processData is true)
	         * 3) key is the dataType
	         * 4) the catchall symbol "*" can be used
	         * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	         */
	        prefilters = {},
	
	        /* Transports bindings
	         * 1) key is the dataType
	         * 2) the catchall symbol "*" can be used
	         * 3) selection will start with transport dataType and THEN go to "*" if needed
	         */
	        transports = {},
	
	        // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	        allTypes = ["*/"] + ["*"];
	
	// #8138, IE may throw an exception when accessing
	// a field from window.location if document.domain has been set
	try {
	        ajaxLocation = location.href;
	} catch( e ) {
	        // Use the href attribute of an A element
	        // since IE will modify it given document.location
	        ajaxLocation = document.createElement( "a" );
	        ajaxLocation.href = "";
	        ajaxLocation = ajaxLocation.href;
	}
	
	// Segment location into parts
	ajaxLocParts = rurl.exec( ajaxLocation.toLowerCase() ) || [];
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
	        // dataTypeExpression is optional and defaults to "*"
	        return function( dataTypeExpression, func ) {
	
	                if ( typeof dataTypeExpression !== "string" ) {
	                        func = dataTypeExpression;
	                        dataTypeExpression = "*";
	                }
	
	                var dataType, list, placeBefore,
	                        dataTypes = dataTypeExpression.toLowerCase().split( core_rspace ),
	                        i = 0,
	                        length = dataTypes.length;
	
	                if ( jQuery.isFunction( func ) ) {
	                        // For each dataType in the dataTypeExpression
	                        for ( ; i < length; i++ ) {
	                                dataType = dataTypes[ i ];
	                                // We control if we're asked to add before
	                                // any existing element
	                                placeBefore = /^\+/.test( dataType );
	                                if ( placeBefore ) {
	                                        dataType = dataType.substr( 1 ) || "*";
	                                }
	                                list = structure[ dataType ] = structure[ dataType ] || [];
	                                // then we add to the structure accordingly
	                                list[ placeBefore ? "unshift" : "push" ]( func );
	                        }
	                }
	        };
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR,
	                dataType /* internal */, inspected /* internal */ ) {
	
	        dataType = dataType || options.dataTypes[ 0 ];
	        inspected = inspected || {};
	
	        inspected[ dataType ] = true;
	
	        var selection,
	                list = structure[ dataType ],
	                i = 0,
	                length = list ? list.length : 0,
	                executeOnly = ( structure === prefilters );
	
	        for ( ; i < length && ( executeOnly || !selection ); i++ ) {
	                selection = list[ i ]( options, originalOptions, jqXHR );
	                // If we got redirected to another dataType
	                // we try there if executing only and not done already
	                if ( typeof selection === "string" ) {
	                        if ( !executeOnly || inspected[ selection ] ) {
	                                selection = undefined;
	                        } else {
	                                options.dataTypes.unshift( selection );
	                                selection = inspectPrefiltersOrTransports(
	                                                structure, options, originalOptions, jqXHR, selection, inspected );
	                        }
	                }
	        }
	        // If we're only executing or nothing was selected
	        // we try the catchall dataType if not done already
	        if ( ( executeOnly || !selection ) && !inspected[ "*" ] ) {
	                selection = inspectPrefiltersOrTransports(
	                                structure, options, originalOptions, jqXHR, "*", inspected );
	        }
	        // unnecessary when only executing (prefilters)
	        // but it'll be ignored by the caller in that case
	        return selection;
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
	        var key, deep,
	                flatOptions = jQuery.ajaxSettings.flatOptions || {};
	        for ( key in src ) {
	                if ( src[ key ] !== undefined ) {
	                        ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
	                }
	        }
	        if ( deep ) {
	                jQuery.extend( true, target, deep );
	        }
	}
	
	jQuery.fn.load = function( url, params, callback ) {
	        if ( typeof url !== "string" && _load ) {
	                return _load.apply( this, arguments );
	        }
	
	        // Don't do a request if no elements are being requested
	        if ( !this.length ) {
	                return this;
	        }
	
	        var selector, type, response,
	                self = this,
	                off = url.indexOf(" ");
	
	        if ( off >= 0 ) {
	                selector = url.slice( off, url.length );
	                url = url.slice( 0, off );
	        }
	
	        // If it's a function
	        if ( jQuery.isFunction( params ) ) {
	
	                // We assume that it's the callback
	                callback = params;
	                params = undefined;
	
	        // Otherwise, build a param string
	        } else if ( params && typeof params === "object" ) {
	                type = "POST";
	        }
	
	        // Request the remote document
	        jQuery.ajax({
	                url: url,
	
	                // if "type" variable is undefined, then "GET" method will be used
	                type: type,
	                dataType: "html",
	                data: params,
	                complete: function( jqXHR, status ) {
	                        if ( callback ) {
	                                self.each( callback, response || [ jqXHR.responseText, status, jqXHR ] );
	                        }
	                }
	        }).done(function( responseText ) {
	
	                // Save response for use in complete callback
	                response = arguments;
	
	                // See if a selector was specified
	                self.html( selector ?
	
	                        // Create a dummy div to hold the results
	                        jQuery("<div>")
	
	                                // inject the contents of the document in, removing the scripts
	                                // to avoid any 'Permission Denied' errors in IE
	                                .append( responseText.replace( rscript, "" ) )
	
	                                // Locate the specified elements
	                                .find( selector ) :
	
	                        // If not, just inject the full result
	                        responseText );
	
	        });
	
	        return this;
	};
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( "ajaxStart ajaxStop ajaxComplete ajaxError ajaxSuccess ajaxSend".split( " " ), function( i, o ){
	        jQuery.fn[ o ] = function( f ){
	                return this.on( o, f );
	        };
	});
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
	        jQuery[ method ] = function( url, data, callback, type ) {
	                // shift arguments if data argument was omitted
	                if ( jQuery.isFunction( data ) ) {
	                        type = type || callback;
	                        callback = data;
	                        data = undefined;
	                }
	
	                return jQuery.ajax({
	                        type: method,
	                        url: url,
	                        data: data,
	                        success: callback,
	                        dataType: type
	                });
	        };
	});
	
	jQuery.extend({
	
	        getScript: function( url, callback ) {
	                return jQuery.get( url, undefined, callback, "script" );
	        },
	
	        getJSON: function( url, data, callback ) {
	                return jQuery.get( url, data, callback, "json" );
	        },
	
	        // Creates a full fledged settings object into target
	        // with both ajaxSettings and settings fields.
	        // If target is omitted, writes into ajaxSettings.
	        ajaxSetup: function( target, settings ) {
	                if ( settings ) {
	                        // Building a settings object
	                        ajaxExtend( target, jQuery.ajaxSettings );
	                } else {
	                        // Extending ajaxSettings
	                        settings = target;
	                        target = jQuery.ajaxSettings;
	                }
	                ajaxExtend( target, settings );
	                return target;
	        },
	
	        ajaxSettings: {
	                url: ajaxLocation,
	                isLocal: rlocalProtocol.test( ajaxLocParts[ 1 ] ),
	                global: true,
	                type: "GET",
	                contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	                processData: true,
	                async: true,
	                /*
	                timeout: 0,
	                data: null,
	                dataType: null,
	                username: null,
	                password: null,
	                cache: null,
	                throws: false,
	                traditional: false,
	                headers: {},
	                */
	
	                accepts: {
	                        xml: "application/xml, text/xml",
	                        html: "text/html",
	                        text: "text/plain",
	                        json: "application/json, text/javascript",
	                        "*": allTypes
	                },
	
	                contents: {
	                        xml: /xml/,
	                        html: /html/,
	                        json: /json/
	                },
	
	                responseFields: {
	                        xml: "responseXML",
	                        text: "responseText"
	                },
	
	                // List of data converters
	                // 1) key format is "source_type destination_type" (a single space in-between)
	                // 2) the catchall symbol "*" can be used for source_type
	                converters: {
	
	                        // Convert anything to text
	                        "* text": window.String,
	
	                        // Text to html (true = no transformation)
	                        "text html": true,
	
	                        // Evaluate text as a json expression
	                        "text json": jQuery.parseJSON,
	
	                        // Parse text as xml
	                        "text xml": jQuery.parseXML
	                },
	
	                // For options that shouldn't be deep extended:
	                // you can add your own custom options here if
	                // and when you create one that shouldn't be
	                // deep extended (see ajaxExtend)
	                flatOptions: {
	                        context: true,
	                        url: true
	                }
	        },
	
	        ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	        ajaxTransport: addToPrefiltersOrTransports( transports ),
	
	        // Main method
	        ajax: function( url, options ) {
	
	                // If url is an object, simulate pre-1.5 signature
	                if ( typeof url === "object" ) {
	                        options = url;
	                        url = undefined;
	                }
	
	                // Force options to be an object
	                options = options || {};
	
	                var // ifModified key
	                        ifModifiedKey,
	                        // Response headers
	                        responseHeadersString,
	                        responseHeaders,
	                        // transport
	                        transport,
	                        // timeout handle
	                        timeoutTimer,
	                        // Cross-domain detection vars
	                        parts,
	                        // To know if global events are to be dispatched
	                        fireGlobals,
	                        // Loop variable
	                        i,
	                        // Create the final options object
	                        s = jQuery.ajaxSetup( {}, options ),
	                        // Callbacks context
	                        callbackContext = s.context || s,
	                        // Context for global events
	                        // It's the callbackContext if one was provided in the options
	                        // and if it's a DOM node or a jQuery collection
	                        globalEventContext = callbackContext !== s &&
	                                ( callbackContext.nodeType || callbackContext instanceof jQuery ) ?
	                                                jQuery( callbackContext ) : jQuery.event,
	                        // Deferreds
	                        deferred = jQuery.Deferred(),
	                        completeDeferred = jQuery.Callbacks( "once memory" ),
	                        // Status-dependent callbacks
	                        statusCode = s.statusCode || {},
	                        // Headers (they are sent all at once)
	                        requestHeaders = {},
	                        requestHeadersNames = {},
	                        // The jqXHR state
	                        state = 0,
	                        // Default abort message
	                        strAbort = "canceled",
	                        // Fake xhr
	                        jqXHR = {
	
	                                readyState: 0,
	
	                                // Caches the header
	                                setRequestHeader: function( name, value ) {
	                                        if ( !state ) {
	                                                var lname = name.toLowerCase();
	                                                name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
	                                                requestHeaders[ name ] = value;
	                                        }
	                                        return this;
	                                },
	
	                                // Raw string
	                                getAllResponseHeaders: function() {
	                                        return state === 2 ? responseHeadersString : null;
	                                },
	
	                                // Builds headers hashtable if needed
	                                getResponseHeader: function( key ) {
	                                        var match;
	                                        if ( state === 2 ) {
	                                                if ( !responseHeaders ) {
	                                                        responseHeaders = {};
	                                                        while( ( match = rheaders.exec( responseHeadersString ) ) ) {
	                                                                responseHeaders[ match[1].toLowerCase() ] = match[ 2 ];
	                                                        }
	                                                }
	                                                match = responseHeaders[ key.toLowerCase() ];
	                                        }
	                                        return match === undefined ? null : match;
	                                },
	
	                                // Overrides response content-type header
	                                overrideMimeType: function( type ) {
	                                        if ( !state ) {
	                                                s.mimeType = type;
	                                        }
	                                        return this;
	                                },
	
	                                // Cancel the request
	                                abort: function( statusText ) {
	                                        statusText = statusText || strAbort;
	                                        if ( transport ) {
	                                                transport.abort( statusText );
	                                        }
	                                        done( 0, statusText );
	                                        return this;
	                                }
	                        };
	
	                // Callback for when everything is done
	                // It is defined here because jslint complains if it is declared
	                // at the end of the function (which would be more logical and readable)
	                function done( status, nativeStatusText, responses, headers ) {
	                        var isSuccess, success, error, response, modified,
	                                statusText = nativeStatusText;
	
	                        // Called once
	                        if ( state === 2 ) {
	                                return;
	                        }
	
	                        // State is "done" now
	                        state = 2;
	
	                        // Clear timeout if it exists
	                        if ( timeoutTimer ) {
	                                clearTimeout( timeoutTimer );
	                        }
	
	                        // Dereference transport for early garbage collection
	                        // (no matter how long the jqXHR object will be used)
	                        transport = undefined;
	
	                        // Cache response headers
	                        responseHeadersString = headers || "";
	
	                        // Set readyState
	                        jqXHR.readyState = status > 0 ? 4 : 0;
	
	                        // Get response data
	                        if ( responses ) {
	                                response = ajaxHandleResponses( s, jqXHR, responses );
	                        }
	
	                        // If successful, handle type chaining
	                        if ( status >= 200 && status < 300 || status === 304 ) {
	
	                                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
	                                if ( s.ifModified ) {
	
	                                        modified = jqXHR.getResponseHeader("Last-Modified");
	                                        if ( modified ) {
	                                                jQuery.lastModified[ ifModifiedKey ] = modified;
	                                        }
	                                        modified = jqXHR.getResponseHeader("Etag");
	                                        if ( modified ) {
	                                                jQuery.etag[ ifModifiedKey ] = modified;
	                                        }
	                                }
	
	                                // If not modified
	                                if ( status === 304 ) {
	
	                                        statusText = "notmodified";
	                                        isSuccess = true;
	
	                                // If we have data
	                                } else {
	
	                                        isSuccess = ajaxConvert( s, response );
	                                        statusText = isSuccess.state;
	                                        success = isSuccess.data;
	                                        error = isSuccess.error;
	                                        isSuccess = !error;
	                                }
	                        } else {
	                                // We extract error from statusText
	                                // then normalize statusText and status for non-aborts
	                                error = statusText;
	                                if ( !statusText || status ) {
	                                        statusText = "error";
	                                        if ( status < 0 ) {
	                                                status = 0;
	                                        }
	                                }
	                        }
	
	                        // Set data for the fake xhr object
	                        jqXHR.status = status;
	                        jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
	                        // Success/Error
	                        if ( isSuccess ) {
	                                deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
	                        } else {
	                                deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
	                        }
	
	                        // Status-dependent callbacks
	                        jqXHR.statusCode( statusCode );
	                        statusCode = undefined;
	
	                        if ( fireGlobals ) {
	                                globalEventContext.trigger( "ajax" + ( isSuccess ? "Success" : "Error" ),
	                                                [ jqXHR, s, isSuccess ? success : error ] );
	                        }
	
	                        // Complete
	                        completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
	                        if ( fireGlobals ) {
	                                globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	                                // Handle the global AJAX counter
	                                if ( !( --jQuery.active ) ) {
	                                        jQuery.event.trigger( "ajaxStop" );
	                                }
	                        }
	                }
	
	                // Attach deferreds
	                deferred.promise( jqXHR );
	                jqXHR.success = jqXHR.done;
	                jqXHR.error = jqXHR.fail;
	                jqXHR.complete = completeDeferred.add;
	
	                // Status-dependent callbacks
	                jqXHR.statusCode = function( map ) {
	                        if ( map ) {
	                                var tmp;
	                                if ( state < 2 ) {
	                                        for ( tmp in map ) {
	                                                statusCode[ tmp ] = [ statusCode[tmp], map[tmp] ];
	                                        }
	                                } else {
	                                        tmp = map[ jqXHR.status ];
	                                        jqXHR.always( tmp );
	                                }
	                        }
	                        return this;
	                };
	
	                // Remove hash character (#7531: and string promotion)
	                // Add protocol if not provided (#5866: IE7 issue with protocol-less urls)
	                // We also use the url parameter if available
	                s.url = ( ( url || s.url ) + "" ).replace( rhash, "" ).replace( rprotocol, ajaxLocParts[ 1 ] + "//" );
	
	                // Extract dataTypes list
	                s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().split( core_rspace );
	
	                // A cross-domain request is in order when we have a protocol:host:port mismatch
	                if ( s.crossDomain == null ) {
	                        parts = rurl.exec( s.url.toLowerCase() );
	                        s.crossDomain = !!( parts &&
	                                ( parts[ 1 ] !== ajaxLocParts[ 1 ] || parts[ 2 ] !== ajaxLocParts[ 2 ] ||
	                                        ( parts[ 3 ] || ( parts[ 1 ] === "http:" ? 80 : 443 ) ) !=
	                                                ( ajaxLocParts[ 3 ] || ( ajaxLocParts[ 1 ] === "http:" ? 80 : 443 ) ) )
	                        );
	                }
	
	                // Convert data if not already a string
	                if ( s.data && s.processData && typeof s.data !== "string" ) {
	                        s.data = jQuery.param( s.data, s.traditional );
	                }
	
	                // Apply prefilters
	                inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
	                // If request was aborted inside a prefilter, stop there
	                if ( state === 2 ) {
	                        return jqXHR;
	                }
	
	                // We can fire global events as of now if asked to
	                fireGlobals = s.global;
	
	                // Uppercase the type
	                s.type = s.type.toUpperCase();
	
	                // Determine if request has content
	                s.hasContent = !rnoContent.test( s.type );
	
	                // Watch for a new set of requests
	                if ( fireGlobals && jQuery.active++ === 0 ) {
	                        jQuery.event.trigger( "ajaxStart" );
	                }
	
	                // More options handling for requests with no content
	                if ( !s.hasContent ) {
	
	                        // If data is available, append data to url
	                        if ( s.data ) {
	                                s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.data;
	                                // #9682: remove data so that it's not used in an eventual retry
	                                delete s.data;
	                        }
	
	                        // Get ifModifiedKey before adding the anti-cache parameter
	                        ifModifiedKey = s.url;
	
	                        // Add anti-cache in url if needed
	                        if ( s.cache === false ) {
	
	                                var ts = jQuery.now(),
	                                        // try replacing _= if it is there
	                                        ret = s.url.replace( rts, "$1_=" + ts );
	
	                                // if nothing was replaced, add timestamp to the end
	                                s.url = ret + ( ( ret === s.url ) ? ( rquery.test( s.url ) ? "&" : "?" ) + "_=" + ts : "" );
	                        }
	                }
	
	                // Set the correct header, if data is being sent
	                if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
	                        jqXHR.setRequestHeader( "Content-Type", s.contentType );
	                }
	
	                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
	                if ( s.ifModified ) {
	                        ifModifiedKey = ifModifiedKey || s.url;
	                        if ( jQuery.lastModified[ ifModifiedKey ] ) {
	                                jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ ifModifiedKey ] );
	                        }
	                        if ( jQuery.etag[ ifModifiedKey ] ) {
	                                jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ ifModifiedKey ] );
	                        }
	                }
	
	                // Set the Accepts header for the server, depending on the dataType
	                jqXHR.setRequestHeader(
	                        "Accept",
	                        s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[0] ] ?
	                                s.accepts[ s.dataTypes[0] ] + ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
	                                s.accepts[ "*" ]
	                );
	
	                // Check for headers option
	                for ( i in s.headers ) {
	                        jqXHR.setRequestHeader( i, s.headers[ i ] );
	                }
	
	                // Allow custom headers/mimetypes and early abort
	                if ( s.beforeSend && ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {
	                                // Abort if not done already and return
	                                return jqXHR.abort();
	
	                }
	
	                // aborting is no longer a cancellation
	                strAbort = "abort";
	
	                // Install callbacks on deferreds
	                for ( i in { success: 1, error: 1, complete: 1 } ) {
	                        jqXHR[ i ]( s[ i ] );
	                }
	
	                // Get transport
	                transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
	                // If no transport, we auto-abort
	                if ( !transport ) {
	                        done( -1, "No Transport" );
	                } else {
	                        jqXHR.readyState = 1;
	                        // Send global event
	                        if ( fireGlobals ) {
	                                globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
	                        }
	                        // Timeout
	                        if ( s.async && s.timeout > 0 ) {
	                                timeoutTimer = setTimeout( function(){
	                                        jqXHR.abort( "timeout" );
	                                }, s.timeout );
	                        }
	
	                        try {
	                                state = 1;
	                                transport.send( requestHeaders, done );
	                        } catch (e) {
	                                // Propagate exception as error if not done
	                                if ( state < 2 ) {
	                                        done( -1, e );
	                                // Simply rethrow otherwise
	                                } else {
	                                        throw e;
	                                }
	                        }
	                }
	
	                return jqXHR;
	        },
	
	        // Counter for holding the number of active queries
	        active: 0,
	
	        // Last-Modified header cache for next request
	        lastModified: {},
	        etag: {}
	
	});
	
	/* Handles responses to an ajax request:
	 * - sets all responseXXX fields accordingly
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
	        var ct, type, finalDataType, firstDataType,
	                contents = s.contents,
	                dataTypes = s.dataTypes,
	                responseFields = s.responseFields;
	
	        // Fill responseXXX fields
	        for ( type in responseFields ) {
	                if ( type in responses ) {
	                        jqXHR[ responseFields[type] ] = responses[ type ];
	                }
	        }
	
	        // Remove auto dataType and get content-type in the process
	        while( dataTypes[ 0 ] === "*" ) {
	                dataTypes.shift();
	                if ( ct === undefined ) {
	                        ct = s.mimeType || jqXHR.getResponseHeader( "content-type" );
	                }
	        }
	
	        // Check if we're dealing with a known content-type
	        if ( ct ) {
	                for ( type in contents ) {
	                        if ( contents[ type ] && contents[ type ].test( ct ) ) {
	                                dataTypes.unshift( type );
	                                break;
	                        }
	                }
	        }
	
	        // Check to see if we have a response for the expected dataType
	        if ( dataTypes[ 0 ] in responses ) {
	                finalDataType = dataTypes[ 0 ];
	        } else {
	                // Try convertible dataTypes
	                for ( type in responses ) {
	                        if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[0] ] ) {
	                                finalDataType = type;
	                                break;
	                        }
	                        if ( !firstDataType ) {
	                                firstDataType = type;
	                        }
	                }
	                // Or just use first one
	                finalDataType = finalDataType || firstDataType;
	        }
	
	        // If we found a dataType
	        // We add the dataType to the list if needed
	        // and return the corresponding response
	        if ( finalDataType ) {
	                if ( finalDataType !== dataTypes[ 0 ] ) {
	                        dataTypes.unshift( finalDataType );
	                }
	                return responses[ finalDataType ];
	        }
	}
	
	// Chain conversions given the request and the original response
	function ajaxConvert( s, response ) {
	
	        var conv, conv2, current, tmp,
	                // Work with a copy of dataTypes in case we need to modify it for conversion
	                dataTypes = s.dataTypes.slice(),
	                prev = dataTypes[ 0 ],
	                converters = {},
	                i = 0;
	
	        // Apply the dataFilter if provided
	        if ( s.dataFilter ) {
	                response = s.dataFilter( response, s.dataType );
	        }
	
	        // Create converters map with lowercased keys
	        if ( dataTypes[ 1 ] ) {
	                for ( conv in s.converters ) {
	                        converters[ conv.toLowerCase() ] = s.converters[ conv ];
	                }
	        }
	
	        // Convert to each sequential dataType, tolerating list modification
	        for ( ; (current = dataTypes[++i]); ) {
	
	                // There's only work to do if current dataType is non-auto
	                if ( current !== "*" ) {
	
	                        // Convert response if prev dataType is non-auto and differs from current
	                        if ( prev !== "*" && prev !== current ) {
	
	                                // Seek a direct converter
	                                conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
	                                // If none found, seek a pair
	                                if ( !conv ) {
	                                        for ( conv2 in converters ) {
	
	                                                // If conv2 outputs current
	                                                tmp = conv2.split(" ");
	                                                if ( tmp[ 1 ] === current ) {
	
	                                                        // If prev can be converted to accepted input
	                                                        conv = converters[ prev + " " + tmp[ 0 ] ] ||
	                                                                converters[ "* " + tmp[ 0 ] ];
	                                                        if ( conv ) {
	                                                                // Condense equivalence converters
	                                                                if ( conv === true ) {
	                                                                        conv = converters[ conv2 ];
	
	                                                                // Otherwise, insert the intermediate dataType
	                                                                } else if ( converters[ conv2 ] !== true ) {
	                                                                        current = tmp[ 0 ];
	                                                                        dataTypes.splice( i--, 0, current );
	                                                                }
	
	                                                                break;
	                                                        }
	                                                }
	                                        }
	                                }
	
	                                // Apply converter (if not an equivalence)
	                                if ( conv !== true ) {
	
	                                        // Unless errors are allowed to bubble, catch and return them
	                                        if ( conv && s["throws"] ) {
	                                                response = conv( response );
	                                        } else {
	                                                try {
	                                                        response = conv( response );
	                                                } catch ( e ) {
	                                                        return { state: "parsererror", error: conv ? e : "No conversion from " + prev + " to " + current };
	                                                }
	                                        }
	                                }
	                        }
	
	                        // Update prev for next iteration
	                        prev = current;
	                }
	        }
	
	        return { state: "success", data: response };
	}
	var oldCallbacks = [],
	        rquestion = /\?/,
	        rjsonp = /(=)\?(?=&|$)|\?\?/,
	        nonce = jQuery.now();
	
	// Default jsonp settings
	jQuery.ajaxSetup({
	        jsonp: "callback",
	        jsonpCallback: function() {
	                var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
	                this[ callback ] = true;
	                return callback;
	        }
	});
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
	        var callbackName, overwritten, responseContainer,
	                data = s.data,
	                url = s.url,
	                hasCallback = s.jsonp !== false,
	                replaceInUrl = hasCallback && rjsonp.test( url ),
	                replaceInData = hasCallback && !replaceInUrl && typeof data === "string" &&
	                        !( s.contentType || "" ).indexOf("application/x-www-form-urlencoded") &&
	                        rjsonp.test( data );
	
	        // Handle iff the expected data type is "jsonp" or we have a parameter to set
	        if ( s.dataTypes[ 0 ] === "jsonp" || replaceInUrl || replaceInData ) {
	
	                // Get callback name, remembering preexisting value associated with it
	                callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
	                        s.jsonpCallback() :
	                        s.jsonpCallback;
	                overwritten = window[ callbackName ];
	
	                // Insert callback into url or form data
	                if ( replaceInUrl ) {
	                        s.url = url.replace( rjsonp, "$1" + callbackName );
	                } else if ( replaceInData ) {
	                        s.data = data.replace( rjsonp, "$1" + callbackName );
	                } else if ( hasCallback ) {
	                        s.url += ( rquestion.test( url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
	                }
	
	                // Use data converter to retrieve json after script execution
	                s.converters["script json"] = function() {
	                        if ( !responseContainer ) {
	                                jQuery.error( callbackName + " was not called" );
	                        }
	                        return responseContainer[ 0 ];
	                };
	
	                // force json dataType
	                s.dataTypes[ 0 ] = "json";
	
	                // Install callback
	                window[ callbackName ] = function() {
	                        responseContainer = arguments;
	                };
	
	                // Clean-up function (fires after converters)
	                jqXHR.always(function() {
	                        // Restore preexisting value
	                        window[ callbackName ] = overwritten;
	
	                        // Save back as free
	                        if ( s[ callbackName ] ) {
	                                // make sure that re-using the options doesn't screw things around
	                                s.jsonpCallback = originalSettings.jsonpCallback;
	
	                                // save the callback name for future use
	                                oldCallbacks.push( callbackName );
	                        }
	
	                        // Call if it was a function and we have a response
	                        if ( responseContainer && jQuery.isFunction( overwritten ) ) {
	                                overwritten( responseContainer[ 0 ] );
	                        }
	
	                        responseContainer = overwritten = undefined;
	                });
	
	                // Delegate to script
	                return "script";
	        }
	});
	// Install script dataType
	jQuery.ajaxSetup({
	        accepts: {
	                script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
	        },
	        contents: {
	                script: /javascript|ecmascript/
	        },
	        converters: {
	                "text script": function( text ) {
	                        jQuery.globalEval( text );
	                        return text;
	                }
	        }
	});
	
	// Handle cache's special case and global
	jQuery.ajaxPrefilter( "script", function( s ) {
	        if ( s.cache === undefined ) {
	                s.cache = false;
	        }
	        if ( s.crossDomain ) {
	                s.type = "GET";
	                s.global = false;
	        }
	});
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function(s) {
	
	        // This transport only deals with cross domain requests
	        if ( s.crossDomain ) {
	
	                var script,
	                        head = document.head || document.getElementsByTagName( "head" )[0] || document.documentElement;
	
	                return {
	
	                        send: function( _, callback ) {
	
	                                script = document.createElement( "script" );
	
	                                script.async = "async";
	
	                                if ( s.scriptCharset ) {
	                                        script.charset = s.scriptCharset;
	                                }
	
	                                script.src = s.url;
	
	                                // Attach handlers for all browsers
	                                script.onload = script.onreadystatechange = function( _, isAbort ) {
	
	                                        if ( isAbort || !script.readyState || /loaded|complete/.test( script.readyState ) ) {
	
	                                                // Handle memory leak in IE
	                                                script.onload = script.onreadystatechange = null;
	
	                                                // Remove the script
	                                                if ( head && script.parentNode ) {
	                                                        head.removeChild( script );
	                                                }
	
	                                                // Dereference the script
	                                                script = undefined;
	
	                                                // Callback if not abort
	                                                if ( !isAbort ) {
	                                                        callback( 200, "success" );
	                                                }
	                                        }
	                                };
	                                // Use insertBefore instead of appendChild  to circumvent an IE6 bug.
	                                // This arises when a base node is used (#2709 and #4378).
	                                head.insertBefore( script, head.firstChild );
	                        },
	
	                        abort: function() {
	                                if ( script ) {
	                                        script.onload( 0, 1 );
	                                }
	                        }
	                };
	        }
	});
	var xhrCallbacks,
	        // #5280: Internet Explorer will keep connections alive if we don't abort on unload
	        xhrOnUnloadAbort = window.ActiveXObject ? function() {
	                // Abort all pending requests
	                for ( var key in xhrCallbacks ) {
	                        xhrCallbacks[ key ]( 0, 1 );
	                }
	        } : false,
	        xhrId = 0;
	
	// Functions to create xhrs
	function createStandardXHR() {
	        try {
	                return new window.XMLHttpRequest();
	        } catch( e ) {}
	}
	
	function createActiveXHR() {
	        try {
	                return new window.ActiveXObject( "Microsoft.XMLHTTP" );
	        } catch( e ) {}
	}
	
	// Create the request object
	// (This is still attached to ajaxSettings for backward compatibility)
	jQuery.ajaxSettings.xhr = window.ActiveXObject ?
	        /* Microsoft failed to properly
	         * implement the XMLHttpRequest in IE7 (can't request local files),
	         * so we use the ActiveXObject when it is available
	         * Additionally XMLHttpRequest can be disabled in IE7/IE8 so
	         * we need a fallback.
	         */
	        function() {
	                return !this.isLocal && createStandardXHR() || createActiveXHR();
	        } :
	        // For all other browsers, use the standard XMLHttpRequest object
	        createStandardXHR;
	
	// Determine support properties
	(function( xhr ) {
	        jQuery.extend( jQuery.support, {
	                ajax: !!xhr,
	                cors: !!xhr && ( "withCredentials" in xhr )
	        });
	})( jQuery.ajaxSettings.xhr() );
	
	// Create transport if the browser can provide an xhr
	if ( jQuery.support.ajax ) {
	
	        jQuery.ajaxTransport(function( s ) {
	                // Cross domain only allowed if supported through XMLHttpRequest
	                if ( !s.crossDomain || jQuery.support.cors ) {
	
	                        var callback;
	
	                        return {
	                                send: function( headers, complete ) {
	
	                                        // Get a new xhr
	                                        var handle, i,
	                                                xhr = s.xhr();
	
	                                        // Open the socket
	                                        // Passing null username, generates a login popup on Opera (#2865)
	                                        if ( s.username ) {
	                                                xhr.open( s.type, s.url, s.async, s.username, s.password );
	                                        } else {
	                                                xhr.open( s.type, s.url, s.async );
	                                        }
	
	                                        // Apply custom fields if provided
	                                        if ( s.xhrFields ) {
	                                                for ( i in s.xhrFields ) {
	                                                        xhr[ i ] = s.xhrFields[ i ];
	                                                }
	                                        }
	
	                                        // Override mime type if needed
	                                        if ( s.mimeType && xhr.overrideMimeType ) {
	                                                xhr.overrideMimeType( s.mimeType );
	                                        }
	
	                                        // X-Requested-With header
	                                        // For cross-domain requests, seeing as conditions for a preflight are
	                                        // akin to a jigsaw puzzle, we simply never set it to be sure.
	                                        // (it can always be set on a per-request basis or even using ajaxSetup)
	                                        // For same-domain requests, won't change header if already provided.
	                                        if ( !s.crossDomain && !headers["X-Requested-With"] ) {
	                                                headers[ "X-Requested-With" ] = "XMLHttpRequest";
	                                        }
	
	                                        // Need an extra try/catch for cross domain requests in Firefox 3
	                                        try {
	                                                for ( i in headers ) {
	                                                        xhr.setRequestHeader( i, headers[ i ] );
	                                                }
	                                        } catch( _ ) {}
	
	                                        // Do send the request
	                                        // This may raise an exception which is actually
	                                        // handled in jQuery.ajax (so no try/catch here)
	                                        xhr.send( ( s.hasContent && s.data ) || null );
	
	                                        // Listener
	                                        callback = function( _, isAbort ) {
	
	                                                var status,
	                                                        statusText,
	                                                        responseHeaders,
	                                                        responses,
	                                                        xml;
	
	                                                // Firefox throws exceptions when accessing properties
	                                                // of an xhr when a network error occurred
	                                                // http://helpful.knobs-dials.com/index.php/Component_returned_failure_code:_0x80040111_(NS_ERROR_NOT_AVAILABLE)
	                                                try {
	
	                                                        // Was never called and is aborted or complete
	                                                        if ( callback && ( isAbort || xhr.readyState === 4 ) ) {
	
	                                                                // Only called once
	                                                                callback = undefined;
	
	                                                                // Do not keep as active anymore
	                                                                if ( handle ) {
	                                                                        xhr.onreadystatechange = jQuery.noop;
	                                                                        if ( xhrOnUnloadAbort ) {
	                                                                                delete xhrCallbacks[ handle ];
	                                                                        }
	                                                                }
	
	                                                                // If it's an abort
	                                                                if ( isAbort ) {
	                                                                        // Abort it manually if needed
	                                                                        if ( xhr.readyState !== 4 ) {
	                                                                                xhr.abort();
	                                                                        }
	                                                                } else {
	                                                                        status = xhr.status;
	                                                                        responseHeaders = xhr.getAllResponseHeaders();
	                                                                        responses = {};
	                                                                        xml = xhr.responseXML;
	
	                                                                        // Construct response list
	                                                                        if ( xml && xml.documentElement /* #4958 */ ) {
	                                                                                responses.xml = xml;
	                                                                        }
	
	                                                                        // When requesting binary data, IE6-9 will throw an exception
	                                                                        // on any attempt to access responseText (#11426)
	                                                                        try {
	                                                                                responses.text = xhr.responseText;
	                                                                        } catch( e ) {
	                                                                        }
	
	                                                                        // Firefox throws an exception when accessing
	                                                                        // statusText for faulty cross-domain requests
	                                                                        try {
	                                                                                statusText = xhr.statusText;
	                                                                        } catch( e ) {
	                                                                                // We normalize with Webkit giving an empty statusText
	                                                                                statusText = "";
	                                                                        }
	
	                                                                        // Filter status for non standard behaviors
	
	                                                                        // If the request is local and we have data: assume a success
	                                                                        // (success with no data won't get notified, that's the best we
	                                                                        // can do given current implementations)
	                                                                        if ( !status && s.isLocal && !s.crossDomain ) {
	                                                                                status = responses.text ? 200 : 404;
	                                                                        // IE - #1450: sometimes returns 1223 when it should be 204
	                                                                        } else if ( status === 1223 ) {
	                                                                                status = 204;
	                                                                        }
	                                                                }
	                                                        }
	                                                } catch( firefoxAccessException ) {
	                                                        if ( !isAbort ) {
	                                                                complete( -1, firefoxAccessException );
	                                                        }
	                                                }
	
	                                                // Call complete if needed
	                                                if ( responses ) {
	                                                        complete( status, statusText, responses, responseHeaders );
	                                                }
	                                        };
	
	                                        if ( !s.async ) {
	                                                // if we're in sync mode we fire the callback
	                                                callback();
	                                        } else if ( xhr.readyState === 4 ) {
	                                                // (IE6 & IE7) if it's in cache and has been
	                                                // retrieved directly we need to fire the callback
	                                                setTimeout( callback, 0 );
	                                        } else {
	                                                handle = ++xhrId;
	                                                if ( xhrOnUnloadAbort ) {
	                                                        // Create the active xhrs callbacks list if needed
	                                                        // and attach the unload handler
	                                                        if ( !xhrCallbacks ) {
	                                                                xhrCallbacks = {};
	                                                                jQuery( window ).unload( xhrOnUnloadAbort );
	                                                        }
	                                                        // Add to list of active xhrs callbacks
	                                                        xhrCallbacks[ handle ] = callback;
	                                                }
	                                                xhr.onreadystatechange = callback;
	                                        }
	                                },
	
	                                abort: function() {
	                                        if ( callback ) {
	                                                callback(0,1);
	                                        }
	                                }
	                        };
	                }
	        });
	}
	var fxNow, timerId,
	        rfxtypes = /^(?:toggle|show|hide)$/,
	        rfxnum = new RegExp( "^(?:([-+])=|)(" + core_pnum + ")([a-z%]*)$", "i" ),
	        rrun = /queueHooks$/,
	        animationPrefilters = [ defaultPrefilter ],
	        tweeners = {
	                "*": [function( prop, value ) {
	                        var end, unit,
	                                tween = this.createTween( prop, value ),
	                                parts = rfxnum.exec( value ),
	                                target = tween.cur(),
	                                start = +target || 0,
	                                scale = 1,
	                                maxIterations = 20;
	
	                        if ( parts ) {
	                                end = +parts[2];
	                                unit = parts[3] || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	
	                                // We need to compute starting value
	                                if ( unit !== "px" && start ) {
	                                        // Iteratively approximate from a nonzero starting point
	                                        // Prefer the current property, because this process will be trivial if it uses the same units
	                                        // Fallback to end or a simple constant
	                                        start = jQuery.css( tween.elem, prop, true ) || end || 1;
	
	                                        do {
	                                                // If previous iteration zeroed out, double until we get *something*
	                                                // Use a string for doubling factor so we don't accidentally see scale as unchanged below
	                                                scale = scale || ".5";
	
	                                                // Adjust and apply
	                                                start = start / scale;
	                                                jQuery.style( tween.elem, prop, start + unit );
	
	                                        // Update scale, tolerating zero or NaN from tween.cur()
	                                        // And breaking the loop if scale is unchanged or perfect, or if we've just had enough
	                                        } while ( scale !== (scale = tween.cur() / target) && scale !== 1 && --maxIterations );
	                                }
	
	                                tween.unit = unit;
	                                tween.start = start;
	                                // If a +=/-= token was provided, we're doing a relative animation
	                                tween.end = parts[1] ? start + ( parts[1] + 1 ) * end : end;
	                        }
	                        return tween;
	                }]
	        };
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
	        setTimeout(function() {
	                fxNow = undefined;
	        }, 0 );
	        return ( fxNow = jQuery.now() );
	}
	
	function createTweens( animation, props ) {
	        jQuery.each( props, function( prop, value ) {
	                var collection = ( tweeners[ prop ] || [] ).concat( tweeners[ "*" ] ),
	                        index = 0,
	                        length = collection.length;
	                for ( ; index < length; index++ ) {
	                        if ( collection[ index ].call( animation, prop, value ) ) {
	
	                                // we're done with this property
	                                return;
	                        }
	                }
	        });
	}
	
	function Animation( elem, properties, options ) {
	        var result,
	                index = 0,
	                tweenerIndex = 0,
	                length = animationPrefilters.length,
	                deferred = jQuery.Deferred().always( function() {
	                        // don't match elem in the :animated selector
	                        delete tick.elem;
	                }),
	                tick = function() {
	                        var currentTime = fxNow || createFxNow(),
	                                remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	                                // archaic crash bug won't allow us to use 1 - ( 0.5 || 0 ) (#12497)
	                                temp = remaining / animation.duration || 0,
	                                percent = 1 - temp,
	                                index = 0,
	                                length = animation.tweens.length;
	
	                        for ( ; index < length ; index++ ) {
	                                animation.tweens[ index ].run( percent );
	                        }
	
	                        deferred.notifyWith( elem, [ animation, percent, remaining ]);
	
	                        if ( percent < 1 && length ) {
	                                return remaining;
	                        } else {
	                                deferred.resolveWith( elem, [ animation ] );
	                                return false;
	                        }
	                },
	                animation = deferred.promise({
	                        elem: elem,
	                        props: jQuery.extend( {}, properties ),
	                        opts: jQuery.extend( true, { specialEasing: {} }, options ),
	                        originalProperties: properties,
	                        originalOptions: options,
	                        startTime: fxNow || createFxNow(),
	                        duration: options.duration,
	                        tweens: [],
	                        createTween: function( prop, end, easing ) {
	                                var tween = jQuery.Tween( elem, animation.opts, prop, end,
	                                                animation.opts.specialEasing[ prop ] || animation.opts.easing );
	                                animation.tweens.push( tween );
	                                return tween;
	                        },
	                        stop: function( gotoEnd ) {
	                                var index = 0,
	                                        // if we are going to the end, we want to run all the tweens
	                                        // otherwise we skip this part
	                                        length = gotoEnd ? animation.tweens.length : 0;
	
	                                for ( ; index < length ; index++ ) {
	                                        animation.tweens[ index ].run( 1 );
	                                }
	
	                                // resolve when we played the last frame
	                                // otherwise, reject
	                                if ( gotoEnd ) {
	                                        deferred.resolveWith( elem, [ animation, gotoEnd ] );
	                                } else {
	                                        deferred.rejectWith( elem, [ animation, gotoEnd ] );
	                                }
	                                return this;
	                        }
	                }),
	                props = animation.props;
	
	        propFilter( props, animation.opts.specialEasing );
	
	        for ( ; index < length ; index++ ) {
	                result = animationPrefilters[ index ].call( animation, elem, props, animation.opts );
	                if ( result ) {
	                        return result;
	                }
	        }
	
	        createTweens( animation, props );
	
	        if ( jQuery.isFunction( animation.opts.start ) ) {
	                animation.opts.start.call( elem, animation );
	        }
	
	        jQuery.fx.timer(
	                jQuery.extend( tick, {
	                        anim: animation,
	                        queue: animation.opts.queue,
	                        elem: elem
	                })
	        );
	
	        // attach callbacks from options
	        return animation.progress( animation.opts.progress )
	                .done( animation.opts.done, animation.opts.complete )
	                .fail( animation.opts.fail )
	                .always( animation.opts.always );
	}
	
	function propFilter( props, specialEasing ) {
	        var index, name, easing, value, hooks;
	
	        // camelCase, specialEasing and expand cssHook pass
	        for ( index in props ) {
	                name = jQuery.camelCase( index );
	                easing = specialEasing[ name ];
	                value = props[ index ];
	                if ( jQuery.isArray( value ) ) {
	                        easing = value[ 1 ];
	                        value = props[ index ] = value[ 0 ];
	                }
	
	                if ( index !== name ) {
	                        props[ name ] = value;
	                        delete props[ index ];
	                }
	
	                hooks = jQuery.cssHooks[ name ];
	                if ( hooks && "expand" in hooks ) {
	                        value = hooks.expand( value );
	                        delete props[ name ];
	
	                        // not quite $.extend, this wont overwrite keys already present.
	                        // also - reusing 'index' from above because we have the correct "name"
	                        for ( index in value ) {
	                                if ( !( index in props ) ) {
	                                        props[ index ] = value[ index ];
	                                        specialEasing[ index ] = easing;
	                                }
	                        }
	                } else {
	                        specialEasing[ name ] = easing;
	                }
	        }
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
	        tweener: function( props, callback ) {
	                if ( jQuery.isFunction( props ) ) {
	                        callback = props;
	                        props = [ "*" ];
	                } else {
	                        props = props.split(" ");
	                }
	
	                var prop,
	                        index = 0,
	                        length = props.length;
	
	                for ( ; index < length ; index++ ) {
	                        prop = props[ index ];
	                        tweeners[ prop ] = tweeners[ prop ] || [];
	                        tweeners[ prop ].unshift( callback );
	                }
	        },
	
	        prefilter: function( callback, prepend ) {
	                if ( prepend ) {
	                        animationPrefilters.unshift( callback );
	                } else {
	                        animationPrefilters.push( callback );
	                }
	        }
	});
	
	function defaultPrefilter( elem, props, opts ) {
	        var index, prop, value, length, dataShow, toggle, tween, hooks, oldfire,
	                anim = this,
	                style = elem.style,
	                orig = {},
	                handled = [],
	                hidden = elem.nodeType && isHidden( elem );
	
	        // handle queue: false promises
	        if ( !opts.queue ) {
	                hooks = jQuery._queueHooks( elem, "fx" );
	                if ( hooks.unqueued == null ) {
	                        hooks.unqueued = 0;
	                        oldfire = hooks.empty.fire;
	                        hooks.empty.fire = function() {
	                                if ( !hooks.unqueued ) {
	                                        oldfire();
	                                }
	                        };
	                }
	                hooks.unqueued++;
	
	                anim.always(function() {
	                        // doing this makes sure that the complete handler will be called
	                        // before this completes
	                        anim.always(function() {
	                                hooks.unqueued--;
	                                if ( !jQuery.queue( elem, "fx" ).length ) {
	                                        hooks.empty.fire();
	                                }
	                        });
	                });
	        }
	
	        // height/width overflow pass
	        if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {
	                // Make sure that nothing sneaks out
	                // Record all 3 overflow attributes because IE does not
	                // change the overflow attribute when overflowX and
	                // overflowY are set to the same value
	                opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
	                // Set display property to inline-block for height/width
	                // animations on inline elements that are having width/height animated
	                if ( jQuery.css( elem, "display" ) === "inline" &&
	                                jQuery.css( elem, "float" ) === "none" ) {
	
	                        // inline-level elements accept inline-block;
	                        // block-level elements need to be inline with layout
	                        if ( !jQuery.support.inlineBlockNeedsLayout || css_defaultDisplay( elem.nodeName ) === "inline" ) {
	                                style.display = "inline-block";
	
	                        } else {
	                                style.zoom = 1;
	                        }
	                }
	        }
	
	        if ( opts.overflow ) {
	                style.overflow = "hidden";
	                if ( !jQuery.support.shrinkWrapBlocks ) {
	                        anim.done(function() {
	                                style.overflow = opts.overflow[ 0 ];
	                                style.overflowX = opts.overflow[ 1 ];
	                                style.overflowY = opts.overflow[ 2 ];
	                        });
	                }
	        }
	
	
	        // show/hide pass
	        for ( index in props ) {
	                value = props[ index ];
	                if ( rfxtypes.exec( value ) ) {
	                        delete props[ index ];
	                        toggle = toggle || value === "toggle";
	                        if ( value === ( hidden ? "hide" : "show" ) ) {
	                                continue;
	                        }
	                        handled.push( index );
	                }
	        }
	
	        length = handled.length;
	        if ( length ) {
	                dataShow = jQuery._data( elem, "fxshow" ) || jQuery._data( elem, "fxshow", {} );
	                if ( "hidden" in dataShow ) {
	                        hidden = dataShow.hidden;
	                }
	
	                // store state if its toggle - enables .stop().toggle() to "reverse"
	                if ( toggle ) {
	                        dataShow.hidden = !hidden;
	                }
	                if ( hidden ) {
	                        jQuery( elem ).show();
	                } else {
	                        anim.done(function() {
	                                jQuery( elem ).hide();
	                        });
	                }
	                anim.done(function() {
	                        var prop;
	                        jQuery.removeData( elem, "fxshow", true );
	                        for ( prop in orig ) {
	                                jQuery.style( elem, prop, orig[ prop ] );
	                        }
	                });
	                for ( index = 0 ; index < length ; index++ ) {
	                        prop = handled[ index ];
	                        tween = anim.createTween( prop, hidden ? dataShow[ prop ] : 0 );
	                        orig[ prop ] = dataShow[ prop ] || jQuery.style( elem, prop );
	
	                        if ( !( prop in dataShow ) ) {
	                                dataShow[ prop ] = tween.start;
	                                if ( hidden ) {
	                                        tween.end = tween.start;
	                                        tween.start = prop === "width" || prop === "height" ? 1 : 0;
	                                }
	                        }
	                }
	        }
	}
	
	function Tween( elem, options, prop, end, easing ) {
	        return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
	        constructor: Tween,
	        init: function( elem, options, prop, end, easing, unit ) {
	                this.elem = elem;
	                this.prop = prop;
	                this.easing = easing || "swing";
	                this.options = options;
	                this.start = this.now = this.cur();
	                this.end = end;
	                this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	        },
	        cur: function() {
	                var hooks = Tween.propHooks[ this.prop ];
	
	                return hooks && hooks.get ?
	                        hooks.get( this ) :
	                        Tween.propHooks._default.get( this );
	        },
	        run: function( percent ) {
	                var eased,
	                        hooks = Tween.propHooks[ this.prop ];
	
	                if ( this.options.duration ) {
	                        this.pos = eased = jQuery.easing[ this.easing ](
	                                percent, this.options.duration * percent, 0, 1, this.options.duration
	                        );
	                } else {
	                        this.pos = eased = percent;
	                }
	                this.now = ( this.end - this.start ) * eased + this.start;
	
	                if ( this.options.step ) {
	                        this.options.step.call( this.elem, this.now, this );
	                }
	
	                if ( hooks && hooks.set ) {
	                        hooks.set( this );
	                } else {
	                        Tween.propHooks._default.set( this );
	                }
	                return this;
	        }
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
	        _default: {
	                get: function( tween ) {
	                        var result;
	
	                        if ( tween.elem[ tween.prop ] != null &&
	                                (!tween.elem.style || tween.elem.style[ tween.prop ] == null) ) {
	                                return tween.elem[ tween.prop ];
	                        }
	
	                        // passing any value as a 4th parameter to .css will automatically
	                        // attempt a parseFloat and fallback to a string if the parse fails
	                        // so, simple values such as "10px" are parsed to Float.
	                        // complex values such as "rotate(1rad)" are returned as is.
	                        result = jQuery.css( tween.elem, tween.prop, false, "" );
	                        // Empty strings, null, undefined and "auto" are converted to 0.
	                        return !result || result === "auto" ? 0 : result;
	                },
	                set: function( tween ) {
	                        // use step hook for back compat - use cssHook if its there - use .style if its
	                        // available and use plain properties where available
	                        if ( jQuery.fx.step[ tween.prop ] ) {
	                                jQuery.fx.step[ tween.prop ]( tween );
	                        } else if ( tween.elem.style && ( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null || jQuery.cssHooks[ tween.prop ] ) ) {
	                                jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
	                        } else {
	                                tween.elem[ tween.prop ] = tween.now;
	                        }
	                }
	        }
	};
	
	// Remove in 2.0 - this supports IE8's panic based approach
	// to setting things on disconnected nodes
	
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	        set: function( tween ) {
	                if ( tween.elem.nodeType && tween.elem.parentNode ) {
	                        tween.elem[ tween.prop ] = tween.now;
	                }
	        }
	};
	
	jQuery.each([ "toggle", "show", "hide" ], function( i, name ) {
	        var cssFn = jQuery.fn[ name ];
	        jQuery.fn[ name ] = function( speed, easing, callback ) {
	                return speed == null || typeof speed === "boolean" ||
	                        // special check for .toggle( handler, handler, ... )
	                        ( !i && jQuery.isFunction( speed ) && jQuery.isFunction( easing ) ) ?
	                        cssFn.apply( this, arguments ) :
	                        this.animate( genFx( name, true ), speed, easing, callback );
	        };
	});
	
	jQuery.fn.extend({
	        fadeTo: function( speed, to, easing, callback ) {
	
	                // show any hidden elements after setting opacity to 0
	                return this.filter( isHidden ).css( "opacity", 0 ).show()
	
	                        // animate to the value specified
	                        .end().animate({ opacity: to }, speed, easing, callback );
	        },
	        animate: function( prop, speed, easing, callback ) {
	                var empty = jQuery.isEmptyObject( prop ),
	                        optall = jQuery.speed( speed, easing, callback ),
	                        doAnimation = function() {
	                                // Operate on a copy of prop so per-property easing won't be lost
	                                var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
	                                // Empty animations resolve immediately
	                                if ( empty ) {
	                                        anim.stop( true );
	                                }
	                        };
	
	                return empty || optall.queue === false ?
	                        this.each( doAnimation ) :
	                        this.queue( optall.queue, doAnimation );
	        },
	        stop: function( type, clearQueue, gotoEnd ) {
	                var stopQueue = function( hooks ) {
	                        var stop = hooks.stop;
	                        delete hooks.stop;
	                        stop( gotoEnd );
	                };
	
	                if ( typeof type !== "string" ) {
	                        gotoEnd = clearQueue;
	                        clearQueue = type;
	                        type = undefined;
	                }
	                if ( clearQueue && type !== false ) {
	                        this.queue( type || "fx", [] );
	                }
	
	                return this.each(function() {
	                        var dequeue = true,
	                                index = type != null && type + "queueHooks",
	                                timers = jQuery.timers,
	                                data = jQuery._data( this );
	
	                        if ( index ) {
	                                if ( data[ index ] && data[ index ].stop ) {
	                                        stopQueue( data[ index ] );
	                                }
	                        } else {
	                                for ( index in data ) {
	                                        if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
	                                                stopQueue( data[ index ] );
	                                        }
	                                }
	                        }
	
	                        for ( index = timers.length; index--; ) {
	                                if ( timers[ index ].elem === this && (type == null || timers[ index ].queue === type) ) {
	                                        timers[ index ].anim.stop( gotoEnd );
	                                        dequeue = false;
	                                        timers.splice( index, 1 );
	                                }
	                        }
	
	                        // start the next in the queue if the last step wasn't forced
	                        // timers currently will call their complete callbacks, which will dequeue
	                        // but only if they were gotoEnd
	                        if ( dequeue || !gotoEnd ) {
	                                jQuery.dequeue( this, type );
	                        }
	                });
	        }
	});
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
	        var which,
	                attrs = { height: type },
	                i = 0;
	
	        // if we include width, step value is 1 to do all cssExpand values,
	        // if we don't include width, step value is 2 to skip over Left and Right
	        includeWidth = includeWidth? 1 : 0;
	        for( ; i < 4 ; i += 2 - includeWidth ) {
	                which = cssExpand[ i ];
	                attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	        }
	
	        if ( includeWidth ) {
	                attrs.opacity = attrs.width = type;
	        }
	
	        return attrs;
	}
	
	// Generate shortcuts for custom animations
	jQuery.each({
	        slideDown: genFx("show"),
	        slideUp: genFx("hide"),
	        slideToggle: genFx("toggle"),
	        fadeIn: { opacity: "show" },
	        fadeOut: { opacity: "hide" },
	        fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
	        jQuery.fn[ name ] = function( speed, easing, callback ) {
	                return this.animate( props, speed, easing, callback );
	        };
	});
	
	jQuery.speed = function( speed, easing, fn ) {
	        var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
	                complete: fn || !fn && easing ||
	                        jQuery.isFunction( speed ) && speed,
	                duration: speed,
	                easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	        };
	
	        opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ? opt.duration :
	                opt.duration in jQuery.fx.speeds ? jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;
	
	        // normalize opt.queue - true/undefined/null -> "fx"
	        if ( opt.queue == null || opt.queue === true ) {
	                opt.queue = "fx";
	        }
	
	        // Queueing
	        opt.old = opt.complete;
	
	        opt.complete = function() {
	                if ( jQuery.isFunction( opt.old ) ) {
	                        opt.old.call( this );
	                }
	
	                if ( opt.queue ) {
	                        jQuery.dequeue( this, opt.queue );
	                }
	        };
	
	        return opt;
	};
	
	jQuery.easing = {
	        linear: function( p ) {
	                return p;
	        },
	        swing: function( p ) {
	                return 0.5 - Math.cos( p*Math.PI ) / 2;
	        }
	};
	
	jQuery.timers = [];
	jQuery.fx = Tween.prototype.init;
	jQuery.fx.tick = function() {
	        var timer,
	                timers = jQuery.timers,
	                i = 0;
	
	        fxNow = jQuery.now();
	
	        for ( ; i < timers.length; i++ ) {
	                timer = timers[ i ];
	                // Checks the timer has not already been removed
	                if ( !timer() && timers[ i ] === timer ) {
	                        timers.splice( i--, 1 );
	                }
	        }
	
	        if ( !timers.length ) {
	                jQuery.fx.stop();
	        }
	        fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
	        if ( timer() && jQuery.timers.push( timer ) && !timerId ) {
	                timerId = setInterval( jQuery.fx.tick, jQuery.fx.interval );
	        }
	};
	
	jQuery.fx.interval = 13;
	
	jQuery.fx.stop = function() {
	        clearInterval( timerId );
	        timerId = null;
	};
	
	jQuery.fx.speeds = {
	        slow: 600,
	        fast: 200,
	        // Default speed
	        _default: 400
	};
	
	// Back Compat <1.8 extension point
	jQuery.fx.step = {};
	
	if ( jQuery.expr && jQuery.expr.filters ) {
	        jQuery.expr.filters.animated = function( elem ) {
	                return jQuery.grep(jQuery.timers, function( fn ) {
	                        return elem === fn.elem;
	                }).length;
	        };
	}
	var rroot = /^(?:body|html)$/i;
	
	jQuery.fn.offset = function( options ) {
	        if ( arguments.length ) {
	                return options === undefined ?
	                        this :
	                        this.each(function( i ) {
	                                jQuery.offset.setOffset( this, options, i );
	                        });
	        }
	
	        var docElem, body, win, clientTop, clientLeft, scrollTop, scrollLeft,
	                box = { top: 0, left: 0 },
	                elem = this[ 0 ],
	                doc = elem && elem.ownerDocument;
	
	        if ( !doc ) {
	                return;
	        }
	
	        if ( (body = doc.body) === elem ) {
	                return jQuery.offset.bodyOffset( elem );
	        }
	
	        docElem = doc.documentElement;
	
	        // Make sure it's not a disconnected DOM node
	        if ( !jQuery.contains( docElem, elem ) ) {
	                return box;
	        }
	
	        // If we don't have gBCR, just use 0,0 rather than error
	        // BlackBerry 5, iOS 3 (original iPhone)
	        if ( typeof elem.getBoundingClientRect !== "undefined" ) {
	                box = elem.getBoundingClientRect();
	        }
	        win = getWindow( doc );
	        clientTop  = docElem.clientTop  || body.clientTop  || 0;
	        clientLeft = docElem.clientLeft || body.clientLeft || 0;
	        scrollTop  = win.pageYOffset || docElem.scrollTop;
	        scrollLeft = win.pageXOffset || docElem.scrollLeft;
	        return {
	                top: box.top  + scrollTop  - clientTop,
	                left: box.left + scrollLeft - clientLeft
	        };
	};
	
	jQuery.offset = {
	
	        bodyOffset: function( body ) {
	                var top = body.offsetTop,
	                        left = body.offsetLeft;
	
	                if ( jQuery.support.doesNotIncludeMarginInBodyOffset ) {
	                        top  += parseFloat( jQuery.css(body, "marginTop") ) || 0;
	                        left += parseFloat( jQuery.css(body, "marginLeft") ) || 0;
	                }
	
	                return { top: top, left: left };
	        },
	
	        setOffset: function( elem, options, i ) {
	                var position = jQuery.css( elem, "position" );
	
	                // set position first, in-case top/left are set even on static elem
	                if ( position === "static" ) {
	                        elem.style.position = "relative";
	                }
	
	                var curElem = jQuery( elem ),
	                        curOffset = curElem.offset(),
	                        curCSSTop = jQuery.css( elem, "top" ),
	                        curCSSLeft = jQuery.css( elem, "left" ),
	                        calculatePosition = ( position === "absolute" || position === "fixed" ) && jQuery.inArray("auto", [curCSSTop, curCSSLeft]) > -1,
	                        props = {}, curPosition = {}, curTop, curLeft;
	
	                // need to be able to calculate position if either top or left is auto and position is either absolute or fixed
	                if ( calculatePosition ) {
	                        curPosition = curElem.position();
	                        curTop = curPosition.top;
	                        curLeft = curPosition.left;
	                } else {
	                        curTop = parseFloat( curCSSTop ) || 0;
	                        curLeft = parseFloat( curCSSLeft ) || 0;
	                }
	
	                if ( jQuery.isFunction( options ) ) {
	                        options = options.call( elem, i, curOffset );
	                }
	
	                if ( options.top != null ) {
	                        props.top = ( options.top - curOffset.top ) + curTop;
	                }
	                if ( options.left != null ) {
	                        props.left = ( options.left - curOffset.left ) + curLeft;
	                }
	
	                if ( "using" in options ) {
	                        options.using.call( elem, props );
	                } else {
	                        curElem.css( props );
	                }
	        }
	};
	
	
	jQuery.fn.extend({
	
	        position: function() {
	                if ( !this[0] ) {
	                        return;
	                }
	
	                var elem = this[0],
	
	                // Get *real* offsetParent
	                offsetParent = this.offsetParent(),
	
	                // Get correct offsets
	                offset       = this.offset(),
	                parentOffset = rroot.test(offsetParent[0].nodeName) ? { top: 0, left: 0 } : offsetParent.offset();
	
	                // Subtract element margins
	                // note: when an element has margin: auto the offsetLeft and marginLeft
	                // are the same in Safari causing offset.left to incorrectly be 0
	                offset.top  -= parseFloat( jQuery.css(elem, "marginTop") ) || 0;
	                offset.left -= parseFloat( jQuery.css(elem, "marginLeft") ) || 0;
	
	                // Add offsetParent borders
	                parentOffset.top  += parseFloat( jQuery.css(offsetParent[0], "borderTopWidth") ) || 0;
	                parentOffset.left += parseFloat( jQuery.css(offsetParent[0], "borderLeftWidth") ) || 0;
	
	                // Subtract the two offsets
	                return {
	                        top:  offset.top  - parentOffset.top,
	                        left: offset.left - parentOffset.left
	                };
	        },
	
	        offsetParent: function() {
	                return this.map(function() {
	                        var offsetParent = this.offsetParent || document.body;
	                        while ( offsetParent && (!rroot.test(offsetParent.nodeName) && jQuery.css(offsetParent, "position") === "static") ) {
	                                offsetParent = offsetParent.offsetParent;
	                        }
	                        return offsetParent || document.body;
	                });
	        }
	});
	
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( {scrollLeft: "pageXOffset", scrollTop: "pageYOffset"}, function( method, prop ) {
	        var top = /Y/.test( prop );
	
	        jQuery.fn[ method ] = function( val ) {
	                return jQuery.access( this, function( elem, method, val ) {
	                        var win = getWindow( elem );
	
	                        if ( val === undefined ) {
	                                return win ? (prop in win) ? win[ prop ] :
	                                        win.document.documentElement[ method ] :
	                                        elem[ method ];
	                        }
	
	                        if ( win ) {
	                                win.scrollTo(
	                                        !top ? val : jQuery( win ).scrollLeft(),
	                                         top ? val : jQuery( win ).scrollTop()
	                                );
	
	                        } else {
	                                elem[ method ] = val;
	                        }
	                }, method, val, arguments.length, null );
	        };
	});
	
	function getWindow( elem ) {
	        return jQuery.isWindow( elem ) ?
	                elem :
	                elem.nodeType === 9 ?
	                        elem.defaultView || elem.parentWindow :
	                        false;
	}
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	        jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name }, function( defaultExtra, funcName ) {
	                // margin is only for outerHeight, outerWidth
	                jQuery.fn[ funcName ] = function( margin, value ) {
	                        var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
	                                extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
	                        return jQuery.access( this, function( elem, type, value ) {
	                                var doc;
	
	                                if ( jQuery.isWindow( elem ) ) {
	                                        // As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
	                                        // isn't a whole lot we can do. See pull request at this URL for discussion:
	                                        // https://github.com/jquery/jquery/pull/764
	                                        return elem.document.documentElement[ "client" + name ];
	                                }
	
	                                // Get document width or height
	                                if ( elem.nodeType === 9 ) {
	                                        doc = elem.documentElement;
	
	                                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height], whichever is greatest
	                                        // unfortunately, this causes bug #3838 in IE6/8 only, but there is currently no good, small way to fix it.
	                                        return Math.max(
	                                                elem.body[ "scroll" + name ], doc[ "scroll" + name ],
	                                                elem.body[ "offset" + name ], doc[ "offset" + name ],
	                                                doc[ "client" + name ]
	                                        );
	                                }
	
	                                return value === undefined ?
	                                        // Get width or height on the element, requesting but not forcing parseFloat
	                                        jQuery.css( elem, type, value, extra ) :
	
	                                        // Set width or height on the element
	                                        jQuery.style( elem, type, value, extra );
	                        }, type, chainable ? margin : undefined, chainable, null );
	                };
	        });
	});
	// Expose jQuery to the global object
	window.jQuery = window.$ = jQuery;
	
	// Expose jQuery as an AMD module, but only for AMD loaders that
	// understand the issues with loading multiple versions of jQuery
	// in a page that all might call define(). The loader will indicate
	// they have special allowances for multiple jQuery versions by
	// specifying define.amd.jQuery = true. Register as a named module,
	// since jQuery can be concatenated with other files that may use define,
	// but not use a proper concatenation script that understands anonymous
	// AMD modules. A named AMD is safest and most robust way to register.
	// Lowercase jquery is used because AMD module names are derived from
	// file names, and jQuery is normally delivered in a lowercase file name.
	// Do this after creating the global so that if an AMD module wants to call
	// noConflict to hide this version of jQuery, it will work.
	if ( "function" === "function" && __webpack_require__(4) && __webpack_require__(4).jQuery ) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () { return jQuery; }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	})( window );


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {"jQuery":true}))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($, jQuery) {/**
	 * @filename cloud
	 * @filetype {object}
	 * @filedescription "system core class"
	 * @filereturn {function} cloud
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  __webpack_require__(1);
	  __webpack_require__(6);
	  __webpack_require__(9);
	  __webpack_require__(14);
	  __webpack_require__(16);
	  __webpack_require__(18);
	  __webpack_require__(11);
	  __webpack_require__(23);
	  __webpack_require__(24);
	  __webpack_require__(27);
	  __webpack_require__(28);
	  __webpack_require__(30);
	  __webpack_require__(32);
	  __webpack_require__(33);
	  var config = __webpack_require__(34);
	  var Postal = __webpack_require__(35);
	  window._ = __webpack_require__(36);
	
	  if (!!navigator.userAgent.match(/Trident.*rv\:11\./)) {
	    // IE 11 cache bug.
	    $.ajaxSetup({
	      cache: false
	    });
	  }
	
	  // initialize cloud object
	  cloud = {
	    config: config,
	    util: {}
	  };
	
	  /*
	   * @author Jerolin
	   * @name createUniqueID
	   * @type {function}
	   * @description "Create a unique id with the given prefix"
	   * @param {string} options "prefix"
	   * @return {String}
	   */
	  var sequenceID = 0;
	  cloud.util.createUniqueID = function (prefix) {
	    var id = (++sequenceID).toString();
	    return prefix ? prefix + id : id;
	  };
	  /*
	   * @author qinjunwen
	   * @name getCurrentLocation
	   * @type {function}
	   * @description "A light packaging of HTML5 geo-location API"
	   * @param {function} callback "callback parameter is a function"
	   * @param {Object} context "context of callback function, default to be window"
	   * @returns {Object} "properties included : longitude, latitude, timestamp;if refuse ,return default location"
	   */
	  cloud.util.getCurrentLocation = function (callback, context) {
	    var done = false;
	
	    var timeout = 3000;
	
	    var defaultLocation = {
	      longitude: 116.407013,
	      latitude: 39.926588,
	      timestamp: (new Date()).getTime()
	    };
	
	    var timeoutHandler = function () {
	      if (done == false) {
	        done = true;
	        console.log(locale.get("get_location_failed"));
	        callback.call(context || this, defaultLocation);
	      }
	    };
	
	    setTimeout(timeoutHandler, timeout);
	
	    navigator.geolocation.getCurrentPosition(function (position) {
	      if (done == false) {
	        var location = {
	          longitude: position.coords.longitude,
	          latitude: position.coords.latitude,
	          timestamp: position.timestamp
	        };
	        done = true;
	        callback.call(context || this, location);
	      }
	    }, function () {
	      if (done == false) {
	        done = true;
	        callback.call(context || this, defaultLocation);
	      }
	    });
	  };
	
	
	  /*
	   * @author qinjunwen
	   * @name objectArrayToArray
	   * @type {function}
	   * @description "object array to array"
	   * @param {Array} arr "array"
	   * @param {String} str "string"
	   * @returns {String} property name;
	   */
	  cloud.util.objectArrayToArray = function (arr, str) {
	    var _arr = [];
	    for (var num = 0; num < arr.length; num++) {
	      _arr.push(arr[num][str]);
	    }
	    return _arr;
	  };
	
	  /*
	   * @author qinjunwen
	   * @name isEmpty
	   * @type {function}
	   * @description "Check whether the object is empty"
	   * @param {Object} obj "object"
	   * @return {Boolean}
	   */
	  cloud.util.isEmpty = function (obj) {
	    for (var name in obj) {
	      return false;
	    }
	    return true;
	  };
	
	  /*
	   * @author Jerolin
	   * @name dateFormat
	   * @type {function}
	   * @description "Format a date object to a given template"
	   * @param {Object} date "date"
	   * @param {Object} format "format MM: Month, dd: Date, hh: Hour, mm: Minutes, ss:Seconds".
	   * @return {String}
	   */
	  cloud.util.dateFormat = function (date, format) {
	    // temporary convert date. exclude it after api fixed the issue.
	    date = new Date((date.getTime() * 1000));
	    var o = {
	      "M+": date.getMonth() + 1,
	      "d+": date.getDate(),
	      "h+": date.getHours(),
	      "m+": date.getMinutes(),
	      "s+": date.getSeconds(),
	      "q+": Math.floor((date.getMonth() + 3) / 3),
	      "S": date.getMilliseconds()
	    };
	    if (/(y+)/.test(format)) {
	      format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
	    }
	    for (var k in o) {
	      if (new RegExp("(" + k + ")").test(format)) {
	        format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
	      }
	    }
	    return format;
	  };
	
	  /*
	   * @author Jerolin
	   * @name result
	   * @type {function}
	   * @description "If the value of the named property is a function then invoke it otherwise, return it."
	   * @param {Object} object "object"
	   * @param {Object} property "property"
	   * @return {Object}
	   */
	  cloud.util.result = function (object, property) {
	    if (object === null)
	      return null;
	    var value = object[property];
	    return Object.isFunction(value) ? value.call(object) : value;
	  };
	
	  /*
	   * @name throttle
	   * @type {function}
	   * @description "Return a new function, no matter how often the function is called, it will invoke only once in wait time."
	   * @param {function} func "Original function".
	   * @param {Object} wait "Milliseconds of wait time".
	   * @param {Object} context "is a object".
	   * @return {Object}
	   */
	  cloud.util.throttle = function (func, wait, context) {
	    var args = null, timeout = null, result = null;
	    var previous = 0;
	    var later = function () {
	      previous = new Date();
	      timeout = null;
	      result = func.apply(context, args);
	    };
	    return function () {
	      var now = new Date();
	      var remaining = wait - (now - previous);
	      context = context ? context : this;
	      args = arguments;
	      if (remaining <= 0) {
	        clearTimeout(timeout);
	        timeout = null;
	        previous = now;
	        result = func.apply(context, args);
	      } else if (!timeout) {
	        timeout = setTimeout(later, remaining);
	      }
	      return result;
	    };
	  };
	
	  /*
	   * @name once
	   * @type {function}
	   * @description "Return a function that will only be executed once"
	   * @param {function} func "is function parameter".
	   * @return {function}
	   */
	  cloud.util.once = function (func) {
	    var ran = false, memo = null;
	    return function () {
	      if (ran)
	        return memo;
	      ran = true;
	      memo = func.apply(this, arguments);
	      func = null;
	      return memo;
	    };
	  };
	
	  /*
	   * @name after
	   * @type {function}
	   * @description "Return a function, that will invoke 'func' parameter after some times."
	   * @param {Object} times "is object parameter"
	   * @param {function} func "is function parameter"
	   */
	  cloud.util.after = function (times, func) {
	    if (times <= 0)
	      return func();
	    return function () {
	      if (--times < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  };
	
	  /*
	   * @name defaults
	   * @type {function}
	   * @description "Fill in a given object with default properties."
	   * @param {Object} obj "is object parameter".
	   * @return {Object}
	   */
	  cloud.util.defaults = function (obj) {
	    Array.prototype.slice.call(arguments, 1).each(function (source) {
	      if (source) {
	        for (var prop in source) {
	          if (Object.isUndefined(obj[prop]))
	            obj[prop] = source[prop];
	        }
	      }
	    });
	    return obj;
	  };
	
	  /*
	   * @name has
	   * @type {function}
	   * @description "Shortcut for hasOwnProperty() method."
	   * @param {Object} obj "object"
	   * @param {Object} key "key"
	   * @return {Object}
	   */
	  cloud.util.has = function (obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	  };
	
	  /*
	   * @name random
	   * @type {function}
	   * @description "Return a random integer between min and max (inclusive)."
	   * @param {Object} min
	   * @param {Object} max
	   * @return {Number}
	   */
	  cloud.util.random = function (min, max) {
	    if (max === null) {
	      max = min;
	      min = 0;
	    }
	    return min + Math.floor(Math.random() * (max - min + 1));
	  };
	
	  /*
	   * @name pick
	   * @type {function}
	   * @description "pick a sub objcet by the given keys."
	   * @param {Object} obj
	   * @return {Object}
	   */
	  cloud.util.pick = function (obj) {
	    var copy = {};
	    var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	    keys.each(function (key) {
	      if (key in obj)
	        copy[key] = obj[key];
	    });
	    return copy;
	  };
	
	
	  /*
	   * @name omit
	   * @type {function}
	   * @description "get the object's properties exclude the given keys."
	   * @param {Object} obj
	   * @return {Object}
	   */
	  cloud.util.omit = function (obj) {
	    var copy = {};
	    var keys = Array.prototype.concat.apply(Array.prototype, Array.prototype.slice.call(arguments, 1));
	    for (var key in obj) {
	      if (!keys.include(key)) {
	        copy[key] = obj[key];
	      }
	    }
	    return copy;
	  };
	
	  /*
	   * @name makeArray
	   * @type {function}
	   * @description "Convert arguments to an array."
	   * @param {Array} arguments
	   * @return {Array}
	   */
	  cloud.util.makeArray = function () {
	    return [$A(arguments)].flatten();
	  };
	
	  /*
	   * @name mixin
	   * @type {function}
	   * @description "proccess src  append to target object"
	   * @param {Object} target
	   * @param {Object} src
	   * @return {undefined}
	   */
	  cloud.util.mixin = function (target, src) {
	    var filtered = cloud.util.omit(src, "initialize", "destroy");
	    $.extend(target, filtered);
	    target.mixed = target.mixed || $A();
	    target.mixed.push(src);
	    if (Object.isFunction(src.initialize)) {
	      src.initialize.call(target);
	    }
	  };
	
	  /*
	   * @name mask
	   * @type {function}
	   * @description "Load mask"
	   * @param {Object} element "element is HTMLElEMENT or string or jquery object"
	   * @param {String} label "label is string"
	   * @return {undefined}
	   */
	  cloud.util.mask = function (element, label) {
	    __webpack_require__(37).restart();
	    element = (typeof element === "string") ? $(element) : element;
	    label = label || locale.get({
	        lang: "loading"
	      });
	    if (cloud.util.isMasked(element)) {
	      cloud.util.unmask(element);
	    }
	
	    if (element.css("position") == "static") {
	      element.addClass("masked-relative");
	    }
	
	    element.addClass("masked");
	
	    var maskDiv = $('<div class="loadmask"></div>');
	
	    // auto height fix for IE
	    if (navigator.userAgent.toLowerCase().indexOf("msie") > -1) {
	      maskDiv.height(element.height() + parseInt(element.css("padding-top"), 0) + parseInt(element.css("padding-bottom"), 0));
	      maskDiv.width(element.width() + parseInt(element.css("padding-left"), 0) + parseInt(element.css("padding-right"), 0));
	    }
	
	    // fix for z-index bug with selects in IE6
	    if (navigator.userAgent.toLowerCase().indexOf("msie 6") > -1) {
	      element.find("select").addClass("masked-hidden");
	    }
	    var opts = {
	      color: '#fff',
	      lines: 12,
	      length: 8,
	      width: 4,
	      trail: 60,
	      speed: 1.5
	    };
	    if (element.outerHeight() < 30) {
	      opts.scale = 0.5;
	    }
	    maskDiv.spin(opts);
	    element.append(maskDiv);
	  };
	
	
	  /*
	   * @name unmask
	   * @type {function}
	   * @description "Unload mask"
	   * @param {Object} element "element is HTMLElEMENT or string or jquery object"
	   * @return {undefined}
	   */
	  cloud.util.unmask = function (element) {
	    element = element || 'body';
	    if (!element) {
	      $(".loadmask").remove();
	      $(".loadmask-msg").remove();
	      return;
	    }
	    element = (typeof element === "string") ? $(element) : element;
	    element.spin(false);
	    element.find(".loadmask-msg,.loadmask").remove();
	    element.find('.spinner').parent().spin(false);
	    element.removeClass("masked");
	    element.removeClass("loadmask-fixed");
	    element.find("select").removeClass("masked-hidden");
	  };
	
	  /*
	   * @name isMasked
	   * @type {function}
	   * @description "Is mask existed"
	   * @param {Object} opt "opt is jquery object"
	   * @return {Boolean}
	   */
	  cloud.util.isMasked = function (opt) {
	    var element = Object.isString(opt) ? $(opt) : opt;
	    if (element) {
	      return element.hasClass("masked");
	    }
	  };
	
	  $.fn.mask = $.fn.mask || function (label, delay) {
	      $(this).each(function () {
	        cloud.util.mask($(this));
	      });
	    };
	
	  /**
	   * Removes mask from the element(s). Accepts both single and multiple selectors.
	   */
	  $.fn.unmask = $.fn.unmask || function () {
	      $(this).each(function () {
	        cloud.util.unmask($(this));
	      });
	    };
	
	  /*
	   * @author PANJC
	   * @name inArray
	   * @type {function}
	   * @description "To judge whether an array element"
	   * @param {String} data
	   * @param {Array} arr
	   * @return {Boolean}
	   */
	  cloud.util.inArray = function (data, arr) {
	    var total = 0;
	    for (var num = 0; num < arr.length; num++) {
	      if (arr[num] == data) {
	        total++;
	      }
	    }
	    if (total > 0) {
	      return true;
	    } else {
	      return false;
	    }
	  };
	  /*
	   * @author PANJC
	   * @name inString
	   * @type {function}
	   * @description "to judge whether exists in the string"
	   * @param {String} match
	   * @param {String} str
	   * @param {Boolean} sensitive
	   * @return {Boolean}
	   */
	  cloud.util.inString = function (match, str, sensitive) {
	    var sensitive = sensitive ? true : false;
	    if (!sensitive) {
	      var match = match.toLowerCase();
	      var str = str.toLowerCase();
	    }
	    if (str.indexOf(match) > -1) {
	      return true;
	    } else {
	      return false;
	    }
	  };
	  /*
	   * @author PANJC
	   * @name setCurrentApp
	   * @type {function}
	   * @description "set current app"
	   * @param {Object} obj
	   * @return {undefined}
	   */
	  cloud.util.setCurrentApp = function (obj) {
	    if (obj.element) {
	      localStorage.setItem("appElement", obj.element);
	      localStorage.setItem("appView", "");
	      localStorage.setItem("appUrl", "");
	    }
	    if (obj.view) {
	      localStorage.setItem("appView", obj.view);
	    }
	    if (obj.url) {
	      localStorage.setItem("appUrl", obj.url);
	    }
	  };
	  /*
	   * @author PANJC
	   * @name refresh
	   * @type {function}
	   * @description "Refresh current page"
	   * @return {undefined}
	   */
	  cloud.util.refresh = function () {
	    if (localStorage.getItem("appInnerNav") && $(localStorage.getItem("appInnerNav")).length > 0) {
	      $(localStorage.getItem("appInnerNav")).trigger("click");
	    } else if (localStorage.getItem("appView") && $(localStorage.getItem("appView")).length > 0) {
	      $(localStorage.getItem("appView")).trigger("click");
	    } else if (localStorage.getItem("appElement") && $(localStorage.getItem("appElement")).length > 0) {
	      $(localStorage.getItem("appElement")).trigger("click");
	    }
	  };
	  /*
	   * @author PANJC
	   * @name strToJson
	   * @type {function}
	   * @description "string to json"
	   * @param {String} str
	   * @return {Object}
	   */
	  cloud.util.strToJson = function (str) {
	    var obj = {};
	    if (str && (typeof str) == "string") {
	      if (str.indexOf("{") > -1) {
	        str = str.replace(/[\"\']/g, "");
	        str = str.replace(/\s/g, "");
	        str = str.replace("{", "{\"");
	        str = str.replace(",}", "}");
	        str = str.replace("}", "\"}");
	        str = str.replace(/:/g, "\":\"");
	        str = str.replace(/,/g, "\",\"");
	      } else {
	        str = str.replace(/[\"\']/g, "");
	        str = str.replace(/\s/g, "");
	        str = str.replace(/:/g, "\":\"");
	        str = "\"" + str + "\"";
	      }
	      obj = $.parseJSON(str);
	    }
	    return obj;
	  };
	  /*
	   * @author Jerolin
	   * @name md5
	   * @type {function}
	   * @description "Extend Prototype, add some method to native object.extend string.md5 #example "123".md5() //-> md5 code in upper case"
	   * @param {String} str
	   * @return {String}
	   */
	  cloud.util.md5 = (function (str) {
	
	    var hex_chr = "0123456789abcdef";
	
	    function rhex(num) {
	      str = "";
	      for (var j = 0; j <= 3; j++) {
	        str += hex_chr.charAt((num >> (j * 8 + 4)) & 15) + hex_chr.charAt((num >> (j * 8)) & 15);
	      }
	      return str;
	    }
	
	    function str2blks_MD5(str) {
	      nblk = ((str.length + 8) >> 6) + 1;
	      blks = new Array(nblk * 16);
	      for (var i = 0; i < nblk * 16; i++) {
	        blks[i] = 0;
	      }
	      for (i = 0; i < str.length; i++) {
	        blks[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
	      }
	      blks[i >> 2] |= 128 << ((i % 4) * 8);
	      blks[nblk * 16 - 2] = str.length * 8;
	      return blks;
	    }
	
	    function add(x, y) {
	      var lsw = (x & 65535) + (y & 65535);
	      var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
	      return (msw << 16) | (lsw & 65535);
	    }
	
	    function rol(num, cnt) {
	      return (num << cnt) | (num >>> (32 - cnt));
	    }
	
	    function cmn(q, a, b, x, s, t) {
	      return add(rol(add(add(a, q), add(x, t)), s), b);
	    }
	
	    function ff(a, b, c, d, x, s, t) {
	      return cmn((b & c) | ((~b) & d), a, b, x, s, t);
	    }
	
	    function gg(a, b, c, d, x, s, t) {
	      return cmn((b & d) | (c & (~d)), a, b, x, s, t);
	    }
	
	    function hh(a, b, c, d, x, s, t) {
	      return cmn(b ^ c ^ d, a, b, x, s, t);
	    }
	
	    function ii(a, b, c, d, x, s, t) {
	      return cmn(c ^ (b | (~d)), a, b, x, s, t);
	    }
	
	    function MD5(str) {
	      x = str2blks_MD5(str);
	      var a = 1732584193;
	      var b = -271733879;
	      var c = -1732584194;
	      var d = 271733878;
	      for (var i = 0; i < x.length; i += 16) {
	        var olda = a;
	        var oldb = b;
	        var oldc = c;
	        var oldd = d;
	        a = ff(a, b, c, d, x[i + 0], 7, -680876936);
	        d = ff(d, a, b, c, x[i + 1], 12, -389564586);
	        c = ff(c, d, a, b, x[i + 2], 17, 606105819);
	        b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
	        a = ff(a, b, c, d, x[i + 4], 7, -176418897);
	        d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
	        c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
	        b = ff(b, c, d, a, x[i + 7], 22, -45705983);
	        a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
	        d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
	        c = ff(c, d, a, b, x[i + 10], 17, -42063);
	        b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
	        a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
	        d = ff(d, a, b, c, x[i + 13], 12, -40341101);
	        c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
	        b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
	        a = gg(a, b, c, d, x[i + 1], 5, -165796510);
	        d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
	        c = gg(c, d, a, b, x[i + 11], 14, 643717713);
	        b = gg(b, c, d, a, x[i + 0], 20, -373897302);
	        a = gg(a, b, c, d, x[i + 5], 5, -701558691);
	        d = gg(d, a, b, c, x[i + 10], 9, 38016083);
	        c = gg(c, d, a, b, x[i + 15], 14, -660478335);
	        b = gg(b, c, d, a, x[i + 4], 20, -405537848);
	        a = gg(a, b, c, d, x[i + 9], 5, 568446438);
	        d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
	        c = gg(c, d, a, b, x[i + 3], 14, -187363961);
	        b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
	        a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
	        d = gg(d, a, b, c, x[i + 2], 9, -51403784);
	        c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
	        b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
	        a = hh(a, b, c, d, x[i + 5], 4, -378558);
	        d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
	        c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
	        b = hh(b, c, d, a, x[i + 14], 23, -35309556);
	        a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
	        d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
	        c = hh(c, d, a, b, x[i + 7], 16, -155497632);
	        b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
	        a = hh(a, b, c, d, x[i + 13], 4, 681279174);
	        d = hh(d, a, b, c, x[i + 0], 11, -358537222);
	        c = hh(c, d, a, b, x[i + 3], 16, -722521979);
	        b = hh(b, c, d, a, x[i + 6], 23, 76029189);
	        a = hh(a, b, c, d, x[i + 9], 4, -640364487);
	        d = hh(d, a, b, c, x[i + 12], 11, -421815835);
	        c = hh(c, d, a, b, x[i + 15], 16, 530742520);
	        b = hh(b, c, d, a, x[i + 2], 23, -995338651);
	        a = ii(a, b, c, d, x[i + 0], 6, -198630844);
	        d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
	        c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
	        b = ii(b, c, d, a, x[i + 5], 21, -57434055);
	        a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
	        d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
	        c = ii(c, d, a, b, x[i + 10], 15, -1051523);
	        b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
	        a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
	        d = ii(d, a, b, c, x[i + 15], 10, -30611744);
	        c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
	        b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
	        a = ii(a, b, c, d, x[i + 4], 6, -145523070);
	        d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
	        c = ii(c, d, a, b, x[i + 2], 15, 718787259);
	        b = ii(b, c, d, a, x[i + 9], 21, -343485551);
	        a = add(a, olda);
	        b = add(b, oldb);
	        c = add(c, oldc);
	        d = add(d, oldd);
	      }
	      return rhex(a) + rhex(b) + rhex(c) + rhex(d);
	    }
	
	    if (!String.prototype.md5) {
	      String.prototype.md5 = function () {
	        return MD5(this).toUpperCase();
	      };
	    }
	
	    return function (str) {
	      return MD5(str).toUpperCase();
	    };
	
	  })();
	  /*
	   * @author PANJC
	   * @name ensureToken
	   * @type {function}
	   * @description "Ensure the token correctly"
	   * @param {function} callback
	   * @return {undefined}
	   */
	  cloud.util.ensureToken = function (callback) {
	    cloud.Ajax.request({
	      url: "api2/users/this",
	      type: "GET",
	      parameters: {
	        verbose: 1
	      },
	      success: function (data) {
	        if (callback && Object.isFunction(callback)) {
	          callback(data);
	        }
	      }
	    });
	  };
	  /*
	   * @name unitConversion
	   * @type {function}
	   * @description "conversion k-kb-mb"
	   * @param {Number} opt
	   * @return {String}
	   */
	  cloud.util.unitConversion = function (opt) {
	    if (typeof opt === "number") {
	      if (opt < 1024) {
	        return opt.toFixed(0) + "B";
	      } else if (opt < 1024 * 1024) {
	        return (opt / 1024).toFixed(3) + "KB";
	      } else if (opt < 1024 * 1024 * 1024) {
	        return (opt / 1024 / 1024).toFixed(3) + "MB";
	      } else {
	        return (opt / 1024 / 1024 / 1024).toFixed(3) + "GB";
	      }
	    } else {
	      return opt;
	    }
	  };
	
	  /*
	   * @name LatitudeLongitudeConversion
	   * @type {function}
	   * @description "latitude to longitude of conversion"
	   * @param {String} data
	   * @return {String}
	   */
	  cloud.util.LatitudeLongitudeConversion = function (data) {
	    var returnStr;
	    var str = data + "";
	    if (str.indexOf(".") !== -1 && str.indexOf("°") === -1) {
	      returnStr = "";
	      var integer = str.substring(0, str.indexOf(".")) * 1;
	      var decimal = ("0." + str.substring(str.indexOf(".") + 1)) * 1;
	      returnStr += integer + "°";
	      var min = Math.floor(decimal * 60);
	      returnStr += min + "'";
	      var sec = Math.floor(("0." + ((decimal * 60 + "").substring((decimal * 60 + "").indexOf(".") + 1))) * 60);
	      returnStr += sec + "\"";
	    }
	    return data;
	  };
	
	
	  /*
	   * Sub&Pub events
	   *
	   *  subscribe an event named "topic1" on "channel1":
	   * var sub = cloud.message.on("channel1",{
	   * 		"topic1":function(data,envelope){
	   //	 * 			console.log(envelope);
	   * 		},
	   * 		...
	   * });
	   *  unsubscribe events
	   * sub.unbind();    unbind all topics on "channel1"
	   * sub.unbind("topic")  unbind  "topic" on "channel1"
	   *
	   *  publish "topic" event on "channel" with data:
	   * cloud.message.fire("channel","topic",data);
	   *
	   *  query topic "#.b.*" on which channel;
	   * cloud.message.query("#.b.*")
	   */
	
	  cloud.message = (function () {
	    return {
	//			map:$H(),
	      _compare: function (a, b) {
	        return Postal.configuration.resolver.compare(a, b) || Postal.configuration.resolver.compare(b, a)
	      },
	
	      queryByTopic: function (topic, isDetail) {
	        var result = $A();
	        cloud.message.getSubscribers().each(function (sub) {
	          if (cloud.message._compare(topic, sub.topic)) {
	            if (isDetail) {
	              result.push(sub)
	            } else {
	              result.push(sub.channel)
	            }
	          }
	        });
	        return result.uniq();
	      },
	
	      getSubscribers: function (channel) {
	        var subscribers = $A();
	        $.each(postal.configuration.bus.subscriptions, function (i, group) {
	          $.each(group, function (i, subArray) {
	            $.each(subArray, function (i, sub) {
	              if (channel == null || (channel == sub.channel)) {
	                subscribers.push(sub);
	              }
	            });
	          });
	        });
	        return subscribers;
	      },
	
	      clearChannel: function (channel) {
	        var channelSubs = this.getSubscribers(channel);
	        channelSubs.each(function (sub) {
	          sub.unsubscribe();
	        })
	      },
	
	      /*query:function(topic){
	       var self = this;
	       var result =[];
	       var keys = this.map.keys();
	       keys.each(function(key){
	       if(self._compare(topic,key)){
	       result = result.concat(self.map.get(key));
	       }
	       });
	       return result;
	       },*/
	      on: function (channel, config) {
	        var self = this;
	        if (arguments.length === 1) {//config
	          config = channel;
	          channel = "/";
	        }
	        var events = $H(config);
	        var scope = events.unset("scope") || this;
	
	        var hash = $H();
	        events.each(function (event) {
	          //
	          $A(Postal.utils.getSubscribersFor(channel, event.key)).each(function (oneSub) {
	            if (oneSub.callback.toString() === event.value.toString()) {
	              oneSub.unsubscribe();
	//							self._removeMap(oneSub.topic,oneSub.channel);
	              throw $break;
	            }
	          });
	          var sub = Postal.subscribe({
	            channel: channel,
	            topic: event.key,
	            callback: event.value
	          });
	          sub.withContext(scope);
	//					self._setMap(sub);
	          hash.set(event.key, sub);
	        });
	        hash = hash.toJSON();
	        hash.unbind = function (topic) {
	          self._unbind(hash, topic);
	        };
	        return hash;
	      },
	      /*_setMap:function(sub){
	       var key = sub.topic
	       var value = this.map.get(key);
	       if(!value){
	       value = $A();
	       }
	       value.push(sub.channel);
	       this.map.set(key,value);
	       },
	       _removeMap:function(topic,channel){
	       var values = this.map.get(topic);
	       values.pop(channel);
	       },*/
	      _unbind: function (hash, topic) {
	        if (topic) {
	          hash[topic].unsubscribe();
	//					this._removeMap(topic,hash[topic].channel)
	        } else {
	          for (var i in hash) {
	            if (i !== "unbind") {
	              hash[i].unsubscribe();
	//							this._removeMap(i,hash[i].channel);
	            }
	          }
	        }
	      },
	      post: function (channel, topic, data) {
	        if (arguments.length === 2 && data) {//topic,data
	          data = topic;
	          topic = channel;
	          channel = "/";
	        } else if (arguments.length === 1) {//topic
	          topic = channel;
	          channel = "/";
	        }
	        Postal.publish({
	          channel: channel,
	          topic: topic,
	          data: data
	        })
	      }
	
	
	    }
	  })();
	
	  /*
	   * API for use localStorage and sessionStorage
	   * @author Jerolin
	   * @return {Object}
	   */
	  cloud.storage = (function () {
	
	    return {
	      /*
	       * @author Jerolin
	       * @name localStorage
	       * @type {function}
	       * @description "include getter and setter in one method to change localStorage."
	       * @param {String} key
	       * @param {Object} value
	       * @return {undefined}
	       */
	      localStorage: function (key, value) {
	        var storage = window.localStorage;
	        if (storage) {
	          if (arguments.length == 1) {
	            value = storage.getItem(key);
	            return value;
	          } else if (arguments.length == 2) {
	            if (value) {
	              storage.setItem(key, value);
	            } else {
	              storage.removeItem(key);
	            }
	          }
	        }
	      },
	
	      /*
	       * @author Jerolin
	       * @name sessionStorage
	       * @type {function}
	       * @description "include getter and setter in one method to change sessionStorage."
	       * @param {String} key
	       * @param {Object} value
	       * @return {undefined}
	       */
	      sessionStorage: function (key, value) {
	        var storage = window.sessionStorage;
	        if (storage) {
	          if (arguments.length == 1) {
	            value = storage.getItem(key);
	            return value;
	          } else if (arguments.length == 2) {
	            if (value) {
	              storage.setItem(key, value);
	            } else {
	              storage.removeItem(key);
	            }
	          }
	        }
	      }
	    };
	
	  })();
	  cloud.accessToken = (function () {
	    var _a = "accessToken";
	    return {
	      get: function () {
	        return cloud.storage.sessionStorage(_a);
	      },
	      set: function (val) {
	        cloud.storage.sessionStorage(_a, val);
	      },
	      remove: function () {
	        cloud.storage.sessionStorage(_a, null);
	      }
	    }
	  })();
	  cloud.refreshToken = (function () {
	    var _r = "refreshToken";
	    return {
	      get: function () {
	        return cloud.storage.sessionStorage(_r);
	      },
	      set: function (val) {
	        cloud.storage.sessionStorage(_r, val);
	      },
	      remove: function () {
	        cloud.storage.sessionStorage(_r, null);
	      }
	    }
	  })();
	
	
	  /*
	   * cloud ajax request
	   * @author PANJC,Jerolin
	   * @return {Object}
	   */
	
	  cloud.Ajax = (function () {
	
	    return {
	
	      server: cloud.config.API_SERVER_URL,
	      errorURL: "../index.html",
	
	      //Default auth options
	      defaultAuthOptions: {
	        url: cloud.config.AUTH_SERVER_URL + "/access_token",
	        type: "POST",
	        dataType: "JSON",
	        data: {
	          client_id: cloud.config.CLIENT_ID,
	          client_secret: cloud.config.CLIENT_SECRET
	        }
	      },
	
	      //Failed requests
	      failedRequests: {
	        queue: [],
	        number: 0,
	        delayTime: 2000
	      },
	
	      //Delay requests object
	      delayRequests: {
	        times: 0,
	        intervalTime: 0,
	        url: null,
	        type: null,
	        param: null,
	        parameters: null,
	        data: null
	      },
	
	      //get access token
	      getAccessToken: function () {
	        return cloud.storage.sessionStorage("accessToken");
	      },
	
	      //set access token
	      _setAccessToken: function (_accessToken) {
	        cloud.storage.sessionStorage("accessToken", _accessToken);
	      },
	
	      //get refresh token
	      _getRefreshToken: function () {
	        return cloud.storage.sessionStorage("refreshToken");
	      },
	
	      //set refresh token
	      _setRefreshToken: function (_refreshToken) {
	        cloud.storage.sessionStorage("refreshToken", _refreshToken);
	      },
	
	      //refresh access token
	      _refreshAccessToken: function (callback) {
	        var self = this;
	        if (!self._getRefreshToken()) {
	          dialog.close();
	          dialog.render({
	            lang: "login_again",
	            buttons: [{
	              lang: "ok", click: function () {
	                dialog.close();
	                self.logout();
	              }
	            }],
	            close: function () {
	              dialog.close();
	              self.logout();
	            }
	          });
	          return;
	        }
	        var obj = self.defaultAuthOptions;
	        obj.async = false;
	        obj.data.grant_type = "refresh_token";
	        obj.data.refresh_token = self._getRefreshToken();
	        obj.data.contentType = "application/x-www-form-urlencoded";
	        obj.success = function (result) {
	          self._setAccessToken(result.access_token);
	          self._setRefreshToken(result.refresh_token);
	          if (callback) {
	            callback();
	          }
	        };
	        obj.error = function (result) {
	          dialog.render({
	            lang: "login_timeout",
	            buttons: [{
	              lang: "ok",
	              click: function () {
	                dialog.close();
	                self.logout();
	              }
	            }],
	            close: function () {
	              dialog.close();
	              self.logout();
	            }
	          });
	        };
	        self._request(obj);
	      },
	
	      //request failed ajax queue
	      _requestFailedQueue: function () {
	        var self = this;
	        var failedRequestsQueue = self.failedRequests.queue;
	        if (failedRequestsQueue.length > 0) {
	          $.each(failedRequestsQueue, function (index, obj) {
	            self._request(obj);
	          });
	          self.failedRequests.queue = [];
	          self.failedRequests.number = 0;
	        }
	      },
	
	      //defer to execute failure requests
	      _deferFailedRequests: function (obj) {
	        var self = this;
	        if (this.failedRequests.number == 0) {
	          function delayFun() {
	            self._refreshAccessToken(function () {
	              self._requestFailedQueue();
	            });
	          }
	
	          setTimeout(function () {
	            delayFun();
	          }, self.failedRequests.delayTime);
	        }
	        self.failedRequests.queue.push(obj);
	        self.failedRequests.number++;
	      },
	
	      // priavte request method
	      _request: function (obj) {
	        var self = this;
	        if (obj.url.include('access_token=')) {
	          obj.url = obj.url.replace(/access_token=[\w\d]{32}/, "access_token=" + this.getAccessToken());
	        } else {
	          obj.url += (obj.url.include('?') ? '&' : '?') + "access_token=" + this.getAccessToken();
	        }
	        if (Prototype.Browser.IE) {
	          if (obj.url.include('random=')) {
	            obj.url = obj.url.replace(/rand=[\w\d]{32}/, "random=" + cloud.util.md5(Math.random()));
	          } else {
	            obj.url += (obj.url.include('?') ? '&' : '?') + "random=" + cloud.util.md5(Math.random());
	          }
	        }
	        var requestSuccessFun = obj.success ? obj.success : "";
	        var requestErrorFun = obj.error ? obj.error : "";
	        var successHandler = (obj.success && Object.isFunction(requestSuccessFun)) ? requestSuccessFun : function () {
	        };
	        var errorHandler = (obj.error && Object.isFunction(requestErrorFun)) ? function (error) {
	          defaultDataError(error);
	          requestErrorFun(error);
	        } : function (error) {
	          error.params = error.params || error.fields;
	          error.request = obj.url.substring(0, obj.url.indexOf('?'));
	          defaultDataError(error);
	          customDataError(error);
	        };
	
	        //default data request error handle
	        function defaultDataError(error) {
	          var errorNumber = parseFloat(error.error_code);
	          if (cloud.util.inArray(errorNumber, [21327, 21334, 21335, 21336])) {
	            self._deferFailedRequests(obj);
	          } else if (cloud.util.inArray(errorNumber, [21305, 21332, 21333])) {
	            dialog.render({
	              lang: "login_again",
	              buttons: [{
	                lang: "ok", click: function () {
	                  dialog.close();
	                  self.logout();
	                }
	              }],
	              close: function () {
	                dialog.close();
	                self.logout();
	              }
	            });
	          } else if (errorNumber == 20006 && error.error.indexOf("@") == -1) {
	            dialog.render({
	              lang: 20006,
	              buttons: [{
	                lang: "refresh_app", click: function () {
	                  dialog.close();
	                  cloud.util.refresh();
	                }
	              },
	                {
	                  lang: "ignore1", click: function () {
	                  dialog.close();
	                }
	                }],
	              close: function () {
	                dialog.close();
	              }
	            });
	          }
	          cloud.util.unmask();
	        };
	
	        //custom data request error handle
	        function customDataError(error) {
	          var errorNumber = parseInt(error.error_code);
	          var errorContent = error.error.toLowerCase();
	          var errorRequest = error.request.toLowerCase();
	          var errorParams = error.params;
	          if (!cloud.util.inArray(errorNumber, [20006, 21327, 21334, 21335, 21305, 21332, 21333, 21334, 21335, 21336])) {
	            if (errorNumber == 20007) {
	              if (cloud.util.inString("tag", errorContent)) {
	                dialog.render({
	                  lang: "tag_already_exists"
	                });
	              } else if (cloud.util.inString("gateway", errorContent)) {
	                dialog.render({
	                  lang: "gateway_already_exists"
	                });
	              } else if (cloud.util.inString("sites", errorRequest)) {
	                dialog.render({
	                  lang: "site_already_exists"
	                });
	              } else if (cloud.util.inString("name", errorContent)) {
	                if (cloud.util.inString("device", errorRequest)) {
	                  dialog.render({
	                    lang: "device_already_exists"
	                  });
	                } else if (cloud.util.inString("sites", errorRequest)) {
	                  dialog.render({
	                    lang: "site_already_exists"
	                  });
	                }
	              } else if (cloud.util.inString("serival", errorContent)) {
	                dialog.render({
	                  lang: "serial_number_already_exists"
	                })
	              } else if (cloud.util.inString("devices", errorRequest)) {
	                if (error.params[1] == 'site') {
	                  dialog.render({
	                    text: locale.get({ lang: "site_someone_already_exists" }).replace("{0}", "(" + error.params[0] + ")")
	                  })
	                } else {
	                  dialog.render({
	                    lang: "serial_number_already_exists"
	                  })
	                }
	              } else if (cloud.util.inString("group", errorRequest)) {
	                dialog.render({
	                  lang: "group_already_exists"
	                });
	              } else {
	                dialog.render({
	                  text: locale.get({ lang: "resource_already_exists" }).replace("{0}", "(" + error.params[0] + ")")
	                });
	              }
	            } else if (errorNumber == 21322) {
	              if (cloud.util.inString("machines", errorRequest)) {
	                dialog.render({
	                  lang: "controller_already_exists"
	                });
	              }
	              else if (cloud.util.inString("devices", errorRequest)) {
	                dialog.render({
	                  lang: "gateway_already_exists"
	                })
	              }
	              else if (cloud.util.inString("sites", errorRequest)) {
	                dialog.render({
	                  lang: "site_already_exists"
	                })
	              }
	              else if (cloud.util.inString("models", errorRequest)) {
	                dialog.render({
	                  lang: "model_already_exists"
	                });
	              }
	            } else {
	              if ($.isArray(errorParams)) {
	                var _prompt = locale.get(errorNumber, errorParams);
	                dialog.render({
	                  text: _prompt
	                })
	              } else {
	                dialog.render({lang: errorNumber});
	              }
	            }
	          }
	        };
	
	        // default ajax request error handler
	        function defaultAjaxError(jqXHR, textStatus, errorThrown) {
	          if (jqXHR.status > 399 && jqXHR.status < 500) {
	            var returnData = $.parseJSON(jqXHR.responseText);
	            obj.success(returnData)
	            return;
	          }
	          // The error information encapsulated into results
	          var error = {
	            request: jqXHR,
	            status: textStatus,
	            thrown: errorThrown
	          };
	          if (error.status && (error.status != "abort")) {// modified by qinjunwen, ignore "abort" status
	            if (error.status == "timeout") {
	              dialog.render({lang: "network_timeout+!"});
	            } else {
	              if (error.request.readyState !== 0) {
	                dialog.render({lang: "network_error+!"});
	              }
	            }
	          }
	          cloud.util.unmask();
	        }
	
	        //new ajax object
	        obj = Object.extend(obj, {
	          success: function (result) {
	            //if is to create and delete, delay correction
	            function handler() {
	              if (result.error) {
	                errorHandler(result);
	              } else {
	                successHandler(result);
	              }
	            }
	
	            switch ($.trim(obj.type.toLowerCase())) {
	              case "delete":
	                setTimeout(function () {
	                  handler();
	                }, 600);
	                break;
	              case "post":
	                if (cloud.util.inString("/list", obj.url)) {
	                  handler();
	                } else {
	                  setTimeout(function () {
	                    handler();
	                  }, 600);
	                }
	                break;
	              default:
	                handler();
	                break;
	            }
	          },
	          error: function (XMLHttpRequest, textStatus, errorThrown) {
	            defaultAjaxError(XMLHttpRequest, textStatus, errorThrown);
	          }
	        });
	
	        //If this is the request queue, queue request
	        if (obj.delay) {
	          var delay = obj.delay;
	          delete obj.delay;
	          setTimeout(function () {
	            return $.ajax(obj);
	          }, delay);
	        } else {
	          return $.ajax(obj);
	        }
	
	      },
	
	      // clear access token and refresh token in session storage.
	      _logout: function (jump) {
	        this._setAccessToken(null);
	        this._setRefreshToken(null);
	
	        if (jump) {
	          window.location.href = this.errorURL;
	        }
	      },
	
	      clearDelay: function () {
	        this.delayRequests.times = 0;
	        this.delayRequests.intervalTime = 0;
	        this.delayRequests.url = null;
	        this.delayRequests.type = null;
	        this.delayRequests.param = null;
	        this.delayRequests.parameters = null;
	        this.delayRequests.data = null;
	      },
	
	      //public ajax request
	      request: function (options) {
	        var self = this;
	        options.url = $.trim(options.url);
	        options.url = this.server + (options.url.startsWith("/") ? "" : "/") + options.url;
	        if (options.delay && $.isNumeric(options.delay)) {
	          var optionsUrl = options.url.split("/");
	          optionsUrl = (optionsUrl[1] + "/" + optionsUrl[2]).toLowerCase();
	          var optionsType = options.type.toLowerCase();
	          var optionsParam = null;
	          var optionsParameters = null;
	          var optionsData = null;
	          var questionMarkIndex = options.url.indexOf("?");
	          if (questionMarkIndex != -1) {
	            optionsParam = options.url.substring(questionMarkIndex + 1).toLowerCase();
	          }
	          if (options.parameters) {
	            optionsParameters = Object.toQueryString(options.parameters);
	          }
	          if (options.data) {
	            optionsData = Object.toQueryString(data);
	          }
	          if (this.delayRequests.url != optionsUrl || this.delayRequests.type != optionsType || self.delayRequests.param != optionsParam || self.delayRequests.parameters != optionsParameters || self.delayRequests.data != optionsData) {
	            self.delayRequests.times = 1;
	            self.delayRequests.intervalTime = options.delay;
	            self.delayRequests.url = optionsUrl;
	            self.delayRequests.type = optionsType;
	            self.delayRequests.param = optionsParam;
	            self.delayRequests.parameters = optionsParameters;
	            self.delayRequests.data = optionsData;
	          } else {
	            self.delayRequests.times++;
	            if (self.delayRequests.intervalTime != options.delay) {
	              options.delay = (self.delayRequests.times - 1) * self.delayRequests.intervalTime + options.delay;
	            } else {
	              options.delay = self.delayRequests.times * self.delayRequests.intervalTime;
	            }
	          }
	        }
	        if (options.parameters) {
	          options.parameters = Object.isString(options.parameters) ? options.parameters : Object.toQueryString(options.parameters);
	          options.url += (options.url.include('?') ? '&' : '?') + options.parameters;
	          delete options.parameters;
	        }
	        if (Prototype.Browser.IE) {
	          options.url += (options.url.include('?') ? '&' : '?') + "random=" + Math.random();
	        }
	        if (options.data && ($.isPlainObject(options.data)) && (options.type.toUpperCase() == "POST" || options.type.toUpperCase() == "PUT")) {
	          options.data = Object.toJSON(options.data);
	        }
	        var obj = {
	          type: "GET",
	          dataType: "JSON",
	          contentType: "application/json;charset=UTF-8",
	          processData: false,
	          timeout: 120000
	        };
	        obj = Object.extend(obj, options);
	        return this._request(obj);
	      },
	
	      /*
	       * @name Ajax.login
	       * @type {method}
	       * @description "用户登录"
	       * @param {Object} options.
	       */
	      login: function (options) {
	        var self = this;
	        if ((Object.isString(options.username) && options.username.strip().empty()) && (Object.isString(options.password) && options.password.strip().empty())) {
	          dialog.render({
	            lang: "username_or_password_cannot_be_null"
	          });
	          return;
	        }
	        var params = Object.extend({}, this.defaultAuthOptions);
	        params.data.grant_type = "password";
	        params.data.username = options.username;
	        params.data.password = options.password.md5();
	        params.data.pictureId = options.pictureId;
	        params.data.code = options.code;
	        params.data.language = options.language;
	        params.type = "POST";
	        params.success = function (data) {
	          window.location.href = options.redirectURL;
	          self._setAccessToken(data.access_token);
	          self._setRefreshToken(data.refresh_token);
	        };
	        if (options.error) {
	          params.error = options.error;
	        }
	        params.url = options.url;
	        params.data = Object.toJSON(params.data);
	        this._request(params);
	      },
	
	      /*
	       * @name Ajax.logout
	       * @type {method}
	       * @description "用户注销"
	       */
	      logout: function () {
	        var self = this;
	        this.request({
	          url: "api2/logout",
	          type: "GET",
	          error: function () {
	            self._logout(true);
	          },
	          success: function () {
	            self._logout(true);
	          }
	        });
	      },
	
	      /*
	       * Check login state
	       */
	      checkLogin: function () {
	        if (!this.getAccessToken() || !this._getRefreshToken()) {
	          this._logout(true);
	        }
	      }
	
	    };
	
	  })();
	
	  /*
	   * @author Jerolin
	   * @name PrivilegeMap
	   * @type {method}
	   * @return {Object}
	   */
	  cloud.PrivilegeMap = (function () {
	
	    return $H({
	      1: {
	        name: 'readSystem',
	        displayName: "读取系统信息"
	      },
	      2: {
	        name: "writeSystem",
	        displayName: "增删改系统信息"
	      },
	      3: {
	        name: "readOrganization",
	        displayName: "读取机构"
	      },
	      4: {
	        name: "writeOrganization",
	        displayName: "增删改机构"
	      },
	      5: {
	        name: "readUser",
	        displayName: "读取用户"
	      },
	      6: {
	        name: "writeUser",
	        displayName: "增删改用户"
	      },
	      7: {
	        name: "readRole",
	        displayName: "读取角色"
	      },
	      8: {
	        name: "writeRole",
	        displayName: "增删改角色"
	      },
	      9: {
	        name: "readClient",
	        displayName: "读取客户端"
	      },
	      10: {
	        name: "writeClient",
	        displayName: "增删改客户端"
	      },
	      11: {
	        name: "readDevice",
	        displayName: "读取设备"
	      },
	      12: {
	        name: "writeDevice",
	        displayName: "增删改设备"
	      },
	      13: {
	        name: "readModel",
	        displayName: "读取机型"
	      },
	      14: {
	        name: "writeModel",
	        displayName: "增删改机型"
	      },
	      15: {
	        name: "readTag",
	        displayName: "读取标签"
	      },
	      16: {
	        name: "writeTag",
	        displayName: "增删改标签"
	      },
	      17: {
	        name: "readCustomer",
	        displayName: "读取客户"
	      },
	      18: {
	        name: "writeCustomer",
	        displayName: "增删改客户"
	      },
	      19: {
	        name: "readData",
	        displayName: "读取数据"
	      },
	      20: {
	        name: "writeData",
	        displayName: "增删改数据"
	      },
	      21: {
	        name: "readConfig",
	        displayName: "获取配置"
	      }
	    });
	
	  })();
	
	  /*
	   * @name PrivilegeManager
	   * @description  "Privilege Manager"
	   * @author Jerolin
	   * @return Object
	   */
	  cloud.PrivilegeManager = (function () {
	
	    return {
	
	      url: "api2/users/this/privilege",
	      userPrivileges: null,
	      privileges: cloud.PrivilegeMap,
	
	      load: function () {
	        this.userPrivileges = {
	          accept: [1, 2, 3],
	          deny: [4, 5, 6],
	          'default': "none"
	        };
	      },
	
	      PrivilegeList: function (callback) {
	        cloud.Ajax.request({
	          url: this.url,
	          type: "get",
	          async: false,
	          success: (function (data) {
	            result = data.result;
	            this.userPrivileges = {
	              accept: result.accept,
	              deny: result.deny,
	              'default': result["default"]
	            };
	            if (callback) {
	              callback(this.privilegesId);
	            }
	          }).bind(this)
	        });
	      },
	
	      process: function () {
	        var nodes = $("[privilege]");
	        var node, id;
	        for (var i = 0; i < nodes.length; i++) {
	          node = $(nodes[i]);
	          id = node.attr("privilege");
	          if (!this.can(id)) {
	            node.hide();
	          }
	        }
	      },
	
	      can: function (id) {
	        var self = this;
	        this.privilegesId = id;
	        if (!this.userPrivileges) {
	          this.PrivilegeList(function () {
	            self.canFun();
	          });
	        } else {
	          this.canFun(this.privilegesId);
	        }
	        // console.log(this.privileges.get(id));
	        // for (var deny in this.userPrivileges.deny) {
	        // if (this.userPrivileges.deny[deny] == id) {
	        // return false;
	        // }
	        // }
	        // for (var accept in this.userPrivileges.accept) {
	        // if (this.userPrivileges.accept[accept] == id) {
	        // return true;
	        // }
	        // }
	        // switch (this.userPrivileges['default']) {
	        // case "all":
	        // return true;
	        // case "none":
	        // return false;
	        // case "readOnly":
	        // return this.privileges.get(id).name.indexOf("read") === 0;
	        // default:
	        // return false;
	        // }
	      },
	
	      canFun: function (id) {
	        for (var deny in this.userPrivileges.deny) {
	          if (this.userPrivileges.deny[deny] == id) {
	            return false;
	          }
	        }
	        for (var accept in this.userPrivileges.accept) {
	          if (this.userPrivileges.accept[accept] == id) {
	            return true;
	          }
	        }
	        switch (this.userPrivileges['default']) {
	          case "all":
	            return true;
	          case "none":
	            return false;
	          case "readOnly":
	            return this.privileges.get(id).name.indexOf("read") === 0;
	          default:
	            return false;
	        }
	      }
	
	    };
	
	  })();
	
	  /*
	   * Cloud Module,Cloud Component
	   * @author Jerolin
	   * @return {Object}
	   */
	  (function () {
	
	    /*
	     * Events
	     * @author Jerolin
	     * @param {Object} object If the handlers dosn't have a scope, use this to replace.
	     */
	    var Events = {
	
	      initialize: function () {
	        this.listeners = $H();
	      },
	
	      destroy: function () {
	        this.listeners = null;
	      },
	
	      /*
	       * Observe events
	       * @param {Object} events
	       */
	      on: function (events) {
	        events = $H(events);
	        var scope = events.get("scope");
	        scope = scope || this;
	
	        events.each(function (event) {
	          if (event.key != "scope") {
	            this.observe(event.key, scope, event.value);
	          }
	        }.bind(this));
	      },
	
	      bind: function () {
	        this.observe.apply(this, arguments);
	      },
	
	      /*
	       * Observe one event.
	       * @param {Object} type Event type.
	       * @param {Object} scope Which in event handler function "this" pointed.
	       * @param {Object} handler Event callback.
	       */
	      observe: function (type, scope, handler) {
	
	        if (Object.isFunction(scope) && Object.isUndefined(handler)) {
	          handler = scope;
	          scope = this;
	        }
	
	        if (handler !== null) {
	          var listeners = this.listeners.get(type);
	
	          // if listeners dosn't have this type of event, create one.
	          if (typeof listeners === "undefined") {
	            listeners = $A();
	            this.listeners.set(type, listeners);
	          }
	
	          listeners.push({
	            scope: scope,
	            handler: handler
	          });
	        }
	
	      },
	
	      /*
	       * Unbind a event.
	       * @param {Object} type
	       * @param {Object} handler
	       */
	      stopObserving: function (type, handler) {
	        var listeners = this.listeners.get(type);
	
	        if (listeners !== null) {
	          if (!handler) {
	            listeners.clear();
	            listeners = null;
	            this.listeners.unset(type);
	          } else {
	            for (var i = 0; i < listeners.length; i++) {
	              if (listeners[i].handler == handler) {
	                listeners.splice(i, 1);
	                break;
	              }
	            }
	
	            if (listeners.size() === 0) {
	              listeners = null;
	              this.listeners.unset(type);
	            }
	          }
	        }
	      },
	
	      /*
	       * Trigger an event with args.
	       * @param {Object} type Event type
	       * @param {Object} args Arguments to pass to the handler.
	       */
	      fire: function (type) {
	        var listeners = this.listeners.get(type);
	        var continueChain;
	
	        var args = $A(arguments).slice(1);
	
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            var callback = listeners[i];
	            // bind the context to callback.obj
	            continueChain = callback.handler.apply(callback.scope,
	              args);
	
	            if ((continueChain !== undefined) && (continueChain === false)) {
	              return false;
	              // if callback returns false, execute no more
	              // callbacks.
	              break;
	            } else {
	              return true;
	            }
	          }
	        }
	      }
	
	    };
	
	    var Maskable = {
	
	      isMasked: function () {
	        return cloud.util.isMasked(this.element);
	      },
	
	      mask: function (label) {
	        cloud.util.mask(this.element, label);
	      },
	
	      unmask: function () {
	        cloud.util.unmask(this.element);
	      }
	
	    };
	
	    /*
	     * Initialize a Module, create events, unique id of the module.
	     * @author Jerolin
	     */
	    var Module = Class.create({
	      id: null,
	      moduleName: "module",
	      mixins: [Events],
	
	      initialize: function () {
	        this.mixins.each(function (mixin) {
	          cloud.util.mixin(this, mixin);
	        }, this);
	      },
	
	      mixin: function (mixin) {
	        cloud.util.mixin(this, mixin);
	      },
	
	      uniqueID: function (prefix) {
	        this.id = this.id || cloud.util.createUniqueID(prefix || (this.moduleName + "-"));
	        return this.id;
	      }
	    });
	
	    /*
	     * super component class, include an element and a default element.
	     * @author Jerolin
	     */
	    var Component = Class.create(Module, {
	      moduleName: "component",
	      defaultElement: "<div>",
	
	      initialize: function ($super, options) {
	        $super();
	        this.options = {
	          disabled: false,
	          extraClass: ""
	        };
	        $.extend(this.options, options || {});
	        this.id = this.options.id || null;
	        options.selector = $(options.selector || this.template || this.defaultElement)[0];
	        this.element = $(options.selector).addClass(this.options.extraClass);
	        if (options.container) {
	          this.element.appendTo(options.container);
	        }
	
	        if (options.events) {
	          this.on(options.events);
	        }
	        this.uniqueID();
	        this.mixin(Maskable);
	
	        this.destroyed = false;
	      },
	
	      uniqueID: function ($super) {
	        this.id = this.element.attr("id") || $super();
	        this.element.attr("id", this.id);
	      },
	
	      destroy: function () {
	        this.id = null;
	//				this.element && (this.element.remove());
	        if (this.element) this.element.remove();
	        this.element = null;
	        this.moduleName = null;
	        this.destroyed = true;
	      },
	
	      enable: function () {
	        this.options.disabled = false;
	        this.element.removeClass("state-disabled");
	      },
	
	      disable: function () {
	        this.options.disabled = true;
	        this.element.addClass("state-disabled");
	      },
	
	      errorMessage: function (text) {
	        $.pnotify({
	          text: text,
	          type: 'error',
	          history: false,
	          styling: 'jqueryui',
	          cornerclass: 'ui-pnotify-sharp'
	        });
	      },
	
	      appendTo: function (dest) {
	        if (dest instanceof cloud.Component) {
	          dest.element.append(this.element);
	        } else if (dest instanceof jQuery) {
	          dest.append(this.element);
	        }
	      },
	
	      show: function () {
	        this.element.show();
	      },
	
	      hide: function () {
	        this.element.hide();
	      }
	    });
	
	    var View = Class.create(Component, {
	      moduleName: "view",
	
	      initialize: function ($super, options) {
	        $super(options);
	        var self = this;
	
	        if (options.parent) {
	          this.parent = options.parent;
	        }
	
	        this.context = new Context({
	          view: this,
	          parent: this.parent ? this.parent.$getContext() : null
	        });
	
	        if (options.contextAttrs) {
	          $.extend(this.context, options.contextAttrs);
	        }
	        ;
	
	        if (options.controllerCls) {
	          this.controller = new options.controllerCls({
	            context: this.context,
	            parent: this.parent ? this.parent.$getController() : null
	          });
	        } else {
	          this.controller = null;
	        }
	
	        this.$control(this.context);
	      },
	
	      $control: function (context) {
	
	      },
	
	      $getContext: function () {
	        return this.context;
	      },
	
	      $getController: function () {
	        return this.controller;
	      },
	
	      destroy: function ($super) {
	        //TODO  can not call $super because of a bug in platform.js
	        this.context.$destroy();
	        this.context = null;
	        this.controller && this.controller.destroy();
	        this.parent = null;
	        $super();
	      },
	    });
	
	    var Controller = Class.create(Module, {
	      moduleName: "controller",
	
	      initialize: function ($super, options) {
	        $super(options);
	        $.extend(this.options, options || {});
	
	        //hold context, call Model
	        this.view = options.context._$view;// view is required
	        this.parent = options.parent;
	
	        this.context = options.context;
	
	//                this.parent = null;
	        this.$prepare(this.context, this.view);
	
	        this.$control(this.context, this.view);
	
	      },
	
	      $prepare: function (context, view) {
	
	      },
	
	      $control: function (context, view) {
	
	      },
	
	      destroy: function () {
	        this.context = null;
	        this.parent = null;
	        this.view = null;
	      },
	    });
	
	    var Context = Class.create({
	      _moduleName: "context",
	
	      initialize: function (options) {
	        $.extend(this._$options, options || {});
	
	        this._$view = options.view;//view is required
	        this._$id = this._$view.id;
	
	        this._$parent = null;
	        if (options.parent) {
	          this.$setParent(options.parent);
	        }
	
	        this._$childrens = $H();
	
	        this._$subs = null;
	
	        this._$channel = Postal.channel(this._$id);
	        this._$attrs = $H();//chain ?
	      },
	
	      //broadcast to parent context
	      $emitAll: function (name, data) {
	        if (this._$parent) {
	          this._$parent.$emitAll(name, data);//TODO chain or just one level up?
	        } else {
	          this.$broadcast(name, data);
	        }
	      },
	
	      $emit: function (name, data) {
	        if (this._$parent) {
	          this._$parent.$broadcast(name, data, true);
	        }
	        this.$broadcast(name, data);
	      },
	
	      $broadcast: function (name, data, noCascade) {
	//                this._$channel.publish(name, data);
	        cloud.message.post(this._$id, name, data);
	
	        if (!noCascade) {
	          this._$childrens.each(function (child) {
	            child.value.$broadcast(name, data);
	          })
	        }
	      },
	
	      //TODO scope support
	      $on: function (subscribes) {
	        var self = this;
	        cloud.message.on(this._$id, subscribes);
	        /*$H(subscribes).each(function(one){
	         self.subs.each(function(sub){
	         if (sub.callback == one.value){
	         //                            console.log("equals!")
	         }else{
	         //                            console.log("not equal!");
	         }
	         })
	
	         self._$subs.push(self._$channel.subscribe(one.key, one.value));
	         })*/
	      },
	
	      /*setAttr : function(name, data){
	
	       },
	
	       getAttr : function(name){
	
	       },*/
	
	      $setParent: function (context) {
	        this._$parent = context;
	        context.$addChild(this);
	      },
	
	      $getParent: function () {
	        return this._$parent;
	      },
	
	      $addChild: function (context) {
	        this._$childrens.set(context._$id, context);
	      },
	
	      $removeChild: function (context) {
	        this._$childrens.remove(context._$id);
	      },
	
	      $destroy: function () {
	        /*this._$subs.each(function(sub){
	         sub.unsubscribe();
	         });
	         this._$subs = null;*/
	//                this._$subs && this._$subs.unbind && this._$subs.unbind();
	
	        cloud.message.clearChannel(this._$id);
	
	        this._$id = null;
	        this._$view = null;
	        this._$parent = null;
	        this._$childrens.each(function (child) {
	          child.destroy && child.destroy();
	        });
	        this._$childrens = null;
	        this._$channel = null;
	      },
	    });
	
	    cloud.Module = cloud.Module || Module;
	    cloud.Component = cloud.Component || Component;
	    cloud.View = cloud.View || View;
	    cloud.Controller = cloud.Controller || Controller;
	  })();
	
	  (function () {
	    var PropWrapper = Class.create({
	      initialize: function (options) {
	        this.map = $H(options.map);
	        this.scope = options.scope;
	        this.element = $(options.scope.element || document);
	      },
	
	      setMap: function (map) {
	        this.map = map;
	      },
	
	      setBean: function (obj) {
	        var self = this;
	        $H(obj).each(function (prop) {
	          self.set(prop.key, prop.value);
	        });
	      },
	
	      getBean: function () {
	        var self = this;
	        var result = {};
	        this.map.each(function (prop) {
	          result[prop.key] = self.get(prop.key);
	        });
	        return result;
	      },
	
	      get: function (prop) {
	        var result;
	        var mapValue = this.map.get(prop);
	        var mapValueType = typeof mapValue;
	        if (mapValueType == "string") {
	          result = this.getById(mapValue);
	        } else if (mapValueType == "object") {
	          var customHandler = mapValue["$getter"];
	          if ((typeof customHandler) == "function") {
	            result = customHandler.call(this.scope, prop);
	          } else if ((typeof customHandler) == "string") {
	            result = this.getById(customHandler);
	          } else {
	//                        console.debug("PropWrapper: prop not found when get : " + prop + ". scope :", this.scope);
	          }
	        } else {
	//                    console.debug("PropWrapper: prop not found when get : " + prop + ". scope :", this.scope);
	        }
	        return result;
	      },
	
	      set: function (prop, value) {
	        var mapValue = this.map.get(prop);
	        var mapValueType = typeof mapValue;
	        if (mapValueType == "string") {
	          this.setById(mapValue, value);
	        } else if (mapValueType == "object") {
	          var customHandler = mapValue["$setter"];
	          if ((typeof customHandler) == "function") {
	            customHandler.call(this.scope, value, prop);
	          } else if ((typeof customHandler) == "string") {
	            this.setById(customHandler, value);
	          } else {
	//                        console.debug("PropWrapper: prop not found when set " + value + " to " + prop + ". scope :", this.scope);
	          }
	        } else {
	//                    console.debug("PropWrapper: prop not found when set " + value + " to " + prop + ". scope :", this.scope);
	        }
	      },
	
	      getById: function (id) {
	        return this.element.find("#" + id).val();
	      },
	
	      setById: function (id, value) {
	        this.element.find("#" + id).val(value);
	      },
	
	      destroy: function () {
	        this.map = null;
	        this.element = null;
	        this.scope = null;
	      },
	    });
	    cloud.PropWrapper = PropWrapper;
	  })()
	
	  return cloud;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1), __webpack_require__(1)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(7)(__webpack_require__(8))

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	module.exports = function(src) {
		function log(error) {
			(typeof console !== "undefined")
			&& (console.error || console.log)("[Script Loader]", error);
		}
	
		// Check for IE =< 8
		function isIE() {
			return typeof attachEvent !== "undefined" && typeof addEventListener === "undefined";
		}
	
		try {
			if (typeof execScript !== "undefined" && isIE()) {
				execScript(src);
			} else if (typeof eval !== "undefined") {
				eval.call(null, src);
			} else {
				log("EvalError: No eval function available");
			}
		} catch (error) {
			log(error);
		}
	}


/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = "/**\n * @preserve\n * Prototype JavaScript framework, version 1.7.1\n *  (c) 2005-2010 Sam Stephenson\n *\n *  Prototype is freely distributable under the terms of an MIT-style license.\n *  For details, see the Prototype web site: http://www.prototypejs.org/\n *\n *--------------------------------------------------------------------------*/\n/*\n * Prototype JavaScript framework, version 1.7.1\n *  (c) 2005-2010 Sam Stephenson\n *\n *  Prototype is freely distributable under the terms of an MIT-style license.\n *  For details, see the Prototype web site: http://www.prototypejs.org/\n *\n *--------------------------------------------------------------------------*/\nvar Prototype = {\n  Version: '1.7.1',\n  Browser: (function(){\n    var ua = navigator.userAgent;\n    // Opera (at least) 8.x+ has \"Opera\" as a [[Class]] of `window.opera`\n    // This is a safer inference than plain boolean type conversion of `window.opera`\n    var isOpera = Object.prototype.toString.call(window.opera) == '[object Opera]';\n    return {\n      IE:             !!window.attachEvent && !isOpera,\n      Opera:          isOpera,\n      WebKit:         ua.indexOf('AppleWebKit/') > -1,\n      Gecko:          ua.indexOf('Gecko') > -1 && ua.indexOf('KHTML') === -1,\n      MobileSafari:   /Apple.*Mobile/.test(ua)\n    }\n  })(),\n  BrowserFeatures: {\n    XPath: !!document.evaluate,\n    SelectorsAPI: !!document.querySelector,\n    ElementExtensions: (function() {\n      var constructor = window.Element || window.HTMLElement;\n      return !!(constructor && constructor.prototype);\n    })(),\n    SpecificElementExtensions: (function() {\n      // First, try the named class\n      if (typeof window.HTMLDivElement !== 'undefined')\n        return true;\n      var div = document.createElement('div'),\n          form = document.createElement('form'),\n          isSupported = false;\n      if (div['__proto__'] && (div['__proto__'] !== form['__proto__'])) {\n        isSupported = true;\n      }\n      div = form = null;\n      return isSupported;\n    })()\n  },\n  ScriptFragment: '<script[^>]*>([\\\\S\\\\s]*?)<\\/script\\\\s*>',\n  JSONFilter: /^\\/\\*-secure-([\\s\\S]*)\\*\\/\\s*$/,\n  emptyFunction: function() { },\n  K: function(x) { return x }\n};\nif (Prototype.Browser.MobileSafari)\n  Prototype.BrowserFeatures.SpecificElementExtensions = false;\n/* Based on Alex Arnell's inheritance implementation. */\nvar Class = (function() {\n  \n  // Some versions of JScript fail to enumerate over properties, names of which \n  // correspond to non-enumerable properties in the prototype chain\n  var IS_DONTENUM_BUGGY = (function(){\n    for (var p in { toString: 1 }) {\n      // check actual property name, so that it works with augmented Object.prototype\n      if (p === 'toString') return false;\n    }\n    return true;\n  })();\n  \n  function subclass() {};\n  function create() {\n    var parent = null, properties = $A(arguments);\n    if (Object.isFunction(properties[0]))\n      parent = properties.shift();\n    function klass() {\n      this.initialize.apply(this, arguments);\n    }\n    Object.extend(klass, Class.Methods);\n    klass.superclass = parent;\n    klass.subclasses = [];\n    if (parent) {\n      subclass.prototype = parent.prototype;\n      klass.prototype = new subclass;\n      parent.subclasses.push(klass);\n    }\n    for (var i = 0, length = properties.length; i < length; i++)\n      klass.addMethods(properties[i]);\n    if (!klass.prototype.initialize)\n      klass.prototype.initialize = Prototype.emptyFunction;\n    klass.prototype.constructor = klass;\n    return klass;\n  }\n  function addMethods(source) {\n    var ancestor   = this.superclass && this.superclass.prototype,\n        properties = Object.keys(source);\n    // IE6 doesn't enumerate `toString` and `valueOf` (among other built-in `Object.prototype`) properties,\n    // Force copy if they're not Object.prototype ones.\n    // Do not copy other Object.prototype.* for performance reasons\n    if (IS_DONTENUM_BUGGY) {\n      if (source.toString != Object.prototype.toString)\n        properties.push(\"toString\");\n      if (source.valueOf != Object.prototype.valueOf)\n        properties.push(\"valueOf\");\n    }\n    for (var i = 0, length = properties.length; i < length; i++) {\n      var property = properties[i], value = source[property];\n      if (ancestor && Object.isFunction(value) &&\n          value.argumentNames()[0] == \"$super\") {\n        var method = value;\n        value = (function(m) {\n          return function() { return ancestor[m].apply(this, arguments); };\n        })(property).wrap(method);\n        \n        // We used to use `bind` to ensure that `toString` and `valueOf`\n        // methods were called in the proper context, but now that we're \n        // relying on native bind and/or an existing polyfill, we can't rely\n        // on the nuanced behavior of whatever `bind` implementation is on\n        // the page.\n        //\n        // MDC's polyfill, for instance, doesn't like binding functions that\n        // haven't got a `prototype` property defined.\n        value.valueOf = (function(method) {\n          return function() { return method.valueOf.call(method); };\n        })(method);\n        \n        value.toString = (function(method) {\n          return function() { return method.toString.call(method); };\n        })(method);\n      }\n      this.prototype[property] = value;\n    }\n    return this;\n  }\n  return {\n    create: create,\n    Methods: {\n      addMethods: addMethods\n    }\n  };\n})();\n(function() {\n  var _toString = Object.prototype.toString,\n      _hasOwnProperty = Object.prototype.hasOwnProperty,\n      NULL_TYPE = 'Null',\n      UNDEFINED_TYPE = 'Undefined',\n      BOOLEAN_TYPE = 'Boolean',\n      NUMBER_TYPE = 'Number',\n      STRING_TYPE = 'String',\n      OBJECT_TYPE = 'Object',\n      FUNCTION_CLASS = '[object Function]',\n      BOOLEAN_CLASS = '[object Boolean]',\n      NUMBER_CLASS = '[object Number]',\n      STRING_CLASS = '[object String]',\n      ARRAY_CLASS = '[object Array]',\n      DATE_CLASS = '[object Date]',\n      NATIVE_JSON_STRINGIFY_SUPPORT = window.JSON &&\n        typeof JSON.stringify === 'function' &&\n        JSON.stringify(0) === '0' &&\n        typeof JSON.stringify(Prototype.K) === 'undefined';\n        \n  \n  \n  var DONT_ENUMS = ['toString', 'toLocaleString', 'valueOf',\n   'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'];\n  \n  // Some versions of JScript fail to enumerate over properties, names of which \n  // correspond to non-enumerable properties in the prototype chain\n  var IS_DONTENUM_BUGGY = (function(){\n    for (var p in { toString: 1 }) {\n      // check actual property name, so that it works with augmented Object.prototype\n      if (p === 'toString') return false;\n    }\n    return true;\n  })();\n        \n  function Type(o) {\n    switch(o) {\n      case null: return NULL_TYPE;\n      case (void 0): return UNDEFINED_TYPE;\n    }\n    var type = typeof o;\n    switch(type) {\n      case 'boolean': return BOOLEAN_TYPE;\n      case 'number':  return NUMBER_TYPE;\n      case 'string':  return STRING_TYPE;\n    }\n    return OBJECT_TYPE;\n  }\n  \n  function extend(destination, source) {\n    for (var property in source)\n      destination[property] = source[property];\n    return destination;\n  }\n  function inspect(object) {\n    try {\n      if (isUndefined(object)) return 'undefined';\n      if (object === null) return 'null';\n      return object.inspect ? object.inspect() : String(object);\n    } catch (e) {\n      if (e instanceof RangeError) return '...';\n      throw e;\n    }\n  }\n  function toJSON(value) {\n    return Str('', { '': value }, []);\n  }\n  function Str(key, holder, stack) {\n    var value = holder[key];\n    if (Type(value) === OBJECT_TYPE && typeof value.toJSON === 'function') {\n      value = value.toJSON(key);\n    }\n    var _class = _toString.call(value);\n    switch (_class) {\n      case NUMBER_CLASS:\n      case BOOLEAN_CLASS:\n      case STRING_CLASS:\n        value = value.valueOf();\n    }\n    switch (value) {\n      case null: return 'null';\n      case true: return 'true';\n      case false: return 'false';\n    }\n    var type = typeof value;\n    switch (type) {\n      case 'string':\n        return value.inspect(true);\n      case 'number':\n        return isFinite(value) ? String(value) : 'null';\n      case 'object':\n        for (var i = 0, length = stack.length; i < length; i++) {\n          if (stack[i] === value) {\n            throw new TypeError(\"Cyclic reference to '\" + value + \"' in object\");\n          }\n        }\n        stack.push(value);\n        var partial = [];\n        if (_class === ARRAY_CLASS) {\n          for (var i = 0, length = value.length; i < length; i++) {\n            var str = Str(i, value, stack);\n            partial.push(typeof str === 'undefined' ? 'null' : str);\n          }\n          partial = '[' + partial.join(',') + ']';\n        } else {\n          var keys = Object.keys(value);\n          for (var i = 0, length = keys.length; i < length; i++) {\n            var key = keys[i], str = Str(key, value, stack);\n            if (typeof str !== \"undefined\") {\n               partial.push(key.inspect(true)+ ':' + str);\n             }\n          }\n          partial = '{' + partial.join(',') + '}';\n        }\n        stack.pop();\n        return partial;\n    }\n  }\n  function stringify(object) {\n    return JSON.stringify(object);\n  }\n  function toQueryString(object) {\n    return $H(object).toQueryString();\n  }\n  function toHTML(object) {\n    return object && object.toHTML ? object.toHTML() : String.interpret(object);\n  }\n  function keys(object) {\n    if (Type(object) !== OBJECT_TYPE) { throw new TypeError(); }\n    var results = [];\n    for (var property in object) {\n      if (_hasOwnProperty.call(object, property))\n        results.push(property);\n    }\n    \n    // Account for the DontEnum properties in affected browsers.\n    if (IS_DONTENUM_BUGGY) {\n      for (var i = 0; property = DONT_ENUMS[i]; i++) {\n        if (_hasOwnProperty.call(object, property))\n          results.push(property);\n      }\n    }\n    \n    return results;\n  }\n  function values(object) {\n    var results = [];\n    for (var property in object)\n      results.push(object[property]);\n    return results;\n  }\n  function clone(object) {\n    return extend({ }, object);\n  }\n  function isElement(object) {\n    return !!(object && object.nodeType == 1);\n  }\n  function isArray(object) {\n    return _toString.call(object) === ARRAY_CLASS;\n  }\n  \n  var hasNativeIsArray = (typeof Array.isArray == 'function') \n    && Array.isArray([]) && !Array.isArray({});\n  \n  if (hasNativeIsArray) {\n    isArray = Array.isArray;\n  }\n  function isHash(object) {\n    return object instanceof Hash;\n  }\n  function isFunction(object) {\n    return _toString.call(object) === FUNCTION_CLASS;\n  }\n  function isString(object) {\n    return _toString.call(object) === STRING_CLASS;\n  }\n  function isNumber(object) {\n    return _toString.call(object) === NUMBER_CLASS;\n  }\n  \n  function isDate(object) {\n    return _toString.call(object) === DATE_CLASS;\n  }\n  function isUndefined(object) {\n    return typeof object === \"undefined\";\n  }\n  extend(Object, {\n    extend:        extend,\n    inspect:       inspect,\n    toJSON:        NATIVE_JSON_STRINGIFY_SUPPORT ? stringify : toJSON,\n    toQueryString: toQueryString,\n    toHTML:        toHTML,\n    keys:          Object.keys || keys,\n    values:        values,\n    clone:         clone,\n    isElement:     isElement,\n    isArray:       isArray,\n    isHash:        isHash,\n    isFunction:    isFunction,\n    isString:      isString,\n    isNumber:      isNumber,\n    isDate:        isDate,\n    isUndefined:   isUndefined\n  });\n})();\nObject.extend(Function.prototype, (function() {\n  var slice = Array.prototype.slice;\n  function update(array, args) {\n    var arrayLength = array.length, length = args.length;\n    while (length--) array[arrayLength + length] = args[length];\n    return array;\n  }\n  function merge(array, args) {\n    array = slice.call(array, 0);\n    return update(array, args);\n  }\n  function argumentNames() {\n    var names = this.toString().match(/^[\\s\\(]*function[^(]*\\(([^)]*)\\)/)[1]\n      .replace(/\\/\\/.*?[\\r\\n]|\\/\\*(?:.|[\\r\\n])*?\\*\\//g, '')\n      .replace(/\\s+/g, '').split(',');\n    return names.length == 1 && !names[0] ? [] : names;\n  }\n  function bind(context) {\n    if (arguments.length < 2 && Object.isUndefined(arguments[0]))\n      return this;\n    if (!Object.isFunction(this))\n      throw new TypeError(\"The object is not callable.\");\n      \n    var nop = function() {};\n    var __method = this, args = slice.call(arguments, 1);\n    \n    var bound = function() {\n      var a = merge(args, arguments);\n      // Ignore the supplied context when the bound function is called with\n      // the \"new\" keyword.\n      var c = this instanceof bound ? this : context;\n      return __method.apply(c, a);\n    };\n        \n    nop.prototype   = this.prototype;\n    bound.prototype = new nop();\n    return bound;\n  }\n  function bindAsEventListener(context) {\n    var __method = this, args = slice.call(arguments, 1);\n    return function(event) {\n      var a = update([event || window.event], args);\n      return __method.apply(context, a);\n    }\n  }\n  function curry() {\n    if (!arguments.length) return this;\n    var __method = this, args = slice.call(arguments, 0);\n    return function() {\n      var a = merge(args, arguments);\n      return __method.apply(this, a);\n    }\n  }\n  function delay(timeout) {\n    var __method = this, args = slice.call(arguments, 1);\n    timeout = timeout * 1000;\n    return window.setTimeout(function() {\n      return __method.apply(__method, args);\n    }, timeout);\n  }\n  function defer() {\n    var args = update([0.01], arguments);\n    return this.delay.apply(this, args);\n  }\n  function wrap(wrapper) {\n    var __method = this;\n    return function() {\n      var a = update([__method.bind(this)], arguments);\n      return wrapper.apply(this, a);\n    }\n  }\n  function methodize() {\n    if (this._methodized) return this._methodized;\n    var __method = this;\n    return this._methodized = function() {\n      var a = update([this], arguments);\n      return __method.apply(null, a);\n    };\n  }\n  \n  var extensions = {\n    argumentNames:       argumentNames,\n    bindAsEventListener: bindAsEventListener,\n    curry:               curry,\n    delay:               delay,\n    defer:               defer,\n    wrap:                wrap,\n    methodize:           methodize\n  };\n  \n  if (!Function.prototype.bind)\n    extensions.bind = bind;\n  return extensions;\n})());\n(function(proto) {\n  \n  \n  function toISOString() {\n    return this.getUTCFullYear() + '-' +\n      (this.getUTCMonth() + 1).toPaddedString(2) + '-' +\n      this.getUTCDate().toPaddedString(2) + 'T' +\n      this.getUTCHours().toPaddedString(2) + ':' +\n      this.getUTCMinutes().toPaddedString(2) + ':' +\n      this.getUTCSeconds().toPaddedString(2) + 'Z';\n  }\n  \n  function toJSON() {\n    return this.toISOString();\n  }\n  \n  if (!proto.toISOString) proto.toISOString = toISOString;\n  if (!proto.toJSON) proto.toJSON = toJSON;\n  \n})(Date.prototype);\nRegExp.prototype.match = RegExp.prototype.test;\nRegExp.escape = function(str) {\n  return String(str).replace(/([.*+?^=!:${}()|[\\]\\/\\\\])/g, '\\\\$1');\n};\nvar PeriodicalExecuter = Class.create({\n  initialize: function(callback, frequency) {\n    this.callback = callback;\n    this.frequency = frequency;\n    this.currentlyExecuting = false;\n    this.registerCallback();\n  },\n  registerCallback: function() {\n    this.timer = setInterval(this.onTimerEvent.bind(this), this.frequency * 1000);\n  },\n  execute: function() {\n    this.callback(this);\n  },\n  stop: function() {\n    if (!this.timer) return;\n    clearInterval(this.timer);\n    this.timer = null;\n  },\n  onTimerEvent: function() {\n    if (!this.currentlyExecuting) {\n      // IE doesn't support `finally` statements unless all errors are caught.\n      // We mimic the behaviour of `finally` statements by duplicating code\n      // that would belong in it. First at the bottom of the `try` statement\n      // (for errorless cases). Secondly, inside a `catch` statement which\n      // rethrows any caught errors.\n      try {\n        this.currentlyExecuting = true;\n        this.execute();\n        this.currentlyExecuting = false;\n      } catch(e) {\n        this.currentlyExecuting = false;\n        throw e;\n      }\n    }\n  }\n});\nObject.extend(String, {\n  interpret: function(value) {\n    return value == null ? '' : String(value);\n  },\n  specialChar: {\n    '\\b': '\\\\b',\n    '\\t': '\\\\t',\n    '\\n': '\\\\n',\n    '\\f': '\\\\f',\n    '\\r': '\\\\r',\n    '\\\\': '\\\\\\\\'\n  }\n});\nObject.extend(String.prototype, (function() {\n  var NATIVE_JSON_PARSE_SUPPORT = window.JSON &&\n    typeof JSON.parse === 'function' &&\n    JSON.parse('{\"test\": true}').test;\n  function prepareReplacement(replacement) {\n    if (Object.isFunction(replacement)) return replacement;\n    var template = new Template(replacement);\n    return function(match) { return template.evaluate(match) };\n  }\n  function gsub(pattern, replacement) {\n    var result = '', source = this, match;\n    replacement = prepareReplacement(replacement);\n    if (Object.isString(pattern))\n      pattern = RegExp.escape(pattern);\n    if (!(pattern.length || pattern.source)) {\n      replacement = replacement('');\n      return replacement + source.split('').join(replacement) + replacement;\n    }\n    while (source.length > 0) {\n      match = source.match(pattern);\n      if (match && match[0].length > 0) {\n        result += source.slice(0, match.index);\n        result += String.interpret(replacement(match));\n        source  = source.slice(match.index + match[0].length);\n      } else {\n        result += source, source = '';\n      }\n    }\n    return result;\n  }\n  function sub(pattern, replacement, count) {\n    replacement = prepareReplacement(replacement);\n    count = Object.isUndefined(count) ? 1 : count;\n    return this.gsub(pattern, function(match) {\n      if (--count < 0) return match[0];\n      return replacement(match);\n    });\n  }\n  function scan(pattern, iterator) {\n    this.gsub(pattern, iterator);\n    return String(this);\n  }\n  function truncate(length, truncation) {\n    length = length || 30;\n    truncation = Object.isUndefined(truncation) ? '...' : truncation;\n    return this.length > length ?\n      this.slice(0, length - truncation.length) + truncation : String(this);\n  }\n  function strip() {\n    return this.replace(/^\\s+/, '').replace(/\\s+$/, '');\n  }\n  function stripTags() {\n    return this.replace(/<\\w+(\\s+(\"[^\"]*\"|'[^']*'|[^>])+)?>|<\\/\\w+>/gi, '');\n  }\n  function stripScripts() {\n    return this.replace(new RegExp(Prototype.ScriptFragment, 'img'), '');\n  }\n  function extractScripts() {\n    var matchAll = new RegExp(Prototype.ScriptFragment, 'img'),\n        matchOne = new RegExp(Prototype.ScriptFragment, 'im');\n    return (this.match(matchAll) || []).map(function(scriptTag) {\n      return (scriptTag.match(matchOne) || ['', ''])[1];\n    });\n  }\n  function evalScripts() {\n    return this.extractScripts().map(function(script) { return eval(script); });\n  }\n  function escapeHTML() {\n    return this.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');\n  }\n  function unescapeHTML() {\n    // Warning: In 1.7 String#unescapeHTML will no longer call String#stripTags.\n    return this.stripTags().replace(/&lt;/g,'<').replace(/&gt;/g,'>').replace(/&amp;/g,'&');\n  }\n  function toQueryParams(separator) {\n    var match = this.strip().match(/([^?#]*)(#.*)?$/);\n    if (!match) return { };\n    return match[1].split(separator || '&').inject({ }, function(hash, pair) {\n      if ((pair = pair.split('='))[0]) {\n        var key = decodeURIComponent(pair.shift()),\n            value = pair.length > 1 ? pair.join('=') : pair[0];\n        if (value != undefined) {\n          value = value.gsub('+', ' ');\n          value = decodeURIComponent(value);\n        }\n        if (key in hash) {\n          if (!Object.isArray(hash[key])) hash[key] = [hash[key]];\n          hash[key].push(value);\n        }\n        else hash[key] = value;\n      }\n      return hash;\n    });\n  }\n  function toArray() {\n    return this.split('');\n  }\n  function succ() {\n    return this.slice(0, this.length - 1) +\n      String.fromCharCode(this.charCodeAt(this.length - 1) + 1);\n  }\n  function times(count) {\n    return count < 1 ? '' : new Array(count + 1).join(this);\n  }\n  function camelize() {\n    return this.replace(/-+(.)?/g, function(match, chr) {\n      return chr ? chr.toUpperCase() : '';\n    });\n  }\n  function capitalize() {\n    return this.charAt(0).toUpperCase() + this.substring(1).toLowerCase();\n  }\n  function underscore() {\n    return this.replace(/::/g, '/')\n               .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')\n               .replace(/([a-z\\d])([A-Z])/g, '$1_$2')\n               .replace(/-/g, '_')\n               .toLowerCase();\n  }\n  function dasherize() {\n    return this.replace(/_/g, '-');\n  }\n  function inspect(useDoubleQuotes) {\n    var escapedString = this.replace(/[\\x00-\\x1f\\\\]/g, function(character) {\n      if (character in String.specialChar) {\n        return String.specialChar[character];\n      }\n      return '\\\\u00' + character.charCodeAt().toPaddedString(2, 16);\n    });\n    if (useDoubleQuotes) return '\"' + escapedString.replace(/\"/g, '\\\\\"') + '\"';\n    return \"'\" + escapedString.replace(/'/g, '\\\\\\'') + \"'\";\n  }\n  function unfilterJSON(filter) {\n    return this.replace(filter || Prototype.JSONFilter, '$1');\n  }\n  function isJSON() {\n    var str = this;\n    if (str.blank()) return false;\n    str = str.replace(/\\\\(?:[\"\\\\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@');\n    str = str.replace(/\"[^\"\\\\\\n\\r]*\"|true|false|null|-?\\d+(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?/g, ']');\n    str = str.replace(/(?:^|:|,)(?:\\s*\\[)+/g, '');\n    return (/^[\\],:{}\\s]*$/).test(str);\n  }\n  function evalJSON(sanitize) {\n    var json = this.unfilterJSON(),\n        cx = /[\\u0000\\u00ad\\u0600-\\u0604\\u070f\\u17b4\\u17b5\\u200c-\\u200f\\u2028-\\u202f\\u2060-\\u206f\\ufeff\\ufff0-\\uffff]/g;\n    if (cx.test(json)) {\n      json = json.replace(cx, function (a) {\n        return '\\\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);\n      });\n    }\n    try {\n      if (!sanitize || json.isJSON()) return eval('(' + json + ')');\n    } catch (e) { }\n    throw new SyntaxError('Badly formed JSON string: ' + this.inspect());\n  }\n  \n  function parseJSON() {\n    var json = this.unfilterJSON();\n    return JSON.parse(json);\n  }\n  function include(pattern) {\n    return this.indexOf(pattern) !== -1;\n  }\n  function startsWith(pattern, position) {\n    position = Object.isNumber(position) ? position : 0;\n    // We use `lastIndexOf` instead of `indexOf` to avoid tying execution\n    // time to string length when string doesn't start with pattern.\n    return this.lastIndexOf(pattern, position) === position;\n  }\n  function endsWith(pattern, position) {\n    pattern = String(pattern);\n    position = Object.isNumber(position) ? position : this.length;\n    if (position < 0) position = 0;\n    if (position > this.length) position = this.length;\n    var d = position - pattern.length;\n    // We use `indexOf` instead of `lastIndexOf` to avoid tying execution\n    // time to string length when string doesn't end with pattern.\n    return d >= 0 && this.indexOf(pattern, d) === d;\n  }\n  function empty() {\n    return this == '';\n  }\n  function blank() {\n    return /^\\s*$/.test(this);\n  }\n  function interpolate(object, pattern) {\n    return new Template(this, pattern).evaluate(object);\n  }\n  return {\n    gsub:           gsub,\n    sub:            sub,\n    scan:           scan,\n    truncate:       truncate,\n    // Firefox 3.5+ supports String.prototype.trim\n    // (`trim` is ~ 5x faster than `strip` in FF3.5)\n    strip:          String.prototype.trim || strip,\n    stripTags:      stripTags,\n    stripScripts:   stripScripts,\n    extractScripts: extractScripts,\n    evalScripts:    evalScripts,\n    escapeHTML:     escapeHTML,\n    unescapeHTML:   unescapeHTML,\n    toQueryParams:  toQueryParams,\n    parseQuery:     toQueryParams,\n    toArray:        toArray,\n    succ:           succ,\n    times:          times,\n    camelize:       camelize,\n    capitalize:     capitalize,\n    underscore:     underscore,\n    dasherize:      dasherize,\n    inspect:        inspect,\n    unfilterJSON:   unfilterJSON,\n    isJSON:         isJSON,\n    evalJSON:       NATIVE_JSON_PARSE_SUPPORT ? parseJSON : evalJSON,\n    //ECMA 6 supports contains(), if it exists map include() to contains()\n    include:        String.prototype.contains || include,\n    // Firefox 18+ supports String.prototype.startsWith, String.prototype.endsWith\n    startsWith:     String.prototype.startsWith || startsWith,\n    endsWith:       String.prototype.endsWith || endsWith,\n    empty:          empty,\n    blank:          blank,\n    interpolate:    interpolate\n  };\n})());\nvar Template = Class.create({\n  initialize: function(template, pattern) {\n    this.template = template.toString();\n    this.pattern = pattern || Template.Pattern;\n  },\n  evaluate: function(object) {\n    if (object && Object.isFunction(object.toTemplateReplacements))\n      object = object.toTemplateReplacements();\n    return this.template.gsub(this.pattern, function(match) {\n      if (object == null) return (match[1] + '');\n      var before = match[1] || '';\n      if (before == '\\\\') return match[2];\n      var ctx = object, expr = match[3],\n          pattern = /^([^.[]+|\\[((?:.*?[^\\\\])?)\\])(\\.|\\[|$)/;\n          \n      match = pattern.exec(expr);\n      if (match == null) return before;\n      while (match != null) {\n        var comp = match[1].startsWith('[') ? match[2].replace(/\\\\\\\\]/g, ']') : match[1];\n        ctx = ctx[comp];\n        if (null == ctx || '' == match[3]) break;\n        expr = expr.substring('[' == match[3] ? match[1].length : match[0].length);\n        match = pattern.exec(expr);\n      }\n      return before + String.interpret(ctx);\n    });\n  }\n});\nTemplate.Pattern = /(^|.|\\r|\\n)(#\\{(.*?)\\})/;\nvar $break = { };\nvar Enumerable = (function() {\n  function each(iterator, context) {\n    try {\n      this._each(iterator, context);\n    } catch (e) {\n      if (e != $break) throw e;\n    }\n    return this;\n  }\n  function eachSlice(number, iterator, context) {\n    var index = -number, slices = [], array = this.toArray();\n    if (number < 1) return array;\n    while ((index += number) < array.length)\n      slices.push(array.slice(index, index+number));\n    return slices.collect(iterator, context);\n  }\n  function all(iterator, context) {\n    iterator = iterator || Prototype.K;\n    var result = true;\n    this.each(function(value, index) {\n      if (!iterator.call(context, value, index, this)) {\n          result = false;\n          throw $break;\n      }\n    }, this);\n    return result;\n  }\n  function any(iterator, context) {\n    iterator = iterator || Prototype.K;\n    var result = false;\n    this.each(function(value, index) {\n      if (result = !!iterator.call(context, value, index, this))\n        throw $break;\n    }, this);\n    return result;\n  }\n  function collect(iterator, context) {\n    iterator = iterator || Prototype.K;\n    var results = [];\n    this.each(function(value, index) {\n      results.push(iterator.call(context, value, index, this));\n    }, this);\n    return results;\n  }\n  function detect(iterator, context) {\n    var result;\n    this.each(function(value, index) {\n      if (iterator.call(context, value, index, this)) {\n        result = value;\n        throw $break;\n      }\n    }, this);\n    return result;\n  }\n  function findAll(iterator, context) {\n    var results = [];\n    this.each(function(value, index) {\n      if (iterator.call(context, value, index, this))\n        results.push(value);\n    }, this);\n    return results;\n  }\n  function grep(filter, iterator, context) {\n    iterator = iterator || Prototype.K;\n    var results = [];\n    if (Object.isString(filter))\n      filter = new RegExp(RegExp.escape(filter));\n    this.each(function(value, index) {\n      if (filter.match(value))\n        results.push(iterator.call(context, value, index, this));\n    }, this);\n    return results;\n  }\n  function include(object) {\n    if (Object.isFunction(this.indexOf) && this.indexOf(object) != -1)\n      return true;\n    var found = false;\n    this.each(function(value) {\n      if (value == object) {\n        found = true;\n        throw $break;\n      }\n    });\n    return found;\n  }\n  function inGroupsOf(number, fillWith) {\n    fillWith = Object.isUndefined(fillWith) ? null : fillWith;\n    return this.eachSlice(number, function(slice) {\n      while(slice.length < number) slice.push(fillWith);\n      return slice;\n    });\n  }\n  function inject(memo, iterator, context) {\n    this.each(function(value, index) {\n      memo = iterator.call(context, memo, value, index, this);\n    }, this);\n    return memo;\n  }\n  function invoke(method) {\n    var args = $A(arguments).slice(1);\n    return this.map(function(value) {\n      return value[method].apply(value, args);\n    });\n  }\n  function max(iterator, context) {\n    iterator = iterator || Prototype.K;\n    var result;\n    this.each(function(value, index) {\n      value = iterator.call(context, value, index, this);\n      if (result == null || value >= result)\n        result = value;\n    }, this);\n    return result;\n  }\n  function min(iterator, context) {\n    iterator = iterator || Prototype.K;\n    var result;\n    this.each(function(value, index) {\n      value = iterator.call(context, value, index, this);\n      if (result == null || value < result)\n        result = value;\n    }, this);\n    return result;\n  }\n  function partition(iterator, context) {\n    iterator = iterator || Prototype.K;\n    var trues = [], falses = [];\n    this.each(function(value, index) {\n      (iterator.call(context, value, index, this) ?\n        trues : falses).push(value);\n    }, this);\n    return [trues, falses];\n  }\n  function pluck(property) {\n    var results = [];\n    this.each(function(value) {\n      results.push(value[property]);\n    });\n    return results;\n  }\n  function reject(iterator, context) {\n    var results = [];\n    this.each(function(value, index) {\n      if (!iterator.call(context, value, index, this))\n        results.push(value);\n    }, this);\n    return results;\n  }\n  function sortBy(iterator, context) {\n    return this.map(function(value, index) {\n      return {\n        value: value,\n        criteria: iterator.call(context, value, index, this)\n      };\n    }, this).sort(function(left, right) {\n      var a = left.criteria, b = right.criteria;\n      return a < b ? -1 : a > b ? 1 : 0;\n    }).pluck('value');\n  }\n  function toArray() {\n    return this.map();\n  }\n  function zip() {\n    var iterator = Prototype.K, args = $A(arguments);\n    if (Object.isFunction(args.last()))\n      iterator = args.pop();\n    var collections = [this].concat(args).map($A);\n    return this.map(function(value, index) {\n      return iterator(collections.pluck(index));\n    });\n  }\n  function size() {\n    return this.toArray().length;\n  }\n  function inspect() {\n    return '#<Enumerable:' + this.toArray().inspect() + '>';\n  }\n  return {\n    each:       each,\n    eachSlice:  eachSlice,\n    all:        all,\n    every:      all,\n    any:        any,\n    some:       any,\n    collect:    collect,\n    map:        collect,\n    detect:     detect,\n    findAll:    findAll,\n    select:     findAll,\n    filter:     findAll,\n    grep:       grep,\n    include:    include,\n    member:     include,\n    inGroupsOf: inGroupsOf,\n    inject:     inject,\n    invoke:     invoke,\n    max:        max,\n    min:        min,\n    partition:  partition,\n    pluck:      pluck,\n    reject:     reject,\n    sortBy:     sortBy,\n    toArray:    toArray,\n    entries:    toArray,\n    zip:        zip,\n    size:       size,\n    inspect:    inspect,\n    find:       detect\n  };\n})();\nfunction $A(iterable) {\n  if (!iterable) return [];\n  // Safari <2.0.4 crashes when accessing property of a node list with property accessor.\n  // It nevertheless works fine with `in` operator, which is why we use it here\n  if ('toArray' in Object(iterable)) return iterable.toArray();\n  var length = iterable.length || 0, results = new Array(length);\n  while (length--) results[length] = iterable[length];\n  return results;\n}\nfunction $w(string) {\n  if (!Object.isString(string)) return [];\n  string = string.strip();\n  return string ? string.split(/\\s+/) : [];\n}\nArray.from = $A;\n(function() {\n  var arrayProto = Array.prototype,\n      slice = arrayProto.slice,\n      _each = arrayProto.forEach,\n      _entries = arrayProto.entries; // use native browser JS 1.6 implementation if available\n  function each(iterator, context) {\n    for (var i = 0, length = this.length >>> 0; i < length; i++) {\n      if (i in this) iterator.call(context, this[i], i, this);\n    }\n  }\n  if (!_each) _each = each;\n  \n  function clear() {\n    this.length = 0;\n    return this;\n  }\n  function first() {\n    return this[0];\n  }\n  function last() {\n    return this[this.length - 1];\n  }\n  function compact() {\n    return this.select(function(value) {\n      return value != null;\n    });\n  }\n  function flatten() {\n    return this.inject([], function(array, value) {\n      if (Object.isArray(value))\n        return array.concat(value.flatten());\n      array.push(value);\n      return array;\n    });\n  }\n  function without() {\n    var values = slice.call(arguments, 0);\n    return this.select(function(value) {\n      return !values.include(value);\n    });\n  }\n  function reverse(inline) {\n    return (inline === false ? this.toArray() : this)._reverse();\n  }\n  function uniq(sorted) {\n    return this.inject([], function(array, value, index) {\n      if (0 == index || (sorted ? array.last() != value : !array.include(value)))\n        array.push(value);\n      return array;\n    });\n  }\n  function intersect(array) {\n    return this.uniq().findAll(function(item) {\n      return array.indexOf(item) !== -1;\n    });\n  }\n  function clone() {\n    return slice.call(this, 0);\n  }\n  function size() {\n    return this.length;\n  }\n  function inspect() {\n    return '[' + this.map(Object.inspect).join(', ') + ']';\n  }\n  function indexOf(item, i) {\n    if (this == null) throw new TypeError();\n    \n    var array = Object(this), length = array.length >>> 0;\n    if (length === 0) return -1;\n    \n    // The rules for the `fromIndex` argument are tricky. Let's follow the\n    // spec line-by-line.\n    i = Number(i);\n    if (isNaN(i)) {\n      i = 0;\n    } else if (i !== 0 && isFinite(i)) {\n      // Equivalent to ES5's `ToInteger` operation.\n      i = (i > 0 ? 1 : -1) * Math.floor(Math.abs(i));\n    }\n    \n    // If the search index is greater than the length of the array,\n    // return -1.\n    if (i > length) return -1;\n    \n    // If the search index is negative, take its absolute value, subtract it\n    // from the length, and make that the new search index. If it's still\n    // negative, make it 0.\n    var k = i >= 0 ? i : Math.max(length - Math.abs(i), 0);\n    for (; k < length; k++)\n      if (k in array && array[k] === item) return k;\n    return -1;\n  }\n  \n  function lastIndexOf(item, i) {\n    if (this == null) throw new TypeError();\n    \n    var array = Object(this), length = array.length >>> 0;\n    if (length === 0) return -1;\n    \n    // The rules for the `fromIndex` argument are tricky. Let's follow the\n    // spec line-by-line.\n    if (!Object.isUndefined(i)) {\n      i = Number(i);\n      if (isNaN(i)) {\n        i = 0;\n      } else if (i !== 0 && isFinite(i)) {\n        // Equivalent to ES5's `ToInteger` operation.\n        i = (i > 0 ? 1 : -1) * Math.floor(Math.abs(i));\n      }\n    } else {\n      i = length;\n    }\n    \n    // If fromIndex is positive, clamp it to the last index in the array;\n    // if it's negative, subtract its absolute value from the array's length.\n    var k = i >= 0 ? Math.min(i, length - 1) :\n     length - Math.abs(i);\n    // (If fromIndex is still negative, it'll bypass this loop altogether and\n    // return -1.)\n    for (; k >= 0; k--)\n      if (k in array && array[k] === item) return k;\n    return -1;\n  }\n  // Replaces a built-in function. No PDoc needed.\n  //\n  // Used instead of the broken version of Array#concat in some versions of\n  // Opera. Made to be ES5-compliant.\n  function concat(_) {\n    var array = [], items = slice.call(arguments, 0), item, n = 0;\n    items.unshift(this);\n    for (var i = 0, length = items.length; i < length; i++) {\n      item = items[i];\n      if (Object.isArray(item) && !('callee' in item)) {\n        for (var j = 0, arrayLength = item.length; j < arrayLength; j++) {\n          if (j in item) array[n] = item[j];\n          n++;\n        }\n      } else {\n        array[n++] = item;\n      }\n    }\n    array.length = n;\n    return array;\n  }\n  \n  // Certain ES5 array methods have the same names as Prototype array methods\n  // and perform the same functions.\n  //\n  // Prototype's implementations of these methods differ from the ES5 spec in\n  // the way a missing iterator function is handled. Prototype uses \n  // `Prototype.K` as a default iterator, while ES5 specifies that a\n  // `TypeError` must be thrown. Implementing the ES5 spec completely would \n  // break backward compatibility and would force users to pass `Prototype.K`\n  // manually. \n  //\n  // Instead, if native versions of these methods exist, we wrap the existing\n  // methods with our own behavior. This has very little performance impact.\n  // It violates the spec by suppressing `TypeError`s for certain methods,\n  // but that's an acceptable trade-off.\n  \n  function wrapNative(method) {\n    return function() {\n      if (arguments.length === 0) {\n        // No iterator was given. Instead of throwing a `TypeError`, use\n        // `Prototype.K` as the default iterator.\n        return method.call(this, Prototype.K);\n      } else if (arguments[0] === undefined) {\n        // Same as above.\n        var args = slice.call(arguments, 1);\n        args.unshift(Prototype.K);\n        return method.apply(this, args);\n      } else {\n        // Pass straight through to the native method.\n        return method.apply(this, arguments);\n      }\n    };\n  }\n  \n  // Note that #map, #filter, #some, and #every take some extra steps for\n  // ES5 compliance: the context in which they're called is coerced to an\n  // object, and that object's `length` property is coerced to a finite\n  // integer. This makes it easier to use the methods as generics.\n  //\n  // This means that they behave a little differently from other methods in\n  // `Enumerable`/`Array` that don't collide with ES5, but that's OK.\n  \n  function map(iterator) {\n    if (this == null) throw new TypeError();\n    iterator = iterator || Prototype.K;\n    var object = Object(this);\n    var results = [], context = arguments[1], n = 0;\n    for (var i = 0, length = object.length >>> 0; i < length; i++) {\n      if (i in object) {\n        results[n] = iterator.call(context, object[i], i, object);\n      }\n      n++;\n    }\n    results.length = n;\n    return results;\n  }\n  \n  if (arrayProto.map) {\n    map = wrapNative(Array.prototype.map);\n  }\n  \n  function filter(iterator) {\n    if (this == null || !Object.isFunction(iterator))\n      throw new TypeError();\n    \n    var object = Object(this);\n    var results = [], context = arguments[1], value;\n    for (var i = 0, length = object.length >>> 0; i < length; i++) {\n      if (i in object) {\n        value = object[i];\n        if (iterator.call(context, value, i, object)) {\n          results.push(value);\n        }\n      }\n    }\n    return results;\n  }\n  if (arrayProto.filter) {\n    // `Array#filter` requires an iterator by nature, so we don't need to\n    // wrap it.\n    filter = Array.prototype.filter;\n  }\n  function some(iterator) {\n    if (this == null) throw new TypeError();\n    iterator = iterator || Prototype.K;\n    var context = arguments[1];\n    var object = Object(this);\n    for (var i = 0, length = object.length >>> 0; i < length; i++) {\n      if (i in object && iterator.call(context, object[i], i, object)) {\n        return true;\n      }\n    }\n      \n    return false;\n  }\n  \n  if (arrayProto.some) {\n    var some = wrapNative(Array.prototype.some);\n  }\n  \n  \n  function every(iterator) {\n    if (this == null) throw new TypeError();\n    iterator = iterator || Prototype.K;\n    var context = arguments[1];\n    var object = Object(this);\n    for (var i = 0, length = object.length >>> 0; i < length; i++) {\n      if (i in object && !iterator.call(context, object[i], i, object)) {\n        return false;\n      }\n    }\n      \n    return true;\n  }\n  \n  if (arrayProto.every) {\n    var every = wrapNative(Array.prototype.every);\n  }\n  \n  function entries() {\n    if (this == null) throw new TypeError();\n    return this.map(function(i,index) {\n        return [index,i];\n    });\n  }\n  // Prototype's `Array#inject` behaves similarly to ES5's `Array#reduce`.\n  var _reduce = arrayProto.reduce;\n  function inject(memo, iterator) {\n    iterator = iterator || Prototype.K;\n    var context = arguments[2];\n    // The iterator must be bound, as `Array#reduce` always binds to\n    // `undefined`.\n    return _reduce.call(this, iterator.bind(context), memo);\n  }\n  \n  // Piggyback on `Array#reduce` if it exists; otherwise fall back to the\n  // standard `Enumerable.inject`.\n  if (!arrayProto.reduce) {\n    var inject = Enumerable.inject;\n  }\n  Object.extend(arrayProto, Enumerable);\n  if (!arrayProto._reverse)\n    arrayProto._reverse = arrayProto.reverse;\n  Object.extend(arrayProto, {\n    _each:     _each,\n    \n    map:       map,\n    collect:   map,\n    select:    filter,\n    filter:    filter,\n    findAll:   filter,\n    some:      some,\n    any:       some,\n    every:     every,\n    all:       every,\n    inject:    inject,\n    \n    clear:     clear,\n    first:     first,\n    last:      last,\n    compact:   compact,\n    flatten:   flatten,\n    without:   without,\n    reverse:   reverse,\n    uniq:      uniq,\n    intersect: intersect,\n    clone:     clone,\n    toArray:   clone,\n    size:      size,\n    inspect:   inspect,\n    entries:   _entries || entries\n  });\n  // fix for opera\n  var CONCAT_ARGUMENTS_BUGGY = (function() {\n    return [].concat(arguments)[0][0] !== 1;\n  })(1,2);\n  if (CONCAT_ARGUMENTS_BUGGY) arrayProto.concat = concat;\n  // Use native browser JS 1.6 implementations if available.\n  if (!arrayProto.indexOf) arrayProto.indexOf = indexOf;\n  if (!arrayProto.lastIndexOf) arrayProto.lastIndexOf = lastIndexOf;\n})();\nfunction $H(object) {\n  return new Hash(object);\n};\nvar Hash = Class.create(Enumerable, (function() {\n  function initialize(object) {\n    this._object = Object.isHash(object) ? object.toObject() : Object.clone(object);\n  }\n  // Docs for #each even though technically it's implemented by Enumerable\n  // Our _internal_ each\n  function _each(iterator, context) {\n    var i = 0;\n    for (var key in this._object) {\n      var value = this._object[key], pair = [key, value];\n      pair.key = key;\n      pair.value = value;\n      iterator.call(context, pair, i);\n      i++;\n    }\n  }\n  function set(key, value) {\n    return this._object[key] = value;\n  }\n  function get(key) {\n    // simulating poorly supported hasOwnProperty\n    if (this._object[key] !== Object.prototype[key])\n      return this._object[key];\n  }\n  function unset(key) {\n    var value = this._object[key];\n    delete this._object[key];\n    return value;\n  }\n  function toObject() {\n    return Object.clone(this._object);\n  }\n  \n  \n  function keys() {\n    return this.pluck('key');\n  }\n  function values() {\n    return this.pluck('value');\n  }\n  function index(value) {\n    var match = this.detect(function(pair) {\n      return pair.value === value;\n    });\n    return match && match.key;\n  }\n  function merge(object) {\n    return this.clone().update(object);\n  }\n  function update(object) {\n    return new Hash(object).inject(this, function(result, pair) {\n      result.set(pair.key, pair.value);\n      return result;\n    });\n  }\n  // Private. No PDoc necessary.\n  function toQueryPair(key, value) {\n    if (Object.isUndefined(value)) return key;\n    \n    value = String.interpret(value);\n    // Normalize newlines as \\r\\n because the HTML spec says newlines should\n    // be encoded as CRLFs.\n    value = value.gsub(/(\\r)?\\n/, '\\r\\n');\n    value = encodeURIComponent(value);\n    // Likewise, according to the spec, spaces should be '+' rather than\n    // '%20'.\n    value = value.gsub(/%20/, '+');\n    return key + '=' + value;\n  }\n  function toQueryString() {\n    return this.inject([], function(results, pair) {\n      var key = encodeURIComponent(pair.key), values = pair.value;\n      \n      if (values && typeof values == 'object') {\n        if (Object.isArray(values)) {\n          // We used to use `Array#map` here to get the query pair for each\n          // item in the array, but that caused test regressions once we\n          // added the sparse array behavior for array iterator methods.\n          // Changed to an ordinary `for` loop so that we can handle\n          // `undefined` values ourselves rather than have them skipped.\n          var queryValues = [];\n          for (var i = 0, len = values.length, value; i < len; i++) {\n            value = values[i];\n            queryValues.push(toQueryPair(key, value));            \n          }\n          return results.concat(queryValues);\n        }\n      } else results.push(toQueryPair(key, values));\n      return results;\n    }).join('&');\n  }\n  function inspect() {\n    return '#<Hash:{' + this.map(function(pair) {\n      return pair.map(Object.inspect).join(': ');\n    }).join(', ') + '}>';\n  }\n  function clone() {\n    return new Hash(this);\n  }\n  return {\n    initialize:             initialize,\n    _each:                  _each,\n    set:                    set,\n    get:                    get,\n    unset:                  unset,\n    toObject:               toObject,\n    toTemplateReplacements: toObject,\n    keys:                   keys,\n    values:                 values,\n    index:                  index,\n    merge:                  merge,\n    update:                 update,\n    toQueryString:          toQueryString,\n    inspect:                inspect,\n    toJSON:                 toObject,\n    clone:                  clone\n  };\n})());\nHash.from = $H;\nObject.extend(Number.prototype, (function() {\n  function toColorPart() {\n    return this.toPaddedString(2, 16);\n  }\n  function succ() {\n    return this + 1;\n  }\n  function times(iterator, context) {\n    $R(0, this, true).each(iterator, context);\n    return this;\n  }\n  function toPaddedString(length, radix) {\n    var string = this.toString(radix || 10);\n    return '0'.times(length - string.length) + string;\n  }\n  function abs() {\n    return Math.abs(this);\n  }\n  function round() {\n    return Math.round(this);\n  }\n  function ceil() {\n    return Math.ceil(this);\n  }\n  function floor() {\n    return Math.floor(this);\n  }\n  return {\n    toColorPart:    toColorPart,\n    succ:           succ,\n    times:          times,\n    toPaddedString: toPaddedString,\n    abs:            abs,\n    round:          round,\n    ceil:           ceil,\n    floor:          floor\n  };\n})());\nfunction $R(start, end, exclusive) {\n  return new ObjectRange(start, end, exclusive);\n}\nvar ObjectRange = Class.create(Enumerable, (function() {\n  function initialize(start, end, exclusive) {\n    this.start = start;\n    this.end = end;\n    this.exclusive = exclusive;\n  }\n  function _each(iterator, context) {\n    var value = this.start, i;\n    for (i = 0; this.include(value); i++) {\n      iterator.call(context, value, i);\n      value = value.succ();\n    }\n  }\n  function include(value) {\n    if (value < this.start)\n      return false;\n    if (this.exclusive)\n      return value < this.end;\n    return value <= this.end;\n  }\n  return {\n    initialize: initialize,\n    _each:      _each,\n    include:    include\n  };\n})());\nvar Abstract = { };\nvar Try = {\n  these: function() {\n    var returnValue;\n    for (var i = 0, length = arguments.length; i < length; i++) {\n      var lambda = arguments[i];\n      try {\n        returnValue = lambda();\n        break;\n      } catch (e) { }\n    }\n    return returnValue;\n  }\n};\nvar Ajax = {\n  getTransport: function() {\n    return Try.these(\n      function() {return new XMLHttpRequest()},\n      function() {return new ActiveXObject('Msxml2.XMLHTTP')},\n      function() {return new ActiveXObject('Microsoft.XMLHTTP')}\n    ) || false;\n  },\n  activeRequestCount: 0\n};\nAjax.Responders = {\n  responders: [],\n  _each: function(iterator, context) {\n    this.responders._each(iterator, context);\n  },\n  register: function(responder) {\n    if (!this.include(responder))\n      this.responders.push(responder);\n  },\n  unregister: function(responder) {\n    this.responders = this.responders.without(responder);\n  },\n  dispatch: function(callback, request, transport, json) {\n    this.each(function(responder) {\n      if (Object.isFunction(responder[callback])) {\n        try {\n          responder[callback].apply(responder, [request, transport, json]);\n        } catch (e) { }\n      }\n    });\n  }\n};\nObject.extend(Ajax.Responders, Enumerable);\nAjax.Responders.register({\n  onCreate:   function() { Ajax.activeRequestCount++ },\n  onComplete: function() { Ajax.activeRequestCount-- }\n});\nAjax.Base = Class.create({\n  initialize: function(options) {\n    this.options = {\n      method:       'post',\n      asynchronous: true,\n      contentType:  'application/x-www-form-urlencoded',\n      encoding:     'UTF-8',\n      parameters:   '',\n      evalJSON:     true,\n      evalJS:       true\n    };\n    Object.extend(this.options, options || { });\n    this.options.method = this.options.method.toLowerCase();\n    if (Object.isHash(this.options.parameters))\n      this.options.parameters = this.options.parameters.toObject();\n  }\n});\nAjax.Request = Class.create(Ajax.Base, {\n  _complete: false,\n  initialize: function($super, url, options) {\n    $super(options);\n    this.transport = Ajax.getTransport();\n    this.request(url);\n  },\n  request: function(url) {\n    this.url = url;\n    this.method = this.options.method;\n    var params = Object.isString(this.options.parameters) ?\n          this.options.parameters :\n          Object.toQueryString(this.options.parameters);\n    if (!['get', 'post'].include(this.method)) {\n      // simulate other verbs over post\n      params += (params ? '&' : '') + \"_method=\" + this.method;\n      this.method = 'post';\n    }\n    if (params && this.method === 'get') {\n      // when GET, append parameters to URL\n      this.url += (this.url.include('?') ? '&' : '?') + params;\n    }\n    this.parameters = params.toQueryParams();\n    try {\n      var response = new Ajax.Response(this);\n      if (this.options.onCreate) this.options.onCreate(response);\n      Ajax.Responders.dispatch('onCreate', this, response);\n      this.transport.open(this.method.toUpperCase(), this.url,\n        this.options.asynchronous);\n      if (this.options.asynchronous) this.respondToReadyState.bind(this).defer(1);\n      this.transport.onreadystatechange = this.onStateChange.bind(this);\n      this.setRequestHeaders();\n      this.body = this.method == 'post' ? (this.options.postBody || params) : null;\n      this.transport.send(this.body);\n      /* Force Firefox to handle ready state 4 for synchronous requests */\n      if (!this.options.asynchronous && this.transport.overrideMimeType)\n        this.onStateChange();\n    }\n    catch (e) {\n      this.dispatchException(e);\n    }\n  },\n  onStateChange: function() {\n    var readyState = this.transport.readyState;\n    if (readyState > 1 && !((readyState == 4) && this._complete))\n      this.respondToReadyState(this.transport.readyState);\n  },\n  setRequestHeaders: function() {\n    var headers = {\n      'X-Requested-With': 'XMLHttpRequest',\n      'X-Prototype-Version': Prototype.Version,\n      'Accept': 'text/javascript, text/html, application/xml, text/xml, */*'\n    };\n    if (this.method == 'post') {\n      headers['Content-type'] = this.options.contentType +\n        (this.options.encoding ? '; charset=' + this.options.encoding : '');\n      /* Force \"Connection: close\" for older Mozilla browsers to work\n       * around a bug where XMLHttpRequest sends an incorrect\n       * Content-length header. See Mozilla Bugzilla #246651.\n       */\n      if (this.transport.overrideMimeType &&\n          (navigator.userAgent.match(/Gecko\\/(\\d{4})/) || [0,2005])[1] < 2005)\n            headers['Connection'] = 'close';\n    }\n    // user-defined headers\n    if (typeof this.options.requestHeaders == 'object') {\n      var extras = this.options.requestHeaders;\n      if (Object.isFunction(extras.push))\n        for (var i = 0, length = extras.length; i < length; i += 2)\n          headers[extras[i]] = extras[i+1];\n      else\n        $H(extras).each(function(pair) { headers[pair.key] = pair.value });\n    }\n    // skip null or undefined values\n    for (var name in headers)\n      if (headers[name] != null)\n        this.transport.setRequestHeader(name, headers[name]);\n  },\n  success: function() {\n    var status = this.getStatus();\n    return !status || (status >= 200 && status < 300) || status == 304;\n  },\n  getStatus: function() {\n    try {\n      // IE sometimes returns 1223 for a 204 response.\n      if (this.transport.status === 1223) return 204;\n      return this.transport.status || 0;\n    } catch (e) { return 0 }\n  },\n  respondToReadyState: function(readyState) {\n    var state = Ajax.Request.Events[readyState], response = new Ajax.Response(this);\n    if (state == 'Complete') {\n      try {\n        this._complete = true;\n        (this.options['on' + response.status]\n         || this.options['on' + (this.success() ? 'Success' : 'Failure')]\n         || Prototype.emptyFunction)(response, response.headerJSON);\n      } catch (e) {\n        this.dispatchException(e);\n      }\n      var contentType = response.getHeader('Content-type');\n      if (this.options.evalJS == 'force'\n          || (this.options.evalJS && this.isSameOrigin() && contentType\n          && contentType.match(/^\\s*(text|application)\\/(x-)?(java|ecma)script(;.*)?\\s*$/i)))\n        this.evalResponse();\n    }\n    try {\n      (this.options['on' + state] || Prototype.emptyFunction)(response, response.headerJSON);\n      Ajax.Responders.dispatch('on' + state, this, response, response.headerJSON);\n    } catch (e) {\n      this.dispatchException(e);\n    }\n    if (state == 'Complete') {\n      // avoid memory leak in MSIE: clean up\n      this.transport.onreadystatechange = Prototype.emptyFunction;\n    }\n  },\n  isSameOrigin: function() {\n    var m = this.url.match(/^\\s*https?:\\/\\/[^\\/]*/);\n    return !m || (m[0] == '#{protocol}//#{domain}#{port}'.interpolate({\n      protocol: location.protocol,\n      domain: document.domain,\n      port: location.port ? ':' + location.port : ''\n    }));\n  },\n  getHeader: function(name) {\n    try {\n      return this.transport.getResponseHeader(name) || null;\n    } catch (e) { return null; }\n  },\n  evalResponse: function() {\n    try {\n      return eval((this.transport.responseText || '').unfilterJSON());\n    } catch (e) {\n      this.dispatchException(e);\n    }\n  },\n  dispatchException: function(exception) {\n    (this.options.onException || Prototype.emptyFunction)(this, exception);\n    Ajax.Responders.dispatch('onException', this, exception);\n  }\n});\nAjax.Request.Events =\n  ['Uninitialized', 'Loading', 'Loaded', 'Interactive', 'Complete'];\nAjax.Response = Class.create({\n  // Don't document the constructor; should never be manually instantiated.\n  initialize: function(request){\n    this.request = request;\n    var transport  = this.transport  = request.transport,\n        readyState = this.readyState = transport.readyState;\n    if ((readyState > 2 && !Prototype.Browser.IE) || readyState == 4) {\n      this.status       = this.getStatus();\n      this.statusText   = this.getStatusText();\n      this.responseText = String.interpret(transport.responseText);\n      this.headerJSON   = this._getHeaderJSON();\n    }\n    if (readyState == 4) {\n      var xml = transport.responseXML;\n      this.responseXML  = Object.isUndefined(xml) ? null : xml;\n      this.responseJSON = this._getResponseJSON();\n    }\n  },\n  status:      0,\n  statusText: '',\n  getStatus: Ajax.Request.prototype.getStatus,\n  getStatusText: function() {\n    try {\n      return this.transport.statusText || '';\n    } catch (e) { return '' }\n  },\n  getHeader: Ajax.Request.prototype.getHeader,\n  getAllHeaders: function() {\n    try {\n      return this.getAllResponseHeaders();\n    } catch (e) { return null }\n  },\n  getResponseHeader: function(name) {\n    return this.transport.getResponseHeader(name);\n  },\n  getAllResponseHeaders: function() {\n    return this.transport.getAllResponseHeaders();\n  },\n  _getHeaderJSON: function() {\n    var json = this.getHeader('X-JSON');\n    if (!json) return null;\n    try {\n      // Browsers expect HTTP headers to be ASCII and nothing else. Running\n      // them through `decodeURIComponent` processes them with the page's\n      // specified encoding.\n      json = decodeURIComponent(escape(json));\n    } catch(e) {\n      // Except Chrome doesn't seem to need this, and calling\n      // `decodeURIComponent` on text that's already in the proper encoding\n      // will throw a `URIError`. The ugly solution is to assume that a\n      // `URIError` raised here signifies that the text is, in fact, already \n      // in the correct encoding, and treat the failure as a good sign.\n      //\n      // This is ugly, but so too is sending extended characters in an HTTP\n      // header with no spec to back you up.\n    }\n    \n    try {\n      return json.evalJSON(this.request.options.sanitizeJSON ||\n        !this.request.isSameOrigin());\n    } catch (e) {\n      this.request.dispatchException(e);\n    }\n  },\n  _getResponseJSON: function() {\n    var options = this.request.options;\n    if (!options.evalJSON || (options.evalJSON != 'force' &&\n      !(this.getHeader('Content-type') || '').include('application/json')) ||\n        this.responseText.blank())\n          return null;\n    try {\n      return this.responseText.evalJSON(options.sanitizeJSON ||\n        !this.request.isSameOrigin());\n    } catch (e) {\n      this.request.dispatchException(e);\n    }\n  }\n});\nAjax.Updater = Class.create(Ajax.Request, {\n  initialize: function($super, container, url, options) {\n    this.container = {\n      success: (container.success || container),\n      failure: (container.failure || (container.success ? null : container))\n    };\n    options = Object.clone(options);\n    var onComplete = options.onComplete;\n    options.onComplete = (function(response, json) {\n      this.updateContent(response.responseText);\n      if (Object.isFunction(onComplete)) onComplete(response, json);\n    }).bind(this);\n    $super(url, options);\n  },\n  updateContent: function(responseText) {\n    var receiver = this.container[this.success() ? 'success' : 'failure'],\n        options = this.options;\n    if (!options.evalScripts) responseText = responseText.stripScripts();\n    if (receiver = $(receiver)) {\n      if (options.insertion) {\n        if (Object.isString(options.insertion)) {\n          var insertion = { }; insertion[options.insertion] = responseText;\n          receiver.insert(insertion);\n        }\n        else options.insertion(receiver, responseText);\n      }\n      else receiver.update(responseText);\n    }\n  }\n});\nAjax.PeriodicalUpdater = Class.create(Ajax.Base, {\n  initialize: function($super, container, url, options) {\n    $super(options);\n    this.onComplete = this.options.onComplete;\n    this.frequency = (this.options.frequency || 2);\n    this.decay = (this.options.decay || 1);\n    this.updater = { };\n    this.container = container;\n    this.url = url;\n    this.start();\n  },\n  start: function() {\n    this.options.onComplete = this.updateComplete.bind(this);\n    this.onTimerEvent();\n  },\n  stop: function() {\n    this.updater.options.onComplete = undefined;\n    clearTimeout(this.timer);\n    (this.onComplete || Prototype.emptyFunction).apply(this, arguments);\n  },\n  updateComplete: function(response) {\n    if (this.options.decay) {\n      this.decay = (response.responseText == this.lastText ?\n        this.decay * this.options.decay : 1);\n      this.lastText = response.responseText;\n    }\n    this.timer = this.onTimerEvent.bind(this).delay(this.decay * this.frequency);\n  },\n  onTimerEvent: function() {\n    this.updater = new Ajax.Updater(this.container, this.url, this.options);\n  }\n});\n(function(GLOBAL) {\n  \n  var UNDEFINED;\n  var SLICE = Array.prototype.slice;\n  \n  // Try to reuse the same created element as much as possible. We'll use\n  // this DIV for capability checks (where possible) and for normalizing\n  // HTML content.\n  var DIV = document.createElement('div');\n  \n  function $(element) {\n    if (arguments.length > 1) {\n      for (var i = 0, elements = [], length = arguments.length; i < length; i++)\n        elements.push($(arguments[i]));\n      return elements;\n    }\n    \n    if (Object.isString(element))\n      element = document.getElementById(element);\n    return Element.extend(element);\n  }\n  \n  GLOBAL.$ = $;\n  \n  \n  // Define the DOM Level 2 node type constants if they're missing.\n  if (!GLOBAL.Node) GLOBAL.Node = {};\n  \n  if (!GLOBAL.Node.ELEMENT_NODE) {\n    Object.extend(GLOBAL.Node, {\n      ELEMENT_NODE:                1,\n      ATTRIBUTE_NODE:              2,\n      TEXT_NODE:                   3,\n      CDATA_SECTION_NODE:          4,\n      ENTITY_REFERENCE_NODE:       5,\n      ENTITY_NODE:                 6,\n      PROCESSING_INSTRUCTION_NODE: 7,\n      COMMENT_NODE:                8,\n      DOCUMENT_NODE:               9,\n      DOCUMENT_TYPE_NODE:         10,\n      DOCUMENT_FRAGMENT_NODE:     11,\n      NOTATION_NODE:              12\n    });\n  }\n  \n  // The cache for all our created elements.\n  var ELEMENT_CACHE = {};\n  \n  // For performance reasons, we create new elements by cloning a \"blank\"\n  // version of a given element. But sometimes this causes problems. Skip\n  // the cache if:\n  //   (a) We're creating a SELECT element (troublesome in IE6);\n  //   (b) We're setting the `type` attribute on an INPUT element\n  //       (troublesome in IE9).\n  function shouldUseCreationCache(tagName, attributes) {\n    if (tagName === 'select') return false;\n    if ('type' in attributes) return false;\n    return true;\n  }\n  \n  // IE requires that `name` and `type` attributes be set this way.\n  var HAS_EXTENDED_CREATE_ELEMENT_SYNTAX = (function(){\n    try {\n      var el = document.createElement('<input name=\"x\">');\n      return el.tagName.toLowerCase() === 'input' && el.name === 'x';\n    } \n    catch(err) {\n      return false;\n    }\n  })();\n  \n  \n  var oldElement = GLOBAL.Element;\n  function Element(tagName, attributes) {\n    attributes = attributes || {};\n    tagName = tagName.toLowerCase();\n    \n    if (HAS_EXTENDED_CREATE_ELEMENT_SYNTAX && attributes.name) {\n      tagName = '<' + tagName + ' name=\"' + attributes.name + '\">';\n      delete attributes.name;\n      return Element.writeAttribute(document.createElement(tagName), attributes);\n    }\n    \n    if (!ELEMENT_CACHE[tagName])\n      ELEMENT_CACHE[tagName] = Element.extend(document.createElement(tagName));\n    \n    var node = shouldUseCreationCache(tagName, attributes) ?\n     ELEMENT_CACHE[tagName].cloneNode(false) : document.createElement(tagName);\n     \n    return Element.writeAttribute(node, attributes);\n  }\n  \n  GLOBAL.Element = Element;\n  \n  Object.extend(GLOBAL.Element, oldElement || {});\n  if (oldElement) GLOBAL.Element.prototype = oldElement.prototype;\n  \n  Element.Methods = { ByTag: {}, Simulated: {} };\n  // Temporary object for holding all our initial element methods. We'll add\n  // them all at once at the bottom of this file.\n  var methods = {};\n  \n  var INSPECT_ATTRIBUTES = { id: 'id', className: 'class' };\n  function inspect(element) {\n    element = $(element);\n    var result = '<' + element.tagName.toLowerCase();\n    \n    var attribute, value;\n    for (var property in INSPECT_ATTRIBUTES) {\n      attribute = INSPECT_ATTRIBUTES[property];\n      value = (element[property] || '').toString();\n      if (value) result += ' ' + attribute + '=' + value.inspect(true);\n    }\n    \n    return result + '>';\n  }\n  \n  methods.inspect = inspect;\n  \n  // VISIBILITY\n  \n  function visible(element) {\n    return $(element).style.display !== 'none';\n  }\n  \n  function toggle(element, bool) {\n    element = $(element);\n    if (Object.isUndefined(bool))\n      bool = !Element.visible(element);\n    Element[bool ? 'show' : 'hide'](element);\n    \n    return element;\n  }\n  function hide(element) {\n    element = $(element);\n    element.style.display = 'none';\n    return element;\n  }\n  \n  function show(element) {\n    element = $(element);\n    element.style.display = '';\n    return element;\n  }\n  \n  \n  Object.extend(methods, {\n    visible: visible,\n    toggle:  toggle,\n    hide:    hide,\n    show:    show\n  });\n  \n  // MANIPULATION\n  \n  function remove(element) {\n    element = $(element);\n    element.parentNode.removeChild(element);\n    return element;\n  }\n  \n  // see: http://support.microsoft.com/kb/276228\n  var SELECT_ELEMENT_INNERHTML_BUGGY = (function(){\n    var el = document.createElement(\"select\"),\n        isBuggy = true;\n    el.innerHTML = \"<option value=\\\"test\\\">test</option>\";\n    if (el.options && el.options[0]) {\n      isBuggy = el.options[0].nodeName.toUpperCase() !== \"OPTION\";\n    }\n    el = null;\n    return isBuggy;\n  })();\n  // see: http://msdn.microsoft.com/en-us/library/ms533897(VS.85).aspx\n  var TABLE_ELEMENT_INNERHTML_BUGGY = (function(){\n    try {\n      var el = document.createElement(\"table\");\n      if (el && el.tBodies) {\n        el.innerHTML = \"<tbody><tr><td>test</td></tr></tbody>\";\n        var isBuggy = typeof el.tBodies[0] == \"undefined\";\n        el = null;\n        return isBuggy;\n      }\n    } catch (e) {\n      return true;\n    }\n  })();\n  \n  var LINK_ELEMENT_INNERHTML_BUGGY = (function() {\n    try {\n      var el = document.createElement('div');\n      el.innerHTML = \"<link />\";\n      var isBuggy = (el.childNodes.length === 0);\n      el = null;\n      return isBuggy;\n    } catch(e) {\n      return true;\n    }\n  })();\n  \n  var ANY_INNERHTML_BUGGY = SELECT_ELEMENT_INNERHTML_BUGGY ||\n   TABLE_ELEMENT_INNERHTML_BUGGY || LINK_ELEMENT_INNERHTML_BUGGY;    \n  var SCRIPT_ELEMENT_REJECTS_TEXTNODE_APPENDING = (function () {\n    var s = document.createElement(\"script\"),\n        isBuggy = false;\n    try {\n      s.appendChild(document.createTextNode(\"\"));\n      isBuggy = !s.firstChild ||\n        s.firstChild && s.firstChild.nodeType !== 3;\n    } catch (e) {\n      isBuggy = true;\n    }\n    s = null;\n    return isBuggy;\n  })();\n  \n  function update(element, content) {\n    element = $(element);\n    \n    // Purge the element's existing contents of all storage keys and\n    // event listeners, since said content will be replaced no matter\n    // what.\n    var descendants = element.getElementsByTagName('*'),\n     i = descendants.length;\n    while (i--) purgeElement(descendants[i]);\n    \n    if (content && content.toElement)\n      content = content.toElement();\n      \n    if (Object.isElement(content))\n      return element.update().insert(content);\n      \n    \n    content = Object.toHTML(content);\n    var tagName = element.tagName.toUpperCase();\n    \n    if (tagName === 'SCRIPT' && SCRIPT_ELEMENT_REJECTS_TEXTNODE_APPENDING) {\n      // Scripts are not evaluated when updating a SCRIPT element.\n      element.text = content;\n      return element;\n    }\n    \n    if (ANY_INNERHTML_BUGGY) {\n      if (tagName in INSERTION_TRANSLATIONS.tags) {\n        while (element.firstChild)\n          element.removeChild(element.firstChild);\n        \n        var nodes = getContentFromAnonymousElement(tagName, content.stripScripts());        \n        for (var i = 0, node; node = nodes[i]; i++)\n          element.appendChild(node);\n        \n      } else if (LINK_ELEMENT_INNERHTML_BUGGY && Object.isString(content) && content.indexOf('<link') > -1) {\n        // IE barfs when inserting a string that beings with a LINK\n        // element. The workaround is to add any content to the beginning\n        // of the string; we'll be inserting a text node (see\n        // getContentFromAnonymousElement below).\n        while (element.firstChild)\n          element.removeChild(element.firstChild);\n          \n        var nodes = getContentFromAnonymousElement(tagName,\n         content.stripScripts(), true);\n        \n        for (var i = 0, node; node = nodes[i]; i++)\n          element.appendChild(node);\n      } else {\n        element.innerHTML = content.stripScripts();\n      }\n    } else {\n      element.innerHTML = content.stripScripts();\n    }\n    \n    content.evalScripts.bind(content).defer();\n    return element;\n  }\n  \n  function replace(element, content) {\n    element = $(element);\n    \n    if (content && content.toElement) {\n      content = content.toElement();      \n    } else if (!Object.isElement(content)) {\n      content = Object.toHTML(content);\n      var range = element.ownerDocument.createRange();\n      range.selectNode(element);\n      content.evalScripts.bind(content).defer();\n      content = range.createContextualFragment(content.stripScripts());\n    }\n      \n    element.parentNode.replaceChild(content, element);\n    return element;\n  }\n  \n  var INSERTION_TRANSLATIONS = {\n    before: function(element, node) {\n      element.parentNode.insertBefore(node, element);\n    },\n    top: function(element, node) {\n      element.insertBefore(node, element.firstChild);\n    },\n    bottom: function(element, node) {\n      element.appendChild(node);\n    },\n    after: function(element, node) {\n      element.parentNode.insertBefore(node, element.nextSibling);\n    },\n    \n    tags: {\n      TABLE:  ['<table>',                '</table>',                   1],\n      TBODY:  ['<table><tbody>',         '</tbody></table>',           2],\n      TR:     ['<table><tbody><tr>',     '</tr></tbody></table>',      3],\n      TD:     ['<table><tbody><tr><td>', '</td></tr></tbody></table>', 4],\n      SELECT: ['<select>',               '</select>',                  1]\n    }\n  };\n  \n  var tags = INSERTION_TRANSLATIONS.tags;\n  \n  Object.extend(tags, {\n    THEAD: tags.TBODY,\n    TFOOT: tags.TBODY,\n    TH:    tags.TD\n  });\n  \n  function replace_IE(element, content) {\n    element = $(element);\n    if (content && content.toElement)\n      content = content.toElement();\n    if (Object.isElement(content)) {\n      element.parentNode.replaceChild(content, element);\n      return element;\n    }\n    \n    content = Object.toHTML(content);\n    var parent = element.parentNode, tagName = parent.tagName.toUpperCase();\n    \n    if (tagName in INSERTION_TRANSLATIONS.tags) {\n      var nextSibling = Element.next(element);\n      var fragments = getContentFromAnonymousElement(\n       tagName, content.stripScripts());\n      \n      parent.removeChild(element);\n      \n      var iterator;\n      if (nextSibling)\n        iterator = function(node) { parent.insertBefore(node, nextSibling) };\n      else\n        iterator = function(node) { parent.appendChild(node); }\n        \n      fragments.each(iterator);\n    } else {\n      // We don't need to special-case this one.\n      element.outerHTML = content.stripScripts();\n    }\n    \n    content.evalScripts.bind(content).defer();\n    return element;\n  }\n  \n  if ('outerHTML' in document.documentElement)\n    replace = replace_IE;\n  \n  function isContent(content) {\n    if (Object.isUndefined(content) || content === null) return false;\n    \n    if (Object.isString(content) || Object.isNumber(content)) return true;\n    if (Object.isElement(content)) return true;    \n    if (content.toElement || content.toHTML) return true;\n    \n    return false;\n  }\n  \n  // This private method does the bulk of the work for Element#insert. The\n  // actual insert method handles argument normalization and multiple\n  // content insertions.\n  function insertContentAt(element, content, position) {\n    position   = position.toLowerCase();\n    var method = INSERTION_TRANSLATIONS[position];\n    \n    if (content && content.toElement) content = content.toElement();\n    if (Object.isElement(content)) {\n      method(element, content);\n      return element;\n    }\n    \n    content = Object.toHTML(content);      \n    var tagName = ((position === 'before' || position === 'after') ?\n     element.parentNode : element).tagName.toUpperCase();\n    \n    var childNodes = getContentFromAnonymousElement(tagName, content.stripScripts());\n    \n    if (position === 'top' || position === 'after') childNodes.reverse();\n    \n    for (var i = 0, node; node = childNodes[i]; i++)\n      method(element, node);\n      \n    content.evalScripts.bind(content).defer();    \n  }\n  function insert(element, insertions) {\n    element = $(element);\n    \n    if (isContent(insertions))\n      insertions = { bottom: insertions };\n      \n    for (var position in insertions)\n      insertContentAt(element, insertions[position], position);\n    \n    return element;    \n  }\n  \n  function wrap(element, wrapper, attributes) {\n    element = $(element);\n    \n    if (Object.isElement(wrapper)) {\n      // The wrapper argument is a DOM node.\n      $(wrapper).writeAttribute(attributes || {});      \n    } else if (Object.isString(wrapper)) {\n      // The wrapper argument is a string representing a tag name.\n      wrapper = new Element(wrapper, attributes);\n    } else {\n      // No wrapper was specified, which means the second argument is a set\n      // of attributes.\n      wrapper = new Element('div', wrapper);\n    }\n    \n    if (element.parentNode)\n      element.parentNode.replaceChild(wrapper, element);\n    \n    wrapper.appendChild(element);\n    \n    return wrapper;\n  }\n  \n  function cleanWhitespace(element) {\n    element = $(element);\n    var node = element.firstChild;\n    \n    while (node) {\n      var nextNode = node.nextSibling;\n      if (node.nodeType === Node.TEXT_NODE && !/\\S/.test(node.nodeValue))\n        element.removeChild(node);\n      node = nextNode;\n    }\n    return element;\n  }\n  \n  function empty(element) {\n    return $(element).innerHTML.blank();\n  }\n  \n  // In older versions of Internet Explorer, certain elements don't like\n  // having innerHTML set on them — including SELECT and most table-related\n  // tags. So we wrap the string with enclosing HTML (if necessary), stick it\n  // in a DIV, then grab the DOM nodes.\n  function getContentFromAnonymousElement(tagName, html, force) {\n    var t = INSERTION_TRANSLATIONS.tags[tagName], div = DIV;\n    \n    var workaround = !!t;\n    if (!workaround && force) {\n      workaround = true;\n      t = ['', '', 0];\n    }\n    \n    if (workaround) {\n      div.innerHTML = '&#160;' + t[0] + html + t[1];\n      div.removeChild(div.firstChild);\n      for (var i = t[2]; i--; )\n        div = div.firstChild;\n    } else {\n      div.innerHTML = html;\n    }\n    \n    return $A(div.childNodes);\n    //return SLICE.call(div.childNodes, 0);\n  }\n  \n  function clone(element, deep) {\n    if (!(element = $(element))) return;\n    var clone = element.cloneNode(deep);\n    if (!HAS_UNIQUE_ID_PROPERTY) {\n      clone._prototypeUID = UNDEFINED;\n      if (deep) {\n        var descendants = Element.select(clone, '*'),\n         i = descendants.length;\n        while (i--)\n          descendants[i]._prototypeUID = UNDEFINED;\n      }\n    }\n    return Element.extend(clone);\n  }\n  \n  // Performs cleanup on a single element before it is removed from the page.\n  function purgeElement(element) {\n    var uid = getUniqueElementID(element);\n    if (uid) {\n      Element.stopObserving(element);\n      if (!HAS_UNIQUE_ID_PROPERTY)\n        element._prototypeUID = UNDEFINED;\n      delete Element.Storage[uid];\n    }\n  }\n  \n  function purgeCollection(elements) {\n    var i = elements.length;\n    while (i--)\n      purgeElement(elements[i]);\n  }\n  \n  function purgeCollection_IE(elements) {\n    var i = elements.length, element, uid;\n    while (i--) {\n      element = elements[i];\n      uid = getUniqueElementID(element);\n      delete Element.Storage[uid];\n      delete Event.cache[uid];\n    }\n  }\n  \n  if (HAS_UNIQUE_ID_PROPERTY) {\n    purgeCollection = purgeCollection_IE;\n  }\n  \n  \n  function purge(element) {\n    if (!(element = $(element))) return;\n    purgeElement(element);\n    \n    var descendants = element.getElementsByTagName('*'),\n     i = descendants.length;\n     \n    while (i--) purgeElement(descendants[i]);\n    \n    return null;\n  }\n  \n  Object.extend(methods, {\n    remove:  remove,\n    update:  update,\n    replace: replace,\n    insert:  insert,\n    wrap:    wrap,\n    cleanWhitespace: cleanWhitespace,\n    empty:   empty,\n    clone:   clone,\n    purge:   purge\n  });\n  \n  // TRAVERSAL\n  \n  function recursivelyCollect(element, property, maximumLength) {\n    element = $(element);\n    maximumLength = maximumLength || -1;\n    var elements = [];\n    \n    while (element = element[property]) {\n      if (element.nodeType === Node.ELEMENT_NODE)\n        elements.push(Element.extend(element));\n        \n      if (elements.length === maximumLength) break;\n    }\n    \n    return elements;    \n  }\n  \n  function ancestors(element) {\n    return recursivelyCollect(element, 'parentNode');\n  }\n  \n  function descendants(element) {\n    return Element.select(element, '*');\n  }\n  \n  function firstDescendant(element) {\n    element = $(element).firstChild;\n    while (element && element.nodeType !== Node.ELEMENT_NODE)\n      element = element.nextSibling;\n    return $(element);\n  }\n  \n  function immediateDescendants(element) {\n    var results = [], child = $(element).firstChild;\n    \n    while (child) {\n      if (child.nodeType === Node.ELEMENT_NODE)\n        results.push(Element.extend(child));\n      \n      child = child.nextSibling;\n    }\n    \n    return results;\n  }\n  \n  function previousSiblings(element) {\n    return recursivelyCollect(element, 'previousSibling');\n  }\n  \n  function nextSiblings(element) {\n    return recursivelyCollect(element, 'nextSibling');\n  }\n  \n  function siblings(element) {\n    element = $(element);    \n    var previous = previousSiblings(element),\n     next = nextSiblings(element);\n    return previous.reverse().concat(next);\n  }\n  \n  function match(element, selector) {\n    element = $(element);\n    \n    // If selector is a string, we assume it's a CSS selector.\n    if (Object.isString(selector))\n      return Prototype.Selector.match(element, selector);\n      \n    // Otherwise, we assume it's an object with its own `match` method.\n    return selector.match(element);\n  }\n  \n  \n  // Internal method for optimizing traversal. Works like \n  // `recursivelyCollect`, except it stops at the first match and doesn't\n  // extend any elements except for the returned element.\n  function _recursivelyFind(element, property, expression, index) {\n    element = $(element), expression = expression || 0, index = index || 0;\n    if (Object.isNumber(expression)) {\n      index = expression, expression = null;\n    }\n    \n    while (element = element[property]) {\n      // Skip any non-element nodes.\n      if (element.nodeType !== 1) continue;\n      // Skip any nodes that don't match the expression, if there is one.\n      if (expression && !Prototype.Selector.match(element, expression))\n        continue;\n      // Skip the first `index` matches we find.\n      if (--index >= 0) continue;\n      \n      return Element.extend(element);\n    }\n  }\n  \n  \n  function up(element, expression, index) {\n    element = $(element);\n    if (arguments.length === 1) return $(element.parentNode);\n    return _recursivelyFind(element, 'parentNode', expression, index);\n  }\n  function down(element, expression, index) {\n    if (arguments.length === 1) return firstDescendant(element);\n    element = $(element), expression = expression || 0, index = index || 0;\n    \n    if (Object.isNumber(expression))\n      index = expression, expression = '*';\n    \n    var node = Prototype.Selector.select(expression, element)[index];\n    return Element.extend(node);\n  }\n  function previous(element, expression, index) {\n    return _recursivelyFind(element, 'previousSibling', expression, index);\n  }\n  \n  function next(element, expression, index) {\n    return _recursivelyFind(element, 'nextSibling', expression, index);\n  }\n    \n  function select(element) {\n    element = $(element);\n    var expressions = SLICE.call(arguments, 1).join(', ');\n    return Prototype.Selector.select(expressions, element);\n  }\n  function adjacent(element) {\n    element = $(element);\n    var expressions = SLICE.call(arguments, 1).join(', ');\n    var siblings = Element.siblings(element), results = [];\n    for (var i = 0, sibling; sibling = siblings[i]; i++) {\n      if (Prototype.Selector.match(sibling, expressions))\n        results.push(sibling);\n    }\n    \n    return results;\n  }\n  \n  function descendantOf_DOM(element, ancestor) {\n    element = $(element), ancestor = $(ancestor);\n    while (element = element.parentNode)\n      if (element === ancestor) return true;\n    return false;\n  }\n  \n  function descendantOf_contains(element, ancestor) {\n    element = $(element), ancestor = $(ancestor);\n    // Some nodes, like `document`, don't have the \"contains\" method.\n    if (!ancestor.contains) return descendantOf_DOM(element, ancestor);\n    return ancestor.contains(element) && ancestor !== element;\n  }\n  \n  function descendantOf_compareDocumentPosition(element, ancestor) {\n    element = $(element), ancestor = $(ancestor);\n    return (element.compareDocumentPosition(ancestor) & 8) === 8;\n  }\n  \n  var descendantOf;\n  if (DIV.compareDocumentPosition) {\n    descendantOf = descendantOf_compareDocumentPosition;\n  } else if (DIV.contains) {\n    descendantOf = descendantOf_contains;\n  } else {\n    descendantOf = descendantOf_DOM;\n  }\n  \n  \n  Object.extend(methods, {\n    recursivelyCollect:   recursivelyCollect,\n    ancestors:            ancestors,\n    descendants:          descendants,\n    firstDescendant:      firstDescendant,\n    immediateDescendants: immediateDescendants,\n    previousSiblings:     previousSiblings,\n    nextSiblings:         nextSiblings,\n    siblings:             siblings,\n    match:                match,\n    up:                   up,\n    down:                 down,\n    previous:             previous,\n    next:                 next,\n    select:               select,\n    adjacent:             adjacent,\n    descendantOf:         descendantOf,\n    \n    // ALIASES\n    getElementsBySelector: select,\n    \n    childElements:         immediateDescendants\n  });\n  \n  \n  // ATTRIBUTES\n  var idCounter = 1;\n  function identify(element) {\n    element = $(element);\n    var id = Element.readAttribute(element, 'id');\n    if (id) return id;\n    \n    // The element doesn't have an ID of its own. Give it one, first ensuring\n    // that it's unique.\n    do { id = 'anonymous_element_' + idCounter++ } while ($(id));\n    \n    Element.writeAttribute(element, 'id', id);\n    return id;\n  }\n  \n  function readAttribute(element, name) {\n    return $(element).getAttribute(name);\n  }\n  \n  function readAttribute_IE(element, name) {\n    element = $(element);\n    \n    // If the attribute name exists in the value translation table, it means\n    // we should use a custom method for retrieving that attribute's value.\n    var table = ATTRIBUTE_TRANSLATIONS.read;\n    if (table.values[name])\n      return table.values[name](element, name);\n      \n    // If it exists in the name translation table, it means the attribute has\n    // an alias.\n    if (table.names[name]) name = table.names[name];\n    \n    // Special-case namespaced attributes.\n    if (name.include(':')) {\n      if (!element.attributes || !element.attributes[name]) return null;\n      return element.attributes[name].value;\n    }\n    \n    return element.getAttribute(name);\n  }\n  \n  function readAttribute_Opera(element, name) {\n    if (name === 'title') return element.title;\n    return element.getAttribute(name);\n  }\n  \n  var PROBLEMATIC_ATTRIBUTE_READING = (function() {\n    // This test used to set 'onclick' to `Prototype.emptyFunction`, but that\n    // caused an (uncatchable) error in IE 10. For some reason, switching to\n    // an empty array prevents this issue.\n    DIV.setAttribute('onclick', []);\n    var value = DIV.getAttribute('onclick');\n    var isFunction = Object.isArray(value);\n    DIV.removeAttribute('onclick');\n    return isFunction;\n  })();\n  \n  if (PROBLEMATIC_ATTRIBUTE_READING) {\n    readAttribute = readAttribute_IE;\n  } else if (Prototype.Browser.Opera) {\n    readAttribute = readAttribute_Opera;\n  }\n  \n  \n  function writeAttribute(element, name, value) {\n    element = $(element);\n    var attributes = {}, table = ATTRIBUTE_TRANSLATIONS.write;\n    \n    if (typeof name === 'object') {\n      attributes = name;\n    } else {\n      attributes[name] = Object.isUndefined(value) ? true : value;\n    }\n    \n    for (var attr in attributes) {\n      name = table.names[attr] || attr;\n      value = attributes[attr];\n      if (table.values[attr])\n        name = table.values[attr](element, value) || name;\n      if (value === false || value === null)\n        element.removeAttribute(name);\n      else if (value === true)\n        element.setAttribute(name, name);\n      else element.setAttribute(name, value);\n    }\n    return element;\n  }\n  \n  function hasAttribute(element, attribute) {\n    attribute = ATTRIBUTE_TRANSLATIONS.has[attribute] || attribute;\n    var node = $(element).getAttributeNode(attribute);\n    return !!(node && node.specified);\n  }\n  \n  GLOBAL.Element.Methods.Simulated.hasAttribute = hasAttribute;\n  \n  function classNames(element) {\n    return new Element.ClassNames(element);\n  }\n  \n  var regExpCache = {};\n  function getRegExpForClassName(className) {\n    if (regExpCache[className]) return regExpCache[className];\n    \n    var re = new RegExp(\"(^|\\\\s+)\" + className + \"(\\\\s+|$)\");\n    regExpCache[className] = re;\n    return re;\n  }\n  \n  function hasClassName(element, className) {\n    if (!(element = $(element))) return;\n    \n    var elementClassName = element.className;\n    // We test these common cases first because we'd like to avoid creating\n    // the regular expression, if possible.\n    if (elementClassName.length === 0) return false;\n    if (elementClassName === className) return true;\n    \n    return getRegExpForClassName(className).test(elementClassName);\n  }\n  \n  function addClassName(element, className) {\n    if (!(element = $(element))) return;\n    \n    if (!hasClassName(element, className))\n      element.className += (element.className ? ' ' : '') + className;\n      \n    return element;\n  }\n  \n  function removeClassName(element, className) {\n    if (!(element = $(element))) return;\n    \n    element.className = element.className.replace(\n     getRegExpForClassName(className), ' ').strip();\n     \n    return element;\n  }\n  \n  function toggleClassName(element, className, bool) {\n    if (!(element = $(element))) return;\n    \n    if (Object.isUndefined(bool))\n      bool = !hasClassName(element, className);\n      \n    var method = Element[bool ? 'addClassName' : 'removeClassName'];\n    return method(element, className);\n  }\n  \n  var ATTRIBUTE_TRANSLATIONS = {};\n  \n  // Test attributes.\n  var classProp = 'className', forProp = 'for';\n  \n  // Try \"className\" first (IE <8)\n  DIV.setAttribute(classProp, 'x');\n  if (DIV.className !== 'x') {\n    // Try \"class\" (IE >=8)\n    DIV.setAttribute('class', 'x');\n    if (DIV.className === 'x')\n      classProp = 'class';\n  }\n  \n  var LABEL = document.createElement('label');\n  LABEL.setAttribute(forProp, 'x');\n  if (LABEL.htmlFor !== 'x') {\n    LABEL.setAttribute('htmlFor', 'x');\n    if (LABEL.htmlFor === 'x')\n      forProp = 'htmlFor';\n  }\n  LABEL = null;\n  \n  function _getAttr(element, attribute) {\n    return element.getAttribute(attribute);\n  }\n  \n  function _getAttr2(element, attribute) {\n    return element.getAttribute(attribute, 2);\n  }\n  \n  function _getAttrNode(element, attribute) {\n    var node = element.getAttributeNode(attribute);\n    return node ? node.value : '';\n  }\n  \n  function _getFlag(element, attribute) {\n    return $(element).hasAttribute(attribute) ? attribute : null;\n  }\n  \n  // Test whether attributes like `onclick` have their values serialized.\n  DIV.onclick = Prototype.emptyFunction;\n  var onclickValue = DIV.getAttribute('onclick');\n  \n  var _getEv;\n  \n  // IE <8\n  if (String(onclickValue).indexOf('{') > -1) {\n    // intrinsic event attributes are serialized as `function { ... }`\n    _getEv = function(element, attribute) {\n      var value = element.getAttribute(attribute);\n      if (!value) return null;\n      value = value.toString();\n      value = value.split('{')[1];\n      value = value.split('}')[0];\n      return value.strip();\n    };\n  } \n  // IE >=8\n  else if (onclickValue === '') {\n    // only function body is serialized\n    _getEv = function(element, attribute) {\n      var value = element.getAttribute(attribute);\n      if (!value) return null;\n      return value.strip();\n    };\n  }\n  \n  ATTRIBUTE_TRANSLATIONS.read = {\n    names: {\n      'class':     classProp,\n      'className': classProp,\n      'for':       forProp,\n      'htmlFor':   forProp\n    },\n        \n    values: {\n      style: function(element) {\n        return element.style.cssText.toLowerCase();\n      },\n      title: function(element) {\n        return element.title;\n      }\n    }\n  };\n  \n  ATTRIBUTE_TRANSLATIONS.write = {\n    names: {\n      className:   'class',\n      htmlFor:     'for',\n      cellpadding: 'cellPadding',\n      cellspacing: 'cellSpacing'\n    },\n    \n    values: {\n      checked: function(element, value) {\n        element.checked = !!value;\n      },\n      \n      style: function(element, value) {\n        element.style.cssText = value ? value : '';\n      }\n    }\n  };\n  \n  ATTRIBUTE_TRANSLATIONS.has = { names: {} };\n  \n  Object.extend(ATTRIBUTE_TRANSLATIONS.write.names,\n   ATTRIBUTE_TRANSLATIONS.read.names);\n   \n  var CAMEL_CASED_ATTRIBUTE_NAMES = $w('colSpan rowSpan vAlign dateTime ' +\n   'accessKey tabIndex encType maxLength readOnly longDesc frameBorder');\n   \n  for (var i = 0, attr; attr = CAMEL_CASED_ATTRIBUTE_NAMES[i]; i++) {\n    ATTRIBUTE_TRANSLATIONS.write.names[attr.toLowerCase()] = attr;\n    ATTRIBUTE_TRANSLATIONS.has.names[attr.toLowerCase()]   = attr;\n  }\n  \n  // The rest of the oddballs.\n  Object.extend(ATTRIBUTE_TRANSLATIONS.read.values, {\n    href:        _getAttr2,\n    src:         _getAttr2,\n    type:        _getAttr,\n    action:      _getAttrNode,\n    disabled:    _getFlag,\n    checked:     _getFlag,\n    readonly:    _getFlag,\n    multiple:    _getFlag,\n    onload:      _getEv,\n    onunload:    _getEv,\n    onclick:     _getEv,\n    ondblclick:  _getEv,\n    onmousedown: _getEv,\n    onmouseup:   _getEv,\n    onmouseover: _getEv,\n    onmousemove: _getEv,\n    onmouseout:  _getEv,\n    onfocus:     _getEv,\n    onblur:      _getEv,\n    onkeypress:  _getEv,\n    onkeydown:   _getEv,\n    onkeyup:     _getEv,\n    onsubmit:    _getEv,\n    onreset:     _getEv,\n    onselect:    _getEv,\n    onchange:    _getEv    \n  });\n  \n  \n  Object.extend(methods, {\n    identify:        identify,\n    readAttribute:   readAttribute,\n    writeAttribute:  writeAttribute,\n    classNames:      classNames,\n    hasClassName:    hasClassName,\n    addClassName:    addClassName,\n    removeClassName: removeClassName,\n    toggleClassName: toggleClassName\n  });\n  \n  \n  // STYLES\n  function normalizeStyleName(style) {\n    if (style === 'float' || style === 'styleFloat')\n      return 'cssFloat';\n    return style.camelize();\n  }\n  \n  function normalizeStyleName_IE(style) {\n    if (style === 'float' || style === 'cssFloat')\n      return 'styleFloat';\n    return style.camelize();\n  }\n  function setStyle(element, styles) {\n    element = $(element);\n    var elementStyle = element.style, match;\n    \n    if (Object.isString(styles)) {\n      // Set the element's CSS text directly.\n      elementStyle.cssText += ';' + styles;\n      if (styles.include('opacity')) {\n        var opacity = styles.match(/opacity:\\s*(\\d?\\.?\\d*)/)[1];\n        Element.setOpacity(element, opacity);\n      }\n      return element;\n    }\n    \n    for (var property in styles) {\n      if (property === 'opacity') {\n        Element.setOpacity(element, styles[property]);\n      } else {\n        var value = styles[property];\n        if (property === 'float' || property === 'cssFloat') {\n          // Browsers disagree on whether this should be called `cssFloat`\n          // or `styleFloat`. Check both.\n          property = Object.isUndefined(elementStyle.styleFloat) ?\n           'cssFloat' : 'styleFloat';\n        }\n        elementStyle[property] = value;\n      }\n    }\n    \n    return element;    \n  }\n  \n  function getStyle(element, style) {\n    if (style === 'opacity') return getOpacity(element);\n    element = $(element);\n    style = normalizeStyleName(style);\n    // Try inline styles first.\n    var value = element.style[style];\n    if (!value || value === 'auto') {\n      // Reluctantly retrieve the computed style.\n      var css = document.defaultView.getComputedStyle(element, null);\n      value = css ? css[style] : null;\n    }\n    \n    return value === 'auto' ? null : value;\n  }\n  \n  function getStyle_Opera(element, style) {\n    switch (style) {\n      case 'height': case 'width':\n        // returns '0px' for hidden elements; we want it to return null\n        if (!Element.visible(element)) return null;\n        \n        // Certain versions of Opera return border-box dimensions instead of\n        // content-box dimensions, so we need to determine if we should\n        // subtract padding and borders from the value.\n        var dim = parseInt(getStyle(element, style), 10);\n        \n        if (dim !== element['offset' + style.capitalize()])\n          return dim + 'px';\n       \n        return Element.measure(element, style);\n        \n      default: return getStyle(element, style);\n    }\n  }\n  \n  function getStyle_IE(element, style) {\n    if (style === 'opacity') return getOpacity_IE(element);\n    element = $(element);\n    style = normalizeStyleName_IE(style);\n    // Try inline styles first.\n    var value = element.style[style];    \n    if (!value && element.currentStyle) {\n      // Reluctantly retrieve the current style.\n      value = element.currentStyle[style];\n    }\n    \n    if (value === 'auto') {\n      // If we need a dimension, return null for hidden elements, but return\n      // pixel values for visible elements.\n      if ((style === 'width' || style === 'height') && Element.visible(element))\n        return Element.measure(element, style) + 'px';\n      return null;\n    }\n    \n    return value;    \n  }\n  \n  function stripAlphaFromFilter_IE(filter) {\n    return (filter || '').replace(/alpha\\([^\\)]*\\)/gi, '');\n  }\n  \n  function hasLayout_IE(element) {\n    if (!element.currentStyle || !element.currentStyle.hasLayout)\n      element.style.zoom = 1;\n    return element;\n  }\n  // Opacity feature test borrowed from Modernizr.\n  var STANDARD_CSS_OPACITY_SUPPORTED = (function() {\n    DIV.style.cssText = \"opacity:.55\";\n    return /^0.55/.test(DIV.style.opacity);\n  })();\n  function setOpacity(element, value) {\n    element = $(element);\n    if (value == 1 || value === '') value = '';\n    else if (value < 0.00001) value = 0;    \n    element.style.opacity = value;    \n    return element;\n  }\n  \n  // The IE versions of `setOpacity` and `getOpacity` are aware of both\n  // the standard approach (an `opacity` property in CSS) and the old-style\n  // IE approach (a proprietary `filter` property). They are written to\n  // prefer the standard approach unless it isn't supported.\n  var setOpacity_IE = STANDARD_CSS_OPACITY_SUPPORTED ? setOpacity : function(element, value) {\n    element = $(element);\n    var style = element.style;\n    if (!element.currentStyle || !element.currentStyle.hasLayout)\n      style.zoom = 1;\n    var filter = Element.getStyle(element, 'filter');\n     \n    if (value == 1 || value === '') {\n      // Remove the `alpha` filter from IE's `filter` CSS property. If there\n      // is anything left after removal, put it back where it was; otherwise\n      // remove the property.\n      filter = stripAlphaFromFilter_IE(filter);\n      if (filter) style.filter = filter;\n      else style.removeAttribute('filter');      \n      return element;\n    }\n    \n    if (value < 0.00001) value = 0;\n        \n    style.filter = stripAlphaFromFilter_IE(filter) + \n     ' alpha(opacity=' + (value * 100) + ')';\n     \n    return element;\n  };\n  \n  \n  function getOpacity(element) {\n    element = $(element);\n    // Try inline styles first.\n    var value = element.style.opacity;\n    if (!value || value === 'auto') {\n      // Reluctantly retrieve the computed style.\n      var css = document.defaultView.getComputedStyle(element, null);\n      value = css ? css.opacity : null;\n    }\n    return value ? parseFloat(value) : 1.0;\n  }\n  \n  // Prefer the standard CSS approach unless it's not supported.\n  var getOpacity_IE = STANDARD_CSS_OPACITY_SUPPORTED ? getOpacity : function(element) {\n    var filter = Element.getStyle(element, 'filter');\n    if (filter.length === 0) return 1.0;\n    var match = (filter || '').match(/alpha\\(opacity=(.*)\\)/i);\n    if (match && match[1]) return parseFloat(match[1]) / 100;\n    return 1.0;\n  };\n  \n  \n  Object.extend(methods, {\n    setStyle:   setStyle,\n    getStyle:   getStyle,\n    setOpacity: setOpacity,\n    getOpacity: getOpacity\n  });\n  if (Prototype.Browser.Opera) {\n    // Opera also has 'styleFloat' in DIV.style\n    methods.getStyle = getStyle_Opera;\n  } else if ('styleFloat' in DIV.style) {\n    methods.getStyle = getStyle_IE;\n    methods.setOpacity = setOpacity_IE;\n    methods.getOpacity = getOpacity_IE;\n  }\n  \n  // STORAGE\n  var UID = 0;\n  \n  GLOBAL.Element.Storage = { UID: 1 };\n  \n  function getUniqueElementID(element) {\n    if (element === window) return 0;\n    // Need to use actual `typeof` operator to prevent errors in some\n    // environments when accessing node expandos.\n    if (typeof element._prototypeUID === 'undefined')\n      element._prototypeUID = Element.Storage.UID++;\n    return element._prototypeUID;\n  }\n  \n  // In Internet Explorer, DOM nodes have a `uniqueID` property. Saves us\n  // from inventing our own.\n  function getUniqueElementID_IE(element) {\n    if (element === window) return 0;\n    // The document object's `uniqueID` property changes each time you read it.\n    if (element == document) return 1;\n    return element.uniqueID;\n  }\n  \n  var HAS_UNIQUE_ID_PROPERTY = ('uniqueID' in DIV);\n  if (HAS_UNIQUE_ID_PROPERTY)\n    getUniqueElementID = getUniqueElementID_IE;\n  \n  function getStorage(element) {\n    if (!(element = $(element))) return;\n    \n    var uid = getUniqueElementID(element);\n    \n    if (!Element.Storage[uid])\n      Element.Storage[uid] = $H();\n      \n    return Element.Storage[uid];\n  }\n  \n  function store(element, key, value) {\n    if (!(element = $(element))) return;\n    var storage = getStorage(element);\n    if (arguments.length === 2) {\n      // Assume we've been passed an object full of key/value pairs.\n      storage.update(key);\n    } else {\n      storage.set(key, value);\n    }\n    return element;\n  }\n  \n  function retrieve(element, key, defaultValue) {\n    if (!(element = $(element))) return;\n    var storage = getStorage(element), value = storage.get(key);\n    \n    if (Object.isUndefined(value)) {\n      storage.set(key, defaultValue);\n      value = defaultValue;\n    }\n    \n    return value;\n  }\n  \n  \n  Object.extend(methods, {\n    getStorage: getStorage,\n    store:      store,\n    retrieve:   retrieve\n  });\n  \n  \n  // ELEMENT EXTENSION\n  var Methods = {}, ByTag = Element.Methods.ByTag,\n   F = Prototype.BrowserFeatures;\n  \n  // Handle environments which support extending element prototypes\n  // but don't expose the standard class name.\n  if (!F.ElementExtensions && ('__proto__' in DIV)) {\n    GLOBAL.HTMLElement = {};\n    GLOBAL.HTMLElement.prototype = DIV['__proto__'];\n    F.ElementExtensions = true;\n  }\n  \n  // Certain oddball element types can't be extended in IE8.\n  function checkElementPrototypeDeficiency(tagName) {\n    if (typeof window.Element === 'undefined') return false;\n    var proto = window.Element.prototype;\n    if (proto) {\n      var id = '_' + (Math.random() + '').slice(2),\n       el = document.createElement(tagName);\n      proto[id] = 'x';\n      var isBuggy = (el[id] !== 'x');\n      delete proto[id];\n      el = null;\n      return isBuggy;\n    }\n    \n    return false;    \n  }\n  \n  var HTMLOBJECTELEMENT_PROTOTYPE_BUGGY = \n   checkElementPrototypeDeficiency('object');\n  \n  function extendElementWith(element, methods) {\n    for (var property in methods) {\n      var value = methods[property];\n      if (Object.isFunction(value) && !(property in element))\n        element[property] = value.methodize();\n    }\n  }\n  \n  // Keeps track of the UIDs of extended elements.\n  var EXTENDED = {};\n  function elementIsExtended(element) {\n    var uid = getUniqueElementID(element);\n    return (uid in EXTENDED);\n  }\n  \n  function extend(element) {\n    if (!element || elementIsExtended(element)) return element;\n    if (element.nodeType !== Node.ELEMENT_NODE || element == window)\n      return element;\n      \n    var methods = Object.clone(Methods),\n     tagName = element.tagName.toUpperCase();\n     \n    // Add methods for specific tags.\n    if (ByTag[tagName]) Object.extend(methods, ByTag[tagName]);\n    \n    extendElementWith(element, methods);\n    EXTENDED[getUniqueElementID(element)] = true;\n    return element;\n  }\n  \n  // Because of the deficiency mentioned above, IE8 needs a very thin version\n  // of Element.extend that acts like Prototype.K _except_ when the element\n  // is one of the problematic types.\n  function extend_IE8(element) {\n    if (!element || elementIsExtended(element)) return element;\n    \n    var t = element.tagName;\n    if (t && (/^(?:object|applet|embed)$/i.test(t))) {\n      extendElementWith(element, Element.Methods);\n      extendElementWith(element, Element.Methods.Simulated);\n      extendElementWith(element, Element.Methods.ByTag[t.toUpperCase()]);\n    }\n    \n    return element;\n  }\n  // If the browser lets us extend specific elements, we can replace `extend`\n  // with a thinner version (or, ideally, an empty version).\n  if (F.SpecificElementExtensions) {\n    extend = HTMLOBJECTELEMENT_PROTOTYPE_BUGGY ? extend_IE8 : Prototype.K;\n  }\n  \n  function addMethodsToTagName(tagName, methods) {\n    tagName = tagName.toUpperCase();\n    if (!ByTag[tagName]) ByTag[tagName] = {};\n    Object.extend(ByTag[tagName], methods);\n  }\n  \n  function mergeMethods(destination, methods, onlyIfAbsent) {\n    if (Object.isUndefined(onlyIfAbsent)) onlyIfAbsent = false;\n    for (var property in methods) {\n      var value = methods[property];\n      if (!Object.isFunction(value)) continue;\n      if (!onlyIfAbsent || !(property in destination))\n        destination[property] = value.methodize();\n    }\n  }\n  \n  function findDOMClass(tagName) {\n    var klass;\n    var trans = {\n      \"OPTGROUP\": \"OptGroup\", \"TEXTAREA\": \"TextArea\", \"P\": \"Paragraph\",\n      \"FIELDSET\": \"FieldSet\", \"UL\": \"UList\", \"OL\": \"OList\", \"DL\": \"DList\",\n      \"DIR\": \"Directory\", \"H1\": \"Heading\", \"H2\": \"Heading\", \"H3\": \"Heading\",\n      \"H4\": \"Heading\", \"H5\": \"Heading\", \"H6\": \"Heading\", \"Q\": \"Quote\",\n      \"INS\": \"Mod\", \"DEL\": \"Mod\", \"A\": \"Anchor\", \"IMG\": \"Image\", \"CAPTION\":\n      \"TableCaption\", \"COL\": \"TableCol\", \"COLGROUP\": \"TableCol\", \"THEAD\":\n      \"TableSection\", \"TFOOT\": \"TableSection\", \"TBODY\": \"TableSection\", \"TR\":\n      \"TableRow\", \"TH\": \"TableCell\", \"TD\": \"TableCell\", \"FRAMESET\":\n      \"FrameSet\", \"IFRAME\": \"IFrame\"\n    };\n    if (trans[tagName]) klass = 'HTML' + trans[tagName] + 'Element';\n    if (window[klass]) return window[klass];\n    klass = 'HTML' + tagName + 'Element';\n    if (window[klass]) return window[klass];\n    klass = 'HTML' + tagName.capitalize() + 'Element';\n    if (window[klass]) return window[klass];\n    var element = document.createElement(tagName),\n     proto = element['__proto__'] || element.constructor.prototype;\n        \n    element = null;\n    return proto;\n  }\n  \n  function addMethods(methods) {\n    if (arguments.length === 0) addFormMethods();\n    \n    if (arguments.length === 2) {\n      // Tag names have been specified.\n      var tagName = methods;\n      methods = arguments[1];\n    }\n    \n    if (!tagName) {\n      Object.extend(Element.Methods, methods || {});\n    } else {\n      if (Object.isArray(tagName)) {\n        for (var i = 0, tag; tag = tagName[i]; i++)\n          addMethodsToTagName(tag, methods);\n      } else {\n        addMethodsToTagName(tagName, methods);\n      }\n    }\n    \n    var ELEMENT_PROTOTYPE = window.HTMLElement ? HTMLElement.prototype :\n     Element.prototype;\n     \n    if (F.ElementExtensions) {\n      mergeMethods(ELEMENT_PROTOTYPE, Element.Methods);\n      mergeMethods(ELEMENT_PROTOTYPE, Element.Methods.Simulated, true);\n    }\n    \n    if (F.SpecificElementExtensions) {\n      for (var tag in Element.Methods.ByTag) {\n        var klass = findDOMClass(tag);\n        if (Object.isUndefined(klass)) continue;\n        mergeMethods(klass.prototype, ByTag[tag]);\n      }\n    }\n    \n    Object.extend(Element, Element.Methods);\n    Object.extend(Element, Element.Methods.Simulated);\n    delete Element.ByTag;\n    delete Element.Simulated;\n    \n    Element.extend.refresh();\n    \n    // We need to replace the element creation cache because the nodes in the\n    // cache now have stale versions of the element methods.\n    ELEMENT_CACHE = {};\n  }\n  \n  Object.extend(GLOBAL.Element, {\n    extend:     extend,\n    addMethods: addMethods\n  });\n  \n  if (extend === Prototype.K) {\n    GLOBAL.Element.extend.refresh = Prototype.emptyFunction;\n  } else {\n    GLOBAL.Element.extend.refresh = function() {\n      if (Prototype.BrowserFeatures.ElementExtensions) return;\n      Object.extend(Methods, Element.Methods);\n      Object.extend(Methods, Element.Methods.Simulated);\n      // All existing extended elements are stale and need to be refreshed.\n      EXTENDED = {};\n    };\n  }\n  \n  function addFormMethods() {\n    // Add relevant element methods from the forms API.\n    Object.extend(Form, Form.Methods);\n    Object.extend(Form.Element, Form.Element.Methods);\n    Object.extend(Element.Methods.ByTag, {\n      \"FORM\":     Object.clone(Form.Methods),\n      \"INPUT\":    Object.clone(Form.Element.Methods),\n      \"SELECT\":   Object.clone(Form.Element.Methods),\n      \"TEXTAREA\": Object.clone(Form.Element.Methods),\n      \"BUTTON\":   Object.clone(Form.Element.Methods)\n    });\n  }\n  Element.addMethods(methods);\n  // Prevent IE leaks on DIV and ELEMENT_CACHE\n  function destroyCache_IE() {\n    DIV = null;\n    ELEMENT_CACHE = null;\n  }\n  if (window.attachEvent)\n    window.attachEvent('onunload', destroyCache_IE);\n})(this);\n(function() {\n  \n  // Converts a CSS percentage value to a decimal.\n  // Ex: toDecimal(\"30%\"); // -> 0.3\n  function toDecimal(pctString) {\n    var match = pctString.match(/^(\\d+)%?$/i);\n    if (!match) return null;\n    return (Number(match[1]) / 100);\n  }\n  \n  // A bare-bones version of Element.getStyle. Needed because getStyle is\n  // public-facing and too user-friendly for our tastes. We need raw,\n  // non-normalized values.\n  //\n  // Camel-cased property names only.\n  function getRawStyle(element, style) {\n    element = $(element);\n    // Try inline styles first.\n    var value = element.style[style];\n    if (!value || value === 'auto') {\n      // Reluctantly retrieve the computed style.\n      var css = document.defaultView.getComputedStyle(element, null);\n      value = css ? css[style] : null;\n    }\n    \n    if (style === 'opacity') return value ? parseFloat(value) : 1.0;\n    return value === 'auto' ? null : value;\n  }\n  \n  function getRawStyle_IE(element, style) {\n    // Try inline styles first.\n    var value = element.style[style];    \n    if (!value && element.currentStyle) {\n      // Reluctantly retrieve the current style.\n      value = element.currentStyle[style];\n    }\n    return value;\n  }\n  \n  // Quickly figures out the content width of an element. Used instead of\n  // `element.measure('width')` in several places below; we don't want to \n  // call back into layout code recursively if we don't have to.\n  //\n  // But this means it doesn't handle edge cases. Use it when you know the\n  // element in question is visible and will give accurate measurements.\n  function getContentWidth(element, context) {\n    var boxWidth = element.offsetWidth;\n    \n    var bl = getPixelValue(element, 'borderLeftWidth',  context) || 0;\n    var br = getPixelValue(element, 'borderRightWidth', context) || 0;\n    var pl = getPixelValue(element, 'paddingLeft',      context) || 0;\n    var pr = getPixelValue(element, 'paddingRight',     context) || 0;\n    \n    return boxWidth - bl - br - pl - pr;\n  }\n  \n  if ('currentStyle' in document.documentElement) {\n    getRawStyle = getRawStyle_IE;\n  }\n  \n  \n  // Can be called like this:\n  //   getPixelValue(\"11px\");\n  // Or like this:\n  //   getPixelValue(someElement, 'paddingTop');  \n  function getPixelValue(value, property, context) {\n    var element = null;\n    if (Object.isElement(value)) {\n      element = value;\n      value = getRawStyle(element, property);\n    }\n    if (value === null || Object.isUndefined(value)) {\n      return null;\n    }\n    \n    // Non-IE browsers will always return pixels if possible.\n    // (We use parseFloat instead of parseInt because Firefox can return\n    // non-integer pixel values.)\n    if ((/^(?:-)?\\d+(\\.\\d+)?(px)?$/i).test(value)) {\n      return window.parseFloat(value);\n    }\n    var isPercentage = value.include('%'), isViewport = (context === document.viewport);\n    \n    // When IE gives us something other than a pixel value, this technique\n    // (invented by Dean Edwards) will convert it to pixels.\n    //\n    // (This doesn't work for percentage values on elements with `position: fixed`\n    // because those percentages are relative to the viewport.)\n    if (/\\d/.test(value) && element && element.runtimeStyle && !(isPercentage && isViewport)) {\n      var style = element.style.left, rStyle = element.runtimeStyle.left; \n      element.runtimeStyle.left = element.currentStyle.left;\n      element.style.left = value || 0;  \n      value = element.style.pixelLeft;\n      element.style.left = style;\n      element.runtimeStyle.left = rStyle;\n      \n      return value;\n    }\n    // For other browsers, we have to do a bit of work.\n    // (At this point, only percentages should be left; all other CSS units\n    // are converted to pixels by getComputedStyle.)\n    if (element && isPercentage) {\n      // The `context` argument comes into play for percentage units; it's\n      // the thing that the unit represents a percentage of. When an\n      // absolutely-positioned element has a width of 50%, we know that's\n      // 50% of its offset parent. If it's `position: fixed` instead, we know\n      // it's 50% of the viewport. And so on.\n      context = context || element.parentNode;\n      var decimal = toDecimal(value), whole = null;\n      \n      var isHorizontal = property.include('left') || property.include('right') ||\n       property.include('width');\n       \n      var isVertical   = property.include('top') || property.include('bottom') ||\n        property.include('height');\n        \n      if (context === document.viewport) {\n        if (isHorizontal) {\n          whole = document.viewport.getWidth();\n        } else if (isVertical) {\n          whole = document.viewport.getHeight();\n        }\n      } else {\n        if (isHorizontal) {\n          whole = $(context).measure('width');\n        } else if (isVertical) {\n          whole = $(context).measure('height');\n        }\n      }\n      \n      return (whole === null) ? 0 : whole * decimal;\n    }\n    \n    // If we get this far, we should probably give up.\n    return 0;\n  }\n  \n  // Turns plain numbers into pixel measurements.\n  function toCSSPixels(number) {\n    if (Object.isString(number) && number.endsWith('px'))\n      return number;\n    return number + 'px';    \n  }\n  \n  // Shortcut for figuring out if an element is `display: none` or not.\n  function isDisplayed(element) {\n    while (element && element.parentNode) {\n      var display = element.getStyle('display');\n      if (display === 'none') {\n        return false;\n      }\n      element = $(element.parentNode);\n    }\n    return true;\n  }\n  \n  // In IE6-7, positioned elements often need hasLayout triggered before they\n  // report accurate measurements.\n  var hasLayout = Prototype.K;  \n  if ('currentStyle' in document.documentElement) {\n    hasLayout = function(element) {\n      if (!element.currentStyle.hasLayout) {\n        element.style.zoom = 1;\n      }\n      return element;\n    };\n  }\n  // Converts the layout hash property names back to the CSS equivalents.\n  // For now, only the border properties differ.\n  function cssNameFor(key) {\n    if (key.include('border')) key = key + '-width';\n    return key.camelize();\n  }\n  \n  Element.Layout = Class.create(Hash, {\n    initialize: function($super, element, preCompute) {\n      $super();\n      this.element = $(element);\n      \n      // nullify all properties keys\n      Element.Layout.PROPERTIES.each( function(property) {\n        this._set(property, null);\n      }, this);\n      \n      // The 'preCompute' boolean tells us whether we should fetch all values\n      // at once. If so, we should do setup/teardown only once. We set a flag\n      // so that we can ignore calls to `_begin` and `_end` elsewhere.\n      if (preCompute) {\n        this._preComputing = true;\n        this._begin();\n        Element.Layout.PROPERTIES.each( this._compute, this );\n        this._end();\n        this._preComputing = false;\n      }\n    },\n    \n    _set: function(property, value) {\n      return Hash.prototype.set.call(this, property, value);\n    },    \n    \n    // TODO: Investigate.\n    set: function(property, value) {\n      throw \"Properties of Element.Layout are read-only.\";\n    },\n    \n    get: function($super, property) {\n      // Try to fetch from the cache.\n      var value = $super(property);\n      return value === null ? this._compute(property) : value;\n    },\n    \n    // `_begin` and `_end` are two functions that are called internally \n    // before and after any measurement is done. In certain conditions (e.g.,\n    // when hidden), elements need a \"preparation\" phase that ensures\n    // accuracy of measurements.\n    _begin: function() {\n      if (this._isPrepared()) return;\n      \n      var element = this.element;\n      if (isDisplayed(element)) {\n        this._setPrepared(true);\n        return;\n      }\n      \n      // If we get this far, it means this element is hidden. To get usable\n      // measurements, we must remove `display: none`, but in a manner that \n      // isn't noticeable to the user. That means we also set\n      // `visibility: hidden` to make it invisible, and `position: absolute`\n      // so that it won't alter the document flow when displayed.\n      //\n      // Once we do this, the element is \"prepared,\" and we can make our\n      // measurements. When we're done, the `_end` method cleans up our\n      // changes.\n      \n      // Remember the original values for some styles we're going to alter.\n      var originalStyles = {\n        position:   element.style.position   || '',\n        width:      element.style.width      || '',\n        visibility: element.style.visibility || '',\n        display:    element.style.display    || ''\n      };\n      \n      // We store them so that the `_end` method can retrieve them later.\n      element.store('prototype_original_styles', originalStyles);\n      \n      var position = getRawStyle(element, 'position'), width = element.offsetWidth;\n      if (width === 0 || width === null) {\n        // Opera/IE won't report the true width of the element through\n        // `getComputedStyle` if it's hidden. If we got a nonsensical value,\n        // we need to show the element and try again.\n        element.style.display = 'block';\n        width = element.offsetWidth;\n      }\n      \n      // Preserve the context in case we get a percentage value.  \n      var context = (position === 'fixed') ? document.viewport :\n       element.parentNode;\n       \n      var tempStyles = {\n        visibility: 'hidden',\n        display:    'block'\n      };\n      \n      // If the element's `position: fixed`, it's already out of the document\n      // flow, so it's both unnecessary and inaccurate to set\n      // `position: absolute`.\n      if (position !== 'fixed') tempStyles.position = 'absolute';\n       \n      element.setStyle(tempStyles);\n      \n      var positionedWidth = element.offsetWidth, newWidth;\n      if (width && (positionedWidth === width)) {\n        // If the element's width is the same both before and after\n        // we set absolute positioning, that means:\n        //  (a) it was already absolutely-positioned; or\n        //  (b) it has an explicitly-set width, instead of width: auto.\n        // Either way, it means the element is the width it needs to be\n        // in order to report an accurate height.\n        newWidth = getContentWidth(element, context);\n      } else if (position === 'absolute' || position === 'fixed') {\n        // Absolute- and fixed-position elements' dimensions don't depend\n        // upon those of their parents.\n        newWidth = getContentWidth(element, context);\n      } else {\n        // Otherwise, the element's width depends upon the width of its\n        // parent.\n        var parent = element.parentNode, pLayout = $(parent).getLayout();\n        newWidth = pLayout.get('width') -\n         this.get('margin-left') -\n         this.get('border-left') -\n         this.get('padding-left') -\n         this.get('padding-right') -\n         this.get('border-right') -\n         this.get('margin-right');\n      }\n      \n      // Whatever the case, we've now figured out the correct `width` value\n      // for the element.\n      element.setStyle({ width: newWidth + 'px' });\n      \n      // The element is now ready for measuring.\n      this._setPrepared(true);\n    },\n    \n    _end: function() {\n      var element = this.element;\n      var originalStyles = element.retrieve('prototype_original_styles');\n      element.store('prototype_original_styles', null);\n      element.setStyle(originalStyles);\n      this._setPrepared(false);\n    },\n    \n    _compute: function(property) {\n      var COMPUTATIONS = Element.Layout.COMPUTATIONS;\n      if (!(property in COMPUTATIONS)) {\n        throw \"Property not found.\";\n      }\n      \n      return this._set(property, COMPUTATIONS[property].call(this, this.element));\n    },\n    \n    _isPrepared: function() {\n      return this.element.retrieve('prototype_element_layout_prepared', false);\n    },\n    \n    _setPrepared: function(bool) {\n      return this.element.store('prototype_element_layout_prepared', bool);\n    },\n    \n    toObject: function() {\n      var args = $A(arguments);\n      var keys = (args.length === 0) ? Element.Layout.PROPERTIES :\n       args.join(' ').split(' ');\n      var obj = {};\n      keys.each( function(key) {\n        // Key needs to be a valid Element.Layout property.\n        if (!Element.Layout.PROPERTIES.include(key)) return;\n        var value = this.get(key);\n        if (value != null) obj[key] = value;\n      }, this);\n      return obj;\n    },\n    \n    toHash: function() {\n      var obj = this.toObject.apply(this, arguments);\n      return new Hash(obj);\n    },\n    \n    toCSS: function() {\n      var args = $A(arguments);\n      var keys = (args.length === 0) ? Element.Layout.PROPERTIES :\n       args.join(' ').split(' ');\n      var css = {};\n      keys.each( function(key) {\n        // Key needs to be a valid Element.Layout property...\n        if (!Element.Layout.PROPERTIES.include(key)) return;        \n        // ...but not a composite property.\n        if (Element.Layout.COMPOSITE_PROPERTIES.include(key)) return;\n        var value = this.get(key);\n        if (value != null) css[cssNameFor(key)] = value + 'px';\n      }, this);\n      return css;\n    },\n    \n    inspect: function() {\n      return \"#<Element.Layout>\";\n    }\n  });\n  \n  Object.extend(Element.Layout, {\n    PROPERTIES: $w('height width top left right bottom border-left border-right border-top border-bottom padding-left padding-right padding-top padding-bottom margin-top margin-bottom margin-left margin-right padding-box-width padding-box-height border-box-width border-box-height margin-box-width margin-box-height'),\n    \n    COMPOSITE_PROPERTIES: $w('padding-box-width padding-box-height margin-box-width margin-box-height border-box-width border-box-height'),\n    \n    COMPUTATIONS: {\n      'height': function(element) {\n        if (!this._preComputing) this._begin();\n        \n        var bHeight = this.get('border-box-height');\n        if (bHeight <= 0) {\n          if (!this._preComputing) this._end();\n          return 0;\n        }\n        \n        var bTop = this.get('border-top'),\n         bBottom = this.get('border-bottom');\n        var pTop = this.get('padding-top'),\n         pBottom = this.get('padding-bottom');\n        if (!this._preComputing) this._end();\n        return bHeight - bTop - bBottom - pTop - pBottom;\n      },\n      \n      'width': function(element) {\n        if (!this._preComputing) this._begin();\n        \n        var bWidth = this.get('border-box-width');\n        if (bWidth <= 0) {\n          if (!this._preComputing) this._end();\n          return 0;\n        }\n        var bLeft = this.get('border-left'),\n         bRight = this.get('border-right');\n        var pLeft = this.get('padding-left'),\n         pRight = this.get('padding-right');\n         \n        if (!this._preComputing) this._end();\n        return bWidth - bLeft - bRight - pLeft - pRight;\n      },\n      \n      'padding-box-height': function(element) {\n        var height = this.get('height'),\n         pTop = this.get('padding-top'),\n         pBottom = this.get('padding-bottom');\n         \n        return height + pTop + pBottom;\n      },\n      'padding-box-width': function(element) {\n        var width = this.get('width'),\n         pLeft = this.get('padding-left'),\n         pRight = this.get('padding-right');\n         \n        return width + pLeft + pRight;\n      },\n      \n      'border-box-height': function(element) {\n        if (!this._preComputing) this._begin();\n        var height = element.offsetHeight;\n        if (!this._preComputing) this._end();\n        return height;\n      },\n            \n      'border-box-width': function(element) {\n        if (!this._preComputing) this._begin();\n        var width = element.offsetWidth;\n        if (!this._preComputing) this._end();\n        return width;\n      },\n      \n      'margin-box-height': function(element) {\n        var bHeight = this.get('border-box-height'),\n         mTop = this.get('margin-top'),\n         mBottom = this.get('margin-bottom');\n         \n        if (bHeight <= 0) return 0;\n         \n        return bHeight + mTop + mBottom;        \n      },\n      'margin-box-width': function(element) {\n        var bWidth = this.get('border-box-width'),\n         mLeft = this.get('margin-left'),\n         mRight = this.get('margin-right');\n        if (bWidth <= 0) return 0;\n         \n        return bWidth + mLeft + mRight;\n      },\n      \n      'top': function(element) {\n        var offset = element.positionedOffset();\n        return offset.top;\n      },\n      \n      'bottom': function(element) {\n        var offset = element.positionedOffset(),\n         parent = element.getOffsetParent(),\n         pHeight = parent.measure('height');\n        \n        var mHeight = this.get('border-box-height');\n        \n        return pHeight - mHeight - offset.top;\n        // \n        // return getPixelValue(element, 'bottom');\n      },\n      \n      'left': function(element) {\n        var offset = element.positionedOffset();\n        return offset.left;\n      },\n      \n      'right': function(element) {\n        var offset = element.positionedOffset(),\n         parent = element.getOffsetParent(),\n         pWidth = parent.measure('width');\n        \n        var mWidth = this.get('border-box-width');\n        \n        return pWidth - mWidth - offset.left;\n        //  \n        // return getPixelValue(element, 'right');\n      },\n      \n      'padding-top': function(element) {\n        return getPixelValue(element, 'paddingTop');\n      },\n      \n      'padding-bottom': function(element) {\n        return getPixelValue(element, 'paddingBottom');\n      },\n      \n      'padding-left': function(element) {\n        return getPixelValue(element, 'paddingLeft');\n      },\n      \n      'padding-right': function(element) {\n        return getPixelValue(element, 'paddingRight');\n      },\n      \n      'border-top': function(element) {\n        return getPixelValue(element, 'borderTopWidth');\n      },\n      \n      'border-bottom': function(element) {\n        return getPixelValue(element, 'borderBottomWidth');\n      },\n      \n      'border-left': function(element) {\n        return getPixelValue(element, 'borderLeftWidth');\n      },\n      \n      'border-right': function(element) {\n        return getPixelValue(element, 'borderRightWidth');\n      },\n      \n      'margin-top': function(element) {\n        return getPixelValue(element, 'marginTop');\n      },\n      \n      'margin-bottom': function(element) {\n        return getPixelValue(element, 'marginBottom');\n      },\n      \n      'margin-left': function(element) {\n        return getPixelValue(element, 'marginLeft');\n      },\n      \n      'margin-right': function(element) {\n        return getPixelValue(element, 'marginRight');\n      }\n    }\n  });\n  \n  // An easier way to compute right and bottom offsets.\n  if ('getBoundingClientRect' in document.documentElement) {\n    Object.extend(Element.Layout.COMPUTATIONS, {\n      'right': function(element) {\n        var parent = hasLayout(element.getOffsetParent());\n        var rect = element.getBoundingClientRect(),\n         pRect = parent.getBoundingClientRect();\n         \n        return (pRect.right - rect.right).round();\n      },\n      \n      'bottom': function(element) {\n        var parent = hasLayout(element.getOffsetParent());\n        var rect = element.getBoundingClientRect(),\n         pRect = parent.getBoundingClientRect();\n         \n        return (pRect.bottom - rect.bottom).round();\n      }\n    });\n  }\n  \n  Element.Offset = Class.create({\n    initialize: function(left, top) {\n      this.left = left.round();\n      this.top  = top.round();\n      \n      // Act like an array.\n      this[0] = this.left;\n      this[1] = this.top;\n    },\n    \n    relativeTo: function(offset) {\n      return new Element.Offset(\n        this.left - offset.left, \n        this.top  - offset.top\n      );\n    },\n    \n    inspect: function() {\n      return \"#<Element.Offset left: #{left} top: #{top}>\".interpolate(this);\n    },\n    \n    toString: function() {\n      return \"[#{left}, #{top}]\".interpolate(this);\n    },\n    \n    toArray: function() {\n      return [this.left, this.top];\n    }\n  });\n  \n  function getLayout(element, preCompute) {\n    return new Element.Layout(element, preCompute);\n  }\n    \n  function measure(element, property) {\n    return $(element).getLayout().get(property);  \n  }\n  function getHeight(element) {\n    return Element.getDimensions(element).height;\n  }\n  \n  function getWidth(element) {\n    return Element.getDimensions(element).width;\n  }\n  function getDimensions(element) {\n    element = $(element);\n    var display = Element.getStyle(element, 'display');\n    \n    if (display && display !== 'none') {\n      return { width: element.offsetWidth, height: element.offsetHeight };\n    }\n    \n    // All *Width and *Height properties give 0 on elements with\n    // `display: none`, so show the element temporarily.\n    var style = element.style;\n    var originalStyles = {\n      visibility: style.visibility,\n      position:   style.position,\n      display:    style.display\n    };\n    \n    var newStyles = {\n      visibility: 'hidden',\n      display:    'block'\n    };\n    // Switching `fixed` to `absolute` causes issues in Safari.\n    if (originalStyles.position !== 'fixed')\n      newStyles.position = 'absolute';\n    \n    Element.setStyle(element, newStyles);\n    \n    var dimensions = {\n      width:  element.offsetWidth,\n      height: element.offsetHeight\n    };\n    \n    Element.setStyle(element, originalStyles);\n    return dimensions;\n  }\n  \n  function getOffsetParent(element) {\n    element = $(element);\n    \n    // For unusual cases like these, we standardize on returning the BODY\n    // element as the offset parent.\n    if (isDocument(element) || isDetached(element) || isBody(element) || isHtml(element))\n      return $(document.body);\n    // IE reports offset parent incorrectly for inline elements.\n    var isInline = (Element.getStyle(element, 'display') === 'inline');\n    if (!isInline && element.offsetParent) return isHtml(element.offsetParent) ? $(document.body) : $(element.offsetParent);\n    \n    while ((element = element.parentNode) && element !== document.body) {\n      if (Element.getStyle(element, 'position') !== 'static') {\n        return isHtml(element) ? $(document.body) : $(element);\n      }\n    }\n    \n    return $(document.body);\n  }\n  \n  \n  function cumulativeOffset(element) {\n    element = $(element);\n    var valueT = 0, valueL = 0;\n    if (element.parentNode) {\n      do {\n        valueT += element.offsetTop  || 0;\n        valueL += element.offsetLeft || 0;\n        element = element.offsetParent;\n      } while (element);\n    }\n    return new Element.Offset(valueL, valueT);\n  }\n  \n  function positionedOffset(element) {    \n    element = $(element);\n    // Account for the margin of the element.\n    var layout = element.getLayout();\n    \n    var valueT = 0, valueL = 0;\n    do {\n      valueT += element.offsetTop  || 0;\n      valueL += element.offsetLeft || 0;\n      element = element.offsetParent;\n      if (element) {\n        if (isBody(element)) break;\n        var p = Element.getStyle(element, 'position');\n        if (p !== 'static') break;\n      }\n    } while (element);\n    \n    valueT -= layout.get('margin-top');\n    valueL -= layout.get('margin-left');\n    \n    return new Element.Offset(valueL, valueT);\n  }\n  function cumulativeScrollOffset(element) {\n    var valueT = 0, valueL = 0;\n    do {\n      if(element == document.body){\n        valueT += (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop || 0;\n        valueL += (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft || 0;\n        break;\n      } else {\n        valueT += element.scrollTop  || 0;\n        valueL += element.scrollLeft || 0;\n        element = element.parentNode;\n      }\n    } while (element);\n    return new Element.Offset(valueL, valueT);\n  }\n  function viewportOffset(forElement) {\n    var valueT = 0, valueL = 0, docBody = document.body;\n    forElement = $(forElement);\n    var element = forElement;\n    do {\n      valueT += element.offsetTop  || 0;\n      valueL += element.offsetLeft || 0;\n      // Safari fix\n      if (element.offsetParent == docBody &&\n        Element.getStyle(element, 'position') == 'absolute') break;\n    } while (element = element.offsetParent);\n    element = forElement;\n    do {\n      // Opera < 9.5 sets scrollTop/Left on both HTML and BODY elements.\n      // Other browsers set it only on the HTML element. The BODY element\n      // can be skipped since its scrollTop/Left should always be 0.\n      if (element != docBody) {\n        valueT -= element.scrollTop  || 0;\n        valueL -= element.scrollLeft || 0;\n      }\n    } while (element = element.parentNode);    \n    return new Element.Offset(valueL, valueT);\n  }\n  \n  function absolutize(element) {\n    element = $(element);\n    \n    if (Element.getStyle(element, 'position') === 'absolute') {\n      return element;\n    }\n    \n    var offsetParent = getOffsetParent(element);    \n    var eOffset = element.viewportOffset(),\n     pOffset = offsetParent.viewportOffset();\n     \n    var offset = eOffset.relativeTo(pOffset);\n    var layout = element.getLayout();    \n    \n    element.store('prototype_absolutize_original_styles', {\n      position: element.getStyle('position'),\n      left:     element.getStyle('left'),\n      top:      element.getStyle('top'),\n      width:    element.getStyle('width'),\n      height:   element.getStyle('height')\n    });\n    \n    element.setStyle({\n      position: 'absolute',\n      top:    offset.top + 'px',\n      left:   offset.left + 'px',\n      width:  layout.get('width') + 'px',\n      height: layout.get('height') + 'px'\n    });\n    \n    return element;\n  }\n  \n  function relativize(element) {\n    element = $(element);\n    if (Element.getStyle(element, 'position') === 'relative') {\n      return element;\n    }\n    \n    // Restore the original styles as captured by Element#absolutize.\n    var originalStyles = \n     element.retrieve('prototype_absolutize_original_styles');\n    \n    if (originalStyles) element.setStyle(originalStyles);\n    return element;\n  }\n  \n  \n  function scrollTo(element) {\n    element = $(element);\n    var pos = Element.cumulativeOffset(element);\n    window.scrollTo(pos.left, pos.top);\n    return element;\n  }\n  \n  function makePositioned(element) {\n    element = $(element);\n    var position = Element.getStyle(element, 'position'), styles = {};\n    if (position === 'static' || !position) {\n      styles.position = 'relative';\n      // When an element is `position: relative` with an undefined `top` and\n      // `left`, Opera returns the offset relative to positioning context.\n      if (Prototype.Browser.Opera) {\n        styles.top  = 0;\n        styles.left = 0;\n      }\n      Element.setStyle(element, styles);\n      Element.store(element, 'prototype_made_positioned', true);\n    }\n    return element;\n  }\n  \n  function undoPositioned(element) {\n    element = $(element);\n    var storage = Element.getStorage(element),\n     madePositioned = storage.get('prototype_made_positioned');\n    \n    if (madePositioned) {\n      storage.unset('prototype_made_positioned');\n      Element.setStyle(element, {\n        position: '',\n        top:      '',\n        bottom:   '',\n        left:     '',\n        right:    ''\n      });\n    }  \n    return element;\n  }\n  \n  function makeClipping(element) {\n    element = $(element);\n    \n    var storage = Element.getStorage(element),\n     madeClipping = storage.get('prototype_made_clipping');\n    \n    // The \"prototype_made_clipping\" storage key is meant to hold the\n    // original CSS overflow value. A string value or `null` means that we've\n    // called `makeClipping` already. An `undefined` value means we haven't.\n    if (Object.isUndefined(madeClipping)) {\n      var overflow = Element.getStyle(element, 'overflow');\n      storage.set('prototype_made_clipping', overflow);\n      if (overflow !== 'hidden')\n        element.style.overflow = 'hidden';\n    }\n    \n    return element;\n  }\n  \n  function undoClipping(element) {\n    element = $(element);\n    var storage = Element.getStorage(element),\n     overflow = storage.get('prototype_made_clipping');\n    \n    if (!Object.isUndefined(overflow)) {\n      storage.unset('prototype_made_clipping');\n      element.style.overflow = overflow || '';\n    }\n    \n    return element;\n  }\n  \n  function clonePosition(element, source, options) {\n    options = Object.extend({\n      setLeft:    true,\n      setTop:     true,\n      setWidth:   true,\n      setHeight:  true,\n      offsetTop:  0,\n      offsetLeft: 0\n    }, options || {});\n    \n    // Find page position of source.    \n    source  = $(source);\n    element = $(element);    \n    var p, delta, layout, styles = {};\n    if (options.setLeft || options.setTop) {\n      p = Element.viewportOffset(source);\n      delta = [0, 0];\n      // A delta of 0/0 will work for `positioned: fixed` elements, but\n      // for `position: absolute` we need to get the parent's offset.\n      if (Element.getStyle(element, 'position') === 'absolute') {\n        var parent = Element.getOffsetParent(element);\n        if (parent !== document.body) delta = Element.viewportOffset(parent);\n      }\n    }\n    if (options.setWidth || options.setHeight) {\n      layout = Element.getLayout(source);\n    }\n    // Set position.\n    if (options.setLeft)\n      styles.left = (p[0] - delta[0] + options.offsetLeft) + 'px';\n    if (options.setTop)\n      styles.top  = (p[1] - delta[1] + options.offsetTop)  + 'px';\n    \n    if (options.setWidth)\n      styles.width  = layout.get('border-box-width')  + 'px';\n    if (options.setHeight)\n      styles.height = layout.get('border-box-height') + 'px';\n    \n    return Element.setStyle(element, styles);\n  }\n  \n    \n  if (Prototype.Browser.IE) {\n    // IE doesn't report offsets correctly for static elements, so we change them\n    // to \"relative\" to get the values, then change them back.\n    getOffsetParent = getOffsetParent.wrap(\n      function(proceed, element) {\n        element = $(element);\n        \n        // For unusual cases like these, we standardize on returning the BODY\n        // element as the offset parent.\n        if (isDocument(element) || isDetached(element) || isBody(element) || isHtml(element))\n          return $(document.body);\n        var position = element.getStyle('position');\n        if (position !== 'static') return proceed(element);\n        element.setStyle({ position: 'relative' });\n        var value = proceed(element);\n        element.setStyle({ position: position });\n        return value;\n      }\n    );\n    \n    positionedOffset = positionedOffset.wrap(function(proceed, element) {\n      element = $(element);\n      if (!element.parentNode) return new Element.Offset(0, 0);\n      var position = element.getStyle('position');\n      if (position !== 'static') return proceed(element);\n      // Trigger hasLayout on the offset parent so that IE6 reports\n      // accurate offsetTop and offsetLeft values for position: fixed.\n      var offsetParent = element.getOffsetParent();\n      if (offsetParent && offsetParent.getStyle('position') === 'fixed')\n        hasLayout(offsetParent);\n      element.setStyle({ position: 'relative' });\n      var value = proceed(element);\n      element.setStyle({ position: position });\n      return value;\n    });\n  } else if (Prototype.Browser.Webkit) {    \n    // Safari returns margins on body which is incorrect if the child is absolutely\n    // positioned.  For performance reasons, redefine Element#cumulativeOffset for\n    // KHTML/WebKit only.\n    cumulativeOffset = function(element) {\n      element = $(element);\n      var valueT = 0, valueL = 0;\n      do {\n        valueT += element.offsetTop  || 0;\n        valueL += element.offsetLeft || 0;\n        if (element.offsetParent == document.body) {\n          if (Element.getStyle(element, 'position') == 'absolute') break;\n        }\n        element = element.offsetParent;\n      } while (element);\n      return new Element.Offset(valueL, valueT);\n    };\n  }\n  \n  \n  Element.addMethods({\n    getLayout:              getLayout,\n    measure:                measure,\n    getWidth:               getWidth,\n    getHeight:              getHeight,\n    getDimensions:          getDimensions,\n    getOffsetParent:        getOffsetParent,\n    cumulativeOffset:       cumulativeOffset,\n    positionedOffset:       positionedOffset,\n    cumulativeScrollOffset: cumulativeScrollOffset,\n    viewportOffset:         viewportOffset,    \n    absolutize:             absolutize,\n    relativize:             relativize,\n    scrollTo:               scrollTo,\n    makePositioned:         makePositioned,\n    undoPositioned:         undoPositioned,\n    makeClipping:           makeClipping,\n    undoClipping:           undoClipping,\n    clonePosition:          clonePosition\n  });\n  \n  function isBody(element) {\n    return element.nodeName.toUpperCase() === 'BODY';\n  }\n  \n  function isHtml(element) {\n    return element.nodeName.toUpperCase() === 'HTML';\n  }\n  \n  function isDocument(element) {\n    return element.nodeType === Node.DOCUMENT_NODE;\n  }\n  \n  function isDetached(element) {\n    return element !== document.body &&\n     !Element.descendantOf(element, document.body);\n  }\n  \n  // If the browser supports the nonstandard `getBoundingClientRect`\n  // (currently only IE and Firefox), it becomes far easier to obtain\n  // true offsets.\n  if ('getBoundingClientRect' in document.documentElement) {\n    Element.addMethods({\n      viewportOffset: function(element) {\n        element = $(element);        \n        if (isDetached(element)) return new Element.Offset(0, 0);\n        var rect = element.getBoundingClientRect(),\n         docEl = document.documentElement;\n        // The HTML element on IE < 8 has a 2px border by default, giving\n        // an incorrect offset. We correct this by subtracting clientTop\n        // and clientLeft.\n        return new Element.Offset(rect.left - docEl.clientLeft,\n         rect.top - docEl.clientTop);\n      }\n    }); \n  }\n  \n  \n})();\n(function() {\n  \n  var IS_OLD_OPERA = Prototype.Browser.Opera &&\n   (window.parseFloat(window.opera.version()) < 9.5);\n  var ROOT = null;\n  function getRootElement() {\n    if (ROOT) return ROOT;    \n    ROOT = IS_OLD_OPERA ? document.body : document.documentElement;\n    return ROOT;\n  }\n  function getDimensions() {\n    return { width: this.getWidth(), height: this.getHeight() };\n  }\n  \n  function getWidth() {\n    return getRootElement().clientWidth;\n  }\n  \n  function getHeight() {\n    return getRootElement().clientHeight;\n  }\n  \n  function getScrollOffsets() {\n    var x = window.pageXOffset || document.documentElement.scrollLeft ||\n     document.body.scrollLeft;\n    var y = window.pageYOffset || document.documentElement.scrollTop ||\n     document.body.scrollTop;\n     \n    return new Element.Offset(x, y);\n  }\n  \n  document.viewport = {\n    getDimensions:    getDimensions,\n    getWidth:         getWidth,\n    getHeight:        getHeight,\n    getScrollOffsets: getScrollOffsets\n  };\n  \n})();\nwindow.$$ = function() {\n  var expression = $A(arguments).join(', ');\n  return Prototype.Selector.select(expression, document);\n};\nPrototype.Selector = (function() {\n  \n  function select() {\n    throw new Error('Method \"Prototype.Selector.select\" must be defined.');\n  }\n  function match() {\n    throw new Error('Method \"Prototype.Selector.match\" must be defined.');\n  }\n  function find(elements, expression, index) {\n    index = index || 0;\n    var match = Prototype.Selector.match, length = elements.length, matchIndex = 0, i;\n    for (i = 0; i < length; i++) {\n      if (match(elements[i], expression) && index == matchIndex++) {\n        return Element.extend(elements[i]);\n      }\n    }\n  }\n  \n  function extendElements(elements) {\n    for (var i = 0, length = elements.length; i < length; i++) {\n      Element.extend(elements[i]);\n    }\n    return elements;\n  }\n  \n  \n  var K = Prototype.K;\n  \n  return {\n    select: select,\n    match: match,\n    find: find,\n    extendElements: (Element.extend === K) ? K : extendElements,\n    extendElement: Element.extend\n  };\n})();\n/*!\n * Sizzle CSS Selector Engine v1.9.4-pre\n * http://sizzlejs.com/\n *\n * Copyright 2013 jQuery Foundation, Inc. and other contributors\n * Released under the MIT license\n * http://jquery.org/license\n *\n * Date: 2013-06-03\n */\n(function( window, undefined ) {\nvar i,\n\tsupport,\n\tcachedruns,\n\tExpr,\n\tgetText,\n\tisXML,\n\tcompile,\n\toutermostContext,\n\tsortInput,\n\t// Local document vars\n\tsetDocument,\n\tdocument,\n\tdocElem,\n\tdocumentIsHTML,\n\trbuggyQSA,\n\trbuggyMatches,\n\tmatches,\n\tcontains,\n\t// Instance-specific data\n\texpando = \"sizzle\" + -(new Date()),\n\tpreferredDoc = window.document,\n\tdirruns = 0,\n\tdone = 0,\n\tclassCache = createCache(),\n\ttokenCache = createCache(),\n\tcompilerCache = createCache(),\n\thasDuplicate = false,\n\tsortOrder = function( a, b ) {\n\t\tif ( a === b ) {\n\t\t\thasDuplicate = true;\n\t\t\treturn 0;\n\t\t}\n\t\treturn 0;\n\t},\n\t// General-purpose constants\n\tstrundefined = typeof undefined,\n\tMAX_NEGATIVE = 1 << 31,\n\t// Instance methods\n\thasOwn = ({}).hasOwnProperty,\n\tarr = [],\n\tpop = arr.pop,\n\tpush_native = arr.push,\n\tpush = arr.push,\n\tslice = arr.slice,\n\t// Use a stripped-down indexOf if we can't use a native one\n\tindexOf = arr.indexOf || function( elem ) {\n\t\tvar i = 0,\n\t\t\tlen = this.length;\n\t\tfor ( ; i < len; i++ ) {\n\t\t\tif ( this[i] === elem ) {\n\t\t\t\treturn i;\n\t\t\t}\n\t\t}\n\t\treturn -1;\n\t},\n\tbooleans = \"checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped\",\n\t// Regular expressions\n\t// Whitespace characters http://www.w3.org/TR/css3-selectors/#whitespace\n\twhitespace = \"[\\\\x20\\\\t\\\\r\\\\n\\\\f]\",\n\t// http://www.w3.org/TR/css3-syntax/#characters\n\tcharacterEncoding = \"(?:\\\\\\\\.|[\\\\w-]|[^\\\\x00-\\\\xa0])+\",\n\t// Loosely modeled on CSS identifier characters\n\t// An unquoted value should be a CSS identifier http://www.w3.org/TR/css3-selectors/#attribute-selectors\n\t// Proper syntax: http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier\n\tidentifier = characterEncoding.replace( \"w\", \"w#\" ),\n\t// Acceptable operators http://www.w3.org/TR/selectors/#attribute-selectors\n\tattributes = \"\\\\[\" + whitespace + \"*(\" + characterEncoding + \")\" + whitespace +\n\t\t\"*(?:([*^$|!~]?=)\" + whitespace + \"*(?:(['\\\"])((?:\\\\\\\\.|[^\\\\\\\\])*?)\\\\3|(\" + identifier + \")|)|)\" + whitespace + \"*\\\\]\",\n\t// Prefer arguments quoted,\n\t//   then not containing pseudos/brackets,\n\t//   then attribute selectors/non-parenthetical expressions,\n\t//   then anything else\n\t// These preferences are here to reduce the number of selectors\n\t//   needing tokenize in the PSEUDO preFilter\n\tpseudos = \":(\" + characterEncoding + \")(?:\\\\(((['\\\"])((?:\\\\\\\\.|[^\\\\\\\\])*?)\\\\3|((?:\\\\\\\\.|[^\\\\\\\\()[\\\\]]|\" + attributes.replace( 3, 8 ) + \")*)|.*)\\\\)|)\",\n\t// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter\n\trtrim = new RegExp( \"^\" + whitespace + \"+|((?:^|[^\\\\\\\\])(?:\\\\\\\\.)*)\" + whitespace + \"+$\", \"g\" ),\n\trcomma = new RegExp( \"^\" + whitespace + \"*,\" + whitespace + \"*\" ),\n\trcombinators = new RegExp( \"^\" + whitespace + \"*([>+~]|\" + whitespace + \")\" + whitespace + \"*\" ),\n\trsibling = new RegExp( whitespace + \"*[+~]\" ),\n\trattributeQuotes = new RegExp( \"=\" + whitespace + \"*([^\\\\]'\\\"]*)\" + whitespace + \"*\\\\]\", \"g\" ),\n\trpseudo = new RegExp( pseudos ),\n\tridentifier = new RegExp( \"^\" + identifier + \"$\" ),\n\tmatchExpr = {\n\t\t\"ID\": new RegExp( \"^#(\" + characterEncoding + \")\" ),\n\t\t\"CLASS\": new RegExp( \"^\\\\.(\" + characterEncoding + \")\" ),\n\t\t\"TAG\": new RegExp( \"^(\" + characterEncoding.replace( \"w\", \"w*\" ) + \")\" ),\n\t\t\"ATTR\": new RegExp( \"^\" + attributes ),\n\t\t\"PSEUDO\": new RegExp( \"^\" + pseudos ),\n\t\t\"CHILD\": new RegExp( \"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\\\(\" + whitespace +\n\t\t\t\"*(even|odd|(([+-]|)(\\\\d*)n|)\" + whitespace + \"*(?:([+-]|)\" + whitespace +\n\t\t\t\"*(\\\\d+)|))\" + whitespace + \"*\\\\)|)\", \"i\" ),\n\t\t\"bool\": new RegExp( \"^(?:\" + booleans + \")$\", \"i\" ),\n\t\t// For use in libraries implementing .is()\n\t\t// We use this for POS matching in `select`\n\t\t\"needsContext\": new RegExp( \"^\" + whitespace + \"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\\\(\" +\n\t\t\twhitespace + \"*((?:-\\\\d)?\\\\d*)\" + whitespace + \"*\\\\)|)(?=[^-]|$)\", \"i\" )\n\t},\n\trnative = /^[^{]+\\{\\s*\\[native \\w/,\n\t// Easily-parseable/retrievable ID or TAG or CLASS selectors\n\trquickExpr = /^(?:#([\\w-]+)|(\\w+)|\\.([\\w-]+))$/,\n\trinputs = /^(?:input|select|textarea|button)$/i,\n\trheader = /^h\\d$/i,\n\trescape = /'|\\\\/g,\n\t// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters\n\trunescape = new RegExp( \"\\\\\\\\([\\\\da-f]{1,6}\" + whitespace + \"?|(\" + whitespace + \")|.)\", \"ig\" ),\n\tfunescape = function( _, escaped, escapedWhitespace ) {\n\t\tvar high = \"0x\" + escaped - 0x10000;\n\t\t// NaN means non-codepoint\n\t\t// Support: Firefox\n\t\t// Workaround erroneous numeric interpretation of +\"0x\"\n\t\treturn high !== high || escapedWhitespace ?\n\t\t\tescaped :\n\t\t\t// BMP codepoint\n\t\t\thigh < 0 ?\n\t\t\t\tString.fromCharCode( high + 0x10000 ) :\n\t\t\t\t// Supplemental Plane codepoint (surrogate pair)\n\t\t\t\tString.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );\n\t};\ntry {\n\tpush.apply(\n\t\t(arr = slice.call( preferredDoc.childNodes )),\n\t\tpreferredDoc.childNodes\n\t);\n\t// Support: Android<4.0\n\t// Detect silently failing push.apply\n\tarr[ preferredDoc.childNodes.length ].nodeType;\n} catch ( e ) {\n\tpush = { apply: arr.length ?\n\t\t// Leverage slice if possible\n\t\tfunction( target, els ) {\n\t\t\tpush_native.apply( target, slice.call(els) );\n\t\t} :\n\t\t// Support: IE<9\n\t\t// Otherwise append directly\n\t\tfunction( target, els ) {\n\t\t\tvar j = target.length,\n\t\t\t\ti = 0;\n\t\t\t// Can't trust NodeList.length\n\t\t\twhile ( (target[j++] = els[i++]) ) {}\n\t\t\ttarget.length = j - 1;\n\t\t}\n\t};\n}\nfunction Sizzle( selector, context, results, seed ) {\n\tvar match, elem, m, nodeType,\n\t\t// QSA vars\n\t\ti, groups, old, nid, newContext, newSelector;\n\tif ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {\n\t\tsetDocument( context );\n\t}\n\tcontext = context || document;\n\tresults = results || [];\n\tif ( !selector || typeof selector !== \"string\" ) {\n\t\treturn results;\n\t}\n\tif ( (nodeType = context.nodeType) !== 1 && nodeType !== 9 ) {\n\t\treturn [];\n\t}\n\tif ( documentIsHTML && !seed ) {\n\t\t// Shortcuts\n\t\tif ( (match = rquickExpr.exec( selector )) ) {\n\t\t\t// Speed-up: Sizzle(\"#ID\")\n\t\t\tif ( (m = match[1]) ) {\n\t\t\t\tif ( nodeType === 9 ) {\n\t\t\t\t\telem = context.getElementById( m );\n\t\t\t\t\t// Check parentNode to catch when Blackberry 4.6 returns\n\t\t\t\t\t// nodes that are no longer in the document #6963\n\t\t\t\t\tif ( elem && elem.parentNode ) {\n\t\t\t\t\t\t// Handle the case where IE, Opera, and Webkit return items\n\t\t\t\t\t\t// by name instead of ID\n\t\t\t\t\t\tif ( elem.id === m ) {\n\t\t\t\t\t\t\tresults.push( elem );\n\t\t\t\t\t\t\treturn results;\n\t\t\t\t\t\t}\n\t\t\t\t\t} else {\n\t\t\t\t\t\treturn results;\n\t\t\t\t\t}\n\t\t\t\t} else {\n\t\t\t\t\t// Context is not a document\n\t\t\t\t\tif ( context.ownerDocument && (elem = context.ownerDocument.getElementById( m )) &&\n\t\t\t\t\t\tcontains( context, elem ) && elem.id === m ) {\n\t\t\t\t\t\tresults.push( elem );\n\t\t\t\t\t\treturn results;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t// Speed-up: Sizzle(\"TAG\")\n\t\t\t} else if ( match[2] ) {\n\t\t\t\tpush.apply( results, context.getElementsByTagName( selector ) );\n\t\t\t\treturn results;\n\t\t\t// Speed-up: Sizzle(\".CLASS\")\n\t\t\t} else if ( (m = match[3]) && support.getElementsByClassName && context.getElementsByClassName ) {\n\t\t\t\tpush.apply( results, context.getElementsByClassName( m ) );\n\t\t\t\treturn results;\n\t\t\t}\n\t\t}\n\t\t// QSA path\n\t\tif ( support.qsa && (!rbuggyQSA || !rbuggyQSA.test( selector )) ) {\n\t\t\tnid = old = expando;\n\t\t\tnewContext = context;\n\t\t\tnewSelector = nodeType === 9 && selector;\n\t\t\t// qSA works strangely on Element-rooted queries\n\t\t\t// We can work around this by specifying an extra ID on the root\n\t\t\t// and working up from there (Thanks to Andrew Dupont for the technique)\n\t\t\t// IE 8 doesn't work on object elements\n\t\t\tif ( nodeType === 1 && context.nodeName.toLowerCase() !== \"object\" ) {\n\t\t\t\tgroups = tokenize( selector );\n\t\t\t\tif ( (old = context.getAttribute(\"id\")) ) {\n\t\t\t\t\tnid = old.replace( rescape, \"\\\\$&\" );\n\t\t\t\t} else {\n\t\t\t\t\tcontext.setAttribute( \"id\", nid );\n\t\t\t\t}\n\t\t\t\tnid = \"[id='\" + nid + \"'] \";\n\t\t\t\ti = groups.length;\n\t\t\t\twhile ( i-- ) {\n\t\t\t\t\tgroups[i] = nid + toSelector( groups[i] );\n\t\t\t\t}\n\t\t\t\tnewContext = rsibling.test( selector ) && context.parentNode || context;\n\t\t\t\tnewSelector = groups.join(\",\");\n\t\t\t}\n\t\t\tif ( newSelector ) {\n\t\t\t\ttry {\n\t\t\t\t\tpush.apply( results,\n\t\t\t\t\t\tnewContext.querySelectorAll( newSelector )\n\t\t\t\t\t);\n\t\t\t\t\treturn results;\n\t\t\t\t} catch(qsaError) {\n\t\t\t\t} finally {\n\t\t\t\t\tif ( !old ) {\n\t\t\t\t\t\tcontext.removeAttribute(\"id\");\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t// All others\n\treturn select( selector.replace( rtrim, \"$1\" ), context, results, seed );\n}\nfunction createCache() {\n\tvar keys = [];\n\tfunction cache( key, value ) {\n\t\t// Use (key + \" \") to avoid collision with native prototype properties (see Issue #157)\n\t\tif ( keys.push( key += \" \" ) > Expr.cacheLength ) {\n\t\t\t// Only keep the most recent entries\n\t\t\tdelete cache[ keys.shift() ];\n\t\t}\n\t\treturn (cache[ key ] = value);\n\t}\n\treturn cache;\n}\nfunction markFunction( fn ) {\n\tfn[ expando ] = true;\n\treturn fn;\n}\nfunction assert( fn ) {\n\tvar div = document.createElement(\"div\");\n\ttry {\n\t\treturn !!fn( div );\n\t} catch (e) {\n\t\treturn false;\n\t} finally {\n\t\t// Remove from its parent by default\n\t\tif ( div.parentNode ) {\n\t\t\tdiv.parentNode.removeChild( div );\n\t\t}\n\t\t// release memory in IE\n\t\tdiv = null;\n\t}\n}\nfunction addHandle( attrs, handler ) {\n\tvar arr = attrs.split(\"|\"),\n\t\ti = attrs.length;\n\twhile ( i-- ) {\n\t\tExpr.attrHandle[ arr[i] ] = handler;\n\t}\n}\nfunction siblingCheck( a, b ) {\n\tvar cur = b && a,\n\t\tdiff = cur && a.nodeType === 1 && b.nodeType === 1 &&\n\t\t\t( ~b.sourceIndex || MAX_NEGATIVE ) -\n\t\t\t( ~a.sourceIndex || MAX_NEGATIVE );\n\t// Use IE sourceIndex if available on both nodes\n\tif ( diff ) {\n\t\treturn diff;\n\t}\n\t// Check if b follows a\n\tif ( cur ) {\n\t\twhile ( (cur = cur.nextSibling) ) {\n\t\t\tif ( cur === b ) {\n\t\t\t\treturn -1;\n\t\t\t}\n\t\t}\n\t}\n\treturn a ? 1 : -1;\n}\nfunction createInputPseudo( type ) {\n\treturn function( elem ) {\n\t\tvar name = elem.nodeName.toLowerCase();\n\t\treturn name === \"input\" && elem.type === type;\n\t};\n}\nfunction createButtonPseudo( type ) {\n\treturn function( elem ) {\n\t\tvar name = elem.nodeName.toLowerCase();\n\t\treturn (name === \"input\" || name === \"button\") && elem.type === type;\n\t};\n}\nfunction createPositionalPseudo( fn ) {\n\treturn markFunction(function( argument ) {\n\t\targument = +argument;\n\t\treturn markFunction(function( seed, matches ) {\n\t\t\tvar j,\n\t\t\t\tmatchIndexes = fn( [], seed.length, argument ),\n\t\t\t\ti = matchIndexes.length;\n\t\t\t// Match elements found at the specified indexes\n\t\t\twhile ( i-- ) {\n\t\t\t\tif ( seed[ (j = matchIndexes[i]) ] ) {\n\t\t\t\t\tseed[j] = !(matches[j] = seed[j]);\n\t\t\t\t}\n\t\t\t}\n\t\t});\n\t});\n}\nisXML = Sizzle.isXML = function( elem ) {\n\t// documentElement is verified for cases where it doesn't yet exist\n\t// (such as loading iframes in IE - #4833)\n\tvar documentElement = elem && (elem.ownerDocument || elem).documentElement;\n\treturn documentElement ? documentElement.nodeName !== \"HTML\" : false;\n};\nsupport = Sizzle.support = {};\nsetDocument = Sizzle.setDocument = function( node ) {\n\tvar doc = node ? node.ownerDocument || node : preferredDoc,\n\t\tparent = doc.defaultView;\n\t// If no document and documentElement is available, return\n\tif ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {\n\t\treturn document;\n\t}\n\t// Set our document\n\tdocument = doc;\n\tdocElem = doc.documentElement;\n\t// Support tests\n\tdocumentIsHTML = !isXML( doc );\n\t// Support: IE>8\n\t// If iframe document is assigned to \"document\" variable and if iframe has been reloaded,\n\t// IE will throw \"permission denied\" error when accessing \"document\" variable, see jQuery #13936\n\t// IE6-8 do not support the defaultView property so parent will be undefined\n\tif ( parent && parent.attachEvent && parent !== parent.top ) {\n\t\tparent.attachEvent( \"onbeforeunload\", function() {\n\t\t\tsetDocument();\n\t\t});\n\t}\n\t/* Attributes\n\t---------------------------------------------------------------------- */\n\t// Support: IE<8\n\t// Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)\n\tsupport.attributes = assert(function( div ) {\n\t\tdiv.className = \"i\";\n\t\treturn !div.getAttribute(\"className\");\n\t});\n\t/* getElement(s)By*\n\t---------------------------------------------------------------------- */\n\t// Check if getElementsByTagName(\"*\") returns only elements\n\tsupport.getElementsByTagName = assert(function( div ) {\n\t\tdiv.appendChild( doc.createComment(\"\") );\n\t\treturn !div.getElementsByTagName(\"*\").length;\n\t});\n\t// Check if getElementsByClassName can be trusted\n\tsupport.getElementsByClassName = assert(function( div ) {\n\t\tdiv.innerHTML = \"<div class='a'></div><div class='a i'></div>\";\n\t\t// Support: Safari<4\n\t\t// Catch class over-caching\n\t\tdiv.firstChild.className = \"i\";\n\t\t// Support: Opera<10\n\t\t// Catch gEBCN failure to find non-leading classes\n\t\treturn div.getElementsByClassName(\"i\").length === 2;\n\t});\n\t// Support: IE<10\n\t// Check if getElementById returns elements by name\n\t// The broken getElementById methods don't pick up programatically-set names,\n\t// so use a roundabout getElementsByName test\n\tsupport.getById = assert(function( div ) {\n\t\tdocElem.appendChild( div ).id = expando;\n\t\treturn !doc.getElementsByName || !doc.getElementsByName( expando ).length;\n\t});\n\t// ID find and filter\n\tif ( support.getById ) {\n\t\tExpr.find[\"ID\"] = function( id, context ) {\n\t\t\tif ( typeof context.getElementById !== strundefined && documentIsHTML ) {\n\t\t\t\tvar m = context.getElementById( id );\n\t\t\t\t// Check parentNode to catch when Blackberry 4.6 returns\n\t\t\t\t// nodes that are no longer in the document #6963\n\t\t\t\treturn m && m.parentNode ? [m] : [];\n\t\t\t}\n\t\t};\n\t\tExpr.filter[\"ID\"] = function( id ) {\n\t\t\tvar attrId = id.replace( runescape, funescape );\n\t\t\treturn function( elem ) {\n\t\t\t\treturn elem.getAttribute(\"id\") === attrId;\n\t\t\t};\n\t\t};\n\t} else {\n\t\t// Support: IE6/7\n\t\t// getElementById is not reliable as a find shortcut\n\t\tdelete Expr.find[\"ID\"];\n\t\tExpr.filter[\"ID\"] =  function( id ) {\n\t\t\tvar attrId = id.replace( runescape, funescape );\n\t\t\treturn function( elem ) {\n\t\t\t\tvar node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode(\"id\");\n\t\t\t\treturn node && node.value === attrId;\n\t\t\t};\n\t\t};\n\t}\n\t// Tag\n\tExpr.find[\"TAG\"] = support.getElementsByTagName ?\n\t\tfunction( tag, context ) {\n\t\t\tif ( typeof context.getElementsByTagName !== strundefined ) {\n\t\t\t\treturn context.getElementsByTagName( tag );\n\t\t\t}\n\t\t} :\n\t\tfunction( tag, context ) {\n\t\t\tvar elem,\n\t\t\t\ttmp = [],\n\t\t\t\ti = 0,\n\t\t\t\tresults = context.getElementsByTagName( tag );\n\t\t\t// Filter out possible comments\n\t\t\tif ( tag === \"*\" ) {\n\t\t\t\twhile ( (elem = results[i++]) ) {\n\t\t\t\t\tif ( elem.nodeType === 1 ) {\n\t\t\t\t\t\ttmp.push( elem );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\treturn tmp;\n\t\t\t}\n\t\t\treturn results;\n\t\t};\n\t// Class\n\tExpr.find[\"CLASS\"] = support.getElementsByClassName && function( className, context ) {\n\t\tif ( typeof context.getElementsByClassName !== strundefined && documentIsHTML ) {\n\t\t\treturn context.getElementsByClassName( className );\n\t\t}\n\t};\n\t/* QSA/matchesSelector\n\t---------------------------------------------------------------------- */\n\t// QSA and matchesSelector support\n\t// matchesSelector(:active) reports false when true (IE9/Opera 11.5)\n\trbuggyMatches = [];\n\t// qSa(:focus) reports false when true (Chrome 21)\n\t// We allow this because of a bug in IE8/9 that throws an error\n\t// whenever `document.activeElement` is accessed on an iframe\n\t// So, we allow :focus to pass through QSA all the time to avoid the IE error\n\t// See http://bugs.jquery.com/ticket/13378\n\trbuggyQSA = [];\n\tif ( (support.qsa = rnative.test( doc.querySelectorAll )) ) {\n\t\t// Build QSA regex\n\t\t// Regex strategy adopted from Diego Perini\n\t\tassert(function( div ) {\n\t\t\t// Select is set to empty string on purpose\n\t\t\t// This is to test IE's treatment of not explicitly\n\t\t\t// setting a boolean content attribute,\n\t\t\t// since its presence should be enough\n\t\t\t// http://bugs.jquery.com/ticket/12359\n\t\t\tdiv.innerHTML = \"<select><option selected=''></option></select>\";\n\t\t\t// Support: IE8\n\t\t\t// Boolean attributes and \"value\" are not treated correctly\n\t\t\tif ( !div.querySelectorAll(\"[selected]\").length ) {\n\t\t\t\trbuggyQSA.push( \"\\\\[\" + whitespace + \"*(?:value|\" + booleans + \")\" );\n\t\t\t}\n\t\t\t// Webkit/Opera - :checked should return selected option elements\n\t\t\t// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked\n\t\t\t// IE8 throws error here and will not see later tests\n\t\t\tif ( !div.querySelectorAll(\":checked\").length ) {\n\t\t\t\trbuggyQSA.push(\":checked\");\n\t\t\t}\n\t\t});\n\t\tassert(function( div ) {\n\t\t\t// Support: Opera 10-12/IE8\n\t\t\t// ^= $= *= and empty values\n\t\t\t// Should not select anything\n\t\t\t// Support: Windows 8 Native Apps\n\t\t\t// The type attribute is restricted during .innerHTML assignment\n\t\t\tvar input = doc.createElement(\"input\");\n\t\t\tinput.setAttribute( \"type\", \"hidden\" );\n\t\t\tdiv.appendChild( input ).setAttribute( \"t\", \"\" );\n\t\t\tif ( div.querySelectorAll(\"[t^='']\").length ) {\n\t\t\t\trbuggyQSA.push( \"[*^$]=\" + whitespace + \"*(?:''|\\\"\\\")\" );\n\t\t\t}\n\t\t\t// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)\n\t\t\t// IE8 throws error here and will not see later tests\n\t\t\tif ( !div.querySelectorAll(\":enabled\").length ) {\n\t\t\t\trbuggyQSA.push( \":enabled\", \":disabled\" );\n\t\t\t}\n\t\t\t// Opera 10-11 does not throw on post-comma invalid pseudos\n\t\t\tdiv.querySelectorAll(\"*,:x\");\n\t\t\trbuggyQSA.push(\",.*:\");\n\t\t});\n\t}\n\tif ( (support.matchesSelector = rnative.test( (matches = docElem.webkitMatchesSelector ||\n\t\tdocElem.mozMatchesSelector ||\n\t\tdocElem.oMatchesSelector ||\n\t\tdocElem.msMatchesSelector) )) ) {\n\t\tassert(function( div ) {\n\t\t\t// Check to see if it's possible to do matchesSelector\n\t\t\t// on a disconnected node (IE 9)\n\t\t\tsupport.disconnectedMatch = matches.call( div, \"div\" );\n\t\t\t// This should fail with an exception\n\t\t\t// Gecko does not error, returns false instead\n\t\t\tmatches.call( div, \"[s!='']:x\" );\n\t\t\trbuggyMatches.push( \"!=\", pseudos );\n\t\t});\n\t}\n\trbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join(\"|\") );\n\trbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join(\"|\") );\n\t/* Contains\n\t---------------------------------------------------------------------- */\n\t// Element contains another\n\t// Purposefully does not implement inclusive descendent\n\t// As in, an element does not contain itself\n\tcontains = rnative.test( docElem.contains ) || docElem.compareDocumentPosition ?\n\t\tfunction( a, b ) {\n\t\t\tvar adown = a.nodeType === 9 ? a.documentElement : a,\n\t\t\t\tbup = b && b.parentNode;\n\t\t\treturn a === bup || !!( bup && bup.nodeType === 1 && (\n\t\t\t\tadown.contains ?\n\t\t\t\t\tadown.contains( bup ) :\n\t\t\t\t\ta.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16\n\t\t\t));\n\t\t} :\n\t\tfunction( a, b ) {\n\t\t\tif ( b ) {\n\t\t\t\twhile ( (b = b.parentNode) ) {\n\t\t\t\t\tif ( b === a ) {\n\t\t\t\t\t\treturn true;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn false;\n\t\t};\n\t/* Sorting\n\t---------------------------------------------------------------------- */\n\t// Document order sorting\n\tsortOrder = docElem.compareDocumentPosition ?\n\tfunction( a, b ) {\n\t\t// Flag for duplicate removal\n\t\tif ( a === b ) {\n\t\t\thasDuplicate = true;\n\t\t\treturn 0;\n\t\t}\n\t\tvar compare = b.compareDocumentPosition && a.compareDocumentPosition && a.compareDocumentPosition( b );\n\t\tif ( compare ) {\n\t\t\t// Disconnected nodes\n\t\t\tif ( compare & 1 ||\n\t\t\t\t(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {\n\t\t\t\t// Choose the first element that is related to our preferred document\n\t\t\t\tif ( a === doc || contains(preferredDoc, a) ) {\n\t\t\t\t\treturn -1;\n\t\t\t\t}\n\t\t\t\tif ( b === doc || contains(preferredDoc, b) ) {\n\t\t\t\t\treturn 1;\n\t\t\t\t}\n\t\t\t\t// Maintain original order\n\t\t\t\treturn sortInput ?\n\t\t\t\t\t( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :\n\t\t\t\t\t0;\n\t\t\t}\n\t\t\treturn compare & 4 ? -1 : 1;\n\t\t}\n\t\t// Not directly comparable, sort on existence of method\n\t\treturn a.compareDocumentPosition ? -1 : 1;\n\t} :\n\tfunction( a, b ) {\n\t\tvar cur,\n\t\t\ti = 0,\n\t\t\taup = a.parentNode,\n\t\t\tbup = b.parentNode,\n\t\t\tap = [ a ],\n\t\t\tbp = [ b ];\n\t\t// Exit early if the nodes are identical\n\t\tif ( a === b ) {\n\t\t\thasDuplicate = true;\n\t\t\treturn 0;\n\t\t// Parentless nodes are either documents or disconnected\n\t\t} else if ( !aup || !bup ) {\n\t\t\treturn a === doc ? -1 :\n\t\t\t\tb === doc ? 1 :\n\t\t\t\taup ? -1 :\n\t\t\t\tbup ? 1 :\n\t\t\t\tsortInput ?\n\t\t\t\t( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :\n\t\t\t\t0;\n\t\t// If the nodes are siblings, we can do a quick check\n\t\t} else if ( aup === bup ) {\n\t\t\treturn siblingCheck( a, b );\n\t\t}\n\t\t// Otherwise we need full lists of their ancestors for comparison\n\t\tcur = a;\n\t\twhile ( (cur = cur.parentNode) ) {\n\t\t\tap.unshift( cur );\n\t\t}\n\t\tcur = b;\n\t\twhile ( (cur = cur.parentNode) ) {\n\t\t\tbp.unshift( cur );\n\t\t}\n\t\t// Walk down the tree looking for a discrepancy\n\t\twhile ( ap[i] === bp[i] ) {\n\t\t\ti++;\n\t\t}\n\t\treturn i ?\n\t\t\t// Do a sibling check if the nodes have a common ancestor\n\t\t\tsiblingCheck( ap[i], bp[i] ) :\n\t\t\t// Otherwise nodes in our document sort first\n\t\t\tap[i] === preferredDoc ? -1 :\n\t\t\tbp[i] === preferredDoc ? 1 :\n\t\t\t0;\n\t};\n\treturn doc;\n};\nSizzle.matches = function( expr, elements ) {\n\treturn Sizzle( expr, null, null, elements );\n};\nSizzle.matchesSelector = function( elem, expr ) {\n\t// Set document vars if needed\n\tif ( ( elem.ownerDocument || elem ) !== document ) {\n\t\tsetDocument( elem );\n\t}\n\t// Make sure that attribute selectors are quoted\n\texpr = expr.replace( rattributeQuotes, \"='$1']\" );\n\tif ( support.matchesSelector && documentIsHTML &&\n\t\t( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&\n\t\t( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {\n\t\ttry {\n\t\t\tvar ret = matches.call( elem, expr );\n\t\t\t// IE 9's matchesSelector returns false on disconnected nodes\n\t\t\tif ( ret || support.disconnectedMatch ||\n\t\t\t\t\t// As well, disconnected nodes are said to be in a document\n\t\t\t\t\t// fragment in IE 9\n\t\t\t\t\telem.document && elem.document.nodeType !== 11 ) {\n\t\t\t\treturn ret;\n\t\t\t}\n\t\t} catch(e) {}\n\t}\n\treturn Sizzle( expr, document, null, [elem] ).length > 0;\n};\nSizzle.contains = function( context, elem ) {\n\t// Set document vars if needed\n\tif ( ( context.ownerDocument || context ) !== document ) {\n\t\tsetDocument( context );\n\t}\n\treturn contains( context, elem );\n};\nSizzle.attr = function( elem, name ) {\n\t// Set document vars if needed\n\tif ( ( elem.ownerDocument || elem ) !== document ) {\n\t\tsetDocument( elem );\n\t}\n\tvar fn = Expr.attrHandle[ name.toLowerCase() ],\n\t\t// Don't get fooled by Object.prototype properties (jQuery #13807)\n\t\tval = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?\n\t\t\tfn( elem, name, !documentIsHTML ) :\n\t\t\tundefined;\n\treturn val === undefined ?\n\t\tsupport.attributes || !documentIsHTML ?\n\t\t\telem.getAttribute( name ) :\n\t\t\t(val = elem.getAttributeNode(name)) && val.specified ?\n\t\t\t\tval.value :\n\t\t\t\tnull :\n\t\tval;\n};\nSizzle.error = function( msg ) {\n\tthrow new Error( \"Syntax error, unrecognized expression: \" + msg );\n};\nSizzle.uniqueSort = function( results ) {\n\tvar elem,\n\t\tduplicates = [],\n\t\tj = 0,\n\t\ti = 0;\n\t// Unless we *know* we can detect duplicates, assume their presence\n\thasDuplicate = !support.detectDuplicates;\n\tsortInput = !support.sortStable && results.slice( 0 );\n\tresults.sort( sortOrder );\n\tif ( hasDuplicate ) {\n\t\twhile ( (elem = results[i++]) ) {\n\t\t\tif ( elem === results[ i ] ) {\n\t\t\t\tj = duplicates.push( i );\n\t\t\t}\n\t\t}\n\t\twhile ( j-- ) {\n\t\t\tresults.splice( duplicates[ j ], 1 );\n\t\t}\n\t}\n\treturn results;\n};\ngetText = Sizzle.getText = function( elem ) {\n\tvar node,\n\t\tret = \"\",\n\t\ti = 0,\n\t\tnodeType = elem.nodeType;\n\tif ( !nodeType ) {\n\t\t// If no nodeType, this is expected to be an array\n\t\tfor ( ; (node = elem[i]); i++ ) {\n\t\t\t// Do not traverse comment nodes\n\t\t\tret += getText( node );\n\t\t}\n\t} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {\n\t\t// Use textContent for elements\n\t\t// innerText usage removed for consistency of new lines (see #11153)\n\t\tif ( typeof elem.textContent === \"string\" ) {\n\t\t\treturn elem.textContent;\n\t\t} else {\n\t\t\t// Traverse its children\n\t\t\tfor ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {\n\t\t\t\tret += getText( elem );\n\t\t\t}\n\t\t}\n\t} else if ( nodeType === 3 || nodeType === 4 ) {\n\t\treturn elem.nodeValue;\n\t}\n\t// Do not include comment or processing instruction nodes\n\treturn ret;\n};\nExpr = Sizzle.selectors = {\n\t// Can be adjusted by the user\n\tcacheLength: 50,\n\tcreatePseudo: markFunction,\n\tmatch: matchExpr,\n\tattrHandle: {},\n\tfind: {},\n\trelative: {\n\t\t\">\": { dir: \"parentNode\", first: true },\n\t\t\" \": { dir: \"parentNode\" },\n\t\t\"+\": { dir: \"previousSibling\", first: true },\n\t\t\"~\": { dir: \"previousSibling\" }\n\t},\n\tpreFilter: {\n\t\t\"ATTR\": function( match ) {\n\t\t\tmatch[1] = match[1].replace( runescape, funescape );\n\t\t\t// Move the given value to match[3] whether quoted or unquoted\n\t\t\tmatch[3] = ( match[4] || match[5] || \"\" ).replace( runescape, funescape );\n\t\t\tif ( match[2] === \"~=\" ) {\n\t\t\t\tmatch[3] = \" \" + match[3] + \" \";\n\t\t\t}\n\t\t\treturn match.slice( 0, 4 );\n\t\t},\n\t\t\"CHILD\": function( match ) {\n\t\t\t/* matches from matchExpr[\"CHILD\"]\n\t\t\t\t1 type (only|nth|...)\n\t\t\t\t2 what (child|of-type)\n\t\t\t\t3 argument (even|odd|\\d*|\\d*n([+-]\\d+)?|...)\n\t\t\t\t4 xn-component of xn+y argument ([+-]?\\d*n|)\n\t\t\t\t5 sign of xn-component\n\t\t\t\t6 x of xn-component\n\t\t\t\t7 sign of y-component\n\t\t\t\t8 y of y-component\n\t\t\t*/\n\t\t\tmatch[1] = match[1].toLowerCase();\n\t\t\tif ( match[1].slice( 0, 3 ) === \"nth\" ) {\n\t\t\t\t// nth-* requires argument\n\t\t\t\tif ( !match[3] ) {\n\t\t\t\t\tSizzle.error( match[0] );\n\t\t\t\t}\n\t\t\t\t// numeric x and y parameters for Expr.filter.CHILD\n\t\t\t\t// remember that false/true cast respectively to 0/1\n\t\t\t\tmatch[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === \"even\" || match[3] === \"odd\" ) );\n\t\t\t\tmatch[5] = +( ( match[7] + match[8] ) || match[3] === \"odd\" );\n\t\t\t// other types prohibit arguments\n\t\t\t} else if ( match[3] ) {\n\t\t\t\tSizzle.error( match[0] );\n\t\t\t}\n\t\t\treturn match;\n\t\t},\n\t\t\"PSEUDO\": function( match ) {\n\t\t\tvar excess,\n\t\t\t\tunquoted = !match[5] && match[2];\n\t\t\tif ( matchExpr[\"CHILD\"].test( match[0] ) ) {\n\t\t\t\treturn null;\n\t\t\t}\n\t\t\t// Accept quoted arguments as-is\n\t\t\tif ( match[3] && match[4] !== undefined ) {\n\t\t\t\tmatch[2] = match[4];\n\t\t\t// Strip excess characters from unquoted arguments\n\t\t\t} else if ( unquoted && rpseudo.test( unquoted ) &&\n\t\t\t\t// Get excess from tokenize (recursively)\n\t\t\t\t(excess = tokenize( unquoted, true )) &&\n\t\t\t\t// advance to the next closing parenthesis\n\t\t\t\t(excess = unquoted.indexOf( \")\", unquoted.length - excess ) - unquoted.length) ) {\n\t\t\t\t// excess is a negative index\n\t\t\t\tmatch[0] = match[0].slice( 0, excess );\n\t\t\t\tmatch[2] = unquoted.slice( 0, excess );\n\t\t\t}\n\t\t\t// Return only captures needed by the pseudo filter method (type and argument)\n\t\t\treturn match.slice( 0, 3 );\n\t\t}\n\t},\n\tfilter: {\n\t\t\"TAG\": function( nodeNameSelector ) {\n\t\t\tvar nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();\n\t\t\treturn nodeNameSelector === \"*\" ?\n\t\t\t\tfunction() { return true; } :\n\t\t\t\tfunction( elem ) {\n\t\t\t\t\treturn elem.nodeName && elem.nodeName.toLowerCase() === nodeName;\n\t\t\t\t};\n\t\t},\n\t\t\"CLASS\": function( className ) {\n\t\t\tvar pattern = classCache[ className + \" \" ];\n\t\t\treturn pattern ||\n\t\t\t\t(pattern = new RegExp( \"(^|\" + whitespace + \")\" + className + \"(\" + whitespace + \"|$)\" )) &&\n\t\t\t\tclassCache( className, function( elem ) {\n\t\t\t\t\treturn pattern.test( typeof elem.className === \"string\" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute(\"class\") || \"\" );\n\t\t\t\t});\n\t\t},\n\t\t\"ATTR\": function( name, operator, check ) {\n\t\t\treturn function( elem ) {\n\t\t\t\tvar result = Sizzle.attr( elem, name );\n\t\t\t\tif ( result == null ) {\n\t\t\t\t\treturn operator === \"!=\";\n\t\t\t\t}\n\t\t\t\tif ( !operator ) {\n\t\t\t\t\treturn true;\n\t\t\t\t}\n\t\t\t\tresult += \"\";\n\t\t\t\treturn operator === \"=\" ? result === check :\n\t\t\t\t\toperator === \"!=\" ? result !== check :\n\t\t\t\t\toperator === \"^=\" ? check && result.indexOf( check ) === 0 :\n\t\t\t\t\toperator === \"*=\" ? check && result.indexOf( check ) > -1 :\n\t\t\t\t\toperator === \"$=\" ? check && result.slice( -check.length ) === check :\n\t\t\t\t\toperator === \"~=\" ? ( \" \" + result + \" \" ).indexOf( check ) > -1 :\n\t\t\t\t\toperator === \"|=\" ? result === check || result.slice( 0, check.length + 1 ) === check + \"-\" :\n\t\t\t\t\tfalse;\n\t\t\t};\n\t\t},\n\t\t\"CHILD\": function( type, what, argument, first, last ) {\n\t\t\tvar simple = type.slice( 0, 3 ) !== \"nth\",\n\t\t\t\tforward = type.slice( -4 ) !== \"last\",\n\t\t\t\tofType = what === \"of-type\";\n\t\t\treturn first === 1 && last === 0 ?\n\t\t\t\t// Shortcut for :nth-*(n)\n\t\t\t\tfunction( elem ) {\n\t\t\t\t\treturn !!elem.parentNode;\n\t\t\t\t} :\n\t\t\t\tfunction( elem, context, xml ) {\n\t\t\t\t\tvar cache, outerCache, node, diff, nodeIndex, start,\n\t\t\t\t\t\tdir = simple !== forward ? \"nextSibling\" : \"previousSibling\",\n\t\t\t\t\t\tparent = elem.parentNode,\n\t\t\t\t\t\tname = ofType && elem.nodeName.toLowerCase(),\n\t\t\t\t\t\tuseCache = !xml && !ofType;\n\t\t\t\t\tif ( parent ) {\n\t\t\t\t\t\t// :(first|last|only)-(child|of-type)\n\t\t\t\t\t\tif ( simple ) {\n\t\t\t\t\t\t\twhile ( dir ) {\n\t\t\t\t\t\t\t\tnode = elem;\n\t\t\t\t\t\t\t\twhile ( (node = node[ dir ]) ) {\n\t\t\t\t\t\t\t\t\tif ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) {\n\t\t\t\t\t\t\t\t\t\treturn false;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t// Reverse direction for :only-* (if we haven't yet done so)\n\t\t\t\t\t\t\t\tstart = dir = type === \"only\" && !start && \"nextSibling\";\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tstart = [ forward ? parent.firstChild : parent.lastChild ];\n\t\t\t\t\t\t// non-xml :nth-child(...) stores cache data on `parent`\n\t\t\t\t\t\tif ( forward && useCache ) {\n\t\t\t\t\t\t\t// Seek `elem` from a previously-cached index\n\t\t\t\t\t\t\touterCache = parent[ expando ] || (parent[ expando ] = {});\n\t\t\t\t\t\t\tcache = outerCache[ type ] || [];\n\t\t\t\t\t\t\tnodeIndex = cache[0] === dirruns && cache[1];\n\t\t\t\t\t\t\tdiff = cache[0] === dirruns && cache[2];\n\t\t\t\t\t\t\tnode = nodeIndex && parent.childNodes[ nodeIndex ];\n\t\t\t\t\t\t\twhile ( (node = ++nodeIndex && node && node[ dir ] ||\n\t\t\t\t\t\t\t\t// Fallback to seeking `elem` from the start\n\t\t\t\t\t\t\t\t(diff = nodeIndex = 0) || start.pop()) ) {\n\t\t\t\t\t\t\t\t// When found, cache indexes on `parent` and break\n\t\t\t\t\t\t\t\tif ( node.nodeType === 1 && ++diff && node === elem ) {\n\t\t\t\t\t\t\t\t\touterCache[ type ] = [ dirruns, nodeIndex, diff ];\n\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t// Use previously-cached element index if available\n\t\t\t\t\t\t} else if ( useCache && (cache = (elem[ expando ] || (elem[ expando ] = {}))[ type ]) && cache[0] === dirruns ) {\n\t\t\t\t\t\t\tdiff = cache[1];\n\t\t\t\t\t\t// xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\t// Use the same loop as above to seek `elem` from the start\n\t\t\t\t\t\t\twhile ( (node = ++nodeIndex && node && node[ dir ] ||\n\t\t\t\t\t\t\t\t(diff = nodeIndex = 0) || start.pop()) ) {\n\t\t\t\t\t\t\t\tif ( ( ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1 ) && ++diff ) {\n\t\t\t\t\t\t\t\t\t// Cache the index of each encountered element\n\t\t\t\t\t\t\t\t\tif ( useCache ) {\n\t\t\t\t\t\t\t\t\t\t(node[ expando ] || (node[ expando ] = {}))[ type ] = [ dirruns, diff ];\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\tif ( node === elem ) {\n\t\t\t\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t// Incorporate the offset, then check against cycle size\n\t\t\t\t\t\tdiff -= last;\n\t\t\t\t\t\treturn diff === first || ( diff % first === 0 && diff / first >= 0 );\n\t\t\t\t\t}\n\t\t\t\t};\n\t\t},\n\t\t\"PSEUDO\": function( pseudo, argument ) {\n\t\t\t// pseudo-class names are case-insensitive\n\t\t\t// http://www.w3.org/TR/selectors/#pseudo-classes\n\t\t\t// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters\n\t\t\t// Remember that setFilters inherits from pseudos\n\t\t\tvar args,\n\t\t\t\tfn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||\n\t\t\t\t\tSizzle.error( \"unsupported pseudo: \" + pseudo );\n\t\t\t// The user may use createPseudo to indicate that\n\t\t\t// arguments are needed to create the filter function\n\t\t\t// just as Sizzle does\n\t\t\tif ( fn[ expando ] ) {\n\t\t\t\treturn fn( argument );\n\t\t\t}\n\t\t\t// But maintain support for old signatures\n\t\t\tif ( fn.length > 1 ) {\n\t\t\t\targs = [ pseudo, pseudo, \"\", argument ];\n\t\t\t\treturn Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?\n\t\t\t\t\tmarkFunction(function( seed, matches ) {\n\t\t\t\t\t\tvar idx,\n\t\t\t\t\t\t\tmatched = fn( seed, argument ),\n\t\t\t\t\t\t\ti = matched.length;\n\t\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\t\tidx = indexOf.call( seed, matched[i] );\n\t\t\t\t\t\t\tseed[ idx ] = !( matches[ idx ] = matched[i] );\n\t\t\t\t\t\t}\n\t\t\t\t\t}) :\n\t\t\t\t\tfunction( elem ) {\n\t\t\t\t\t\treturn fn( elem, 0, args );\n\t\t\t\t\t};\n\t\t\t}\n\t\t\treturn fn;\n\t\t}\n\t},\n\tpseudos: {\n\t\t// Potentially complex pseudos\n\t\t\"not\": markFunction(function( selector ) {\n\t\t\t// Trim the selector passed to compile\n\t\t\t// to avoid treating leading and trailing\n\t\t\t// spaces as combinators\n\t\t\tvar input = [],\n\t\t\t\tresults = [],\n\t\t\t\tmatcher = compile( selector.replace( rtrim, \"$1\" ) );\n\t\t\treturn matcher[ expando ] ?\n\t\t\t\tmarkFunction(function( seed, matches, context, xml ) {\n\t\t\t\t\tvar elem,\n\t\t\t\t\t\tunmatched = matcher( seed, null, xml, [] ),\n\t\t\t\t\t\ti = seed.length;\n\t\t\t\t\t// Match elements unmatched by `matcher`\n\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\tif ( (elem = unmatched[i]) ) {\n\t\t\t\t\t\t\tseed[i] = !(matches[i] = elem);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}) :\n\t\t\t\tfunction( elem, context, xml ) {\n\t\t\t\t\tinput[0] = elem;\n\t\t\t\t\tmatcher( input, null, xml, results );\n\t\t\t\t\treturn !results.pop();\n\t\t\t\t};\n\t\t}),\n\t\t\"has\": markFunction(function( selector ) {\n\t\t\treturn function( elem ) {\n\t\t\t\treturn Sizzle( selector, elem ).length > 0;\n\t\t\t};\n\t\t}),\n\t\t\"contains\": markFunction(function( text ) {\n\t\t\treturn function( elem ) {\n\t\t\t\treturn ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;\n\t\t\t};\n\t\t}),\n\t\t// \"Whether an element is represented by a :lang() selector\n\t\t// is based solely on the element's language value\n\t\t// being equal to the identifier C,\n\t\t// or beginning with the identifier C immediately followed by \"-\".\n\t\t// The matching of C against the element's language value is performed case-insensitively.\n\t\t// The identifier C does not have to be a valid language name.\"\n\t\t// http://www.w3.org/TR/selectors/#lang-pseudo\n\t\t\"lang\": markFunction( function( lang ) {\n\t\t\t// lang value must be a valid identifier\n\t\t\tif ( !ridentifier.test(lang || \"\") ) {\n\t\t\t\tSizzle.error( \"unsupported lang: \" + lang );\n\t\t\t}\n\t\t\tlang = lang.replace( runescape, funescape ).toLowerCase();\n\t\t\treturn function( elem ) {\n\t\t\t\tvar elemLang;\n\t\t\t\tdo {\n\t\t\t\t\tif ( (elemLang = documentIsHTML ?\n\t\t\t\t\t\telem.lang :\n\t\t\t\t\t\telem.getAttribute(\"xml:lang\") || elem.getAttribute(\"lang\")) ) {\n\t\t\t\t\t\telemLang = elemLang.toLowerCase();\n\t\t\t\t\t\treturn elemLang === lang || elemLang.indexOf( lang + \"-\" ) === 0;\n\t\t\t\t\t}\n\t\t\t\t} while ( (elem = elem.parentNode) && elem.nodeType === 1 );\n\t\t\t\treturn false;\n\t\t\t};\n\t\t}),\n\t\t// Miscellaneous\n\t\t\"target\": function( elem ) {\n\t\t\tvar hash = window.location && window.location.hash;\n\t\t\treturn hash && hash.slice( 1 ) === elem.id;\n\t\t},\n\t\t\"root\": function( elem ) {\n\t\t\treturn elem === docElem;\n\t\t},\n\t\t\"focus\": function( elem ) {\n\t\t\treturn elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);\n\t\t},\n\t\t// Boolean properties\n\t\t\"enabled\": function( elem ) {\n\t\t\treturn elem.disabled === false;\n\t\t},\n\t\t\"disabled\": function( elem ) {\n\t\t\treturn elem.disabled === true;\n\t\t},\n\t\t\"checked\": function( elem ) {\n\t\t\t// In CSS3, :checked should return both checked and selected elements\n\t\t\t// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked\n\t\t\tvar nodeName = elem.nodeName.toLowerCase();\n\t\t\treturn (nodeName === \"input\" && !!elem.checked) || (nodeName === \"option\" && !!elem.selected);\n\t\t},\n\t\t\"selected\": function( elem ) {\n\t\t\t// Accessing this property makes selected-by-default\n\t\t\t// options in Safari work properly\n\t\t\tif ( elem.parentNode ) {\n\t\t\t\telem.parentNode.selectedIndex;\n\t\t\t}\n\t\t\treturn elem.selected === true;\n\t\t},\n\t\t// Contents\n\t\t\"empty\": function( elem ) {\n\t\t\t// http://www.w3.org/TR/selectors/#empty-pseudo\n\t\t\t// :empty is only affected by element nodes and content nodes(including text(3), cdata(4)),\n\t\t\t//   not comment, processing instructions, or others\n\t\t\t// Thanks to Diego Perini for the nodeName shortcut\n\t\t\t//   Greater than \"@\" means alpha characters (specifically not starting with \"#\" or \"?\")\n\t\t\tfor ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {\n\t\t\t\tif ( elem.nodeName > \"@\" || elem.nodeType === 3 || elem.nodeType === 4 ) {\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn true;\n\t\t},\n\t\t\"parent\": function( elem ) {\n\t\t\treturn !Expr.pseudos[\"empty\"]( elem );\n\t\t},\n\t\t// Element/input types\n\t\t\"header\": function( elem ) {\n\t\t\treturn rheader.test( elem.nodeName );\n\t\t},\n\t\t\"input\": function( elem ) {\n\t\t\treturn rinputs.test( elem.nodeName );\n\t\t},\n\t\t\"button\": function( elem ) {\n\t\t\tvar name = elem.nodeName.toLowerCase();\n\t\t\treturn name === \"input\" && elem.type === \"button\" || name === \"button\";\n\t\t},\n\t\t\"text\": function( elem ) {\n\t\t\tvar attr;\n\t\t\t// IE6 and 7 will map elem.type to 'text' for new HTML5 types (search, etc)\n\t\t\t// use getAttribute instead to test this case\n\t\t\treturn elem.nodeName.toLowerCase() === \"input\" &&\n\t\t\t\telem.type === \"text\" &&\n\t\t\t\t( (attr = elem.getAttribute(\"type\")) == null || attr.toLowerCase() === elem.type );\n\t\t},\n\t\t// Position-in-collection\n\t\t\"first\": createPositionalPseudo(function() {\n\t\t\treturn [ 0 ];\n\t\t}),\n\t\t\"last\": createPositionalPseudo(function( matchIndexes, length ) {\n\t\t\treturn [ length - 1 ];\n\t\t}),\n\t\t\"eq\": createPositionalPseudo(function( matchIndexes, length, argument ) {\n\t\t\treturn [ argument < 0 ? argument + length : argument ];\n\t\t}),\n\t\t\"even\": createPositionalPseudo(function( matchIndexes, length ) {\n\t\t\tvar i = 0;\n\t\t\tfor ( ; i < length; i += 2 ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t}),\n\t\t\"odd\": createPositionalPseudo(function( matchIndexes, length ) {\n\t\t\tvar i = 1;\n\t\t\tfor ( ; i < length; i += 2 ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t}),\n\t\t\"lt\": createPositionalPseudo(function( matchIndexes, length, argument ) {\n\t\t\tvar i = argument < 0 ? argument + length : argument;\n\t\t\tfor ( ; --i >= 0; ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t}),\n\t\t\"gt\": createPositionalPseudo(function( matchIndexes, length, argument ) {\n\t\t\tvar i = argument < 0 ? argument + length : argument;\n\t\t\tfor ( ; ++i < length; ) {\n\t\t\t\tmatchIndexes.push( i );\n\t\t\t}\n\t\t\treturn matchIndexes;\n\t\t})\n\t}\n};\nExpr.pseudos[\"nth\"] = Expr.pseudos[\"eq\"];\nfor ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {\n\tExpr.pseudos[ i ] = createInputPseudo( i );\n}\nfor ( i in { submit: true, reset: true } ) {\n\tExpr.pseudos[ i ] = createButtonPseudo( i );\n}\nfunction setFilters() {}\nsetFilters.prototype = Expr.filters = Expr.pseudos;\nExpr.setFilters = new setFilters();\nfunction tokenize( selector, parseOnly ) {\n\tvar matched, match, tokens, type,\n\t\tsoFar, groups, preFilters,\n\t\tcached = tokenCache[ selector + \" \" ];\n\tif ( cached ) {\n\t\treturn parseOnly ? 0 : cached.slice( 0 );\n\t}\n\tsoFar = selector;\n\tgroups = [];\n\tpreFilters = Expr.preFilter;\n\twhile ( soFar ) {\n\t\t// Comma and first run\n\t\tif ( !matched || (match = rcomma.exec( soFar )) ) {\n\t\t\tif ( match ) {\n\t\t\t\t// Don't consume trailing commas as valid\n\t\t\t\tsoFar = soFar.slice( match[0].length ) || soFar;\n\t\t\t}\n\t\t\tgroups.push( tokens = [] );\n\t\t}\n\t\tmatched = false;\n\t\t// Combinators\n\t\tif ( (match = rcombinators.exec( soFar )) ) {\n\t\t\tmatched = match.shift();\n\t\t\ttokens.push({\n\t\t\t\tvalue: matched,\n\t\t\t\t// Cast descendant combinators to space\n\t\t\t\ttype: match[0].replace( rtrim, \" \" )\n\t\t\t});\n\t\t\tsoFar = soFar.slice( matched.length );\n\t\t}\n\t\t// Filters\n\t\tfor ( type in Expr.filter ) {\n\t\t\tif ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||\n\t\t\t\t(match = preFilters[ type ]( match ))) ) {\n\t\t\t\tmatched = match.shift();\n\t\t\t\ttokens.push({\n\t\t\t\t\tvalue: matched,\n\t\t\t\t\ttype: type,\n\t\t\t\t\tmatches: match\n\t\t\t\t});\n\t\t\t\tsoFar = soFar.slice( matched.length );\n\t\t\t}\n\t\t}\n\t\tif ( !matched ) {\n\t\t\tbreak;\n\t\t}\n\t}\n\t// Return the length of the invalid excess\n\t// if we're just parsing\n\t// Otherwise, throw an error or return tokens\n\treturn parseOnly ?\n\t\tsoFar.length :\n\t\tsoFar ?\n\t\t\tSizzle.error( selector ) :\n\t\t\t// Cache the tokens\n\t\t\ttokenCache( selector, groups ).slice( 0 );\n}\nfunction toSelector( tokens ) {\n\tvar i = 0,\n\t\tlen = tokens.length,\n\t\tselector = \"\";\n\tfor ( ; i < len; i++ ) {\n\t\tselector += tokens[i].value;\n\t}\n\treturn selector;\n}\nfunction addCombinator( matcher, combinator, base ) {\n\tvar dir = combinator.dir,\n\t\tcheckNonElements = base && dir === \"parentNode\",\n\t\tdoneName = done++;\n\treturn combinator.first ?\n\t\t// Check against closest ancestor/preceding element\n\t\tfunction( elem, context, xml ) {\n\t\t\twhile ( (elem = elem[ dir ]) ) {\n\t\t\t\tif ( elem.nodeType === 1 || checkNonElements ) {\n\t\t\t\t\treturn matcher( elem, context, xml );\n\t\t\t\t}\n\t\t\t}\n\t\t} :\n\t\t// Check against all ancestor/preceding elements\n\t\tfunction( elem, context, xml ) {\n\t\t\tvar data, cache, outerCache,\n\t\t\t\tdirkey = dirruns + \" \" + doneName;\n\t\t\t// We can't set arbitrary data on XML nodes, so they don't benefit from dir caching\n\t\t\tif ( xml ) {\n\t\t\t\twhile ( (elem = elem[ dir ]) ) {\n\t\t\t\t\tif ( elem.nodeType === 1 || checkNonElements ) {\n\t\t\t\t\t\tif ( matcher( elem, context, xml ) ) {\n\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t} else {\n\t\t\t\twhile ( (elem = elem[ dir ]) ) {\n\t\t\t\t\tif ( elem.nodeType === 1 || checkNonElements ) {\n\t\t\t\t\t\touterCache = elem[ expando ] || (elem[ expando ] = {});\n\t\t\t\t\t\tif ( (cache = outerCache[ dir ]) && cache[0] === dirkey ) {\n\t\t\t\t\t\t\tif ( (data = cache[1]) === true || data === cachedruns ) {\n\t\t\t\t\t\t\t\treturn data === true;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tcache = outerCache[ dir ] = [ dirkey ];\n\t\t\t\t\t\t\tcache[1] = matcher( elem, context, xml ) || cachedruns;\n\t\t\t\t\t\t\tif ( cache[1] === true ) {\n\t\t\t\t\t\t\t\treturn true;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t};\n}\nfunction elementMatcher( matchers ) {\n\treturn matchers.length > 1 ?\n\t\tfunction( elem, context, xml ) {\n\t\t\tvar i = matchers.length;\n\t\t\twhile ( i-- ) {\n\t\t\t\tif ( !matchers[i]( elem, context, xml ) ) {\n\t\t\t\t\treturn false;\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn true;\n\t\t} :\n\t\tmatchers[0];\n}\nfunction condense( unmatched, map, filter, context, xml ) {\n\tvar elem,\n\t\tnewUnmatched = [],\n\t\ti = 0,\n\t\tlen = unmatched.length,\n\t\tmapped = map != null;\n\tfor ( ; i < len; i++ ) {\n\t\tif ( (elem = unmatched[i]) ) {\n\t\t\tif ( !filter || filter( elem, context, xml ) ) {\n\t\t\t\tnewUnmatched.push( elem );\n\t\t\t\tif ( mapped ) {\n\t\t\t\t\tmap.push( i );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\treturn newUnmatched;\n}\nfunction setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {\n\tif ( postFilter && !postFilter[ expando ] ) {\n\t\tpostFilter = setMatcher( postFilter );\n\t}\n\tif ( postFinder && !postFinder[ expando ] ) {\n\t\tpostFinder = setMatcher( postFinder, postSelector );\n\t}\n\treturn markFunction(function( seed, results, context, xml ) {\n\t\tvar temp, i, elem,\n\t\t\tpreMap = [],\n\t\t\tpostMap = [],\n\t\t\tpreexisting = results.length,\n\t\t\t// Get initial elements from seed or context\n\t\t\telems = seed || multipleContexts( selector || \"*\", context.nodeType ? [ context ] : context, [] ),\n\t\t\t// Prefilter to get matcher input, preserving a map for seed-results synchronization\n\t\t\tmatcherIn = preFilter && ( seed || !selector ) ?\n\t\t\t\tcondense( elems, preMap, preFilter, context, xml ) :\n\t\t\t\telems,\n\t\t\tmatcherOut = matcher ?\n\t\t\t\t// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,\n\t\t\t\tpostFinder || ( seed ? preFilter : preexisting || postFilter ) ?\n\t\t\t\t\t// ...intermediate processing is necessary\n\t\t\t\t\t[] :\n\t\t\t\t\t// ...otherwise use results directly\n\t\t\t\t\tresults :\n\t\t\t\tmatcherIn;\n\t\t// Find primary matches\n\t\tif ( matcher ) {\n\t\t\tmatcher( matcherIn, matcherOut, context, xml );\n\t\t}\n\t\t// Apply postFilter\n\t\tif ( postFilter ) {\n\t\t\ttemp = condense( matcherOut, postMap );\n\t\t\tpostFilter( temp, [], context, xml );\n\t\t\t// Un-match failing elements by moving them back to matcherIn\n\t\t\ti = temp.length;\n\t\t\twhile ( i-- ) {\n\t\t\t\tif ( (elem = temp[i]) ) {\n\t\t\t\t\tmatcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tif ( seed ) {\n\t\t\tif ( postFinder || preFilter ) {\n\t\t\t\tif ( postFinder ) {\n\t\t\t\t\t// Get the final matcherOut by condensing this intermediate into postFinder contexts\n\t\t\t\t\ttemp = [];\n\t\t\t\t\ti = matcherOut.length;\n\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\tif ( (elem = matcherOut[i]) ) {\n\t\t\t\t\t\t\t// Restore matcherIn since elem is not yet a final match\n\t\t\t\t\t\t\ttemp.push( (matcherIn[i] = elem) );\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tpostFinder( null, (matcherOut = []), temp, xml );\n\t\t\t\t}\n\t\t\t\t// Move matched elements from seed to results to keep them synchronized\n\t\t\t\ti = matcherOut.length;\n\t\t\t\twhile ( i-- ) {\n\t\t\t\t\tif ( (elem = matcherOut[i]) &&\n\t\t\t\t\t\t(temp = postFinder ? indexOf.call( seed, elem ) : preMap[i]) > -1 ) {\n\t\t\t\t\t\tseed[temp] = !(results[temp] = elem);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t// Add elements to results, through postFinder if defined\n\t\t} else {\n\t\t\tmatcherOut = condense(\n\t\t\t\tmatcherOut === results ?\n\t\t\t\t\tmatcherOut.splice( preexisting, matcherOut.length ) :\n\t\t\t\t\tmatcherOut\n\t\t\t);\n\t\t\tif ( postFinder ) {\n\t\t\t\tpostFinder( null, results, matcherOut, xml );\n\t\t\t} else {\n\t\t\t\tpush.apply( results, matcherOut );\n\t\t\t}\n\t\t}\n\t});\n}\nfunction matcherFromTokens( tokens ) {\n\tvar checkContext, matcher, j,\n\t\tlen = tokens.length,\n\t\tleadingRelative = Expr.relative[ tokens[0].type ],\n\t\timplicitRelative = leadingRelative || Expr.relative[\" \"],\n\t\ti = leadingRelative ? 1 : 0,\n\t\t// The foundational matcher ensures that elements are reachable from top-level context(s)\n\t\tmatchContext = addCombinator( function( elem ) {\n\t\t\treturn elem === checkContext;\n\t\t}, implicitRelative, true ),\n\t\tmatchAnyContext = addCombinator( function( elem ) {\n\t\t\treturn indexOf.call( checkContext, elem ) > -1;\n\t\t}, implicitRelative, true ),\n\t\tmatchers = [ function( elem, context, xml ) {\n\t\t\treturn ( !leadingRelative && ( xml || context !== outermostContext ) ) || (\n\t\t\t\t(checkContext = context).nodeType ?\n\t\t\t\t\tmatchContext( elem, context, xml ) :\n\t\t\t\t\tmatchAnyContext( elem, context, xml ) );\n\t\t} ];\n\tfor ( ; i < len; i++ ) {\n\t\tif ( (matcher = Expr.relative[ tokens[i].type ]) ) {\n\t\t\tmatchers = [ addCombinator(elementMatcher( matchers ), matcher) ];\n\t\t} else {\n\t\t\tmatcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );\n\t\t\t// Return special upon seeing a positional matcher\n\t\t\tif ( matcher[ expando ] ) {\n\t\t\t\t// Find the next relative operator (if any) for proper handling\n\t\t\t\tj = ++i;\n\t\t\t\tfor ( ; j < len; j++ ) {\n\t\t\t\t\tif ( Expr.relative[ tokens[j].type ] ) {\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\treturn setMatcher(\n\t\t\t\t\ti > 1 && elementMatcher( matchers ),\n\t\t\t\t\ti > 1 && toSelector(\n\t\t\t\t\t\t// If the preceding token was a descendant combinator, insert an implicit any-element `*`\n\t\t\t\t\t\ttokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === \" \" ? \"*\" : \"\" })\n\t\t\t\t\t).replace( rtrim, \"$1\" ),\n\t\t\t\t\tmatcher,\n\t\t\t\t\ti < j && matcherFromTokens( tokens.slice( i, j ) ),\n\t\t\t\t\tj < len && matcherFromTokens( (tokens = tokens.slice( j )) ),\n\t\t\t\t\tj < len && toSelector( tokens )\n\t\t\t\t);\n\t\t\t}\n\t\t\tmatchers.push( matcher );\n\t\t}\n\t}\n\treturn elementMatcher( matchers );\n}\nfunction matcherFromGroupMatchers( elementMatchers, setMatchers ) {\n\t// A counter to specify which element is currently being matched\n\tvar matcherCachedRuns = 0,\n\t\tbySet = setMatchers.length > 0,\n\t\tbyElement = elementMatchers.length > 0,\n\t\tsuperMatcher = function( seed, context, xml, results, expandContext ) {\n\t\t\tvar elem, j, matcher,\n\t\t\t\tsetMatched = [],\n\t\t\t\tmatchedCount = 0,\n\t\t\t\ti = \"0\",\n\t\t\t\tunmatched = seed && [],\n\t\t\t\toutermost = expandContext != null,\n\t\t\t\tcontextBackup = outermostContext,\n\t\t\t\t// We must always have either seed elements or context\n\t\t\t\telems = seed || byElement && Expr.find[\"TAG\"]( \"*\", expandContext && context.parentNode || context ),\n\t\t\t\t// Use integer dirruns iff this is the outermost matcher\n\t\t\t\tdirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1);\n\t\t\tif ( outermost ) {\n\t\t\t\toutermostContext = context !== document && context;\n\t\t\t\tcachedruns = matcherCachedRuns;\n\t\t\t}\n\t\t\t// Add elements passing elementMatchers directly to results\n\t\t\t// Keep `i` a string if there are no elements so `matchedCount` will be \"00\" below\n\t\t\tfor ( ; (elem = elems[i]) != null; i++ ) {\n\t\t\t\tif ( byElement && elem ) {\n\t\t\t\t\tj = 0;\n\t\t\t\t\twhile ( (matcher = elementMatchers[j++]) ) {\n\t\t\t\t\t\tif ( matcher( elem, context, xml ) ) {\n\t\t\t\t\t\t\tresults.push( elem );\n\t\t\t\t\t\t\tbreak;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\tif ( outermost ) {\n\t\t\t\t\t\tdirruns = dirrunsUnique;\n\t\t\t\t\t\tcachedruns = ++matcherCachedRuns;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t// Track unmatched elements for set filters\n\t\t\t\tif ( bySet ) {\n\t\t\t\t\t// They will have gone through all possible matchers\n\t\t\t\t\tif ( (elem = !matcher && elem) ) {\n\t\t\t\t\t\tmatchedCount--;\n\t\t\t\t\t}\n\t\t\t\t\t// Lengthen the array for every element, matched or not\n\t\t\t\t\tif ( seed ) {\n\t\t\t\t\t\tunmatched.push( elem );\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t// Apply set filters to unmatched elements\n\t\t\tmatchedCount += i;\n\t\t\tif ( bySet && i !== matchedCount ) {\n\t\t\t\tj = 0;\n\t\t\t\twhile ( (matcher = setMatchers[j++]) ) {\n\t\t\t\t\tmatcher( unmatched, setMatched, context, xml );\n\t\t\t\t}\n\t\t\t\tif ( seed ) {\n\t\t\t\t\t// Reintegrate element matches to eliminate the need for sorting\n\t\t\t\t\tif ( matchedCount > 0 ) {\n\t\t\t\t\t\twhile ( i-- ) {\n\t\t\t\t\t\t\tif ( !(unmatched[i] || setMatched[i]) ) {\n\t\t\t\t\t\t\t\tsetMatched[i] = pop.call( results );\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t// Discard index placeholder values to get only actual matches\n\t\t\t\t\tsetMatched = condense( setMatched );\n\t\t\t\t}\n\t\t\t\t// Add matches to results\n\t\t\t\tpush.apply( results, setMatched );\n\t\t\t\t// Seedless set matches succeeding multiple successful matchers stipulate sorting\n\t\t\t\tif ( outermost && !seed && setMatched.length > 0 &&\n\t\t\t\t\t( matchedCount + setMatchers.length ) > 1 ) {\n\t\t\t\t\tSizzle.uniqueSort( results );\n\t\t\t\t}\n\t\t\t}\n\t\t\t// Override manipulation of globals by nested matchers\n\t\t\tif ( outermost ) {\n\t\t\t\tdirruns = dirrunsUnique;\n\t\t\t\toutermostContext = contextBackup;\n\t\t\t}\n\t\t\treturn unmatched;\n\t\t};\n\treturn bySet ?\n\t\tmarkFunction( superMatcher ) :\n\t\tsuperMatcher;\n}\ncompile = Sizzle.compile = function( selector, group /* Internal Use Only */ ) {\n\tvar i,\n\t\tsetMatchers = [],\n\t\telementMatchers = [],\n\t\tcached = compilerCache[ selector + \" \" ];\n\tif ( !cached ) {\n\t\t// Generate a function of recursive functions that can be used to check each element\n\t\tif ( !group ) {\n\t\t\tgroup = tokenize( selector );\n\t\t}\n\t\ti = group.length;\n\t\twhile ( i-- ) {\n\t\t\tcached = matcherFromTokens( group[i] );\n\t\t\tif ( cached[ expando ] ) {\n\t\t\t\tsetMatchers.push( cached );\n\t\t\t} else {\n\t\t\t\telementMatchers.push( cached );\n\t\t\t}\n\t\t}\n\t\t// Cache the compiled function\n\t\tcached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );\n\t}\n\treturn cached;\n};\nfunction multipleContexts( selector, contexts, results ) {\n\tvar i = 0,\n\t\tlen = contexts.length;\n\tfor ( ; i < len; i++ ) {\n\t\tSizzle( selector, contexts[i], results );\n\t}\n\treturn results;\n}\nfunction select( selector, context, results, seed ) {\n\tvar i, tokens, token, type, find,\n\t\tmatch = tokenize( selector );\n\tif ( !seed ) {\n\t\t// Try to minimize operations if there is only one group\n\t\tif ( match.length === 1 ) {\n\t\t\t// Take a shortcut and set the context if the root selector is an ID\n\t\t\ttokens = match[0] = match[0].slice( 0 );\n\t\t\tif ( tokens.length > 2 && (token = tokens[0]).type === \"ID\" &&\n\t\t\t\t\tsupport.getById && context.nodeType === 9 && documentIsHTML &&\n\t\t\t\t\tExpr.relative[ tokens[1].type ] ) {\n\t\t\t\tcontext = ( Expr.find[\"ID\"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];\n\t\t\t\tif ( !context ) {\n\t\t\t\t\treturn results;\n\t\t\t\t}\n\t\t\t\tselector = selector.slice( tokens.shift().value.length );\n\t\t\t}\n\t\t\t// Fetch a seed set for right-to-left matching\n\t\t\ti = matchExpr[\"needsContext\"].test( selector ) ? 0 : tokens.length;\n\t\t\twhile ( i-- ) {\n\t\t\t\ttoken = tokens[i];\n\t\t\t\t// Abort if we hit a combinator\n\t\t\t\tif ( Expr.relative[ (type = token.type) ] ) {\n\t\t\t\t\tbreak;\n\t\t\t\t}\n\t\t\t\tif ( (find = Expr.find[ type ]) ) {\n\t\t\t\t\t// Search, expanding context for leading sibling combinators\n\t\t\t\t\tif ( (seed = find(\n\t\t\t\t\t\ttoken.matches[0].replace( runescape, funescape ),\n\t\t\t\t\t\trsibling.test( tokens[0].type ) && context.parentNode || context\n\t\t\t\t\t)) ) {\n\t\t\t\t\t\t// If seed is empty or no tokens remain, we can return early\n\t\t\t\t\t\ttokens.splice( i, 1 );\n\t\t\t\t\t\tselector = seed.length && toSelector( tokens );\n\t\t\t\t\t\tif ( !selector ) {\n\t\t\t\t\t\t\tpush.apply( results, seed );\n\t\t\t\t\t\t\treturn results;\n\t\t\t\t\t\t}\n\t\t\t\t\t\tbreak;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t// Compile and execute a filtering function\n\t// Provide `match` to avoid retokenization if we modified the selector above\n\tcompile( selector, match )(\n\t\tseed,\n\t\tcontext,\n\t\t!documentIsHTML,\n\t\tresults,\n\t\trsibling.test( selector )\n\t);\n\treturn results;\n}\nsupport.sortStable = expando.split(\"\").sort( sortOrder ).join(\"\") === expando;\nsupport.detectDuplicates = hasDuplicate;\nsetDocument();\nsupport.sortDetached = assert(function( div1 ) {\n\t// Should return 1, but returns 4 (following)\n\treturn div1.compareDocumentPosition( document.createElement(\"div\") ) & 1;\n});\nif ( !assert(function( div ) {\n\tdiv.innerHTML = \"<a href='#'></a>\";\n\treturn div.firstChild.getAttribute(\"href\") === \"#\" ;\n}) ) {\n\taddHandle( \"type|href|height|width\", function( elem, name, isXML ) {\n\t\tif ( !isXML ) {\n\t\t\treturn elem.getAttribute( name, name.toLowerCase() === \"type\" ? 1 : 2 );\n\t\t}\n\t});\n}\nif ( !support.attributes || !assert(function( div ) {\n\tdiv.innerHTML = \"<input/>\";\n\tdiv.firstChild.setAttribute( \"value\", \"\" );\n\treturn div.firstChild.getAttribute( \"value\" ) === \"\";\n}) ) {\n\taddHandle( \"value\", function( elem, name, isXML ) {\n\t\tif ( !isXML && elem.nodeName.toLowerCase() === \"input\" ) {\n\t\t\treturn elem.defaultValue;\n\t\t}\n\t});\n}\nif ( !assert(function( div ) {\n\treturn div.getAttribute(\"disabled\") == null;\n}) ) {\n\taddHandle( booleans, function( elem, name, isXML ) {\n\t\tvar val;\n\t\tif ( !isXML ) {\n\t\t\treturn (val = elem.getAttributeNode( name )) && val.specified ?\n\t\t\t\tval.value :\n\t\t\t\telem[ name ] === true ? name.toLowerCase() : null;\n\t\t}\n\t});\n}\nif ( typeof define === \"function\" && define.amd ) {\n\tdefine(function() { return Sizzle; });\n} else {\n\twindow.Sizzle = Sizzle;\n}\n})( window );\nPrototype._original_property = window.Sizzle;\n;(function(engine) {\n  var extendElements = Prototype.Selector.extendElements;\n  function select(selector, scope) {\n    return extendElements(engine(selector, scope || document));\n  }\n  function match(element, selector) {\n    return engine.matches(selector, [element]).length == 1;\n  }\n  Prototype.Selector.engine = engine;\n  Prototype.Selector.select = select;\n  Prototype.Selector.match = match;\n})(Sizzle);\nwindow.Sizzle = Prototype._original_property;\ndelete Prototype._original_property;\nvar Form = {\n  reset: function(form) {\n    form = $(form);\n    form.reset();\n    return form;\n  },\n  serializeElements: function(elements, options) {\n    // An earlier version accepted a boolean second parameter (hash) where\n    // the default if omitted was false; respect that, but if they pass in an\n    // options object (e.g., the new signature) but don't specify the hash option,\n    // default true, as that's the new preferred approach.\n    if (typeof options != 'object') options = { hash: !!options };\n    else if (Object.isUndefined(options.hash)) options.hash = true;\n    var key, value, submitted = false, submit = options.submit, accumulator, initial;\n    \n    if (options.hash) {\n      initial = {};\n      accumulator = function(result, key, value) {\n        if (key in result) {\n          if (!Object.isArray(result[key])) result[key] = [result[key]];\n          result[key] = result[key].concat(value);\n        } else result[key] = value;\n        return result;\n      };\n    } else {\n      initial = '';\n      accumulator = function(result, key, values) {\n        if (!Object.isArray(values)) {values = [values];}\n        if (!values.length) {return result;}\n        // According to the spec, spaces should be '+' rather than '%20'.\n        var encodedKey = encodeURIComponent(key).gsub(/%20/, '+');\n        return result + (result ? \"&\" : \"\") + values.map(function (value) {\n          // Normalize newlines as \\r\\n because the HTML spec says newlines should\n          // be encoded as CRLFs.\n          value = value.gsub(/(\\r)?\\n/, '\\r\\n');\n          value = encodeURIComponent(value);\n          // According to the spec, spaces should be '+' rather than '%20'.\n          value = value.gsub(/%20/, '+');\n          return encodedKey + \"=\" + value;\n        }).join(\"&\");\n      };\n    }\n    \n    return elements.inject(initial, function(result, element) {\n      if (!element.disabled && element.name) {\n        key = element.name; value = $(element).getValue();\n        if (value != null && element.type != 'file' && (element.type != 'submit' || (!submitted &&\n            submit !== false && (!submit || key == submit) && (submitted = true)))) {\n          result = accumulator(result, key, value);\n        }\n      }\n      return result;\n    });\n  }\n};\nForm.Methods = {\n  serialize: function(form, options) {\n    return Form.serializeElements(Form.getElements(form), options);\n  },\n  \n  getElements: function(form) {\n    var elements = $(form).getElementsByTagName('*');\n    var element, results = [], serializers = Form.Element.Serializers;\n    \n    for (var i = 0; element = elements[i]; i++) {\n      if (serializers[element.tagName.toLowerCase()])\n        results.push(Element.extend(element));\n    }\n    return results;\n  },\n  getInputs: function(form, typeName, name) {\n    form = $(form);\n    var inputs = form.getElementsByTagName('input');\n    if (!typeName && !name) return $A(inputs).map(Element.extend);\n    for (var i = 0, matchingInputs = [], length = inputs.length; i < length; i++) {\n      var input = inputs[i];\n      if ((typeName && input.type != typeName) || (name && input.name != name))\n        continue;\n      matchingInputs.push(Element.extend(input));\n    }\n    return matchingInputs;\n  },\n  disable: function(form) {\n    form = $(form);\n    Form.getElements(form).invoke('disable');\n    return form;\n  },\n  enable: function(form) {\n    form = $(form);\n    Form.getElements(form).invoke('enable');\n    return form;\n  },\n  findFirstElement: function(form) {\n    var elements = $(form).getElements().findAll(function(element) {\n      return 'hidden' != element.type && !element.disabled;\n    });\n    var firstByIndex = elements.findAll(function(element) {\n      return element.hasAttribute('tabIndex') && element.tabIndex >= 0;\n    }).sortBy(function(element) { return element.tabIndex }).first();\n    return firstByIndex ? firstByIndex : elements.find(function(element) {\n      return /^(?:input|select|textarea)$/i.test(element.tagName);\n    });\n  },\n  focusFirstElement: function(form) {\n    form = $(form);\n    var element = form.findFirstElement();\n    if (element) element.activate();\n    return form;\n  },\n  request: function(form, options) {\n    form = $(form), options = Object.clone(options || { });\n    var params = options.parameters, action = form.readAttribute('action') || '';\n    if (action.blank()) action = window.location.href;\n    options.parameters = form.serialize(true);\n    if (params) {\n      if (Object.isString(params)) params = params.toQueryParams();\n      Object.extend(options.parameters, params);\n    }\n    if (form.hasAttribute('method') && !options.method)\n      options.method = form.method;\n    return new Ajax.Request(action, options);\n  }\n};\n/*--------------------------------------------------------------------------*/\nForm.Element = {\n  focus: function(element) {\n    $(element).focus();\n    return element;\n  },\n  select: function(element) {\n    $(element).select();\n    return element;\n  }\n};\nForm.Element.Methods = {\n  serialize: function(element) {\n    element = $(element);\n    if (!element.disabled && element.name) {\n      var value = element.getValue();\n      if (value != undefined) {\n        var pair = { };\n        pair[element.name] = value;\n        return Object.toQueryString(pair);\n      }\n    }\n    return '';\n  },\n  getValue: function(element) {\n    element = $(element);\n    var method = element.tagName.toLowerCase();\n    return Form.Element.Serializers[method](element);\n  },\n  setValue: function(element, value) {\n    element = $(element);\n    var method = element.tagName.toLowerCase();\n    Form.Element.Serializers[method](element, value);\n    return element;\n  },\n  clear: function(element) {\n    $(element).value = '';\n    return element;\n  },\n  present: function(element) {\n    return $(element).value != '';\n  },\n  activate: function(element) {\n    element = $(element);\n    try {\n      element.focus();\n      if (element.select && (element.tagName.toLowerCase() != 'input' ||\n          !(/^(?:button|reset|submit)$/i.test(element.type))))\n        element.select();\n    } catch (e) { }\n    return element;\n  },\n  disable: function(element) {\n    element = $(element);\n    element.disabled = true;\n    return element;\n  },\n  enable: function(element) {\n    element = $(element);\n    element.disabled = false;\n    return element;\n  }\n};\n/*--------------------------------------------------------------------------*/\nvar Field = Form.Element;\nvar $F = Form.Element.Methods.getValue;\n/*--------------------------------------------------------------------------*/\nForm.Element.Serializers = (function() {\n  function input(element, value) {\n    switch (element.type.toLowerCase()) {\n      case 'checkbox':\n      case 'radio':\n        return inputSelector(element, value);\n      default:\n        return valueSelector(element, value);\n    }\n  }\n  \n  function inputSelector(element, value) {\n    if (Object.isUndefined(value))\n      return element.checked ? element.value : null;\n    else element.checked = !!value;    \n  }\n  \n  function valueSelector(element, value) {\n    if (Object.isUndefined(value)) return element.value;\n    else element.value = value;\n  }\n  \n  function select(element, value) {\n    if (Object.isUndefined(value))\n      return (element.type === 'select-one' ? selectOne : selectMany)(element);\n       \n    var opt, currentValue, single = !Object.isArray(value);\n    for (var i = 0, length = element.length; i < length; i++) {\n      opt = element.options[i];\n      currentValue = this.optionValue(opt);\n      if (single) {\n        if (currentValue == value) {\n          opt.selected = true;\n          return;\n        }\n      }\n      else opt.selected = value.include(currentValue);\n    }\n  }\n  \n  function selectOne(element) {\n    var index = element.selectedIndex;\n    return index >= 0 ? optionValue(element.options[index]) : null;\n  }\n  \n  function selectMany(element) {\n    var values, length = element.length;\n    if (!length) return null;\n    for (var i = 0, values = []; i < length; i++) {\n      var opt = element.options[i];\n      if (opt.selected) values.push(optionValue(opt));\n    }\n    return values;\n  }\n  \n  function optionValue(opt) {\n    return Element.hasAttribute(opt, 'value') ? opt.value : opt.text;\n  }\n  \n  return {\n    input:         input,\n    inputSelector: inputSelector,\n    textarea:      valueSelector,\n    select:        select,\n    selectOne:     selectOne,\n    selectMany:    selectMany,\n    optionValue:   optionValue,\n    button:        valueSelector\n  };\n})();\n/*--------------------------------------------------------------------------*/\nAbstract.TimedObserver = Class.create(PeriodicalExecuter, {\n  initialize: function($super, element, frequency, callback) {\n    $super(callback, frequency);\n    this.element   = $(element);\n    this.lastValue = this.getValue();\n  },\n  execute: function() {\n    var value = this.getValue();\n    if (Object.isString(this.lastValue) && Object.isString(value) ?\n        this.lastValue != value : String(this.lastValue) != String(value)) {\n      this.callback(this.element, value);\n      this.lastValue = value;\n    }\n  }\n});\nForm.Element.Observer = Class.create(Abstract.TimedObserver, {\n  getValue: function() {\n    return Form.Element.getValue(this.element);\n  }\n});\nForm.Observer = Class.create(Abstract.TimedObserver, {\n  getValue: function() {\n    return Form.serialize(this.element);\n  }\n});\n/*--------------------------------------------------------------------------*/\nAbstract.EventObserver = Class.create({\n  initialize: function(element, callback) {\n    this.element  = $(element);\n    this.callback = callback;\n    this.lastValue = this.getValue();\n    if (this.element.tagName.toLowerCase() == 'form')\n      this.registerFormCallbacks();\n    else\n      this.registerCallback(this.element);\n  },\n  onElementEvent: function() {\n    var value = this.getValue();\n    if (this.lastValue != value) {\n      this.callback(this.element, value);\n      this.lastValue = value;\n    }\n  },\n  registerFormCallbacks: function() {\n    Form.getElements(this.element).each(this.registerCallback, this);\n  },\n  registerCallback: function(element) {\n    if (element.type) {\n      switch (element.type.toLowerCase()) {\n        case 'checkbox':\n        case 'radio':\n          Event.observe(element, 'click', this.onElementEvent.bind(this));\n          break;\n        default:\n          Event.observe(element, 'change', this.onElementEvent.bind(this));\n          break;\n      }\n    }\n  }\n});\nForm.Element.EventObserver = Class.create(Abstract.EventObserver, {\n  getValue: function() {\n    return Form.Element.getValue(this.element);\n  }\n});\nForm.EventObserver = Class.create(Abstract.EventObserver, {\n  getValue: function() {\n    return Form.serialize(this.element);\n  }\n});\n(function(GLOBAL) {\n  var DIV = document.createElement('div');\n  var docEl = document.documentElement;\n  var MOUSEENTER_MOUSELEAVE_EVENTS_SUPPORTED = 'onmouseenter' in docEl\n   && 'onmouseleave' in docEl;\n  \n  var Event = {\n    KEY_BACKSPACE: 8,\n    KEY_TAB:       9,\n    KEY_RETURN:   13,\n    KEY_ESC:      27,\n    KEY_LEFT:     37,\n    KEY_UP:       38,\n    KEY_RIGHT:    39,\n    KEY_DOWN:     40,\n    KEY_DELETE:   46,\n    KEY_HOME:     36,\n    KEY_END:      35,\n    KEY_PAGEUP:   33,\n    KEY_PAGEDOWN: 34,\n    KEY_INSERT:   45\n  };\n  \n  // We need to support three different event \"modes\":\n  //  1. browsers with only DOM L2 Events (WebKit, FireFox);\n  //  2. browsers with only IE's legacy events system (IE 6-8);\n  //  3. browsers with _both_ systems (IE 9 and arguably Opera).\n  //\n  // Groups 1 and 2 are easy; group three is trickier.\n  var isIELegacyEvent = function(event) { return false; };\n  if (window.attachEvent) {\n    if (window.addEventListener) {\n      // Both systems are supported. We need to decide at runtime.\n      // (Though Opera supports both systems, the event object appears to be\n      // the same no matter which system is used. That means that this function\n      // will always return `true` in Opera, but that's OK; it keeps us from\n      // having to do a browser sniff.)\n      isIELegacyEvent = function(event) {\n        return !(event instanceof window.Event);\n      };\n    } else {\n      // No support for DOM L2 events. All events will be legacy.\n      isIELegacyEvent = function(event) { return true; };\n    }\n  }\n  \n  // The two systems have different ways of indicating which button was used\n  // for a mouse event.\n  var _isButton;\n  function _isButtonForDOMEvents(event, code) {\n    return event.which ? (event.which === code + 1) : (event.button === code);\n  }\n  var legacyButtonMap = { 0: 1, 1: 4, 2: 2 };\n  function _isButtonForLegacyEvents(event, code) {\n    return event.button === legacyButtonMap[code];\n  }\n  // In WebKit we have to account for when the user holds down the \"meta\" key.\n  function _isButtonForWebKit(event, code) {\n    switch (code) {\n      case 0: return event.which == 1 && !event.metaKey;\n      case 1: return event.which == 2 || (event.which == 1 && event.metaKey);\n      case 2: return event.which == 3;\n      default: return false;\n    }\n  }\n  if (window.attachEvent) {\n    if (!window.addEventListener) {\n      // Legacy IE events only.\n      _isButton = _isButtonForLegacyEvents;      \n    } else {\n      // Both systems are supported; decide at runtime.\n      _isButton = function(event, code) {\n        return isIELegacyEvent(event) ? _isButtonForLegacyEvents(event, code) :\n         _isButtonForDOMEvents(event, code);\n      }\n    }\n  } else if (Prototype.Browser.WebKit) {\n    _isButton = _isButtonForWebKit;\n  } else {\n    _isButton = _isButtonForDOMEvents;\n  }\n  \n  function isLeftClick(event)   { return _isButton(event, 0) }\n  function isMiddleClick(event) { return _isButton(event, 1) }\n  function isRightClick(event)  { return _isButton(event, 2) }\n  \n  function element(event) {\n    // The public version of `Event.element` is a thin wrapper around the\n    // private `_element` method below. We do this so that we can use it\n    // internally as `_element` without having to extend the node.\n    return Element.extend(_element(event));\n  }\n  \n  function _element(event) {\n    event = Event.extend(event);\n    var node = event.target, type = event.type,\n     currentTarget = event.currentTarget;\n    if (currentTarget && currentTarget.tagName) {\n      // Firefox screws up the \"click\" event when moving between radio buttons\n      // via arrow keys. It also screws up the \"load\" and \"error\" events on images,\n      // reporting the document as the target instead of the original image.\n      if (type === 'load' || type === 'error' ||\n        (type === 'click' && currentTarget.tagName.toLowerCase() === 'input'\n          && currentTarget.type === 'radio'))\n            node = currentTarget;\n    }\n    // Fix a Safari bug where a text node gets passed as the target of an\n    // anchor click rather than the anchor itself.\n    return node.nodeType == Node.TEXT_NODE ? node.parentNode : node;\n  }\n  function findElement(event, expression) {\n    var element = _element(event), selector = Prototype.Selector;\n    if (!expression) return Element.extend(element);\n    while (element) {\n      if (Object.isElement(element) && selector.match(element, expression))\n        return Element.extend(element);\n      element = element.parentNode;\n    }\n  }\n  \n  function pointer(event) {\n    return { x: pointerX(event), y: pointerY(event) };\n  }\n  function pointerX(event) {\n    var docElement = document.documentElement,\n     body = document.body || { scrollLeft: 0 };\n    return event.pageX || (event.clientX +\n      (docElement.scrollLeft || body.scrollLeft) -\n      (docElement.clientLeft || 0));\n  }\n  function pointerY(event) {\n    var docElement = document.documentElement,\n     body = document.body || { scrollTop: 0 };\n    return  event.pageY || (event.clientY +\n       (docElement.scrollTop || body.scrollTop) -\n       (docElement.clientTop || 0));\n  }\n  function stop(event) {\n    Event.extend(event);\n    event.preventDefault();\n    event.stopPropagation();\n    // Set a \"stopped\" property so that a custom event can be inspected\n    // after the fact to determine whether or not it was stopped.\n    event.stopped = true;\n  }\n  Event.Methods = {\n    isLeftClick:   isLeftClick,\n    isMiddleClick: isMiddleClick,\n    isRightClick:  isRightClick,\n    element:     element,\n    findElement: findElement,\n    pointer:  pointer,\n    pointerX: pointerX,\n    pointerY: pointerY,\n    stop: stop\n  };\n  // Compile the list of methods that get extended onto Events.\n  var methods = Object.keys(Event.Methods).inject({ }, function(m, name) {\n    m[name] = Event.Methods[name].methodize();\n    return m;\n  });\n  if (window.attachEvent) {\n    // For IE's event system, we need to do some work to make the event\n    // object behave like a standard event object.\n    function _relatedTarget(event) {\n      var element;\n      switch (event.type) {\n        case 'mouseover':\n        case 'mouseenter':\n          element = event.fromElement;\n          break;\n        case 'mouseout':\n        case 'mouseleave':\n          element = event.toElement;\n          break;\n        default:\n          return null;\n      }\n      return Element.extend(element);\n    }\n    // These methods should be added _only_ to legacy IE event objects.\n    var additionalMethods = {\n      stopPropagation: function() { this.cancelBubble = true },\n      preventDefault:  function() { this.returnValue = false },\n      inspect: function() { return '[object Event]' }\n    };\n    // IE's method for extending events.\n    Event.extend = function(event, element) {\n      if (!event) return false;\n      \n      // If it's not a legacy event, it doesn't need extending.\n      if (!isIELegacyEvent(event)) return event;\n      // Mark this event so we know not to extend a second time.\n      if (event._extendedByPrototype) return event;\n      event._extendedByPrototype = Prototype.emptyFunction;\n      \n      var pointer = Event.pointer(event);\n      // The optional `element` argument gives us a fallback value for the\n      // `target` property in case IE doesn't give us through `srcElement`.\n      Object.extend(event, {\n        target: event.srcElement || element,\n        relatedTarget: _relatedTarget(event),\n        pageX:  pointer.x,\n        pageY:  pointer.y\n      });\n      \n      Object.extend(event, methods);\n      Object.extend(event, additionalMethods);\n      \n      return event;\n    };\n  } else {\n    // Only DOM events, so no manual extending necessary.\n    Event.extend = Prototype.K;\n  }\n  \n  if (window.addEventListener) {\n    // In all browsers that support DOM L2 Events, we can augment\n    // `Event.prototype` directly.\n    Event.prototype = window.Event.prototype || document.createEvent('HTMLEvents').__proto__;\n    Object.extend(Event.prototype, methods);\n  }\n  \n  //\n  // EVENT REGISTRY\n  //\n  var EVENT_TRANSLATIONS = {\n    mouseenter: 'mouseover',\n    mouseleave: 'mouseout'\n  };\n  \n  function getDOMEventName(eventName) {\n    return EVENT_TRANSLATIONS[eventName] || eventName;\n  }\n  \n  if (MOUSEENTER_MOUSELEAVE_EVENTS_SUPPORTED)\n    getDOMEventName = Prototype.K;\n  \n  function getUniqueElementID(element) {\n    if (element === window) return 0;\n    // Need to use actual `typeof` operator to prevent errors in some\n    // environments when accessing node expandos.\n    if (typeof element._prototypeUID === 'undefined')\n      element._prototypeUID = Element.Storage.UID++;\n    return element._prototypeUID;\n  }\n  \n  // In Internet Explorer, DOM nodes have a `uniqueID` property. Saves us\n  // from inventing our own.\n  function getUniqueElementID_IE(element) {\n    if (element === window) return 0;\n    // The document object's `uniqueID` property changes each time you read it.\n    if (element == document) return 1;\n    return element.uniqueID;\n  }\n  \n  if ('uniqueID' in DIV)\n    getUniqueElementID = getUniqueElementID_IE;\n  function isCustomEvent(eventName) {\n    return eventName.include(':');\n  }\n  Event._isCustomEvent = isCustomEvent;\n  // These two functions take an optional UID as a second argument so that we\n  // can skip lookup if we've already got the element's UID.\n  function getRegistryForElement(element, uid) {\n    var CACHE = GLOBAL.Event.cache;\n    if (Object.isUndefined(uid))\n      uid = getUniqueElementID(element);\n    if (!CACHE[uid]) CACHE[uid] = { element: element };\n    return CACHE[uid];\n  }\n  \n  function destroyRegistryForElement(element, uid) {\n    if (Object.isUndefined(uid))\n      uid = getUniqueElementID(element);\n    delete GLOBAL.Event.cache[uid];\n  }\n  \n  // The `register` and `unregister` functions handle creating the responder\n  // and managing an event registry. They _don't_ attach and detach the\n  // listeners themselves.\n  \n  // Add an event to the element's event registry.\n  function register(element, eventName, handler) {\n    var registry = getRegistryForElement(element);\n    if (!registry[eventName]) registry[eventName] = [];\n    var entries = registry[eventName];\n    // Make sure this handler isn't already attached.\n    var i = entries.length;\n    while (i--)\n      if (entries[i].handler === handler) return null;\n      \n    var uid = getUniqueElementID(element);\n    var responder = GLOBAL.Event._createResponder(uid, eventName, handler);\n    var entry = {\n      responder: responder,\n      handler:   handler\n    };\n    entries.push(entry);    \n    return entry;\n  }\n  \n  // Remove an event from the element's event registry.\n  function unregister(element, eventName, handler) {\n    var registry = getRegistryForElement(element);\n    var entries = registry[eventName];\n    if (!entries) return;\n    \n    var i = entries.length, entry;\n    while (i--) {\n      if (entries[i].handler === handler) {\n        entry = entries[i];\n        break;\n      }\n    }\n    \n    // This handler wasn't in the collection, so it doesn't need to be\n    // unregistered.\n    if (!entry) return;\n    // Remove the entry from the collection;\n    var index = entries.indexOf(entry);\n    entries.splice(index, 1);\n    if (entries.length == 0) {\n      stopObservingEventName(element, eventName);\n    }\n    return entry;\n  }  \n  \n  \n  //\n  // EVENT OBSERVING\n  //\n  function observe(element, eventName, handler) {\n    element = $(element);\n    var entry = register(element, eventName, handler);\n    \n    if (entry === null) return element;\n    var responder = entry.responder;    \n    if (isCustomEvent(eventName))\n      observeCustomEvent(element, eventName, responder);\n    else\n      observeStandardEvent(element, eventName, responder);\n      \n    return element;\n  }\n  \n  function observeStandardEvent(element, eventName, responder) {\n    var actualEventName = getDOMEventName(eventName);\n    if (element.addEventListener) {\n      element.addEventListener(actualEventName, responder, false);\n    } else {\n      element.attachEvent('on' + actualEventName, responder);\n    }\n  }\n  \n  function observeCustomEvent(element, eventName, responder) {\n    if (element.addEventListener) {\n      element.addEventListener('dataavailable', responder, false);\n    } else {\n      // We observe two IE-proprietarty events: one for custom events that\n      // bubble and one for custom events that do not bubble.\n      element.attachEvent('ondataavailable', responder);\n      element.attachEvent('onlosecapture',   responder);\n    }\n  }\n  \n  function stopObserving(element, eventName, handler) {\n    element = $(element);\n    var handlerGiven = !Object.isUndefined(handler),\n     eventNameGiven = !Object.isUndefined(eventName);\n     \n    if (!eventNameGiven && !handlerGiven) {\n      stopObservingElement(element);\n      return element;\n    }\n    \n    if (!handlerGiven) {\n      stopObservingEventName(element, eventName);\n      return element;\n    }\n    \n    var entry = unregister(element, eventName, handler);\n    \n    if (!entry) return element; \n    removeEvent(element, eventName, entry.responder);\n    return element;\n  }\n  \n  function stopObservingStandardEvent(element, eventName, responder) {\n    var actualEventName = getDOMEventName(eventName);\n    if (element.removeEventListener) {\n      element.removeEventListener(actualEventName, responder, false);      \n    } else {\n      element.detachEvent('on' + actualEventName, responder);\n    }\n  }\n  \n  function stopObservingCustomEvent(element, eventName, responder) {\n    if (element.removeEventListener) {\n      element.removeEventListener('dataavailable', responder, false);\n    } else {\n      element.detachEvent('ondataavailable', responder);\n      element.detachEvent('onlosecapture',   responder);\n    }\n  }\n  \n  // The `stopObservingElement` and `stopObservingEventName` functions are\n  // for bulk removal of event listeners. We use them rather than recurse\n  // back into `stopObserving` to avoid touching the registry more often than\n  // necessary.\n  // Stop observing _all_ listeners on an element.\n  function stopObservingElement(element) {\n    // Do a manual registry lookup because we don't want to create a registry\n    // if one doesn't exist.\n    var uid = getUniqueElementID(element), registry = GLOBAL.Event.cache[uid];\n    // This way we can return early if there is no registry.\n    if (!registry) return;\n    destroyRegistryForElement(element, uid);\n    var entries, i;\n    for (var eventName in registry) {\n      // Explicitly skip elements so we don't accidentally find one with a\n      // `length` property.\n      if (eventName === 'element') continue;\n      entries = registry[eventName];\n      i = entries.length;\n      while (i--)\n        removeEvent(element, eventName, entries[i].responder);\n    }\n  }\n  \n  // Stop observing all listeners of a certain event name on an element.\n  function stopObservingEventName(element, eventName) {\n    var registry = getRegistryForElement(element);\n    var entries = registry[eventName];\n    if (!entries) return;\n    delete registry[eventName];\n    \n    var i = entries.length;\n    while (i--)\n      removeEvent(element, eventName, entries[i].responder);\n    for (var name in registry) {\n      if (name === 'element') continue;\n      return; // There is another registered event\n    }\n    // No other events for the element, destroy the registry:\n    destroyRegistryForElement(element);\n  }\n  \n  function removeEvent(element, eventName, handler) {\n    if (isCustomEvent(eventName))\n      stopObservingCustomEvent(element, eventName, handler);\n    else\n      stopObservingStandardEvent(element, eventName, handler);\n  }\n  \n  \n  \n  // FIRING CUSTOM EVENTS\n  function getFireTarget(element) {\n    if (element !== document) return element;\n    if (document.createEvent && !element.dispatchEvent)\n      return document.documentElement;\n    return element;\n  }\n  \n  function fire(element, eventName, memo, bubble) {\n    element = getFireTarget($(element));\n    if (Object.isUndefined(bubble)) bubble = true;      \n    memo = memo || {};\n      \n    var event = fireEvent(element, eventName, memo, bubble);\n    return Event.extend(event);\n  }\n  \n  function fireEvent_DOM(element, eventName, memo, bubble) {\n    var event = document.createEvent('HTMLEvents');\n    event.initEvent('dataavailable', bubble, true);\n    \n    event.eventName = eventName;\n    event.memo = memo;\n    \n    element.dispatchEvent(event);\n    return event;\n  }\n  \n  function fireEvent_IE(element, eventName, memo, bubble) {\n    var event = document.createEventObject();\n    event.eventType = bubble ? 'ondataavailable' : 'onlosecapture';\n    \n    event.eventName = eventName;\n    event.memo = memo;\n    \n    element.fireEvent(event.eventType, event);    \n    return event;\n  }\n  \n  var fireEvent = document.createEvent ? fireEvent_DOM : fireEvent_IE;\n  \n  \n  // EVENT DELEGATION\n  \n  Event.Handler = Class.create({\n    initialize: function(element, eventName, selector, callback) {\n      this.element   = $(element);\n      this.eventName = eventName;\n      this.selector  = selector;\n      this.callback  = callback;\n      this.handler   = this.handleEvent.bind(this);\n    },\n    \n    start: function() {\n      Event.observe(this.element, this.eventName, this.handler);\n      return this;\n    },\n    \n    stop: function() {\n      Event.stopObserving(this.element, this.eventName, this.handler);\n      return this;\n    },\n    \n    handleEvent: function(event) {\n      var element = Event.findElement(event, this.selector);\n      if (element) this.callback.call(this.element, event, element);\n    }\n  });\n  \n  function on(element, eventName, selector, callback) {\n    element = $(element);\n    if (Object.isFunction(selector) && Object.isUndefined(callback)) {\n      callback = selector, selector = null;\n    }\n    \n    return new Event.Handler(element, eventName, selector, callback).start();\n  }\n  \n  Object.extend(Event, Event.Methods);\n  Object.extend(Event, {\n    fire:          fire,\n    observe:       observe,\n    stopObserving: stopObserving,\n    on:            on\n  });\n  Element.addMethods({\n    fire:          fire,\n    observe:       observe,\n    stopObserving: stopObserving,\n    \n    on:            on\n  });\n  Object.extend(document, {\n    fire:          fire.methodize(),\n    observe:       observe.methodize(),\n    stopObserving: stopObserving.methodize(),\n    \n    on:            on.methodize(),\n    loaded:        false\n  });\n  // Export to the global scope.\n  if (GLOBAL.Event) Object.extend(window.Event, Event);\n  else GLOBAL.Event = Event;\n  \n  GLOBAL.Event.cache = {};\n    \n  function destroyCache_IE() {\n    GLOBAL.Event.cache = null;\n  }\n  \n  if (window.attachEvent)\n    window.attachEvent('onunload', destroyCache_IE);\n    \n  DIV = null;\n  docEl = null;\n})(this);\n(function(GLOBAL) {  \n  /* Code for creating leak-free event responders is based on work by\n   John-David Dalton. */\n  \n  var docEl = document.documentElement;\n  var MOUSEENTER_MOUSELEAVE_EVENTS_SUPPORTED = 'onmouseenter' in docEl\n    && 'onmouseleave' in docEl;\n    \n  function isSimulatedMouseEnterLeaveEvent(eventName) {\n    return !MOUSEENTER_MOUSELEAVE_EVENTS_SUPPORTED &&\n     (eventName === 'mouseenter' || eventName === 'mouseleave');\n  }\n  \n  // The functions for creating responders accept the element's UID rather\n  // than the element itself. This way, there are _no_ DOM objects inside the\n  // closure we create, meaning there's no need to unregister event listeners\n  // on unload.\n  function createResponder(uid, eventName, handler) {    \n    if (Event._isCustomEvent(eventName))\n      return createResponderForCustomEvent(uid, eventName, handler);      \n    if (isSimulatedMouseEnterLeaveEvent(eventName))\n      return createMouseEnterLeaveResponder(uid, eventName, handler);\n    \n    return function(event) {\n      if (!Event.cache) return;\n      \n      var element = Event.cache[uid].element;\n      Event.extend(event, element);\n      handler.call(element, event);\n    };\n  }\n  \n  function createResponderForCustomEvent(uid, eventName, handler) {\n    return function(event) {\n      var element = Event.cache[uid] !== undefined ? Event.cache[uid].element : event.target;\n      if (Object.isUndefined(event.eventName))\n        return false;\n        \n      if (event.eventName !== eventName)\n        return false;\n        \n      Event.extend(event, element);\n      handler.call(element, event);\n    };\n  }\n  \n  function createMouseEnterLeaveResponder(uid, eventName, handler) {\n    return function(event) {\n      var element = Event.cache[uid].element;\n      \n      Event.extend(event, element);\n      var parent = event.relatedTarget;\n      \n      // Walk up the DOM tree to see if the related target is a descendant of\n      // the original element. If it is, we ignore the event to match the\n      // behavior of mouseenter/mouseleave.\n      while (parent && parent !== element) {\n        try { parent = parent.parentNode; }\n        catch(e) { parent = element; }\n      }\n      \n      if (parent === element) return;      \n      handler.call(element, event);\n    }\n  }\n  \n  GLOBAL.Event._createResponder = createResponder;\n  docEl = null;\n})(this);\n(function(GLOBAL) {\n  /* Support for the DOMContentLoaded event is based on work by Dan Webb,\n     Matthias Miller, Dean Edwards, John Resig, and Diego Perini. */\n  \n  var TIMER;\n  \n  function fireContentLoadedEvent() {\n    if (document.loaded) return;\n    if (TIMER) window.clearTimeout(TIMER);\n    document.loaded = true;\n    document.fire('dom:loaded');\n  }\n  \n  function checkReadyState() {\n    if (document.readyState === 'complete') {\n      document.detachEvent('onreadystatechange', checkReadyState);\n      fireContentLoadedEvent();\n    }\n  }\n  \n  function pollDoScroll() {\n    try {\n      document.documentElement.doScroll('left');\n    } catch (e) {\n      TIMER = pollDoScroll.defer();\n      return;\n    }\n    \n    fireContentLoadedEvent();\n  }\n  if (document.readyState === 'complete') {\n    // We must have been loaded asynchronously, because the DOMContentLoaded\n    // event has already fired. We can just fire `dom:loaded` and be done\n    // with it.\n    fireContentLoadedEvent();\n    return;\n  }\n  \n  if (document.addEventListener) {\n    // All browsers that support DOM L2 Events support DOMContentLoaded,\n    // including IE 9.\n    document.addEventListener('DOMContentLoaded', fireContentLoadedEvent, false);\n  } else {\n    document.attachEvent('onreadystatechange', checkReadyState);\n    if (window == top) TIMER = pollDoScroll.defer();\n  }\n  \n  // Worst-case fallback.\n  Event.observe(window, 'load', fireContentLoadedEvent);\n})(this);\nElement.addMethods();\n/*------------------------------- DEPRECATED -------------------------------*/\nHash.toQueryString = Object.toQueryString;\nvar Toggle = { display: Element.toggle };\nElement.Methods.childOf = Element.Methods.descendantOf;\nvar Insertion = {\n  Before: function(element, content) {\n    return Element.insert(element, {before:content});\n  },\n  Top: function(element, content) {\n    return Element.insert(element, {top:content});\n  },\n  Bottom: function(element, content) {\n    return Element.insert(element, {bottom:content});\n  },\n  After: function(element, content) {\n    return Element.insert(element, {after:content});\n  }\n};\nvar $continue = new Error('\"throw $continue\" is deprecated, use \"return\" instead');\nvar Position = {\n  // set to true if needed, warning: firefox performance problems\n  // NOT neeeded for page scrolling, only if draggable contained in\n  // scrollable elements\n  includeScrollOffsets: false,\n  // must be called before calling withinIncludingScrolloffset, every time the\n  // page is scrolled\n  prepare: function() {\n    this.deltaX =  window.pageXOffset\n                || document.documentElement.scrollLeft\n                || document.body.scrollLeft\n                || 0;\n    this.deltaY =  window.pageYOffset\n                || document.documentElement.scrollTop\n                || document.body.scrollTop\n                || 0;\n  },\n  // caches x/y coordinate pair to use with overlap\n  within: function(element, x, y) {\n    if (this.includeScrollOffsets)\n      return this.withinIncludingScrolloffsets(element, x, y);\n    this.xcomp = x;\n    this.ycomp = y;\n    this.offset = Element.cumulativeOffset(element);\n    return (y >= this.offset[1] &&\n            y <  this.offset[1] + element.offsetHeight &&\n            x >= this.offset[0] &&\n            x <  this.offset[0] + element.offsetWidth);\n  },\n  withinIncludingScrolloffsets: function(element, x, y) {\n    var offsetcache = Element.cumulativeScrollOffset(element);\n    this.xcomp = x + offsetcache[0] - this.deltaX;\n    this.ycomp = y + offsetcache[1] - this.deltaY;\n    this.offset = Element.cumulativeOffset(element);\n    return (this.ycomp >= this.offset[1] &&\n            this.ycomp <  this.offset[1] + element.offsetHeight &&\n            this.xcomp >= this.offset[0] &&\n            this.xcomp <  this.offset[0] + element.offsetWidth);\n  },\n  // within must be called directly before\n  overlap: function(mode, element) {\n    if (!mode) return 0;\n    if (mode == 'vertical')\n      return ((this.offset[1] + element.offsetHeight) - this.ycomp) /\n        element.offsetHeight;\n    if (mode == 'horizontal')\n      return ((this.offset[0] + element.offsetWidth) - this.xcomp) /\n        element.offsetWidth;\n  },\n  // Deprecation layer -- use newer Element methods now (1.5.2).\n  cumulativeOffset: Element.Methods.cumulativeOffset,\n  positionedOffset: Element.Methods.positionedOffset,\n  absolutize: function(element) {\n    Position.prepare();\n    return Element.absolutize(element);\n  },\n  relativize: function(element) {\n    Position.prepare();\n    return Element.relativize(element);\n  },\n  realOffset: Element.Methods.cumulativeScrollOffset,\n  offsetParent: Element.Methods.getOffsetParent,\n  page: Element.Methods.viewportOffset,\n  clone: function(source, target, options) {\n    options = options || { };\n    return Element.clonePosition(target, source, options);\n  }\n};\n/*--------------------------------------------------------------------------*/\nif (!document.getElementsByClassName) document.getElementsByClassName = function(instanceMethods){\n  function iter(name) {\n    return name.blank() ? null : \"[contains(concat(' ', @class, ' '), ' \" + name + \" ')]\";\n  }\n  instanceMethods.getElementsByClassName = Prototype.BrowserFeatures.XPath ?\n  function(element, className) {\n    className = className.toString().strip();\n    var cond = /\\s/.test(className) ? $w(className).map(iter).join('') : iter(className);\n    return cond ? document._getElementsByXPath('.//*' + cond, element) : [];\n  } : function(element, className) {\n    className = className.toString().strip();\n    var elements = [], classNames = (/\\s/.test(className) ? $w(className) : null);\n    if (!classNames && !className) return elements;\n    var nodes = $(element).getElementsByTagName('*');\n    className = ' ' + className + ' ';\n    for (var i = 0, child, cn; child = nodes[i]; i++) {\n      if (child.className && (cn = ' ' + child.className + ' ') && (cn.include(className) ||\n          (classNames && classNames.all(function(name) {\n            return !name.toString().blank() && cn.include(' ' + name + ' ');\n          }))))\n        elements.push(Element.extend(child));\n    }\n    return elements;\n  };\n  return function(className, parentElement) {\n    return $(parentElement || document.body).getElementsByClassName(className);\n  };\n}(Element.Methods);\n/*--------------------------------------------------------------------------*/\nElement.ClassNames = Class.create();\nElement.ClassNames.prototype = {\n  initialize: function(element) {\n    this.element = $(element);\n  },\n  _each: function(iterator, context) {\n    this.element.className.split(/\\s+/).select(function(name) {\n      return name.length > 0;\n    })._each(iterator, context);\n  },\n  set: function(className) {\n    this.element.className = className;\n  },\n  add: function(classNameToAdd) {\n    if (this.include(classNameToAdd)) return;\n    this.set($A(this).concat(classNameToAdd).join(' '));\n  },\n  remove: function(classNameToRemove) {\n    if (!this.include(classNameToRemove)) return;\n    this.set($A(this).without(classNameToRemove).join(' '));\n  },\n  toString: function() {\n    return $A(this).join(' ');\n  }\n};\nObject.extend(Element.ClassNames.prototype, Enumerable);\n/*--------------------------------------------------------------------------*/\n(function() {\n  window.Selector = Class.create({\n    initialize: function(expression) {\n      this.expression = expression.strip();\n    },\n  \n    findElements: function(rootElement) {\n      return Prototype.Selector.select(this.expression, rootElement);\n    },\n  \n    match: function(element) {\n      return Prototype.Selector.match(element, this.expression);\n    },\n  \n    toString: function() {\n      return this.expression;\n    },\n  \n    inspect: function() {\n      return \"#<Selector: \" + this.expression + \">\";\n    }\n  });\n  Object.extend(Selector, {\n    matchElements: function(elements, expression) {\n      var match = Prototype.Selector.match,\n          results = [];\n          \n      for (var i = 0, length = elements.length; i < length; i++) {\n        var element = elements[i];\n        if (match(element, expression)) {\n          results.push(Element.extend(element));\n        }\n      }\n      return results;\n    },\n    findElement: function(elements, expression, index) {\n      index = index || 0;\n      var matchIndex = 0, element;\n      // Match each element individually, since Sizzle.matches does not preserve order\n      for (var i = 0, length = elements.length; i < length; i++) {\n        element = elements[i];\n        if (Prototype.Selector.match(element, expression) && index === matchIndex++) {\n          return Element.extend(element);\n        }\n      }\n    },\n    findChildElements: function(element, expressions) {\n      var selector = expressions.toArray().join(', ');\n      return Prototype.Selector.select(selector, element || document);\n    }\n  });\n})();"

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @author PanJC
	 * @filename _config
	 * @filetype {object}
	 * @filedescription "新版本系统配置文件,用户不可修改，全局对象"
	 * @filereturn
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(10)], __WEBPACK_AMD_DEFINE_RESULT__ = function (config) {
	
	  var root = window;
	
	  CONFIG = root.CONFIG = {};
	  /*
	   * @property {string} CONFIG.ouath.client_id "oauth2 client_id参数"
	   * @property {string} CONFIG.ouath.client_secret "oauth2 client_secret参数"
	   * @property {string} CONFIG.ouath.grant_type.password "oauth2 请求令牌标识"
	   * @property {string} CONFIG.ouath.grant_type.refresh_token "oauth2  刷新令牌标识"
	   * @property {string} CONFIG.ouath.token.access_token "oauth2  访问令牌标识"
	   * @property {string} CONFIG.ouath.token.refresh_token "oauth2  刷新令牌标识"
	   * @property {object} CONFIG.ouath.gatewayModel "机型文件及对应文件位置"
	   * @property {string} CONFIG.ouath.modelSensorTypes[$].id "传感器类型id"
	   * @property {string} CONFIG.ouath.modelSensorTypes[$].name "传感器类型名"
	   */
	  CONFIG = {
	
	    oauth: {
	      client_id: "000017953450251798098136",
	      client_secret: "08E9EC6793345759456CB8BAE52615F3",
	      grant_type: {
	        password: "password",
	        refresh_token: "refresh_token"
	      }
	    },
	
	    token: {
	      access_token: "accessToken",
	      refresh_token: "refreshToken"
	    },
	
	    gatewayModel: $H({
	      "InDTU3XX_GPRS-STATUS": {path: "0_1", html: "InDTU"},
	      "InDTU3XX_GPRS/EDGE": {path: "0_1", html: "InDTU"},
	      "IR300": {path: "0_31", html: "IR300"},
	      "IR320": {path: "0_36", html: "IR300"},
	      "IR600": {path: "0_45", html: "IR700"},
	      "IR6XX_TD": {path: "0_45", html: "IR700"},
	      "IR6XX_EVDO": {path: "0_44", html: "IR700"},
	      "IR6XX_CDMA": {path: "0_44", html: "IR700"},
	      "IR6XX_WCDMA": {path: "0_46", html: "IR700"},
	      "IG601_HSPA+": {path: "0_46", html: "IR700"},
	      "IG601_EVDO": {path: "0_46", html: "IR700"},
	//		        "IR6XX_WCDMA":{path:"0_71",html:"IR900"},
	      "IR7XX_EVDO": {path: "0_63", html: "IR700"},
	      "IR7XX_CDMA": {path: "0_63", html: "IR700"},
	      "IR7XX_EVDO/CDMA": {path: "0_63", html: "IR700"},
	      "IR7XX_UE": {path: "0_63", html: "IR700"},
	      "IR7XX_GPRS": {path: "0_51", html: "IR700"},
	      "IR7XX_EDGE": {path: "0_51", html: "IR700"},
	      "IR7XX_GPRS/EDGE": {path: "0_51", html: "IR700"},
	      "IR7XX_TD-SCDMA": {path: "0_60", html: "IR700"},
	      "IR7XX_WCDMA": {path: "0_54", html: "IR700"},
	      "IR9XX_WCDMA": {path: "0_71", html: "IR900"},
	      "IR9XX_EVDO": {path: "0_70", html: "IR900"},
	      "IR9XX_FDD-LTE": {path: "0_73", html: "IR900"},
	      "IR9XX_TDD-LTE": {path: "0_72", html: "IR900"},
	      "IR900": {path: "0_72", html: "IR900"},
	      "RTU": {path: "0_80", html: "InDTU"},
	      "IR8XX_EVDO": {path: "0_83", html: "IR800"},
	      "IR8XX_TDD-LTE": {path: "0_84", html: "IR800"},
	      "IR8XX_FDD-LTE": {path: "0_85", html: "IR800"},
	      "IR8XX_WCDMA": {path: "0_86", html: "IR800"},
	    }),
	
	    modelSensorTypes: [{
	      id: 0,
	      name: "inRouter"
	    }, {
	      id: 3,
	      name: "modbus_rtu"
	    }, {
	      id: 61705,
	      name: "ab"
	    }, {
	      id: 61706,
	      name: "mpi"
	    }, {
	      id: 61701,
	      name: "midea_frequency_centrifuge"
	    }, {
	      id: 61446,
	      name: "modbus_tcp"
	    },
	      /*
	       {
	       id : 1025,
	       name : "common_network_port"
	       },
	       {
	       id : 1026,
	       name : "universal_serial"
	       },
	       */
	      {
	        id: 61702,
	        name: "siemens_ppi"
	      }, {
	        id: 61700,
	        name: "multi_line"
	      }, {
	        id: 61699,
	        name: "midea_air_cooled_heat_pump"
	      }, {
	        id: 61698,
	        name: "midea_screw_machine"
	      }],
	
	    map: "cloud/components/mapImpl/gmapImpl",
	    baidu: {
	      ak: 'AOakjqiyDS4GHt4nf8IljN4SuOcwbGLf'
	    },
	    useGoogleMap: false,
	    google: {
	      url: "https://maps.googleapis.com/maps/api/js?sensor=false&libraries=places&key=AIzaSyDV_nZOWZ9s86aeNuAUGWJx1SGJeKsglRE"
	    }
	  };
	
	  for (var attr in config) {
	    CONFIG[attr] = config[attr];
	  }
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @author PANJC
	 * @filename config
	 * @filetype {object}
	 * @filedescription "用户配置文件"
	 * @filereturn
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  /*
	   * @property {string} config.server.path.oauth "oauth2服务器地址"
	   * @property {string} config.server.path.api "api服务器地址"
	   * @property {boolean} config.server.debugMode "服务端是否调试模式"
	   * @property {number} config.ajax.timeout "ajax超时时间设置"
	   * @property {number} config.ajax.cacheTime "刷新令牌的缓存时间"
	   * @property {string} config.url.login.fail "登录失败跳转到的页面地址"
	   * @property {string} config.url.login.success "登录成功跳转到的页面地址"
	   * @property {string} config.dialog.module "提示组件所在位置"
	   * @property {string} config.locale.packages.default "默认语言包地址"
	   * @property {string} config.locale.packages "语言包"
	   * @property {string} config.locale.languages "语言种类"
	   * @property {string} config.permission "权限控制"
	   * @property {boolean} config.debug "客户端是否调试模式"
	   */
	  var config = {
	
	    server: {
	      path: {
	        oauth: "",
	        api: "",
	      },
	      debugMode: true
	    },
	
	    ajax: {
	      timeout: 120000,
	      cacheTime: 2000
	    },
	
	    url: {
	      login: {
	        fail: "../www/index.html",
	        success: "../applications/index.html"
	      }
	    },
	
	    dialog: {
	      module: __webpack_require__(11)
	    },
	
	    locale: {
	      packages: {
	        "default": "base",
	        cloud: "/cloud/resources/language",
	        base: "../resources/language"
	      },
	      languages: ["en", "zh_CN"]
	    },
	
	    permission: {
	      // apps: "/DeviceNetwork/permission/apps",
	      // config: "DeviceNetwork/permission/config",
	      // gates: "/DeviceNetwork/permission/gates"
	    },
	    debug: false
	  };
	  var path = window.location.pathname;
	  var pathArr = path.split("/");
	  var indexURL;
	  if (path.indexOf("DeviceNetwork/applications/") == -1) {
	    if (path.indexOf("/www/") == -1) {
	      window.localStorage.setItem("indexURL", "index/" + pathArr[3]);
	      indexURL = window.localStorage.getItem("indexURL");
	      config.url.login.fail = "../" + indexURL + "/index.html";
	      config.url.login.success = "../../applications/index.html";
	      // config.locale.packages.cloud = require.toUrl("../../resources/language");
	      config.locale.packages.base = "../../resources/language";
	    }
	    else {
	      window.localStorage.setItem("indexURL", pathArr[2]);
	      indexURL = window.localStorage.getItem("indexURL");
	    }
	  }
	  else {
	    indexURL = window.localStorage.getItem("indexURL");
	    config.url.login.fail = "../" + indexURL + "/index.html";
	  }
	  return config;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Copyright (c) 2007-2014, InHand Networks All Rights Reserved.
	 * @author PANJC
	 * Example
	 * dialog.render({
	 *  container:"#window-login",
	 * 	lang:"confirm_the_deletion",
	 * 	buttons:[{lang:"yes",click:function(){alert("yes")}},{lang:"no",click:function(){alert("no")}}],
	 *  close:function(){alert("close")}
	 * });
	 *
	 * dialog.render({
	 * 	lang:"confirm_the_deletion"
	 * });
	 *
	 * dialog.render({
	 * 	text:"Confirm the deletion?"
	 * });
	 *
	 * dialog.render({
	 * 	content:[{lang:21304},{html:"<p id='confirm'></p>"},{text:"cancel"}...],
	 * });
	 *
	 */
	/**
	 * @author PANJC
	 * @filename dialog
	 * @filetype {object}
	 * @filedescription "这是一个对话框对象"
	 * @filereturn {object} "dialog对象"
	 *
	 * */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  __webpack_require__(1);
	  __webpack_require__(12);
	  __webpack_require__(13);
	  window.dialog = {
	    element: "",
	    defaultObj: {
	      appendTo: "body",
	      autoOpen: true,
	      buttons: {},
	      closeOnEscape: true,
	      closeText: "hide",
	      dialogClass: "dialogclass",
	      draggable: true,
	      hide: 50,
	      show: 10,
	      width: 360,
	      minWidth: 360,
	      maxWidth: 460,
	      minHeight: 150,
	      maxHeight: 250,
	      modal: true,
	      position: {my: "center", at: "center", of: window},
	      resizable: false,
	      stack: false,
	      title: "",
	      beforeClose: null,
	      close: null,
	      create: null,
	      drag: null,
	      dragStart: null,
	      dragStop: null,
	      focus: null,
	      open: null,
	      resize: null,
	      resizeStart: null,
	      resizeStop: null
	    },
	
	    /**
	     * @author PANJC
	     * @name render
	     * @type {method}
	     * @description "显示对   话框"
	     * @param {object} userObj "以json形式组织的参数对象"
	     * @param {array} variableArr "变量数组"
	     */
	    render: function (userObj, variableArr) {
	      if ($(".inhand-dialog").length > 0) {
	        return;
	      }
	      this._setDialogIntoContainer(userObj, this._returnDialogContent(userObj, variableArr));
	      $(this.element).dialog(this._returnExtendOptions(userObj));
	    },
	
	    /**
	     * @author PANJC
	     * @name _returnExtendOptions
	     * @type {method}
	     * @description "扩展传入的参数对象"
	     * @param {Object} userObj "json对象"
	     * @return {Object} "新的json对象"
	     * @private
	     */
	    _returnExtendOptions: function (userObj) {
	      var self = this;
	      var newObj = {};
	      var defaultObj = this.defaultObj;
	
	      if (userObj.container) {
	        newObj.appendTo = userObj.container;
	        newObj.position = {my: "center", at: "center", of: userObj.container};
	        newObj.width = 260;
	        newObj.minWidth = 260;
	        newObj.height = 130;
	        newObj.minHeight = 130;
	        newObj.draggable = false;
	      } else {
	        newObj.appendTo = "body";
	        newObj.position = {my: "center", at: "center", of: window};
	        newObj.width = 360;
	        newObj.minWidth = 360;
	        newObj.minHeight = 150;
	        newObj.draggable = false;
	      }
	
	      if (userObj.buttons) {
	        var arr = [];
	        $.each(userObj.buttons, function (index, obj) {
	          var buttonObj = {};
	          if (obj.text) {
	            buttonObj.text = obj.text;
	          } else if (obj.lang) {
	            buttonObj.text = locale.get({lang: obj.lang, pos: "base"});
	          }
	          buttonObj.click = obj.click;
	          arr.push(buttonObj);
	        });
	        newObj.buttons = arr;
	        newObj.title = locale.get({lang: "prompt", pos: "base"});
	      } else {
	        newObj.buttons = [{
	          text: locale.get({lang: "ok", pos: "base"}), click: function () {
	            self.close();
	          }
	        }];
	        newObj.title = locale.get({lang: "prompt", pos: "base"});
	      }
	      if (userObj.model) {
	        newObj.modal = true;
	      }
	
	      if (userObj.open && ($.isFunction(userObj.open))) {
	        newObj.open = function () {
	          userObj.open();
	        };
	      }
	
	      if (userObj.close && ($.isFunction(userObj.close))) {
	        newObj.close = function () {
	          self.close();
	          userObj.close();
	        };
	      } else {
	        newObj.close = function () {
	          self.close();
	        };
	      }
	
	      if (userObj.create && ($.isFunction(userObj.create))) {
	        newObj.create = function () {
	          userObj.create();
	        };
	      }
	
	      if (userObj.width) {
	        newObj.width = userObj.width;
	        newObj.minWidth = userObj.width;
	      }
	
	      if (userObj.height) {
	        newObj.height = userObj.height;
	        newObj.minHeight = userObj.height;
	      }
	
	      newObj = $.extend(defaultObj, newObj);
	
	      return newObj;
	
	    },
	
	    /**
	     * @author PANJC
	     * @name _returnDialogContent
	     * @type {method}
	     * @description "获取要显示对话框的文字内容"
	     * @param {Object} userObj "json格式的对象"
	     * @param {Array} variableArr "变量数组"
	     * @return {String} "对话框文字内容"
	     * @private
	     */
	    _returnDialogContent: function (userObj, variableArr) {
	      var dialogContent = "";
	      if (!userObj.content) {
	        if (userObj.text) {
	          dialogContent = userObj.text;
	        } else if (userObj.lang) {
	          dialogContent = variableArr ? locale.get({
	            lang: userObj.lang,
	            pos: "base"
	          }, variableArr) : locale.get({lang: userObj.lang, pos: "base"});
	        }
	      } else {
	        var content = userObj.content;
	        for (var num = 0; num < content.length; num++) {
	          if (content[num]["lang"]) {
	            if (variableArr) {
	              dialogContent += locale.get({lang: content[num]["lang"], pos: "base"}, variableArr);
	            } else {
	              dialogContent += locale.get({lang: content[num]["lang"], pos: "base"});
	            }
	          } else if (content[num]["text"]) {
	            dialogContent += content[num]["text"];
	          } else if (content[num]["html"]) {
	            dialogContent += content[num]["html"];
	          }
	        }
	      }
	      return dialogContent;
	    },
	
	    /**
	     * @author PANJC
	     * @name _setDialogIntoContainer
	     * @type {method}
	     * @description "将对话框添加到显示页面中的dom结构中去"
	     * @param {Object} userObj "json格式的对象"
	     * @param {String} content "对话框文字内容"
	     * @private
	     */
	    _setDialogIntoContainer: function (userObj, content) {
	      var element = this._createRandomElement();
	      var $dialog = this._createDialogElement(element, content);
	      if (userObj.container) {
	        $dialog.appendTo($(userObj.container));
	      } else {
	        $dialog.appendTo("body");
	      }
	    },
	
	    /**
	     * @author PANJC
	     * @name _createRandomElement
	     * @type {method}
	     * @description "以时间为区分，创建dom的jquery选择器"
	     * @return {String}
	     * @private
	     */
	    _createRandomElement: function () {
	      var date = (new Date()).toString().md5();
	      var random = (Math.random()).toString().md5();
	      element = "#" + "dialog-" + date + random;
	      this.element = element;
	      return element;
	    },
	
	    /**
	     * @author PANJC
	     * @name _createDialogElement
	     * @type {method}
	     * @description "创建对话框的内容元素"
	     * @param {string} element "dom的id选择器"
	     * @param {string} content "对话框的文字内容"
	     * @return {Object} "jquery对象"
	     * @private
	     */
	    _createDialogElement: function (element, content) {
	      var $dialog = $("<div>").attr("id", element.substring(1)).attr("class", "inhand-dialog").css({
	        width: "100%",
	        height: 60
	      });
	      var $content = $("<span>").html(content);
	      $content.appendTo($dialog);
	      return $dialog;
	    },
	
	    /**
	     * @author PANJC
	     * @name close
	     * @type {method}
	     * @description "关闭对话框"
	     */
	    close: function () {
	      var self = this;
	      $(self.element).dialog("close");
	      $(self.element).dialog("destroy");
	      $(self.element).remove();
	    }
	
	  };
	
	  return dialog;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {
	/* injects from baggage-loader */
	__webpack_require__(13);
	
	/*! jQuery UI - v1.10.3 - 2013-07-16
	* http://jqueryui.com
	* Includes: jquery.ui.core.js, jquery.ui.widget.js, jquery.ui.mouse.js, jquery.ui.position.js, jquery.ui.draggable.js, jquery.ui.droppable.js, jquery.ui.resizable.js, jquery.ui.selectable.js, jquery.ui.sortable.js, jquery.ui.accordion.js, jquery.ui.autocomplete.js, jquery.ui.button.js, jquery.ui.datepicker.js, jquery.ui.dialog.js, jquery.ui.menu.js, jquery.ui.progressbar.js, jquery.ui.slider.js, jquery.ui.spinner.js, jquery.ui.tabs.js, jquery.ui.tooltip.js, jquery.ui.effect.js, jquery.ui.effect-blind.js, jquery.ui.effect-bounce.js, jquery.ui.effect-clip.js, jquery.ui.effect-drop.js, jquery.ui.effect-explode.js, jquery.ui.effect-fade.js, jquery.ui.effect-fold.js, jquery.ui.effect-highlight.js, jquery.ui.effect-pulsate.js, jquery.ui.effect-scale.js, jquery.ui.effect-shake.js, jquery.ui.effect-slide.js, jquery.ui.effect-transfer.js
	* Copyright 2013 jQuery Foundation and other contributors Licensed MIT */
	(function(e,t){function i(t,i){var a,n,r,o=t.nodeName.toLowerCase();return"area"===o?(a=t.parentNode,n=a.name,t.href&&n&&"map"===a.nodeName.toLowerCase()?(r=e("img[usemap=#"+n+"]")[0],!!r&&s(r)):!1):(/input|select|textarea|button|object/.test(o)?!t.disabled:"a"===o?t.href||i:i)&&s(t)}function s(t){return e.expr.filters.visible(t)&&!e(t).parents().addBack().filter(function(){return"hidden"===e.css(this,"visibility")}).length}var a=0,n=/^ui-id-\d+$/;e.ui=e.ui||{},e.extend(e.ui,{version:"1.10.3",keyCode:{BACKSPACE:8,COMMA:188,DELETE:46,DOWN:40,END:35,ENTER:13,ESCAPE:27,HOME:36,LEFT:37,NUMPAD_ADD:107,NUMPAD_DECIMAL:110,NUMPAD_DIVIDE:111,NUMPAD_ENTER:108,NUMPAD_MULTIPLY:106,NUMPAD_SUBTRACT:109,PAGE_DOWN:34,PAGE_UP:33,PERIOD:190,RIGHT:39,SPACE:32,TAB:9,UP:38}}),e.fn.extend({focus:function(t){return function(i,s){return"number"==typeof i?this.each(function(){var t=this;setTimeout(function(){e(t).focus(),s&&s.call(t)},i)}):t.apply(this,arguments)}}(e.fn.focus),scrollParent:function(){var t;return t=e.ui.ie&&/(static|relative)/.test(this.css("position"))||/absolute/.test(this.css("position"))?this.parents().filter(function(){return/(relative|absolute|fixed)/.test(e.css(this,"position"))&&/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0):this.parents().filter(function(){return/(auto|scroll)/.test(e.css(this,"overflow")+e.css(this,"overflow-y")+e.css(this,"overflow-x"))}).eq(0),/fixed/.test(this.css("position"))||!t.length?e(document):t},zIndex:function(i){if(i!==t)return this.css("zIndex",i);if(this.length)for(var s,a,n=e(this[0]);n.length&&n[0]!==document;){if(s=n.css("position"),("absolute"===s||"relative"===s||"fixed"===s)&&(a=parseInt(n.css("zIndex"),10),!isNaN(a)&&0!==a))return a;n=n.parent()}return 0},uniqueId:function(){return this.each(function(){this.id||(this.id="ui-id-"+ ++a)})},removeUniqueId:function(){return this.each(function(){n.test(this.id)&&e(this).removeAttr("id")})}}),e.extend(e.expr[":"],{data:e.expr.createPseudo?e.expr.createPseudo(function(t){return function(i){return!!e.data(i,t)}}):function(t,i,s){return!!e.data(t,s[3])},focusable:function(t){return i(t,!isNaN(e.attr(t,"tabindex")))},tabbable:function(t){var s=e.attr(t,"tabindex"),a=isNaN(s);return(a||s>=0)&&i(t,!a)}}),e("<a>").outerWidth(1).jquery||e.each(["Width","Height"],function(i,s){function a(t,i,s,a){return e.each(n,function(){i-=parseFloat(e.css(t,"padding"+this))||0,s&&(i-=parseFloat(e.css(t,"border"+this+"Width"))||0),a&&(i-=parseFloat(e.css(t,"margin"+this))||0)}),i}var n="Width"===s?["Left","Right"]:["Top","Bottom"],r=s.toLowerCase(),o={innerWidth:e.fn.innerWidth,innerHeight:e.fn.innerHeight,outerWidth:e.fn.outerWidth,outerHeight:e.fn.outerHeight};e.fn["inner"+s]=function(i){return i===t?o["inner"+s].call(this):this.each(function(){e(this).css(r,a(this,i)+"px")})},e.fn["outer"+s]=function(t,i){return"number"!=typeof t?o["outer"+s].call(this,t):this.each(function(){e(this).css(r,a(this,t,!0,i)+"px")})}}),e.fn.addBack||(e.fn.addBack=function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}),e("<a>").data("a-b","a").removeData("a-b").data("a-b")&&(e.fn.removeData=function(t){return function(i){return arguments.length?t.call(this,e.camelCase(i)):t.call(this)}}(e.fn.removeData)),e.ui.ie=!!/msie [\w.]+/.exec(navigator.userAgent.toLowerCase()),e.support.selectstart="onselectstart"in document.createElement("div"),e.fn.extend({disableSelection:function(){return this.bind((e.support.selectstart?"selectstart":"mousedown")+".ui-disableSelection",function(e){e.preventDefault()})},enableSelection:function(){return this.unbind(".ui-disableSelection")}}),e.extend(e.ui,{plugin:{add:function(t,i,s){var a,n=e.ui[t].prototype;for(a in s)n.plugins[a]=n.plugins[a]||[],n.plugins[a].push([i,s[a]])},call:function(e,t,i){var s,a=e.plugins[t];if(a&&e.element[0].parentNode&&11!==e.element[0].parentNode.nodeType)for(s=0;a.length>s;s++)e.options[a[s][0]]&&a[s][1].apply(e.element,i)}},hasScroll:function(t,i){if("hidden"===e(t).css("overflow"))return!1;var s=i&&"left"===i?"scrollLeft":"scrollTop",a=!1;return t[s]>0?!0:(t[s]=1,a=t[s]>0,t[s]=0,a)}})})(jQuery);(function(e,t){var i=0,s=Array.prototype.slice,n=e.cleanData;e.cleanData=function(t){for(var i,s=0;null!=(i=t[s]);s++)try{e(i).triggerHandler("remove")}catch(a){}n(t)},e.widget=function(i,s,n){var a,r,o,h,l={},u=i.split(".")[0];i=i.split(".")[1],a=u+"-"+i,n||(n=s,s=e.Widget),e.expr[":"][a.toLowerCase()]=function(t){return!!e.data(t,a)},e[u]=e[u]||{},r=e[u][i],o=e[u][i]=function(e,i){return this._createWidget?(arguments.length&&this._createWidget(e,i),t):new o(e,i)},e.extend(o,r,{version:n.version,_proto:e.extend({},n),_childConstructors:[]}),h=new s,h.options=e.widget.extend({},h.options),e.each(n,function(i,n){return e.isFunction(n)?(l[i]=function(){var e=function(){return s.prototype[i].apply(this,arguments)},t=function(e){return s.prototype[i].apply(this,e)};return function(){var i,s=this._super,a=this._superApply;return this._super=e,this._superApply=t,i=n.apply(this,arguments),this._super=s,this._superApply=a,i}}(),t):(l[i]=n,t)}),o.prototype=e.widget.extend(h,{widgetEventPrefix:r?h.widgetEventPrefix:i},l,{constructor:o,namespace:u,widgetName:i,widgetFullName:a}),r?(e.each(r._childConstructors,function(t,i){var s=i.prototype;e.widget(s.namespace+"."+s.widgetName,o,i._proto)}),delete r._childConstructors):s._childConstructors.push(o),e.widget.bridge(i,o)},e.widget.extend=function(i){for(var n,a,r=s.call(arguments,1),o=0,h=r.length;h>o;o++)for(n in r[o])a=r[o][n],r[o].hasOwnProperty(n)&&a!==t&&(i[n]=e.isPlainObject(a)?e.isPlainObject(i[n])?e.widget.extend({},i[n],a):e.widget.extend({},a):a);return i},e.widget.bridge=function(i,n){var a=n.prototype.widgetFullName||i;e.fn[i]=function(r){var o="string"==typeof r,h=s.call(arguments,1),l=this;return r=!o&&h.length?e.widget.extend.apply(null,[r].concat(h)):r,o?this.each(function(){var s,n=e.data(this,a);return n?e.isFunction(n[r])&&"_"!==r.charAt(0)?(s=n[r].apply(n,h),s!==n&&s!==t?(l=s&&s.jquery?l.pushStack(s.get()):s,!1):t):e.error("no such method '"+r+"' for "+i+" widget instance"):e.error("cannot call methods on "+i+" prior to initialization; "+"attempted to call method '"+r+"'")}):this.each(function(){var t=e.data(this,a);t?t.option(r||{})._init():e.data(this,a,new n(r,this))}),l}},e.Widget=function(){},e.Widget._childConstructors=[],e.Widget.prototype={widgetName:"widget",widgetEventPrefix:"",defaultElement:"<div>",options:{disabled:!1,create:null},_createWidget:function(t,s){s=e(s||this.defaultElement||this)[0],this.element=e(s),this.uuid=i++,this.eventNamespace="."+this.widgetName+this.uuid,this.options=e.widget.extend({},this.options,this._getCreateOptions(),t),this.bindings=e(),this.hoverable=e(),this.focusable=e(),s!==this&&(e.data(s,this.widgetFullName,this),this._on(!0,this.element,{remove:function(e){e.target===s&&this.destroy()}}),this.document=e(s.style?s.ownerDocument:s.document||s),this.window=e(this.document[0].defaultView||this.document[0].parentWindow)),this._create(),this._trigger("create",null,this._getCreateEventData()),this._init()},_getCreateOptions:e.noop,_getCreateEventData:e.noop,_create:e.noop,_init:e.noop,destroy:function(){this._destroy(),this.element.unbind(this.eventNamespace).removeData(this.widgetName).removeData(this.widgetFullName).removeData(e.camelCase(this.widgetFullName)),this.widget().unbind(this.eventNamespace).removeAttr("aria-disabled").removeClass(this.widgetFullName+"-disabled "+"ui-state-disabled"),this.bindings.unbind(this.eventNamespace),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")},_destroy:e.noop,widget:function(){return this.element},option:function(i,s){var n,a,r,o=i;if(0===arguments.length)return e.widget.extend({},this.options);if("string"==typeof i)if(o={},n=i.split("."),i=n.shift(),n.length){for(a=o[i]=e.widget.extend({},this.options[i]),r=0;n.length-1>r;r++)a[n[r]]=a[n[r]]||{},a=a[n[r]];if(i=n.pop(),s===t)return a[i]===t?null:a[i];a[i]=s}else{if(s===t)return this.options[i]===t?null:this.options[i];o[i]=s}return this._setOptions(o),this},_setOptions:function(e){var t;for(t in e)this._setOption(t,e[t]);return this},_setOption:function(e,t){return this.options[e]=t,"disabled"===e&&(this.widget().toggleClass(this.widgetFullName+"-disabled ui-state-disabled",!!t).attr("aria-disabled",t),this.hoverable.removeClass("ui-state-hover"),this.focusable.removeClass("ui-state-focus")),this},enable:function(){return this._setOption("disabled",!1)},disable:function(){return this._setOption("disabled",!0)},_on:function(i,s,n){var a,r=this;"boolean"!=typeof i&&(n=s,s=i,i=!1),n?(s=a=e(s),this.bindings=this.bindings.add(s)):(n=s,s=this.element,a=this.widget()),e.each(n,function(n,o){function h(){return i||r.options.disabled!==!0&&!e(this).hasClass("ui-state-disabled")?("string"==typeof o?r[o]:o).apply(r,arguments):t}"string"!=typeof o&&(h.guid=o.guid=o.guid||h.guid||e.guid++);var l=n.match(/^(\w+)\s*(.*)$/),u=l[1]+r.eventNamespace,c=l[2];c?a.delegate(c,u,h):s.bind(u,h)})},_off:function(e,t){t=(t||"").split(" ").join(this.eventNamespace+" ")+this.eventNamespace,e.unbind(t).undelegate(t)},_delay:function(e,t){function i(){return("string"==typeof e?s[e]:e).apply(s,arguments)}var s=this;return setTimeout(i,t||0)},_hoverable:function(t){this.hoverable=this.hoverable.add(t),this._on(t,{mouseenter:function(t){e(t.currentTarget).addClass("ui-state-hover")},mouseleave:function(t){e(t.currentTarget).removeClass("ui-state-hover")}})},_focusable:function(t){this.focusable=this.focusable.add(t),this._on(t,{focusin:function(t){e(t.currentTarget).addClass("ui-state-focus")},focusout:function(t){e(t.currentTarget).removeClass("ui-state-focus")}})},_trigger:function(t,i,s){var n,a,r=this.options[t];if(s=s||{},i=e.Event(i),i.type=(t===this.widgetEventPrefix?t:this.widgetEventPrefix+t).toLowerCase(),i.target=this.element[0],a=i.originalEvent)for(n in a)n in i||(i[n]=a[n]);return this.element.trigger(i,s),!(e.isFunction(r)&&r.apply(this.element[0],[i].concat(s))===!1||i.isDefaultPrevented())}},e.each({show:"fadeIn",hide:"fadeOut"},function(t,i){e.Widget.prototype["_"+t]=function(s,n,a){"string"==typeof n&&(n={effect:n});var r,o=n?n===!0||"number"==typeof n?i:n.effect||i:t;n=n||{},"number"==typeof n&&(n={duration:n}),r=!e.isEmptyObject(n),n.complete=a,n.delay&&s.delay(n.delay),r&&e.effects&&e.effects.effect[o]?s[t](n):o!==t&&s[o]?s[o](n.duration,n.easing,a):s.queue(function(i){e(this)[t](),a&&a.call(s[0]),i()})}})})(jQuery);(function(e){var t=!1;e(document).mouseup(function(){t=!1}),e.widget("ui.mouse",{version:"1.10.3",options:{cancel:"input,textarea,button,select,option",distance:1,delay:0},_mouseInit:function(){var t=this;this.element.bind("mousedown."+this.widgetName,function(e){return t._mouseDown(e)}).bind("click."+this.widgetName,function(i){return!0===e.data(i.target,t.widgetName+".preventClickEvent")?(e.removeData(i.target,t.widgetName+".preventClickEvent"),i.stopImmediatePropagation(),!1):undefined}),this.started=!1},_mouseDestroy:function(){this.element.unbind("."+this.widgetName),this._mouseMoveDelegate&&e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate)},_mouseDown:function(i){if(!t){this._mouseStarted&&this._mouseUp(i),this._mouseDownEvent=i;var s=this,n=1===i.which,a="string"==typeof this.options.cancel&&i.target.nodeName?e(i.target).closest(this.options.cancel).length:!1;return n&&!a&&this._mouseCapture(i)?(this.mouseDelayMet=!this.options.delay,this.mouseDelayMet||(this._mouseDelayTimer=setTimeout(function(){s.mouseDelayMet=!0},this.options.delay)),this._mouseDistanceMet(i)&&this._mouseDelayMet(i)&&(this._mouseStarted=this._mouseStart(i)!==!1,!this._mouseStarted)?(i.preventDefault(),!0):(!0===e.data(i.target,this.widgetName+".preventClickEvent")&&e.removeData(i.target,this.widgetName+".preventClickEvent"),this._mouseMoveDelegate=function(e){return s._mouseMove(e)},this._mouseUpDelegate=function(e){return s._mouseUp(e)},e(document).bind("mousemove."+this.widgetName,this._mouseMoveDelegate).bind("mouseup."+this.widgetName,this._mouseUpDelegate),i.preventDefault(),t=!0,!0)):!0}},_mouseMove:function(t){return e.ui.ie&&(!document.documentMode||9>document.documentMode)&&!t.button?this._mouseUp(t):this._mouseStarted?(this._mouseDrag(t),t.preventDefault()):(this._mouseDistanceMet(t)&&this._mouseDelayMet(t)&&(this._mouseStarted=this._mouseStart(this._mouseDownEvent,t)!==!1,this._mouseStarted?this._mouseDrag(t):this._mouseUp(t)),!this._mouseStarted)},_mouseUp:function(t){return e(document).unbind("mousemove."+this.widgetName,this._mouseMoveDelegate).unbind("mouseup."+this.widgetName,this._mouseUpDelegate),this._mouseStarted&&(this._mouseStarted=!1,t.target===this._mouseDownEvent.target&&e.data(t.target,this.widgetName+".preventClickEvent",!0),this._mouseStop(t)),!1},_mouseDistanceMet:function(e){return Math.max(Math.abs(this._mouseDownEvent.pageX-e.pageX),Math.abs(this._mouseDownEvent.pageY-e.pageY))>=this.options.distance},_mouseDelayMet:function(){return this.mouseDelayMet},_mouseStart:function(){},_mouseDrag:function(){},_mouseStop:function(){},_mouseCapture:function(){return!0}})})(jQuery);(function(t,e){function i(t,e,i){return[parseFloat(t[0])*(p.test(t[0])?e/100:1),parseFloat(t[1])*(p.test(t[1])?i/100:1)]}function s(e,i){return parseInt(t.css(e,i),10)||0}function n(e){var i=e[0];return 9===i.nodeType?{width:e.width(),height:e.height(),offset:{top:0,left:0}}:t.isWindow(i)?{width:e.width(),height:e.height(),offset:{top:e.scrollTop(),left:e.scrollLeft()}}:i.preventDefault?{width:0,height:0,offset:{top:i.pageY,left:i.pageX}}:{width:e.outerWidth(),height:e.outerHeight(),offset:e.offset()}}t.ui=t.ui||{};var a,o=Math.max,r=Math.abs,h=Math.round,l=/left|center|right/,c=/top|center|bottom/,u=/[\+\-]\d+(\.[\d]+)?%?/,d=/^\w+/,p=/%$/,f=t.fn.position;t.position={scrollbarWidth:function(){if(a!==e)return a;var i,s,n=t("<div style='display:block;width:50px;height:50px;overflow:hidden;'><div style='height:100px;width:auto;'></div></div>"),o=n.children()[0];return t("body").append(n),i=o.offsetWidth,n.css("overflow","scroll"),s=o.offsetWidth,i===s&&(s=n[0].clientWidth),n.remove(),a=i-s},getScrollInfo:function(e){var i=e.isWindow?"":e.element.css("overflow-x"),s=e.isWindow?"":e.element.css("overflow-y"),n="scroll"===i||"auto"===i&&e.width<e.element[0].scrollWidth,a="scroll"===s||"auto"===s&&e.height<e.element[0].scrollHeight;return{width:a?t.position.scrollbarWidth():0,height:n?t.position.scrollbarWidth():0}},getWithinInfo:function(e){var i=t(e||window),s=t.isWindow(i[0]);return{element:i,isWindow:s,offset:i.offset()||{left:0,top:0},scrollLeft:i.scrollLeft(),scrollTop:i.scrollTop(),width:s?i.width():i.outerWidth(),height:s?i.height():i.outerHeight()}}},t.fn.position=function(e){if(!e||!e.of)return f.apply(this,arguments);e=t.extend({},e);var a,p,m,g,v,b,_=t(e.of),y=t.position.getWithinInfo(e.within),w=t.position.getScrollInfo(y),x=(e.collision||"flip").split(" "),k={};return b=n(_),_[0].preventDefault&&(e.at="left top"),p=b.width,m=b.height,g=b.offset,v=t.extend({},g),t.each(["my","at"],function(){var t,i,s=(e[this]||"").split(" ");1===s.length&&(s=l.test(s[0])?s.concat(["center"]):c.test(s[0])?["center"].concat(s):["center","center"]),s[0]=l.test(s[0])?s[0]:"center",s[1]=c.test(s[1])?s[1]:"center",t=u.exec(s[0]),i=u.exec(s[1]),k[this]=[t?t[0]:0,i?i[0]:0],e[this]=[d.exec(s[0])[0],d.exec(s[1])[0]]}),1===x.length&&(x[1]=x[0]),"right"===e.at[0]?v.left+=p:"center"===e.at[0]&&(v.left+=p/2),"bottom"===e.at[1]?v.top+=m:"center"===e.at[1]&&(v.top+=m/2),a=i(k.at,p,m),v.left+=a[0],v.top+=a[1],this.each(function(){var n,l,c=t(this),u=c.outerWidth(),d=c.outerHeight(),f=s(this,"marginLeft"),b=s(this,"marginTop"),D=u+f+s(this,"marginRight")+w.width,T=d+b+s(this,"marginBottom")+w.height,C=t.extend({},v),M=i(k.my,c.outerWidth(),c.outerHeight());"right"===e.my[0]?C.left-=u:"center"===e.my[0]&&(C.left-=u/2),"bottom"===e.my[1]?C.top-=d:"center"===e.my[1]&&(C.top-=d/2),C.left+=M[0],C.top+=M[1],t.support.offsetFractions||(C.left=h(C.left),C.top=h(C.top)),n={marginLeft:f,marginTop:b},t.each(["left","top"],function(i,s){t.ui.position[x[i]]&&t.ui.position[x[i]][s](C,{targetWidth:p,targetHeight:m,elemWidth:u,elemHeight:d,collisionPosition:n,collisionWidth:D,collisionHeight:T,offset:[a[0]+M[0],a[1]+M[1]],my:e.my,at:e.at,within:y,elem:c})}),e.using&&(l=function(t){var i=g.left-C.left,s=i+p-u,n=g.top-C.top,a=n+m-d,h={target:{element:_,left:g.left,top:g.top,width:p,height:m},element:{element:c,left:C.left,top:C.top,width:u,height:d},horizontal:0>s?"left":i>0?"right":"center",vertical:0>a?"top":n>0?"bottom":"middle"};u>p&&p>r(i+s)&&(h.horizontal="center"),d>m&&m>r(n+a)&&(h.vertical="middle"),h.important=o(r(i),r(s))>o(r(n),r(a))?"horizontal":"vertical",e.using.call(this,t,h)}),c.offset(t.extend(C,{using:l}))})},t.ui.position={fit:{left:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollLeft:s.offset.left,a=s.width,r=t.left-e.collisionPosition.marginLeft,h=n-r,l=r+e.collisionWidth-a-n;e.collisionWidth>a?h>0&&0>=l?(i=t.left+h+e.collisionWidth-a-n,t.left+=h-i):t.left=l>0&&0>=h?n:h>l?n+a-e.collisionWidth:n:h>0?t.left+=h:l>0?t.left-=l:t.left=o(t.left-r,t.left)},top:function(t,e){var i,s=e.within,n=s.isWindow?s.scrollTop:s.offset.top,a=e.within.height,r=t.top-e.collisionPosition.marginTop,h=n-r,l=r+e.collisionHeight-a-n;e.collisionHeight>a?h>0&&0>=l?(i=t.top+h+e.collisionHeight-a-n,t.top+=h-i):t.top=l>0&&0>=h?n:h>l?n+a-e.collisionHeight:n:h>0?t.top+=h:l>0?t.top-=l:t.top=o(t.top-r,t.top)}},flip:{left:function(t,e){var i,s,n=e.within,a=n.offset.left+n.scrollLeft,o=n.width,h=n.isWindow?n.scrollLeft:n.offset.left,l=t.left-e.collisionPosition.marginLeft,c=l-h,u=l+e.collisionWidth-o-h,d="left"===e.my[0]?-e.elemWidth:"right"===e.my[0]?e.elemWidth:0,p="left"===e.at[0]?e.targetWidth:"right"===e.at[0]?-e.targetWidth:0,f=-2*e.offset[0];0>c?(i=t.left+d+p+f+e.collisionWidth-o-a,(0>i||r(c)>i)&&(t.left+=d+p+f)):u>0&&(s=t.left-e.collisionPosition.marginLeft+d+p+f-h,(s>0||u>r(s))&&(t.left+=d+p+f))},top:function(t,e){var i,s,n=e.within,a=n.offset.top+n.scrollTop,o=n.height,h=n.isWindow?n.scrollTop:n.offset.top,l=t.top-e.collisionPosition.marginTop,c=l-h,u=l+e.collisionHeight-o-h,d="top"===e.my[1],p=d?-e.elemHeight:"bottom"===e.my[1]?e.elemHeight:0,f="top"===e.at[1]?e.targetHeight:"bottom"===e.at[1]?-e.targetHeight:0,m=-2*e.offset[1];0>c?(s=t.top+p+f+m+e.collisionHeight-o-a,t.top+p+f+m>c&&(0>s||r(c)>s)&&(t.top+=p+f+m)):u>0&&(i=t.top-e.collisionPosition.marginTop+p+f+m-h,t.top+p+f+m>u&&(i>0||u>r(i))&&(t.top+=p+f+m))}},flipfit:{left:function(){t.ui.position.flip.left.apply(this,arguments),t.ui.position.fit.left.apply(this,arguments)},top:function(){t.ui.position.flip.top.apply(this,arguments),t.ui.position.fit.top.apply(this,arguments)}}},function(){var e,i,s,n,a,o=document.getElementsByTagName("body")[0],r=document.createElement("div");e=document.createElement(o?"div":"body"),s={visibility:"hidden",width:0,height:0,border:0,margin:0,background:"none"},o&&t.extend(s,{position:"absolute",left:"-1000px",top:"-1000px"});for(a in s)e.style[a]=s[a];e.appendChild(r),i=o||document.documentElement,i.insertBefore(e,i.firstChild),r.style.cssText="position: absolute; left: 10.7432222px;",n=t(r).offset().left,t.support.offsetFractions=n>10&&11>n,e.innerHTML="",i.removeChild(e)}()})(jQuery);(function(e){e.widget("ui.draggable",e.ui.mouse,{version:"1.10.3",widgetEventPrefix:"drag",options:{addClasses:!0,appendTo:"parent",axis:!1,connectToSortable:!1,containment:!1,cursor:"auto",cursorAt:!1,grid:!1,handle:!1,helper:"original",iframeFix:!1,opacity:!1,refreshPositions:!1,revert:!1,revertDuration:500,scope:"default",scroll:!0,scrollSensitivity:20,scrollSpeed:20,snap:!1,snapMode:"both",snapTolerance:20,stack:!1,zIndex:!1,drag:null,start:null,stop:null},_create:function(){"original"!==this.options.helper||/^(?:r|a|f)/.test(this.element.css("position"))||(this.element[0].style.position="relative"),this.options.addClasses&&this.element.addClass("ui-draggable"),this.options.disabled&&this.element.addClass("ui-draggable-disabled"),this._mouseInit()},_destroy:function(){this.element.removeClass("ui-draggable ui-draggable-dragging ui-draggable-disabled"),this._mouseDestroy()},_mouseCapture:function(t){var i=this.options;return this.helper||i.disabled||e(t.target).closest(".ui-resizable-handle").length>0?!1:(this.handle=this._getHandle(t),this.handle?(e(i.iframeFix===!0?"iframe":i.iframeFix).each(function(){e("<div class='ui-draggable-iframeFix' style='background: #fff;'></div>").css({width:this.offsetWidth+"px",height:this.offsetHeight+"px",position:"absolute",opacity:"0.001",zIndex:1e3}).css(e(this).offset()).appendTo("body")}),!0):!1)},_mouseStart:function(t){var i=this.options;return this.helper=this._createHelper(t),this.helper.addClass("ui-draggable-dragging"),this._cacheHelperProportions(),e.ui.ddmanager&&(e.ui.ddmanager.current=this),this._cacheMargins(),this.cssPosition=this.helper.css("position"),this.scrollParent=this.helper.scrollParent(),this.offsetParent=this.helper.offsetParent(),this.offsetParentCssPosition=this.offsetParent.css("position"),this.offset=this.positionAbs=this.element.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},this.offset.scroll=!1,e.extend(this.offset,{click:{left:t.pageX-this.offset.left,top:t.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.originalPosition=this.position=this._generatePosition(t),this.originalPageX=t.pageX,this.originalPageY=t.pageY,i.cursorAt&&this._adjustOffsetFromHelper(i.cursorAt),this._setContainment(),this._trigger("start",t)===!1?(this._clear(),!1):(this._cacheHelperProportions(),e.ui.ddmanager&&!i.dropBehaviour&&e.ui.ddmanager.prepareOffsets(this,t),this._mouseDrag(t,!0),e.ui.ddmanager&&e.ui.ddmanager.dragStart(this,t),!0)},_mouseDrag:function(t,i){if("fixed"===this.offsetParentCssPosition&&(this.offset.parent=this._getParentOffset()),this.position=this._generatePosition(t),this.positionAbs=this._convertPositionTo("absolute"),!i){var s=this._uiHash();if(this._trigger("drag",t,s)===!1)return this._mouseUp({}),!1;this.position=s.position}return this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),e.ui.ddmanager&&e.ui.ddmanager.drag(this,t),!1},_mouseStop:function(t){var i=this,s=!1;return e.ui.ddmanager&&!this.options.dropBehaviour&&(s=e.ui.ddmanager.drop(this,t)),this.dropped&&(s=this.dropped,this.dropped=!1),"original"!==this.options.helper||e.contains(this.element[0].ownerDocument,this.element[0])?("invalid"===this.options.revert&&!s||"valid"===this.options.revert&&s||this.options.revert===!0||e.isFunction(this.options.revert)&&this.options.revert.call(this.element,s)?e(this.helper).animate(this.originalPosition,parseInt(this.options.revertDuration,10),function(){i._trigger("stop",t)!==!1&&i._clear()}):this._trigger("stop",t)!==!1&&this._clear(),!1):!1},_mouseUp:function(t){return e("div.ui-draggable-iframeFix").each(function(){this.parentNode.removeChild(this)}),e.ui.ddmanager&&e.ui.ddmanager.dragStop(this,t),e.ui.mouse.prototype._mouseUp.call(this,t)},cancel:function(){return this.helper.is(".ui-draggable-dragging")?this._mouseUp({}):this._clear(),this},_getHandle:function(t){return this.options.handle?!!e(t.target).closest(this.element.find(this.options.handle)).length:!0},_createHelper:function(t){var i=this.options,s=e.isFunction(i.helper)?e(i.helper.apply(this.element[0],[t])):"clone"===i.helper?this.element.clone().removeAttr("id"):this.element;return s.parents("body").length||s.appendTo("parent"===i.appendTo?this.element[0].parentNode:i.appendTo),s[0]===this.element[0]||/(fixed|absolute)/.test(s.css("position"))||s.css("position","absolute"),s},_adjustOffsetFromHelper:function(t){"string"==typeof t&&(t=t.split(" ")),e.isArray(t)&&(t={left:+t[0],top:+t[1]||0}),"left"in t&&(this.offset.click.left=t.left+this.margins.left),"right"in t&&(this.offset.click.left=this.helperProportions.width-t.right+this.margins.left),"top"in t&&(this.offset.click.top=t.top+this.margins.top),"bottom"in t&&(this.offset.click.top=this.helperProportions.height-t.bottom+this.margins.top)},_getParentOffset:function(){var t=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==document&&e.contains(this.scrollParent[0],this.offsetParent[0])&&(t.left+=this.scrollParent.scrollLeft(),t.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&e.ui.ie)&&(t={top:0,left:0}),{top:t.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:t.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var e=this.element.position();return{top:e.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:e.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.element.css("marginLeft"),10)||0,top:parseInt(this.element.css("marginTop"),10)||0,right:parseInt(this.element.css("marginRight"),10)||0,bottom:parseInt(this.element.css("marginBottom"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var t,i,s,n=this.options;return n.containment?"window"===n.containment?(this.containment=[e(window).scrollLeft()-this.offset.relative.left-this.offset.parent.left,e(window).scrollTop()-this.offset.relative.top-this.offset.parent.top,e(window).scrollLeft()+e(window).width()-this.helperProportions.width-this.margins.left,e(window).scrollTop()+(e(window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],undefined):"document"===n.containment?(this.containment=[0,0,e(document).width()-this.helperProportions.width-this.margins.left,(e(document).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top],undefined):n.containment.constructor===Array?(this.containment=n.containment,undefined):("parent"===n.containment&&(n.containment=this.helper[0].parentNode),i=e(n.containment),s=i[0],s&&(t="hidden"!==i.css("overflow"),this.containment=[(parseInt(i.css("borderLeftWidth"),10)||0)+(parseInt(i.css("paddingLeft"),10)||0),(parseInt(i.css("borderTopWidth"),10)||0)+(parseInt(i.css("paddingTop"),10)||0),(t?Math.max(s.scrollWidth,s.offsetWidth):s.offsetWidth)-(parseInt(i.css("borderRightWidth"),10)||0)-(parseInt(i.css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left-this.margins.right,(t?Math.max(s.scrollHeight,s.offsetHeight):s.offsetHeight)-(parseInt(i.css("borderBottomWidth"),10)||0)-(parseInt(i.css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top-this.margins.bottom],this.relative_container=i),undefined):(this.containment=null,undefined)},_convertPositionTo:function(t,i){i||(i=this.position);var s="absolute"===t?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent;return this.offset.scroll||(this.offset.scroll={top:n.scrollTop(),left:n.scrollLeft()}),{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():this.offset.scroll.top)*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():this.offset.scroll.left)*s}},_generatePosition:function(t){var i,s,n,a,o=this.options,r="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&e.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,h=t.pageX,l=t.pageY;return this.offset.scroll||(this.offset.scroll={top:r.scrollTop(),left:r.scrollLeft()}),this.originalPosition&&(this.containment&&(this.relative_container?(s=this.relative_container.offset(),i=[this.containment[0]+s.left,this.containment[1]+s.top,this.containment[2]+s.left,this.containment[3]+s.top]):i=this.containment,t.pageX-this.offset.click.left<i[0]&&(h=i[0]+this.offset.click.left),t.pageY-this.offset.click.top<i[1]&&(l=i[1]+this.offset.click.top),t.pageX-this.offset.click.left>i[2]&&(h=i[2]+this.offset.click.left),t.pageY-this.offset.click.top>i[3]&&(l=i[3]+this.offset.click.top)),o.grid&&(n=o.grid[1]?this.originalPageY+Math.round((l-this.originalPageY)/o.grid[1])*o.grid[1]:this.originalPageY,l=i?n-this.offset.click.top>=i[1]||n-this.offset.click.top>i[3]?n:n-this.offset.click.top>=i[1]?n-o.grid[1]:n+o.grid[1]:n,a=o.grid[0]?this.originalPageX+Math.round((h-this.originalPageX)/o.grid[0])*o.grid[0]:this.originalPageX,h=i?a-this.offset.click.left>=i[0]||a-this.offset.click.left>i[2]?a:a-this.offset.click.left>=i[0]?a-o.grid[0]:a+o.grid[0]:a)),{top:l-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():this.offset.scroll.top),left:h-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():this.offset.scroll.left)}},_clear:function(){this.helper.removeClass("ui-draggable-dragging"),this.helper[0]===this.element[0]||this.cancelHelperRemoval||this.helper.remove(),this.helper=null,this.cancelHelperRemoval=!1},_trigger:function(t,i,s){return s=s||this._uiHash(),e.ui.plugin.call(this,t,[i,s]),"drag"===t&&(this.positionAbs=this._convertPositionTo("absolute")),e.Widget.prototype._trigger.call(this,t,i,s)},plugins:{},_uiHash:function(){return{helper:this.helper,position:this.position,originalPosition:this.originalPosition,offset:this.positionAbs}}}),e.ui.plugin.add("draggable","connectToSortable",{start:function(t,i){var s=e(this).data("ui-draggable"),n=s.options,a=e.extend({},i,{item:s.element});s.sortables=[],e(n.connectToSortable).each(function(){var i=e.data(this,"ui-sortable");i&&!i.options.disabled&&(s.sortables.push({instance:i,shouldRevert:i.options.revert}),i.refreshPositions(),i._trigger("activate",t,a))})},stop:function(t,i){var s=e(this).data("ui-draggable"),n=e.extend({},i,{item:s.element});e.each(s.sortables,function(){this.instance.isOver?(this.instance.isOver=0,s.cancelHelperRemoval=!0,this.instance.cancelHelperRemoval=!1,this.shouldRevert&&(this.instance.options.revert=this.shouldRevert),this.instance._mouseStop(t),this.instance.options.helper=this.instance.options._helper,"original"===s.options.helper&&this.instance.currentItem.css({top:"auto",left:"auto"})):(this.instance.cancelHelperRemoval=!1,this.instance._trigger("deactivate",t,n))})},drag:function(t,i){var s=e(this).data("ui-draggable"),n=this;e.each(s.sortables,function(){var a=!1,o=this;this.instance.positionAbs=s.positionAbs,this.instance.helperProportions=s.helperProportions,this.instance.offset.click=s.offset.click,this.instance._intersectsWith(this.instance.containerCache)&&(a=!0,e.each(s.sortables,function(){return this.instance.positionAbs=s.positionAbs,this.instance.helperProportions=s.helperProportions,this.instance.offset.click=s.offset.click,this!==o&&this.instance._intersectsWith(this.instance.containerCache)&&e.contains(o.instance.element[0],this.instance.element[0])&&(a=!1),a})),a?(this.instance.isOver||(this.instance.isOver=1,this.instance.currentItem=e(n).clone().removeAttr("id").appendTo(this.instance.element).data("ui-sortable-item",!0),this.instance.options._helper=this.instance.options.helper,this.instance.options.helper=function(){return i.helper[0]},t.target=this.instance.currentItem[0],this.instance._mouseCapture(t,!0),this.instance._mouseStart(t,!0,!0),this.instance.offset.click.top=s.offset.click.top,this.instance.offset.click.left=s.offset.click.left,this.instance.offset.parent.left-=s.offset.parent.left-this.instance.offset.parent.left,this.instance.offset.parent.top-=s.offset.parent.top-this.instance.offset.parent.top,s._trigger("toSortable",t),s.dropped=this.instance.element,s.currentItem=s.element,this.instance.fromOutside=s),this.instance.currentItem&&this.instance._mouseDrag(t)):this.instance.isOver&&(this.instance.isOver=0,this.instance.cancelHelperRemoval=!0,this.instance.options.revert=!1,this.instance._trigger("out",t,this.instance._uiHash(this.instance)),this.instance._mouseStop(t,!0),this.instance.options.helper=this.instance.options._helper,this.instance.currentItem.remove(),this.instance.placeholder&&this.instance.placeholder.remove(),s._trigger("fromSortable",t),s.dropped=!1)})}}),e.ui.plugin.add("draggable","cursor",{start:function(){var t=e("body"),i=e(this).data("ui-draggable").options;t.css("cursor")&&(i._cursor=t.css("cursor")),t.css("cursor",i.cursor)},stop:function(){var t=e(this).data("ui-draggable").options;t._cursor&&e("body").css("cursor",t._cursor)}}),e.ui.plugin.add("draggable","opacity",{start:function(t,i){var s=e(i.helper),n=e(this).data("ui-draggable").options;s.css("opacity")&&(n._opacity=s.css("opacity")),s.css("opacity",n.opacity)},stop:function(t,i){var s=e(this).data("ui-draggable").options;s._opacity&&e(i.helper).css("opacity",s._opacity)}}),e.ui.plugin.add("draggable","scroll",{start:function(){var t=e(this).data("ui-draggable");t.scrollParent[0]!==document&&"HTML"!==t.scrollParent[0].tagName&&(t.overflowOffset=t.scrollParent.offset())},drag:function(t){var i=e(this).data("ui-draggable"),s=i.options,n=!1;i.scrollParent[0]!==document&&"HTML"!==i.scrollParent[0].tagName?(s.axis&&"x"===s.axis||(i.overflowOffset.top+i.scrollParent[0].offsetHeight-t.pageY<s.scrollSensitivity?i.scrollParent[0].scrollTop=n=i.scrollParent[0].scrollTop+s.scrollSpeed:t.pageY-i.overflowOffset.top<s.scrollSensitivity&&(i.scrollParent[0].scrollTop=n=i.scrollParent[0].scrollTop-s.scrollSpeed)),s.axis&&"y"===s.axis||(i.overflowOffset.left+i.scrollParent[0].offsetWidth-t.pageX<s.scrollSensitivity?i.scrollParent[0].scrollLeft=n=i.scrollParent[0].scrollLeft+s.scrollSpeed:t.pageX-i.overflowOffset.left<s.scrollSensitivity&&(i.scrollParent[0].scrollLeft=n=i.scrollParent[0].scrollLeft-s.scrollSpeed))):(s.axis&&"x"===s.axis||(t.pageY-e(document).scrollTop()<s.scrollSensitivity?n=e(document).scrollTop(e(document).scrollTop()-s.scrollSpeed):e(window).height()-(t.pageY-e(document).scrollTop())<s.scrollSensitivity&&(n=e(document).scrollTop(e(document).scrollTop()+s.scrollSpeed))),s.axis&&"y"===s.axis||(t.pageX-e(document).scrollLeft()<s.scrollSensitivity?n=e(document).scrollLeft(e(document).scrollLeft()-s.scrollSpeed):e(window).width()-(t.pageX-e(document).scrollLeft())<s.scrollSensitivity&&(n=e(document).scrollLeft(e(document).scrollLeft()+s.scrollSpeed)))),n!==!1&&e.ui.ddmanager&&!s.dropBehaviour&&e.ui.ddmanager.prepareOffsets(i,t)}}),e.ui.plugin.add("draggable","snap",{start:function(){var t=e(this).data("ui-draggable"),i=t.options;t.snapElements=[],e(i.snap.constructor!==String?i.snap.items||":data(ui-draggable)":i.snap).each(function(){var i=e(this),s=i.offset();this!==t.element[0]&&t.snapElements.push({item:this,width:i.outerWidth(),height:i.outerHeight(),top:s.top,left:s.left})})},drag:function(t,i){var s,n,a,o,r,h,l,u,c,d,p=e(this).data("ui-draggable"),f=p.options,m=f.snapTolerance,g=i.offset.left,v=g+p.helperProportions.width,b=i.offset.top,y=b+p.helperProportions.height;for(c=p.snapElements.length-1;c>=0;c--)r=p.snapElements[c].left,h=r+p.snapElements[c].width,l=p.snapElements[c].top,u=l+p.snapElements[c].height,r-m>v||g>h+m||l-m>y||b>u+m||!e.contains(p.snapElements[c].item.ownerDocument,p.snapElements[c].item)?(p.snapElements[c].snapping&&p.options.snap.release&&p.options.snap.release.call(p.element,t,e.extend(p._uiHash(),{snapItem:p.snapElements[c].item})),p.snapElements[c].snapping=!1):("inner"!==f.snapMode&&(s=m>=Math.abs(l-y),n=m>=Math.abs(u-b),a=m>=Math.abs(r-v),o=m>=Math.abs(h-g),s&&(i.position.top=p._convertPositionTo("relative",{top:l-p.helperProportions.height,left:0}).top-p.margins.top),n&&(i.position.top=p._convertPositionTo("relative",{top:u,left:0}).top-p.margins.top),a&&(i.position.left=p._convertPositionTo("relative",{top:0,left:r-p.helperProportions.width}).left-p.margins.left),o&&(i.position.left=p._convertPositionTo("relative",{top:0,left:h}).left-p.margins.left)),d=s||n||a||o,"outer"!==f.snapMode&&(s=m>=Math.abs(l-b),n=m>=Math.abs(u-y),a=m>=Math.abs(r-g),o=m>=Math.abs(h-v),s&&(i.position.top=p._convertPositionTo("relative",{top:l,left:0}).top-p.margins.top),n&&(i.position.top=p._convertPositionTo("relative",{top:u-p.helperProportions.height,left:0}).top-p.margins.top),a&&(i.position.left=p._convertPositionTo("relative",{top:0,left:r}).left-p.margins.left),o&&(i.position.left=p._convertPositionTo("relative",{top:0,left:h-p.helperProportions.width}).left-p.margins.left)),!p.snapElements[c].snapping&&(s||n||a||o||d)&&p.options.snap.snap&&p.options.snap.snap.call(p.element,t,e.extend(p._uiHash(),{snapItem:p.snapElements[c].item})),p.snapElements[c].snapping=s||n||a||o||d)}}),e.ui.plugin.add("draggable","stack",{start:function(){var t,i=this.data("ui-draggable").options,s=e.makeArray(e(i.stack)).sort(function(t,i){return(parseInt(e(t).css("zIndex"),10)||0)-(parseInt(e(i).css("zIndex"),10)||0)});s.length&&(t=parseInt(e(s[0]).css("zIndex"),10)||0,e(s).each(function(i){e(this).css("zIndex",t+i)}),this.css("zIndex",t+s.length))}}),e.ui.plugin.add("draggable","zIndex",{start:function(t,i){var s=e(i.helper),n=e(this).data("ui-draggable").options;s.css("zIndex")&&(n._zIndex=s.css("zIndex")),s.css("zIndex",n.zIndex)},stop:function(t,i){var s=e(this).data("ui-draggable").options;s._zIndex&&e(i.helper).css("zIndex",s._zIndex)}})})(jQuery);(function(e){function t(e,t,i){return e>t&&t+i>e}e.widget("ui.droppable",{version:"1.10.3",widgetEventPrefix:"drop",options:{accept:"*",activeClass:!1,addClasses:!0,greedy:!1,hoverClass:!1,scope:"default",tolerance:"intersect",activate:null,deactivate:null,drop:null,out:null,over:null},_create:function(){var t=this.options,i=t.accept;this.isover=!1,this.isout=!0,this.accept=e.isFunction(i)?i:function(e){return e.is(i)},this.proportions={width:this.element[0].offsetWidth,height:this.element[0].offsetHeight},e.ui.ddmanager.droppables[t.scope]=e.ui.ddmanager.droppables[t.scope]||[],e.ui.ddmanager.droppables[t.scope].push(this),t.addClasses&&this.element.addClass("ui-droppable")},_destroy:function(){for(var t=0,i=e.ui.ddmanager.droppables[this.options.scope];i.length>t;t++)i[t]===this&&i.splice(t,1);this.element.removeClass("ui-droppable ui-droppable-disabled")},_setOption:function(t,i){"accept"===t&&(this.accept=e.isFunction(i)?i:function(e){return e.is(i)}),e.Widget.prototype._setOption.apply(this,arguments)},_activate:function(t){var i=e.ui.ddmanager.current;this.options.activeClass&&this.element.addClass(this.options.activeClass),i&&this._trigger("activate",t,this.ui(i))},_deactivate:function(t){var i=e.ui.ddmanager.current;this.options.activeClass&&this.element.removeClass(this.options.activeClass),i&&this._trigger("deactivate",t,this.ui(i))},_over:function(t){var i=e.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.addClass(this.options.hoverClass),this._trigger("over",t,this.ui(i)))},_out:function(t){var i=e.ui.ddmanager.current;i&&(i.currentItem||i.element)[0]!==this.element[0]&&this.accept.call(this.element[0],i.currentItem||i.element)&&(this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("out",t,this.ui(i)))},_drop:function(t,i){var s=i||e.ui.ddmanager.current,n=!1;return s&&(s.currentItem||s.element)[0]!==this.element[0]?(this.element.find(":data(ui-droppable)").not(".ui-draggable-dragging").each(function(){var t=e.data(this,"ui-droppable");return t.options.greedy&&!t.options.disabled&&t.options.scope===s.options.scope&&t.accept.call(t.element[0],s.currentItem||s.element)&&e.ui.intersect(s,e.extend(t,{offset:t.element.offset()}),t.options.tolerance)?(n=!0,!1):undefined}),n?!1:this.accept.call(this.element[0],s.currentItem||s.element)?(this.options.activeClass&&this.element.removeClass(this.options.activeClass),this.options.hoverClass&&this.element.removeClass(this.options.hoverClass),this._trigger("drop",t,this.ui(s)),this.element):!1):!1},ui:function(e){return{draggable:e.currentItem||e.element,helper:e.helper,position:e.position,offset:e.positionAbs}}}),e.ui.intersect=function(e,i,s){if(!i.offset)return!1;var n,a,o=(e.positionAbs||e.position.absolute).left,r=o+e.helperProportions.width,h=(e.positionAbs||e.position.absolute).top,l=h+e.helperProportions.height,u=i.offset.left,c=u+i.proportions.width,d=i.offset.top,p=d+i.proportions.height;switch(s){case"fit":return o>=u&&c>=r&&h>=d&&p>=l;case"intersect":return o+e.helperProportions.width/2>u&&c>r-e.helperProportions.width/2&&h+e.helperProportions.height/2>d&&p>l-e.helperProportions.height/2;case"pointer":return n=(e.positionAbs||e.position.absolute).left+(e.clickOffset||e.offset.click).left,a=(e.positionAbs||e.position.absolute).top+(e.clickOffset||e.offset.click).top,t(a,d,i.proportions.height)&&t(n,u,i.proportions.width);case"touch":return(h>=d&&p>=h||l>=d&&p>=l||d>h&&l>p)&&(o>=u&&c>=o||r>=u&&c>=r||u>o&&r>c);default:return!1}},e.ui.ddmanager={current:null,droppables:{"default":[]},prepareOffsets:function(t,i){var s,n,a=e.ui.ddmanager.droppables[t.options.scope]||[],o=i?i.type:null,r=(t.currentItem||t.element).find(":data(ui-droppable)").addBack();e:for(s=0;a.length>s;s++)if(!(a[s].options.disabled||t&&!a[s].accept.call(a[s].element[0],t.currentItem||t.element))){for(n=0;r.length>n;n++)if(r[n]===a[s].element[0]){a[s].proportions.height=0;continue e}a[s].visible="none"!==a[s].element.css("display"),a[s].visible&&("mousedown"===o&&a[s]._activate.call(a[s],i),a[s].offset=a[s].element.offset(),a[s].proportions={width:a[s].element[0].offsetWidth,height:a[s].element[0].offsetHeight})}},drop:function(t,i){var s=!1;return e.each((e.ui.ddmanager.droppables[t.options.scope]||[]).slice(),function(){this.options&&(!this.options.disabled&&this.visible&&e.ui.intersect(t,this,this.options.tolerance)&&(s=this._drop.call(this,i)||s),!this.options.disabled&&this.visible&&this.accept.call(this.element[0],t.currentItem||t.element)&&(this.isout=!0,this.isover=!1,this._deactivate.call(this,i)))}),s},dragStart:function(t,i){t.element.parentsUntil("body").bind("scroll.droppable",function(){t.options.refreshPositions||e.ui.ddmanager.prepareOffsets(t,i)})},drag:function(t,i){t.options.refreshPositions&&e.ui.ddmanager.prepareOffsets(t,i),e.each(e.ui.ddmanager.droppables[t.options.scope]||[],function(){if(!this.options.disabled&&!this.greedyChild&&this.visible){var s,n,a,o=e.ui.intersect(t,this,this.options.tolerance),r=!o&&this.isover?"isout":o&&!this.isover?"isover":null;r&&(this.options.greedy&&(n=this.options.scope,a=this.element.parents(":data(ui-droppable)").filter(function(){return e.data(this,"ui-droppable").options.scope===n}),a.length&&(s=e.data(a[0],"ui-droppable"),s.greedyChild="isover"===r)),s&&"isover"===r&&(s.isover=!1,s.isout=!0,s._out.call(s,i)),this[r]=!0,this["isout"===r?"isover":"isout"]=!1,this["isover"===r?"_over":"_out"].call(this,i),s&&"isout"===r&&(s.isout=!1,s.isover=!0,s._over.call(s,i)))}})},dragStop:function(t,i){t.element.parentsUntil("body").unbind("scroll.droppable"),t.options.refreshPositions||e.ui.ddmanager.prepareOffsets(t,i)}}})(jQuery);(function(e){function t(e){return parseInt(e,10)||0}function i(e){return!isNaN(parseInt(e,10))}e.widget("ui.resizable",e.ui.mouse,{version:"1.10.3",widgetEventPrefix:"resize",options:{alsoResize:!1,animate:!1,animateDuration:"slow",animateEasing:"swing",aspectRatio:!1,autoHide:!1,containment:!1,ghost:!1,grid:!1,handles:"e,s,se",helper:!1,maxHeight:null,maxWidth:null,minHeight:10,minWidth:10,zIndex:90,resize:null,start:null,stop:null},_create:function(){var t,i,s,n,a,o=this,r=this.options;if(this.element.addClass("ui-resizable"),e.extend(this,{_aspectRatio:!!r.aspectRatio,aspectRatio:r.aspectRatio,originalElement:this.element,_proportionallyResizeElements:[],_helper:r.helper||r.ghost||r.animate?r.helper||"ui-resizable-helper":null}),this.element[0].nodeName.match(/canvas|textarea|input|select|button|img/i)&&(this.element.wrap(e("<div class='ui-wrapper' style='overflow: hidden;'></div>").css({position:this.element.css("position"),width:this.element.outerWidth(),height:this.element.outerHeight(),top:this.element.css("top"),left:this.element.css("left")})),this.element=this.element.parent().data("ui-resizable",this.element.data("ui-resizable")),this.elementIsWrapper=!0,this.element.css({marginLeft:this.originalElement.css("marginLeft"),marginTop:this.originalElement.css("marginTop"),marginRight:this.originalElement.css("marginRight"),marginBottom:this.originalElement.css("marginBottom")}),this.originalElement.css({marginLeft:0,marginTop:0,marginRight:0,marginBottom:0}),this.originalResizeStyle=this.originalElement.css("resize"),this.originalElement.css("resize","none"),this._proportionallyResizeElements.push(this.originalElement.css({position:"static",zoom:1,display:"block"})),this.originalElement.css({margin:this.originalElement.css("margin")}),this._proportionallyResize()),this.handles=r.handles||(e(".ui-resizable-handle",this.element).length?{n:".ui-resizable-n",e:".ui-resizable-e",s:".ui-resizable-s",w:".ui-resizable-w",se:".ui-resizable-se",sw:".ui-resizable-sw",ne:".ui-resizable-ne",nw:".ui-resizable-nw"}:"e,s,se"),this.handles.constructor===String)for("all"===this.handles&&(this.handles="n,e,s,w,se,sw,ne,nw"),t=this.handles.split(","),this.handles={},i=0;t.length>i;i++)s=e.trim(t[i]),a="ui-resizable-"+s,n=e("<div class='ui-resizable-handle "+a+"'></div>"),n.css({zIndex:r.zIndex}),"se"===s&&n.addClass("ui-icon ui-icon-gripsmall-diagonal-se"),this.handles[s]=".ui-resizable-"+s,this.element.append(n);this._renderAxis=function(t){var i,s,n,a;t=t||this.element;for(i in this.handles)this.handles[i].constructor===String&&(this.handles[i]=e(this.handles[i],this.element).show()),this.elementIsWrapper&&this.originalElement[0].nodeName.match(/textarea|input|select|button/i)&&(s=e(this.handles[i],this.element),a=/sw|ne|nw|se|n|s/.test(i)?s.outerHeight():s.outerWidth(),n=["padding",/ne|nw|n/.test(i)?"Top":/se|sw|s/.test(i)?"Bottom":/^e$/.test(i)?"Right":"Left"].join(""),t.css(n,a),this._proportionallyResize()),e(this.handles[i]).length},this._renderAxis(this.element),this._handles=e(".ui-resizable-handle",this.element).disableSelection(),this._handles.mouseover(function(){o.resizing||(this.className&&(n=this.className.match(/ui-resizable-(se|sw|ne|nw|n|e|s|w)/i)),o.axis=n&&n[1]?n[1]:"se")}),r.autoHide&&(this._handles.hide(),e(this.element).addClass("ui-resizable-autohide").mouseenter(function(){r.disabled||(e(this).removeClass("ui-resizable-autohide"),o._handles.show())}).mouseleave(function(){r.disabled||o.resizing||(e(this).addClass("ui-resizable-autohide"),o._handles.hide())})),this._mouseInit()},_destroy:function(){this._mouseDestroy();var t,i=function(t){e(t).removeClass("ui-resizable ui-resizable-disabled ui-resizable-resizing").removeData("resizable").removeData("ui-resizable").unbind(".resizable").find(".ui-resizable-handle").remove()};return this.elementIsWrapper&&(i(this.element),t=this.element,this.originalElement.css({position:t.css("position"),width:t.outerWidth(),height:t.outerHeight(),top:t.css("top"),left:t.css("left")}).insertAfter(t),t.remove()),this.originalElement.css("resize",this.originalResizeStyle),i(this.originalElement),this},_mouseCapture:function(t){var i,s,n=!1;for(i in this.handles)s=e(this.handles[i])[0],(s===t.target||e.contains(s,t.target))&&(n=!0);return!this.options.disabled&&n},_mouseStart:function(i){var s,n,a,o=this.options,r=this.element.position(),h=this.element;return this.resizing=!0,/absolute/.test(h.css("position"))?h.css({position:"absolute",top:h.css("top"),left:h.css("left")}):h.is(".ui-draggable")&&h.css({position:"absolute",top:r.top,left:r.left}),this._renderProxy(),s=t(this.helper.css("left")),n=t(this.helper.css("top")),o.containment&&(s+=e(o.containment).scrollLeft()||0,n+=e(o.containment).scrollTop()||0),this.offset=this.helper.offset(),this.position={left:s,top:n},this.size=this._helper?{width:h.outerWidth(),height:h.outerHeight()}:{width:h.width(),height:h.height()},this.originalSize=this._helper?{width:h.outerWidth(),height:h.outerHeight()}:{width:h.width(),height:h.height()},this.originalPosition={left:s,top:n},this.sizeDiff={width:h.outerWidth()-h.width(),height:h.outerHeight()-h.height()},this.originalMousePosition={left:i.pageX,top:i.pageY},this.aspectRatio="number"==typeof o.aspectRatio?o.aspectRatio:this.originalSize.width/this.originalSize.height||1,a=e(".ui-resizable-"+this.axis).css("cursor"),e("body").css("cursor","auto"===a?this.axis+"-resize":a),h.addClass("ui-resizable-resizing"),this._propagate("start",i),!0},_mouseDrag:function(t){var i,s=this.helper,n={},a=this.originalMousePosition,o=this.axis,r=this.position.top,h=this.position.left,l=this.size.width,u=this.size.height,c=t.pageX-a.left||0,d=t.pageY-a.top||0,p=this._change[o];return p?(i=p.apply(this,[t,c,d]),this._updateVirtualBoundaries(t.shiftKey),(this._aspectRatio||t.shiftKey)&&(i=this._updateRatio(i,t)),i=this._respectSize(i,t),this._updateCache(i),this._propagate("resize",t),this.position.top!==r&&(n.top=this.position.top+"px"),this.position.left!==h&&(n.left=this.position.left+"px"),this.size.width!==l&&(n.width=this.size.width+"px"),this.size.height!==u&&(n.height=this.size.height+"px"),s.css(n),!this._helper&&this._proportionallyResizeElements.length&&this._proportionallyResize(),e.isEmptyObject(n)||this._trigger("resize",t,this.ui()),!1):!1},_mouseStop:function(t){this.resizing=!1;var i,s,n,a,o,r,h,l=this.options,u=this;return this._helper&&(i=this._proportionallyResizeElements,s=i.length&&/textarea/i.test(i[0].nodeName),n=s&&e.ui.hasScroll(i[0],"left")?0:u.sizeDiff.height,a=s?0:u.sizeDiff.width,o={width:u.helper.width()-a,height:u.helper.height()-n},r=parseInt(u.element.css("left"),10)+(u.position.left-u.originalPosition.left)||null,h=parseInt(u.element.css("top"),10)+(u.position.top-u.originalPosition.top)||null,l.animate||this.element.css(e.extend(o,{top:h,left:r})),u.helper.height(u.size.height),u.helper.width(u.size.width),this._helper&&!l.animate&&this._proportionallyResize()),e("body").css("cursor","auto"),this.element.removeClass("ui-resizable-resizing"),this._propagate("stop",t),this._helper&&this.helper.remove(),!1},_updateVirtualBoundaries:function(e){var t,s,n,a,o,r=this.options;o={minWidth:i(r.minWidth)?r.minWidth:0,maxWidth:i(r.maxWidth)?r.maxWidth:1/0,minHeight:i(r.minHeight)?r.minHeight:0,maxHeight:i(r.maxHeight)?r.maxHeight:1/0},(this._aspectRatio||e)&&(t=o.minHeight*this.aspectRatio,n=o.minWidth/this.aspectRatio,s=o.maxHeight*this.aspectRatio,a=o.maxWidth/this.aspectRatio,t>o.minWidth&&(o.minWidth=t),n>o.minHeight&&(o.minHeight=n),o.maxWidth>s&&(o.maxWidth=s),o.maxHeight>a&&(o.maxHeight=a)),this._vBoundaries=o},_updateCache:function(e){this.offset=this.helper.offset(),i(e.left)&&(this.position.left=e.left),i(e.top)&&(this.position.top=e.top),i(e.height)&&(this.size.height=e.height),i(e.width)&&(this.size.width=e.width)},_updateRatio:function(e){var t=this.position,s=this.size,n=this.axis;return i(e.height)?e.width=e.height*this.aspectRatio:i(e.width)&&(e.height=e.width/this.aspectRatio),"sw"===n&&(e.left=t.left+(s.width-e.width),e.top=null),"nw"===n&&(e.top=t.top+(s.height-e.height),e.left=t.left+(s.width-e.width)),e},_respectSize:function(e){var t=this._vBoundaries,s=this.axis,n=i(e.width)&&t.maxWidth&&t.maxWidth<e.width,a=i(e.height)&&t.maxHeight&&t.maxHeight<e.height,o=i(e.width)&&t.minWidth&&t.minWidth>e.width,r=i(e.height)&&t.minHeight&&t.minHeight>e.height,h=this.originalPosition.left+this.originalSize.width,l=this.position.top+this.size.height,u=/sw|nw|w/.test(s),c=/nw|ne|n/.test(s);return o&&(e.width=t.minWidth),r&&(e.height=t.minHeight),n&&(e.width=t.maxWidth),a&&(e.height=t.maxHeight),o&&u&&(e.left=h-t.minWidth),n&&u&&(e.left=h-t.maxWidth),r&&c&&(e.top=l-t.minHeight),a&&c&&(e.top=l-t.maxHeight),e.width||e.height||e.left||!e.top?e.width||e.height||e.top||!e.left||(e.left=null):e.top=null,e},_proportionallyResize:function(){if(this._proportionallyResizeElements.length){var e,t,i,s,n,a=this.helper||this.element;for(e=0;this._proportionallyResizeElements.length>e;e++){if(n=this._proportionallyResizeElements[e],!this.borderDif)for(this.borderDif=[],i=[n.css("borderTopWidth"),n.css("borderRightWidth"),n.css("borderBottomWidth"),n.css("borderLeftWidth")],s=[n.css("paddingTop"),n.css("paddingRight"),n.css("paddingBottom"),n.css("paddingLeft")],t=0;i.length>t;t++)this.borderDif[t]=(parseInt(i[t],10)||0)+(parseInt(s[t],10)||0);n.css({height:a.height()-this.borderDif[0]-this.borderDif[2]||0,width:a.width()-this.borderDif[1]-this.borderDif[3]||0})}}},_renderProxy:function(){var t=this.element,i=this.options;this.elementOffset=t.offset(),this._helper?(this.helper=this.helper||e("<div style='overflow:hidden;'></div>"),this.helper.addClass(this._helper).css({width:this.element.outerWidth()-1,height:this.element.outerHeight()-1,position:"absolute",left:this.elementOffset.left+"px",top:this.elementOffset.top+"px",zIndex:++i.zIndex}),this.helper.appendTo("body").disableSelection()):this.helper=this.element},_change:{e:function(e,t){return{width:this.originalSize.width+t}},w:function(e,t){var i=this.originalSize,s=this.originalPosition;return{left:s.left+t,width:i.width-t}},n:function(e,t,i){var s=this.originalSize,n=this.originalPosition;return{top:n.top+i,height:s.height-i}},s:function(e,t,i){return{height:this.originalSize.height+i}},se:function(t,i,s){return e.extend(this._change.s.apply(this,arguments),this._change.e.apply(this,[t,i,s]))},sw:function(t,i,s){return e.extend(this._change.s.apply(this,arguments),this._change.w.apply(this,[t,i,s]))},ne:function(t,i,s){return e.extend(this._change.n.apply(this,arguments),this._change.e.apply(this,[t,i,s]))},nw:function(t,i,s){return e.extend(this._change.n.apply(this,arguments),this._change.w.apply(this,[t,i,s]))}},_propagate:function(t,i){e.ui.plugin.call(this,t,[i,this.ui()]),"resize"!==t&&this._trigger(t,i,this.ui())},plugins:{},ui:function(){return{originalElement:this.originalElement,element:this.element,helper:this.helper,position:this.position,size:this.size,originalSize:this.originalSize,originalPosition:this.originalPosition}}}),e.ui.plugin.add("resizable","animate",{stop:function(t){var i=e(this).data("ui-resizable"),s=i.options,n=i._proportionallyResizeElements,a=n.length&&/textarea/i.test(n[0].nodeName),o=a&&e.ui.hasScroll(n[0],"left")?0:i.sizeDiff.height,r=a?0:i.sizeDiff.width,h={width:i.size.width-r,height:i.size.height-o},l=parseInt(i.element.css("left"),10)+(i.position.left-i.originalPosition.left)||null,u=parseInt(i.element.css("top"),10)+(i.position.top-i.originalPosition.top)||null;i.element.animate(e.extend(h,u&&l?{top:u,left:l}:{}),{duration:s.animateDuration,easing:s.animateEasing,step:function(){var s={width:parseInt(i.element.css("width"),10),height:parseInt(i.element.css("height"),10),top:parseInt(i.element.css("top"),10),left:parseInt(i.element.css("left"),10)};n&&n.length&&e(n[0]).css({width:s.width,height:s.height}),i._updateCache(s),i._propagate("resize",t)}})}}),e.ui.plugin.add("resizable","containment",{start:function(){var i,s,n,a,o,r,h,l=e(this).data("ui-resizable"),u=l.options,c=l.element,d=u.containment,p=d instanceof e?d.get(0):/parent/.test(d)?c.parent().get(0):d;p&&(l.containerElement=e(p),/document/.test(d)||d===document?(l.containerOffset={left:0,top:0},l.containerPosition={left:0,top:0},l.parentData={element:e(document),left:0,top:0,width:e(document).width(),height:e(document).height()||document.body.parentNode.scrollHeight}):(i=e(p),s=[],e(["Top","Right","Left","Bottom"]).each(function(e,n){s[e]=t(i.css("padding"+n))}),l.containerOffset=i.offset(),l.containerPosition=i.position(),l.containerSize={height:i.innerHeight()-s[3],width:i.innerWidth()-s[1]},n=l.containerOffset,a=l.containerSize.height,o=l.containerSize.width,r=e.ui.hasScroll(p,"left")?p.scrollWidth:o,h=e.ui.hasScroll(p)?p.scrollHeight:a,l.parentData={element:p,left:n.left,top:n.top,width:r,height:h}))},resize:function(t){var i,s,n,a,o=e(this).data("ui-resizable"),r=o.options,h=o.containerOffset,l=o.position,u=o._aspectRatio||t.shiftKey,c={top:0,left:0},d=o.containerElement;d[0]!==document&&/static/.test(d.css("position"))&&(c=h),l.left<(o._helper?h.left:0)&&(o.size.width=o.size.width+(o._helper?o.position.left-h.left:o.position.left-c.left),u&&(o.size.height=o.size.width/o.aspectRatio),o.position.left=r.helper?h.left:0),l.top<(o._helper?h.top:0)&&(o.size.height=o.size.height+(o._helper?o.position.top-h.top:o.position.top),u&&(o.size.width=o.size.height*o.aspectRatio),o.position.top=o._helper?h.top:0),o.offset.left=o.parentData.left+o.position.left,o.offset.top=o.parentData.top+o.position.top,i=Math.abs((o._helper?o.offset.left-c.left:o.offset.left-c.left)+o.sizeDiff.width),s=Math.abs((o._helper?o.offset.top-c.top:o.offset.top-h.top)+o.sizeDiff.height),n=o.containerElement.get(0)===o.element.parent().get(0),a=/relative|absolute/.test(o.containerElement.css("position")),n&&a&&(i-=o.parentData.left),i+o.size.width>=o.parentData.width&&(o.size.width=o.parentData.width-i,u&&(o.size.height=o.size.width/o.aspectRatio)),s+o.size.height>=o.parentData.height&&(o.size.height=o.parentData.height-s,u&&(o.size.width=o.size.height*o.aspectRatio))},stop:function(){var t=e(this).data("ui-resizable"),i=t.options,s=t.containerOffset,n=t.containerPosition,a=t.containerElement,o=e(t.helper),r=o.offset(),h=o.outerWidth()-t.sizeDiff.width,l=o.outerHeight()-t.sizeDiff.height;t._helper&&!i.animate&&/relative/.test(a.css("position"))&&e(this).css({left:r.left-n.left-s.left,width:h,height:l}),t._helper&&!i.animate&&/static/.test(a.css("position"))&&e(this).css({left:r.left-n.left-s.left,width:h,height:l})}}),e.ui.plugin.add("resizable","alsoResize",{start:function(){var t=e(this).data("ui-resizable"),i=t.options,s=function(t){e(t).each(function(){var t=e(this);t.data("ui-resizable-alsoresize",{width:parseInt(t.width(),10),height:parseInt(t.height(),10),left:parseInt(t.css("left"),10),top:parseInt(t.css("top"),10)})})};"object"!=typeof i.alsoResize||i.alsoResize.parentNode?s(i.alsoResize):i.alsoResize.length?(i.alsoResize=i.alsoResize[0],s(i.alsoResize)):e.each(i.alsoResize,function(e){s(e)})},resize:function(t,i){var s=e(this).data("ui-resizable"),n=s.options,a=s.originalSize,o=s.originalPosition,r={height:s.size.height-a.height||0,width:s.size.width-a.width||0,top:s.position.top-o.top||0,left:s.position.left-o.left||0},h=function(t,s){e(t).each(function(){var t=e(this),n=e(this).data("ui-resizable-alsoresize"),a={},o=s&&s.length?s:t.parents(i.originalElement[0]).length?["width","height"]:["width","height","top","left"];e.each(o,function(e,t){var i=(n[t]||0)+(r[t]||0);i&&i>=0&&(a[t]=i||null)}),t.css(a)})};"object"!=typeof n.alsoResize||n.alsoResize.nodeType?h(n.alsoResize):e.each(n.alsoResize,function(e,t){h(e,t)})},stop:function(){e(this).removeData("resizable-alsoresize")}}),e.ui.plugin.add("resizable","ghost",{start:function(){var t=e(this).data("ui-resizable"),i=t.options,s=t.size;t.ghost=t.originalElement.clone(),t.ghost.css({opacity:.25,display:"block",position:"relative",height:s.height,width:s.width,margin:0,left:0,top:0}).addClass("ui-resizable-ghost").addClass("string"==typeof i.ghost?i.ghost:""),t.ghost.appendTo(t.helper)},resize:function(){var t=e(this).data("ui-resizable");t.ghost&&t.ghost.css({position:"relative",height:t.size.height,width:t.size.width})},stop:function(){var t=e(this).data("ui-resizable");t.ghost&&t.helper&&t.helper.get(0).removeChild(t.ghost.get(0))}}),e.ui.plugin.add("resizable","grid",{resize:function(){var t=e(this).data("ui-resizable"),i=t.options,s=t.size,n=t.originalSize,a=t.originalPosition,o=t.axis,r="number"==typeof i.grid?[i.grid,i.grid]:i.grid,h=r[0]||1,l=r[1]||1,u=Math.round((s.width-n.width)/h)*h,c=Math.round((s.height-n.height)/l)*l,d=n.width+u,p=n.height+c,f=i.maxWidth&&d>i.maxWidth,m=i.maxHeight&&p>i.maxHeight,g=i.minWidth&&i.minWidth>d,v=i.minHeight&&i.minHeight>p;i.grid=r,g&&(d+=h),v&&(p+=l),f&&(d-=h),m&&(p-=l),/^(se|s|e)$/.test(o)?(t.size.width=d,t.size.height=p):/^(ne)$/.test(o)?(t.size.width=d,t.size.height=p,t.position.top=a.top-c):/^(sw)$/.test(o)?(t.size.width=d,t.size.height=p,t.position.left=a.left-u):(t.size.width=d,t.size.height=p,t.position.top=a.top-c,t.position.left=a.left-u)}})})(jQuery);(function(e){e.widget("ui.selectable",e.ui.mouse,{version:"1.10.3",options:{appendTo:"body",autoRefresh:!0,distance:0,filter:"*",tolerance:"touch",selected:null,selecting:null,start:null,stop:null,unselected:null,unselecting:null},_create:function(){var t,i=this;this.element.addClass("ui-selectable"),this.dragged=!1,this.refresh=function(){t=e(i.options.filter,i.element[0]),t.addClass("ui-selectee"),t.each(function(){var t=e(this),i=t.offset();e.data(this,"selectable-item",{element:this,$element:t,left:i.left,top:i.top,right:i.left+t.outerWidth(),bottom:i.top+t.outerHeight(),startselected:!1,selected:t.hasClass("ui-selected"),selecting:t.hasClass("ui-selecting"),unselecting:t.hasClass("ui-unselecting")})})},this.refresh(),this.selectees=t.addClass("ui-selectee"),this._mouseInit(),this.helper=e("<div class='ui-selectable-helper'></div>")},_destroy:function(){this.selectees.removeClass("ui-selectee").removeData("selectable-item"),this.element.removeClass("ui-selectable ui-selectable-disabled"),this._mouseDestroy()},_mouseStart:function(t){var i=this,s=this.options;this.opos=[t.pageX,t.pageY],this.options.disabled||(this.selectees=e(s.filter,this.element[0]),this._trigger("start",t),e(s.appendTo).append(this.helper),this.helper.css({left:t.pageX,top:t.pageY,width:0,height:0}),s.autoRefresh&&this.refresh(),this.selectees.filter(".ui-selected").each(function(){var s=e.data(this,"selectable-item");s.startselected=!0,t.metaKey||t.ctrlKey||(s.$element.removeClass("ui-selected"),s.selected=!1,s.$element.addClass("ui-unselecting"),s.unselecting=!0,i._trigger("unselecting",t,{unselecting:s.element}))}),e(t.target).parents().addBack().each(function(){var s,n=e.data(this,"selectable-item");return n?(s=!t.metaKey&&!t.ctrlKey||!n.$element.hasClass("ui-selected"),n.$element.removeClass(s?"ui-unselecting":"ui-selected").addClass(s?"ui-selecting":"ui-unselecting"),n.unselecting=!s,n.selecting=s,n.selected=s,s?i._trigger("selecting",t,{selecting:n.element}):i._trigger("unselecting",t,{unselecting:n.element}),!1):undefined}))},_mouseDrag:function(t){if(this.dragged=!0,!this.options.disabled){var i,s=this,n=this.options,a=this.opos[0],o=this.opos[1],r=t.pageX,h=t.pageY;return a>r&&(i=r,r=a,a=i),o>h&&(i=h,h=o,o=i),this.helper.css({left:a,top:o,width:r-a,height:h-o}),this.selectees.each(function(){var i=e.data(this,"selectable-item"),l=!1;i&&i.element!==s.element[0]&&("touch"===n.tolerance?l=!(i.left>r||a>i.right||i.top>h||o>i.bottom):"fit"===n.tolerance&&(l=i.left>a&&r>i.right&&i.top>o&&h>i.bottom),l?(i.selected&&(i.$element.removeClass("ui-selected"),i.selected=!1),i.unselecting&&(i.$element.removeClass("ui-unselecting"),i.unselecting=!1),i.selecting||(i.$element.addClass("ui-selecting"),i.selecting=!0,s._trigger("selecting",t,{selecting:i.element}))):(i.selecting&&((t.metaKey||t.ctrlKey)&&i.startselected?(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.$element.addClass("ui-selected"),i.selected=!0):(i.$element.removeClass("ui-selecting"),i.selecting=!1,i.startselected&&(i.$element.addClass("ui-unselecting"),i.unselecting=!0),s._trigger("unselecting",t,{unselecting:i.element}))),i.selected&&(t.metaKey||t.ctrlKey||i.startselected||(i.$element.removeClass("ui-selected"),i.selected=!1,i.$element.addClass("ui-unselecting"),i.unselecting=!0,s._trigger("unselecting",t,{unselecting:i.element})))))}),!1}},_mouseStop:function(t){var i=this;return this.dragged=!1,e(".ui-unselecting",this.element[0]).each(function(){var s=e.data(this,"selectable-item");s.$element.removeClass("ui-unselecting"),s.unselecting=!1,s.startselected=!1,i._trigger("unselected",t,{unselected:s.element})}),e(".ui-selecting",this.element[0]).each(function(){var s=e.data(this,"selectable-item");s.$element.removeClass("ui-selecting").addClass("ui-selected"),s.selecting=!1,s.selected=!0,s.startselected=!0,i._trigger("selected",t,{selected:s.element})}),this._trigger("stop",t),this.helper.remove(),!1}})})(jQuery);(function(t){function e(t,e,i){return t>e&&e+i>t}function i(t){return/left|right/.test(t.css("float"))||/inline|table-cell/.test(t.css("display"))}t.widget("ui.sortable",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"sort",ready:!1,options:{appendTo:"parent",axis:!1,connectWith:!1,containment:!1,cursor:"auto",cursorAt:!1,dropOnEmpty:!0,forcePlaceholderSize:!1,forceHelperSize:!1,grid:!1,handle:!1,helper:"original",items:"> *",opacity:!1,placeholder:!1,revert:!1,scroll:!0,scrollSensitivity:20,scrollSpeed:20,scope:"default",tolerance:"intersect",zIndex:1e3,activate:null,beforeStop:null,change:null,deactivate:null,out:null,over:null,receive:null,remove:null,sort:null,start:null,stop:null,update:null},_create:function(){var t=this.options;this.containerCache={},this.element.addClass("ui-sortable"),this.refresh(),this.floating=this.items.length?"x"===t.axis||i(this.items[0].item):!1,this.offset=this.element.offset(),this._mouseInit(),this.ready=!0},_destroy:function(){this.element.removeClass("ui-sortable ui-sortable-disabled"),this._mouseDestroy();for(var t=this.items.length-1;t>=0;t--)this.items[t].item.removeData(this.widgetName+"-item");return this},_setOption:function(e,i){"disabled"===e?(this.options[e]=i,this.widget().toggleClass("ui-sortable-disabled",!!i)):t.Widget.prototype._setOption.apply(this,arguments)},_mouseCapture:function(e,i){var s=null,n=!1,a=this;return this.reverting?!1:this.options.disabled||"static"===this.options.type?!1:(this._refreshItems(e),t(e.target).parents().each(function(){return t.data(this,a.widgetName+"-item")===a?(s=t(this),!1):undefined}),t.data(e.target,a.widgetName+"-item")===a&&(s=t(e.target)),s?!this.options.handle||i||(t(this.options.handle,s).find("*").addBack().each(function(){this===e.target&&(n=!0)}),n)?(this.currentItem=s,this._removeCurrentsFromItems(),!0):!1:!1)},_mouseStart:function(e,i,s){var n,a,o=this.options;if(this.currentContainer=this,this.refreshPositions(),this.helper=this._createHelper(e),this._cacheHelperProportions(),this._cacheMargins(),this.scrollParent=this.helper.scrollParent(),this.offset=this.currentItem.offset(),this.offset={top:this.offset.top-this.margins.top,left:this.offset.left-this.margins.left},t.extend(this.offset,{click:{left:e.pageX-this.offset.left,top:e.pageY-this.offset.top},parent:this._getParentOffset(),relative:this._getRelativeOffset()}),this.helper.css("position","absolute"),this.cssPosition=this.helper.css("position"),this.originalPosition=this._generatePosition(e),this.originalPageX=e.pageX,this.originalPageY=e.pageY,o.cursorAt&&this._adjustOffsetFromHelper(o.cursorAt),this.domPosition={prev:this.currentItem.prev()[0],parent:this.currentItem.parent()[0]},this.helper[0]!==this.currentItem[0]&&this.currentItem.hide(),this._createPlaceholder(),o.containment&&this._setContainment(),o.cursor&&"auto"!==o.cursor&&(a=this.document.find("body"),this.storedCursor=a.css("cursor"),a.css("cursor",o.cursor),this.storedStylesheet=t("<style>*{ cursor: "+o.cursor+" !important; }</style>").appendTo(a)),o.opacity&&(this.helper.css("opacity")&&(this._storedOpacity=this.helper.css("opacity")),this.helper.css("opacity",o.opacity)),o.zIndex&&(this.helper.css("zIndex")&&(this._storedZIndex=this.helper.css("zIndex")),this.helper.css("zIndex",o.zIndex)),this.scrollParent[0]!==document&&"HTML"!==this.scrollParent[0].tagName&&(this.overflowOffset=this.scrollParent.offset()),this._trigger("start",e,this._uiHash()),this._preserveHelperProportions||this._cacheHelperProportions(),!s)for(n=this.containers.length-1;n>=0;n--)this.containers[n]._trigger("activate",e,this._uiHash(this));return t.ui.ddmanager&&(t.ui.ddmanager.current=this),t.ui.ddmanager&&!o.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e),this.dragging=!0,this.helper.addClass("ui-sortable-helper"),this._mouseDrag(e),!0},_mouseDrag:function(e){var i,s,n,a,o=this.options,r=!1;for(this.position=this._generatePosition(e),this.positionAbs=this._convertPositionTo("absolute"),this.lastPositionAbs||(this.lastPositionAbs=this.positionAbs),this.options.scroll&&(this.scrollParent[0]!==document&&"HTML"!==this.scrollParent[0].tagName?(this.overflowOffset.top+this.scrollParent[0].offsetHeight-e.pageY<o.scrollSensitivity?this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop+o.scrollSpeed:e.pageY-this.overflowOffset.top<o.scrollSensitivity&&(this.scrollParent[0].scrollTop=r=this.scrollParent[0].scrollTop-o.scrollSpeed),this.overflowOffset.left+this.scrollParent[0].offsetWidth-e.pageX<o.scrollSensitivity?this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft+o.scrollSpeed:e.pageX-this.overflowOffset.left<o.scrollSensitivity&&(this.scrollParent[0].scrollLeft=r=this.scrollParent[0].scrollLeft-o.scrollSpeed)):(e.pageY-t(document).scrollTop()<o.scrollSensitivity?r=t(document).scrollTop(t(document).scrollTop()-o.scrollSpeed):t(window).height()-(e.pageY-t(document).scrollTop())<o.scrollSensitivity&&(r=t(document).scrollTop(t(document).scrollTop()+o.scrollSpeed)),e.pageX-t(document).scrollLeft()<o.scrollSensitivity?r=t(document).scrollLeft(t(document).scrollLeft()-o.scrollSpeed):t(window).width()-(e.pageX-t(document).scrollLeft())<o.scrollSensitivity&&(r=t(document).scrollLeft(t(document).scrollLeft()+o.scrollSpeed))),r!==!1&&t.ui.ddmanager&&!o.dropBehaviour&&t.ui.ddmanager.prepareOffsets(this,e)),this.positionAbs=this._convertPositionTo("absolute"),this.options.axis&&"y"===this.options.axis||(this.helper[0].style.left=this.position.left+"px"),this.options.axis&&"x"===this.options.axis||(this.helper[0].style.top=this.position.top+"px"),i=this.items.length-1;i>=0;i--)if(s=this.items[i],n=s.item[0],a=this._intersectsWithPointer(s),a&&s.instance===this.currentContainer&&n!==this.currentItem[0]&&this.placeholder[1===a?"next":"prev"]()[0]!==n&&!t.contains(this.placeholder[0],n)&&("semi-dynamic"===this.options.type?!t.contains(this.element[0],n):!0)){if(this.direction=1===a?"down":"up","pointer"!==this.options.tolerance&&!this._intersectsWithSides(s))break;this._rearrange(e,s),this._trigger("change",e,this._uiHash());break}return this._contactContainers(e),t.ui.ddmanager&&t.ui.ddmanager.drag(this,e),this._trigger("sort",e,this._uiHash()),this.lastPositionAbs=this.positionAbs,!1},_mouseStop:function(e,i){if(e){if(t.ui.ddmanager&&!this.options.dropBehaviour&&t.ui.ddmanager.drop(this,e),this.options.revert){var s=this,n=this.placeholder.offset(),a=this.options.axis,o={};a&&"x"!==a||(o.left=n.left-this.offset.parent.left-this.margins.left+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollLeft)),a&&"y"!==a||(o.top=n.top-this.offset.parent.top-this.margins.top+(this.offsetParent[0]===document.body?0:this.offsetParent[0].scrollTop)),this.reverting=!0,t(this.helper).animate(o,parseInt(this.options.revert,10)||500,function(){s._clear(e)})}else this._clear(e,i);return!1}},cancel:function(){if(this.dragging){this._mouseUp({target:null}),"original"===this.options.helper?this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper"):this.currentItem.show();for(var e=this.containers.length-1;e>=0;e--)this.containers[e]._trigger("deactivate",null,this._uiHash(this)),this.containers[e].containerCache.over&&(this.containers[e]._trigger("out",null,this._uiHash(this)),this.containers[e].containerCache.over=0)}return this.placeholder&&(this.placeholder[0].parentNode&&this.placeholder[0].parentNode.removeChild(this.placeholder[0]),"original"!==this.options.helper&&this.helper&&this.helper[0].parentNode&&this.helper.remove(),t.extend(this,{helper:null,dragging:!1,reverting:!1,_noFinalSort:null}),this.domPosition.prev?t(this.domPosition.prev).after(this.currentItem):t(this.domPosition.parent).prepend(this.currentItem)),this},serialize:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},t(i).each(function(){var i=(t(e.item||this).attr(e.attribute||"id")||"").match(e.expression||/(.+)[\-=_](.+)/);i&&s.push((e.key||i[1]+"[]")+"="+(e.key&&e.expression?i[1]:i[2]))}),!s.length&&e.key&&s.push(e.key+"="),s.join("&")},toArray:function(e){var i=this._getItemsAsjQuery(e&&e.connected),s=[];return e=e||{},i.each(function(){s.push(t(e.item||this).attr(e.attribute||"id")||"")}),s},_intersectsWith:function(t){var e=this.positionAbs.left,i=e+this.helperProportions.width,s=this.positionAbs.top,n=s+this.helperProportions.height,a=t.left,o=a+t.width,r=t.top,h=r+t.height,l=this.offset.click.top,c=this.offset.click.left,u="x"===this.options.axis||s+l>r&&h>s+l,d="y"===this.options.axis||e+c>a&&o>e+c,p=u&&d;return"pointer"===this.options.tolerance||this.options.forcePointerForContainers||"pointer"!==this.options.tolerance&&this.helperProportions[this.floating?"width":"height"]>t[this.floating?"width":"height"]?p:e+this.helperProportions.width/2>a&&o>i-this.helperProportions.width/2&&s+this.helperProportions.height/2>r&&h>n-this.helperProportions.height/2},_intersectsWithPointer:function(t){var i="x"===this.options.axis||e(this.positionAbs.top+this.offset.click.top,t.top,t.height),s="y"===this.options.axis||e(this.positionAbs.left+this.offset.click.left,t.left,t.width),n=i&&s,a=this._getDragVerticalDirection(),o=this._getDragHorizontalDirection();return n?this.floating?o&&"right"===o||"down"===a?2:1:a&&("down"===a?2:1):!1},_intersectsWithSides:function(t){var i=e(this.positionAbs.top+this.offset.click.top,t.top+t.height/2,t.height),s=e(this.positionAbs.left+this.offset.click.left,t.left+t.width/2,t.width),n=this._getDragVerticalDirection(),a=this._getDragHorizontalDirection();return this.floating&&a?"right"===a&&s||"left"===a&&!s:n&&("down"===n&&i||"up"===n&&!i)},_getDragVerticalDirection:function(){var t=this.positionAbs.top-this.lastPositionAbs.top;return 0!==t&&(t>0?"down":"up")},_getDragHorizontalDirection:function(){var t=this.positionAbs.left-this.lastPositionAbs.left;return 0!==t&&(t>0?"right":"left")},refresh:function(t){return this._refreshItems(t),this.refreshPositions(),this},_connectWith:function(){var t=this.options;return t.connectWith.constructor===String?[t.connectWith]:t.connectWith},_getItemsAsjQuery:function(e){var i,s,n,a,o=[],r=[],h=this._connectWith();if(h&&e)for(i=h.length-1;i>=0;i--)for(n=t(h[i]),s=n.length-1;s>=0;s--)a=t.data(n[s],this.widgetFullName),a&&a!==this&&!a.options.disabled&&r.push([t.isFunction(a.options.items)?a.options.items.call(a.element):t(a.options.items,a.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),a]);for(r.push([t.isFunction(this.options.items)?this.options.items.call(this.element,null,{options:this.options,item:this.currentItem}):t(this.options.items,this.element).not(".ui-sortable-helper").not(".ui-sortable-placeholder"),this]),i=r.length-1;i>=0;i--)r[i][0].each(function(){o.push(this)});return t(o)},_removeCurrentsFromItems:function(){var e=this.currentItem.find(":data("+this.widgetName+"-item)");this.items=t.grep(this.items,function(t){for(var i=0;e.length>i;i++)if(e[i]===t.item[0])return!1;return!0})},_refreshItems:function(e){this.items=[],this.containers=[this];var i,s,n,a,o,r,h,l,c=this.items,u=[[t.isFunction(this.options.items)?this.options.items.call(this.element[0],e,{item:this.currentItem}):t(this.options.items,this.element),this]],d=this._connectWith();if(d&&this.ready)for(i=d.length-1;i>=0;i--)for(n=t(d[i]),s=n.length-1;s>=0;s--)a=t.data(n[s],this.widgetFullName),a&&a!==this&&!a.options.disabled&&(u.push([t.isFunction(a.options.items)?a.options.items.call(a.element[0],e,{item:this.currentItem}):t(a.options.items,a.element),a]),this.containers.push(a));for(i=u.length-1;i>=0;i--)for(o=u[i][1],r=u[i][0],s=0,l=r.length;l>s;s++)h=t(r[s]),h.data(this.widgetName+"-item",o),c.push({item:h,instance:o,width:0,height:0,left:0,top:0})},refreshPositions:function(e){this.offsetParent&&this.helper&&(this.offset.parent=this._getParentOffset());var i,s,n,a;for(i=this.items.length-1;i>=0;i--)s=this.items[i],s.instance!==this.currentContainer&&this.currentContainer&&s.item[0]!==this.currentItem[0]||(n=this.options.toleranceElement?t(this.options.toleranceElement,s.item):s.item,e||(s.width=n.outerWidth(),s.height=n.outerHeight()),a=n.offset(),s.left=a.left,s.top=a.top);if(this.options.custom&&this.options.custom.refreshContainers)this.options.custom.refreshContainers.call(this);else for(i=this.containers.length-1;i>=0;i--)a=this.containers[i].element.offset(),this.containers[i].containerCache.left=a.left,this.containers[i].containerCache.top=a.top,this.containers[i].containerCache.width=this.containers[i].element.outerWidth(),this.containers[i].containerCache.height=this.containers[i].element.outerHeight();return this},_createPlaceholder:function(e){e=e||this;var i,s=e.options;s.placeholder&&s.placeholder.constructor!==String||(i=s.placeholder,s.placeholder={element:function(){var s=e.currentItem[0].nodeName.toLowerCase(),n=t("<"+s+">",e.document[0]).addClass(i||e.currentItem[0].className+" ui-sortable-placeholder").removeClass("ui-sortable-helper");return"tr"===s?e.currentItem.children().each(function(){t("<td>&#160;</td>",e.document[0]).attr("colspan",t(this).attr("colspan")||1).appendTo(n)}):"img"===s&&n.attr("src",e.currentItem.attr("src")),i||n.css("visibility","hidden"),n},update:function(t,n){(!i||s.forcePlaceholderSize)&&(n.height()||n.height(e.currentItem.innerHeight()-parseInt(e.currentItem.css("paddingTop")||0,10)-parseInt(e.currentItem.css("paddingBottom")||0,10)),n.width()||n.width(e.currentItem.innerWidth()-parseInt(e.currentItem.css("paddingLeft")||0,10)-parseInt(e.currentItem.css("paddingRight")||0,10)))}}),e.placeholder=t(s.placeholder.element.call(e.element,e.currentItem)),e.currentItem.after(e.placeholder),s.placeholder.update(e,e.placeholder)},_contactContainers:function(s){var n,a,o,r,h,l,c,u,d,p,f=null,m=null;for(n=this.containers.length-1;n>=0;n--)if(!t.contains(this.currentItem[0],this.containers[n].element[0]))if(this._intersectsWith(this.containers[n].containerCache)){if(f&&t.contains(this.containers[n].element[0],f.element[0]))continue;f=this.containers[n],m=n}else this.containers[n].containerCache.over&&(this.containers[n]._trigger("out",s,this._uiHash(this)),this.containers[n].containerCache.over=0);if(f)if(1===this.containers.length)this.containers[m].containerCache.over||(this.containers[m]._trigger("over",s,this._uiHash(this)),this.containers[m].containerCache.over=1);else{for(o=1e4,r=null,p=f.floating||i(this.currentItem),h=p?"left":"top",l=p?"width":"height",c=this.positionAbs[h]+this.offset.click[h],a=this.items.length-1;a>=0;a--)t.contains(this.containers[m].element[0],this.items[a].item[0])&&this.items[a].item[0]!==this.currentItem[0]&&(!p||e(this.positionAbs.top+this.offset.click.top,this.items[a].top,this.items[a].height))&&(u=this.items[a].item.offset()[h],d=!1,Math.abs(u-c)>Math.abs(u+this.items[a][l]-c)&&(d=!0,u+=this.items[a][l]),o>Math.abs(u-c)&&(o=Math.abs(u-c),r=this.items[a],this.direction=d?"up":"down"));if(!r&&!this.options.dropOnEmpty)return;if(this.currentContainer===this.containers[m])return;r?this._rearrange(s,r,null,!0):this._rearrange(s,null,this.containers[m].element,!0),this._trigger("change",s,this._uiHash()),this.containers[m]._trigger("change",s,this._uiHash(this)),this.currentContainer=this.containers[m],this.options.placeholder.update(this.currentContainer,this.placeholder),this.containers[m]._trigger("over",s,this._uiHash(this)),this.containers[m].containerCache.over=1}},_createHelper:function(e){var i=this.options,s=t.isFunction(i.helper)?t(i.helper.apply(this.element[0],[e,this.currentItem])):"clone"===i.helper?this.currentItem.clone():this.currentItem;return s.parents("body").length||t("parent"!==i.appendTo?i.appendTo:this.currentItem[0].parentNode)[0].appendChild(s[0]),s[0]===this.currentItem[0]&&(this._storedCSS={width:this.currentItem[0].style.width,height:this.currentItem[0].style.height,position:this.currentItem.css("position"),top:this.currentItem.css("top"),left:this.currentItem.css("left")}),(!s[0].style.width||i.forceHelperSize)&&s.width(this.currentItem.width()),(!s[0].style.height||i.forceHelperSize)&&s.height(this.currentItem.height()),s},_adjustOffsetFromHelper:function(e){"string"==typeof e&&(e=e.split(" ")),t.isArray(e)&&(e={left:+e[0],top:+e[1]||0}),"left"in e&&(this.offset.click.left=e.left+this.margins.left),"right"in e&&(this.offset.click.left=this.helperProportions.width-e.right+this.margins.left),"top"in e&&(this.offset.click.top=e.top+this.margins.top),"bottom"in e&&(this.offset.click.top=this.helperProportions.height-e.bottom+this.margins.top)},_getParentOffset:function(){this.offsetParent=this.helper.offsetParent();var e=this.offsetParent.offset();return"absolute"===this.cssPosition&&this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])&&(e.left+=this.scrollParent.scrollLeft(),e.top+=this.scrollParent.scrollTop()),(this.offsetParent[0]===document.body||this.offsetParent[0].tagName&&"html"===this.offsetParent[0].tagName.toLowerCase()&&t.ui.ie)&&(e={top:0,left:0}),{top:e.top+(parseInt(this.offsetParent.css("borderTopWidth"),10)||0),left:e.left+(parseInt(this.offsetParent.css("borderLeftWidth"),10)||0)}},_getRelativeOffset:function(){if("relative"===this.cssPosition){var t=this.currentItem.position();return{top:t.top-(parseInt(this.helper.css("top"),10)||0)+this.scrollParent.scrollTop(),left:t.left-(parseInt(this.helper.css("left"),10)||0)+this.scrollParent.scrollLeft()}}return{top:0,left:0}},_cacheMargins:function(){this.margins={left:parseInt(this.currentItem.css("marginLeft"),10)||0,top:parseInt(this.currentItem.css("marginTop"),10)||0}},_cacheHelperProportions:function(){this.helperProportions={width:this.helper.outerWidth(),height:this.helper.outerHeight()}},_setContainment:function(){var e,i,s,n=this.options;"parent"===n.containment&&(n.containment=this.helper[0].parentNode),("document"===n.containment||"window"===n.containment)&&(this.containment=[0-this.offset.relative.left-this.offset.parent.left,0-this.offset.relative.top-this.offset.parent.top,t("document"===n.containment?document:window).width()-this.helperProportions.width-this.margins.left,(t("document"===n.containment?document:window).height()||document.body.parentNode.scrollHeight)-this.helperProportions.height-this.margins.top]),/^(document|window|parent)$/.test(n.containment)||(e=t(n.containment)[0],i=t(n.containment).offset(),s="hidden"!==t(e).css("overflow"),this.containment=[i.left+(parseInt(t(e).css("borderLeftWidth"),10)||0)+(parseInt(t(e).css("paddingLeft"),10)||0)-this.margins.left,i.top+(parseInt(t(e).css("borderTopWidth"),10)||0)+(parseInt(t(e).css("paddingTop"),10)||0)-this.margins.top,i.left+(s?Math.max(e.scrollWidth,e.offsetWidth):e.offsetWidth)-(parseInt(t(e).css("borderLeftWidth"),10)||0)-(parseInt(t(e).css("paddingRight"),10)||0)-this.helperProportions.width-this.margins.left,i.top+(s?Math.max(e.scrollHeight,e.offsetHeight):e.offsetHeight)-(parseInt(t(e).css("borderTopWidth"),10)||0)-(parseInt(t(e).css("paddingBottom"),10)||0)-this.helperProportions.height-this.margins.top])},_convertPositionTo:function(e,i){i||(i=this.position);var s="absolute"===e?1:-1,n="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,a=/(html|body)/i.test(n[0].tagName);return{top:i.top+this.offset.relative.top*s+this.offset.parent.top*s-("fixed"===this.cssPosition?-this.scrollParent.scrollTop():a?0:n.scrollTop())*s,left:i.left+this.offset.relative.left*s+this.offset.parent.left*s-("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():a?0:n.scrollLeft())*s}},_generatePosition:function(e){var i,s,n=this.options,a=e.pageX,o=e.pageY,r="absolute"!==this.cssPosition||this.scrollParent[0]!==document&&t.contains(this.scrollParent[0],this.offsetParent[0])?this.scrollParent:this.offsetParent,h=/(html|body)/i.test(r[0].tagName);return"relative"!==this.cssPosition||this.scrollParent[0]!==document&&this.scrollParent[0]!==this.offsetParent[0]||(this.offset.relative=this._getRelativeOffset()),this.originalPosition&&(this.containment&&(e.pageX-this.offset.click.left<this.containment[0]&&(a=this.containment[0]+this.offset.click.left),e.pageY-this.offset.click.top<this.containment[1]&&(o=this.containment[1]+this.offset.click.top),e.pageX-this.offset.click.left>this.containment[2]&&(a=this.containment[2]+this.offset.click.left),e.pageY-this.offset.click.top>this.containment[3]&&(o=this.containment[3]+this.offset.click.top)),n.grid&&(i=this.originalPageY+Math.round((o-this.originalPageY)/n.grid[1])*n.grid[1],o=this.containment?i-this.offset.click.top>=this.containment[1]&&i-this.offset.click.top<=this.containment[3]?i:i-this.offset.click.top>=this.containment[1]?i-n.grid[1]:i+n.grid[1]:i,s=this.originalPageX+Math.round((a-this.originalPageX)/n.grid[0])*n.grid[0],a=this.containment?s-this.offset.click.left>=this.containment[0]&&s-this.offset.click.left<=this.containment[2]?s:s-this.offset.click.left>=this.containment[0]?s-n.grid[0]:s+n.grid[0]:s)),{top:o-this.offset.click.top-this.offset.relative.top-this.offset.parent.top+("fixed"===this.cssPosition?-this.scrollParent.scrollTop():h?0:r.scrollTop()),left:a-this.offset.click.left-this.offset.relative.left-this.offset.parent.left+("fixed"===this.cssPosition?-this.scrollParent.scrollLeft():h?0:r.scrollLeft())}},_rearrange:function(t,e,i,s){i?i[0].appendChild(this.placeholder[0]):e.item[0].parentNode.insertBefore(this.placeholder[0],"down"===this.direction?e.item[0]:e.item[0].nextSibling),this.counter=this.counter?++this.counter:1;var n=this.counter;this._delay(function(){n===this.counter&&this.refreshPositions(!s)})},_clear:function(t,e){this.reverting=!1;var i,s=[];if(!this._noFinalSort&&this.currentItem.parent().length&&this.placeholder.before(this.currentItem),this._noFinalSort=null,this.helper[0]===this.currentItem[0]){for(i in this._storedCSS)("auto"===this._storedCSS[i]||"static"===this._storedCSS[i])&&(this._storedCSS[i]="");this.currentItem.css(this._storedCSS).removeClass("ui-sortable-helper")}else this.currentItem.show();for(this.fromOutside&&!e&&s.push(function(t){this._trigger("receive",t,this._uiHash(this.fromOutside))}),!this.fromOutside&&this.domPosition.prev===this.currentItem.prev().not(".ui-sortable-helper")[0]&&this.domPosition.parent===this.currentItem.parent()[0]||e||s.push(function(t){this._trigger("update",t,this._uiHash())}),this!==this.currentContainer&&(e||(s.push(function(t){this._trigger("remove",t,this._uiHash())}),s.push(function(t){return function(e){t._trigger("receive",e,this._uiHash(this))}}.call(this,this.currentContainer)),s.push(function(t){return function(e){t._trigger("update",e,this._uiHash(this))}}.call(this,this.currentContainer)))),i=this.containers.length-1;i>=0;i--)e||s.push(function(t){return function(e){t._trigger("deactivate",e,this._uiHash(this))}}.call(this,this.containers[i])),this.containers[i].containerCache.over&&(s.push(function(t){return function(e){t._trigger("out",e,this._uiHash(this))}}.call(this,this.containers[i])),this.containers[i].containerCache.over=0);if(this.storedCursor&&(this.document.find("body").css("cursor",this.storedCursor),this.storedStylesheet.remove()),this._storedOpacity&&this.helper.css("opacity",this._storedOpacity),this._storedZIndex&&this.helper.css("zIndex","auto"===this._storedZIndex?"":this._storedZIndex),this.dragging=!1,this.cancelHelperRemoval){if(!e){for(this._trigger("beforeStop",t,this._uiHash()),i=0;s.length>i;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!1}if(e||this._trigger("beforeStop",t,this._uiHash()),this.placeholder[0].parentNode.removeChild(this.placeholder[0]),this.helper[0]!==this.currentItem[0]&&this.helper.remove(),this.helper=null,!e){for(i=0;s.length>i;i++)s[i].call(this,t);this._trigger("stop",t,this._uiHash())}return this.fromOutside=!1,!0},_trigger:function(){t.Widget.prototype._trigger.apply(this,arguments)===!1&&this.cancel()},_uiHash:function(e){var i=e||this;return{helper:i.helper,placeholder:i.placeholder||t([]),position:i.position,originalPosition:i.originalPosition,offset:i.positionAbs,item:i.currentItem,sender:e?e.element:null}}})})(jQuery);(function(t){var e=0,i={},s={};i.height=i.paddingTop=i.paddingBottom=i.borderTopWidth=i.borderBottomWidth="hide",s.height=s.paddingTop=s.paddingBottom=s.borderTopWidth=s.borderBottomWidth="show",t.widget("ui.accordion",{version:"1.10.3",options:{active:0,animate:{},collapsible:!1,event:"click",header:"> li > :first-child,> :not(li):even",heightStyle:"auto",icons:{activeHeader:"ui-icon-triangle-1-s",header:"ui-icon-triangle-1-e"},activate:null,beforeActivate:null},_create:function(){var e=this.options;this.prevShow=this.prevHide=t(),this.element.addClass("ui-accordion ui-widget ui-helper-reset").attr("role","tablist"),e.collapsible||e.active!==!1&&null!=e.active||(e.active=0),this._processPanels(),0>e.active&&(e.active+=this.headers.length),this._refresh()},_getCreateEventData:function(){return{header:this.active,panel:this.active.length?this.active.next():t(),content:this.active.length?this.active.next():t()}},_createIcons:function(){var e=this.options.icons;e&&(t("<span>").addClass("ui-accordion-header-icon ui-icon "+e.header).prependTo(this.headers),this.active.children(".ui-accordion-header-icon").removeClass(e.header).addClass(e.activeHeader),this.headers.addClass("ui-accordion-icons"))},_destroyIcons:function(){this.headers.removeClass("ui-accordion-icons").children(".ui-accordion-header-icon").remove()},_destroy:function(){var t;this.element.removeClass("ui-accordion ui-widget ui-helper-reset").removeAttr("role"),this.headers.removeClass("ui-accordion-header ui-accordion-header-active ui-helper-reset ui-state-default ui-corner-all ui-state-active ui-state-disabled ui-corner-top").removeAttr("role").removeAttr("aria-selected").removeAttr("aria-controls").removeAttr("tabIndex").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),this._destroyIcons(),t=this.headers.next().css("display","").removeAttr("role").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-labelledby").removeClass("ui-helper-reset ui-widget-content ui-corner-bottom ui-accordion-content ui-accordion-content-active ui-state-disabled").each(function(){/^ui-accordion/.test(this.id)&&this.removeAttribute("id")}),"content"!==this.options.heightStyle&&t.css("height","")},_setOption:function(t,e){return"active"===t?(this._activate(e),undefined):("event"===t&&(this.options.event&&this._off(this.headers,this.options.event),this._setupEvents(e)),this._super(t,e),"collapsible"!==t||e||this.options.active!==!1||this._activate(0),"icons"===t&&(this._destroyIcons(),e&&this._createIcons()),"disabled"===t&&this.headers.add(this.headers.next()).toggleClass("ui-state-disabled",!!e),undefined)},_keydown:function(e){if(!e.altKey&&!e.ctrlKey){var i=t.ui.keyCode,s=this.headers.length,n=this.headers.index(e.target),a=!1;switch(e.keyCode){case i.RIGHT:case i.DOWN:a=this.headers[(n+1)%s];break;case i.LEFT:case i.UP:a=this.headers[(n-1+s)%s];break;case i.SPACE:case i.ENTER:this._eventHandler(e);break;case i.HOME:a=this.headers[0];break;case i.END:a=this.headers[s-1]}a&&(t(e.target).attr("tabIndex",-1),t(a).attr("tabIndex",0),a.focus(),e.preventDefault())}},_panelKeyDown:function(e){e.keyCode===t.ui.keyCode.UP&&e.ctrlKey&&t(e.currentTarget).prev().focus()},refresh:function(){var e=this.options;this._processPanels(),e.active===!1&&e.collapsible===!0||!this.headers.length?(e.active=!1,this.active=t()):e.active===!1?this._activate(0):this.active.length&&!t.contains(this.element[0],this.active[0])?this.headers.length===this.headers.find(".ui-state-disabled").length?(e.active=!1,this.active=t()):this._activate(Math.max(0,e.active-1)):e.active=this.headers.index(this.active),this._destroyIcons(),this._refresh()},_processPanels:function(){this.headers=this.element.find(this.options.header).addClass("ui-accordion-header ui-helper-reset ui-state-default ui-corner-all"),this.headers.next().addClass("ui-accordion-content ui-helper-reset ui-widget-content ui-corner-bottom").filter(":not(.ui-accordion-content-active)").hide()},_refresh:function(){var i,s=this.options,n=s.heightStyle,a=this.element.parent(),o=this.accordionId="ui-accordion-"+(this.element.attr("id")||++e);this.active=this._findActive(s.active).addClass("ui-accordion-header-active ui-state-active ui-corner-top").removeClass("ui-corner-all"),this.active.next().addClass("ui-accordion-content-active").show(),this.headers.attr("role","tab").each(function(e){var i=t(this),s=i.attr("id"),n=i.next(),a=n.attr("id");s||(s=o+"-header-"+e,i.attr("id",s)),a||(a=o+"-panel-"+e,n.attr("id",a)),i.attr("aria-controls",a),n.attr("aria-labelledby",s)}).next().attr("role","tabpanel"),this.headers.not(this.active).attr({"aria-selected":"false",tabIndex:-1}).next().attr({"aria-expanded":"false","aria-hidden":"true"}).hide(),this.active.length?this.active.attr({"aria-selected":"true",tabIndex:0}).next().attr({"aria-expanded":"true","aria-hidden":"false"}):this.headers.eq(0).attr("tabIndex",0),this._createIcons(),this._setupEvents(s.event),"fill"===n?(i=a.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.headers.each(function(){i-=t(this).outerHeight(!0)}),this.headers.next().each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===n&&(i=0,this.headers.next().each(function(){i=Math.max(i,t(this).css("height","").height())}).height(i))},_activate:function(e){var i=this._findActive(e)[0];i!==this.active[0]&&(i=i||this.active[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return"number"==typeof e?this.headers.eq(e):t()},_setupEvents:function(e){var i={keydown:"_keydown"};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.headers.add(this.headers.next())),this._on(this.headers,i),this._on(this.headers.next(),{keydown:"_panelKeyDown"}),this._hoverable(this.headers),this._focusable(this.headers)},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),a=n[0]===s[0],o=a&&i.collapsible,r=o?t():n.next(),h=s.next(),l={oldHeader:s,oldPanel:h,newHeader:o?t():n,newPanel:r};e.preventDefault(),a&&!i.collapsible||this._trigger("beforeActivate",e,l)===!1||(i.active=o?!1:this.headers.index(n),this.active=a?t():n,this._toggle(l),s.removeClass("ui-accordion-header-active ui-state-active"),i.icons&&s.children(".ui-accordion-header-icon").removeClass(i.icons.activeHeader).addClass(i.icons.header),a||(n.removeClass("ui-corner-all").addClass("ui-accordion-header-active ui-state-active ui-corner-top"),i.icons&&n.children(".ui-accordion-header-icon").removeClass(i.icons.header).addClass(i.icons.activeHeader),n.next().addClass("ui-accordion-content-active")))},_toggle:function(e){var i=e.newPanel,s=this.prevShow.length?this.prevShow:e.oldPanel;this.prevShow.add(this.prevHide).stop(!0,!0),this.prevShow=i,this.prevHide=s,this.options.animate?this._animate(i,s,e):(s.hide(),i.show(),this._toggleComplete(e)),s.attr({"aria-expanded":"false","aria-hidden":"true"}),s.prev().attr("aria-selected","false"),i.length&&s.length?s.prev().attr("tabIndex",-1):i.length&&this.headers.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),i.attr({"aria-expanded":"true","aria-hidden":"false"}).prev().attr({"aria-selected":"true",tabIndex:0})},_animate:function(t,e,n){var a,o,r,h=this,l=0,c=t.length&&(!e.length||t.index()<e.index()),u=this.options.animate||{},d=c&&u.down||u,p=function(){h._toggleComplete(n)};return"number"==typeof d&&(r=d),"string"==typeof d&&(o=d),o=o||d.easing||u.easing,r=r||d.duration||u.duration,e.length?t.length?(a=t.show().outerHeight(),e.animate(i,{duration:r,easing:o,step:function(t,e){e.now=Math.round(t)}}),t.hide().animate(s,{duration:r,easing:o,complete:p,step:function(t,i){i.now=Math.round(t),"height"!==i.prop?l+=i.now:"content"!==h.options.heightStyle&&(i.now=Math.round(a-e.outerHeight()-l),l=0)}}),undefined):e.animate(i,r,o,p):t.animate(s,r,o,p)},_toggleComplete:function(t){var e=t.oldPanel;e.removeClass("ui-accordion-content-active").prev().removeClass("ui-corner-top").addClass("ui-corner-all"),e.length&&(e.parent()[0].className=e.parent()[0].className),this._trigger("activate",null,t)}})})(jQuery);(function(t){var e=0;t.widget("ui.autocomplete",{version:"1.10.3",defaultElement:"<input>",options:{appendTo:null,autoFocus:!1,delay:300,minLength:1,position:{my:"left top",at:"left bottom",collision:"none"},source:null,change:null,close:null,focus:null,open:null,response:null,search:null,select:null},pending:0,_create:function(){var e,i,s,n=this.element[0].nodeName.toLowerCase(),a="textarea"===n,o="input"===n;this.isMultiLine=a?!0:o?!1:this.element.prop("isContentEditable"),this.valueMethod=this.element[a||o?"val":"text"],this.isNewMenu=!0,this.element.addClass("ui-autocomplete-input").attr("autocomplete","off"),this._on(this.element,{keydown:function(n){if(this.element.prop("readOnly"))return e=!0,s=!0,i=!0,undefined;e=!1,s=!1,i=!1;var a=t.ui.keyCode;switch(n.keyCode){case a.PAGE_UP:e=!0,this._move("previousPage",n);break;case a.PAGE_DOWN:e=!0,this._move("nextPage",n);break;case a.UP:e=!0,this._keyEvent("previous",n);break;case a.DOWN:e=!0,this._keyEvent("next",n);break;case a.ENTER:case a.NUMPAD_ENTER:this.menu.active&&(e=!0,n.preventDefault(),this.menu.select(n));break;case a.TAB:this.menu.active&&this.menu.select(n);break;case a.ESCAPE:this.menu.element.is(":visible")&&(this._value(this.term),this.close(n),n.preventDefault());break;default:i=!0,this._searchTimeout(n)}},keypress:function(s){if(e)return e=!1,(!this.isMultiLine||this.menu.element.is(":visible"))&&s.preventDefault(),undefined;if(!i){var n=t.ui.keyCode;switch(s.keyCode){case n.PAGE_UP:this._move("previousPage",s);break;case n.PAGE_DOWN:this._move("nextPage",s);break;case n.UP:this._keyEvent("previous",s);break;case n.DOWN:this._keyEvent("next",s)}}},input:function(t){return s?(s=!1,t.preventDefault(),undefined):(this._searchTimeout(t),undefined)},focus:function(){this.selectedItem=null,this.previous=this._value()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,undefined):(clearTimeout(this.searching),this.close(t),this._change(t),undefined)}}),this._initSource(),this.menu=t("<ul>").addClass("ui-autocomplete ui-front").appendTo(this._appendTo()).menu({role:null}).hide().data("ui-menu"),this._on(this.menu.element,{mousedown:function(e){e.preventDefault(),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur});var i=this.menu.element[0];t(e.target).closest(".ui-menu-item").length||this._delay(function(){var e=this;this.document.one("mousedown",function(s){s.target===e.element[0]||s.target===i||t.contains(i,s.target)||e.close()})})},menufocus:function(e,i){if(this.isNewMenu&&(this.isNewMenu=!1,e.originalEvent&&/^mouse/.test(e.originalEvent.type)))return this.menu.blur(),this.document.one("mousemove",function(){t(e.target).trigger(e.originalEvent)}),undefined;var s=i.item.data("ui-autocomplete-item");!1!==this._trigger("focus",e,{item:s})?e.originalEvent&&/^key/.test(e.originalEvent.type)&&this._value(s.value):this.liveRegion.text(s.value)},menuselect:function(t,e){var i=e.item.data("ui-autocomplete-item"),s=this.previous;this.element[0]!==this.document[0].activeElement&&(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s,this.selectedItem=i})),!1!==this._trigger("select",t,{item:i})&&this._value(i.value),this.term=this._value(),this.close(t),this.selectedItem=i}}),this.liveRegion=t("<span>",{role:"status","aria-live":"polite"}).addClass("ui-helper-hidden-accessible").insertBefore(this.element),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_destroy:function(){clearTimeout(this.searching),this.element.removeClass("ui-autocomplete-input").removeAttr("autocomplete"),this.menu.element.remove(),this.liveRegion.remove()},_setOption:function(t,e){this._super(t,e),"source"===t&&this._initSource(),"appendTo"===t&&this.menu.element.appendTo(this._appendTo()),"disabled"===t&&e&&this.xhr&&this.xhr.abort()},_appendTo:function(){var e=this.options.appendTo;return e&&(e=e.jquery||e.nodeType?t(e):this.document.find(e).eq(0)),e||(e=this.element.closest(".ui-front")),e.length||(e=this.document[0].body),e},_initSource:function(){var e,i,s=this;t.isArray(this.options.source)?(e=this.options.source,this.source=function(i,s){s(t.ui.autocomplete.filter(e,i.term))}):"string"==typeof this.options.source?(i=this.options.source,this.source=function(e,n){s.xhr&&s.xhr.abort(),s.xhr=t.ajax({url:i,data:e,dataType:"json",success:function(t){n(t)},error:function(){n([])}})}):this.source=this.options.source},_searchTimeout:function(t){clearTimeout(this.searching),this.searching=this._delay(function(){this.term!==this._value()&&(this.selectedItem=null,this.search(null,t))},this.options.delay)},search:function(t,e){return t=null!=t?t:this._value(),this.term=this._value(),t.length<this.options.minLength?this.close(e):this._trigger("search",e)!==!1?this._search(t):undefined},_search:function(t){this.pending++,this.element.addClass("ui-autocomplete-loading"),this.cancelSearch=!1,this.source({term:t},this._response())},_response:function(){var t=this,i=++e;return function(s){i===e&&t.__response(s),t.pending--,t.pending||t.element.removeClass("ui-autocomplete-loading")}},__response:function(t){t&&(t=this._normalize(t)),this._trigger("response",null,{content:t}),!this.options.disabled&&t&&t.length&&!this.cancelSearch?(this._suggest(t),this._trigger("open")):this._close()},close:function(t){this.cancelSearch=!0,this._close(t)},_close:function(t){this.menu.element.is(":visible")&&(this.menu.element.hide(),this.menu.blur(),this.isNewMenu=!0,this._trigger("close",t))},_change:function(t){this.previous!==this._value()&&this._trigger("change",t,{item:this.selectedItem})},_normalize:function(e){return e.length&&e[0].label&&e[0].value?e:t.map(e,function(e){return"string"==typeof e?{label:e,value:e}:t.extend({label:e.label||e.value,value:e.value||e.label},e)})},_suggest:function(e){var i=this.menu.element.empty();this._renderMenu(i,e),this.isNewMenu=!0,this.menu.refresh(),i.show(),this._resizeMenu(),i.position(t.extend({of:this.element},this.options.position)),this.options.autoFocus&&this.menu.next()},_resizeMenu:function(){var t=this.menu.element;t.outerWidth(Math.max(t.width("").outerWidth()+1,this.element.outerWidth()))},_renderMenu:function(e,i){var s=this;t.each(i,function(t,i){s._renderItemData(e,i)})},_renderItemData:function(t,e){return this._renderItem(t,e).data("ui-autocomplete-item",e)},_renderItem:function(e,i){return t("<li>").append(t("<a>").text(i.label)).appendTo(e)},_move:function(t,e){return this.menu.element.is(":visible")?this.menu.isFirstItem()&&/^previous/.test(t)||this.menu.isLastItem()&&/^next/.test(t)?(this._value(this.term),this.menu.blur(),undefined):(this.menu[t](e),undefined):(this.search(null,e),undefined)},widget:function(){return this.menu.element},_value:function(){return this.valueMethod.apply(this.element,arguments)},_keyEvent:function(t,e){(!this.isMultiLine||this.menu.element.is(":visible"))&&(this._move(t,e),e.preventDefault())}}),t.extend(t.ui.autocomplete,{escapeRegex:function(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")},filter:function(e,i){var s=RegExp(t.ui.autocomplete.escapeRegex(i),"i");return t.grep(e,function(t){return s.test(t.label||t.value||t)})}}),t.widget("ui.autocomplete",t.ui.autocomplete,{options:{messages:{noResults:"No search results.",results:function(t){return t+(t>1?" results are":" result is")+" available, use up and down arrow keys to navigate."}}},__response:function(t){var e;this._superApply(arguments),this.options.disabled||this.cancelSearch||(e=t&&t.length?this.options.messages.results(t.length):this.options.messages.noResults,this.liveRegion.text(e))}})})(jQuery);(function(t){var e,i,s,n,a="ui-button ui-widget ui-state-default ui-corner-all",o="ui-state-hover ui-state-active ",r="ui-button-icons-only ui-button-icon-only ui-button-text-icons ui-button-text-icon-primary ui-button-text-icon-secondary ui-button-text-only",h=function(){var e=t(this);setTimeout(function(){e.find(":ui-button").button("refresh")},1)},l=function(e){var i=e.name,s=e.form,n=t([]);return i&&(i=i.replace(/'/g,"\\'"),n=s?t(s).find("[name='"+i+"']"):t("[name='"+i+"']",e.ownerDocument).filter(function(){return!this.form})),n};t.widget("ui.button",{version:"1.10.3",defaultElement:"<button>",options:{disabled:null,text:!0,label:null,icons:{primary:null,secondary:null}},_create:function(){this.element.closest("form").unbind("reset"+this.eventNamespace).bind("reset"+this.eventNamespace,h),"boolean"!=typeof this.options.disabled?this.options.disabled=!!this.element.prop("disabled"):this.element.prop("disabled",this.options.disabled),this._determineButtonType(),this.hasTitle=!!this.buttonElement.attr("title");var o=this,r=this.options,c="checkbox"===this.type||"radio"===this.type,u=c?"":"ui-state-active",d="ui-state-focus";null===r.label&&(r.label="input"===this.type?this.buttonElement.val():this.buttonElement.html()),this._hoverable(this.buttonElement),this.buttonElement.addClass(a).attr("role","button").bind("mouseenter"+this.eventNamespace,function(){r.disabled||this===e&&t(this).addClass("ui-state-active")}).bind("mouseleave"+this.eventNamespace,function(){r.disabled||t(this).removeClass(u)}).bind("click"+this.eventNamespace,function(t){r.disabled&&(t.preventDefault(),t.stopImmediatePropagation())}),this.element.bind("focus"+this.eventNamespace,function(){o.buttonElement.addClass(d)}).bind("blur"+this.eventNamespace,function(){o.buttonElement.removeClass(d)}),c&&(this.element.bind("change"+this.eventNamespace,function(){n||o.refresh()}),this.buttonElement.bind("mousedown"+this.eventNamespace,function(t){r.disabled||(n=!1,i=t.pageX,s=t.pageY)}).bind("mouseup"+this.eventNamespace,function(t){r.disabled||(i!==t.pageX||s!==t.pageY)&&(n=!0)})),"checkbox"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){return r.disabled||n?!1:undefined}):"radio"===this.type?this.buttonElement.bind("click"+this.eventNamespace,function(){if(r.disabled||n)return!1;t(this).addClass("ui-state-active"),o.buttonElement.attr("aria-pressed","true");var e=o.element[0];l(e).not(e).map(function(){return t(this).button("widget")[0]}).removeClass("ui-state-active").attr("aria-pressed","false")}):(this.buttonElement.bind("mousedown"+this.eventNamespace,function(){return r.disabled?!1:(t(this).addClass("ui-state-active"),e=this,o.document.one("mouseup",function(){e=null}),undefined)}).bind("mouseup"+this.eventNamespace,function(){return r.disabled?!1:(t(this).removeClass("ui-state-active"),undefined)}).bind("keydown"+this.eventNamespace,function(e){return r.disabled?!1:((e.keyCode===t.ui.keyCode.SPACE||e.keyCode===t.ui.keyCode.ENTER)&&t(this).addClass("ui-state-active"),undefined)}).bind("keyup"+this.eventNamespace+" blur"+this.eventNamespace,function(){t(this).removeClass("ui-state-active")}),this.buttonElement.is("a")&&this.buttonElement.keyup(function(e){e.keyCode===t.ui.keyCode.SPACE&&t(this).click()})),this._setOption("disabled",r.disabled),this._resetButton()},_determineButtonType:function(){var t,e,i;this.type=this.element.is("[type=checkbox]")?"checkbox":this.element.is("[type=radio]")?"radio":this.element.is("input")?"input":"button","checkbox"===this.type||"radio"===this.type?(t=this.element.parents().last(),e="label[for='"+this.element.attr("id")+"']",this.buttonElement=t.find(e),this.buttonElement.length||(t=t.length?t.siblings():this.element.siblings(),this.buttonElement=t.filter(e),this.buttonElement.length||(this.buttonElement=t.find(e))),this.element.addClass("ui-helper-hidden-accessible"),i=this.element.is(":checked"),i&&this.buttonElement.addClass("ui-state-active"),this.buttonElement.prop("aria-pressed",i)):this.buttonElement=this.element},widget:function(){return this.buttonElement},_destroy:function(){this.element.removeClass("ui-helper-hidden-accessible"),this.buttonElement.removeClass(a+" "+o+" "+r).removeAttr("role").removeAttr("aria-pressed").html(this.buttonElement.find(".ui-button-text").html()),this.hasTitle||this.buttonElement.removeAttr("title")},_setOption:function(t,e){return this._super(t,e),"disabled"===t?(e?this.element.prop("disabled",!0):this.element.prop("disabled",!1),undefined):(this._resetButton(),undefined)},refresh:function(){var e=this.element.is("input, button")?this.element.is(":disabled"):this.element.hasClass("ui-button-disabled");e!==this.options.disabled&&this._setOption("disabled",e),"radio"===this.type?l(this.element[0]).each(function(){t(this).is(":checked")?t(this).button("widget").addClass("ui-state-active").attr("aria-pressed","true"):t(this).button("widget").removeClass("ui-state-active").attr("aria-pressed","false")}):"checkbox"===this.type&&(this.element.is(":checked")?this.buttonElement.addClass("ui-state-active").attr("aria-pressed","true"):this.buttonElement.removeClass("ui-state-active").attr("aria-pressed","false"))},_resetButton:function(){if("input"===this.type)return this.options.label&&this.element.val(this.options.label),undefined;var e=this.buttonElement.removeClass(r),i=t("<span></span>",this.document[0]).addClass("ui-button-text").html(this.options.label).appendTo(e.empty()).text(),s=this.options.icons,n=s.primary&&s.secondary,a=[];s.primary||s.secondary?(this.options.text&&a.push("ui-button-text-icon"+(n?"s":s.primary?"-primary":"-secondary")),s.primary&&e.prepend("<span class='ui-button-icon-primary ui-icon "+s.primary+"'></span>"),s.secondary&&e.append("<span class='ui-button-icon-secondary ui-icon "+s.secondary+"'></span>"),this.options.text||(a.push(n?"ui-button-icons-only":"ui-button-icon-only"),this.hasTitle||e.attr("title",t.trim(i)))):a.push("ui-button-text-only"),e.addClass(a.join(" "))}}),t.widget("ui.buttonset",{version:"1.10.3",options:{items:"button, input[type=button], input[type=submit], input[type=reset], input[type=checkbox], input[type=radio], a, :data(ui-button)"},_create:function(){this.element.addClass("ui-buttonset")},_init:function(){this.refresh()},_setOption:function(t,e){"disabled"===t&&this.buttons.button("option",t,e),this._super(t,e)},refresh:function(){var e="rtl"===this.element.css("direction");this.buttons=this.element.find(this.options.items).filter(":ui-button").button("refresh").end().not(":ui-button").button().end().map(function(){return t(this).button("widget")[0]}).removeClass("ui-corner-all ui-corner-left ui-corner-right").filter(":first").addClass(e?"ui-corner-right":"ui-corner-left").end().filter(":last").addClass(e?"ui-corner-left":"ui-corner-right").end().end()},_destroy:function(){this.element.removeClass("ui-buttonset"),this.buttons.map(function(){return t(this).button("widget")[0]}).removeClass("ui-corner-left ui-corner-right").end().button("destroy")}})})(jQuery);(function(t,e){function i(){this._curInst=null,this._keyEvent=!1,this._disabledInputs=[],this._datepickerShowing=!1,this._inDialog=!1,this._mainDivId="ui-datepicker-div",this._inlineClass="ui-datepicker-inline",this._appendClass="ui-datepicker-append",this._triggerClass="ui-datepicker-trigger",this._dialogClass="ui-datepicker-dialog",this._disableClass="ui-datepicker-disabled",this._unselectableClass="ui-datepicker-unselectable",this._currentClass="ui-datepicker-current-day",this._dayOverClass="ui-datepicker-days-cell-over",this.regional=[],this.regional[""]={closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"mm/dd/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""},this._defaults={showOn:"focus",showAnim:"fadeIn",showOptions:{},defaultDate:null,appendText:"",buttonText:"...",buttonImage:"",buttonImageOnly:!1,hideIfNoPrevNext:!1,navigationAsDateFormat:!1,gotoCurrent:!1,changeMonth:!1,changeYear:!1,yearRange:"c-10:c+10",showOtherMonths:!1,selectOtherMonths:!1,showWeek:!1,calculateWeek:this.iso8601Week,shortYearCutoff:"+10",minDate:null,maxDate:null,duration:"fast",beforeShowDay:null,beforeShow:null,onSelect:null,onChangeMonthYear:null,onClose:null,numberOfMonths:1,showCurrentAtPos:0,stepMonths:1,stepBigMonths:12,altField:"",altFormat:"",constrainInput:!0,showButtonPanel:!1,autoSize:!1,disabled:!1},t.extend(this._defaults,this.regional[""]),this.dpDiv=s(t("<div id='"+this._mainDivId+"' class='ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>"))}function s(e){var i="button, .ui-datepicker-prev, .ui-datepicker-next, .ui-datepicker-calendar td a";return e.delegate(i,"mouseout",function(){t(this).removeClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).removeClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).removeClass("ui-datepicker-next-hover")}).delegate(i,"mouseover",function(){t.datepicker._isDisabledDatepicker(a.inline?e.parent()[0]:a.input[0])||(t(this).parents(".ui-datepicker-calendar").find("a").removeClass("ui-state-hover"),t(this).addClass("ui-state-hover"),-1!==this.className.indexOf("ui-datepicker-prev")&&t(this).addClass("ui-datepicker-prev-hover"),-1!==this.className.indexOf("ui-datepicker-next")&&t(this).addClass("ui-datepicker-next-hover"))})}function n(e,i){t.extend(e,i);for(var s in i)null==i[s]&&(e[s]=i[s]);return e}t.extend(t.ui,{datepicker:{version:"1.10.3"}});var a,r="datepicker";t.extend(i.prototype,{markerClassName:"hasDatepicker",maxRows:4,_widgetDatepicker:function(){return this.dpDiv},setDefaults:function(t){return n(this._defaults,t||{}),this},_attachDatepicker:function(e,i){var s,n,a;s=e.nodeName.toLowerCase(),n="div"===s||"span"===s,e.id||(this.uuid+=1,e.id="dp"+this.uuid),a=this._newInst(t(e),n),a.settings=t.extend({},i||{}),"input"===s?this._connectDatepicker(e,a):n&&this._inlineDatepicker(e,a)},_newInst:function(e,i){var n=e[0].id.replace(/([^A-Za-z0-9_\-])/g,"\\\\$1");return{id:n,input:e,selectedDay:0,selectedMonth:0,selectedYear:0,drawMonth:0,drawYear:0,inline:i,dpDiv:i?s(t("<div class='"+this._inlineClass+" ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all'></div>")):this.dpDiv}},_connectDatepicker:function(e,i){var s=t(e);i.append=t([]),i.trigger=t([]),s.hasClass(this.markerClassName)||(this._attachments(s,i),s.addClass(this.markerClassName).keydown(this._doKeyDown).keypress(this._doKeyPress).keyup(this._doKeyUp),this._autoSize(i),t.data(e,r,i),i.settings.disabled&&this._disableDatepicker(e))},_attachments:function(e,i){var s,n,a,r=this._get(i,"appendText"),o=this._get(i,"isRTL");i.append&&i.append.remove(),r&&(i.append=t("<span class='"+this._appendClass+"'>"+r+"</span>"),e[o?"before":"after"](i.append)),e.unbind("focus",this._showDatepicker),i.trigger&&i.trigger.remove(),s=this._get(i,"showOn"),("focus"===s||"both"===s)&&e.focus(this._showDatepicker),("button"===s||"both"===s)&&(n=this._get(i,"buttonText"),a=this._get(i,"buttonImage"),i.trigger=t(this._get(i,"buttonImageOnly")?t("<img/>").addClass(this._triggerClass).attr({src:a,alt:n,title:n}):t("<button type='button'></button>").addClass(this._triggerClass).html(a?t("<img/>").attr({src:a,alt:n,title:n}):n)),e[o?"before":"after"](i.trigger),i.trigger.click(function(){return t.datepicker._datepickerShowing&&t.datepicker._lastInput===e[0]?t.datepicker._hideDatepicker():t.datepicker._datepickerShowing&&t.datepicker._lastInput!==e[0]?(t.datepicker._hideDatepicker(),t.datepicker._showDatepicker(e[0])):t.datepicker._showDatepicker(e[0]),!1}))},_autoSize:function(t){if(this._get(t,"autoSize")&&!t.inline){var e,i,s,n,a=new Date(2009,11,20),r=this._get(t,"dateFormat");r.match(/[DM]/)&&(e=function(t){for(i=0,s=0,n=0;t.length>n;n++)t[n].length>i&&(i=t[n].length,s=n);return s},a.setMonth(e(this._get(t,r.match(/MM/)?"monthNames":"monthNamesShort"))),a.setDate(e(this._get(t,r.match(/DD/)?"dayNames":"dayNamesShort"))+20-a.getDay())),t.input.attr("size",this._formatDate(t,a).length)}},_inlineDatepicker:function(e,i){var s=t(e);s.hasClass(this.markerClassName)||(s.addClass(this.markerClassName).append(i.dpDiv),t.data(e,r,i),this._setDate(i,this._getDefaultDate(i),!0),this._updateDatepicker(i),this._updateAlternate(i),i.settings.disabled&&this._disableDatepicker(e),i.dpDiv.css("display","block"))},_dialogDatepicker:function(e,i,s,a,o){var h,l,c,u,d,p=this._dialogInst;return p||(this.uuid+=1,h="dp"+this.uuid,this._dialogInput=t("<input type='text' id='"+h+"' style='position: absolute; top: -100px; width: 0px;'/>"),this._dialogInput.keydown(this._doKeyDown),t("body").append(this._dialogInput),p=this._dialogInst=this._newInst(this._dialogInput,!1),p.settings={},t.data(this._dialogInput[0],r,p)),n(p.settings,a||{}),i=i&&i.constructor===Date?this._formatDate(p,i):i,this._dialogInput.val(i),this._pos=o?o.length?o:[o.pageX,o.pageY]:null,this._pos||(l=document.documentElement.clientWidth,c=document.documentElement.clientHeight,u=document.documentElement.scrollLeft||document.body.scrollLeft,d=document.documentElement.scrollTop||document.body.scrollTop,this._pos=[l/2-100+u,c/2-150+d]),this._dialogInput.css("left",this._pos[0]+20+"px").css("top",this._pos[1]+"px"),p.settings.onSelect=s,this._inDialog=!0,this.dpDiv.addClass(this._dialogClass),this._showDatepicker(this._dialogInput[0]),t.blockUI&&t.blockUI(this.dpDiv),t.data(this._dialogInput[0],r,p),this},_destroyDatepicker:function(e){var i,s=t(e),n=t.data(e,r);s.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),t.removeData(e,r),"input"===i?(n.append.remove(),n.trigger.remove(),s.removeClass(this.markerClassName).unbind("focus",this._showDatepicker).unbind("keydown",this._doKeyDown).unbind("keypress",this._doKeyPress).unbind("keyup",this._doKeyUp)):("div"===i||"span"===i)&&s.removeClass(this.markerClassName).empty())},_enableDatepicker:function(e){var i,s,n=t(e),a=t.data(e,r);n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!1,a.trigger.filter("button").each(function(){this.disabled=!1}).end().filter("img").css({opacity:"1.0",cursor:""})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().removeClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!1)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}))},_disableDatepicker:function(e){var i,s,n=t(e),a=t.data(e,r);n.hasClass(this.markerClassName)&&(i=e.nodeName.toLowerCase(),"input"===i?(e.disabled=!0,a.trigger.filter("button").each(function(){this.disabled=!0}).end().filter("img").css({opacity:"0.5",cursor:"default"})):("div"===i||"span"===i)&&(s=n.children("."+this._inlineClass),s.children().addClass("ui-state-disabled"),s.find("select.ui-datepicker-month, select.ui-datepicker-year").prop("disabled",!0)),this._disabledInputs=t.map(this._disabledInputs,function(t){return t===e?null:t}),this._disabledInputs[this._disabledInputs.length]=e)},_isDisabledDatepicker:function(t){if(!t)return!1;for(var e=0;this._disabledInputs.length>e;e++)if(this._disabledInputs[e]===t)return!0;return!1},_getInst:function(e){try{return t.data(e,r)}catch(i){throw"Missing instance data for this datepicker"}},_optionDatepicker:function(i,s,a){var r,o,h,l,c=this._getInst(i);return 2===arguments.length&&"string"==typeof s?"defaults"===s?t.extend({},t.datepicker._defaults):c?"all"===s?t.extend({},c.settings):this._get(c,s):null:(r=s||{},"string"==typeof s&&(r={},r[s]=a),c&&(this._curInst===c&&this._hideDatepicker(),o=this._getDateDatepicker(i,!0),h=this._getMinMaxDate(c,"min"),l=this._getMinMaxDate(c,"max"),n(c.settings,r),null!==h&&r.dateFormat!==e&&r.minDate===e&&(c.settings.minDate=this._formatDate(c,h)),null!==l&&r.dateFormat!==e&&r.maxDate===e&&(c.settings.maxDate=this._formatDate(c,l)),"disabled"in r&&(r.disabled?this._disableDatepicker(i):this._enableDatepicker(i)),this._attachments(t(i),c),this._autoSize(c),this._setDate(c,o),this._updateAlternate(c),this._updateDatepicker(c)),e)},_changeDatepicker:function(t,e,i){this._optionDatepicker(t,e,i)},_refreshDatepicker:function(t){var e=this._getInst(t);e&&this._updateDatepicker(e)},_setDateDatepicker:function(t,e){var i=this._getInst(t);i&&(this._setDate(i,e),this._updateDatepicker(i),this._updateAlternate(i))},_getDateDatepicker:function(t,e){var i=this._getInst(t);return i&&!i.inline&&this._setDateFromField(i,e),i?this._getDate(i):null},_doKeyDown:function(e){var i,s,n,a=t.datepicker._getInst(e.target),r=!0,o=a.dpDiv.is(".ui-datepicker-rtl");if(a._keyEvent=!0,t.datepicker._datepickerShowing)switch(e.keyCode){case 9:t.datepicker._hideDatepicker(),r=!1;break;case 13:return n=t("td."+t.datepicker._dayOverClass+":not(."+t.datepicker._currentClass+")",a.dpDiv),n[0]&&t.datepicker._selectDay(e.target,a.selectedMonth,a.selectedYear,n[0]),i=t.datepicker._get(a,"onSelect"),i?(s=t.datepicker._formatDate(a),i.apply(a.input?a.input[0]:null,[s,a])):t.datepicker._hideDatepicker(),!1;case 27:t.datepicker._hideDatepicker();break;case 33:t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(a,"stepBigMonths"):-t.datepicker._get(a,"stepMonths"),"M");break;case 34:t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(a,"stepBigMonths"):+t.datepicker._get(a,"stepMonths"),"M");break;case 35:(e.ctrlKey||e.metaKey)&&t.datepicker._clearDate(e.target),r=e.ctrlKey||e.metaKey;break;case 36:(e.ctrlKey||e.metaKey)&&t.datepicker._gotoToday(e.target),r=e.ctrlKey||e.metaKey;break;case 37:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,o?1:-1,"D"),r=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?-t.datepicker._get(a,"stepBigMonths"):-t.datepicker._get(a,"stepMonths"),"M");break;case 38:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,-7,"D"),r=e.ctrlKey||e.metaKey;break;case 39:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,o?-1:1,"D"),r=e.ctrlKey||e.metaKey,e.originalEvent.altKey&&t.datepicker._adjustDate(e.target,e.ctrlKey?+t.datepicker._get(a,"stepBigMonths"):+t.datepicker._get(a,"stepMonths"),"M");break;case 40:(e.ctrlKey||e.metaKey)&&t.datepicker._adjustDate(e.target,7,"D"),r=e.ctrlKey||e.metaKey;break;default:r=!1}else 36===e.keyCode&&e.ctrlKey?t.datepicker._showDatepicker(this):r=!1;r&&(e.preventDefault(),e.stopPropagation())},_doKeyPress:function(i){var s,n,a=t.datepicker._getInst(i.target);return t.datepicker._get(a,"constrainInput")?(s=t.datepicker._possibleChars(t.datepicker._get(a,"dateFormat")),n=String.fromCharCode(null==i.charCode?i.keyCode:i.charCode),i.ctrlKey||i.metaKey||" ">n||!s||s.indexOf(n)>-1):e},_doKeyUp:function(e){var i,s=t.datepicker._getInst(e.target);if(s.input.val()!==s.lastVal)try{i=t.datepicker.parseDate(t.datepicker._get(s,"dateFormat"),s.input?s.input.val():null,t.datepicker._getFormatConfig(s)),i&&(t.datepicker._setDateFromField(s),t.datepicker._updateAlternate(s),t.datepicker._updateDatepicker(s))}catch(n){}return!0},_showDatepicker:function(e){if(e=e.target||e,"input"!==e.nodeName.toLowerCase()&&(e=t("input",e.parentNode)[0]),!t.datepicker._isDisabledDatepicker(e)&&t.datepicker._lastInput!==e){var i,s,a,r,o,h,l;i=t.datepicker._getInst(e),t.datepicker._curInst&&t.datepicker._curInst!==i&&(t.datepicker._curInst.dpDiv.stop(!0,!0),i&&t.datepicker._datepickerShowing&&t.datepicker._hideDatepicker(t.datepicker._curInst.input[0])),s=t.datepicker._get(i,"beforeShow"),a=s?s.apply(e,[e,i]):{},a!==!1&&(n(i.settings,a),i.lastVal=null,t.datepicker._lastInput=e,t.datepicker._setDateFromField(i),t.datepicker._inDialog&&(e.value=""),t.datepicker._pos||(t.datepicker._pos=t.datepicker._findPos(e),t.datepicker._pos[1]+=e.offsetHeight),r=!1,t(e).parents().each(function(){return r|="fixed"===t(this).css("position"),!r}),o={left:t.datepicker._pos[0],top:t.datepicker._pos[1]},t.datepicker._pos=null,i.dpDiv.empty(),i.dpDiv.css({position:"absolute",display:"block",top:"-1000px"}),t.datepicker._updateDatepicker(i),o=t.datepicker._checkOffset(i,o,r),i.dpDiv.css({position:t.datepicker._inDialog&&t.blockUI?"static":r?"fixed":"absolute",display:"none",left:o.left+"px",top:o.top+"px"}),i.inline||(h=t.datepicker._get(i,"showAnim"),l=t.datepicker._get(i,"duration"),i.dpDiv.zIndex(t(e).zIndex()+1),t.datepicker._datepickerShowing=!0,t.effects&&t.effects.effect[h]?i.dpDiv.show(h,t.datepicker._get(i,"showOptions"),l):i.dpDiv[h||"show"](h?l:null),t.datepicker._shouldFocusInput(i)&&i.input.focus(),t.datepicker._curInst=i))}},_updateDatepicker:function(e){this.maxRows=4,a=e,e.dpDiv.empty().append(this._generateHTML(e)),this._attachHandlers(e),e.dpDiv.find("."+this._dayOverClass+" a").mouseover();var i,s=this._getNumberOfMonths(e),n=s[1],r=17;e.dpDiv.removeClass("ui-datepicker-multi-2 ui-datepicker-multi-3 ui-datepicker-multi-4").width(""),n>1&&e.dpDiv.addClass("ui-datepicker-multi-"+n).css("width",r*n+"em"),e.dpDiv[(1!==s[0]||1!==s[1]?"add":"remove")+"Class"]("ui-datepicker-multi"),e.dpDiv[(this._get(e,"isRTL")?"add":"remove")+"Class"]("ui-datepicker-rtl"),e===t.datepicker._curInst&&t.datepicker._datepickerShowing&&t.datepicker._shouldFocusInput(e)&&e.input.focus(),e.yearshtml&&(i=e.yearshtml,setTimeout(function(){i===e.yearshtml&&e.yearshtml&&e.dpDiv.find("select.ui-datepicker-year:first").replaceWith(e.yearshtml),i=e.yearshtml=null},0))},_shouldFocusInput:function(t){return t.input&&t.input.is(":visible")&&!t.input.is(":disabled")&&!t.input.is(":focus")},_checkOffset:function(e,i,s){var n=e.dpDiv.outerWidth(),a=e.dpDiv.outerHeight(),r=e.input?e.input.outerWidth():0,o=e.input?e.input.outerHeight():0,h=document.documentElement.clientWidth+(s?0:t(document).scrollLeft()),l=document.documentElement.clientHeight+(s?0:t(document).scrollTop());return i.left-=this._get(e,"isRTL")?n-r:0,i.left-=s&&i.left===e.input.offset().left?t(document).scrollLeft():0,i.top-=s&&i.top===e.input.offset().top+o?t(document).scrollTop():0,i.left-=Math.min(i.left,i.left+n>h&&h>n?Math.abs(i.left+n-h):0),i.top-=Math.min(i.top,i.top+a>l&&l>a?Math.abs(a+o):0),i},_findPos:function(e){for(var i,s=this._getInst(e),n=this._get(s,"isRTL");e&&("hidden"===e.type||1!==e.nodeType||t.expr.filters.hidden(e));)e=e[n?"previousSibling":"nextSibling"];return i=t(e).offset(),[i.left,i.top]},_hideDatepicker:function(e){var i,s,n,a,o=this._curInst;!o||e&&o!==t.data(e,r)||this._datepickerShowing&&(i=this._get(o,"showAnim"),s=this._get(o,"duration"),n=function(){t.datepicker._tidyDialog(o)},t.effects&&(t.effects.effect[i]||t.effects[i])?o.dpDiv.hide(i,t.datepicker._get(o,"showOptions"),s,n):o.dpDiv["slideDown"===i?"slideUp":"fadeIn"===i?"fadeOut":"hide"](i?s:null,n),i||n(),this._datepickerShowing=!1,a=this._get(o,"onClose"),a&&a.apply(o.input?o.input[0]:null,[o.input?o.input.val():"",o]),this._lastInput=null,this._inDialog&&(this._dialogInput.css({position:"absolute",left:"0",top:"-100px"}),t.blockUI&&(t.unblockUI(),t("body").append(this.dpDiv))),this._inDialog=!1)},_tidyDialog:function(t){t.dpDiv.removeClass(this._dialogClass).unbind(".ui-datepicker-calendar")},_checkExternalClick:function(e){if(t.datepicker._curInst){var i=t(e.target),s=t.datepicker._getInst(i[0]);(i[0].id!==t.datepicker._mainDivId&&0===i.parents("#"+t.datepicker._mainDivId).length&&!i.hasClass(t.datepicker.markerClassName)&&!i.closest("."+t.datepicker._triggerClass).length&&t.datepicker._datepickerShowing&&(!t.datepicker._inDialog||!t.blockUI)||i.hasClass(t.datepicker.markerClassName)&&t.datepicker._curInst!==s)&&t.datepicker._hideDatepicker()}},_adjustDate:function(e,i,s){var n=t(e),a=this._getInst(n[0]);this._isDisabledDatepicker(n[0])||(this._adjustInstDate(a,i+("M"===s?this._get(a,"showCurrentAtPos"):0),s),this._updateDatepicker(a))},_gotoToday:function(e){var i,s=t(e),n=this._getInst(s[0]);this._get(n,"gotoCurrent")&&n.currentDay?(n.selectedDay=n.currentDay,n.drawMonth=n.selectedMonth=n.currentMonth,n.drawYear=n.selectedYear=n.currentYear):(i=new Date,n.selectedDay=i.getDate(),n.drawMonth=n.selectedMonth=i.getMonth(),n.drawYear=n.selectedYear=i.getFullYear()),this._notifyChange(n),this._adjustDate(s)},_selectMonthYear:function(e,i,s){var n=t(e),a=this._getInst(n[0]);a["selected"+("M"===s?"Month":"Year")]=a["draw"+("M"===s?"Month":"Year")]=parseInt(i.options[i.selectedIndex].value,10),this._notifyChange(a),this._adjustDate(n)},_selectDay:function(e,i,s,n){var a,r=t(e);t(n).hasClass(this._unselectableClass)||this._isDisabledDatepicker(r[0])||(a=this._getInst(r[0]),a.selectedDay=a.currentDay=t("a",n).html(),a.selectedMonth=a.currentMonth=i,a.selectedYear=a.currentYear=s,this._selectDate(e,this._formatDate(a,a.currentDay,a.currentMonth,a.currentYear)))},_clearDate:function(e){var i=t(e);this._selectDate(i,"")},_selectDate:function(e,i){var s,n=t(e),a=this._getInst(n[0]);i=null!=i?i:this._formatDate(a),a.input&&a.input.val(i),this._updateAlternate(a),s=this._get(a,"onSelect"),s?s.apply(a.input?a.input[0]:null,[i,a]):a.input&&a.input.trigger("change"),a.inline?this._updateDatepicker(a):(this._hideDatepicker(),this._lastInput=a.input[0],"object"!=typeof a.input[0]&&a.input.focus(),this._lastInput=null)},_updateAlternate:function(e){var i,s,n,a=this._get(e,"altField");a&&(i=this._get(e,"altFormat")||this._get(e,"dateFormat"),s=this._getDate(e),n=this.formatDate(i,s,this._getFormatConfig(e)),t(a).each(function(){t(this).val(n)}))},noWeekends:function(t){var e=t.getDay();return[e>0&&6>e,""]},iso8601Week:function(t){var e,i=new Date(t.getTime());return i.setDate(i.getDate()+4-(i.getDay()||7)),e=i.getTime(),i.setMonth(0),i.setDate(1),Math.floor(Math.round((e-i)/864e5)/7)+1},parseDate:function(i,s,n){if(null==i||null==s)throw"Invalid arguments";if(s="object"==typeof s?""+s:s+"",""===s)return null;var a,r,o,h,l=0,c=(n?n.shortYearCutoff:null)||this._defaults.shortYearCutoff,u="string"!=typeof c?c:(new Date).getFullYear()%100+parseInt(c,10),d=(n?n.dayNamesShort:null)||this._defaults.dayNamesShort,p=(n?n.dayNames:null)||this._defaults.dayNames,f=(n?n.monthNamesShort:null)||this._defaults.monthNamesShort,m=(n?n.monthNames:null)||this._defaults.monthNames,g=-1,v=-1,_=-1,b=-1,y=!1,x=function(t){var e=i.length>a+1&&i.charAt(a+1)===t;return e&&a++,e},k=function(t){var e=x(t),i="@"===t?14:"!"===t?20:"y"===t&&e?4:"o"===t?3:2,n=RegExp("^\\d{1,"+i+"}"),a=s.substring(l).match(n);if(!a)throw"Missing number at position "+l;return l+=a[0].length,parseInt(a[0],10)},w=function(i,n,a){var r=-1,o=t.map(x(i)?a:n,function(t,e){return[[e,t]]}).sort(function(t,e){return-(t[1].length-e[1].length)});if(t.each(o,function(t,i){var n=i[1];return s.substr(l,n.length).toLowerCase()===n.toLowerCase()?(r=i[0],l+=n.length,!1):e}),-1!==r)return r+1;throw"Unknown name at position "+l},D=function(){if(s.charAt(l)!==i.charAt(a))throw"Unexpected literal at position "+l;l++};for(a=0;i.length>a;a++)if(y)"'"!==i.charAt(a)||x("'")?D():y=!1;else switch(i.charAt(a)){case"d":_=k("d");break;case"D":w("D",d,p);break;case"o":b=k("o");break;case"m":v=k("m");break;case"M":v=w("M",f,m);break;case"y":g=k("y");break;case"@":h=new Date(k("@")),g=h.getFullYear(),v=h.getMonth()+1,_=h.getDate();break;case"!":h=new Date((k("!")-this._ticksTo1970)/1e4),g=h.getFullYear(),v=h.getMonth()+1,_=h.getDate();break;case"'":x("'")?D():y=!0;break;default:D()}if(s.length>l&&(o=s.substr(l),!/^\s+/.test(o)))throw"Extra/unparsed characters found in date: "+o;if(-1===g?g=(new Date).getFullYear():100>g&&(g+=(new Date).getFullYear()-(new Date).getFullYear()%100+(u>=g?0:-100)),b>-1)for(v=1,_=b;;){if(r=this._getDaysInMonth(g,v-1),r>=_)break;v++,_-=r}if(h=this._daylightSavingAdjust(new Date(g,v-1,_)),h.getFullYear()!==g||h.getMonth()+1!==v||h.getDate()!==_)throw"Invalid date";return h},ATOM:"yy-mm-dd",COOKIE:"D, dd M yy",ISO_8601:"yy-mm-dd",RFC_822:"D, d M y",RFC_850:"DD, dd-M-y",RFC_1036:"D, d M y",RFC_1123:"D, d M yy",RFC_2822:"D, d M yy",RSS:"D, d M y",TICKS:"!",TIMESTAMP:"@",W3C:"yy-mm-dd",_ticksTo1970:1e7*60*60*24*(718685+Math.floor(492.5)-Math.floor(19.7)+Math.floor(4.925)),formatDate:function(t,e,i){if(!e)return"";var s,n=(i?i.dayNamesShort:null)||this._defaults.dayNamesShort,a=(i?i.dayNames:null)||this._defaults.dayNames,r=(i?i.monthNamesShort:null)||this._defaults.monthNamesShort,o=(i?i.monthNames:null)||this._defaults.monthNames,h=function(e){var i=t.length>s+1&&t.charAt(s+1)===e;return i&&s++,i},l=function(t,e,i){var s=""+e;if(h(t))for(;i>s.length;)s="0"+s;return s},c=function(t,e,i,s){return h(t)?s[e]:i[e]},u="",d=!1;if(e)for(s=0;t.length>s;s++)if(d)"'"!==t.charAt(s)||h("'")?u+=t.charAt(s):d=!1;else switch(t.charAt(s)){case"d":u+=l("d",e.getDate(),2);break;case"D":u+=c("D",e.getDay(),n,a);break;case"o":u+=l("o",Math.round((new Date(e.getFullYear(),e.getMonth(),e.getDate()).getTime()-new Date(e.getFullYear(),0,0).getTime())/864e5),3);break;case"m":u+=l("m",e.getMonth()+1,2);break;case"M":u+=c("M",e.getMonth(),r,o);break;case"y":u+=h("y")?e.getFullYear():(10>e.getYear()%100?"0":"")+e.getYear()%100;break;case"@":u+=e.getTime();break;case"!":u+=1e4*e.getTime()+this._ticksTo1970;break;case"'":h("'")?u+="'":d=!0;break;default:u+=t.charAt(s)}return u},_possibleChars:function(t){var e,i="",s=!1,n=function(i){var s=t.length>e+1&&t.charAt(e+1)===i;return s&&e++,s};for(e=0;t.length>e;e++)if(s)"'"!==t.charAt(e)||n("'")?i+=t.charAt(e):s=!1;else switch(t.charAt(e)){case"d":case"m":case"y":case"@":i+="0123456789";break;case"D":case"M":return null;case"'":n("'")?i+="'":s=!0;break;default:i+=t.charAt(e)}return i},_get:function(t,i){return t.settings[i]!==e?t.settings[i]:this._defaults[i]},_setDateFromField:function(t,e){if(t.input.val()!==t.lastVal){var i=this._get(t,"dateFormat"),s=t.lastVal=t.input?t.input.val():null,n=this._getDefaultDate(t),a=n,r=this._getFormatConfig(t);try{a=this.parseDate(i,s,r)||n}catch(o){s=e?"":s}t.selectedDay=a.getDate(),t.drawMonth=t.selectedMonth=a.getMonth(),t.drawYear=t.selectedYear=a.getFullYear(),t.currentDay=s?a.getDate():0,t.currentMonth=s?a.getMonth():0,t.currentYear=s?a.getFullYear():0,this._adjustInstDate(t)}},_getDefaultDate:function(t){return this._restrictMinMax(t,this._determineDate(t,this._get(t,"defaultDate"),new Date))},_determineDate:function(e,i,s){var n=function(t){var e=new Date;return e.setDate(e.getDate()+t),e},a=function(i){try{return t.datepicker.parseDate(t.datepicker._get(e,"dateFormat"),i,t.datepicker._getFormatConfig(e))}catch(s){}for(var n=(i.toLowerCase().match(/^c/)?t.datepicker._getDate(e):null)||new Date,a=n.getFullYear(),r=n.getMonth(),o=n.getDate(),h=/([+\-]?[0-9]+)\s*(d|D|w|W|m|M|y|Y)?/g,l=h.exec(i);l;){switch(l[2]||"d"){case"d":case"D":o+=parseInt(l[1],10);break;case"w":case"W":o+=7*parseInt(l[1],10);break;case"m":case"M":r+=parseInt(l[1],10),o=Math.min(o,t.datepicker._getDaysInMonth(a,r));break;case"y":case"Y":a+=parseInt(l[1],10),o=Math.min(o,t.datepicker._getDaysInMonth(a,r))}l=h.exec(i)}return new Date(a,r,o)},r=null==i||""===i?s:"string"==typeof i?a(i):"number"==typeof i?isNaN(i)?s:n(i):new Date(i.getTime());return r=r&&"Invalid Date"==""+r?s:r,r&&(r.setHours(0),r.setMinutes(0),r.setSeconds(0),r.setMilliseconds(0)),this._daylightSavingAdjust(r)},_daylightSavingAdjust:function(t){return t?(t.setHours(t.getHours()>12?t.getHours()+2:0),t):null},_setDate:function(t,e,i){var s=!e,n=t.selectedMonth,a=t.selectedYear,r=this._restrictMinMax(t,this._determineDate(t,e,new Date));t.selectedDay=t.currentDay=r.getDate(),t.drawMonth=t.selectedMonth=t.currentMonth=r.getMonth(),t.drawYear=t.selectedYear=t.currentYear=r.getFullYear(),n===t.selectedMonth&&a===t.selectedYear||i||this._notifyChange(t),this._adjustInstDate(t),t.input&&t.input.val(s?"":this._formatDate(t))},_getDate:function(t){var e=!t.currentYear||t.input&&""===t.input.val()?null:this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return e},_attachHandlers:function(e){var i=this._get(e,"stepMonths"),s="#"+e.id.replace(/\\\\/g,"\\");e.dpDiv.find("[data-handler]").map(function(){var e={prev:function(){t.datepicker._adjustDate(s,-i,"M")},next:function(){t.datepicker._adjustDate(s,+i,"M")},hide:function(){t.datepicker._hideDatepicker()},today:function(){t.datepicker._gotoToday(s)},selectDay:function(){return t.datepicker._selectDay(s,+this.getAttribute("data-month"),+this.getAttribute("data-year"),this),!1},selectMonth:function(){return t.datepicker._selectMonthYear(s,this,"M"),!1},selectYear:function(){return t.datepicker._selectMonthYear(s,this,"Y"),!1}};t(this).bind(this.getAttribute("data-event"),e[this.getAttribute("data-handler")])})},_generateHTML:function(t){var e,i,s,n,a,r,o,h,l,c,u,d,p,f,m,g,v,_,b,y,x,k,w,D,T,C,M,S,N,I,P,A,z,H,E,F,O,W,j,R=new Date,L=this._daylightSavingAdjust(new Date(R.getFullYear(),R.getMonth(),R.getDate())),Y=this._get(t,"isRTL"),B=this._get(t,"showButtonPanel"),J=this._get(t,"hideIfNoPrevNext"),K=this._get(t,"navigationAsDateFormat"),Q=this._getNumberOfMonths(t),V=this._get(t,"showCurrentAtPos"),U=this._get(t,"stepMonths"),q=1!==Q[0]||1!==Q[1],X=this._daylightSavingAdjust(t.currentDay?new Date(t.currentYear,t.currentMonth,t.currentDay):new Date(9999,9,9)),G=this._getMinMaxDate(t,"min"),$=this._getMinMaxDate(t,"max"),Z=t.drawMonth-V,te=t.drawYear;if(0>Z&&(Z+=12,te--),$)for(e=this._daylightSavingAdjust(new Date($.getFullYear(),$.getMonth()-Q[0]*Q[1]+1,$.getDate())),e=G&&G>e?G:e;this._daylightSavingAdjust(new Date(te,Z,1))>e;)Z--,0>Z&&(Z=11,te--);for(t.drawMonth=Z,t.drawYear=te,i=this._get(t,"prevText"),i=K?this.formatDate(i,this._daylightSavingAdjust(new Date(te,Z-U,1)),this._getFormatConfig(t)):i,s=this._canAdjustMonth(t,-1,te,Z)?"<a class='ui-datepicker-prev ui-corner-all' data-handler='prev' data-event='click' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"e":"w")+"'>"+i+"</span></a>":J?"":"<a class='ui-datepicker-prev ui-corner-all ui-state-disabled' title='"+i+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"e":"w")+"'>"+i+"</span></a>",n=this._get(t,"nextText"),n=K?this.formatDate(n,this._daylightSavingAdjust(new Date(te,Z+U,1)),this._getFormatConfig(t)):n,a=this._canAdjustMonth(t,1,te,Z)?"<a class='ui-datepicker-next ui-corner-all' data-handler='next' data-event='click' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"w":"e")+"'>"+n+"</span></a>":J?"":"<a class='ui-datepicker-next ui-corner-all ui-state-disabled' title='"+n+"'><span class='ui-icon ui-icon-circle-triangle-"+(Y?"w":"e")+"'>"+n+"</span></a>",r=this._get(t,"currentText"),o=this._get(t,"gotoCurrent")&&t.currentDay?X:L,r=K?this.formatDate(r,o,this._getFormatConfig(t)):r,h=t.inline?"":"<button type='button' class='ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all' data-handler='hide' data-event='click'>"+this._get(t,"closeText")+"</button>",l=B?"<div class='ui-datepicker-buttonpane ui-widget-content'>"+(Y?h:"")+(this._isInRange(t,o)?"<button type='button' class='ui-datepicker-current ui-state-default ui-priority-secondary ui-corner-all' data-handler='today' data-event='click'>"+r+"</button>":"")+(Y?"":h)+"</div>":"",c=parseInt(this._get(t,"firstDay"),10),c=isNaN(c)?0:c,u=this._get(t,"showWeek"),d=this._get(t,"dayNames"),p=this._get(t,"dayNamesMin"),f=this._get(t,"monthNames"),m=this._get(t,"monthNamesShort"),g=this._get(t,"beforeShowDay"),v=this._get(t,"showOtherMonths"),_=this._get(t,"selectOtherMonths"),b=this._getDefaultDate(t),y="",k=0;Q[0]>k;k++){for(w="",this.maxRows=4,D=0;Q[1]>D;D++){if(T=this._daylightSavingAdjust(new Date(te,Z,t.selectedDay)),C=" ui-corner-all",M="",q){if(M+="<div class='ui-datepicker-group",Q[1]>1)switch(D){case 0:M+=" ui-datepicker-group-first",C=" ui-corner-"+(Y?"right":"left");break;case Q[1]-1:M+=" ui-datepicker-group-last",C=" ui-corner-"+(Y?"left":"right");break;default:M+=" ui-datepicker-group-middle",C=""}M+="'>"}for(M+="<div class='ui-datepicker-header ui-widget-header ui-helper-clearfix"+C+"'>"+(/all|left/.test(C)&&0===k?Y?a:s:"")+(/all|right/.test(C)&&0===k?Y?s:a:"")+this._generateMonthYearHeader(t,Z,te,G,$,k>0||D>0,f,m)+"</div><table class='ui-datepicker-calendar'><thead>"+"<tr>",S=u?"<th class='ui-datepicker-week-col'>"+this._get(t,"weekHeader")+"</th>":"",x=0;7>x;x++)N=(x+c)%7,S+="<th"+((x+c+6)%7>=5?" class='ui-datepicker-week-end'":"")+">"+"<span title='"+d[N]+"'>"+p[N]+"</span></th>";for(M+=S+"</tr></thead><tbody>",I=this._getDaysInMonth(te,Z),te===t.selectedYear&&Z===t.selectedMonth&&(t.selectedDay=Math.min(t.selectedDay,I)),P=(this._getFirstDayOfMonth(te,Z)-c+7)%7,A=Math.ceil((P+I)/7),z=q?this.maxRows>A?this.maxRows:A:A,this.maxRows=z,H=this._daylightSavingAdjust(new Date(te,Z,1-P)),E=0;z>E;E++){for(M+="<tr>",F=u?"<td class='ui-datepicker-week-col'>"+this._get(t,"calculateWeek")(H)+"</td>":"",x=0;7>x;x++)O=g?g.apply(t.input?t.input[0]:null,[H]):[!0,""],W=H.getMonth()!==Z,j=W&&!_||!O[0]||G&&G>H||$&&H>$,F+="<td class='"+((x+c+6)%7>=5?" ui-datepicker-week-end":"")+(W?" ui-datepicker-other-month":"")+(H.getTime()===T.getTime()&&Z===t.selectedMonth&&t._keyEvent||b.getTime()===H.getTime()&&b.getTime()===T.getTime()?" "+this._dayOverClass:"")+(j?" "+this._unselectableClass+" ui-state-disabled":"")+(W&&!v?"":" "+O[1]+(H.getTime()===X.getTime()?" "+this._currentClass:"")+(H.getTime()===L.getTime()?" ui-datepicker-today":""))+"'"+(W&&!v||!O[2]?"":" title='"+O[2].replace(/'/g,"&#39;")+"'")+(j?"":" data-handler='selectDay' data-event='click' data-month='"+H.getMonth()+"' data-year='"+H.getFullYear()+"'")+">"+(W&&!v?"&#xa0;":j?"<span class='ui-state-default'>"+H.getDate()+"</span>":"<a class='ui-state-default"+(H.getTime()===L.getTime()?" ui-state-highlight":"")+(H.getTime()===X.getTime()?" ui-state-active":"")+(W?" ui-priority-secondary":"")+"' href='#'>"+H.getDate()+"</a>")+"</td>",H.setDate(H.getDate()+1),H=this._daylightSavingAdjust(H);M+=F+"</tr>"}Z++,Z>11&&(Z=0,te++),M+="</tbody></table>"+(q?"</div>"+(Q[0]>0&&D===Q[1]-1?"<div class='ui-datepicker-row-break'></div>":""):""),w+=M}y+=w}return y+=l,t._keyEvent=!1,y},_generateMonthYearHeader:function(t,e,i,s,n,a,r,o){var h,l,c,u,d,p,f,m,g=this._get(t,"changeMonth"),v=this._get(t,"changeYear"),_=this._get(t,"showMonthAfterYear"),b="<div class='ui-datepicker-title'>",y="";if(a||!g)y+="<span class='ui-datepicker-month'>"+r[e]+"</span>";else{for(h=s&&s.getFullYear()===i,l=n&&n.getFullYear()===i,y+="<select class='ui-datepicker-month' data-handler='selectMonth' data-event='change'>",c=0;12>c;c++)(!h||c>=s.getMonth())&&(!l||n.getMonth()>=c)&&(y+="<option value='"+c+"'"+(c===e?" selected='selected'":"")+">"+o[c]+"</option>");y+="</select>"}if(_||(b+=y+(!a&&g&&v?"":"&#xa0;")),!t.yearshtml)if(t.yearshtml="",a||!v)b+="<span class='ui-datepicker-year'>"+i+"</span>";else{for(u=this._get(t,"yearRange").split(":"),d=(new Date).getFullYear(),p=function(t){var e=t.match(/c[+\-].*/)?i+parseInt(t.substring(1),10):t.match(/[+\-].*/)?d+parseInt(t,10):parseInt(t,10);
	return isNaN(e)?d:e},f=p(u[0]),m=Math.max(f,p(u[1]||"")),f=s?Math.max(f,s.getFullYear()):f,m=n?Math.min(m,n.getFullYear()):m,t.yearshtml+="<select class='ui-datepicker-year' data-handler='selectYear' data-event='change'>";m>=f;f++)t.yearshtml+="<option value='"+f+"'"+(f===i?" selected='selected'":"")+">"+f+"</option>";t.yearshtml+="</select>",b+=t.yearshtml,t.yearshtml=null}return b+=this._get(t,"yearSuffix"),_&&(b+=(!a&&g&&v?"":"&#xa0;")+y),b+="</div>"},_adjustInstDate:function(t,e,i){var s=t.drawYear+("Y"===i?e:0),n=t.drawMonth+("M"===i?e:0),a=Math.min(t.selectedDay,this._getDaysInMonth(s,n))+("D"===i?e:0),r=this._restrictMinMax(t,this._daylightSavingAdjust(new Date(s,n,a)));t.selectedDay=r.getDate(),t.drawMonth=t.selectedMonth=r.getMonth(),t.drawYear=t.selectedYear=r.getFullYear(),("M"===i||"Y"===i)&&this._notifyChange(t)},_restrictMinMax:function(t,e){var i=this._getMinMaxDate(t,"min"),s=this._getMinMaxDate(t,"max"),n=i&&i>e?i:e;return s&&n>s?s:n},_notifyChange:function(t){var e=this._get(t,"onChangeMonthYear");e&&e.apply(t.input?t.input[0]:null,[t.selectedYear,t.selectedMonth+1,t])},_getNumberOfMonths:function(t){var e=this._get(t,"numberOfMonths");return null==e?[1,1]:"number"==typeof e?[1,e]:e},_getMinMaxDate:function(t,e){return this._determineDate(t,this._get(t,e+"Date"),null)},_getDaysInMonth:function(t,e){return 32-this._daylightSavingAdjust(new Date(t,e,32)).getDate()},_getFirstDayOfMonth:function(t,e){return new Date(t,e,1).getDay()},_canAdjustMonth:function(t,e,i,s){var n=this._getNumberOfMonths(t),a=this._daylightSavingAdjust(new Date(i,s+(0>e?e:n[0]*n[1]),1));return 0>e&&a.setDate(this._getDaysInMonth(a.getFullYear(),a.getMonth())),this._isInRange(t,a)},_isInRange:function(t,e){var i,s,n=this._getMinMaxDate(t,"min"),a=this._getMinMaxDate(t,"max"),r=null,o=null,h=this._get(t,"yearRange");return h&&(i=h.split(":"),s=(new Date).getFullYear(),r=parseInt(i[0],10),o=parseInt(i[1],10),i[0].match(/[+\-].*/)&&(r+=s),i[1].match(/[+\-].*/)&&(o+=s)),(!n||e.getTime()>=n.getTime())&&(!a||e.getTime()<=a.getTime())&&(!r||e.getFullYear()>=r)&&(!o||o>=e.getFullYear())},_getFormatConfig:function(t){var e=this._get(t,"shortYearCutoff");return e="string"!=typeof e?e:(new Date).getFullYear()%100+parseInt(e,10),{shortYearCutoff:e,dayNamesShort:this._get(t,"dayNamesShort"),dayNames:this._get(t,"dayNames"),monthNamesShort:this._get(t,"monthNamesShort"),monthNames:this._get(t,"monthNames")}},_formatDate:function(t,e,i,s){e||(t.currentDay=t.selectedDay,t.currentMonth=t.selectedMonth,t.currentYear=t.selectedYear);var n=e?"object"==typeof e?e:this._daylightSavingAdjust(new Date(s,i,e)):this._daylightSavingAdjust(new Date(t.currentYear,t.currentMonth,t.currentDay));return this.formatDate(this._get(t,"dateFormat"),n,this._getFormatConfig(t))}}),t.fn.datepicker=function(e){if(!this.length)return this;t.datepicker.initialized||(t(document).mousedown(t.datepicker._checkExternalClick),t.datepicker.initialized=!0),0===t("#"+t.datepicker._mainDivId).length&&t("body").append(t.datepicker.dpDiv);var i=Array.prototype.slice.call(arguments,1);return"string"!=typeof e||"isDisabled"!==e&&"getDate"!==e&&"widget"!==e?"option"===e&&2===arguments.length&&"string"==typeof arguments[1]?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i)):this.each(function(){"string"==typeof e?t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this].concat(i)):t.datepicker._attachDatepicker(this,e)}):t.datepicker["_"+e+"Datepicker"].apply(t.datepicker,[this[0]].concat(i))},t.datepicker=new i,t.datepicker.initialized=!1,t.datepicker.uuid=(new Date).getTime(),t.datepicker.version="1.10.3"})(jQuery);(function(t){var e={buttons:!0,height:!0,maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0,width:!0},i={maxHeight:!0,maxWidth:!0,minHeight:!0,minWidth:!0};t.widget("ui.dialog",{version:"1.10.3",options:{appendTo:"body",autoOpen:!0,buttons:[],closeOnEscape:!0,closeText:"close",dialogClass:"",draggable:!0,hide:null,height:"auto",maxHeight:null,maxWidth:null,minHeight:150,minWidth:150,modal:!1,position:{my:"center",at:"center",of:window,collision:"fit",using:function(e){var i=t(this).css(e).offset().top;0>i&&t(this).css("top",e.top-i)}},resizable:!0,show:null,title:null,width:300,beforeClose:null,close:null,drag:null,dragStart:null,dragStop:null,focus:null,open:null,resize:null,resizeStart:null,resizeStop:null},_create:function(){this.originalCss={display:this.element[0].style.display,width:this.element[0].style.width,minHeight:this.element[0].style.minHeight,maxHeight:this.element[0].style.maxHeight,height:this.element[0].style.height},this.originalPosition={parent:this.element.parent(),index:this.element.parent().children().index(this.element)},this.originalTitle=this.element.attr("title"),this.options.title=this.options.title||this.originalTitle,this._createWrapper(),this.element.show().removeAttr("title").addClass("ui-dialog-content ui-widget-content").appendTo(this.uiDialog),this._createTitlebar(),this._createButtonPane(),this.options.draggable&&t.fn.draggable&&this._makeDraggable(),this.options.resizable&&t.fn.resizable&&this._makeResizable(),this._isOpen=!1},_init:function(){this.options.autoOpen&&this.open()},_appendTo:function(){var e=this.options.appendTo;return e&&(e.jquery||e.nodeType)?t(e):this.document.find(e||"body").eq(0)},_destroy:function(){var t,e=this.originalPosition;this._destroyOverlay(),this.element.removeUniqueId().removeClass("ui-dialog-content ui-widget-content").css(this.originalCss).detach(),this.uiDialog.stop(!0,!0).remove(),this.originalTitle&&this.element.attr("title",this.originalTitle),t=e.parent.children().eq(e.index),t.length&&t[0]!==this.element[0]?t.before(this.element):e.parent.append(this.element)},widget:function(){return this.uiDialog},disable:t.noop,enable:t.noop,close:function(e){var i=this;this._isOpen&&this._trigger("beforeClose",e)!==!1&&(this._isOpen=!1,this._destroyOverlay(),this.opener.filter(":focusable").focus().length||t(this.document[0].activeElement).blur(),this._hide(this.uiDialog,this.options.hide,function(){i._trigger("close",e)}))},isOpen:function(){return this._isOpen},moveToTop:function(){this._moveToTop()},_moveToTop:function(t,e){var i=!!this.uiDialog.nextAll(":visible").insertBefore(this.uiDialog).length;return i&&!e&&this._trigger("focus",t),i},open:function(){var e=this;return this._isOpen?(this._moveToTop()&&this._focusTabbable(),undefined):(this._isOpen=!0,this.opener=t(this.document[0].activeElement),this._size(),this._position(),this._createOverlay(),this._moveToTop(null,!0),this._show(this.uiDialog,this.options.show,function(){e._focusTabbable(),e._trigger("focus")}),this._trigger("open"),undefined)},_focusTabbable:function(){var t=this.element.find("[autofocus]");t.length||(t=this.element.find(":tabbable")),t.length||(t=this.uiDialogButtonPane.find(":tabbable")),t.length||(t=this.uiDialogTitlebarClose.filter(":tabbable")),t.length||(t=this.uiDialog),t.eq(0).focus()},_keepFocus:function(e){function i(){var e=this.document[0].activeElement,i=this.uiDialog[0]===e||t.contains(this.uiDialog[0],e);i||this._focusTabbable()}e.preventDefault(),i.call(this),this._delay(i)},_createWrapper:function(){this.uiDialog=t("<div>").addClass("ui-dialog ui-widget ui-widget-content ui-corner-all ui-front "+this.options.dialogClass).hide().attr({tabIndex:-1,role:"dialog"}).appendTo(this._appendTo()),this._on(this.uiDialog,{keydown:function(e){if(this.options.closeOnEscape&&!e.isDefaultPrevented()&&e.keyCode&&e.keyCode===t.ui.keyCode.ESCAPE)return e.preventDefault(),this.close(e),undefined;if(e.keyCode===t.ui.keyCode.TAB){var i=this.uiDialog.find(":tabbable"),s=i.filter(":first"),n=i.filter(":last");e.target!==n[0]&&e.target!==this.uiDialog[0]||e.shiftKey?e.target!==s[0]&&e.target!==this.uiDialog[0]||!e.shiftKey||(n.focus(1),e.preventDefault()):(s.focus(1),e.preventDefault())}},mousedown:function(t){this._moveToTop(t)&&this._focusTabbable()}}),this.element.find("[aria-describedby]").length||this.uiDialog.attr({"aria-describedby":this.element.uniqueId().attr("id")})},_createTitlebar:function(){var e;this.uiDialogTitlebar=t("<div>").addClass("ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix").prependTo(this.uiDialog),this._on(this.uiDialogTitlebar,{mousedown:function(e){t(e.target).closest(".ui-dialog-titlebar-close")||this.uiDialog.focus()}}),this.uiDialogTitlebarClose=t("<button></button>").button({label:this.options.closeText,icons:{primary:"ui-icon-closethick"},text:!1}).addClass("ui-dialog-titlebar-close").appendTo(this.uiDialogTitlebar),this._on(this.uiDialogTitlebarClose,{click:function(t){t.preventDefault(),this.close(t)}}),e=t("<span>").uniqueId().addClass("ui-dialog-title").prependTo(this.uiDialogTitlebar),this._title(e),this.uiDialog.attr({"aria-labelledby":e.attr("id")})},_title:function(t){this.options.title||t.html("&#160;"),t.text(this.options.title)},_createButtonPane:function(){this.uiDialogButtonPane=t("<div>").addClass("ui-dialog-buttonpane ui-widget-content ui-helper-clearfix"),this.uiButtonSet=t("<div>").addClass("ui-dialog-buttonset").appendTo(this.uiDialogButtonPane),this._createButtons()},_createButtons:function(){var e=this,i=this.options.buttons;return this.uiDialogButtonPane.remove(),this.uiButtonSet.empty(),t.isEmptyObject(i)||t.isArray(i)&&!i.length?(this.uiDialog.removeClass("ui-dialog-buttons"),undefined):(t.each(i,function(i,s){var n,a;s=t.isFunction(s)?{click:s,text:i}:s,s=t.extend({type:"button"},s),n=s.click,s.click=function(){n.apply(e.element[0],arguments)},a={icons:s.icons,text:s.showText},delete s.icons,delete s.showText,t("<button></button>",s).button(a).appendTo(e.uiButtonSet)}),this.uiDialog.addClass("ui-dialog-buttons"),this.uiDialogButtonPane.appendTo(this.uiDialog),undefined)},_makeDraggable:function(){function e(t){return{position:t.position,offset:t.offset}}var i=this,s=this.options;this.uiDialog.draggable({cancel:".ui-dialog-content, .ui-dialog-titlebar-close",handle:".ui-dialog-titlebar",containment:"document",start:function(s,n){t(this).addClass("ui-dialog-dragging"),i._blockFrames(),i._trigger("dragStart",s,e(n))},drag:function(t,s){i._trigger("drag",t,e(s))},stop:function(n,a){s.position=[a.position.left-i.document.scrollLeft(),a.position.top-i.document.scrollTop()],t(this).removeClass("ui-dialog-dragging"),i._unblockFrames(),i._trigger("dragStop",n,e(a))}})},_makeResizable:function(){function e(t){return{originalPosition:t.originalPosition,originalSize:t.originalSize,position:t.position,size:t.size}}var i=this,s=this.options,n=s.resizable,a=this.uiDialog.css("position"),o="string"==typeof n?n:"n,e,s,w,se,sw,ne,nw";this.uiDialog.resizable({cancel:".ui-dialog-content",containment:"document",alsoResize:this.element,maxWidth:s.maxWidth,maxHeight:s.maxHeight,minWidth:s.minWidth,minHeight:this._minHeight(),handles:o,start:function(s,n){t(this).addClass("ui-dialog-resizing"),i._blockFrames(),i._trigger("resizeStart",s,e(n))},resize:function(t,s){i._trigger("resize",t,e(s))},stop:function(n,a){s.height=t(this).height(),s.width=t(this).width(),t(this).removeClass("ui-dialog-resizing"),i._unblockFrames(),i._trigger("resizeStop",n,e(a))}}).css("position",a)},_minHeight:function(){var t=this.options;return"auto"===t.height?t.minHeight:Math.min(t.minHeight,t.height)},_position:function(){var t=this.uiDialog.is(":visible");t||this.uiDialog.show(),this.uiDialog.position(this.options.position),t||this.uiDialog.hide()},_setOptions:function(s){var n=this,a=!1,o={};t.each(s,function(t,s){n._setOption(t,s),t in e&&(a=!0),t in i&&(o[t]=s)}),a&&(this._size(),this._position()),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option",o)},_setOption:function(t,e){var i,s,n=this.uiDialog;"dialogClass"===t&&n.removeClass(this.options.dialogClass).addClass(e),"disabled"!==t&&(this._super(t,e),"appendTo"===t&&this.uiDialog.appendTo(this._appendTo()),"buttons"===t&&this._createButtons(),"closeText"===t&&this.uiDialogTitlebarClose.button({label:""+e}),"draggable"===t&&(i=n.is(":data(ui-draggable)"),i&&!e&&n.draggable("destroy"),!i&&e&&this._makeDraggable()),"position"===t&&this._position(),"resizable"===t&&(s=n.is(":data(ui-resizable)"),s&&!e&&n.resizable("destroy"),s&&"string"==typeof e&&n.resizable("option","handles",e),s||e===!1||this._makeResizable()),"title"===t&&this._title(this.uiDialogTitlebar.find(".ui-dialog-title")))},_size:function(){var t,e,i,s=this.options;this.element.show().css({width:"auto",minHeight:0,maxHeight:"none",height:0}),s.minWidth>s.width&&(s.width=s.minWidth),t=this.uiDialog.css({height:"auto",width:s.width}).outerHeight(),e=Math.max(0,s.minHeight-t),i="number"==typeof s.maxHeight?Math.max(0,s.maxHeight-t):"none","auto"===s.height?this.element.css({minHeight:e,maxHeight:i,height:"auto"}):this.element.height(Math.max(0,s.height-t)),this.uiDialog.is(":data(ui-resizable)")&&this.uiDialog.resizable("option","minHeight",this._minHeight())},_blockFrames:function(){this.iframeBlocks=this.document.find("iframe").map(function(){var e=t(this);return t("<div>").css({position:"absolute",width:e.outerWidth(),height:e.outerHeight()}).appendTo(e.parent()).offset(e.offset())[0]})},_unblockFrames:function(){this.iframeBlocks&&(this.iframeBlocks.remove(),delete this.iframeBlocks)},_allowInteraction:function(e){return t(e.target).closest(".ui-dialog").length?!0:!!t(e.target).closest(".ui-datepicker").length},_createOverlay:function(){if(this.options.modal){var e=this,i=this.widgetFullName;t.ui.dialog.overlayInstances||this._delay(function(){t.ui.dialog.overlayInstances&&this.document.bind("focusin.dialog",function(s){e._allowInteraction(s)||(s.preventDefault(),t(".ui-dialog:visible:last .ui-dialog-content").data(i)._focusTabbable())})}),this.overlay=t("<div>").addClass("ui-widget-overlay ui-front").appendTo(this._appendTo()),this._on(this.overlay,{mousedown:"_keepFocus"}),t.ui.dialog.overlayInstances++}},_destroyOverlay:function(){this.options.modal&&this.overlay&&(t.ui.dialog.overlayInstances--,t.ui.dialog.overlayInstances||this.document.unbind("focusin.dialog"),this.overlay.remove(),this.overlay=null)}}),t.ui.dialog.overlayInstances=0,t.uiBackCompat!==!1&&t.widget("ui.dialog",t.ui.dialog,{_position:function(){var e,i=this.options.position,s=[],n=[0,0];i?(("string"==typeof i||"object"==typeof i&&"0"in i)&&(s=i.split?i.split(" "):[i[0],i[1]],1===s.length&&(s[1]=s[0]),t.each(["left","top"],function(t,e){+s[t]===s[t]&&(n[t]=s[t],s[t]=e)}),i={my:s[0]+(0>n[0]?n[0]:"+"+n[0])+" "+s[1]+(0>n[1]?n[1]:"+"+n[1]),at:s.join(" ")}),i=t.extend({},t.ui.dialog.prototype.options.position,i)):i=t.ui.dialog.prototype.options.position,e=this.uiDialog.is(":visible"),e||this.uiDialog.show(),this.uiDialog.position(i),e||this.uiDialog.hide()}})})(jQuery);(function(t){t.widget("ui.menu",{version:"1.10.3",defaultElement:"<ul>",delay:300,options:{icons:{submenu:"ui-icon-carat-1-e"},menus:"ul",position:{my:"left top",at:"right top"},role:"menu",blur:null,focus:null,select:null},_create:function(){this.activeMenu=this.element,this.mouseHandled=!1,this.element.uniqueId().addClass("ui-menu ui-widget ui-widget-content ui-corner-all").toggleClass("ui-menu-icons",!!this.element.find(".ui-icon").length).attr({role:this.options.role,tabIndex:0}).bind("click"+this.eventNamespace,t.proxy(function(t){this.options.disabled&&t.preventDefault()},this)),this.options.disabled&&this.element.addClass("ui-state-disabled").attr("aria-disabled","true"),this._on({"mousedown .ui-menu-item > a":function(t){t.preventDefault()},"click .ui-state-disabled > a":function(t){t.preventDefault()},"click .ui-menu-item:has(a)":function(e){var i=t(e.target).closest(".ui-menu-item");!this.mouseHandled&&i.not(".ui-state-disabled").length&&(this.mouseHandled=!0,this.select(e),i.has(".ui-menu").length?this.expand(e):this.element.is(":focus")||(this.element.trigger("focus",[!0]),this.active&&1===this.active.parents(".ui-menu").length&&clearTimeout(this.timer)))},"mouseenter .ui-menu-item":function(e){var i=t(e.currentTarget);i.siblings().children(".ui-state-active").removeClass("ui-state-active"),this.focus(e,i)},mouseleave:"collapseAll","mouseleave .ui-menu":"collapseAll",focus:function(t,e){var i=this.active||this.element.children(".ui-menu-item").eq(0);e||this.focus(t,i)},blur:function(e){this._delay(function(){t.contains(this.element[0],this.document[0].activeElement)||this.collapseAll(e)})},keydown:"_keydown"}),this.refresh(),this._on(this.document,{click:function(e){t(e.target).closest(".ui-menu").length||this.collapseAll(e),this.mouseHandled=!1}})},_destroy:function(){this.element.removeAttr("aria-activedescendant").find(".ui-menu").addBack().removeClass("ui-menu ui-widget ui-widget-content ui-corner-all ui-menu-icons").removeAttr("role").removeAttr("tabIndex").removeAttr("aria-labelledby").removeAttr("aria-expanded").removeAttr("aria-hidden").removeAttr("aria-disabled").removeUniqueId().show(),this.element.find(".ui-menu-item").removeClass("ui-menu-item").removeAttr("role").removeAttr("aria-disabled").children("a").removeUniqueId().removeClass("ui-corner-all ui-state-hover").removeAttr("tabIndex").removeAttr("role").removeAttr("aria-haspopup").children().each(function(){var e=t(this);e.data("ui-menu-submenu-carat")&&e.remove()}),this.element.find(".ui-menu-divider").removeClass("ui-menu-divider ui-widget-content")},_keydown:function(e){function i(t){return t.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g,"\\$&")}var s,n,a,o,r,h=!0;switch(e.keyCode){case t.ui.keyCode.PAGE_UP:this.previousPage(e);break;case t.ui.keyCode.PAGE_DOWN:this.nextPage(e);break;case t.ui.keyCode.HOME:this._move("first","first",e);break;case t.ui.keyCode.END:this._move("last","last",e);break;case t.ui.keyCode.UP:this.previous(e);break;case t.ui.keyCode.DOWN:this.next(e);break;case t.ui.keyCode.LEFT:this.collapse(e);break;case t.ui.keyCode.RIGHT:this.active&&!this.active.is(".ui-state-disabled")&&this.expand(e);break;case t.ui.keyCode.ENTER:case t.ui.keyCode.SPACE:this._activate(e);break;case t.ui.keyCode.ESCAPE:this.collapse(e);break;default:h=!1,n=this.previousFilter||"",a=String.fromCharCode(e.keyCode),o=!1,clearTimeout(this.filterTimer),a===n?o=!0:a=n+a,r=RegExp("^"+i(a),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(t(this).children("a").text())}),s=o&&-1!==s.index(this.active.next())?this.active.nextAll(".ui-menu-item"):s,s.length||(a=String.fromCharCode(e.keyCode),r=RegExp("^"+i(a),"i"),s=this.activeMenu.children(".ui-menu-item").filter(function(){return r.test(t(this).children("a").text())})),s.length?(this.focus(e,s),s.length>1?(this.previousFilter=a,this.filterTimer=this._delay(function(){delete this.previousFilter},1e3)):delete this.previousFilter):delete this.previousFilter}h&&e.preventDefault()},_activate:function(t){this.active.is(".ui-state-disabled")||(this.active.children("a[aria-haspopup='true']").length?this.expand(t):this.select(t))},refresh:function(){var e,i=this.options.icons.submenu,s=this.element.find(this.options.menus);s.filter(":not(.ui-menu)").addClass("ui-menu ui-widget ui-widget-content ui-corner-all").hide().attr({role:this.options.role,"aria-hidden":"true","aria-expanded":"false"}).each(function(){var e=t(this),s=e.prev("a"),n=t("<span>").addClass("ui-menu-icon ui-icon "+i).data("ui-menu-submenu-carat",!0);s.attr("aria-haspopup","true").prepend(n),e.attr("aria-labelledby",s.attr("id"))}),e=s.add(this.element),e.children(":not(.ui-menu-item):has(a)").addClass("ui-menu-item").attr("role","presentation").children("a").uniqueId().addClass("ui-corner-all").attr({tabIndex:-1,role:this._itemRole()}),e.children(":not(.ui-menu-item)").each(function(){var e=t(this);/[^\-\u2014\u2013\s]/.test(e.text())||e.addClass("ui-widget-content ui-menu-divider")}),e.children(".ui-state-disabled").attr("aria-disabled","true"),this.active&&!t.contains(this.element[0],this.active[0])&&this.blur()},_itemRole:function(){return{menu:"menuitem",listbox:"option"}[this.options.role]},_setOption:function(t,e){"icons"===t&&this.element.find(".ui-menu-icon").removeClass(this.options.icons.submenu).addClass(e.submenu),this._super(t,e)},focus:function(t,e){var i,s;this.blur(t,t&&"focus"===t.type),this._scrollIntoView(e),this.active=e.first(),s=this.active.children("a").addClass("ui-state-focus"),this.options.role&&this.element.attr("aria-activedescendant",s.attr("id")),this.active.parent().closest(".ui-menu-item").children("a:first").addClass("ui-state-active"),t&&"keydown"===t.type?this._close():this.timer=this._delay(function(){this._close()},this.delay),i=e.children(".ui-menu"),i.length&&/^mouse/.test(t.type)&&this._startOpening(i),this.activeMenu=e.parent(),this._trigger("focus",t,{item:e})},_scrollIntoView:function(e){var i,s,n,a,o,r;this._hasScroll()&&(i=parseFloat(t.css(this.activeMenu[0],"borderTopWidth"))||0,s=parseFloat(t.css(this.activeMenu[0],"paddingTop"))||0,n=e.offset().top-this.activeMenu.offset().top-i-s,a=this.activeMenu.scrollTop(),o=this.activeMenu.height(),r=e.height(),0>n?this.activeMenu.scrollTop(a+n):n+r>o&&this.activeMenu.scrollTop(a+n-o+r))},blur:function(t,e){e||clearTimeout(this.timer),this.active&&(this.active.children("a").removeClass("ui-state-focus"),this.active=null,this._trigger("blur",t,{item:this.active}))},_startOpening:function(t){clearTimeout(this.timer),"true"===t.attr("aria-hidden")&&(this.timer=this._delay(function(){this._close(),this._open(t)},this.delay))},_open:function(e){var i=t.extend({of:this.active},this.options.position);clearTimeout(this.timer),this.element.find(".ui-menu").not(e.parents(".ui-menu")).hide().attr("aria-hidden","true"),e.show().removeAttr("aria-hidden").attr("aria-expanded","true").position(i)},collapseAll:function(e,i){clearTimeout(this.timer),this.timer=this._delay(function(){var s=i?this.element:t(e&&e.target).closest(this.element.find(".ui-menu"));s.length||(s=this.element),this._close(s),this.blur(e),this.activeMenu=s},this.delay)},_close:function(t){t||(t=this.active?this.active.parent():this.element),t.find(".ui-menu").hide().attr("aria-hidden","true").attr("aria-expanded","false").end().find("a.ui-state-active").removeClass("ui-state-active")},collapse:function(t){var e=this.active&&this.active.parent().closest(".ui-menu-item",this.element);e&&e.length&&(this._close(),this.focus(t,e))},expand:function(t){var e=this.active&&this.active.children(".ui-menu ").children(".ui-menu-item").first();e&&e.length&&(this._open(e.parent()),this._delay(function(){this.focus(t,e)}))},next:function(t){this._move("next","first",t)},previous:function(t){this._move("prev","last",t)},isFirstItem:function(){return this.active&&!this.active.prevAll(".ui-menu-item").length},isLastItem:function(){return this.active&&!this.active.nextAll(".ui-menu-item").length},_move:function(t,e,i){var s;this.active&&(s="first"===t||"last"===t?this.active["first"===t?"prevAll":"nextAll"](".ui-menu-item").eq(-1):this.active[t+"All"](".ui-menu-item").eq(0)),s&&s.length&&this.active||(s=this.activeMenu.children(".ui-menu-item")[e]()),this.focus(i,s)},nextPage:function(e){var i,s,n;return this.active?(this.isLastItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.nextAll(".ui-menu-item").each(function(){return i=t(this),0>i.offset().top-s-n}),this.focus(e,i)):this.focus(e,this.activeMenu.children(".ui-menu-item")[this.active?"last":"first"]())),undefined):(this.next(e),undefined)},previousPage:function(e){var i,s,n;return this.active?(this.isFirstItem()||(this._hasScroll()?(s=this.active.offset().top,n=this.element.height(),this.active.prevAll(".ui-menu-item").each(function(){return i=t(this),i.offset().top-s+n>0}),this.focus(e,i)):this.focus(e,this.activeMenu.children(".ui-menu-item").first())),undefined):(this.next(e),undefined)},_hasScroll:function(){return this.element.outerHeight()<this.element.prop("scrollHeight")},select:function(e){this.active=this.active||t(e.target).closest(".ui-menu-item");var i={item:this.active};this.active.has(".ui-menu").length||this.collapseAll(e,!0),this._trigger("select",e,i)}})})(jQuery);(function(t,e){t.widget("ui.progressbar",{version:"1.10.3",options:{max:100,value:0,change:null,complete:null},min:0,_create:function(){this.oldValue=this.options.value=this._constrainedValue(),this.element.addClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").attr({role:"progressbar","aria-valuemin":this.min}),this.valueDiv=t("<div class='ui-progressbar-value ui-widget-header ui-corner-left'></div>").appendTo(this.element),this._refreshValue()},_destroy:function(){this.element.removeClass("ui-progressbar ui-widget ui-widget-content ui-corner-all").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.valueDiv.remove()},value:function(t){return t===e?this.options.value:(this.options.value=this._constrainedValue(t),this._refreshValue(),e)},_constrainedValue:function(t){return t===e&&(t=this.options.value),this.indeterminate=t===!1,"number"!=typeof t&&(t=0),this.indeterminate?!1:Math.min(this.options.max,Math.max(this.min,t))},_setOptions:function(t){var e=t.value;delete t.value,this._super(t),this.options.value=this._constrainedValue(e),this._refreshValue()},_setOption:function(t,e){"max"===t&&(e=Math.max(this.min,e)),this._super(t,e)},_percentage:function(){return this.indeterminate?100:100*(this.options.value-this.min)/(this.options.max-this.min)},_refreshValue:function(){var e=this.options.value,i=this._percentage();this.valueDiv.toggle(this.indeterminate||e>this.min).toggleClass("ui-corner-right",e===this.options.max).width(i.toFixed(0)+"%"),this.element.toggleClass("ui-progressbar-indeterminate",this.indeterminate),this.indeterminate?(this.element.removeAttr("aria-valuenow"),this.overlayDiv||(this.overlayDiv=t("<div class='ui-progressbar-overlay'></div>").appendTo(this.valueDiv))):(this.element.attr({"aria-valuemax":this.options.max,"aria-valuenow":e}),this.overlayDiv&&(this.overlayDiv.remove(),this.overlayDiv=null)),this.oldValue!==e&&(this.oldValue=e,this._trigger("change")),e===this.options.max&&this._trigger("complete")}})})(jQuery);(function(t){var e=5;t.widget("ui.slider",t.ui.mouse,{version:"1.10.3",widgetEventPrefix:"slide",options:{animate:!1,distance:0,max:100,min:0,orientation:"horizontal",range:!1,step:1,value:0,values:null,change:null,slide:null,start:null,stop:null},_create:function(){this._keySliding=!1,this._mouseSliding=!1,this._animateOff=!0,this._handleIndex=null,this._detectOrientation(),this._mouseInit(),this.element.addClass("ui-slider ui-slider-"+this.orientation+" ui-widget"+" ui-widget-content"+" ui-corner-all"),this._refresh(),this._setOption("disabled",this.options.disabled),this._animateOff=!1},_refresh:function(){this._createRange(),this._createHandles(),this._setupEvents(),this._refreshValue()},_createHandles:function(){var e,i,s=this.options,n=this.element.find(".ui-slider-handle").addClass("ui-state-default ui-corner-all"),a="<a class='ui-slider-handle ui-state-default ui-corner-all' href='#'></a>",o=[];for(i=s.values&&s.values.length||1,n.length>i&&(n.slice(i).remove(),n=n.slice(0,i)),e=n.length;i>e;e++)o.push(a);this.handles=n.add(t(o.join("")).appendTo(this.element)),this.handle=this.handles.eq(0),this.handles.each(function(e){t(this).data("ui-slider-handle-index",e)})},_createRange:function(){var e=this.options,i="";e.range?(e.range===!0&&(e.values?e.values.length&&2!==e.values.length?e.values=[e.values[0],e.values[0]]:t.isArray(e.values)&&(e.values=e.values.slice(0)):e.values=[this._valueMin(),this._valueMin()]),this.range&&this.range.length?this.range.removeClass("ui-slider-range-min ui-slider-range-max").css({left:"",bottom:""}):(this.range=t("<div></div>").appendTo(this.element),i="ui-slider-range ui-widget-header ui-corner-all"),this.range.addClass(i+("min"===e.range||"max"===e.range?" ui-slider-range-"+e.range:""))):this.range=t([])},_setupEvents:function(){var t=this.handles.add(this.range).filter("a");this._off(t),this._on(t,this._handleEvents),this._hoverable(t),this._focusable(t)},_destroy:function(){this.handles.remove(),this.range.remove(),this.element.removeClass("ui-slider ui-slider-horizontal ui-slider-vertical ui-widget ui-widget-content ui-corner-all"),this._mouseDestroy()},_mouseCapture:function(e){var i,s,n,a,o,r,h,l,u=this,c=this.options;return c.disabled?!1:(this.elementSize={width:this.element.outerWidth(),height:this.element.outerHeight()},this.elementOffset=this.element.offset(),i={x:e.pageX,y:e.pageY},s=this._normValueFromMouse(i),n=this._valueMax()-this._valueMin()+1,this.handles.each(function(e){var i=Math.abs(s-u.values(e));(n>i||n===i&&(e===u._lastChangedValue||u.values(e)===c.min))&&(n=i,a=t(this),o=e)}),r=this._start(e,o),r===!1?!1:(this._mouseSliding=!0,this._handleIndex=o,a.addClass("ui-state-active").focus(),h=a.offset(),l=!t(e.target).parents().addBack().is(".ui-slider-handle"),this._clickOffset=l?{left:0,top:0}:{left:e.pageX-h.left-a.width()/2,top:e.pageY-h.top-a.height()/2-(parseInt(a.css("borderTopWidth"),10)||0)-(parseInt(a.css("borderBottomWidth"),10)||0)+(parseInt(a.css("marginTop"),10)||0)},this.handles.hasClass("ui-state-hover")||this._slide(e,o,s),this._animateOff=!0,!0))},_mouseStart:function(){return!0},_mouseDrag:function(t){var e={x:t.pageX,y:t.pageY},i=this._normValueFromMouse(e);return this._slide(t,this._handleIndex,i),!1},_mouseStop:function(t){return this.handles.removeClass("ui-state-active"),this._mouseSliding=!1,this._stop(t,this._handleIndex),this._change(t,this._handleIndex),this._handleIndex=null,this._clickOffset=null,this._animateOff=!1,!1},_detectOrientation:function(){this.orientation="vertical"===this.options.orientation?"vertical":"horizontal"},_normValueFromMouse:function(t){var e,i,s,n,a;return"horizontal"===this.orientation?(e=this.elementSize.width,i=t.x-this.elementOffset.left-(this._clickOffset?this._clickOffset.left:0)):(e=this.elementSize.height,i=t.y-this.elementOffset.top-(this._clickOffset?this._clickOffset.top:0)),s=i/e,s>1&&(s=1),0>s&&(s=0),"vertical"===this.orientation&&(s=1-s),n=this._valueMax()-this._valueMin(),a=this._valueMin()+s*n,this._trimAlignValue(a)},_start:function(t,e){var i={handle:this.handles[e],value:this.value()};return this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("start",t,i)},_slide:function(t,e,i){var s,n,a;this.options.values&&this.options.values.length?(s=this.values(e?0:1),2===this.options.values.length&&this.options.range===!0&&(0===e&&i>s||1===e&&s>i)&&(i=s),i!==this.values(e)&&(n=this.values(),n[e]=i,a=this._trigger("slide",t,{handle:this.handles[e],value:i,values:n}),s=this.values(e?0:1),a!==!1&&this.values(e,i,!0))):i!==this.value()&&(a=this._trigger("slide",t,{handle:this.handles[e],value:i}),a!==!1&&this.value(i))},_stop:function(t,e){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._trigger("stop",t,i)},_change:function(t,e){if(!this._keySliding&&!this._mouseSliding){var i={handle:this.handles[e],value:this.value()};this.options.values&&this.options.values.length&&(i.value=this.values(e),i.values=this.values()),this._lastChangedValue=e,this._trigger("change",t,i)}},value:function(t){return arguments.length?(this.options.value=this._trimAlignValue(t),this._refreshValue(),this._change(null,0),undefined):this._value()},values:function(e,i){var s,n,a;if(arguments.length>1)return this.options.values[e]=this._trimAlignValue(i),this._refreshValue(),this._change(null,e),undefined;if(!arguments.length)return this._values();if(!t.isArray(arguments[0]))return this.options.values&&this.options.values.length?this._values(e):this.value();for(s=this.options.values,n=arguments[0],a=0;s.length>a;a+=1)s[a]=this._trimAlignValue(n[a]),this._change(null,a);this._refreshValue()},_setOption:function(e,i){var s,n=0;switch("range"===e&&this.options.range===!0&&("min"===i?(this.options.value=this._values(0),this.options.values=null):"max"===i&&(this.options.value=this._values(this.options.values.length-1),this.options.values=null)),t.isArray(this.options.values)&&(n=this.options.values.length),t.Widget.prototype._setOption.apply(this,arguments),e){case"orientation":this._detectOrientation(),this.element.removeClass("ui-slider-horizontal ui-slider-vertical").addClass("ui-slider-"+this.orientation),this._refreshValue();break;case"value":this._animateOff=!0,this._refreshValue(),this._change(null,0),this._animateOff=!1;break;case"values":for(this._animateOff=!0,this._refreshValue(),s=0;n>s;s+=1)this._change(null,s);this._animateOff=!1;break;case"min":case"max":this._animateOff=!0,this._refreshValue(),this._animateOff=!1;break;case"range":this._animateOff=!0,this._refresh(),this._animateOff=!1}},_value:function(){var t=this.options.value;return t=this._trimAlignValue(t)},_values:function(t){var e,i,s;if(arguments.length)return e=this.options.values[t],e=this._trimAlignValue(e);if(this.options.values&&this.options.values.length){for(i=this.options.values.slice(),s=0;i.length>s;s+=1)i[s]=this._trimAlignValue(i[s]);return i}return[]},_trimAlignValue:function(t){if(this._valueMin()>=t)return this._valueMin();if(t>=this._valueMax())return this._valueMax();var e=this.options.step>0?this.options.step:1,i=(t-this._valueMin())%e,s=t-i;return 2*Math.abs(i)>=e&&(s+=i>0?e:-e),parseFloat(s.toFixed(5))},_valueMin:function(){return this.options.min},_valueMax:function(){return this.options.max},_refreshValue:function(){var e,i,s,n,a,o=this.options.range,r=this.options,h=this,l=this._animateOff?!1:r.animate,u={};this.options.values&&this.options.values.length?this.handles.each(function(s){i=100*((h.values(s)-h._valueMin())/(h._valueMax()-h._valueMin())),u["horizontal"===h.orientation?"left":"bottom"]=i+"%",t(this).stop(1,1)[l?"animate":"css"](u,r.animate),h.options.range===!0&&("horizontal"===h.orientation?(0===s&&h.range.stop(1,1)[l?"animate":"css"]({left:i+"%"},r.animate),1===s&&h.range[l?"animate":"css"]({width:i-e+"%"},{queue:!1,duration:r.animate})):(0===s&&h.range.stop(1,1)[l?"animate":"css"]({bottom:i+"%"},r.animate),1===s&&h.range[l?"animate":"css"]({height:i-e+"%"},{queue:!1,duration:r.animate}))),e=i}):(s=this.value(),n=this._valueMin(),a=this._valueMax(),i=a!==n?100*((s-n)/(a-n)):0,u["horizontal"===this.orientation?"left":"bottom"]=i+"%",this.handle.stop(1,1)[l?"animate":"css"](u,r.animate),"min"===o&&"horizontal"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({width:i+"%"},r.animate),"max"===o&&"horizontal"===this.orientation&&this.range[l?"animate":"css"]({width:100-i+"%"},{queue:!1,duration:r.animate}),"min"===o&&"vertical"===this.orientation&&this.range.stop(1,1)[l?"animate":"css"]({height:i+"%"},r.animate),"max"===o&&"vertical"===this.orientation&&this.range[l?"animate":"css"]({height:100-i+"%"},{queue:!1,duration:r.animate}))},_handleEvents:{keydown:function(i){var s,n,a,o,r=t(i.target).data("ui-slider-handle-index");switch(i.keyCode){case t.ui.keyCode.HOME:case t.ui.keyCode.END:case t.ui.keyCode.PAGE_UP:case t.ui.keyCode.PAGE_DOWN:case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(i.preventDefault(),!this._keySliding&&(this._keySliding=!0,t(i.target).addClass("ui-state-active"),s=this._start(i,r),s===!1))return}switch(o=this.options.step,n=a=this.options.values&&this.options.values.length?this.values(r):this.value(),i.keyCode){case t.ui.keyCode.HOME:a=this._valueMin();break;case t.ui.keyCode.END:a=this._valueMax();break;case t.ui.keyCode.PAGE_UP:a=this._trimAlignValue(n+(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.PAGE_DOWN:a=this._trimAlignValue(n-(this._valueMax()-this._valueMin())/e);break;case t.ui.keyCode.UP:case t.ui.keyCode.RIGHT:if(n===this._valueMax())return;a=this._trimAlignValue(n+o);break;case t.ui.keyCode.DOWN:case t.ui.keyCode.LEFT:if(n===this._valueMin())return;a=this._trimAlignValue(n-o)}this._slide(i,r,a)},click:function(t){t.preventDefault()},keyup:function(e){var i=t(e.target).data("ui-slider-handle-index");this._keySliding&&(this._keySliding=!1,this._stop(e,i),this._change(e,i),t(e.target).removeClass("ui-state-active"))}}})})(jQuery);(function(t){function e(t){return function(){var e=this.element.val();t.apply(this,arguments),this._refresh(),e!==this.element.val()&&this._trigger("change")}}t.widget("ui.spinner",{version:"1.10.3",defaultElement:"<input>",widgetEventPrefix:"spin",options:{culture:null,icons:{down:"ui-icon-triangle-1-s",up:"ui-icon-triangle-1-n"},incremental:!0,max:null,min:null,numberFormat:null,page:10,step:1,change:null,spin:null,start:null,stop:null},_create:function(){this._setOption("max",this.options.max),this._setOption("min",this.options.min),this._setOption("step",this.options.step),this._value(this.element.val(),!0),this._draw(),this._on(this._events),this._refresh(),this._on(this.window,{beforeunload:function(){this.element.removeAttr("autocomplete")}})},_getCreateOptions:function(){var e={},i=this.element;return t.each(["min","max","step"],function(t,s){var n=i.attr(s);void 0!==n&&n.length&&(e[s]=n)}),e},_events:{keydown:function(t){this._start(t)&&this._keydown(t)&&t.preventDefault()},keyup:"_stop",focus:function(){this.previous=this.element.val()},blur:function(t){return this.cancelBlur?(delete this.cancelBlur,void 0):(this._stop(),this._refresh(),this.previous!==this.element.val()&&this._trigger("change",t),void 0)},mousewheel:function(t,e){if(e){if(!this.spinning&&!this._start(t))return!1;this._spin((e>0?1:-1)*this.options.step,t),clearTimeout(this.mousewheelTimer),this.mousewheelTimer=this._delay(function(){this.spinning&&this._stop(t)},100),t.preventDefault()}},"mousedown .ui-spinner-button":function(e){function i(){var t=this.element[0]===this.document[0].activeElement;t||(this.element.focus(),this.previous=s,this._delay(function(){this.previous=s}))}var s;s=this.element[0]===this.document[0].activeElement?this.previous:this.element.val(),e.preventDefault(),i.call(this),this.cancelBlur=!0,this._delay(function(){delete this.cancelBlur,i.call(this)}),this._start(e)!==!1&&this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e)},"mouseup .ui-spinner-button":"_stop","mouseenter .ui-spinner-button":function(e){return t(e.currentTarget).hasClass("ui-state-active")?this._start(e)===!1?!1:(this._repeat(null,t(e.currentTarget).hasClass("ui-spinner-up")?1:-1,e),void 0):void 0},"mouseleave .ui-spinner-button":"_stop"},_draw:function(){var t=this.uiSpinner=this.element.addClass("ui-spinner-input").attr("autocomplete","off").wrap(this._uiSpinnerHtml()).parent().append(this._buttonHtml());this.element.attr("role","spinbutton"),this.buttons=t.find(".ui-spinner-button").attr("tabIndex",-1).button().removeClass("ui-corner-all"),this.buttons.height()>Math.ceil(.5*t.height())&&t.height()>0&&t.height(t.height()),this.options.disabled&&this.disable()},_keydown:function(e){var i=this.options,s=t.ui.keyCode;switch(e.keyCode){case s.UP:return this._repeat(null,1,e),!0;case s.DOWN:return this._repeat(null,-1,e),!0;case s.PAGE_UP:return this._repeat(null,i.page,e),!0;case s.PAGE_DOWN:return this._repeat(null,-i.page,e),!0}return!1},_uiSpinnerHtml:function(){return"<span class='ui-spinner ui-widget ui-widget-content ui-corner-all'></span>"},_buttonHtml:function(){return"<a class='ui-spinner-button ui-spinner-up ui-corner-tr'><span class='ui-icon "+this.options.icons.up+"'>&#9650;</span>"+"</a>"+"<a class='ui-spinner-button ui-spinner-down ui-corner-br'>"+"<span class='ui-icon "+this.options.icons.down+"'>&#9660;</span>"+"</a>"},_start:function(t){return this.spinning||this._trigger("start",t)!==!1?(this.counter||(this.counter=1),this.spinning=!0,!0):!1},_repeat:function(t,e,i){t=t||500,clearTimeout(this.timer),this.timer=this._delay(function(){this._repeat(40,e,i)},t),this._spin(e*this.options.step,i)},_spin:function(t,e){var i=this.value()||0;this.counter||(this.counter=1),i=this._adjustValue(i+t*this._increment(this.counter)),this.spinning&&this._trigger("spin",e,{value:i})===!1||(this._value(i),this.counter++)},_increment:function(e){var i=this.options.incremental;return i?t.isFunction(i)?i(e):Math.floor(e*e*e/5e4-e*e/500+17*e/200+1):1},_precision:function(){var t=this._precisionOf(this.options.step);return null!==this.options.min&&(t=Math.max(t,this._precisionOf(this.options.min))),t},_precisionOf:function(t){var e=""+t,i=e.indexOf(".");return-1===i?0:e.length-i-1},_adjustValue:function(t){var e,i,s=this.options;return e=null!==s.min?s.min:0,i=t-e,i=Math.round(i/s.step)*s.step,t=e+i,t=parseFloat(t.toFixed(this._precision())),null!==s.max&&t>s.max?s.max:null!==s.min&&s.min>t?s.min:t},_stop:function(t){this.spinning&&(clearTimeout(this.timer),clearTimeout(this.mousewheelTimer),this.counter=0,this.spinning=!1,this._trigger("stop",t))},_setOption:function(t,e){if("culture"===t||"numberFormat"===t){var i=this._parse(this.element.val());return this.options[t]=e,this.element.val(this._format(i)),void 0}("max"===t||"min"===t||"step"===t)&&"string"==typeof e&&(e=this._parse(e)),"icons"===t&&(this.buttons.first().find(".ui-icon").removeClass(this.options.icons.up).addClass(e.up),this.buttons.last().find(".ui-icon").removeClass(this.options.icons.down).addClass(e.down)),this._super(t,e),"disabled"===t&&(e?(this.element.prop("disabled",!0),this.buttons.button("disable")):(this.element.prop("disabled",!1),this.buttons.button("enable")))},_setOptions:e(function(t){this._super(t),this._value(this.element.val())}),_parse:function(t){return"string"==typeof t&&""!==t&&(t=window.Globalize&&this.options.numberFormat?Globalize.parseFloat(t,10,this.options.culture):+t),""===t||isNaN(t)?null:t},_format:function(t){return""===t?"":window.Globalize&&this.options.numberFormat?Globalize.format(t,this.options.numberFormat,this.options.culture):t},_refresh:function(){this.element.attr({"aria-valuemin":this.options.min,"aria-valuemax":this.options.max,"aria-valuenow":this._parse(this.element.val())})},_value:function(t,e){var i;""!==t&&(i=this._parse(t),null!==i&&(e||(i=this._adjustValue(i)),t=this._format(i))),this.element.val(t),this._refresh()},_destroy:function(){this.element.removeClass("ui-spinner-input").prop("disabled",!1).removeAttr("autocomplete").removeAttr("role").removeAttr("aria-valuemin").removeAttr("aria-valuemax").removeAttr("aria-valuenow"),this.uiSpinner.replaceWith(this.element)},stepUp:e(function(t){this._stepUp(t)}),_stepUp:function(t){this._start()&&(this._spin((t||1)*this.options.step),this._stop())},stepDown:e(function(t){this._stepDown(t)}),_stepDown:function(t){this._start()&&(this._spin((t||1)*-this.options.step),this._stop())},pageUp:e(function(t){this._stepUp((t||1)*this.options.page)}),pageDown:e(function(t){this._stepDown((t||1)*this.options.page)}),value:function(t){return arguments.length?(e(this._value).call(this,t),void 0):this._parse(this.element.val())},widget:function(){return this.uiSpinner}})})(jQuery);(function(t,e){function i(){return++n}function s(t){return t.hash.length>1&&decodeURIComponent(t.href.replace(a,""))===decodeURIComponent(location.href.replace(a,""))}var n=0,a=/#.*$/;t.widget("ui.tabs",{version:"1.10.3",delay:300,options:{active:null,collapsible:!1,event:"click",heightStyle:"content",hide:null,show:null,activate:null,beforeActivate:null,beforeLoad:null,load:null},_create:function(){var e=this,i=this.options;this.running=!1,this.element.addClass("ui-tabs ui-widget ui-widget-content ui-corner-all").toggleClass("ui-tabs-collapsible",i.collapsible).delegate(".ui-tabs-nav > li","mousedown"+this.eventNamespace,function(e){t(this).is(".ui-state-disabled")&&e.preventDefault()}).delegate(".ui-tabs-anchor","focus"+this.eventNamespace,function(){t(this).closest("li").is(".ui-state-disabled")&&this.blur()}),this._processTabs(),i.active=this._initialActive(),t.isArray(i.disabled)&&(i.disabled=t.unique(i.disabled.concat(t.map(this.tabs.filter(".ui-state-disabled"),function(t){return e.tabs.index(t)}))).sort()),this.active=this.options.active!==!1&&this.anchors.length?this._findActive(i.active):t(),this._refresh(),this.active.length&&this.load(i.active)},_initialActive:function(){var i=this.options.active,s=this.options.collapsible,n=location.hash.substring(1);return null===i&&(n&&this.tabs.each(function(s,a){return t(a).attr("aria-controls")===n?(i=s,!1):e}),null===i&&(i=this.tabs.index(this.tabs.filter(".ui-tabs-active"))),(null===i||-1===i)&&(i=this.tabs.length?0:!1)),i!==!1&&(i=this.tabs.index(this.tabs.eq(i)),-1===i&&(i=s?!1:0)),!s&&i===!1&&this.anchors.length&&(i=0),i},_getCreateEventData:function(){return{tab:this.active,panel:this.active.length?this._getPanelForTab(this.active):t()}},_tabKeydown:function(i){var s=t(this.document[0].activeElement).closest("li"),n=this.tabs.index(s),a=!0;if(!this._handlePageNav(i)){switch(i.keyCode){case t.ui.keyCode.RIGHT:case t.ui.keyCode.DOWN:n++;break;case t.ui.keyCode.UP:case t.ui.keyCode.LEFT:a=!1,n--;break;case t.ui.keyCode.END:n=this.anchors.length-1;break;case t.ui.keyCode.HOME:n=0;break;case t.ui.keyCode.SPACE:return i.preventDefault(),clearTimeout(this.activating),this._activate(n),e;case t.ui.keyCode.ENTER:return i.preventDefault(),clearTimeout(this.activating),this._activate(n===this.options.active?!1:n),e;default:return}i.preventDefault(),clearTimeout(this.activating),n=this._focusNextTab(n,a),i.ctrlKey||(s.attr("aria-selected","false"),this.tabs.eq(n).attr("aria-selected","true"),this.activating=this._delay(function(){this.option("active",n)},this.delay))}},_panelKeydown:function(e){this._handlePageNav(e)||e.ctrlKey&&e.keyCode===t.ui.keyCode.UP&&(e.preventDefault(),this.active.focus())},_handlePageNav:function(i){return i.altKey&&i.keyCode===t.ui.keyCode.PAGE_UP?(this._activate(this._focusNextTab(this.options.active-1,!1)),!0):i.altKey&&i.keyCode===t.ui.keyCode.PAGE_DOWN?(this._activate(this._focusNextTab(this.options.active+1,!0)),!0):e},_findNextTab:function(e,i){function s(){return e>n&&(e=0),0>e&&(e=n),e}for(var n=this.tabs.length-1;-1!==t.inArray(s(),this.options.disabled);)e=i?e+1:e-1;return e},_focusNextTab:function(t,e){return t=this._findNextTab(t,e),this.tabs.eq(t).focus(),t},_setOption:function(t,i){return"active"===t?(this._activate(i),e):"disabled"===t?(this._setupDisabled(i),e):(this._super(t,i),"collapsible"===t&&(this.element.toggleClass("ui-tabs-collapsible",i),i||this.options.active!==!1||this._activate(0)),"event"===t&&this._setupEvents(i),"heightStyle"===t&&this._setupHeightStyle(i),e)},_tabId:function(t){return t.attr("aria-controls")||"ui-tabs-"+i()},_sanitizeSelector:function(t){return t?t.replace(/[!"$%&'()*+,.\/:;<=>?@\[\]\^`{|}~]/g,"\\$&"):""},refresh:function(){var e=this.options,i=this.tablist.children(":has(a[href])");e.disabled=t.map(i.filter(".ui-state-disabled"),function(t){return i.index(t)}),this._processTabs(),e.active!==!1&&this.anchors.length?this.active.length&&!t.contains(this.tablist[0],this.active[0])?this.tabs.length===e.disabled.length?(e.active=!1,this.active=t()):this._activate(this._findNextTab(Math.max(0,e.active-1),!1)):e.active=this.tabs.index(this.active):(e.active=!1,this.active=t()),this._refresh()},_refresh:function(){this._setupDisabled(this.options.disabled),this._setupEvents(this.options.event),this._setupHeightStyle(this.options.heightStyle),this.tabs.not(this.active).attr({"aria-selected":"false",tabIndex:-1}),this.panels.not(this._getPanelForTab(this.active)).hide().attr({"aria-expanded":"false","aria-hidden":"true"}),this.active.length?(this.active.addClass("ui-tabs-active ui-state-active").attr({"aria-selected":"true",tabIndex:0}),this._getPanelForTab(this.active).show().attr({"aria-expanded":"true","aria-hidden":"false"})):this.tabs.eq(0).attr("tabIndex",0)},_processTabs:function(){var e=this;this.tablist=this._getList().addClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").attr("role","tablist"),this.tabs=this.tablist.find("> li:has(a[href])").addClass("ui-state-default ui-corner-top").attr({role:"tab",tabIndex:-1}),this.anchors=this.tabs.map(function(){return t("a",this)[0]}).addClass("ui-tabs-anchor").attr({role:"presentation",tabIndex:-1}),this.panels=t(),this.anchors.each(function(i,n){var a,o,r,h=t(n).uniqueId().attr("id"),l=t(n).closest("li"),u=l.attr("aria-controls");s(n)?(a=n.hash,o=e.element.find(e._sanitizeSelector(a))):(r=e._tabId(l),a="#"+r,o=e.element.find(a),o.length||(o=e._createPanel(r),o.insertAfter(e.panels[i-1]||e.tablist)),o.attr("aria-live","polite")),o.length&&(e.panels=e.panels.add(o)),u&&l.data("ui-tabs-aria-controls",u),l.attr({"aria-controls":a.substring(1),"aria-labelledby":h}),o.attr("aria-labelledby",h)}),this.panels.addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").attr("role","tabpanel")},_getList:function(){return this.element.find("ol,ul").eq(0)},_createPanel:function(e){return t("<div>").attr("id",e).addClass("ui-tabs-panel ui-widget-content ui-corner-bottom").data("ui-tabs-destroy",!0)},_setupDisabled:function(e){t.isArray(e)&&(e.length?e.length===this.anchors.length&&(e=!0):e=!1);for(var i,s=0;i=this.tabs[s];s++)e===!0||-1!==t.inArray(s,e)?t(i).addClass("ui-state-disabled").attr("aria-disabled","true"):t(i).removeClass("ui-state-disabled").removeAttr("aria-disabled");this.options.disabled=e},_setupEvents:function(e){var i={click:function(t){t.preventDefault()}};e&&t.each(e.split(" "),function(t,e){i[e]="_eventHandler"}),this._off(this.anchors.add(this.tabs).add(this.panels)),this._on(this.anchors,i),this._on(this.tabs,{keydown:"_tabKeydown"}),this._on(this.panels,{keydown:"_panelKeydown"}),this._focusable(this.tabs),this._hoverable(this.tabs)},_setupHeightStyle:function(e){var i,s=this.element.parent();"fill"===e?(i=s.height(),i-=this.element.outerHeight()-this.element.height(),this.element.siblings(":visible").each(function(){var e=t(this),s=e.css("position");"absolute"!==s&&"fixed"!==s&&(i-=e.outerHeight(!0))}),this.element.children().not(this.panels).each(function(){i-=t(this).outerHeight(!0)}),this.panels.each(function(){t(this).height(Math.max(0,i-t(this).innerHeight()+t(this).height()))}).css("overflow","auto")):"auto"===e&&(i=0,this.panels.each(function(){i=Math.max(i,t(this).height("").height())}).height(i))},_eventHandler:function(e){var i=this.options,s=this.active,n=t(e.currentTarget),a=n.closest("li"),o=a[0]===s[0],r=o&&i.collapsible,h=r?t():this._getPanelForTab(a),l=s.length?this._getPanelForTab(s):t(),u={oldTab:s,oldPanel:l,newTab:r?t():a,newPanel:h};e.preventDefault(),a.hasClass("ui-state-disabled")||a.hasClass("ui-tabs-loading")||this.running||o&&!i.collapsible||this._trigger("beforeActivate",e,u)===!1||(i.active=r?!1:this.tabs.index(a),this.active=o?t():a,this.xhr&&this.xhr.abort(),l.length||h.length||t.error("jQuery UI Tabs: Mismatching fragment identifier."),h.length&&this.load(this.tabs.index(a),e),this._toggle(e,u))},_toggle:function(e,i){function s(){a.running=!1,a._trigger("activate",e,i)}function n(){i.newTab.closest("li").addClass("ui-tabs-active ui-state-active"),o.length&&a.options.show?a._show(o,a.options.show,s):(o.show(),s())}var a=this,o=i.newPanel,r=i.oldPanel;this.running=!0,r.length&&this.options.hide?this._hide(r,this.options.hide,function(){i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),n()}):(i.oldTab.closest("li").removeClass("ui-tabs-active ui-state-active"),r.hide(),n()),r.attr({"aria-expanded":"false","aria-hidden":"true"}),i.oldTab.attr("aria-selected","false"),o.length&&r.length?i.oldTab.attr("tabIndex",-1):o.length&&this.tabs.filter(function(){return 0===t(this).attr("tabIndex")}).attr("tabIndex",-1),o.attr({"aria-expanded":"true","aria-hidden":"false"}),i.newTab.attr({"aria-selected":"true",tabIndex:0})},_activate:function(e){var i,s=this._findActive(e);s[0]!==this.active[0]&&(s.length||(s=this.active),i=s.find(".ui-tabs-anchor")[0],this._eventHandler({target:i,currentTarget:i,preventDefault:t.noop}))},_findActive:function(e){return e===!1?t():this.tabs.eq(e)},_getIndex:function(t){return"string"==typeof t&&(t=this.anchors.index(this.anchors.filter("[href$='"+t+"']"))),t},_destroy:function(){this.xhr&&this.xhr.abort(),this.element.removeClass("ui-tabs ui-widget ui-widget-content ui-corner-all ui-tabs-collapsible"),this.tablist.removeClass("ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all").removeAttr("role"),this.anchors.removeClass("ui-tabs-anchor").removeAttr("role").removeAttr("tabIndex").removeUniqueId(),this.tabs.add(this.panels).each(function(){t.data(this,"ui-tabs-destroy")?t(this).remove():t(this).removeClass("ui-state-default ui-state-active ui-state-disabled ui-corner-top ui-corner-bottom ui-widget-content ui-tabs-active ui-tabs-panel").removeAttr("tabIndex").removeAttr("aria-live").removeAttr("aria-busy").removeAttr("aria-selected").removeAttr("aria-labelledby").removeAttr("aria-hidden").removeAttr("aria-expanded").removeAttr("role")}),this.tabs.each(function(){var e=t(this),i=e.data("ui-tabs-aria-controls");i?e.attr("aria-controls",i).removeData("ui-tabs-aria-controls"):e.removeAttr("aria-controls")}),this.panels.show(),"content"!==this.options.heightStyle&&this.panels.css("height","")},enable:function(i){var s=this.options.disabled;s!==!1&&(i===e?s=!1:(i=this._getIndex(i),s=t.isArray(s)?t.map(s,function(t){return t!==i?t:null}):t.map(this.tabs,function(t,e){return e!==i?e:null})),this._setupDisabled(s))},disable:function(i){var s=this.options.disabled;if(s!==!0){if(i===e)s=!0;else{if(i=this._getIndex(i),-1!==t.inArray(i,s))return;s=t.isArray(s)?t.merge([i],s).sort():[i]}this._setupDisabled(s)}},load:function(e,i){e=this._getIndex(e);var n=this,a=this.tabs.eq(e),o=a.find(".ui-tabs-anchor"),r=this._getPanelForTab(a),h={tab:a,panel:r};s(o[0])||(this.xhr=t.ajax(this._ajaxSettings(o,i,h)),this.xhr&&"canceled"!==this.xhr.statusText&&(a.addClass("ui-tabs-loading"),r.attr("aria-busy","true"),this.xhr.success(function(t){setTimeout(function(){r.html(t),n._trigger("load",i,h)},1)}).complete(function(t,e){setTimeout(function(){"abort"===e&&n.panels.stop(!1,!0),a.removeClass("ui-tabs-loading"),r.removeAttr("aria-busy"),t===n.xhr&&delete n.xhr},1)})))},_ajaxSettings:function(e,i,s){var n=this;return{url:e.attr("href"),beforeSend:function(e,a){return n._trigger("beforeLoad",i,t.extend({jqXHR:e,ajaxSettings:a},s))}}},_getPanelForTab:function(e){var i=t(e).attr("aria-controls");return this.element.find(this._sanitizeSelector("#"+i))}})})(jQuery);(function(t){function e(e,i){var s=(e.attr("aria-describedby")||"").split(/\s+/);s.push(i),e.data("ui-tooltip-id",i).attr("aria-describedby",t.trim(s.join(" ")))}function i(e){var i=e.data("ui-tooltip-id"),s=(e.attr("aria-describedby")||"").split(/\s+/),n=t.inArray(i,s);-1!==n&&s.splice(n,1),e.removeData("ui-tooltip-id"),s=t.trim(s.join(" ")),s?e.attr("aria-describedby",s):e.removeAttr("aria-describedby")}var s=0;t.widget("ui.tooltip",{version:"1.10.3",options:{content:function(){var e=t(this).attr("title")||"";return t("<a>").text(e).html()},hide:!0,items:"[title]:not([disabled])",position:{my:"left top+15",at:"left bottom",collision:"flipfit flip"},show:!0,tooltipClass:null,track:!1,close:null,open:null},_create:function(){this._on({mouseover:"open",focusin:"open"}),this.tooltips={},this.parents={},this.options.disabled&&this._disable()},_setOption:function(e,i){var s=this;return"disabled"===e?(this[i?"_disable":"_enable"](),this.options[e]=i,void 0):(this._super(e,i),"content"===e&&t.each(this.tooltips,function(t,e){s._updateContent(e)}),void 0)},_disable:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s[0],e.close(n,!0)}),this.element.find(this.options.items).addBack().each(function(){var e=t(this);e.is("[title]")&&e.data("ui-tooltip-title",e.attr("title")).attr("title","")})},_enable:function(){this.element.find(this.options.items).addBack().each(function(){var e=t(this);e.data("ui-tooltip-title")&&e.attr("title",e.data("ui-tooltip-title"))})},open:function(e){var i=this,s=t(e?e.target:this.element).closest(this.options.items);s.length&&!s.data("ui-tooltip-id")&&(s.attr("title")&&s.data("ui-tooltip-title",s.attr("title")),s.data("ui-tooltip-open",!0),e&&"mouseover"===e.type&&s.parents().each(function(){var e,s=t(this);s.data("ui-tooltip-open")&&(e=t.Event("blur"),e.target=e.currentTarget=this,i.close(e,!0)),s.attr("title")&&(s.uniqueId(),i.parents[this.id]={element:this,title:s.attr("title")},s.attr("title",""))}),this._updateContent(s,e))},_updateContent:function(t,e){var i,s=this.options.content,n=this,a=e?e.type:null;return"string"==typeof s?this._open(e,t,s):(i=s.call(t[0],function(i){t.data("ui-tooltip-open")&&n._delay(function(){e&&(e.type=a),this._open(e,t,i)})}),i&&this._open(e,t,i),void 0)},_open:function(i,s,n){function a(t){l.of=t,o.is(":hidden")||o.position(l)}var o,r,h,l=t.extend({},this.options.position);if(n){if(o=this._find(s),o.length)return o.find(".ui-tooltip-content").html(n),void 0;s.is("[title]")&&(i&&"mouseover"===i.type?s.attr("title",""):s.removeAttr("title")),o=this._tooltip(s),e(s,o.attr("id")),o.find(".ui-tooltip-content").html(n),this.options.track&&i&&/^mouse/.test(i.type)?(this._on(this.document,{mousemove:a}),a(i)):o.position(t.extend({of:s},this.options.position)),o.hide(),this._show(o,this.options.show),this.options.show&&this.options.show.delay&&(h=this.delayedShow=setInterval(function(){o.is(":visible")&&(a(l.of),clearInterval(h))},t.fx.interval)),this._trigger("open",i,{tooltip:o}),r={keyup:function(e){if(e.keyCode===t.ui.keyCode.ESCAPE){var i=t.Event(e);i.currentTarget=s[0],this.close(i,!0)}},remove:function(){this._removeTooltip(o)}},i&&"mouseover"!==i.type||(r.mouseleave="close"),i&&"focusin"!==i.type||(r.focusout="close"),this._on(!0,s,r)}},close:function(e){var s=this,n=t(e?e.currentTarget:this.element),a=this._find(n);this.closing||(clearInterval(this.delayedShow),n.data("ui-tooltip-title")&&n.attr("title",n.data("ui-tooltip-title")),i(n),a.stop(!0),this._hide(a,this.options.hide,function(){s._removeTooltip(t(this))}),n.removeData("ui-tooltip-open"),this._off(n,"mouseleave focusout keyup"),n[0]!==this.element[0]&&this._off(n,"remove"),this._off(this.document,"mousemove"),e&&"mouseleave"===e.type&&t.each(this.parents,function(e,i){t(i.element).attr("title",i.title),delete s.parents[e]}),this.closing=!0,this._trigger("close",e,{tooltip:a}),this.closing=!1)},_tooltip:function(e){var i="ui-tooltip-"+s++,n=t("<div>").attr({id:i,role:"tooltip"}).addClass("ui-tooltip ui-widget ui-corner-all ui-widget-content "+(this.options.tooltipClass||""));return t("<div>").addClass("ui-tooltip-content").appendTo(n),n.appendTo(this.document[0].body),this.tooltips[i]=e,n},_find:function(e){var i=e.data("ui-tooltip-id");return i?t("#"+i):t()},_removeTooltip:function(t){t.remove(),delete this.tooltips[t.attr("id")]},_destroy:function(){var e=this;t.each(this.tooltips,function(i,s){var n=t.Event("blur");n.target=n.currentTarget=s[0],e.close(n,!0),t("#"+i).remove(),s.data("ui-tooltip-title")&&(s.attr("title",s.data("ui-tooltip-title")),s.removeData("ui-tooltip-title"))})}})})(jQuery);(function(t,e){var i="ui-effects-";t.effects={effect:{}},function(t,e){function i(t,e,i){var s=u[e.type]||{};return null==t?i||!e.def?null:e.def:(t=s.floor?~~t:parseFloat(t),isNaN(t)?e.def:s.mod?(t+s.mod)%s.mod:0>t?0:t>s.max?s.max:t)}function s(i){var s=l(),n=s._rgba=[];return i=i.toLowerCase(),f(h,function(t,a){var o,r=a.re.exec(i),h=r&&a.parse(r),l=a.space||"rgba";return h?(o=s[l](h),s[c[l].cache]=o[c[l].cache],n=s._rgba=o._rgba,!1):e}),n.length?("0,0,0,0"===n.join()&&t.extend(n,a.transparent),s):a[i]}function n(t,e,i){return i=(i+1)%1,1>6*i?t+6*(e-t)*i:1>2*i?e:2>3*i?t+6*(e-t)*(2/3-i):t}var a,o="backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",r=/^([\-+])=\s*(\d+\.?\d*)/,h=[{re:/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[t[1],t[2],t[3],t[4]]}},{re:/rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,parse:function(t){return[2.55*t[1],2.55*t[2],2.55*t[3],t[4]]}},{re:/#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,parse:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/#([a-f0-9])([a-f0-9])([a-f0-9])/,parse:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}},{re:/hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,space:"hsla",parse:function(t){return[t[1],t[2]/100,t[3]/100,t[4]]}}],l=t.Color=function(e,i,s,n){return new t.Color.fn.parse(e,i,s,n)},c={rgba:{props:{red:{idx:0,type:"byte"},green:{idx:1,type:"byte"},blue:{idx:2,type:"byte"}}},hsla:{props:{hue:{idx:0,type:"degrees"},saturation:{idx:1,type:"percent"},lightness:{idx:2,type:"percent"}}}},u={"byte":{floor:!0,max:255},percent:{max:1},degrees:{mod:360,floor:!0}},d=l.support={},p=t("<p>")[0],f=t.each;p.style.cssText="background-color:rgba(1,1,1,.5)",d.rgba=p.style.backgroundColor.indexOf("rgba")>-1,f(c,function(t,e){e.cache="_"+t,e.props.alpha={idx:3,type:"percent",def:1}}),l.fn=t.extend(l.prototype,{parse:function(n,o,r,h){if(n===e)return this._rgba=[null,null,null,null],this;(n.jquery||n.nodeType)&&(n=t(n).css(o),o=e);var u=this,d=t.type(n),p=this._rgba=[];return o!==e&&(n=[n,o,r,h],d="array"),"string"===d?this.parse(s(n)||a._default):"array"===d?(f(c.rgba.props,function(t,e){p[e.idx]=i(n[e.idx],e)}),this):"object"===d?(n instanceof l?f(c,function(t,e){n[e.cache]&&(u[e.cache]=n[e.cache].slice())}):f(c,function(e,s){var a=s.cache;f(s.props,function(t,e){if(!u[a]&&s.to){if("alpha"===t||null==n[t])return;u[a]=s.to(u._rgba)}u[a][e.idx]=i(n[t],e,!0)}),u[a]&&0>t.inArray(null,u[a].slice(0,3))&&(u[a][3]=1,s.from&&(u._rgba=s.from(u[a])))}),this):e},is:function(t){var i=l(t),s=!0,n=this;return f(c,function(t,a){var o,r=i[a.cache];return r&&(o=n[a.cache]||a.to&&a.to(n._rgba)||[],f(a.props,function(t,i){return null!=r[i.idx]?s=r[i.idx]===o[i.idx]:e})),s}),s},_space:function(){var t=[],e=this;return f(c,function(i,s){e[s.cache]&&t.push(i)}),t.pop()},transition:function(t,e){var s=l(t),n=s._space(),a=c[n],o=0===this.alpha()?l("transparent"):this,r=o[a.cache]||a.to(o._rgba),h=r.slice();return s=s[a.cache],f(a.props,function(t,n){var a=n.idx,o=r[a],l=s[a],c=u[n.type]||{};null!==l&&(null===o?h[a]=l:(c.mod&&(l-o>c.mod/2?o+=c.mod:o-l>c.mod/2&&(o-=c.mod)),h[a]=i((l-o)*e+o,n)))}),this[n](h)},blend:function(e){if(1===this._rgba[3])return this;var i=this._rgba.slice(),s=i.pop(),n=l(e)._rgba;return l(t.map(i,function(t,e){return(1-s)*n[e]+s*t}))},toRgbaString:function(){var e="rgba(",i=t.map(this._rgba,function(t,e){return null==t?e>2?1:0:t});return 1===i[3]&&(i.pop(),e="rgb("),e+i.join()+")"},toHslaString:function(){var e="hsla(",i=t.map(this.hsla(),function(t,e){return null==t&&(t=e>2?1:0),e&&3>e&&(t=Math.round(100*t)+"%"),t});return 1===i[3]&&(i.pop(),e="hsl("),e+i.join()+")"},toHexString:function(e){var i=this._rgba.slice(),s=i.pop();return e&&i.push(~~(255*s)),"#"+t.map(i,function(t){return t=(t||0).toString(16),1===t.length?"0"+t:t}).join("")},toString:function(){return 0===this._rgba[3]?"transparent":this.toRgbaString()}}),l.fn.parse.prototype=l.fn,c.hsla.to=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e,i,s=t[0]/255,n=t[1]/255,a=t[2]/255,o=t[3],r=Math.max(s,n,a),h=Math.min(s,n,a),l=r-h,c=r+h,u=.5*c;return e=h===r?0:s===r?60*(n-a)/l+360:n===r?60*(a-s)/l+120:60*(s-n)/l+240,i=0===l?0:.5>=u?l/c:l/(2-c),[Math.round(e)%360,i,u,null==o?1:o]},c.hsla.from=function(t){if(null==t[0]||null==t[1]||null==t[2])return[null,null,null,t[3]];var e=t[0]/360,i=t[1],s=t[2],a=t[3],o=.5>=s?s*(1+i):s+i-s*i,r=2*s-o;return[Math.round(255*n(r,o,e+1/3)),Math.round(255*n(r,o,e)),Math.round(255*n(r,o,e-1/3)),a]},f(c,function(s,n){var a=n.props,o=n.cache,h=n.to,c=n.from;l.fn[s]=function(s){if(h&&!this[o]&&(this[o]=h(this._rgba)),s===e)return this[o].slice();var n,r=t.type(s),u="array"===r||"object"===r?s:arguments,d=this[o].slice();return f(a,function(t,e){var s=u["object"===r?t:e.idx];null==s&&(s=d[e.idx]),d[e.idx]=i(s,e)}),c?(n=l(c(d)),n[o]=d,n):l(d)},f(a,function(e,i){l.fn[e]||(l.fn[e]=function(n){var a,o=t.type(n),h="alpha"===e?this._hsla?"hsla":"rgba":s,l=this[h](),c=l[i.idx];return"undefined"===o?c:("function"===o&&(n=n.call(this,c),o=t.type(n)),null==n&&i.empty?this:("string"===o&&(a=r.exec(n),a&&(n=c+parseFloat(a[2])*("+"===a[1]?1:-1))),l[i.idx]=n,this[h](l)))})})}),l.hook=function(e){var i=e.split(" ");f(i,function(e,i){t.cssHooks[i]={set:function(e,n){var a,o,r="";if("transparent"!==n&&("string"!==t.type(n)||(a=s(n)))){if(n=l(a||n),!d.rgba&&1!==n._rgba[3]){for(o="backgroundColor"===i?e.parentNode:e;(""===r||"transparent"===r)&&o&&o.style;)try{r=t.css(o,"backgroundColor"),o=o.parentNode}catch(h){}n=n.blend(r&&"transparent"!==r?r:"_default")}n=n.toRgbaString()}try{e.style[i]=n}catch(h){}}},t.fx.step[i]=function(e){e.colorInit||(e.start=l(e.elem,i),e.end=l(e.end),e.colorInit=!0),t.cssHooks[i].set(e.elem,e.start.transition(e.end,e.pos))}})},l.hook(o),t.cssHooks.borderColor={expand:function(t){var e={};return f(["Top","Right","Bottom","Left"],function(i,s){e["border"+s+"Color"]=t}),e}},a=t.Color.names={aqua:"#00ffff",black:"#000000",blue:"#0000ff",fuchsia:"#ff00ff",gray:"#808080",green:"#008000",lime:"#00ff00",maroon:"#800000",navy:"#000080",olive:"#808000",purple:"#800080",red:"#ff0000",silver:"#c0c0c0",teal:"#008080",white:"#ffffff",yellow:"#ffff00",transparent:[null,null,null,0],_default:"#ffffff"}}(jQuery),function(){function i(e){var i,s,n=e.ownerDocument.defaultView?e.ownerDocument.defaultView.getComputedStyle(e,null):e.currentStyle,a={};if(n&&n.length&&n[0]&&n[n[0]])for(s=n.length;s--;)i=n[s],"string"==typeof n[i]&&(a[t.camelCase(i)]=n[i]);else for(i in n)"string"==typeof n[i]&&(a[i]=n[i]);return a}function s(e,i){var s,n,o={};for(s in i)n=i[s],e[s]!==n&&(a[s]||(t.fx.step[s]||!isNaN(parseFloat(n)))&&(o[s]=n));return o}var n=["add","remove","toggle"],a={border:1,borderBottom:1,borderColor:1,borderLeft:1,borderRight:1,borderTop:1,borderWidth:1,margin:1,padding:1};t.each(["borderLeftStyle","borderRightStyle","borderBottomStyle","borderTopStyle"],function(e,i){t.fx.step[i]=function(t){("none"!==t.end&&!t.setAttr||1===t.pos&&!t.setAttr)&&(jQuery.style(t.elem,i,t.end),t.setAttr=!0)}}),t.fn.addBack||(t.fn.addBack=function(t){return this.add(null==t?this.prevObject:this.prevObject.filter(t))}),t.effects.animateClass=function(e,a,o,r){var h=t.speed(a,o,r);return this.queue(function(){var a,o=t(this),r=o.attr("class")||"",l=h.children?o.find("*").addBack():o;l=l.map(function(){var e=t(this);return{el:e,start:i(this)}}),a=function(){t.each(n,function(t,i){e[i]&&o[i+"Class"](e[i])})},a(),l=l.map(function(){return this.end=i(this.el[0]),this.diff=s(this.start,this.end),this}),o.attr("class",r),l=l.map(function(){var e=this,i=t.Deferred(),s=t.extend({},h,{queue:!1,complete:function(){i.resolve(e)}});return this.el.animate(this.diff,s),i.promise()}),t.when.apply(t,l.get()).done(function(){a(),t.each(arguments,function(){var e=this.el;t.each(this.diff,function(t){e.css(t,"")})}),h.complete.call(o[0])})})},t.fn.extend({addClass:function(e){return function(i,s,n,a){return s?t.effects.animateClass.call(this,{add:i},s,n,a):e.apply(this,arguments)}}(t.fn.addClass),removeClass:function(e){return function(i,s,n,a){return arguments.length>1?t.effects.animateClass.call(this,{remove:i},s,n,a):e.apply(this,arguments)}}(t.fn.removeClass),toggleClass:function(i){return function(s,n,a,o,r){return"boolean"==typeof n||n===e?a?t.effects.animateClass.call(this,n?{add:s}:{remove:s},a,o,r):i.apply(this,arguments):t.effects.animateClass.call(this,{toggle:s},n,a,o)}}(t.fn.toggleClass),switchClass:function(e,i,s,n,a){return t.effects.animateClass.call(this,{add:i,remove:e},s,n,a)}})}(),function(){function s(e,i,s,n){return t.isPlainObject(e)&&(i=e,e=e.effect),e={effect:e},null==i&&(i={}),t.isFunction(i)&&(n=i,s=null,i={}),("number"==typeof i||t.fx.speeds[i])&&(n=s,s=i,i={}),t.isFunction(s)&&(n=s,s=null),i&&t.extend(e,i),s=s||i.duration,e.duration=t.fx.off?0:"number"==typeof s?s:s in t.fx.speeds?t.fx.speeds[s]:t.fx.speeds._default,e.complete=n||i.complete,e}function n(e){return!e||"number"==typeof e||t.fx.speeds[e]?!0:"string"!=typeof e||t.effects.effect[e]?t.isFunction(e)?!0:"object"!=typeof e||e.effect?!1:!0:!0}t.extend(t.effects,{version:"1.10.3",save:function(t,e){for(var s=0;e.length>s;s++)null!==e[s]&&t.data(i+e[s],t[0].style[e[s]])},restore:function(t,s){var n,a;for(a=0;s.length>a;a++)null!==s[a]&&(n=t.data(i+s[a]),n===e&&(n=""),t.css(s[a],n))},setMode:function(t,e){return"toggle"===e&&(e=t.is(":hidden")?"show":"hide"),e},getBaseline:function(t,e){var i,s;switch(t[0]){case"top":i=0;break;case"middle":i=.5;break;case"bottom":i=1;break;default:i=t[0]/e.height}switch(t[1]){case"left":s=0;break;case"center":s=.5;break;case"right":s=1;break;default:s=t[1]/e.width}return{x:s,y:i}},createWrapper:function(e){if(e.parent().is(".ui-effects-wrapper"))return e.parent();var i={width:e.outerWidth(!0),height:e.outerHeight(!0),"float":e.css("float")},s=t("<div></div>").addClass("ui-effects-wrapper").css({fontSize:"100%",background:"transparent",border:"none",margin:0,padding:0}),n={width:e.width(),height:e.height()},a=document.activeElement;try{a.id}catch(o){a=document.body}return e.wrap(s),(e[0]===a||t.contains(e[0],a))&&t(a).focus(),s=e.parent(),"static"===e.css("position")?(s.css({position:"relative"}),e.css({position:"relative"})):(t.extend(i,{position:e.css("position"),zIndex:e.css("z-index")}),t.each(["top","left","bottom","right"],function(t,s){i[s]=e.css(s),isNaN(parseInt(i[s],10))&&(i[s]="auto")}),e.css({position:"relative",top:0,left:0,right:"auto",bottom:"auto"})),e.css(n),s.css(i).show()},removeWrapper:function(e){var i=document.activeElement;return e.parent().is(".ui-effects-wrapper")&&(e.parent().replaceWith(e),(e[0]===i||t.contains(e[0],i))&&t(i).focus()),e},setTransition:function(e,i,s,n){return n=n||{},t.each(i,function(t,i){var a=e.cssUnit(i);a[0]>0&&(n[i]=a[0]*s+a[1])}),n}}),t.fn.extend({effect:function(){function e(e){function s(){t.isFunction(a)&&a.call(n[0]),t.isFunction(e)&&e()}var n=t(this),a=i.complete,r=i.mode;(n.is(":hidden")?"hide"===r:"show"===r)?(n[r](),s()):o.call(n[0],i,s)}var i=s.apply(this,arguments),n=i.mode,a=i.queue,o=t.effects.effect[i.effect];return t.fx.off||!o?n?this[n](i.duration,i.complete):this.each(function(){i.complete&&i.complete.call(this)}):a===!1?this.each(e):this.queue(a||"fx",e)},show:function(t){return function(e){if(n(e))return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="show",this.effect.call(this,i)}}(t.fn.show),hide:function(t){return function(e){if(n(e))return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="hide",this.effect.call(this,i)}}(t.fn.hide),toggle:function(t){return function(e){if(n(e)||"boolean"==typeof e)return t.apply(this,arguments);var i=s.apply(this,arguments);return i.mode="toggle",this.effect.call(this,i)}}(t.fn.toggle),cssUnit:function(e){var i=this.css(e),s=[];return t.each(["em","px","%","pt"],function(t,e){i.indexOf(e)>0&&(s=[parseFloat(i),e])}),s}})}(),function(){var e={};t.each(["Quad","Cubic","Quart","Quint","Expo"],function(t,i){e[i]=function(e){return Math.pow(e,t+2)}}),t.extend(e,{Sine:function(t){return 1-Math.cos(t*Math.PI/2)},Circ:function(t){return 1-Math.sqrt(1-t*t)},Elastic:function(t){return 0===t||1===t?t:-Math.pow(2,8*(t-1))*Math.sin((80*(t-1)-7.5)*Math.PI/15)},Back:function(t){return t*t*(3*t-2)},Bounce:function(t){for(var e,i=4;((e=Math.pow(2,--i))-1)/11>t;);return 1/Math.pow(4,3-i)-7.5625*Math.pow((3*e-2)/22-t,2)}}),t.each(e,function(e,i){t.easing["easeIn"+e]=i,t.easing["easeOut"+e]=function(t){return 1-i(1-t)},t.easing["easeInOut"+e]=function(t){return.5>t?i(2*t)/2:1-i(-2*t+2)/2}})}()})(jQuery);(function(t){var e=/up|down|vertical/,i=/up|left|vertical|horizontal/;t.effects.effect.blind=function(s,n){var a,o,r,h=t(this),l=["position","top","bottom","left","right","height","width"],c=t.effects.setMode(h,s.mode||"hide"),u=s.direction||"up",d=e.test(u),p=d?"height":"width",f=d?"top":"left",m=i.test(u),g={},v="show"===c;h.parent().is(".ui-effects-wrapper")?t.effects.save(h.parent(),l):t.effects.save(h,l),h.show(),a=t.effects.createWrapper(h).css({overflow:"hidden"}),o=a[p](),r=parseFloat(a.css(f))||0,g[p]=v?o:0,m||(h.css(d?"bottom":"right",0).css(d?"top":"left","auto").css({position:"absolute"}),g[f]=v?r:o+r),v&&(a.css(p,0),m||a.css(f,r+o)),a.animate(g,{duration:s.duration,easing:s.easing,queue:!1,complete:function(){"hide"===c&&h.hide(),t.effects.restore(h,l),t.effects.removeWrapper(h),n()}})}})(jQuery);(function(t){t.effects.effect.bounce=function(e,i){var s,n,a,o=t(this),r=["position","top","bottom","left","right","height","width"],h=t.effects.setMode(o,e.mode||"effect"),l="hide"===h,c="show"===h,u=e.direction||"up",d=e.distance,p=e.times||5,f=2*p+(c||l?1:0),m=e.duration/f,g=e.easing,v="up"===u||"down"===u?"top":"left",_="up"===u||"left"===u,b=o.queue(),y=b.length;for((c||l)&&r.push("opacity"),t.effects.save(o,r),o.show(),t.effects.createWrapper(o),d||(d=o["top"===v?"outerHeight":"outerWidth"]()/3),c&&(a={opacity:1},a[v]=0,o.css("opacity",0).css(v,_?2*-d:2*d).animate(a,m,g)),l&&(d/=Math.pow(2,p-1)),a={},a[v]=0,s=0;p>s;s++)n={},n[v]=(_?"-=":"+=")+d,o.animate(n,m,g).animate(a,m,g),d=l?2*d:d/2;l&&(n={opacity:0},n[v]=(_?"-=":"+=")+d,o.animate(n,m,g)),o.queue(function(){l&&o.hide(),t.effects.restore(o,r),t.effects.removeWrapper(o),i()}),y>1&&b.splice.apply(b,[1,0].concat(b.splice(y,f+1))),o.dequeue()}})(jQuery);(function(t){t.effects.effect.clip=function(e,i){var s,n,a,o=t(this),r=["position","top","bottom","left","right","height","width"],h=t.effects.setMode(o,e.mode||"hide"),l="show"===h,c=e.direction||"vertical",u="vertical"===c,d=u?"height":"width",p=u?"top":"left",f={};t.effects.save(o,r),o.show(),s=t.effects.createWrapper(o).css({overflow:"hidden"}),n="IMG"===o[0].tagName?s:o,a=n[d](),l&&(n.css(d,0),n.css(p,a/2)),f[d]=l?a:0,f[p]=l?0:a/2,n.animate(f,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){l||o.hide(),t.effects.restore(o,r),t.effects.removeWrapper(o),i()}})}})(jQuery);(function(t){t.effects.effect.drop=function(e,i){var s,n=t(this),a=["position","top","bottom","left","right","opacity","height","width"],o=t.effects.setMode(n,e.mode||"hide"),r="show"===o,h=e.direction||"left",l="up"===h||"down"===h?"top":"left",c="up"===h||"left"===h?"pos":"neg",u={opacity:r?1:0};t.effects.save(n,a),n.show(),t.effects.createWrapper(n),s=e.distance||n["top"===l?"outerHeight":"outerWidth"](!0)/2,r&&n.css("opacity",0).css(l,"pos"===c?-s:s),u[l]=(r?"pos"===c?"+=":"-=":"pos"===c?"-=":"+=")+s,n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===o&&n.hide(),t.effects.restore(n,a),t.effects.removeWrapper(n),i()}})}})(jQuery);(function(t){t.effects.effect.explode=function(e,i){function s(){b.push(this),b.length===u*d&&n()}function n(){p.css({visibility:"visible"}),t(b).remove(),m||p.hide(),i()}var a,o,r,h,l,c,u=e.pieces?Math.round(Math.sqrt(e.pieces)):3,d=u,p=t(this),f=t.effects.setMode(p,e.mode||"hide"),m="show"===f,g=p.show().css("visibility","hidden").offset(),v=Math.ceil(p.outerWidth()/d),_=Math.ceil(p.outerHeight()/u),b=[];for(a=0;u>a;a++)for(h=g.top+a*_,c=a-(u-1)/2,o=0;d>o;o++)r=g.left+o*v,l=o-(d-1)/2,p.clone().appendTo("body").wrap("<div></div>").css({position:"absolute",visibility:"visible",left:-o*v,top:-a*_}).parent().addClass("ui-effects-explode").css({position:"absolute",overflow:"hidden",width:v,height:_,left:r+(m?l*v:0),top:h+(m?c*_:0),opacity:m?0:1}).animate({left:r+(m?0:l*v),top:h+(m?0:c*_),opacity:m?1:0},e.duration||500,e.easing,s)}})(jQuery);(function(t){t.effects.effect.fade=function(e,i){var s=t(this),n=t.effects.setMode(s,e.mode||"toggle");s.animate({opacity:n},{queue:!1,duration:e.duration,easing:e.easing,complete:i})}})(jQuery);(function(t){t.effects.effect.fold=function(e,i){var s,n,a=t(this),o=["position","top","bottom","left","right","height","width"],r=t.effects.setMode(a,e.mode||"hide"),h="show"===r,l="hide"===r,c=e.size||15,u=/([0-9]+)%/.exec(c),d=!!e.horizFirst,p=h!==d,f=p?["width","height"]:["height","width"],m=e.duration/2,g={},v={};t.effects.save(a,o),a.show(),s=t.effects.createWrapper(a).css({overflow:"hidden"}),n=p?[s.width(),s.height()]:[s.height(),s.width()],u&&(c=parseInt(u[1],10)/100*n[l?0:1]),h&&s.css(d?{height:0,width:c}:{height:c,width:0}),g[f[0]]=h?n[0]:c,v[f[1]]=h?n[1]:0,s.animate(g,m,e.easing).animate(v,m,e.easing,function(){l&&a.hide(),t.effects.restore(a,o),t.effects.removeWrapper(a),i()})}})(jQuery);(function(t){t.effects.effect.highlight=function(e,i){var s=t(this),n=["backgroundImage","backgroundColor","opacity"],a=t.effects.setMode(s,e.mode||"show"),o={backgroundColor:s.css("backgroundColor")};"hide"===a&&(o.opacity=0),t.effects.save(s,n),s.show().css({backgroundImage:"none",backgroundColor:e.color||"#ffff99"}).animate(o,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===a&&s.hide(),t.effects.restore(s,n),i()}})}})(jQuery);(function(t){t.effects.effect.pulsate=function(e,i){var s,n=t(this),a=t.effects.setMode(n,e.mode||"show"),o="show"===a,r="hide"===a,h=o||"hide"===a,l=2*(e.times||5)+(h?1:0),c=e.duration/l,u=0,d=n.queue(),p=d.length;for((o||!n.is(":visible"))&&(n.css("opacity",0).show(),u=1),s=1;l>s;s++)n.animate({opacity:u},c,e.easing),u=1-u;n.animate({opacity:u},c,e.easing),n.queue(function(){r&&n.hide(),i()}),p>1&&d.splice.apply(d,[1,0].concat(d.splice(p,l+1))),n.dequeue()}})(jQuery);(function(t){t.effects.effect.puff=function(e,i){var s=t(this),n=t.effects.setMode(s,e.mode||"hide"),a="hide"===n,o=parseInt(e.percent,10)||150,r=o/100,h={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()};t.extend(e,{effect:"scale",queue:!1,fade:!0,mode:n,complete:i,percent:a?o:100,from:a?h:{height:h.height*r,width:h.width*r,outerHeight:h.outerHeight*r,outerWidth:h.outerWidth*r}}),s.effect(e)},t.effects.effect.scale=function(e,i){var s=t(this),n=t.extend(!0,{},e),a=t.effects.setMode(s,e.mode||"effect"),o=parseInt(e.percent,10)||(0===parseInt(e.percent,10)?0:"hide"===a?0:100),r=e.direction||"both",h=e.origin,l={height:s.height(),width:s.width(),outerHeight:s.outerHeight(),outerWidth:s.outerWidth()},c={y:"horizontal"!==r?o/100:1,x:"vertical"!==r?o/100:1};n.effect="size",n.queue=!1,n.complete=i,"effect"!==a&&(n.origin=h||["middle","center"],n.restore=!0),n.from=e.from||("show"===a?{height:0,width:0,outerHeight:0,outerWidth:0}:l),n.to={height:l.height*c.y,width:l.width*c.x,outerHeight:l.outerHeight*c.y,outerWidth:l.outerWidth*c.x},n.fade&&("show"===a&&(n.from.opacity=0,n.to.opacity=1),"hide"===a&&(n.from.opacity=1,n.to.opacity=0)),s.effect(n)},t.effects.effect.size=function(e,i){var s,n,a,o=t(this),r=["position","top","bottom","left","right","width","height","overflow","opacity"],h=["position","top","bottom","left","right","overflow","opacity"],l=["width","height","overflow"],c=["fontSize"],u=["borderTopWidth","borderBottomWidth","paddingTop","paddingBottom"],d=["borderLeftWidth","borderRightWidth","paddingLeft","paddingRight"],p=t.effects.setMode(o,e.mode||"effect"),f=e.restore||"effect"!==p,m=e.scale||"both",g=e.origin||["middle","center"],v=o.css("position"),_=f?r:h,b={height:0,width:0,outerHeight:0,outerWidth:0};"show"===p&&o.show(),s={height:o.height(),width:o.width(),outerHeight:o.outerHeight(),outerWidth:o.outerWidth()},"toggle"===e.mode&&"show"===p?(o.from=e.to||b,o.to=e.from||s):(o.from=e.from||("show"===p?b:s),o.to=e.to||("hide"===p?b:s)),a={from:{y:o.from.height/s.height,x:o.from.width/s.width},to:{y:o.to.height/s.height,x:o.to.width/s.width}},("box"===m||"both"===m)&&(a.from.y!==a.to.y&&(_=_.concat(u),o.from=t.effects.setTransition(o,u,a.from.y,o.from),o.to=t.effects.setTransition(o,u,a.to.y,o.to)),a.from.x!==a.to.x&&(_=_.concat(d),o.from=t.effects.setTransition(o,d,a.from.x,o.from),o.to=t.effects.setTransition(o,d,a.to.x,o.to))),("content"===m||"both"===m)&&a.from.y!==a.to.y&&(_=_.concat(c).concat(l),o.from=t.effects.setTransition(o,c,a.from.y,o.from),o.to=t.effects.setTransition(o,c,a.to.y,o.to)),t.effects.save(o,_),o.show(),t.effects.createWrapper(o),o.css("overflow","hidden").css(o.from),g&&(n=t.effects.getBaseline(g,s),o.from.top=(s.outerHeight-o.outerHeight())*n.y,o.from.left=(s.outerWidth-o.outerWidth())*n.x,o.to.top=(s.outerHeight-o.to.outerHeight)*n.y,o.to.left=(s.outerWidth-o.to.outerWidth)*n.x),o.css(o.from),("content"===m||"both"===m)&&(u=u.concat(["marginTop","marginBottom"]).concat(c),d=d.concat(["marginLeft","marginRight"]),l=r.concat(u).concat(d),o.find("*[width]").each(function(){var i=t(this),s={height:i.height(),width:i.width(),outerHeight:i.outerHeight(),outerWidth:i.outerWidth()};f&&t.effects.save(i,l),i.from={height:s.height*a.from.y,width:s.width*a.from.x,outerHeight:s.outerHeight*a.from.y,outerWidth:s.outerWidth*a.from.x},i.to={height:s.height*a.to.y,width:s.width*a.to.x,outerHeight:s.height*a.to.y,outerWidth:s.width*a.to.x},a.from.y!==a.to.y&&(i.from=t.effects.setTransition(i,u,a.from.y,i.from),i.to=t.effects.setTransition(i,u,a.to.y,i.to)),a.from.x!==a.to.x&&(i.from=t.effects.setTransition(i,d,a.from.x,i.from),i.to=t.effects.setTransition(i,d,a.to.x,i.to)),i.css(i.from),i.animate(i.to,e.duration,e.easing,function(){f&&t.effects.restore(i,l)})})),o.animate(o.to,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){0===o.to.opacity&&o.css("opacity",o.from.opacity),"hide"===p&&o.hide(),t.effects.restore(o,_),f||("static"===v?o.css({position:"relative",top:o.to.top,left:o.to.left}):t.each(["top","left"],function(t,e){o.css(e,function(e,i){var s=parseInt(i,10),n=t?o.to.left:o.to.top;return"auto"===i?n+"px":s+n+"px"})})),t.effects.removeWrapper(o),i()}})}})(jQuery);(function(t){t.effects.effect.shake=function(e,i){var s,n=t(this),a=["position","top","bottom","left","right","height","width"],o=t.effects.setMode(n,e.mode||"effect"),r=e.direction||"left",h=e.distance||20,l=e.times||3,c=2*l+1,u=Math.round(e.duration/c),d="up"===r||"down"===r?"top":"left",p="up"===r||"left"===r,f={},m={},g={},v=n.queue(),_=v.length;for(t.effects.save(n,a),n.show(),t.effects.createWrapper(n),f[d]=(p?"-=":"+=")+h,m[d]=(p?"+=":"-=")+2*h,g[d]=(p?"-=":"+=")+2*h,n.animate(f,u,e.easing),s=1;l>s;s++)n.animate(m,u,e.easing).animate(g,u,e.easing);n.animate(m,u,e.easing).animate(f,u/2,e.easing).queue(function(){"hide"===o&&n.hide(),t.effects.restore(n,a),t.effects.removeWrapper(n),i()}),_>1&&v.splice.apply(v,[1,0].concat(v.splice(_,c+1))),n.dequeue()}})(jQuery);(function(t){t.effects.effect.slide=function(e,i){var s,n=t(this),a=["position","top","bottom","left","right","width","height"],o=t.effects.setMode(n,e.mode||"show"),r="show"===o,h=e.direction||"left",l="up"===h||"down"===h?"top":"left",c="up"===h||"left"===h,u={};t.effects.save(n,a),n.show(),s=e.distance||n["top"===l?"outerHeight":"outerWidth"](!0),t.effects.createWrapper(n).css({overflow:"hidden"}),r&&n.css(l,c?isNaN(s)?"-"+s:-s:s),u[l]=(r?c?"+=":"-=":c?"-=":"+=")+s,n.animate(u,{queue:!1,duration:e.duration,easing:e.easing,complete:function(){"hide"===o&&n.hide(),t.effects.restore(n,a),t.effects.removeWrapper(n),i()}})}})(jQuery);(function(t){t.effects.effect.transfer=function(e,i){var s=t(this),n=t(e.to),a="fixed"===n.css("position"),o=t("body"),r=a?o.scrollTop():0,h=a?o.scrollLeft():0,l=n.offset(),c={top:l.top-r,left:l.left-h,height:n.innerHeight(),width:n.innerWidth()},u=s.offset(),d=t("<div class='ui-effects-transfer'></div>").appendTo(document.body).addClass(e.className).css({top:u.top-r,left:u.left-h,height:s.innerHeight(),width:s.innerWidth(),position:a?"fixed":"absolute"}).animate(c,e.duration,e.easing,function(){d.remove(),i()})}})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Copyright (c) 2007-2014, InHand Networks All Rights Reserved.
	 * @author PANJC
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	  __webpack_require__(15),
	  __webpack_require__(1),
	  __webpack_require__(6),
	  __webpack_require__(11),
	  __webpack_require__(9)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (_structure,
	             _jquery,
	             _prototye,
	             dialog,
	             _config) {
	
	  var root = window;
	
	  Model = root.Model = (root.Model || {});
	
	  var _ = Model._;
	
	  var structure = Model.structure;
	
	  var config = CONFIG;
	
	  var prompt = (function () {
	    var prompt = config["dialog"]["module"];
	    return {
	      show: function (content, buttons) {
	        var obj = {lang: content};
	        if (buttons) {
	          obj.buttons = [{lang: buttons[0], click: buttons[1]}];
	          obj.close = buttons[1];
	        }
	        prompt.render(obj);
	      },
	      close: function () {
	        prompt.close();
	      }
	    }
	  })();
	
	  var error = {
	    token: {
	      queue: [],
	      number: 0,
	      cachedTime: config["ajax"]["cacheTime"]
	    }
	  }
	
	  var requestStructure = {
	
	    method: [true, _.string],
	    data: [false, _.object],
	    param: [false, _.object],
	    part: [false, _.string],
	    async: [false, _.boolean],
	    success: [false, _["function"]],
	    error: [false, _["function"]],
	    timeout: [false, _.object]
	
	  };
	
	  var method = {
	
	    checkType: function (data, type) {
	
	      var checkType = function (type) {
	
	        switch (type) {
	          case _.string:
	            if (typeof data === "string" && data.search(/^[\s]+$/) === -1) {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case _.number:
	            if (typeof data === "number") {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case _.object:
	            if (typeof data === "object" && data instanceof Object) {
	              if (Object.prototype.toString.call(data) === '[object Array]') {
	                return false;
	              } else {
	                return true;
	              }
	            } else {
	              return false;
	            }
	            break;
	          case _.array:
	            if (data instanceof Array) {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case _.boolean:
	            if (typeof data === "boolean") {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case _["function"]:
	            if (data instanceof Function) {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case _.empty:
	            if (data.search(/^[\s]+$/) !== -1) {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case null:
	            if (data === null) {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	          case undefined:
	            if (data === undefined) {
	              return true;
	            } else {
	              return false;
	            }
	            break;
	        }
	
	      }
	
	      var returnedResult = false;
	
	      if ($.isArray(type) === true) {
	        var _returnedResult = false;
	        for (var num = 0; num < type.length; num++) {
	          _returnedResult = checkType(type[num]) || _returnedResult;
	        }
	        returnedResult = _returnedResult || returnedResult;
	      } else {
	        returnedResult = checkType(type) || returnedResult;
	      }
	
	      return returnedResult;
	
	    },
	
	    checkRequired: function (data, required) {
	      if (required === false) {
	        return "optional";
	      } else if (required === true) {
	        if (data === undefined) {
	          return "fail";
	        } else {
	          return "pass";
	        }
	      }
	    },
	
	    checkOption: function (data, validationArr, info) {
	
	      var checkRequiredResult = this.checkRequired(data, validationArr[1][0]);
	      var checkTypeResult = this.checkType(data, validationArr[1][1]);
	
	      if (checkRequiredResult === "fail") {
	        this.throwError({url: info.url, info: "field \'" + validationArr[0] + "\' is required"});
	        return false;
	      } else if (checkRequiredResult === "pass") {
	        if (checkTypeResult === false) {
	          this.throwError({
	            url: info.url,
	            info: "field \'" + validationArr[0] + "\' must be the " + validationArr[1][1]
	          });
	          return false;
	        } else {
	          return true;
	        }
	      } else if (checkRequiredResult === "optional") {
	        if (data) {
	          if (checkTypeResult === false) {
	            this.throwError({url: info.url, info: "field \'" + validationArr[0] + "\' must be " + validationArr[1][1]});
	            return false;
	          } else {
	            return true;
	          }
	        } else {
	          return true;
	        }
	      }
	
	    },
	
	    checkObject: function (data, arr, info) {
	
	      var filed = arr[0];
	      var obj = arr[1];
	
	      if (data === undefined) {
	        if (obj._required === true) {
	          this.throwError({url: info.url, info: "\n field \'" + filed + "\' is required"});
	          return false;
	        } else if (obj._required === false) {
	          return;
	        }
	      }
	
	      for (var attr in obj) {
	        if (this.checkOption(data[attr], [attr, obj[attr]], info) === false) {
	          return false;
	        }
	      }
	
	    },
	
	    checkStructure: function (data, structure, info) {
	
	      var self = this;
	
	      for (var attr in structure) {
	        if (attr !== "_desc") {
	          if (this.checkType(structure[attr], _.array) === true) {
	            if (this.checkOption(data[attr], [attr, structure[attr]], info) === false) {
	              return false;
	            }
	          } else if (this.checkType(structure[attr], _.object) === true) {
	            if (this.checkObject(data[attr], [attr, structure[attr]], info) === false) {
	              return false;
	            }
	          }
	        }
	      }
	
	    },
	
	    checkMethod: function (data, appType) {
	
	      if (data === undefined) {
	        this.throwError({url: appType, info: "Param is required"});
	        return false;
	      }
	
	      if (this.checkType(data, _.object) === false) {
	        this.throwError({url: appType, info: "Param must be the object"});
	        return false;
	      }
	
	      if (data.method === undefined) {
	        this.throwError({url: appType, info: "Param 'method' is required"});
	        return false;
	      }
	
	      if (Object.isFunction(Model[appType][data["method"]])) {
	        return "extend";
	      }
	
	      var method = data.method;
	      var app = structure[appType];
	
	      if (app[method] === undefined) {
	        this.throwError({url: appType, info: "Method \'" + method + "\' is not existed"});
	        return false;
	      } else {
	        return true;
	      }
	
	    },
	
	    isValidate: function (data) {
	      if (data.validation === undefined) {
	        return true;
	      } else {
	        if (data.validation === false) {
	          return false;
	        } else {
	          return true;
	        }
	      }
	    },
	
	    _paramParam: function (param) {
	      var arr = [];
	      for (var attr in param) {
	        if ($.isArray(param[attr])) {
	          arr.push(attr + "=" + param[attr].join(","));
	        } else {
	          arr.push(attr + "=" + param[attr]);
	        }
	      }
	      return arr.join("&");
	    },
	
	    request: function (data, appType) {
	
	      if (this.checkMethod(data, appType) === "extend") {
	        Model[appType][data["method"]](data);
	        return;
	      }
	      ;
	
	      if (this.checkMethod(data, appType) === false) {
	        return;
	      }
	      ;
	
	      var _dataStructure = structure[appType][data["method"]];
	
	      if (this.isValidate(data)) {
	
	        if (this.checkStructure(data, requestStructure, _dataStructure) === false) {
	          return;
	        }
	
	        if (this.checkStructure(data, _dataStructure, _dataStructure) === false) {
	          return;
	        }
	
	      }
	
	      var self = this;
	
	      var request = {};
	
	      var ajaxObject = {};
	
	      var url = _dataStructure["url"];
	
	      if (url.indexOf("oauth") !== -1) {
	
	        request.url = config["server"]["path"]["oauth"] + url;
	
	      } else if (url.indexOf("api") !== -1) {
	
	        request.url = config["server"]["path"]["api"] + url;
	
	      }
	
	      request.type = _dataStructure["type"];
	
	      request.dataType = "JSON";
	
	      request.processData = false;
	
	      request.timeout = config["ajax"]["timeout"];
	
	      request.error = self.errorHandler;
	
	      if (data.part) {
	        request.url = request.url + "/" + data.part;
	      }
	
	      if (_dataStructure.suffix) {
	        request.url = request.url + _dataStructure.suffix;
	      }
	
	      if (data.param) {
	        if (Prototype.Browser.IE) {
	          data.param.random = Math.random();
	        }
	        if (data.token !== false) {
	          data.param.access_token = self.getAccessToken();
	        }
	        request.url = request.url + "?" + Object.toQueryString(data.param);
	      } else {
	        if (Prototype.Browser.IE || data.token !== false) {
	          var param = {};
	          if (Prototype.Browser.IE) {
	            param.random = Math.random();
	          }
	          if (data.token !== false) {
	            param.access_token = self.getAccessToken();
	          }
	          request.url = request.url + "?" + Object.toQueryString(param);
	        }
	      }
	
	      if (data.contentType) {
	        request.contentType = data.contentType;
	      } else {
	        request.contentType = "application/json;charset=UTF-8";
	      }
	
	      if (data.data) {
	        if (request.contentType == "application/x-www-form-urlencoded") {
	          request.data = Object.toQueryString(data.data);
	        } else {
	          request.data = Object.toJSON(data.data);
	        }
	      }
	
	      if (data.async) {
	        request.async = data.async;
	      }
	
	      if (data.timeout) {
	        request.timeout = data.timeout;
	      }
	
	      request.success = function (returnData) {
	        self.successHandler(returnData, data.success, data.error, request, data.token)
	      };
	
	      $.ajax(request).fail(function (jqXHR, textStatus, errorThrown) {
	        if (jqXHR.status > 399 && jqXHR.status < 500) {
	          var returnData = $.parseJSON(jqXHR.responseText);
	          self.successHandler(returnData, data.success, data.error, request, data.token)
	        }
	      });
	
	    },
	
	    _request: function (data) {
	      if (data.url.indexOf("access_token=") !== -1) {
	        data.url = data.url.replace(/access_token=[\w\d]{32}/, "access_token=" + this.getAccessToken());
	      }
	      $.ajax(data);
	    },
	
	    successHandler: function (returnData, success, error, request, token) {
	      var self = this;
	      if (returnData.error === undefined) {
	        if (success !== undefined) {
	//						var result = (returnData.result !== undefined) ? returnData.result : returnData;
	//						success(result);
	          success(returnData);
	        }
	      } else {
	        if (self.autoErrorHandler(returnData, request, token) === false) {
	          return;
	        }
	        ;
	        if (error !== undefined) {
	          error(returnData);
	          self.defaultErrorHandler(returnData);
	        } else {
	          self.defaultErrorHandler(returnData);
	        }
	        cloud.util.unmask();
	      }
	    },
	
	    errorHandler: function () {
	      var error = {
	//                		request:request,
	//                		status:status,
	//                		thrown:thrown
	      };
	    },
	
	    autoErrorHandler: function (returnData, request, token) {
	      var self = this;
	      var code = parseInt(returnData.error_code);
	      if ($.inArray(code, [21327, 21334, 21335, 21336]) !== -1) {
	        if (token !== false) {
	          if (!self.getAccessToken() || !self.getRefreshToken()) {
	            self.logout();
	            return;
	          }
	          self.cacheErrorTokenRequests(request);
	          return false;
	        }
	      } else if ($.inArray(code, [21305, 21332, 21333]) !== -1) {
	        prompt.show("login_again", ["ok", function () {
	          prompt.close();
	          self.logout();
	        }]);
	        return false;
	      }
	    },
	
	    defaultErrorHandler: function (returnData) {
	      var code = parseInt(returnData.error_code);
	      var content = returnData.error.toLowerCase();
	      var url = returnData.request.toLowerCase();
	      if (code === 20007) {
	        if (cloud.util.inString("tag", content)) {
	          prompt.show("tag_already_exists");
	        } else if (cloud.util.inString("gateway", content)) {
	          prompt.show("gateway_already_exists");
	        } else if (cloud.util.inString("name", content)) {
	          if (cloud.util.inString("device", url)) {
	            prompt.show("device_already_exists");
	          } else if (cloud.util.inString("sites", url)) {
	            prompt.show("site_already_exists");
	          }
	        } else if (cloud.util.inString("serival", content)) {
	          prompt.show("serial_string_already_exists");
	        } else if (cloud.util.inString("group", content)) {
	          prompt.show("group_already_exists");
	        } else {
	          prompt.show("resource_already_exists");
	        }
	      } else {
	        prompt.show(code);
	      }
	    },
	
	    requestErrorTokenQueue: function () {
	      var self = this;
	      var obj = error.token;
	      if (obj.queue.length > 0) {
	        $.each(obj.queue, function (index, _request) {
	          method._request(_request);
	        });
	        obj.queue = [];
	        obj.number = 0;
	      }
	    },
	
	    cacheErrorTokenRequests: function (_request) {
	      var self = this;
	      var obj = error.token;
	      if (obj.number === 0) {
	        var delayFun = function () {
	          if (self.getRefreshToken() === null) {
	            prompt.show("login_again", ["ok", function () {
	              prompt.close();
	              self.logout();
	            }]);
	            return;
	          }
	          self.refreshToken(self.requestErrorTokenQueue);
	        }
	        setTimeout(function () {
	          delayFun()
	        }, obj.cachedTime);
	      }
	      obj.queue.push(_request);
	      obj.number++;
	    },
	
	    refreshToken: function (callback) {
	      var self = this;
	      var refreshTokenFailureNumber = error["token"]["refreshTokenFailureNumber"];
	      Model.oauth({
	        method: "refresh_token",
	        data: {
	          client_id: config["oauth"]["client_id"],
	          client_secret: config["oauth"]["client_secret"],
	          grant_type: config["oauth"]["grant_type"]["refresh_token"],
	          refresh_token: self.getRefreshToken()
	        },
	        contentType: "application/x-www-form-urlencoded",
	        success: function (data) {
	          self.setAccessToken(data.access_token);
	          self.setRefreshToken(data.refresh_token);
	          callback();
	        },
	        error: function (data) {
	          self.clearErrorToken();
	          prompt.show("login_again", ["ok", function () {
	            prompt.close();
	            self.logout();
	          }]);
	        }
	      });
	    },
	
	    clearErrorToken: function () {
	      error.token.queue = [];
	      error.token.number = 0;
	    },
	
	    clearToken: function () {
	      sessionStorage.removeItem(config["token"]["access_token"]);
	      sessionStorage.removeItem(config["token"]["refresh_token"]);
	    },
	
	    logout: function () {
	      var self = this;
	      self.clearToken();
	      self.clearErrorToken();
	      location.replace(config["url"]["login"]["fail"]);
	    },
	
	    throwError: function (obj) {
	      console.log(obj.url + "\n" + obj.info);
	    },
	
	    getAccessToken: function () {
	      return sessionStorage.getItem(config["token"]["access_token"]);
	    },
	
	    getRefreshToken: function () {
	      return sessionStorage.getItem(config["token"]["refresh_token"]);
	    },
	
	    setAccessToken: function (param) {
	      sessionStorage.setItem(config["token"]["access_token"], param);
	    },
	
	    setRefreshToken: function (param) {
	      sessionStorage.setItem(config["token"]["refresh_token"], param);
	    }
	
	  }
	
	  var modelObj = {
	    organ: function (data) {
	      method.request(data, "organ")
	    },
	    site: function (data) {
	      method.request(data, "site")
	    },
	    device: function (data) {
	      method.request(data, "device")
	    },
	    machine: function (data) {
	      method.request(data, "machine")
	    },
	    model: function (data) {
	      method.request(data, "model")
	    },
	    user: function (data) {
	      method.request(data, "user")
	    },
	    role: function (data) {
	      method.request(data, "role")
	    },
	    customer: function (data) {
	      method.request(data, "customer")
	    },
	    task: function (data) {
	      method.request(data, "task")
	    },
	    oauth: function (data) {
	      method.request(data, "oauth")
	    },
	    captchas: function (data) {
	      method.request(data, "captchas")
	    },
	    history: function (data) {
	      method.request(data, "history")
	    },
	    statistics: function (data) {
	      method.request(data, "statistics")
	    },
	    tag: function (data) {
	      method.request(data, "tag")
	    },
	    app: function (data) {
	      method.request(data, "app")
	    },
	    alarm: function (data) {
	      method.request(data, "alarm")
	    },
	    reports: function (data) {
	      method.request(data, "reports")
	    },
	    favor: function (data) {
	      method.request(data, "favor")
	    },
	    log: function (data) {
	      method.request(data, "log")
	    },
	    realtime: function (data) {
	      method.request(data, "realtime")
	    },
	    group: function (data) {
	      method.request(data, "group")
	    },
	    _method: method
	  };
	
	  $.extend(Model, modelObj);
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	
	  var root = window;
	
	  Model = root.Model = (root.Model || {});
	
	  if (Model.t === undefined) {
	
	    Model._ = {
	      "boolean": "boolean",
	      "number": "number",
	      "string": "string",
	      "undefined": undefined,
	      "null": null,
	      "array": "array",
	      "object": "object",
	      "function": "function",
	      "empty": "empty",
	      "get": "GET",
	      "post": "POST",
	      "delete": "DELETE",
	      "put": "PUT"
	    }
	
	  }
	
	  if (Model.structure === undefined) {
	
	    var _ = Model._;
	
	    Model.structure = {
	
	      organ: {
	
	        _name: {
	          zh: "机构",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api2/organizations",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询机构"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api2/organizations",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            name: [false, _.string],
	            state: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询机构列表"
	            }
	          }
	        },
	
	        query_current: {
	          url: "/api2/organizations/this",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询当前机构"
	            }
	          }
	        },
	
	        query_stat: {
	          url: "/api2/organizations/stat",
	          type: _.post,
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询机构状态"
	            }
	          }
	        },
	
	        add: {
	          url: "/api2/organizations",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          data: {
	            _required: true,
	            name: [true, _.string],
	            email: [true, _.string],
	            phone: [true, [_.string, _.number]],
	            website: [false, _.string],
	            fax: [false, [_.string, _.number]],
	            address: [false, _.string],
	            username: [true, _.string],
	            cellPhone: [false, [_.string, _.number]],
	            question: [true, [_.string, _.number]],
	            answer: [true, [_.string, _.number]],
	            photoFileld: [false, _.string],
	            picId: [true, _.string],
	            varificationCode: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "新增机构"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api2/organizations",
	          type: _["delete"],
	          part: [true, _.string],
	          _desc: {
	            zh: {
	              name: "删除机构"
	            }
	          }
	        },
	
	        update: {
	          url: "/api2/organizations",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          data: {
	            _required: false,
	            name: [false, _.string],
	            email: [false, _.string],
	            phone: [false, [_.string, _.number]],
	            website: [false, _.string],
	            fax: [false, [_.string, _.number]],
	            address: [false, _.string],
	            username: [false, _.string],
	            cellPhone: [false, [_.string, _.number]],
	            question: [false, [_.string, _.number]],
	            answer: [false, [_.string, _.number]],
	            photoFileld: [false, _.string],
	            picId: [false, _.string],
	            varificationCode: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新机构信息"
	            }
	          }
	        },
	
	        update_current: {
	          url: "/api2/organizations/this",
	          type: _.put,
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          data: {
	            _required: false,
	            name: [false, _.string],
	            email: [false, _.string],
	            phone: [false, [_.string, _.number]],
	            website: [false, _.string],
	            fax: [false, [_.string, _.number]],
	            address: [false, _.string],
	            username: [false, _.string],
	            cellPhone: [false, [_.string, _.number]],
	            question: [false, [_.string, _.number]],
	            answer: [false, [_.string, _.number]],
	            photoFileld: [false, _.string],
	            picId: [false, _.string],
	            varificationCode: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新当前机构信息"
	            }
	          }
	        }
	
	      },
	
	      site: {
	
	        _name: {
	          zh: "现场",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/sites",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询现场"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/sites",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            address: [false, _.string],
	            online: [false, _.number],
	            has_gateway: [false, _.boolean],
	            business_state: [false, _.string],
	            is_alarm: [false, _.boolean],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询现场列表"
	            }
	          }
	        },
	
	        query_devices_count: {
	          url: "/api/sites/count",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询现场下设备"
	            }
	          }
	        },
	
	        add: {
	          url: "/api/sites",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "新增现场"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/sites",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            delete_all: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除现场"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/sites",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "更新现场信息"
	            }
	          }
	        }
	
	      },
	
	      machine: {
	
	        _name: {
	          zh: "机器",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/machines",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询机器"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/machines",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            plc_id: [false, _.number],
	            site_id: [false, _.string],
	            modelId: [false, _.string],
	            serial_number: [false, _.string],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询机器列表"
	            }
	          }
	        },
	
	        add: {
	          url: "/api/machines",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "新增列表"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/machines",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cancel_site: [false, _.string]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "更新机器信息"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/machines",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除机器"
	            }
	          }
	        }
	
	      },
	
	      device: {
	
	        _name: {
	          zh: "设备",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/devices",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/devices",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            online: [false, _.number],
	            plc_id: [false, _.number],
	            site_id: [false, _.string],
	            site_name: [false, _.string],
	            model: [false, _.string],
	            serial_number: [false, _.string],
	            address: [false, _.string],
	            business_state: [false, _.string],
	            is_alarm: [false, _.boolean],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备列表"
	            }
	          }
	        },
	
	        post_query_list: {
	          url: "/api/devices/overview",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "post查询设备列表"
	            }
	          }
	        },
	
	        query_organ: {
	          url: "/api/devices",
	          type: _.get,
	          param: {
	            _required: true,
	            serial_number: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备所在机构"
	            }
	          }
	        },
	
	        query_site: {
	          url: "/api/devices/batch_get",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            online: [false, _.number],
	            plc_id: [false, _.number],
	            model: [false, _.string],
	            serial_number: [false, _.string],
	            address: [false, _.string],
	            business_state: [false, _.string],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备所属现场"
	            }
	          }
	        },
	
	        add: {
	          url: "/api/devices",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            create_site: [false, _.number]
	          },
	          data: {
	            _required: true,
	            name: [true, _.string],
	            modelId: [true, _.string],
	            serialNumber: [true, _.string],
	            location: [true, _["object"]],
	            model: [false, _.string],
	            plcId: [false, _.number],
	            maxPlcId: [false, _.number],
	            maxSensorId: [false, _.number],
	            mobileNumber: [false, _.number],
	            timezone: [false, _.number],
	            siteName: [false, _.string],
	            siteId: [false, _.string],
	            contact: [false, _["object"]],
	            vendorId: [false, _.number],
	            priIp: [false, _.string],
	            pubIp: [false, _.string],
	            priPort: [false, _.number],
	            pubPort: [false, _.number],
	            online: [false, _.number],
	            syncState: [false, _.number],
	            config: [false, _["object"]],
	            info: [false, _["object"]],
	            isMyFavorite: [false, _.number],
	            alarmCount: [false, _.number],
	            location: [false, _["object"]],
	            deviceConfig: [false, _["object"]],
	            address: [false, _.string],
	            businessState: [false, _.number],
	            owner: [false, _.string],
	            createTime: [false, _.number],
	            updateTime: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "新增设备"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/devices",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除设备"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/devices",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cancel_site: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新设备信息"
	            }
	          }
	        },
	
	        batch_add: {
	          url: "/api/devices/batch_add",
	          type: _.post,
	          param: {
	            _required: true,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            create_site: [false, _.number],
	            file_id: [true, _.string]
	          },
	          data: {
	            _required: true,
	            publicAttribute: [true, _["object"]]
	          },
	          _desc: {
	            zh: {
	              name: "批量增加设备"
	            }
	          }
	        },
	
	        batch_update: {
	          url: "/api/devices/batch_update",
	          type: _.post,
	          param: {
	            _required: true,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            file_id: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "批量更新设备信息"
	            }
	          }
	        },
	
	        batch_delete: {
	          url: "/api/devices/batch_delete",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "批量删除设备"
	            }
	          }
	        }
	
	      },
	
	      model: {
	
	        _name: {
	          zh: "机型",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/models",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询机器"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/models",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询机器列表"
	            }
	          }
	        },
	
	        add: {
	          url: "/api/models",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            configFile: [true, _.string],
	            sensorType: [true, _.number],
	            model: [true, _.string],
	            name: [true, _.string],
	            gateway: [false, _.boolean],
	            accessProto: [false, _.string],
	            firmwareProto: [false, _.string],
	            sensorType: [false, _.number],
	            ioType: [false, _.number],
	            plcTypeId: [false, _.number],
	            "delete": [false, _.number],
	            isMyFavorite: [false, _.number],
	            icon: [false, _.string],
	            descriptions: [false, _["object"]],
	            pics: [false, _.array],
	            views: [false, _.array],
	            owner: [false, _.string],
	            createTime: [false, _.number],
	            createTime: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "新增机器"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/models",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除机器"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/models",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新机器信息"
	            }
	          }
	        }
	
	      },
	
	      history: {
	
	        _name: {
	          zh: "历史数据",
	          en: ""
	        },
	
	        query_devices: {
	          url: "/api/data",
	          type: _.post,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            start_time: [true, _.number],
	            end_time: [true, _.number]
	          },
	          data: {
	            _required: false,
	            devices: [false, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备历史数据"
	            }
	          }
	        }
	
	      },
	
	      tag: {
	
	        _name: {
	          zh: "标签",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/tags",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询标签"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/tags",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            shared: [false, _.boolean]
	          },
	          _desc: {
	            zh: {
	              name: "查询标签列表"
	            }
	          }
	        },
	
	        query_resource_tags: {
	          url: "/api/resource_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            resource_type: [false, _.number],
	            resource_id: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询批量资源所属标签"
	            }
	          }
	        },
	
	        query_resources_tags: {
	          url: "/api/resources_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询资源所属标签"
	            }
	          }
	        },
	
	        query_tag: {
	          url: "/api/tags",
	          type: _.get,
	          part: [true, _.string],
	          suffix: "/resources",
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            resource_type: [false, _.number],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询标签下的资源"
	            }
	          }
	        },
	
	        query_count: {
	          url: "/api/resource_tags/stat",
	          type: _.post,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          data: {
	            _required: true,
	            resourceTypes: [true, _.array],
	            tagIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询标签统计"
	            }
	          }
	        },
	
	        add: {
	          url: "/api/tags",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            name: [true, _.string],
	            shared: [true, _.boolean],
	            owner: [false, _.string],
	            createTime: [false, _.number],
	            updateTime: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "新增标签"
	            }
	          }
	        },
	
	        tag_resource: {
	          url: "/api/resource_tags",
	          type: _.put,
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            resource_type: [true, _.number],//类型待定
	            resource_id: [true, _.string],
	            tag_id: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "给资源打标签"
	            }
	          }
	        },
	
	        tag_resources: {
	          url: "/api/resources_tags",
	          type: _.put,
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            tag_id: [true, _.string]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "给批量资源打标签"
	            }
	          }
	        },
	
	        tag_resources_tags: {
	          url: "/api/resources_multiple_tags",
	          type: _.post,
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            resourceTags: [true, _.array],
	            resourceId: [true, _.string],
	            tagIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "给批量资源打批量标签"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/tags",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除标签"
	            }
	          }
	        },
	
	        delete_resource_tag: {
	          url: "/api/resource_tags",
	          type: _["delete"],
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            resource_id: [true, _.string],
	            tag_id: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除资源的标签"
	            }
	          }
	        },
	
	        delete_resources_tags: {
	          url: "/api/resources_multiple_tags",
	          type: _.put,
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            resourceTags: [true, _.array],
	            resourceId: [true, _.string],
	            tagIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "删除批量资源的标签"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/tags",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: false,
	            name: [false, _.string],
	            shared: [false, _.boolean],
	            owner: [false, _.string],
	            createTime: [false, _.number],
	            updateTime: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "更新标签"
	            }
	          }
	        },
	
	        query_user: {
	          url: "/api/user_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询用户的标签"
	            }
	          }
	        },
	
	        query_role: {
	          url: "/api/role_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询角色的标签"
	            }
	          }
	        },
	
	        query_device: {
	          url: "/api/device_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备的标签"
	            }
	          }
	        },
	
	        query_site: {
	          url: "/api/site_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询现场的标签"
	            }
	          }
	        },
	
	        query_model: {
	          url: "/api/model_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询机型的标签"
	            }
	          }
	        },
	
	        query_document: {
	          url: "/api/document_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询文档的标签"
	            }
	          }
	        },
	
	        query_customer: {
	          url: "/api/customer_tags",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询客户的标签"
	            }
	          }
	        },
	
	        query_none: {
	          url: "/api/tags/none/resources",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询没有资源的标签"
	            }
	          }
	        }
	
	      },
	
	      statistics: {
	
	        _name: {
	          zh: "在线统计",
	          en: ""
	        },
	
	        query_online: {
	          url: "/api/online_stat",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询在线统计"
	            }
	          }
	        },
	
	        query_online_trend: {
	          url: "/api/online_tendency",
	          type: _.post,
	          param: {
	            _required: true,
	            start_time: [true, _.number],
	            end_time: [true, _.number]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询在线曲线"
	            }
	          }
	        },
	
	        query_month_traffic: {
	          url: "/api/traffic_month",
	          type: _.get,
	          param: {
	            _required: true,
	            month: [true, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询月流量"
	            }
	          }
	        },
	
	        query_day_traffic: {
	          url: "/api/traffic_day",
	          type: _.get,
	          param: {
	            _required: true,
	            month: [true, _.number],
	            device_id: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "日流量"
	            }
	          }
	        },
	
	        query_traffic: {
	          url: "/api/traffic",
	          type: _.post,
	          param: {
	            _required: false,
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          data: {
	            _required: true,
	            deviceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询流量"
	            }
	          }
	        },
	
	        query_signal: {
	          url: "/api2/signal",
	          type: _.post,
	          param: {
	            _required: true,
	            start_time: [true, _.number],
	            end_time: [true, _.number]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询信号值"
	            }
	          }
	        }
	
	      },
	
	      user: {
	
	        _name: {
	          zh: "用户",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api2/users",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询用户"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api2/users",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            role_ids: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询用户列表"
	            }
	          }
	        },
	
	        query_list_post: {
	          url: "/api2/users/list",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            role_ids: [false, _.string]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "post查询用户列表"
	            }
	          }
	        },
	
	        query_current: {
	          url: "/api2/users/this",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询当前用户"
	            }
	          }
	        },
	
	        add: {
	          url: "/api2/users",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          data: {
	            _required: true,
	            email: [true, _.string],
	            roleId: [true, _.string],
	            name: [true, _.string],
	            password: [false, _.string],
	            phone: [false, _.string],
	            photoFileld: [false, _.string],
	            owner: [false, _.string],
	            question: [false, _.string],
	            answer: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "新增用户"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api2/users",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除用户"
	            }
	          }
	        },
	
	        update: {
	          url: "/api2/users",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: false,
	            email: [false, _.string],
	            roleId: [false, _.string],
	            name: [false, _.string],
	            password: [false, _.string],
	            phone: [false, _.string],
	            photoFileld: [false, _.string],
	            owner: [false, _.string],
	            question: [false, _.string],
	            answer: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新用户信息"
	            }
	          }
	        },
	
	        update_current: {
	          url: "/api2/users/this",
	          type: _.put,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: false,
	            email: [false, _.string],
	            roleId: [false, _.string],
	            name: [false, _.string],
	            password: [false, _.string],
	            phone: [false, _.string],
	            photoFileld: [false, _.string],
	            owner: [false, _.string],
	            question: [false, _.string],
	            answer: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新当前用户信息"
	            }
	          }
	        },
	
	        update_owner: {
	          url: "/api2/users",
	          type: _.put,
	          part: [true, _.string],
	          suffix: "/owner",
	          param: {
	            _required: true,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            owner: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "更新？？"
	            }
	          }
	        },
	
	        update_role: {
	          url: "/api2/users",
	          type: _.put,
	          part: [true, _.string],
	          suffix: "/role",
	          param: {
	            _required: true,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            role_ids: [true, _.array]//类型待定
	          },
	          _desc: {
	            zh: {
	              name: "更新角色"
	            }
	          }
	        },
	
	        update_password: {
	          url: "/api2/users",
	          type: _.put,
	          part: [true, _.string],
	          suffix: "/password",
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            oldPassword: [true, [_.string, _.number]],
	            newPassword: [true, [_.string, _.number]],
	            phone: [false, [_.string, _.number]]
	          },
	          _desc: {
	            zh: {
	              name: "更改密码"
	            }
	          }
	        },
	
	        update_current_password: {
	          url: "/api2/users/this/password",
	          type: _.put,
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            oldPassword: [true, [_.string, _.number]],
	            newPassword: [true, [_.string, _.number]],
	            phone: [false, [_.string, _.number]]
	          }
	          ,
	          _desc: {
	            zh: {
	              name: "更新当前用户的密码"
	            }
	          }
	        },
	
	        reset_password: {
	          url: "/api2/users",
	          type: _.put,
	          part: [true, _.string],
	          suffix: "/reset_password",
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            language: [true, _.number]
	          },
	          data: {
	            _required: true,
	            phone: [false, [_.string, _.number]],
	            picId: [true, [_.string, _.number]],
	            varificationCode: [true, [_.string, _.number]]
	          },
	          _desc: {
	            zh: {
	              name: "重置用户密码"
	            }
	          }
	        },
	
	        reset_current_password: {
	          url: "/api2/users/this/reset_password",
	          type: _.put,
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            language: [true, _.number]
	          },
	          data: {
	            _required: true,
	            phone: [false, [_.string, _.number]],
	            picId: [true, [_.string, _.number]],
	            varificationCode: [true, [_.string, _.number]]
	          },
	          _desc: {
	            zh: {
	              name: "重置当前用户用户"
	            }
	          }
	        },
	
	        forgot_password: {
	          url: "/api/forgotten_password",
	          type: _.post,
	          param: {
	            _required: true,
	            language: [true, _.number]
	          },
	          data: {
	            _required: true,
	            username: [true, _.string],
	            picId: [true, _.string],
	            varificationCode: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "忘记密码"
	            }
	          }
	        },
	
	        query_privilege: {
	          url: "/api2/users/this/privilege",
	          type: _.get,
	          param: {
	            _required: true,
	            oid: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "获取权限表"
	            }
	          }
	        },
	
	        _logout: {
	          url: "/api2/logout",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "退出登录"
	            }
	          }
	        }
	
	      },
	
	      role: {
	
	        _name: {
	          zh: "角色",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api2/roles",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询角色"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api2/roles",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询角色列表"
	            }
	          }
	        },
	
	        add: {
	          url: "/api2/roles",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            name: [true, _.string],
	            type: [true, _.number],
	            privileges: [false, _["object"]]//类型待定
	          },
	          _desc: {
	            zh: {
	              name: "新增角色"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api2/roles",
	          type: _["delete"],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除角色"
	            }
	          }
	        },
	
	        update: {
	          url: "/api2/roles",
	          type: _.put,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: false,
	            name: [false, _.string],
	            type: [false, _.number],
	            privileges: [false, _["object"]]//类型待定
	          },
	          _desc: {
	            zh: {
	              name: "更新角色信息"
	            }
	          }
	        }
	
	      },
	
	      customer: {
	
	        _name: {
	          zh: "客户",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/customers",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询客户"
	            }
	          }
	
	        },
	
	        query_list: {
	          url: "/api/customers",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询客户列表"
	            }
	          }
	        },
	
	        query_sites_count: {
	          url: "/api/customers",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "？？"
	            }
	          }
	        },
	
	        add: {
	          url: "/api2/customers",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            name: [true, _.string],
	            email: [true, _.string],
	            phone: [false, [_.string, _.number]],
	            address: [false, _.string],
	            webSite: [false, _.string],
	            isMyFavorite: [false, _.number],
	            siteCount: [false, _.number],
	            siteIdList: [false, _.array],
	            contact: [false, _["object"]],//类型待定
	            owner: [false, _.string],
	            createTime: [false, _.number],
	            updateTime: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "新增用户"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/customers",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除用户"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/customers",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: false,
	            name: [false, _.string],
	            email: [false, _.string],
	            phone: [false, [_.string, _.number]],
	            address: [false, _.string],
	            webSite: [false, _.string],
	            isMyFavorite: [false, _.number],
	            siteCount: [false, _.number],
	            siteIdList: [false, _.array],
	            contact: [false, _["object"]],//类型待定
	            owner: [false, _.string],
	            createTime: [false, _.number],
	            updateTime: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "更新用户信息"
	            }
	          }
	        }
	
	      },
	
	      task: {
	
	        _name: {
	          zh: "任务",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api2/tasks",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询任务"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api2/tasks",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            states: [false, _.array],
	            user_types: [false, _.array],
	            types: [false, _.array],
	            object_id: [false, _.string],
	            object_id_list: [false, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询任务列表"
	            }
	          }
	        },
	
	        add: {
	          url: "/api2/tasks",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            userType: [true, _.number],
	            name: [true, _.string],
	            type: [true, _.number],
	            priority: [true, _.number],
	            oid: [false, _.string],
	            uid: [false, _.string],
	            objectId: [false, _.string],
	            objectName: [false, _.string],
	            username: [false, _.string],
	            cycle: [false, _.array],
	            state: [false, _.number],
	            progress: [false, _.number],
	            siteId: [false, _.string],
	            siteName: [false, _.string],
	            create: [false, _.number],
	            startTime: [false, _.number],
	            updateTime: [false, _.number],
	            desc: [false, [_.string, _.number]],
	            error: [false, _.string],
	            data: [false, _["object"]]
	          },
	          _desc: {
	            zh: {
	              name: "新增任务"
	            }
	          }
	        },
	
	        update: {
	          url: "/api2/tasks",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: false,
	            userType: [false, _.number],
	            name: [false, _.string],
	            type: [false, _.number],
	            priority: [false, _.number],
	            oid: [false, _.string],
	            uid: [false, _.string],
	            objectId: [false, _.string],
	            objectName: [false, _.string],
	            username: [false, _.string],
	            cycle: [false, _.array],
	            state: [false, _.number],
	            progress: [false, _.number],
	            siteId: [false, _.string],
	            siteName: [false, _.string],
	            create: [false, _.number],
	            startTime: [false, _.number],
	            updateTime: [false, _.number],
	            desc: [false, [_.string, _.number]],
	            error: [false, _.string],
	            data: [false, _["object"]]
	          },
	          _desc: {
	            zh: {
	              name: "更新任务"
	            }
	          }
	        },
	
	        change_state: {
	          url: "/api2/tasks",
	          type: _.put,
	          part: [true, _.string],
	          suffix: "/status",
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            status: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "改变任务状态"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api2/tasks",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除任务"
	            }
	          }
	        },
	
	        delete_tasks: {
	          url: "/api2/tasks",
	          type: _["delete"],
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            Object_id: [true, _.string],//属性名未确认
	            types: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询任务"
	            }
	          }
	        }
	
	      },
	
	      oauth: {
	
	        _name: {
	          zh: "认证",
	          en: ""
	        },
	
	        get_token: {
	          url: "/oauth2/access_token",
	          type: _.post,
	          data: {
	            _required: true,
	            client_secret: [true, _.string]
	          },
	          param: {
	            _required: true,
	            client_id: [true, _.string],
	            client_secret: [true, _.string],
	            grant_type: [true, _.string],
	            username: [true, _.string],
	            password: [true, _.string],
	            language: [true, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "获取令牌"
	            }
	          }
	        },
	
	        refresh_token: {
	          url: "/oauth2/access_token",
	          type: _.post,
	          data: {
	            _required: true,
	            client_id: [true, _.string],
	            client_secret: [true, _.string],
	            grant_type: [true, _.string],
	            refresh_token: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "刷新令牌"
	            }
	          }
	        },
	
	        get_token_info: {
	          url: "/oauth2/get_token_info",
	          type: _.get,
	          _desc: {
	            zh: {
	              name: "获取令牌信息"
	            }
	          }
	        }
	
	      },
	
	      captchas: {
	
	        _name: {
	          zh: "验证码",
	          en: ""
	        },
	
	        get: {
	          url: "/api/captchas",
	          type: _.get,
	          _desc: {
	            zh: {
	              name: "获取验证码"
	            }
	          }
	        },
	
	        img: {
	          url: "/api/captchas",
	          type: _.get,
	          part: [true, _.string],
	          _desc: {
	            zh: {
	              name: "获取验证码图片地址"
	            }
	          }
	        },
	
	        check: {
	          url: "/api/captchas",
	          type: _.post,
	          data: {
	            _required: true,
	            pictureId: [true, _.string],
	            code: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "验证验证码"
	            }
	          }
	        }
	
	      },
	
	      app: {
	
	        _name: {
	          zh: "应用",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api/apps",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询应用"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/apps",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            types: [false, _.array],
	            classes: [false, _.array],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "获取应用列表"
	            }
	          }
	        },
	
	        add: {
	          url: "/api/apps",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          data: {
	            _required: true,
	            type: [true, _.string],
	            "class": [true, _.string],
	            file: [true, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "新增应用"
	            }
	          }
	        },
	
	        update: {
	          url: "/api/apps",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "更新应用"
	            }
	          }
	        }
	
	      },
	
	      alarm: {
	
	        _name: {
	          zh: "告警",
	          en: ""
	        },
	
	        query: {
	          url: "/api/alarms",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            site_name: [false, _.string],
	            sourc_name: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            types: [false, _.array],
	            levels: [false, _.array],
	            states: [false, _.array],
	            start_time: [false, _.number],
	            end_time: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询告警"
	            }
	          }
	        },
	
	        confirm: {
	          url: "/api/alarms",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "确认告警"
	            }
	          }
	        },
	
	        cancel: {
	          url: "/api/alarms",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "取消告警"
	            }
	          }
	        },
	
	        query_state: {
	          url: "/api/alarm_stat",
	          type: _.get,
	          param: {
	            _required: true,
	            types: [false, _.array],
	            levels: [false, _.array],
	            states: [false, _.array],
	            start_time: [true, _.number],
	            end_time: [true, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询告警状态"
	            }
	          }
	        },
	
	        query_trend: {
	          url: "/api/alarm_trend",
	          type: _.get,
	          param: {
	            _required: true,
	            types: [false, _.array],
	            levels: [false, _.array],
	            states: [false, _.array],
	            start_time: [true, _.number],
	            end_time: [true, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询告警曲线"
	            }
	          }
	        },
	
	        query_count: {
	          url: "/api/alarm_count",
	          type: _.post,
	          param: {
	            _required: false,
	            types: [false, _.array],
	            levels: [false, _.array],
	            states: [false, _.array],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询告警统计"
	            }
	          }
	        }
	
	      },
	
	      reports: {
	
	        _name: {
	          zh: "报表",
	          en: ""
	        },
	
	        get_forms: {
	          url: "/api/reports/forms",
	          type: _.get,
	          param: {
	            _required: false,
	            oid: [false, _.string],
	            report_name: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "获取报表"
	            }
	          }
	        }
	
	      },
	
	      favor: {
	
	        _name: {
	          zh: "收藏",
	          en: ""
	        },
	
	        batch_add: {
	          url: "/api/favorites",
	          type: _.post,
	          data: {
	            _required: true,
	            resourceId: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "批量添加收藏"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api/favorites",
	          type: _["delete"],
	          part: [true, _.string],
	          _desc: {
	            zh: {
	              name: "删除收藏"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api/favorites",
	          type: _.get,
	          param: {
	            _required: false,
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "批量查询收藏"
	            }
	          }
	        },
	
	        check: {
	          url: "/api/favorites/mine",
	          type: _.post,
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true,
	            ids: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "查询收藏状态"
	            }
	          }
	        }
	
	      },
	
	      log: {
	
	        _name: {
	          zh: "日志",
	          en: ""
	        },
	
	        query_behav: {
	          url: "/api2/behav_log",
	          type: _.get,
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            level: [false, _.array],
	            language: [true, _.number],
	            start_time: [false, _.number],
	            end_time: [false, _.number],
	            username: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询操作日志"
	            }
	          }
	        },
	
	        query_comm: {
	          url: "/api2/comm_log",
	          type: _.get,
	          param: {
	            _required: true,
	            oid: [false, _.string],
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            level: [false, _.array],
	            language: [true, _.number],
	            start_time: [false, _.number],
	            end_time: [false, _.number],
	            username: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询通信日志"
	            }
	          }
	        }
	
	      },
	
	      realtime: {
	
	        _name: {
	          zh: "实时数据",
	          en: ""
	        },
	
	        query_devices: {
	          url: "/api/devices",
	          type: _.get,
	          part: [true, _.string],
	          suffix: "/rt_data",
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            filter: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询设备实时数据"
	            }
	          }
	        },
	
	        query_machines: {
	          url: "/api/machines",
	          type: _.get,
	          part: [true, _.string],
	          suffix: "/rt_data",
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            filter: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询机器实时数据"
	            }
	          }
	        },
	
	        query_sites: {
	          url: "/api/sites",
	          type: _.get,
	          part: [true, _.string],
	          suffix: "/rt_data",
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            filter: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询现场实时数据"
	            }
	          }
	        }
	
	      },
	
	      group: {
	
	        _name: {
	          zh: "权限分组",
	          en: ""
	        },
	
	        query_one: {
	          url: "/api2/groups",
	          type: _.get,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询分组"
	            }
	          }
	        },
	
	        query_list: {
	          url: "/api2/groups",
	          type: _.get,
	          param: {
	            _required: false,
	            cursor: [false, _.number],
	            limit: [false, _.number],
	            name: [false, _.string],
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            uid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "查询分组列表"
	            }
	          }
	        },
	
	        add: {
	          url: "/api2/groups",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "新增分组"
	            }
	          }
	        },
	
	        update: {
	          url: "/api2/groups",
	          type: _.put,
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          data: {
	            _required: true
	          },
	          _desc: {
	            zh: {
	              name: "更新分组"
	            }
	          }
	        },
	
	        "delete": {
	          url: "/api2/groups",
	          type: _["delete"],
	          part: [true, _.string],
	          param: {
	            _required: false,
	            oid: [false, _.string]
	          },
	          _desc: {
	            zh: {
	              name: "删除分组"
	            }
	          }
	        },
	
	        query_group_resources: {
	          url: "/api2/groups",
	          type: _.get,
	          part: [true, _.string],
	          suffix: "/resources",
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            type: [true, _.number],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询分组下的资源"
	            }
	          }
	        },
	
	        query_nogroup_resources: {
	          url: "/api2/groups/none/resources",
	          type: _.get,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            type: [true, _.number],
	            cursor: [false, _.number],
	            limit: [false, _.number]
	          },
	          _desc: {
	            zh: {
	              name: "查询没有分组的资源"
	            }
	          }
	        },
	
	        assign_group_resources: {
	          url: "/api2/groups",
	          part: [true, _.string],
	          suffix: "/resources",
	          type: _.post,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            type: [true, _.number]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "给分组添加资源"
	            }
	          }
	        },
	
	        cancel_group_resources: {
	          url: "/api2/groups",
	          part: [true, _.string],
	          suffix: "/resources",
	          type: _.put,
	          param: {
	            _required: false,
	            verbose: [false, _.number],
	            oid: [false, _.string],
	            type: [true, _.number]
	          },
	          data: {
	            _required: true,
	            resourceIds: [true, _.array]
	          },
	          _desc: {
	            zh: {
	              name: "删除分组下的资源"
	            }
	          }
	        }
	
	      }
	
	    };
	
	  }
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Copyright (c) 2007-2014, InHand Networks All Rights Reserved.
	 * @author PANJC
	 * @filename model.custom
	 * @filetype {object}
	 * @filedescription "用户对model的自定义扩展"
	 */
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	  __webpack_require__(15),
	  __webpack_require__(1),
	  __webpack_require__(6),
	  __webpack_require__(11),
	  __webpack_require__(9),
	  __webpack_require__(14),
	  __webpack_require__(17)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (_structure,
	             _jquery,
	             _prototye,
	             dialog,
	             _config,
	             model,
	             dataStructure) {
	
	  var root = window;
	
	  Model = root.Model = (root.Model || {});
	
	  var _ = Model._;
	
	  var structure = Model.structure;
	
	  var config = CONFIG;
	
	  var method = {
	
	    checkData: function (data, info) {
	
	      if (data.data && !$.isPlainObject(data.data)) {
	        this.throwError({
	          url: info,
	          info: "Param must be the Object"
	        });
	        return false;
	      }
	
	      if (data.success && !Object.isFunction(data.success)) {
	        this.throwError({
	          url: info,
	          info: "Param success must be the Function"
	        });
	        return false;
	      }
	
	      if (data.error && !Object.isFunction(data.error)) {
	        this.throwError({
	          url: info,
	          info: "Param error must be the Function"
	        });
	        return false;
	      }
	
	    },
	
	    request: function (data, appType, _request) {
	
	      if (this.checkData(data, appType) === false) {
	        return;
	      }
	      _request();
	
	    },
	
	    func: function (callback) {
	      return callback ? callback : function () {
	      };
	    },
	
	    throwError: function (obj) {
	      console.log(obj.url + "\n" + obj.info);
	    }
	
	  };
	
	  var Extend = {};
	
	  var userExtend = {
	
	    login: function (data) {
	      var _data = data.data;
	      var _param = data.param;
	
	      function setToken(data) {
	        Model._method.setAccessToken(data.access_token);
	        Model._method.setRefreshToken(data.refresh_token);
	      }
	
	      function jump() {
	        location.replace(config["url"]["login"]["success"]);
	      }
	
	      var _success = data.success ? function (returnData) {
	        setToken(returnData);
	        data.success(returnData);
	        jump()
	      } : function (returnData) {
	        setToken(returnData);
	        jump()
	      };
	//				var _error = data.error ? data.error : function(){};
	      method.request(data, "login", function () {
	        var password = _data.password;
	        if (_data.password_type == 3) {
	          password = cloud.util.md5(cloud.util.md5(_data.password) + _data.pictureId);
	        }
	        Model.oauth({
	          method: "get_token",
	          data: {
	            client_secret: config["oauth"]["client_secret"]
	          },
	          param: {
	            client_id: config["oauth"]["client_id"],
	            client_secret: config["oauth"]["client_secret"],
	            grant_type: config["oauth"]["grant_type"]["password"],
	            username: _data.username,
	            password: password,
	            varificationCode: _data.code,
	            picId: _data.pictureId,
	            password_type: _data.password_type,
	            language: _param.language
	          },
	          contentType: "application/x-www-form-urlencoded",
	          token: false,
	          success: _success,
	          error: method.func(data.error)
	        });
	
	      })
	    },
	
	    logout: function (data) {
	      var data = data ? data : {};
	      method.request(data, "logout", function () {
	        var obj = {};
	        obj.method = "_logout";
	        obj.success = function (data) {
	          if (Object.isFunction(data.success)) {
	            data.success();
	          }
	          Model._method.logout();
	        };
	        obj.error = function (data) {
	          if (Object.isFunction(data.error)) {
	            data.error();
	          }
	          Model._method.logout();
	        };
	        Model.user(obj);
	      });
	    }
	
	  }
	
	  var tagExtend = {
	
	    query_type: function (data) {
	      method.request(data, "query_type", function () {
	        if (data.resourceType) {
	          switch (data.resourceType) {
	            case 2 :
	              data.method = "query_user";
	              break;
	            case 3 :
	              data.method = "query_role";
	              break;
	            case 5 :
	              data.method = "query_device";
	              break;
	            case 6 :
	              data.method = "query_model";
	              break;
	            case 14 :
	              data.method = "query_site";
	              break;
	            case 16 :
	              data.method = "query_customer";
	              break;
	            case 17 :
	              data.method = "query_document";
	              break;
	          }
	          delete data.resourceType;
	          Model.tag(data);
	        }
	      });
	    }
	
	  }
	
	  var roleExtend = {
	
	    query_current: function (data) {
	      method.request(data, "query_current", function () {
	        Model.user({
	          method: "query_current", param: {verbose: 10}, success: function (returnData) {
	            var roleId = returnData["result"]["roleId"];
	            Model.role({
	              method: "query_list",
	              param: {verbose: 100},
	              part: roleId,
	              success: method.func(data.success),
	              error: method.func(data.error)
	            })
	          }
	        });
	      });
	    }
	
	  }
	
	  var orgExtend = {
	
	    query_with_stat: function (data) {
	
	//            var suc = data.success;
	//            var err = data.error;
	//            var id = data.part;
	//            data.method = "query_one";
	//            data.success = function(orgInfo){
	//                Model.organ({
	//                    method : "query_stat",
	//                    data : {
	//                        resourceIds : [id]
	//                    },
	//                    success : function(countInfo){
	//                        if (countInfo["result"][0]){
	//                            var orgDetail = $.extend(orgInfo["result"], countInfo["result"][0]);
	//                            suc.call(this, orgDetail);
	//                        }
	//                    },
	//                    err : err
	//                })
	//            }
	//            Model.organ(data);
	
	      method.request(data, "query_detail", function () {
	        Model.organ({
	          method: "query_one",
	          part: data.part,
	          param: data.param,
	          success: function (orgInfo) {
	            Model.organ({
	              method: "query_stat",
	              param: data.param,
	              data: {
	                resourceIds: [data.part],
	              },
	              success: function (countInfo) {
	                if (countInfo["result"][0]) {
	                  var orgDetail = $.extend(orgInfo["result"], countInfo["result"][0]);
	                  data.success(orgDetail);
	                }
	              },
	              error: data.error
	            });
	          }
	        });
	      });
	
	    }
	
	  }
	
	  for (var attr in dataStructure) {
	    if (structure[attr] !== undefined) {
	      $.extend(structure[attr], dataStructure[attr]);
	    }
	  }
	
	  $.extend(Model, Extend);
	  $.extend(Model.user, userExtend);
	  $.extend(Model.tag, tagExtend);
	  $.extend(Model.role, roleExtend);
	  $.extend(Model.organ, orgExtend);
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(14)], __WEBPACK_AMD_DEFINE_RESULT__ = function (__) {
	
	  var root = window;
	
	  Model = root.Model = (root.Model || {});
	
	  var _ = Model._;
	
	  var customStructure = {
	
	    user: {
	
	      login: {
	        param: {
	          _required: true,
	          language: [true, _.number]
	        },
	        data: {
	          _required: true,
	          username: [true, _.string],
	          password: [true, _.string]
	        },
	        _desc: {
	          zh: {
	            name: "用户登录"
	          }
	        },
	        _custom: true
	      },
	
	      logout: {
	        _desc: {
	          zh: {
	            name: "用户退出"
	          }
	        },
	        _custom: true
	      }
	
	    },
	
	//			tag:{
	//				
	//				query_type:{
	//					param:{
	//						_required:false,
	//						verbose:[false,_.number]
	//					},
	//					resourceType:[true,_.string],
	//					_desc:{
	//						zh:{
	//							name:"查询标签类型的标签"
	//						}
	//					},
	//					_custom:true
	//				}
	//				
	//			},
	
	    role: {
	
	      query_current: {
	        _desc: {
	          zh: {
	            name: "查询当前角色"
	          }
	        },
	        _custom: true
	      }
	
	    },
	
	    organ: {
	
	      query_with_stat: {
	        part: [true, _.string],
	        param: {
	          _required: false,
	          verbose: [false, _.number]
	        }, _desc: {
	          zh: {
	            name: "查询机构详细信息"
	          }
	        },
	        _custom: true
	      }
	
	    }
	
	  }
	
	  return customStructure;
	
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {/**
	 * Copyright (c) 2007-2014, InHand Networks All Rights Reserved.
	 * Example locale.render(),locale.render({pos:"www"}),locale.render({element:"#id",pos:"www"}),locale.get({lang:"login"})
	 * @author PanJC
	 * @filename locale
	 * @filetype {object}
	 * @filedescription "语言国际化对象"
	 * @filereturn {object} locale "本地化对象，主要是语言"
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  __webpack_require__(1);
	  __webpack_require__(9);
	  __webpack_require__(19);
	
	  config = CONFIG;
	  packages = config["locale"]["packages"];
	  languages = config["locale"]["languages"];
	
	  //Initialize the locale object
	  window.locale = {
	
	    browserLang: "",
	    userLang: "",
	    localLang: "",
	    storageLang: "",
	    langArr: languages,
	    langPacks: {},
	    packUrl: "",
	    element: "*",
	    pos: packages["default"],
	    lang: "",
	
	    /**
	     * Set the locale attribute browser language
	     * @author PANJC
	     * @name _setBrowserLang
	     * @type {method}
	     * @description "设置浏览器的language属性"
	     * @private
	     * @return
	     */
	    _setBrowserLang: function () {
	      var browser = navigator.language || navigator.browserLanguage;
	      var browserLang = browser.toLowerCase().substring(0, 2);
	      var langArr = this.langArr;
	      var arrCurrent;
	      for (var num = 0; num < langArr.length; num++) {
	        arrCurrent = langArr[num].toLowerCase().substring(0, 2);
	        if (browserLang == arrCurrent) {
	          this.browserLang = langArr[num];
	          return;
	        }
	      }
	    },
	
	    /**
	     * Set the locale attribute user language
	     * @author PANJC
	     * @name _setUserLang
	     * @type {method}
	     * @description "设置用户的language属性"
	     * @param {String} opt
	     * @private
	     * @return
	     */
	    _setUserLang: function (opt) {
	      var langArr = this.langArr;
	      for (var num = 0; num < langArr.length; num++) {
	        if (langArr[num].toLowerCase().indexOf(opt.toLowerCase()) > -1) {
	          this.userLang = langArr[num];
	          return;
	        }
	      }
	    },
	
	    /**
	     * Set the locale attribute storageLang
	     * @author PANJC
	     * @name _setStorageLang
	     * @type {method}
	     * @description "设置storageLang属性"
	     * @param {String} opt
	     * @private
	     * @return {String}
	     */
	    _setStorageLang: function (opt) {
	      this.storageLang = opt;
	    },
	
	    /**
	     * Set the locale attribute localLang
	     * @author PANJC
	     * @name _setLocalLang
	     * @type {method}
	     * @description "设置localLang属性"
	     * @private
	     * @return
	     */
	    _setLocalLang: function () {
	      if (this.storageLang && this.userLang) {
	        this.localLang = this.userLang;
	      } else if (this.storageLang && !this.userLang) {
	        this.localLang = this.storageLang;
	      } else if (!this.storageLang && this.userLang) {
	        this.localLang = this.userLang;
	      } else {
	        this.localLang = this.browserLang;
	      }
	      this._setStorage(this.localLang);
	    },
	
	    /**
	     * Set local lang
	     * @author PANJC
	     * @name _setLang
	     * @type {method}
	     * @description "设置lang属性"
	     * @private
	     * @return
	     */
	    _setLang: function () {
	      if (!this.browserLang) {
	        this._setBrowserLang();
	      }
	      if (!this.storageLang) {
	        this._setStorageLang(localStorage.getItem("language"));
	      }
	      if (this.lang) {
	        this._setUserLang(this.lang);
	      }
	      this._setLocalLang();
	    },
	
	    /**
	     * Set browser local storage attribute language
	     * @author PANJC
	     * @name _setStorage
	     * @type {method}
	     * @description "设置localStorage的属性language"
	     * @param {String} opt
	     * @private
	     * @return
	     */
	    _setStorage: function (lang) {
	      this._setStorageLang(lang);
	      localStorage.setItem("language", lang);
	    },
	
	    /**
	     * Return local storage attribute language
	     * @author PANJC
	     * @name _getStorageLang
	     * @type {method}
	     * @description "获取localStorage中的language"
	     * @private
	     * @return {String}
	     */
	    _getStorageLang: function () {
	      return localStorage.getItem("language");
	    },
	
	    /**
	     * Load language pack
	     * @author PANJC
	     * @name _loadPack
	     * @type {method}
	     * @description "加载语言包"
	     * @param {Function} callback
	     * @private
	     * @return
	     */
	    _loadPack: function (callback) {
	      var self = this;
	      var url = __webpack_require__(20)("./" + this.storageLang + "/lang.js");
	      $.ajax({
	        url: url,
	        dataType: "script",
	        async: false,
	        success: function () {
	          self._cacheLangPacks();
	          if (callback) {
	            if ($.isArray(callback)) {
	              for (var num = 0; num < callback.length; num++) {
	                callback[num]();
	              }
	            } else {
	              callback();
	            }
	          }
	        }
	      });
	    },
	
	    /**
	     * To determine whether a language pack has been in existence
	     * @author PANJC
	     * @name _hasPacks
	     * @type {method}
	     * @description "判断语言包是否已经存在"
	     * @private
	     * @return {Boolean}
	     */
	    _hasPacks: function () {
	      var langPacks = this.langPacks;
	      for (var attr in langPacks) {
	        if (attr == this.storageLang) {
	          for (var _attr in langPacks[attr]) {
	            if (_attr == this.pos) {
	              return true;
	            }
	          }
	        }
	      }
	    },
	
	    /**
	     * Store language pack
	     * @author PANJC
	     * @name _cacheLangPacks
	     * @type {method}
	     * @description "存储语言包"
	     * @private
	     * @return
	     */
	    _cacheLangPacks: function () {
	      var langName, langObj;
	      var pos = this.pos;
	      var langPacks = this.langPacks;
	      for (var attr in lang) {
	        langName = attr;
	        langObj = lang[attr];
	      }
	      if (langPacks[langName]) {
	        langPacks[langName][pos] = langObj;
	      } else {
	        langPacks[langName] = {};
	        langPacks[langName][pos] = langObj;
	      }
	      this.langPacks = langPacks;
	    },
	
	    /**
	     * Get language pack url
	     * @author PANJC
	     * @name _getPackUrl
	     * @type {method}
	     * @description "获取语言包的url"
	     * @private
	     * @return
	     */
	    _getPackUrl: function () {
	      if (this.pos) {
	        packUrl = packages[this.pos];
	        if (packUrl) {
	          this.packUrl = packUrl;
	        } else {
	          this.pos = packages["default"];
	          this.packUrl = packages[this.pos];
	        }
	      } else {
	        this.pos = packages["default"];
	        this.packUrl = packages[this.pos];
	      }
	    },
	
	    /**
	     * Store language pack
	     * @author PANJC
	     * @name _languageIsCorrect
	     * @tyep {method}
	     * @description "存储语言包"
	     * @private
	     * @return {Boolean}
	     */
	    _languageIsCorrect: function () {
	      if (!this.storageLang || !this._getStorageLang()) {
	        return false;
	      } else {
	        if (this.lang && this.lang != this.storageLang) {
	          return false;
	        } else {
	          return true;
	        }
	      }
	    },
	
	    /*
	     * Locale string
	     * @author PANJC
	     * @param {Object/String} opt {Array} variableArr
	     * @private
	     * @return {String}
	     */
	    _get: function (opt, variableArr) {
	      var self = this;
	      var obj = {};
	      if (opt && $.isPlainObject(opt)) {
	        obj.str = opt.lang;
	        this.pos = opt.pos ? opt.pos : "base";
	      } else {
	        obj.str = opt;
	        this.pos = "base";
	      }
	      if (!this._languageIsCorrect()) {
	        this._setLang();
	      }
	      if (this._hasPacks()) {
	        self.str = variableArr ? this._result(obj, variableArr) : this._result(obj);
	      } else {
	        this._getPackUrl();
	        variableArr ? this._loadPack(function () {
	          self.str = self._result(obj, variableArr);
	        }) : this._loadPack(function () {
	          self.str = self._result(obj);
	        });
	      }
	      return self.str;
	    },
	
	    /**
	     * Locale string
	     * @author PANJC
	     * @name get
	     * @type {method}
	     * @description "获取locale的属性值"
	     * @param {Object/String} opt
	     * @param {Array} variableArr
	     * @return {String}
	     */
	    get: function (opt, variableArr) {
	      return this._get(opt, variableArr);
	    },
	
	    /**
	     * Locale page
	     * @author PANJC
	     * @name _render
	     * @type {method}
	     * @description "本地化分页信息"
	     * @param {Object} opt "配置信息"
	     * @private
	     * @return
	     */
	    _render: function (opt) {
	      var self = this;
	      if (opt.method == "render") {
	        this.pos = opt.pos ? opt.pos : "base";
	        this.element = opt.element ? opt.element : "*";
	      } else if (opt.method == "set") {
	        this.lang = opt.lang ? opt.lang : "zh_CN";
	        this.pos = opt.pos ? opt.pos : "base";
	        this.element = "*";
	      }
	      if (!this._languageIsCorrect()) {
	        this._setLang();
	      }
	      if (this._hasPacks()) {
	        this._each(self.element);
	      } else {
	        this._getPackUrl();
	        this._loadPack(function () {
	          self._each(self.element);
	        });
	      }
	      ;
	    },
	
	    /**
	     * Locale page
	     * @author PANJC
	     * @name render
	     * @type {method}
	     * @description "本地化分页信息"
	     * @param {Object} opt "配置信息"
	     * @return
	     */
	    render: function (opt) {
	      if (opt && $.isPlainObject(opt)) {
	        opt.method = "render";
	        this._render(opt);
	      } else {
	        this._render({method: "render"});
	      }
	    },
	
	    /**
	     * Set user language
	     * @author PANJC
	     * @name set
	     * @type {method}
	     * @description "设置用户语言"
	     * @param {Object} opt "配置信息"
	     * @return
	     */
	    set: function (opt) {
	      if (opt && $.isPlainObject(opt)) {
	        opt.method = "set";
	        this._render(opt);
	      }
	    },
	
	    /**
	     * Traverse elements and internationalization
	     * @author PANJC
	     * @name _each
	     * @type {method}
	     * @description "遍历元素国际化"
	     * @private
	     * @return
	     */
	    _each: function () {
	      var self = this;
	      var element = this.element;
	      var storageLang = self.storageLang;
	      var langPacks = self.langPacks;
	      var $dom;
	      if (typeof this.element == "string") {
	        $dom = $(element);
	      } else {
	        $dom = element;
	      }
	      $dom.find("[lang]").each(function () {
	        var $this = $(this);
	        var langContent = $this.attr("lang").toLowerCase();
	        var semiIndex = langContent.indexOf(";");
	        var lbracketIndex = langContent.indexOf("{");
	        var strlen = langContent.length;
	        var colonIndex, attrId, attrValue, dicKey;
	        if (lbracketIndex > -1) {
	          var rbracketIndex = langContent.indexOf("}");
	          if (semiIndex > -1) {
	            langContent = langContent.substring(lbracketIndex + 1, semiIndex);
	          } else {
	            langContent = langContent.substring(lbracketIndex + 1, rbracketIndex);
	          }
	          attrArr = langContent.split(",");
	          for (var num = 0, arrLen = attrArr.length; num < arrLen; num++) {
	            attr = attrArr[num];
	            colonIndex = attr.indexOf(":");
	            attrId = attr.substring(0, colonIndex);
	            attrValue = attr.substring(colonIndex + 1);
	            result = self._result({str: attrValue});
	            self._return({$this: $this, attrId: attrId, str: result});
	          }
	        } else if (langContent) {
	          colonIndex = langContent.indexOf(":");
	          if (semiIndex > -1) {
	            attrId = langContent.substring(0, colonIndex);
	            attrValue = langContent.substring(colonIndex + 1, strlen - 1);
	          } else {
	            attrId = langContent.substring(0, colonIndex);
	            attrValue = langContent.substring(colonIndex + 1);
	          }
	          result = self._result({str: attrValue});
	          self._return({$this: $this, attrId: attrId, str: result});
	        }
	      });
	    },
	
	    /**
	     * Get the result of each
	     * @author PANJC
	     * @name _result
	     * @type {method}
	     * @description "获取遍历的结果"
	     * @param {Object} obj
	     * @param {Array} variableArr
	     * @private
	     * @return {String}
	     */
	    _result: function (obj, variableArr) {
	      var pos = this.pos;
	      var langPacks = this.langPacks;
	      var storageLang = this.storageLang;
	      var attrValue = obj.str.toString();
	      var str = "";
	      if (attrValue.indexOf("+") > -1) {
	        var arr = [];
	        var current;
	        arr = attrValue.split("+");
	        for (var num = 0; num < arr.length; num++) {
	          current = arr[num];
	          if (storageLang == "en") {
	            if (current.match(/\W/)) {
	              str += current + " ";
	            } else {
	              str += langPacks[storageLang][pos][current] + " ";
	            }
	          } else {
	            if (current.match(/\W/)) {
	              str += current;
	            } else {
	              str += langPacks[storageLang][pos][current];
	            }
	          }
	        }
	        str = str.replace(/\s$/g, "");
	      } else {
	        str = langPacks[storageLang][pos][attrValue];
	      }
	      if (variableArr && str) {
	        for (var num = 0; num < variableArr.length; num++) {
	          if (str.indexOf("{" + num + "}") > -1) {
	            str = str.replace("{" + num + "}", variableArr[num]);
	          }
	        }
	        ;
	      }
	      return str;
	    },
	
	    /**
	     * According to the method returns the result
	     * @author PANJC
	     * @name _return
	     * @type {method}
	     * @description "根据方法返回结果"
	     * @param {Object} obj
	     * @private
	     * @return
	     */
	    _return: function (obj) {
	      var $this = obj.$this;
	      var attrId = obj.attrId;
	      var str = obj.str;
	      switch (attrId) {
	        case "text":
	          $this.text(str);
	          break;
	        case "value":
	          $this.val(str);
	          break;
	        case "title":
	          $this.attr("title", str);
	          break;
	        case "alt":
	          $this.attr("alt", str);
	          break;
	        case "placeholder":
	          $this.attr(attrId, str);
	          $this.placeholder();
	          break;
	        case '':
	          $this.text(str);
	          break;
	        default:
	          $this.attr(attrId, str);
	          break;
	      }
	    },
	
	    /**
	     * Return language number,if en return 1,if zh_CN return 2
	     * @author PANJC
	     * @name current
	     * @type {method}
	     * @description "返回language的编号"
	     * @return {Number} "英文对应1;中文对应2"
	     */
	    current: function () {
	      var lang = this._getStorageLang();
	      switch (lang) {
	        case "en":
	          return 1;
	          break;
	        case "zh_CN":
	          return 2;
	          break;
	      }
	    }
	
	  };
	
	  return locale;
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery Placeholder Plugin v2.3.1
	 * https://github.com/mathiasbynens/jquery-placeholder
	 *
	 * Copyright 2011, 2015 Mathias Bynens
	 * Released under the MIT license
	 */
	(function(factory) {
	    if (true) {
	        // AMD
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === 'object' && module.exports) {
	        factory(require('jquery'));
	    } else {
	        // Browser globals
	        factory(jQuery);
	    }
	}(function($) {
	
	    /****
	     * Allows plugin behavior simulation in modern browsers for easier debugging. 
	     * When setting to true, use attribute "placeholder-x" rather than the usual "placeholder" in your inputs/textareas 
	     * i.e. <input type="text" placeholder-x="my placeholder text" />
	     */
	    var debugMode = false; 
	
	    // Opera Mini v7 doesn't support placeholder although its DOM seems to indicate so
	    var isOperaMini = Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
	    var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini && !debugMode;
	    var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini && !debugMode;
	    var valHooks = $.valHooks;
	    var propHooks = $.propHooks;
	    var hooks;
	    var placeholder;
	    var settings = {};
	
	    if (isInputSupported && isTextareaSupported) {
	
	        placeholder = $.fn.placeholder = function() {
	            return this;
	        };
	
	        placeholder.input = true;
	        placeholder.textarea = true;
	
	    } else {
	
	        placeholder = $.fn.placeholder = function(options) {
	
	            var defaults = {customClass: 'placeholder'};
	            settings = $.extend({}, defaults, options);
	
	            return this.filter((isInputSupported ? 'textarea' : ':input') + '[' + (debugMode ? 'placeholder-x' : 'placeholder') + ']')
	                .not('.'+settings.customClass)
	                .not(':radio, :checkbox, [type=hidden]')
	                .bind({
	                    'focus.placeholder': clearPlaceholder,
	                    'blur.placeholder': setPlaceholder
	                })
	                .data('placeholder-enabled', true)
	                .trigger('blur.placeholder');
	        };
	
	        placeholder.input = isInputSupported;
	        placeholder.textarea = isTextareaSupported;
	
	        hooks = {
	            'get': function(element) {
	
	                var $element = $(element);
	                var $passwordInput = $element.data('placeholder-password');
	
	                if ($passwordInput) {
	                    return $passwordInput[0].value;
	                }
	
	                return $element.data('placeholder-enabled') && $element.hasClass(settings.customClass) ? '' : element.value;
	            },
	            'set': function(element, value) {
	
	                var $element = $(element);
	                var $replacement;
	                var $passwordInput;
	
	                if (value !== '') {
	
	                    $replacement = $element.data('placeholder-textinput');
	                    $passwordInput = $element.data('placeholder-password');
	
	                    if ($replacement) {
	                        clearPlaceholder.call($replacement[0], true, value) || (element.value = value);
	                        $replacement[0].value = value;
	
	                    } else if ($passwordInput) {
	                        clearPlaceholder.call(element, true, value) || ($passwordInput[0].value = value);
	                        element.value = value;
	                    }
	                }
	
	                if (!$element.data('placeholder-enabled')) {
	                    element.value = value;
	                    return $element;
	                }
	
	                if (value === '') {
	                    
	                    element.value = value;
	                    
	                    // Setting the placeholder causes problems if the element continues to have focus.
	                    if (element != safeActiveElement()) {
	                        // We can't use `triggerHandler` here because of dummy text/password inputs :(
	                        setPlaceholder.call(element);
	                    }
	
	                } else {
	                    
	                    if ($element.hasClass(settings.customClass)) {
	                        clearPlaceholder.call(element);
	                    }
	
	                    element.value = value;
	                }
	                // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
	                return $element;
	            }
	        };
	
	        if (!isInputSupported) {
	            valHooks.input = hooks;
	            propHooks.value = hooks;
	        }
	
	        if (!isTextareaSupported) {
	            valHooks.textarea = hooks;
	            propHooks.value = hooks;
	        }
	
	        $(function() {
	            // Look for forms
	            $(document).delegate('form', 'submit.placeholder', function() {
	                
	                // Clear the placeholder values so they don't get submitted
	                var $inputs = $('.'+settings.customClass, this).each(function() {
	                    clearPlaceholder.call(this, true, '');
	                });
	
	                setTimeout(function() {
	                    $inputs.each(setPlaceholder);
	                }, 10);
	            });
	        });
	
	        // Clear placeholder values upon page reload
	        $(window).bind('beforeunload.placeholder', function() {
	
	            var clearPlaceholders = true;
	
	            try {
	                // Prevent IE javascript:void(0) anchors from causing cleared values
	                if (document.activeElement.toString() === 'javascript:void(0)') {
	                    clearPlaceholders = false;
	                }
	            } catch (exception) { }
	
	            if (clearPlaceholders) {
	                $('.'+settings.customClass).each(function() {
	                    this.value = '';
	                });
	            }
	        });
	    }
	
	    function args(elem) {
	        // Return an object of element attributes
	        var newAttrs = {};
	        var rinlinejQuery = /^jQuery\d+$/;
	
	        $.each(elem.attributes, function(i, attr) {
	            if (attr.specified && !rinlinejQuery.test(attr.name)) {
	                newAttrs[attr.name] = attr.value;
	            }
	        });
	
	        return newAttrs;
	    }
	
	    function clearPlaceholder(event, value) {
	        
	        var input = this;
	        var $input = $(this);
	        
	        if (input.value === $input.attr((debugMode ? 'placeholder-x' : 'placeholder')) && $input.hasClass(settings.customClass)) {
	            
	            input.value = '';
	            $input.removeClass(settings.customClass);
	
	            if ($input.data('placeholder-password')) {
	
	                $input = $input.hide().nextAll('input[type="password"]:first').show().attr('id', $input.removeAttr('id').data('placeholder-id'));
	                
	                // If `clearPlaceholder` was called from `$.valHooks.input.set`
	                if (event === true) {
	                    $input[0].value = value;
	
	                    return value;
	                }
	
	                $input.focus();
	
	            } else {
	                input == safeActiveElement() && input.select();
	            }
	        }
	    }
	
	    function setPlaceholder(event) {
	        var $replacement;
	        var input = this;
	        var $input = $(this);
	        var id = input.id;
	
	        // If the placeholder is activated, triggering blur event (`$input.trigger('blur')`) should do nothing.
	        if (event && event.type === 'blur' && $input.hasClass(settings.customClass)) {
	            return;
	        }
	
	        if (input.value === '') {
	            if (input.type === 'password') {
	                if (!$input.data('placeholder-textinput')) {
	                    
	                    try {
	                        $replacement = $input.clone().prop({ 'type': 'text' });
	                    } catch(e) {
	                        $replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
	                    }
	
	                    $replacement
	                        .removeAttr('name')
	                        .data({
	                            'placeholder-enabled': true,
	                            'placeholder-password': $input,
	                            'placeholder-id': id
	                        })
	                        .bind('focus.placeholder', clearPlaceholder);
	
	                    $input
	                        .data({
	                            'placeholder-textinput': $replacement,
	                            'placeholder-id': id
	                        })
	                        .before($replacement);
	                }
	
	                input.value = '';
	                $input = $input.removeAttr('id').hide().prevAll('input[type="text"]:first').attr('id', $input.data('placeholder-id')).show();
	
	            } else {
	                
	                var $passwordInput = $input.data('placeholder-password');
	
	                if ($passwordInput) {
	                    $passwordInput[0].value = '';
	                    $input.attr('id', $input.data('placeholder-id')).show().nextAll('input[type="password"]:last').hide().removeAttr('id');
	                }
	            }
	
	            $input.addClass(settings.customClass);
	            $input[0].value = $input.attr((debugMode ? 'placeholder-x' : 'placeholder'));
	
	        } else {
	            $input.removeClass(settings.customClass);
	        }
	    }
	
	    function safeActiveElement() {
	        // Avoid IE9 `document.activeElement` of death
	        try {
	            return document.activeElement;
	        } catch (exception) {}
	    }
	}));


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./en/lang.js": 21,
		"./zh_CN/lang.js": 22
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 20;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "052b5996844903a19e1ff94e08e7a6cf.js";

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "342f633005b680ef087421a305fa7b97.js";

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2007-2014, InHand Networks All Rights Reserved.
	 * @author PANJC
	 * @filename console
	 * @filetype {object}
	 * @filedescription "设置浏览器的console对象"
	 * @filereturn
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	//	require("cloud/lib/jquery");
	//	require("cloud/lib/prototype.lang");
	//	require("cloud/base/_config");
	//	//if IE,rewrite console.log
	//	var root = window;
	//	var console = root.console;
	//	var debugMode = CONFIG["server"]["debugMode"];
	//	switch(debugMode){
	//		case true:
	//			root.console = console;
	//			if(Prototype.Browser.IE){
	//				if(!root.console){
	//					widnow.console = {};
	//					console.log = function(){
	//						if(arguments.length != 0){
	//							var arr = [];
	//							$.each(arguments,function(index,value){
	//								if($.isPlainObject(value)){
	//									value = Object.toJSON(value);
	//								}
	//								arr.push(value);
	//							});
	//							root.console.log(arr.join());
	//						}else{
	//							root.console.log("");
	//						}
	//					};
	//				}
	//				return console.log;
	//			}
	//			break;
	//		case false:
	//			root.console = {};
	//			root.console.log = function(){};
	//			root.console.debug = function(){};
	//			break;
	//		default:
	//			root.console = {};
	//			root.console.log = function(){};
	//			root.console.debug = function(){};
	//			break;
	//	}
	  if (!window.console) (function () {
	
	    var __console, Console;
	
	    Console = function () {
	      var check = setInterval(function () {
	        var f;
	        if (window.console && console.log && !console.__buffer) {
	          clearInterval(check);
	          f = (Function.prototype.bind) ? Function.prototype.bind.call(console.log, console) : console.log;
	          for (var i = 0; i < __console.__buffer.length; i++) f.apply(console, __console.__buffer[i]);
	        }
	      }, 1000);
	
	      function log() {
	        this.__buffer.push(arguments);
	      }
	
	      this.log = log;
	      this.error = log;
	      this.warn = log;
	      this.info = log;
	      this.__buffer = [];
	    };
	
	    __console = window.console = new Console();
	  })();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function($) {!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	
	  __webpack_require__(25);
	
	  var config = __webpack_require__(26);
	  var root = window;
	
	  var widget = root.widget = function (objectParam) {
	
	    var objectParam = objectParam || {};
	    var _type = objectParam.type;
	    var _name = objectParam.name;
	    var _opt = objectParam.opt || {};
	    _opt.events = _opt.events || {};
	
	    if (!_type || !_name) {
	      console.log("组件无法找到");
	      return;
	    }
	
	    switch (_type) {
	
	      case "button":
	
	        var thisCase;
	
	        if (!_opt.size) {
	          thisCase = config[_type][config[_type]["default"]][_name];
	        } else {
	          thisCase = config[_type][_opt.size][_name];
	        }
	
	        var thisAlt;
	
	        if (!_opt.lang && !_opt.title) {
	          thisAlt = locale.get(thisCase["lang"]);
	        }
	
	        if (_opt.lang) {
	          thisAlt = locale.get(lang);
	        }
	
	        if (_opt.title) {
	          thisAlt = title;
	        }
	
	        var iconClass = thisCase["iconClass"];
	
	        var boxClass = thisCase["boxClass"];
	
	        var $p = $("<p></p>").addClass(boxClass).attr({alt: thisAlt, title: thisAlt});
	
	        var $a = $("<a></a>");
	
	        if (typeof iconClass === "object") {
	          for (var i = 0, len = iconClass.length; i < len; i++) {
	            $a.addClass(iconClass[i]);
	          }
	        } else {
	          $a.addClass(iconClass);
	        }
	
	        $p.append($a);
	
	        if (_opt.suffixText) {
	          $span = $("<span></span>").addClass("widget-button-16x16-text").text(_opt.suffixText);
	          $p.append($span);
	        }
	
	        if (_opt.events.click) {
	          $p.click(function () {
	            _opt.events.click();
	          })
	        }
	
	        if (_opt.css) {
	          $p.css(_opt.css);
	        }
	
	        return $p;
	
	        break;
	
	      case "checkbox":
	
	        var thisCase = config[_type];
	
	        var thisAlt;
	
	        if (!_opt.lang && !_opt.title) {
	          thisAlt = locale.get(thisCase["lang"]);
	        }
	
	        if (_opt.lang) {
	          thisAlt = locale.get(lang);
	        }
	
	        if (_opt.title) {
	          thisAlt = title;
	        }
	
	        var iconClass = thisCase["iconClass"];
	
	        var $a = $("<a></a>").addClass(iconClass).attr({alt: thisAlt, title: thisAlt});
	
	        if (_opt.events.click) {
	          $a.click(function () {
	            _opt.events.click();
	          })
	        }
	
	        if (_opt.css) {
	          $a.css(_opt.css);
	        }
	
	        return $a;
	
	        break;
	
	      default:
	
	        return;
	    }
	  }
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 25 */
13,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  var config = {
	    button: {
	      "default": "16x16",
	      "16x16": {
	        curve: {
	          lang: "widget_button_curve",
	          iconClass: ["widget-button-16x16-icon-bg", "widget-button-16x16-icon-curve"],
	          boxClass: "widget-button-16x16"
	        },
	        download: {
	          lang: "widget_button_download",
	          iconClass: ["widget-button-16x16-icon-bg", "widget-button-16x16-icon-download"],
	          boxClass: "widget-button-16x16"
	        }
	      }
	    },
	    checkbox: {
	      lang: "widget_checkbox",
	      iconClass: "widget-checkbox"
	    }
	  }
	  return config;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))


/***/ }),
/* 27 */
13,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 */
	
	/*
	
	Basic Usage:
	============
	
	$('#el').spin() // Creates a default Spinner using the text color of #el.
	$('#el').spin({ ... }) // Creates a Spinner using the provided options.
	
	$('#el').spin(false) // Stops and removes the spinner.
	
	Using Presets:
	==============
	
	$('#el').spin('small') // Creates a 'small' Spinner using the text color of #el.
	$('#el').spin('large', '#fff') // Creates a 'large' white Spinner.
	
	Adding a custom preset:
	=======================
	
	$.fn.spin.presets.flower = {
	  lines:   9
	, length: 10
	, width:  20
	, radius:  0
	}
	
	$('#el').spin('flower', 'red')
	
	*/
	
	;(function(factory) {
	
	  if (true) {
	    // CommonJS
	    factory(__webpack_require__(1), __webpack_require__(29))
	  } else if (typeof define == 'function' && define.amd) {
	    // AMD, register as anonymous module
	    define(['jquery', 'spin'], factory)
	  } else {
	    // Browser globals
	    if (!window.Spinner) throw new Error('Spin.js not present')
	    factory(window.jQuery, window.Spinner)
	  }
	
	}(function($, Spinner) {
	
	  $.fn.spin = function(opts, color) {
	
	    return this.each(function() {
	      var $this = $(this)
	        , data = $this.data()
	
	      if (data.spinner) {
	        data.spinner.stop()
	        delete data.spinner
	      }
	      if (opts !== false) {
	        opts = $.extend(
	          { color: color || $this.css('color') }
	        , $.fn.spin.presets[opts] || opts
	        )
	        data.spinner = new Spinner(opts).spin(this)
	      }
	    })
	  }
	
	  $.fn.spin.presets = {
	    tiny:  { lines:  8, length: 2, width: 2, radius: 3 }
	  , small: { lines:  8, length: 4, width: 3, radius: 5 }
	  , large: { lines: 10, length: 8, width: 4, radius: 8 }
	  }
	
	}));


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 *
	 * Example:
	    var opts = {
	      lines: 12             // The number of lines to draw
	    , length: 7             // The length of each line
	    , width: 5              // The line thickness
	    , radius: 10            // The radius of the inner circle
	    , scale: 1.0            // Scales overall size of the spinner
	    , corners: 1            // Roundness (0..1)
	    , color: '#000'         // #rgb or #rrggbb
	    , opacity: 1/4          // Opacity of the lines
	    , rotate: 0             // Rotation offset
	    , direction: 1          // 1: clockwise, -1: counterclockwise
	    , speed: 1              // Rounds per second
	    , trail: 100            // Afterglow percentage
	    , fps: 20               // Frames per second when using setTimeout()
	    , zIndex: 2e9           // Use a high z-index by default
	    , className: 'spinner'  // CSS class to assign to the element
	    , top: '50%'            // center vertically
	    , left: '50%'           // center horizontally
	    , shadow: false         // Whether to render a shadow
	    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	    , position: 'absolute'  // Element positioning
	    }
	    var target = document.getElementById('foo')
	    var spinner = new Spinner(opts).spin(target)
	 */
	;(function (root, factory) {
	
	  /* CommonJS */
	  if (typeof module == 'object' && module.exports) module.exports = factory()
	
	  /* AMD module */
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	  /* Browser global */
	  else root.Spinner = factory()
	}(this, function () {
	  "use strict"
	
	  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
	    , animations = {} /* Animation rules keyed by their name */
	    , useCssAnimations /* Whether to use CSS animations or setTimeout */
	    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
	
	  /**
	   * Utility function to create elements. If no tag name is given,
	   * a DIV is created. Optionally properties can be passed.
	   */
	  function createEl (tag, prop) {
	    var el = document.createElement(tag || 'div')
	      , n
	
	    for (n in prop) el[n] = prop[n]
	    return el
	  }
	
	  /**
	   * Appends children and returns the parent.
	   */
	  function ins (parent /* child1, child2, ...*/) {
	    for (var i = 1, n = arguments.length; i < n; i++) {
	      parent.appendChild(arguments[i])
	    }
	
	    return parent
	  }
	
	  /**
	   * Creates an opacity keyframe animation rule and returns its name.
	   * Since most mobile Webkits have timing issues with animation-delay,
	   * we create separate rules for each line/segment.
	   */
	  function addAnimation (alpha, trail, i, lines) {
	    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
	      , start = 0.01 + i/lines * 100
	      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
	      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
	      , pre = prefix && '-' + prefix + '-' || ''
	
	    if (!animations[name]) {
	      sheet.insertRule(
	        '@' + pre + 'keyframes ' + name + '{' +
	        '0%{opacity:' + z + '}' +
	        start + '%{opacity:' + alpha + '}' +
	        (start+0.01) + '%{opacity:1}' +
	        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
	        '100%{opacity:' + z + '}' +
	        '}', sheet.cssRules.length)
	
	      animations[name] = 1
	    }
	
	    return name
	  }
	
	  /**
	   * Tries various vendor prefixes and returns the first supported property.
	   */
	  function vendor (el, prop) {
	    var s = el.style
	      , pp
	      , i
	
	    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
	    if (s[prop] !== undefined) return prop
	    for (i = 0; i < prefixes.length; i++) {
	      pp = prefixes[i]+prop
	      if (s[pp] !== undefined) return pp
	    }
	  }
	
	  /**
	   * Sets multiple style properties at once.
	   */
	  function css (el, prop) {
	    for (var n in prop) {
	      el.style[vendor(el, n) || n] = prop[n]
	    }
	
	    return el
	  }
	
	  /**
	   * Fills in default values.
	   */
	  function merge (obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i]
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n]
	      }
	    }
	    return obj
	  }
	
	  /**
	   * Returns the line color from the given string or array.
	   */
	  function getColor (color, idx) {
	    return typeof color == 'string' ? color : color[idx % color.length]
	  }
	
	  // Built-in defaults
	
	  var defaults = {
	    lines: 12             // The number of lines to draw
	  , length: 7             // The length of each line
	  , width: 5              // The line thickness
	  , radius: 10            // The radius of the inner circle
	  , scale: 1.0            // Scales overall size of the spinner
	  , corners: 1            // Roundness (0..1)
	  , color: '#000'         // #rgb or #rrggbb
	  , opacity: 1/4          // Opacity of the lines
	  , rotate: 0             // Rotation offset
	  , direction: 1          // 1: clockwise, -1: counterclockwise
	  , speed: 1              // Rounds per second
	  , trail: 100            // Afterglow percentage
	  , fps: 20               // Frames per second when using setTimeout()
	  , zIndex: 2e9           // Use a high z-index by default
	  , className: 'spinner'  // CSS class to assign to the element
	  , top: '50%'            // center vertically
	  , left: '50%'           // center horizontally
	  , shadow: false         // Whether to render a shadow
	  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	  , position: 'absolute'  // Element positioning
	  }
	
	  /** The constructor */
	  function Spinner (o) {
	    this.opts = merge(o || {}, Spinner.defaults, defaults)
	  }
	
	  // Global defaults that override the built-ins:
	  Spinner.defaults = {}
	
	  merge(Spinner.prototype, {
	    /**
	     * Adds the spinner to the given target element. If this instance is already
	     * spinning, it is automatically removed from its previous target b calling
	     * stop() internally.
	     */
	    spin: function (target) {
	      this.stop()
	
	      var self = this
	        , o = self.opts
	        , el = self.el = createEl(null, {className: o.className})
	
	      css(el, {
	        position: o.position
	      , width: 0
	      , zIndex: o.zIndex
	      , left: o.left
	      , top: o.top
	      })
	
	      if (target) {
	        target.insertBefore(el, target.firstChild || null)
	      }
	
	      el.setAttribute('role', 'progressbar')
	      self.lines(el, self.opts)
	
	      if (!useCssAnimations) {
	        // No CSS animation support, use setTimeout() instead
	        var i = 0
	          , start = (o.lines - 1) * (1 - o.direction) / 2
	          , alpha
	          , fps = o.fps
	          , f = fps / o.speed
	          , ostep = (1 - o.opacity) / (f * o.trail / 100)
	          , astep = f / o.lines
	
	        ;(function anim () {
	          i++
	          for (var j = 0; j < o.lines; j++) {
	            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
	
	            self.opacity(el, j * o.direction + start, alpha, o)
	          }
	          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
	        })()
	      }
	      return self
	    }
	
	    /**
	     * Stops and removes the Spinner.
	     */
	  , stop: function () {
	      var el = this.el
	      if (el) {
	        clearTimeout(this.timeout)
	        if (el.parentNode) el.parentNode.removeChild(el)
	        this.el = undefined
	      }
	      return this
	    }
	
	    /**
	     * Internal method that draws the individual lines. Will be overwritten
	     * in VML fallback mode below.
	     */
	  , lines: function (el, o) {
	      var i = 0
	        , start = (o.lines - 1) * (1 - o.direction) / 2
	        , seg
	
	      function fill (color, shadow) {
	        return css(createEl(), {
	          position: 'absolute'
	        , width: o.scale * (o.length + o.width) + 'px'
	        , height: o.scale * o.width + 'px'
	        , background: color
	        , boxShadow: shadow
	        , transformOrigin: 'left'
	        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
	        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
	        })
	      }
	
	      for (; i < o.lines; i++) {
	        seg = css(createEl(), {
	          position: 'absolute'
	        , top: 1 + ~(o.scale * o.width / 2) + 'px'
	        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
	        , opacity: o.opacity
	        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
	        })
	
	        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
	        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
	      }
	      return el
	    }
	
	    /**
	     * Internal method that adjusts the opacity of a single line.
	     * Will be overwritten in VML fallback mode below.
	     */
	  , opacity: function (el, i, val) {
	      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
	    }
	
	  })
	
	
	  function initVML () {
	
	    /* Utility function to create a VML tag */
	    function vml (tag, attr) {
	      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
	    }
	
	    // No CSS transforms but VML support, add a CSS rule for VML elements:
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
	
	    Spinner.prototype.lines = function (el, o) {
	      var r = o.scale * (o.length + o.width)
	        , s = o.scale * 2 * r
	
	      function grp () {
	        return css(
	          vml('group', {
	            coordsize: s + ' ' + s
	          , coordorigin: -r + ' ' + -r
	          })
	        , { width: s, height: s }
	        )
	      }
	
	      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
	        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
	        , i
	
	      function seg (i, dx, filter) {
	        ins(
	          g
	        , ins(
	            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
	          , ins(
	              css(
	                vml('roundrect', {arcsize: o.corners})
	              , { width: r
	                , height: o.scale * o.width
	                , left: o.scale * o.radius
	                , top: -o.scale * o.width >> 1
	                , filter: filter
	                }
	              )
	            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
	            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        )
	      }
	
	      if (o.shadow)
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
	        }
	
	      for (i = 1; i <= o.lines; i++) seg(i)
	      return ins(el, g)
	    }
	
	    Spinner.prototype.opacity = function (el, i, val, o) {
	      var c = el.firstChild
	      o = o.shadow && o.lines || 0
	      if (c && i + o < c.childNodes.length) {
	        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
	        if (c) c.opacity = val
	      }
	    }
	  }
	
	  if (typeof document !== 'undefined') {
	    sheet = (function () {
	      var el = createEl('style', {type : 'text/css'})
	      ins(document.getElementsByTagName('head')[0], el)
	      return el.sheet || el.styleSheet
	    }())
	
	    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
	
	    if (!vendor(probe, 'transform') && probe.adj) initVML()
	    else useCssAnimations = vendor(probe, 'animation')
	  }
	
	  return Spinner
	
	}));


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(jQuery) {
	/* injects from baggage-loader */
	__webpack_require__(31);
	
	/*
	 * jQuery Pines Notify (pnotify) Plugin 1.2.0
	 *
	 * http://pinesframework.org/pnotify/
	 * Copyright (c) 2009-2012 Hunter Perrin
	 *
	 * Triple license under the GPL, LGPL, and MPL:
	 *	  http://www.gnu.org/licenses/gpl.html
	 *	  http://www.gnu.org/licenses/lgpl.html
	 *	  http://www.mozilla.org/MPL/MPL-1.1.html
	 */
	(function($){var history_handle_top,timer,body,jwindow=$(window),styling={jqueryui:{container:"ui-widget ui-widget-content ui-corner-all",notice:"ui-state-highlight",notice_icon:"ui-icon ui-icon-info",info:"",info_icon:"ui-icon ui-icon-info",success:"ui-state-default",success_icon:"ui-icon ui-icon-circle-check",error:"ui-state-error",error_icon:"ui-icon ui-icon-alert",closer:"ui-icon ui-icon-close",pin_up:"ui-icon ui-icon-pin-w",pin_down:"ui-icon ui-icon-pin-s",hi_menu:"ui-state-default ui-corner-bottom",hi_btn:"ui-state-default ui-corner-all",hi_btnhov:"ui-state-hover",hi_hnd:"ui-icon ui-icon-grip-dotted-horizontal"},bootstrap:{container:"alert",notice:"",notice_icon:"icon-exclamation-sign",info:"alert-info",info_icon:"icon-info-sign",success:"alert-success",success_icon:"icon-ok-sign",error:"alert-error",error_icon:"icon-warning-sign",closer:"icon-remove",pin_up:"icon-pause",pin_down:"icon-play",hi_menu:"well",hi_btn:"btn",hi_btnhov:"",hi_hnd:"icon-chevron-down"}};var do_when_ready=function(){body=$("body");jwindow=$(window);jwindow.bind("resize",function(){if(timer){clearTimeout(timer)}timer=setTimeout($.pnotify_position_all,10)})};if(document.body){do_when_ready()}else{$(do_when_ready)}$.extend({pnotify_remove_all:function(){var notices_data=jwindow.data("pnotify");if(notices_data&&notices_data.length){$.each(notices_data,function(){if(this.pnotify_remove){this.pnotify_remove()}})}},pnotify_position_all:function(){if(timer){clearTimeout(timer)}timer=null;var notices_data=jwindow.data("pnotify");if(!notices_data||!notices_data.length){return}$.each(notices_data,function(){var s=this.opts.stack;if(!s){return}s.nextpos1=s.firstpos1;s.nextpos2=s.firstpos2;s.addpos2=0;s.animation=true});$.each(notices_data,function(){this.pnotify_position()})},pnotify:function(options){var animating;var opts;if(typeof options!="object"){opts=$.extend({},$.pnotify.defaults);opts.text=options}else{opts=$.extend({},$.pnotify.defaults,options)}for(var i in opts){if(typeof i=="string"&&i.match(/^pnotify_/)){opts[i.replace(/^pnotify_/,"")]=opts[i]}}if(opts.before_init){if(opts.before_init(opts)===false){return null}}var nonblock_last_elem;var nonblock_pass=function(e,e_name){pnotify.css("display","none");var element_below=document.elementFromPoint(e.clientX,e.clientY);pnotify.css("display","block");var jelement_below=$(element_below);var cursor_style=jelement_below.css("cursor");pnotify.css("cursor",cursor_style!="auto"?cursor_style:"default");if(!nonblock_last_elem||nonblock_last_elem.get(0)!=element_below){if(nonblock_last_elem){dom_event.call(nonblock_last_elem.get(0),"mouseleave",e.originalEvent);dom_event.call(nonblock_last_elem.get(0),"mouseout",e.originalEvent)}dom_event.call(element_below,"mouseenter",e.originalEvent);dom_event.call(element_below,"mouseover",e.originalEvent)}dom_event.call(element_below,e_name,e.originalEvent);nonblock_last_elem=jelement_below};var styles=styling[opts.styling];var pnotify=$("<div />",{"class":"ui-pnotify "+opts.addclass,"title":locale.get("click_to_close") ? locale.get("click_to_close") : "Click to close","css":{"display":"none","cursor":"pointer"},"mouseenter":function(e){pnotify.closer.css("display","none");if(opts.nonblock){e.stopPropagation()}if(opts.mouse_reset&&animating=="out"){pnotify.stop(true);animating="in";pnotify.css("height","auto").animate({"width":opts.width,"opacity":opts.nonblock?opts.nonblock_opacity:opts.opacity},"fast")}if(opts.nonblock){pnotify.animate({"opacity":opts.nonblock_opacity},"fast")}if(opts.hide&&opts.mouse_reset){pnotify.pnotify_cancel_remove()}if(opts.sticker&&!opts.nonblock){pnotify.sticker.trigger("pnotify_icon").css("visibility","visible")}if(opts.closer&&!opts.nonblock){pnotify.closer.css("visibility","visible")}},"mouseleave":function(e){if(opts.nonblock){e.stopPropagation()}nonblock_last_elem=null;if(opts.nonblock&&animating!="out"){pnotify.animate({"opacity":opts.opacity},"fast")}if(opts.hide&&opts.mouse_reset){pnotify.pnotify_queue_remove()}if(opts.sticker_hover){pnotify.sticker.css("visibility","hidden")}if(opts.closer_hover){pnotify.closer.css("visibility","hidden")}$.pnotify_position_all()},"mouseover":function(e){if(opts.nonblock){e.stopPropagation()}},"mouseout":function(e){if(opts.nonblock){e.stopPropagation()}},"mousemove":function(e){if(opts.nonblock){e.stopPropagation();nonblock_pass(e,"onmousemove")}},"mousedown":function(e){if(opts.nonblock){e.stopPropagation();e.preventDefault();nonblock_pass(e,"onmousedown")}},"mouseup":function(e){if(opts.nonblock){e.stopPropagation();e.preventDefault();nonblock_pass(e,"onmouseup")}},"click":function(e){pnotify.pnotify_remove();pnotify.sticker.css("visibility","hidden");pnotify.closer.css("visibility","hidden");if(opts.nonblock){e.stopPropagation();nonblock_pass(e,"onclick")}},"dblclick":function(e){if(opts.nonblock){e.stopPropagation();nonblock_pass(e,"ondblclick")}}});pnotify.opts=opts;pnotify.container=$("<div />",{"class":styles.container+" ui-pnotify-container "+(opts.type=="error"?styles.error:(opts.type=="info"?styles.info:(opts.type=="success"?styles.success:styles.notice)))}).appendTo(pnotify);if(opts.cornerclass!=""){pnotify.container.removeClass("ui-corner-all").addClass(opts.cornerclass)}if(opts.shadow){pnotify.container.addClass("ui-pnotify-shadow")}pnotify.pnotify_version="1.2.0";pnotify.pnotify=function(options){var old_opts=opts;if(typeof options=="string"){opts.text=options}else{opts=$.extend({},opts,options)}for(var i in opts){if(typeof i=="string"&&i.match(/^pnotify_/)){opts[i.replace(/^pnotify_/,"")]=opts[i]}}pnotify.opts=opts;if(opts.cornerclass!=old_opts.cornerclass){pnotify.container.removeClass("ui-corner-all").addClass(opts.cornerclass)}if(opts.shadow!=old_opts.shadow){if(opts.shadow){pnotify.container.addClass("ui-pnotify-shadow")}else{pnotify.container.removeClass("ui-pnotify-shadow")}}if(opts.addclass===false){pnotify.removeClass(old_opts.addclass)}else{if(opts.addclass!==old_opts.addclass){pnotify.removeClass(old_opts.addclass).addClass(opts.addclass)}}if(opts.title===false){pnotify.title_container.slideUp("fast")}else{if(opts.title!==old_opts.title){if(opts.title_escape){pnotify.title_container.text(opts.title).slideDown(200)}else{pnotify.title_container.html(opts.title).slideDown(200)}}}if(opts.text===false){pnotify.text_container.slideUp("fast")}else{if(opts.text!==old_opts.text){if(opts.text_escape){pnotify.text_container.text(opts.text).slideDown(200)}else{pnotify.text_container.html(opts.insert_brs?String(opts.text).replace(/\n/g,"<br />"):opts.text).slideDown(200)}}}pnotify.pnotify_history=opts.history;pnotify.pnotify_hide=opts.hide;if(opts.type!=old_opts.type){pnotify.container.removeClass(styles.error+" "+styles.notice+" "+styles.success+" "+styles.info).addClass(opts.type=="error"?styles.error:(opts.type=="info"?styles.info:(opts.type=="success"?styles.success:styles.notice)))}if(opts.icon!==old_opts.icon||(opts.icon===true&&opts.type!=old_opts.type)){pnotify.container.find("div.ui-pnotify-icon").remove();if(opts.icon!==false){$("<div />",{"class":"ui-pnotify-icon"}).append($("<span />",{"class":opts.icon===true?(opts.type=="error"?styles.error_icon:(opts.type=="info"?styles.info_icon:(opts.type=="success"?styles.success_icon:styles.notice_icon))):opts.icon})).prependTo(pnotify.container)}}if(opts.width!==old_opts.width){pnotify.animate({width:opts.width})}if(opts.min_height!==old_opts.min_height){pnotify.container.animate({minHeight:opts.min_height})}if(opts.opacity!==old_opts.opacity){pnotify.fadeTo(opts.animate_speed,opts.opacity)}if(!opts.closer||opts.nonblock){pnotify.closer.css("display","none")}else{pnotify.closer.css("display","block")}if(!opts.sticker||opts.nonblock){pnotify.sticker.css("display","none")}else{pnotify.sticker.css("display","block")}pnotify.sticker.trigger("pnotify_icon");if(opts.sticker_hover){pnotify.sticker.css("visibility","hidden")}else{if(!opts.nonblock){pnotify.sticker.css("visibility","visible")}}if(opts.closer_hover){pnotify.closer.css("visibility","hidden")}else{if(!opts.nonblock){pnotify.closer.css("visibility","visible")}}if(!opts.hide){pnotify.pnotify_cancel_remove()}else{if(!old_opts.hide){pnotify.pnotify_queue_remove()}}pnotify.pnotify_queue_position();return pnotify};pnotify.pnotify_position=function(dont_skip_hidden){var s=pnotify.opts.stack;if(!s){return}if(!s.nextpos1){s.nextpos1=s.firstpos1}if(!s.nextpos2){s.nextpos2=s.firstpos2}if(!s.addpos2){s.addpos2=0}var hidden=pnotify.css("display")=="none";if(!hidden||dont_skip_hidden){var curpos1,curpos2;var animate={};var csspos1;switch(s.dir1){case"down":csspos1="top";break;case"up":csspos1="bottom";break;case"left":csspos1="right";break;case"right":csspos1="left";break}curpos1=parseInt(pnotify.css(csspos1));if(isNaN(curpos1)){curpos1=0}if(typeof s.firstpos1=="undefined"&&!hidden){s.firstpos1=curpos1;s.nextpos1=s.firstpos1}var csspos2;switch(s.dir2){case"down":csspos2="top";break;case"up":csspos2="bottom";break;case"left":csspos2="right";break;case"right":csspos2="left";break}curpos2=parseInt(pnotify.css(csspos2));if(isNaN(curpos2)){curpos2=0}if(typeof s.firstpos2=="undefined"&&!hidden){s.firstpos2=curpos2;s.nextpos2=s.firstpos2}if((s.dir1=="down"&&s.nextpos1+pnotify.height()>jwindow.height())||(s.dir1=="up"&&s.nextpos1+pnotify.height()>jwindow.height())||(s.dir1=="left"&&s.nextpos1+pnotify.width()>jwindow.width())||(s.dir1=="right"&&s.nextpos1+pnotify.width()>jwindow.width())){s.nextpos1=s.firstpos1;s.nextpos2+=s.addpos2+(typeof s.spacing2=="undefined"?25:s.spacing2);s.addpos2=0}if(s.animation&&s.nextpos2<curpos2){switch(s.dir2){case"down":animate.top=s.nextpos2+"px";break;case"up":animate.bottom=s.nextpos2+"px";break;case"left":animate.right=s.nextpos2+"px";break;case"right":animate.left=s.nextpos2+"px";break}}else{pnotify.css(csspos2,s.nextpos2+"px")}switch(s.dir2){case"down":case"up":if(pnotify.outerHeight(true)>s.addpos2){s.addpos2=pnotify.height()}break;case"left":case"right":if(pnotify.outerWidth(true)>s.addpos2){s.addpos2=pnotify.width()}break}if(s.nextpos1){if(s.animation&&(curpos1>s.nextpos1||animate.top||animate.bottom||animate.right||animate.left)){switch(s.dir1){case"down":animate.top=s.nextpos1+"px";break;case"up":animate.bottom=s.nextpos1+"px";break;case"left":animate.right=s.nextpos1+"px";break;case"right":animate.left=s.nextpos1+"px";break}}else{pnotify.css(csspos1,s.nextpos1+"px")}}if(animate.top||animate.bottom||animate.right||animate.left){pnotify.animate(animate,{duration:500,queue:false})}switch(s.dir1){case"down":case"up":s.nextpos1+=pnotify.height()+(typeof s.spacing1=="undefined"?25:s.spacing1);break;case"left":case"right":s.nextpos1+=pnotify.width()+(typeof s.spacing1=="undefined"?25:s.spacing1);break}}};pnotify.pnotify_queue_position=function(milliseconds){if(timer){clearTimeout(timer)}if(!milliseconds){milliseconds=10}timer=setTimeout($.pnotify_position_all,milliseconds)};pnotify.pnotify_display=function(){if(!pnotify.parent().length){pnotify.appendTo(body)}if(opts.before_open){if(opts.before_open(pnotify)===false){return}}if(opts.stack.push!="top"){pnotify.pnotify_position(true)}if(opts.animation=="fade"||opts.animation.effect_in=="fade"){pnotify.show().fadeTo(0,0).hide()}else{if(opts.opacity!=1){pnotify.show().fadeTo(0,opts.opacity).hide()}}pnotify.animate_in(function(){if(opts.after_open){opts.after_open(pnotify)}pnotify.pnotify_queue_position();if(opts.hide){pnotify.pnotify_queue_remove()}})};pnotify.pnotify_remove=function(){if(pnotify.timer){window.clearTimeout(pnotify.timer);pnotify.timer=null}if(opts.before_close){if(opts.before_close(pnotify)===false){return}}pnotify.animate_out(function(){if(opts.after_close){if(opts.after_close(pnotify)===false){return}}pnotify.pnotify_queue_position();if(opts.remove){pnotify.detach()}})};pnotify.animate_in=function(callback){animating="in";var animation;if(typeof opts.animation.effect_in!="undefined"){animation=opts.animation.effect_in}else{animation=opts.animation}if(animation=="none"){pnotify.show();callback()}else{if(animation=="show"){pnotify.show(opts.animate_speed,callback)}else{if(animation=="fade"){pnotify.show().fadeTo(opts.animate_speed,opts.opacity,callback)}else{if(animation=="slide"){pnotify.slideDown(opts.animate_speed,callback)}else{if(typeof animation=="function"){animation("in",callback,pnotify)}else{pnotify.show(animation,(typeof opts.animation.options_in=="object"?opts.animation.options_in:{}),opts.animate_speed,callback)}}}}}};pnotify.animate_out=function(callback){animating="out";var animation;if(typeof opts.animation.effect_out!="undefined"){animation=opts.animation.effect_out}else{animation=opts.animation}if(animation=="none"){pnotify.hide();callback()}else{if(animation=="show"){pnotify.hide(opts.animate_speed,callback)}else{if(animation=="fade"){pnotify.fadeOut(opts.animate_speed,callback)}else{if(animation=="slide"){pnotify.slideUp(opts.animate_speed,callback)}else{if(typeof animation=="function"){animation("out",callback,pnotify)}else{pnotify.hide(animation,(typeof opts.animation.options_out=="object"?opts.animation.options_out:{}),opts.animate_speed,callback)}}}}}};pnotify.pnotify_cancel_remove=function(){if(pnotify.timer){window.clearTimeout(pnotify.timer)}};pnotify.pnotify_queue_remove=function(){pnotify.pnotify_cancel_remove();pnotify.timer=window.setTimeout(function(){pnotify.pnotify_remove()},(isNaN(opts.delay)?0:opts.delay))};pnotify.closer=$("<div />",{"class":"ui-pnotify-closer","css":{"cursor":"pointer","visibility":opts.closer_hover?"hidden":"visible"},"click":function(){pnotify.pnotify_remove();pnotify.sticker.css("visibility","hidden");pnotify.closer.css("visibility","hidden")}}).append($("<span />",{"class":styles.closer})).appendTo(pnotify.container);if(!opts.closer||opts.nonblock){pnotify.closer.css("display","none")}pnotify.sticker=$("<div />",{"class":"ui-pnotify-sticker","css":{"cursor":"pointer","visibility":opts.sticker_hover?"hidden":"visible"},"click":function(){opts.hide=!opts.hide;if(opts.hide){pnotify.pnotify_queue_remove()}else{pnotify.pnotify_cancel_remove()}$(this).trigger("pnotify_icon")}}).bind("pnotify_icon",function(){$(this).children().removeClass(styles.pin_up+" "+styles.pin_down).addClass(opts.hide?styles.pin_up:styles.pin_down)}).append($("<span />",{"class":styles.pin_up})).appendTo(pnotify.container);if(!opts.sticker||opts.nonblock){pnotify.sticker.css("display","none")}if(opts.icon!==false){$("<div />",{"class":"ui-pnotify-icon"}).append($("<span />",{"class":opts.icon===true?(opts.type=="error"?styles.error_icon:(opts.type=="info"?styles.info_icon:(opts.type=="success"?styles.success_icon:styles.notice_icon))):opts.icon})).prependTo(pnotify.container)}pnotify.title_container=$("<h4 />",{"class":"ui-pnotify-title"}).appendTo(pnotify.container);if(opts.title===false){pnotify.title_container.hide()}else{if(opts.title_escape){pnotify.title_container.text(opts.title)}else{pnotify.title_container.html(opts.title)}}pnotify.text_container=$("<div />",{"class":"ui-pnotify-text"}).appendTo(pnotify.container);if(opts.text===false){pnotify.text_container.hide()}else{if(opts.text_escape){pnotify.text_container.text(opts.text)}else{pnotify.text_container.html(opts.insert_brs?String(opts.text).replace(/\n/g,"<br />"):opts.text)}}if(typeof opts.width=="string"){pnotify.css("width",opts.width)}if(typeof opts.min_height=="string"){pnotify.container.css("min-height",opts.min_height)}pnotify.pnotify_history=opts.history;pnotify.pnotify_hide=opts.hide;var notices_data=jwindow.data("pnotify");if(notices_data==null||typeof notices_data!="object"){notices_data=[]}if(opts.stack.push=="top"){notices_data=$.merge([pnotify],notices_data)}else{notices_data=$.merge(notices_data,[pnotify])}jwindow.data("pnotify",notices_data);if(opts.stack.push=="top"){pnotify.pnotify_queue_position(1)}if(opts.after_init){opts.after_init(pnotify)}if(opts.history){var history_menu=jwindow.data("pnotify_history");if(typeof history_menu=="undefined"){history_menu=$("<div />",{"class":"ui-pnotify-history-container "+styles.hi_menu,"mouseleave":function(){history_menu.animate({top:"-"+history_handle_top+"px"},{duration:100,queue:false})}}).append($("<div />",{"class":"ui-pnotify-history-header","text":"Redisplay"})).append($("<button />",{"class":"ui-pnotify-history-all "+styles.hi_btn,"text":"All","mouseenter":function(){$(this).addClass(styles.hi_btnhov)},"mouseleave":function(){$(this).removeClass(styles.hi_btnhov)},"click":function(){$.each(notices_data,function(){if(this.pnotify_history){if(this.is(":visible")){if(this.pnotify_hide){this.pnotify_queue_remove()}}else{if(this.pnotify_display){this.pnotify_display()}}}});return false}})).append($("<button />",{"class":"ui-pnotify-history-last "+styles.hi_btn,"text":"Last","mouseenter":function(){$(this).addClass(styles.hi_btnhov)},"mouseleave":function(){$(this).removeClass(styles.hi_btnhov)},"click":function(){var i=-1;var notice;do{if(i==-1){notice=notices_data.slice(i)}else{notice=notices_data.slice(i,i+1)}if(!notice[0]){break}i--}while(!notice[0].pnotify_history||notice[0].is(":visible"));if(!notice[0]){return false}if(notice[0].pnotify_display){notice[0].pnotify_display()}return false}})).appendTo(body);var handle=$("<span />",{"class":"ui-pnotify-history-pulldown "+styles.hi_hnd,"mouseenter":function(){history_menu.animate({top:"0"},{duration:100,queue:false})}}).appendTo(history_menu);history_handle_top=handle.offset().top+2;history_menu.css({top:"-"+history_handle_top+"px"});jwindow.data("pnotify_history",history_menu)}}opts.stack.animation=false;pnotify.pnotify_display();return pnotify}});var re_on=/^on/,re_mouse_events=/^(dbl)?click$|^mouse(move|down|up|over|out|enter|leave)$|^contextmenu$/,re_ui_events=/^(focus|blur|select|change|reset)$|^key(press|down|up)$/,re_html_events=/^(scroll|resize|(un)?load|abort|error)$/;var dom_event=function(e,orig_e){var event_object;e=e.toLowerCase();if(document.createEvent&&this.dispatchEvent){e=e.replace(re_on,"");if(e.match(re_mouse_events)){$(this).offset();event_object=document.createEvent("MouseEvents");event_object.initMouseEvent(e,orig_e.bubbles,orig_e.cancelable,orig_e.view,orig_e.detail,orig_e.screenX,orig_e.screenY,orig_e.clientX,orig_e.clientY,orig_e.ctrlKey,orig_e.altKey,orig_e.shiftKey,orig_e.metaKey,orig_e.button,orig_e.relatedTarget)}else{if(e.match(re_ui_events)){event_object=document.createEvent("UIEvents");event_object.initUIEvent(e,orig_e.bubbles,orig_e.cancelable,orig_e.view,orig_e.detail)}else{if(e.match(re_html_events)){event_object=document.createEvent("HTMLEvents");event_object.initEvent(e,orig_e.bubbles,orig_e.cancelable)}}}if(!event_object){return}this.dispatchEvent(event_object)}else{if(!e.match(re_on)){e="on"+e}event_object=document.createEventObject(orig_e);this.fireEvent(e,event_object)}};$.pnotify.defaults={title:false,title_escape:false,text:false,text_escape:false,styling:"bootstrap",addclass:"",cornerclass:"",nonblock:false,nonblock_opacity:0.2,history:true,width:"300px",min_height:"16px",type:"notice",icon:true,animation:"fade",animate_speed:"slow",opacity:1,shadow:true,closer:true,closer_hover:true,sticker:true,sticker_hover:true,hide:true,delay:8000,mouse_reset:true,remove:true,insert_brs:true,stack:{"dir1":"down","dir2":"left","push":"bottom","spacing1":25,"spacing2":25}}})(jQuery);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 31 */
13,
/* 32 */
13,
/* 33 */
13,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * @author PanJC
	 * @filename config
	 * @filetype {object}
	 * @filedescription "老版本配置文件，用户不可修改"
	 * @filereturn {object} config "配置对象"
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require) {
	  //Set cloud config
	  /*
	   * @property {string} config.debugMode "是否调试模式"
	   * @property {string} config.CLIENT_ID "oauth2 CLIENT_ID"
	   * @property {string} config.CLIENT_SECRET "oauth2 CLIENT_SECRET"
	   * @property {string} config.AUTH_SERVER_URL "oauth2 AUTH_SERVER_URL oauth2验证服务器地址"
	   * @property {string} config.API_SERVER_URL "oauth2 API_SERVER_URL api服务器地址"
	   * @property {string} config.FILE_SERVER_URL "oauth2 FILE_SERVER_URL 文件服务器地址"
	   * @property {string} config.UPGRADE_SERVER "升级服务器地址"
	   * @property {number} config.UPGRADE_PORT.DTU "DTU升级端口号"
	   * @property {number} config.UPGRADE_PORT.ROUTE "ROUTE升级端口号"
	   */
	  var config = {
	    debugMode: false,
	    CLIENT_ID: "17953450251798098136",
	    CLIENT_SECRET: "08E9EC6793345759456CB8BAE52615F3",
	    AUTH_SERVER_URL: "/oauth2",
	    API_SERVER_URL: "",
	    FILE_SERVER_URL: "",
	    UPGRADE_SERVER: "139.129.192.241",
	    UPGRADE_PORT: {
	      DTU: 20010,
	      ROUTE: 20008,
	      ENH: 80
	    }
	  };
	  return config;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
	 postal
	 Author: Jim Cowart (http://freshbrewedcode.com/jimcowart)
	 License: Dual licensed MIT (http://www.opensource.org/licenses/mit-license) & GPL (http://www.opensource.org/licenses/gpl-license)
	 Version 0.8.5
	 */
	(function(t,n){"object"==typeof module&&module.exports?module.exports=function(t){return t=t||__webpack_require__(36),n(t)}: true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(36)], __WEBPACK_AMD_DEFINE_RESULT__ = function(i){return n(i,t)}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):t.postal=n(t._,t)})(this,function(t){var n="/",i="postal",s=function(){var n;return function(i){var s=!1;return t.isString(i)?(s=i===n,n=i):(s=t.isEqual(i,n),n=t.clone(i)),!s}},e=function(){var n=[];return function(i){var s=!t.any(n,function(n){return t.isObject(i)||t.isArray(i)?t.isEqual(i,n):i===n});return s&&n.push(i),s}},c=function(t){this.channel=t||n};c.prototype.subscribe=function(){return 1===arguments.length?new r(this.channel,arguments[0].topic,arguments[0].callback):new r(this.channel,arguments[0],arguments[1])},c.prototype.publish=function(){var t=1===arguments.length?"[object String]"===Object.prototype.toString.call(arguments[0])?{topic:arguments[0]}:arguments[0]:{topic:arguments[0],data:arguments[1]};return t.channel=this.channel,p.configuration.bus.publish(t)};var r=function(t,n,s){this.channel=t,this.topic=n,this.callback=s,this.constraints=[],this.context=null,p.configuration.bus.publish({channel:i,topic:"subscription.created",data:{event:"subscription.created",channel:t,topic:n}}),p.configuration.bus.subscribe(this)};r.prototype={unsubscribe:function(){this.inactive=!0,p.configuration.bus.unsubscribe(this),p.configuration.bus.publish({channel:i,topic:"subscription.removed",data:{event:"subscription.removed",channel:this.channel,topic:this.topic}})},defer:function(){var t=this.callback;return this.callback=function(n){setTimeout(function(){t(n)},0)},this},disposeAfter:function(n){if(t.isNaN(n)||0>=n)throw"The value provided to disposeAfter (maxCalls) must be a number greater than zero.";var i=this.callback,s=t.after(n,t.bind(function(){this.unsubscribe()},this));return this.callback=function(){i.apply(this.context,arguments),s()},this},distinctUntilChanged:function(){return this.withConstraint(new s),this},distinct:function(){return this.withConstraint(new e),this},once:function(){return this.disposeAfter(1),this},withConstraint:function(n){if(!t.isFunction(n))throw"Predicate constraint must be a function";return this.constraints.push(n),this},withConstraints:function(n){var i=this;return t.isArray(n)&&t.each(n,function(t){i.withConstraint(t)}),i},withContext:function(t){return this.context=t,this},withDebounce:function(n){if(t.isNaN(n))throw"Milliseconds must be a number";var i=this.callback;return this.callback=t.debounce(i,n),this},withDelay:function(n){if(t.isNaN(n))throw"Milliseconds must be a number";var i=this.callback;return this.callback=function(t){setTimeout(function(){i(t)},n)},this},withThrottle:function(n){if(t.isNaN(n))throw"Milliseconds must be a number";var i=this.callback;return this.callback=t.throttle(i,n),this},subscribe:function(t){return this.callback=t,this}};var o={cache:{},regex:{},compare:function(n,i){var s,e,c,r=this.cache[i]&&this.cache[i][n];return r!==undefined?r:((e=this.regex[n])||(s="^"+t.map(n.split("."),function(t){var n="";return c&&(n="#"!==c?"\\.\\b":"\\b"),n+="#"===t?"[\\s\\S]*":"*"===t?"[^.]+":t,c=t,n}).join("")+"$",e=this.regex[n]=RegExp(s)),this.cache[i]=this.cache[i]||{},this.cache[i][n]=r=e.test(i),r)},reset:function(){this.cache={},this.regex={}}},u=function(n,i){!n.inactive&&p.configuration.resolver.compare(n.topic,i.topic)&&t.all(n.constraints,function(t){return t.call(n.context,i.data,i)})&&"function"==typeof n.callback&&n.callback.call(n.context,i.data,i)},a=!1,h=[],l={addWireTap:function(t){var n=this;return n.wireTaps.push(t),function(){var i=n.wireTaps.indexOf(t);-1!==i&&n.wireTaps.splice(i,1)}},publish:function(n){return a=!0,n.timeStamp=new Date,t.each(this.wireTaps,function(t){t(n.data,n)}),this.subscriptions[n.channel]&&t.each(this.subscriptions[n.channel],function(t){for(var i,s=0,e=t.length;e>s;)(i=t[s++])&&u(i,n)}),a=!1,n},reset:function(){this.subscriptions&&(t.each(this.subscriptions,function(n){t.each(n,function(t){for(;t.length;)t.pop().unsubscribe()})}),this.subscriptions={})},subscribe:function(t){var n,i=this.subscriptions[t.channel];return i||(i=this.subscriptions[t.channel]={}),n=this.subscriptions[t.channel][t.topic],n||(n=this.subscriptions[t.channel][t.topic]=[]),n.push(t),t},subscriptions:{},wireTaps:[],unsubscribe:function(t){if(a)return h.push(t),undefined;if(this.subscriptions[t.channel][t.topic])for(var n=this.subscriptions[t.channel][t.topic].length,i=0;n>i;){if(this.subscriptions[t.channel][t.topic][i]===t){this.subscriptions[t.channel][t.topic].splice(i,1);break}i+=1}}};l.subscriptions[i]={};var p={configuration:{bus:l,resolver:o,DEFAULT_CHANNEL:n,SYSTEM_CHANNEL:i},ChannelDefinition:c,SubscriptionDefinition:r,channel:function(t){return new c(t)},subscribe:function(t){return new r(t.channel||n,t.topic,t.callback)},publish:function(t){return t.channel=t.channel||n,p.configuration.bus.publish(t)},addWireTap:function(t){return this.configuration.bus.addWireTap(t)},linkChannels:function(i,s){var e=[];return i=t.isArray(i)?i:[i],s=t.isArray(s)?s:[s],t.each(i,function(i){i.topic||"#",t.each(s,function(s){var c=s.channel||n;e.push(p.subscribe({channel:i.channel||n,topic:i.topic||"#",callback:function(n,i){var e=t.clone(i);e.topic=t.isFunction(s.topic)?s.topic(i.topic):s.topic||i.topic,e.channel=c,e.data=n,p.publish(e)}}))})}),e},utils:{getSubscribersFor:function(){var t=arguments[0],n=arguments[1];return 1===arguments.length&&(t=arguments[0].channel||p.configuration.DEFAULT_CHANNEL,n=arguments[0].topic),p.configuration.bus.subscriptions[t]&&Object.prototype.hasOwnProperty.call(p.configuration.bus.subscriptions[t],n)?p.configuration.bus.subscriptions[t][n]:[]},reset:function(){p.configuration.bus.reset(),p.configuration.resolver.reset()}}};return p});

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	// Underscore.js 1.2.2
	// (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
	// Underscore is freely distributable under the MIT license.
	// Portions of Underscore are inspired or borrowed from Prototype,
	// Oliver Steele's Functional, and John Resig's Micro-Templating.
	// For all details and documentation:
	// http://documentcloud.github.com/underscore
	(function () {
		function r( a, c, d ) {
			if ( a === c ) {
				return a !== 0 || 1 / a == 1 / c;
			}
			if ( a == null || c == null ) {
				return a === c;
			}
			if ( a._chain ) {
				a = a._wrapped;
			}
			if ( c._chain ) {
				c = c._wrapped;
			}
			if ( b.isFunction( a.isEqual ) ) {
				return a.isEqual( c );
			}
			if ( b.isFunction( c.isEqual ) ) {
				return c.isEqual( a );
			}
			var e = l.call( a );
			if ( e != l.call( c ) ) {
				return false;
			}
			switch ( e ) {
				case "[object String]":
					return String( a ) == String( c );
				case "[object Number]":
					return a = +a, c = +c, a != a ? c != c : a == 0 ? 1 / a == 1 / c : a == c;
				case "[object Date]":
				case "[object Boolean]":
					return+a == +c;
				case "[object RegExp]":
					return a.source ==
					       c.source && a.global == c.global && a.multiline == c.multiline && a.ignoreCase == c.ignoreCase
			}
			if ( typeof a != "object" || typeof c != "object" ) {
				return false;
			}
			for ( var f = d.length; f--; ) {
				if ( d[f] == a ) {
					return true;
				}
			}
			d.push( a );
			var f = 0, g = true;
			if ( e == "[object Array]" ) {
				if ( f = a.length, g = f == c.length ) {
					for ( ; f--; ) {
						if ( !(g = f in a == f in c && r( a[f], c[f], d )) ) {
							break
						}
					}
				}
			} else {
				if ( "constructor"in a != "constructor"in c || a.constructor != c.constructor ) {
					return false;
				}
				for ( var h in a ) {
					if ( m.call( a, h ) && (f++, !(g = m.call( c, h ) && r( a[h], c[h], d ))) ) {
						break;
					}
				}
				if ( g ) {
					for ( h in c ) {
						if ( m.call( c,
							h ) && !f-- ) {
							break;
						}
					}
					g = !f
				}
			}
			d.pop();
			return g
		}
	
		var s = this, F = s._, o = {}, k = Array.prototype, p = Object.prototype, i = k.slice, G = k.unshift, l = p.toString, m = p.hasOwnProperty, v = k.forEach, w = k.map, x = k.reduce, y = k.reduceRight, z = k.filter, A = k.every, B = k.some, q = k.indexOf, C = k.lastIndexOf, p = Array.isArray, H = Object.keys, t = Function.prototype.bind, b = function ( a ) {
			return new n( a )
		};
		if ( true ) {
			if ( typeof module !== "undefined" && module.exports ) {
				exports = module.exports = b;
			}
			exports._ = b
		} else {
			typeof define === "function" && define.amd ?
			define( "underscore", function () {
				return b
			} ) : s._ = b;
		}
		b.VERSION = "1.2.2";
		var j = b.each = b.forEach = function ( a, c, b ) {
			if ( a != null ) {
				if ( v && a.forEach === v ) {
					a.forEach( c, b );
				} else if ( a.length === +a.length ) {
					for ( var e = 0, f = a.length; e < f; e++ ) {
						if ( e in a && c.call( b, a[e], e, a ) === o ) {
							break
						}
					}
				} else {
					for ( e in a ) {
						if ( m.call( a, e ) && c.call( b, a[e], e, a ) === o ) {
							break
						}
					}
				}
			}
		};
		b.map = function ( a, c, b ) {
			var e = [];
			if ( a == null ) {
				return e;
			}
			if ( w && a.map === w ) {
				return a.map( c, b );
			}
			j( a, function ( a, g, h ) {
				e[e.length] = c.call( b, a, g, h )
			} );
			return e
		};
		b.reduce = b.foldl = b.inject = function ( a, c, d, e ) {
			var f =
				d !== void 0;
			a == null && (a = []);
			if ( x && a.reduce === x ) {
				return e && (c = b.bind( c, e )), f ? a.reduce( c, d ) : a.reduce( c );
			}
			j( a, function ( a, b, i ) {
				f ? d = c.call( e, d, a, b, i ) : (d = a, f = true)
			} );
			if ( !f ) {
				throw new TypeError( "Reduce of empty array with no initial value" );
			}
			return d
		};
		b.reduceRight = b.foldr = function ( a, c, d, e ) {
			a == null && (a = []);
			if ( y && a.reduceRight === y ) {
				return e && (c = b.bind( c, e )), d !== void 0 ? a.reduceRight( c, d ) : a.reduceRight( c );
			}
			a = (b.isArray( a ) ? a.slice() : b.toArray( a )).reverse();
			return b.reduce( a, c, d, e )
		};
		b.find = b.detect = function ( a, c, b ) {
			var e;
			D( a, function ( a, g, h ) {
				if ( c.call( b, a, g, h ) ) {
					return e = a, true
				}
			} );
			return e
		};
		b.filter = b.select = function ( a, c, b ) {
			var e = [];
			if ( a == null ) {
				return e;
			}
			if ( z && a.filter === z ) {
				return a.filter( c, b );
			}
			j( a, function ( a, g, h ) {
				c.call( b, a, g, h ) && (e[e.length] = a)
			} );
			return e
		};
		b.reject = function ( a, c, b ) {
			var e = [];
			if ( a == null ) {
				return e;
			}
			j( a, function ( a, g, h ) {
				c.call( b, a, g, h ) || (e[e.length] = a)
			} );
			return e
		};
		b.every = b.all = function ( a, c, b ) {
			var e = true;
			if ( a == null ) {
				return e;
			}
			if ( A && a.every === A ) {
				return a.every( c, b );
			}
			j( a, function ( a, g, h ) {
				if ( !(e = e && c.call( b, a, g, h )) ) {
					return o
				}
			} );
			return e
		};
		var D = b.some = b.any = function ( a, c, d ) {
			var c = c || b.identity, e = false;
			if ( a == null ) {
				return e;
			}
			if ( B && a.some === B ) {
				return a.some( c, d );
			}
			j( a, function ( a, b, h ) {
				if ( e || (e = c.call( d, a, b, h )) ) {
					return o
				}
			} );
			return!!e
		};
		b.include = b.contains = function ( a, c ) {
			var b = false;
			if ( a == null ) {
				return b;
			}
			return q && a.indexOf === q ? a.indexOf( c ) != -1 : b = D( a, function ( a ) {
				return a === c
			} )
		};
		b.invoke = function ( a, c ) {
			var d = i.call( arguments, 2 );
			return b.map( a, function ( a ) {
				return(c.call ? c || a : a[c]).apply( a, d )
			} )
		};
		b.pluck = function ( a, c ) {
			return b.map( a, function ( a ) {
				return a[c]
			} )
		};
		b.max = function ( a, c, d ) {
			if ( !c && b.isArray( a ) ) {
				return Math.max.apply( Math, a );
			}
			if ( !c && b.isEmpty( a ) ) {
				return-Infinity;
			}
			var e = {computed : -Infinity};
			j( a, function ( a, b, h ) {
				b = c ? c.call( d, a, b, h ) : a;
				b >= e.computed && (e = {value : a, computed : b})
			} );
			return e.value
		};
		b.min = function ( a, c, d ) {
			if ( !c && b.isArray( a ) ) {
				return Math.min.apply( Math, a );
			}
			if ( !c && b.isEmpty( a ) ) {
				return Infinity;
			}
			var e = {computed : Infinity};
			j( a, function ( a, b, h ) {
				b = c ? c.call( d, a, b, h ) : a;
				b < e.computed && (e = {value : a, computed : b})
			} );
			return e.value
		};
		b.shuffle = function ( a ) {
			var c = [], b;
			j( a, function ( a, f ) {
				f == 0 ? c[0] = a : (b = Math.floor( Math.random() * (f + 1) ), c[f] = c[b], c[b] = a)
			} );
			return c
		};
		b.sortBy = function ( a, c, d ) {
			return b.pluck( b.map( a,
				function ( a, b, g ) {
					return{value : a, criteria : c.call( d, a, b, g )}
				} ).sort( function ( a, c ) {
				var b = a.criteria, d = c.criteria;
				return b < d ? -1 : b > d ? 1 : 0
			} ), "value" )
		};
		b.groupBy = function ( a, c ) {
			var d = {}, e = b.isFunction( c ) ? c : function ( a ) {
				return a[c]
			};
			j( a, function ( a, c ) {
				var b = e( a, c );
				(d[b] || (d[b] = [])).push( a )
			} );
			return d
		};
		b.sortedIndex = function ( a, c, d ) {
			d || (d = b.identity);
			for ( var e = 0, f = a.length; e <
			                               f; ) {
				var g = e + f >> 1;
				d( a[g] ) < d( c ) ? e = g + 1 : f = g
			}
			return e
		};
		b.toArray = function ( a ) {
			return!a ? [] : a.toArray ? a.toArray() : b.isArray( a ) ? i.call( a ) : b.isArguments( a ) ? i.call( a ) : b.values( a )
		};
		b.size = function ( a ) {
			return b.toArray( a ).length
		};
		b.first = b.head = function ( a, b, d ) {
			return b != null && !d ? i.call( a, 0, b ) : a[0]
		};
		b.initial = function ( a, b, d ) {
			return i.call( a, 0, a.length - (b == null || d ? 1 : b) )
		};
		b.last = function ( a, b, d ) {
			return b != null && !d ? i.call( a, Math.max( a.length - b, 0 ) ) : a[a.length - 1]
		};
		b.rest = b.tail = function ( a, b, d ) {
			return i.call( a, b == null ||
			                  d ? 1 : b )
		};
		b.compact = function ( a ) {
			return b.filter( a, function ( a ) {
				return!!a
			} )
		};
		b.flatten = function ( a, c ) {
			return b.reduce( a, function ( a, e ) {
				if ( b.isArray( e ) ) {
					return a.concat( c ? e : b.flatten( e ) );
				}
				a[a.length] = e;
				return a
			}, [] )
		};
		b.without = function ( a ) {
			return b.difference( a, i.call( arguments, 1 ) )
		};
		b.uniq = b.unique = function ( a, c, d ) {
			var d = d ? b.map( a, d ) : a, e = [];
			b.reduce( d, function ( d, g, h ) {
				if ( 0 == h || (c === true ? b.last( d ) != g : !b.include( d, g )) ) {
					d[d.length] = g, e[e.length] = a[h];
				}
				return d
			}, [] );
			return e
		};
		b.union = function () {
			return b.uniq( b.flatten( arguments,
				true ) )
		};
		b.intersection = b.intersect = function ( a ) {
			var c = i.call( arguments, 1 );
			return b.filter( b.uniq( a ), function ( a ) {
				return b.every( c, function ( c ) {
					return b.indexOf( c, a ) >= 0
				} )
			} )
		};
		b.difference = function ( a, c ) {
			return b.filter( a, function ( a ) {
				return!b.include( c, a )
			} )
		};
		b.zip = function () {
			for ( var a = i.call( arguments ), c = b.max( b.pluck( a, "length" ) ), d = Array( c ), e = 0; e < c; e++ ) {
				d[e] = b.pluck( a, "" + e );
			}
			return d
		};
		b.indexOf = function ( a, c, d ) {
			if ( a == null ) {
				return-1;
			}
			var e;
			if ( d ) {
				return d = b.sortedIndex( a, c ), a[d] === c ? d : -1;
			}
			if ( q && a.indexOf === q ) {
				return a.indexOf( c );
			}
			for ( d = 0, e = a.length; d < e; d++ ) {
				if ( a[d] === c ) {
					return d;
				}
			}
			return-1
		};
		b.lastIndexOf = function ( a, b ) {
			if ( a == null ) {
				return-1;
			}
			if ( C && a.lastIndexOf === C ) {
				return a.lastIndexOf( b );
			}
			for ( var d = a.length; d--; ) {
				if ( a[d] === b ) {
					return d;
				}
			}
			return-1
		};
		b.range = function ( a, b, d ) {
			arguments.length <= 1 && (b = a || 0, a = 0);
			for ( var d = arguments[2] || 1, e = Math.max( Math.ceil( (b - a) / d ), 0 ), f = 0, g = Array( e ); f < e; ) {
				g[f++] = a, a += d;
			}
			return g
		};
		var E = function () {
		};
		b.bind = function ( a, c ) {
			var d, e;
			if ( a.bind === t && t ) {
				return t.apply( a, i.call( arguments, 1 ) );
			}
			if ( !b.isFunction( a ) ) {
				throw new TypeError;
			}
			e = i.call( arguments, 2 );
			return d = function () {
				if ( !(this instanceof d) ) {
					return a.apply( c, e.concat( i.call( arguments ) ) );
				}
				E.prototype = a.prototype;
				var b = new E, g = a.apply( b, e.concat( i.call( arguments ) ) );
				return Object( g ) === g ? g : b
			}
		};
		b.bindAll = function ( a ) {
			var c = i.call( arguments, 1 );
			c.length == 0 && (c = b.functions( a ));
			j( c, function ( c ) {
				a[c] = b.bind( a[c], a )
			} );
			return a
		};
		b.memoize = function ( a, c ) {
			var d = {};
			c || (c = b.identity);
			return function () {
				var b = c.apply( this, arguments );
				return m.call( d, b ) ? d[b] : d[b] = a.apply( this, arguments )
			}
		};
		b.delay =
		function ( a, b ) {
			var d = i.call( arguments, 2 );
			return setTimeout( function () {
				return a.apply( a, d )
			}, b )
		};
		b.defer = function ( a ) {
			return b.delay.apply( b, [a, 1].concat( i.call( arguments, 1 ) ) )
		};
		b.throttle = function ( a, c ) {
			var d, e, f, g, h, i = b.debounce( function () {
				h = g = false
			}, c );
			return function () {
				d = this;
				e = arguments;
				var b;
				f || (f = setTimeout( function () {
					f = null;
					h && a.apply( d, e );
					i()
				}, c ));
				g ? h = true : a.apply( d, e );
				i();
				g = true
			}
		};
		b.debounce = function ( a, b ) {
			var d;
			return function () {
				var e = this, f = arguments;
				clearTimeout( d );
				d = setTimeout( function () {
					d =
					null;
					a.apply( e, f )
				}, b )
			}
		};
		b.once = function ( a ) {
			var b = false, d;
			return function () {
				if ( b ) {
					return d;
				}
				b = true;
				return d = a.apply( this, arguments )
			}
		};
		b.wrap = function ( a, b ) {
			return function () {
				var d = [a].concat( i.call( arguments ) );
				return b.apply( this, d )
			}
		};
		b.compose = function () {
			var a = i.call( arguments );
			return function () {
				for ( var b = i.call( arguments ), d = a.length - 1; d >= 0; d-- ) {
					b = [a[d].apply( this, b )];
				}
				return b[0]
			}
		};
		b.after = function ( a, b ) {
			return a <= 0 ? b() : function () {
				if ( --a < 1 ) {
					return b.apply( this, arguments )
				}
			}
		};
		b.keys = H || function ( a ) {
			if ( a !==
			     Object( a ) ) {
				throw new TypeError( "Invalid object" );
			}
			var b = [], d;
			for ( d in a ) {
				m.call( a, d ) && (b[b.length] = d);
			}
			return b
		};
		b.values = function ( a ) {
			return b.map( a, b.identity )
		};
		b.functions = b.methods = function ( a ) {
			var c = [], d;
			for ( d in a ) {
				b.isFunction( a[d] ) && c.push( d );
			}
			return c.sort()
		};
		b.extend = function ( a ) {
			j( i.call( arguments, 1 ), function ( b ) {
				for ( var d in b ) {
					b[d] !== void 0 && (a[d] = b[d])
				}
			} );
			return a
		};
		b.defaults = function ( a ) {
			j( i.call( arguments, 1 ), function ( b ) {
				for ( var d in b ) {
					a[d] == null && (a[d] = b[d])
				}
			} );
			return a
		};
		b.clone = function ( a ) {
			return!b.isObject( a ) ?
			      a : b.isArray( a ) ? a.slice() : b.extend( {}, a )
		};
		b.tap = function ( a, b ) {
			b( a );
			return a
		};
		b.isEqual = function ( a, b ) {
			return r( a, b, [] )
		};
		b.isEmpty = function ( a ) {
			if ( b.isArray( a ) || b.isString( a ) ) {
				return a.length === 0;
			}
			for ( var c in a ) {
				if ( m.call( a, c ) ) {
					return false;
				}
			}
			return true
		};
		b.isElement = function ( a ) {
			return!!(a && a.nodeType == 1)
		};
		b.isArray = p || function ( a ) {
			return l.call( a ) == "[object Array]"
		};
		b.isObject = function ( a ) {
			return a === Object( a )
		};
		b.isArguments = l.call( arguments ) == "[object Arguments]" ? function ( a ) {
			return l.call( a ) == "[object Arguments]"
		} :
		                function ( a ) {
			                return!(!a || !m.call( a, "callee" ))
		                };
		b.isFunction = function ( a ) {
			return l.call( a ) == "[object Function]"
		};
		b.isString = function ( a ) {
			return l.call( a ) == "[object String]"
		};
		b.isNumber = function ( a ) {
			return l.call( a ) == "[object Number]"
		};
		b.isNaN = function ( a ) {
			return a !== a
		};
		b.isBoolean = function ( a ) {
			return a === true || a === false || l.call( a ) == "[object Boolean]"
		};
		b.isDate = function ( a ) {
			return l.call( a ) == "[object Date]"
		};
		b.isRegExp = function ( a ) {
			return l.call( a ) == "[object RegExp]"
		};
		b.isNull = function ( a ) {
			return a === null
		};
		b.isUndefined = function ( a ) {
			return a === void 0
		};
		b.noConflict = function () {
			s._ = F;
			return this
		};
		b.identity = function ( a ) {
			return a
		};
		b.times = function ( a, b, d ) {
			for ( var e = 0; e < a; e++ ) {
				b.call( d, e )
			}
		};
		b.escape = function ( a ) {
			return("" + a).replace( /&/g, "&amp;" ).replace( /</g, "&lt;" ).replace( />/g, "&gt;" ).replace( /"/g, "&quot;" ).replace( /'/g, "&#x27;" ).replace( /\//g, "&#x2F;" )
		};
		b.mixin = function ( a ) {
			j( b.functions( a ), function ( c ) {
				I( c, b[c] = a[c] )
			} )
		};
		var J = 0;
		b.uniqueId = function ( a ) {
			var b = J++;
			return a ? a + b : b
		};
		b.templateSettings = {evaluate : /<%([\s\S]+?)%>/g,
			interpolate : /<%=([\s\S]+?)%>/g, escape : /<%-([\s\S]+?)%>/g};
		b.template = function ( a, c ) {
			var d = b.templateSettings, d = "var __p=[],print=function(){__p.push.apply(__p,arguments);};with(obj||{}){__p.push('" + a.replace( /\\/g, "\\\\" ).replace( /'/g, "\\'" ).replace( d.escape,
				function ( a, b ) {
					return"',_.escape(" + b.replace( /\\'/g, "'" ) + "),'"
				} ).replace( d.interpolate,
				function ( a, b ) {
					return"'," + b.replace( /\\'/g, "'" ) + ",'"
				} ).replace( d.evaluate || null,
				function ( a, b ) {
					return"');" + b.replace( /\\'/g, "'" ).replace( /[\r\n\t]/g, " " ) + ";__p.push('"
				} ).replace( /\r/g,
				"\\r" ).replace( /\n/g, "\\n" ).replace( /\t/g, "\\t" ) + "');}return __p.join('');", e = new Function( "obj", "_", d );
			return c ? e( c, b ) : function ( a ) {
				return e( a, b )
			}
		};
		var n = function ( a ) {
			this._wrapped = a
		};
		b.prototype = n.prototype;
		var u = function ( a, c ) {
			return c ? b( a ).chain() : a
		}, I = function ( a, c ) {
			n.prototype[a] = function () {
				var a = i.call( arguments );
				G.call( a, this._wrapped );
				return u( c.apply( b, a ), this._chain )
			}
		};
		b.mixin( b );
		j( "pop,push,reverse,shift,sort,splice,unshift".split( "," ), function ( a ) {
			var b = k[a];
			n.prototype[a] = function () {
				b.apply( this._wrapped,
					arguments );
				return u( this._wrapped, this._chain )
			}
		} );
		j( ["concat", "join", "slice"], function ( a ) {
			var b = k[a];
			n.prototype[a] = function () {
				return u( b.apply( this._wrapped, arguments ), this._chain )
			}
		} );
		n.prototype.chain = function () {
			this._chain = true;
			return this
		};
		n.prototype.value = function () {
			return this._wrapped
		}
	}).call( this );


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	var define = false;
	
	(function() {
	  var AjaxMonitor, Bar, DocumentMonitor, ElementMonitor, ElementTracker, EventLagMonitor, Evented, Events, NoTargetError, Pace, RequestIntercept, SOURCE_KEYS, Scaler, SocketRequestTracker, XHRRequestTracker, animation, avgAmplitude, bar, cancelAnimation, cancelAnimationFrame, defaultOptions, extend, extendNative, getFromDOM, getIntercept, handlePushState, ignoreStack, init, now, options, requestAnimationFrame, result, runAnimation, scalers, shouldIgnoreURL, shouldTrack, source, sources, uniScaler, _WebSocket, _XDomainRequest, _XMLHttpRequest, _i, _intercept, _len, _pushState, _ref, _ref1, _replaceState,
	    __slice = [].slice,
	    __hasProp = {}.hasOwnProperty,
	    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  defaultOptions = {
	    catchupTime: 100,
	    initialRate: .03,
	    minTime: 250,
	    ghostTime: 100,
	    maxProgressPerFrame: 20,
	    easeFactor: 1.25,
	    startOnPageLoad: true,
	    restartOnPushState: true,
	    restartOnRequestAfter: 500,
	    target: 'body',
	    elements: {
	      checkInterval: 100,
	      selectors: ['body']
	    },
	    eventLag: {
	      minSamples: 10,
	      sampleCount: 3,
	      lagThreshold: 3
	    },
	    ajax: {
	      trackMethods: ['GET'],
	      trackWebSockets: true,
	      ignoreURLs: []
	    }
	  };
	
	  now = function() {
	    var _ref;
	    return (_ref = typeof performance !== "undefined" && performance !== null ? typeof performance.now === "function" ? performance.now() : void 0 : void 0) != null ? _ref : +(new Date);
	  };
	
	  requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
	
	  cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
	
	  if (requestAnimationFrame == null) {
	    requestAnimationFrame = function(fn) {
	      return setTimeout(fn, 50);
	    };
	    cancelAnimationFrame = function(id) {
	      return clearTimeout(id);
	    };
	  }
	
	  runAnimation = function(fn) {
	    var last, tick;
	    last = now();
	    tick = function() {
	      var diff;
	      diff = now() - last;
	      if (diff >= 33) {
	        last = now();
	        return fn(diff, function() {
	          return requestAnimationFrame(tick);
	        });
	      } else {
	        return setTimeout(tick, 33 - diff);
	      }
	    };
	    return tick();
	  };
	
	  result = function() {
	    var args, key, obj;
	    obj = arguments[0], key = arguments[1], args = 3 <= arguments.length ? __slice.call(arguments, 2) : [];
	    if (typeof obj[key] === 'function') {
	      return obj[key].apply(obj, args);
	    } else {
	      return obj[key];
	    }
	  };
	
	  extend = function() {
	    var key, out, source, sources, val, _i, _len;
	    out = arguments[0], sources = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    for (_i = 0, _len = sources.length; _i < _len; _i++) {
	      source = sources[_i];
	      if (source) {
	        for (key in source) {
	          if (!__hasProp.call(source, key)) continue;
	          val = source[key];
	          if ((out[key] != null) && typeof out[key] === 'object' && (val != null) && typeof val === 'object') {
	            extend(out[key], val);
	          } else {
	            out[key] = val;
	          }
	        }
	      }
	    }
	    return out;
	  };
	
	  avgAmplitude = function(arr) {
	    var count, sum, v, _i, _len;
	    sum = count = 0;
	    for (_i = 0, _len = arr.length; _i < _len; _i++) {
	      v = arr[_i];
	      sum += Math.abs(v);
	      count++;
	    }
	    return sum / count;
	  };
	
	  getFromDOM = function(key, json) {
	    var data, e, el;
	    if (key == null) {
	      key = 'options';
	    }
	    if (json == null) {
	      json = true;
	    }
	    el = document.querySelector("[data-pace-" + key + "]");
	    if (!el) {
	      return;
	    }
	    data = el.getAttribute("data-pace-" + key);
	    if (!json) {
	      return data;
	    }
	    try {
	      return JSON.parse(data);
	    } catch (_error) {
	      e = _error;
	      return typeof console !== "undefined" && console !== null ? console.error("Error parsing inline pace options", e) : void 0;
	    }
	  };
	
	  Evented = (function() {
	    function Evented() {}
	
	    Evented.prototype.on = function(event, handler, ctx, once) {
	      var _base;
	      if (once == null) {
	        once = false;
	      }
	      if (this.bindings == null) {
	        this.bindings = {};
	      }
	      if ((_base = this.bindings)[event] == null) {
	        _base[event] = [];
	      }
	      return this.bindings[event].push({
	        handler: handler,
	        ctx: ctx,
	        once: once
	      });
	    };
	
	    Evented.prototype.once = function(event, handler, ctx) {
	      return this.on(event, handler, ctx, true);
	    };
	
	    Evented.prototype.off = function(event, handler) {
	      var i, _ref, _results;
	      if (((_ref = this.bindings) != null ? _ref[event] : void 0) == null) {
	        return;
	      }
	      if (handler == null) {
	        return delete this.bindings[event];
	      } else {
	        i = 0;
	        _results = [];
	        while (i < this.bindings[event].length) {
	          if (this.bindings[event][i].handler === handler) {
	            _results.push(this.bindings[event].splice(i, 1));
	          } else {
	            _results.push(i++);
	          }
	        }
	        return _results;
	      }
	    };
	
	    Evented.prototype.trigger = function() {
	      var args, ctx, event, handler, i, once, _ref, _ref1, _results;
	      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	      if ((_ref = this.bindings) != null ? _ref[event] : void 0) {
	        i = 0;
	        _results = [];
	        while (i < this.bindings[event].length) {
	          _ref1 = this.bindings[event][i], handler = _ref1.handler, ctx = _ref1.ctx, once = _ref1.once;
	          handler.apply(ctx != null ? ctx : this, args);
	          if (once) {
	            _results.push(this.bindings[event].splice(i, 1));
	          } else {
	            _results.push(i++);
	          }
	        }
	        return _results;
	      }
	    };
	
	    return Evented;
	
	  })();
	
	  Pace = window.Pace || {};
	
	  window.Pace = Pace;
	
	  extend(Pace, Evented.prototype);
	
	  options = Pace.options = extend({}, defaultOptions, window.paceOptions, getFromDOM());
	
	  _ref = ['ajax', 'document', 'eventLag', 'elements'];
	  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	    source = _ref[_i];
	    if (options[source] === true) {
	      options[source] = defaultOptions[source];
	    }
	  }
	
	  NoTargetError = (function(_super) {
	    __extends(NoTargetError, _super);
	
	    function NoTargetError() {
	      _ref1 = NoTargetError.__super__.constructor.apply(this, arguments);
	      return _ref1;
	    }
	
	    return NoTargetError;
	
	  })(Error);
	
	  Bar = (function() {
	    function Bar() {
	      this.progress = 0;
	    }
	
	    Bar.prototype.getElement = function() {
	      var targetElement;
	      if (this.el == null) {
	        targetElement = document.querySelector(options.target);
	        if (!targetElement) {
	          throw new NoTargetError;
	        }
	        this.el = document.createElement('div');
	        this.el.className = "pace pace-active";
	        document.body.className = document.body.className.replace(/pace-done/g, '');
	        document.body.className += ' pace-running';
	        this.el.innerHTML = '<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>';
	        if (targetElement.firstChild != null) {
	          targetElement.insertBefore(this.el, targetElement.firstChild);
	        } else {
	          targetElement.appendChild(this.el);
	        }
	      }
	      return this.el;
	    };
	
	    Bar.prototype.finish = function() {
	      var el;
	      el = this.getElement();
	      el.className = el.className.replace('pace-active', '');
	      el.className += ' pace-inactive';
	      document.body.className = document.body.className.replace('pace-running', '');
	      return document.body.className += ' pace-done';
	    };
	
	    Bar.prototype.update = function(prog) {
	      this.progress = prog;
	      return this.render();
	    };
	
	    Bar.prototype.destroy = function() {
	      try {
	        this.getElement().parentNode.removeChild(this.getElement());
	      } catch (_error) {
	        NoTargetError = _error;
	      }
	      return this.el = void 0;
	    };
	
	    Bar.prototype.render = function() {
	      var el, key, progressStr, transform, _j, _len1, _ref2;
	      if (document.querySelector(options.target) == null) {
	        return false;
	      }
	      el = this.getElement();
	      transform = "translate3d(" + this.progress + "%, 0, 0)";
	      _ref2 = ['webkitTransform', 'msTransform', 'transform'];
	      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	        key = _ref2[_j];
	        el.children[0].style[key] = transform;
	      }
	      if (!this.lastRenderedProgress || this.lastRenderedProgress | 0 !== this.progress | 0) {
	        el.children[0].setAttribute('data-progress-text', "" + (this.progress | 0) + "%");
	        if (this.progress >= 100) {
	          progressStr = '99';
	        } else {
	          progressStr = this.progress < 10 ? "0" : "";
	          progressStr += this.progress | 0;
	        }
	        el.children[0].setAttribute('data-progress', "" + progressStr);
	      }
	      return this.lastRenderedProgress = this.progress;
	    };
	
	    Bar.prototype.done = function() {
	      return this.progress >= 100;
	    };
	
	    return Bar;
	
	  })();
	
	  Events = (function() {
	    function Events() {
	      this.bindings = {};
	    }
	
	    Events.prototype.trigger = function(name, val) {
	      var binding, _j, _len1, _ref2, _results;
	      if (this.bindings[name] != null) {
	        _ref2 = this.bindings[name];
	        _results = [];
	        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	          binding = _ref2[_j];
	          _results.push(binding.call(this, val));
	        }
	        return _results;
	      }
	    };
	
	    Events.prototype.on = function(name, fn) {
	      var _base;
	      if ((_base = this.bindings)[name] == null) {
	        _base[name] = [];
	      }
	      return this.bindings[name].push(fn);
	    };
	
	    return Events;
	
	  })();
	
	  _XMLHttpRequest = window.XMLHttpRequest;
	
	  _XDomainRequest = window.XDomainRequest;
	
	  _WebSocket = window.WebSocket;
	
	  extendNative = function(to, from) {
	    var e, key, _results;
	    _results = [];
	    for (key in from.prototype) {
	      try {
	        if ((to[key] == null) && typeof from[key] !== 'function') {
	          if (typeof Object.defineProperty === 'function') {
	            _results.push(Object.defineProperty(to, key, {
	              get: function() {
	                return from.prototype[key];
	              },
	              configurable: true,
	              enumerable: true
	            }));
	          } else {
	            _results.push(to[key] = from.prototype[key]);
	          }
	        } else {
	          _results.push(void 0);
	        }
	      } catch (_error) {
	        e = _error;
	      }
	    }
	    return _results;
	  };
	
	  ignoreStack = [];
	
	  Pace.ignore = function() {
	    var args, fn, ret;
	    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    ignoreStack.unshift('ignore');
	    ret = fn.apply(null, args);
	    ignoreStack.shift();
	    return ret;
	  };
	
	  Pace.track = function() {
	    var args, fn, ret;
	    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
	    ignoreStack.unshift('track');
	    ret = fn.apply(null, args);
	    ignoreStack.shift();
	    return ret;
	  };
	
	  shouldTrack = function(method) {
	    var _ref2;
	    if (method == null) {
	      method = 'GET';
	    }
	    if (ignoreStack[0] === 'track') {
	      return 'force';
	    }
	    if (!ignoreStack.length && options.ajax) {
	      if (method === 'socket' && options.ajax.trackWebSockets) {
	        return true;
	      } else if (_ref2 = method.toUpperCase(), __indexOf.call(options.ajax.trackMethods, _ref2) >= 0) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  RequestIntercept = (function(_super) {
	    __extends(RequestIntercept, _super);
	
	    function RequestIntercept() {
	      var monitorXHR,
	        _this = this;
	      RequestIntercept.__super__.constructor.apply(this, arguments);
	      monitorXHR = function(req) {
	        var _open;
	        _open = req.open;
	        return req.open = function(type, url, async) {
	          if (shouldTrack(type)) {
	            _this.trigger('request', {
	              type: type,
	              url: url,
	              request: req
	            });
	          }
	          return _open.apply(req, arguments);
	        };
	      };
	      window.XMLHttpRequest = function(flags) {
	        var req;
	        req = new _XMLHttpRequest(flags);
	        monitorXHR(req);
	        return req;
	      };
	      try {
	        extendNative(window.XMLHttpRequest, _XMLHttpRequest);
	      } catch (_error) {}
	      if (_XDomainRequest != null) {
	        window.XDomainRequest = function() {
	          var req;
	          req = new _XDomainRequest;
	          monitorXHR(req);
	          return req;
	        };
	        try {
	          extendNative(window.XDomainRequest, _XDomainRequest);
	        } catch (_error) {}
	      }
	      if ((_WebSocket != null) && options.ajax.trackWebSockets) {
	        window.WebSocket = function(url, protocols) {
	          var req;
	          if (protocols != null) {
	            req = new _WebSocket(url, protocols);
	          } else {
	            req = new _WebSocket(url);
	          }
	          if (shouldTrack('socket')) {
	            _this.trigger('request', {
	              type: 'socket',
	              url: url,
	              protocols: protocols,
	              request: req
	            });
	          }
	          return req;
	        };
	        try {
	          extendNative(window.WebSocket, _WebSocket);
	        } catch (_error) {}
	      }
	    }
	
	    return RequestIntercept;
	
	  })(Events);
	
	  _intercept = null;
	
	  getIntercept = function() {
	    if (_intercept == null) {
	      _intercept = new RequestIntercept;
	    }
	    return _intercept;
	  };
	
	  shouldIgnoreURL = function(url) {
	    var pattern, _j, _len1, _ref2;
	    _ref2 = options.ajax.ignoreURLs;
	    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	      pattern = _ref2[_j];
	      if (typeof pattern === 'string') {
	        if (url.indexOf(pattern) !== -1) {
	          return true;
	        }
	      } else {
	        if (pattern.test(url)) {
	          return true;
	        }
	      }
	    }
	    return false;
	  };
	
	  getIntercept().on('request', function(_arg) {
	    var after, args, request, type, url;
	    type = _arg.type, request = _arg.request, url = _arg.url;
	    if (shouldIgnoreURL(url)) {
	      return;
	    }
	    if (!Pace.running && (options.restartOnRequestAfter !== false || shouldTrack(type) === 'force')) {
	      args = arguments;
	      after = options.restartOnRequestAfter || 0;
	      if (typeof after === 'boolean') {
	        after = 0;
	      }
	      return setTimeout(function() {
	        var stillActive, _j, _len1, _ref2, _ref3, _results;
	        if (type === 'socket') {
	          stillActive = request.readyState < 2;
	        } else {
	          stillActive = (0 < (_ref2 = request.readyState) && _ref2 < 4);
	        }
	        if (stillActive) {
	          Pace.restart();
	          _ref3 = Pace.sources;
	          _results = [];
	          for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
	            source = _ref3[_j];
	            if (source instanceof AjaxMonitor) {
	              source.watch.apply(source, args);
	              break;
	            } else {
	              _results.push(void 0);
	            }
	          }
	          return _results;
	        }
	      }, after);
	    }
	  });
	
	  AjaxMonitor = (function() {
	    function AjaxMonitor() {
	      var _this = this;
	      this.elements = [];
	      getIntercept().on('request', function() {
	        return _this.watch.apply(_this, arguments);
	      });
	    }
	
	    AjaxMonitor.prototype.watch = function(_arg) {
	      var request, tracker, type, url;
	      type = _arg.type, request = _arg.request, url = _arg.url;
	      if (shouldIgnoreURL(url)) {
	        return;
	      }
	      if (type === 'socket') {
	        tracker = new SocketRequestTracker(request);
	      } else {
	        tracker = new XHRRequestTracker(request);
	      }
	      return this.elements.push(tracker);
	    };
	
	    return AjaxMonitor;
	
	  })();
	
	  XHRRequestTracker = (function() {
	    function XHRRequestTracker(request) {
	      var event, size, _j, _len1, _onreadystatechange, _ref2,
	        _this = this;
	      this.progress = 0;
	      if (window.ProgressEvent != null) {
	        size = null;
	        request.addEventListener('progress', function(evt) {
	          if (evt.lengthComputable) {
	            return _this.progress = 100 * evt.loaded / evt.total;
	          } else {
	            return _this.progress = _this.progress + (100 - _this.progress) / 2;
	          }
	        }, false);
	        _ref2 = ['load', 'abort', 'timeout', 'error'];
	        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	          event = _ref2[_j];
	          request.addEventListener(event, function() {
	            return _this.progress = 100;
	          }, false);
	        }
	      } else {
	        _onreadystatechange = request.onreadystatechange;
	        request.onreadystatechange = function() {
	          var _ref3;
	          if ((_ref3 = request.readyState) === 0 || _ref3 === 4) {
	            _this.progress = 100;
	          } else if (request.readyState === 3) {
	            _this.progress = 50;
	          }
	          return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
	        };
	      }
	    }
	
	    return XHRRequestTracker;
	
	  })();
	
	  SocketRequestTracker = (function() {
	    function SocketRequestTracker(request) {
	      var event, _j, _len1, _ref2,
	        _this = this;
	      this.progress = 0;
	      _ref2 = ['error', 'open'];
	      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	        event = _ref2[_j];
	        request.addEventListener(event, function() {
	          return _this.progress = 100;
	        }, false);
	      }
	    }
	
	    return SocketRequestTracker;
	
	  })();
	
	  ElementMonitor = (function() {
	    function ElementMonitor(options) {
	      var selector, _j, _len1, _ref2;
	      if (options == null) {
	        options = {};
	      }
	      this.elements = [];
	      if (options.selectors == null) {
	        options.selectors = [];
	      }
	      _ref2 = options.selectors;
	      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	        selector = _ref2[_j];
	        this.elements.push(new ElementTracker(selector));
	      }
	    }
	
	    return ElementMonitor;
	
	  })();
	
	  ElementTracker = (function() {
	    function ElementTracker(selector) {
	      this.selector = selector;
	      this.progress = 0;
	      this.check();
	    }
	
	    ElementTracker.prototype.check = function() {
	      var _this = this;
	      if (document.querySelector(this.selector)) {
	        return this.done();
	      } else {
	        return setTimeout((function() {
	          return _this.check();
	        }), options.elements.checkInterval);
	      }
	    };
	
	    ElementTracker.prototype.done = function() {
	      return this.progress = 100;
	    };
	
	    return ElementTracker;
	
	  })();
	
	  DocumentMonitor = (function() {
	    DocumentMonitor.prototype.states = {
	      loading: 0,
	      interactive: 50,
	      complete: 100
	    };
	
	    function DocumentMonitor() {
	      var _onreadystatechange, _ref2,
	        _this = this;
	      this.progress = (_ref2 = this.states[document.readyState]) != null ? _ref2 : 100;
	      _onreadystatechange = document.onreadystatechange;
	      document.onreadystatechange = function() {
	        if (_this.states[document.readyState] != null) {
	          _this.progress = _this.states[document.readyState];
	        }
	        return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
	      };
	    }
	
	    return DocumentMonitor;
	
	  })();
	
	  EventLagMonitor = (function() {
	    function EventLagMonitor() {
	      var avg, interval, last, points, samples,
	        _this = this;
	      this.progress = 0;
	      avg = 0;
	      samples = [];
	      points = 0;
	      last = now();
	      interval = setInterval(function() {
	        var diff;
	        diff = now() - last - 50;
	        last = now();
	        samples.push(diff);
	        if (samples.length > options.eventLag.sampleCount) {
	          samples.shift();
	        }
	        avg = avgAmplitude(samples);
	        if (++points >= options.eventLag.minSamples && avg < options.eventLag.lagThreshold) {
	          _this.progress = 100;
	          return clearInterval(interval);
	        } else {
	          return _this.progress = 100 * (3 / (avg + 3));
	        }
	      }, 50);
	    }
	
	    return EventLagMonitor;
	
	  })();
	
	  Scaler = (function() {
	    function Scaler(source) {
	      this.source = source;
	      this.last = this.sinceLastUpdate = 0;
	      this.rate = options.initialRate;
	      this.catchup = 0;
	      this.progress = this.lastProgress = 0;
	      if (this.source != null) {
	        this.progress = result(this.source, 'progress');
	      }
	    }
	
	    Scaler.prototype.tick = function(frameTime, val) {
	      var scaling;
	      if (val == null) {
	        val = result(this.source, 'progress');
	      }
	      if (val >= 100) {
	        this.done = true;
	      }
	      if (val === this.last) {
	        this.sinceLastUpdate += frameTime;
	      } else {
	        if (this.sinceLastUpdate) {
	          this.rate = (val - this.last) / this.sinceLastUpdate;
	        }
	        this.catchup = (val - this.progress) / options.catchupTime;
	        this.sinceLastUpdate = 0;
	        this.last = val;
	      }
	      if (val > this.progress) {
	        this.progress += this.catchup * frameTime;
	      }
	      scaling = 1 - Math.pow(this.progress / 100, options.easeFactor);
	      this.progress += scaling * this.rate * frameTime;
	      this.progress = Math.min(this.lastProgress + options.maxProgressPerFrame, this.progress);
	      this.progress = Math.max(0, this.progress);
	      this.progress = Math.min(100, this.progress);
	      this.lastProgress = this.progress;
	      return this.progress;
	    };
	
	    return Scaler;
	
	  })();
	
	  sources = null;
	
	  scalers = null;
	
	  bar = null;
	
	  uniScaler = null;
	
	  animation = null;
	
	  cancelAnimation = null;
	
	  Pace.running = false;
	
	  handlePushState = function() {
	    if (options.restartOnPushState) {
	      return Pace.restart();
	    }
	  };
	
	  if (window.history.pushState != null) {
	    _pushState = window.history.pushState;
	    window.history.pushState = function() {
	      handlePushState();
	      return _pushState.apply(window.history, arguments);
	    };
	  }
	
	  if (window.history.replaceState != null) {
	    _replaceState = window.history.replaceState;
	    window.history.replaceState = function() {
	      handlePushState();
	      return _replaceState.apply(window.history, arguments);
	    };
	  }
	
	  SOURCE_KEYS = {
	    ajax: AjaxMonitor,
	    elements: ElementMonitor,
	    document: DocumentMonitor,
	    eventLag: EventLagMonitor
	  };
	
	  (init = function() {
	    var type, _j, _k, _len1, _len2, _ref2, _ref3, _ref4;
	    Pace.sources = sources = [];
	    _ref2 = ['ajax', 'elements', 'document', 'eventLag'];
	    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
	      type = _ref2[_j];
	      if (options[type] !== false) {
	        sources.push(new SOURCE_KEYS[type](options[type]));
	      }
	    }
	    _ref4 = (_ref3 = options.extraSources) != null ? _ref3 : [];
	    for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
	      source = _ref4[_k];
	      sources.push(new source(options));
	    }
	    Pace.bar = bar = new Bar;
	    scalers = [];
	    return uniScaler = new Scaler;
	  })();
	
	  Pace.stop = function() {
	    Pace.trigger('stop');
	    Pace.running = false;
	    bar.destroy();
	    cancelAnimation = true;
	    if (animation != null) {
	      if (typeof cancelAnimationFrame === "function") {
	        cancelAnimationFrame(animation);
	      }
	      animation = null;
	    }
	    return init();
	  };
	
	  Pace.restart = function() {
	    Pace.trigger('restart');
	    Pace.stop();
	    return Pace.start();
	  };
	
	  Pace.go = function() {
	    var start;
	    Pace.running = true;
	    bar.render();
	    start = now();
	    cancelAnimation = false;
	    return animation = runAnimation(function(frameTime, enqueueNextFrame) {
	      var avg, count, done, element, elements, i, j, remaining, scaler, scalerList, sum, _j, _k, _len1, _len2, _ref2;
	      remaining = 100 - bar.progress;
	      count = sum = 0;
	      done = true;
	      for (i = _j = 0, _len1 = sources.length; _j < _len1; i = ++_j) {
	        source = sources[i];
	        scalerList = scalers[i] != null ? scalers[i] : scalers[i] = [];
	        elements = (_ref2 = source.elements) != null ? _ref2 : [source];
	        for (j = _k = 0, _len2 = elements.length; _k < _len2; j = ++_k) {
	          element = elements[j];
	          scaler = scalerList[j] != null ? scalerList[j] : scalerList[j] = new Scaler(element);
	          done &= scaler.done;
	          if (scaler.done) {
	            continue;
	          }
	          count++;
	          sum += scaler.tick(frameTime);
	        }
	      }
	      avg = sum / count;
	      bar.update(uniScaler.tick(frameTime, avg));
	      if (bar.done() || done || cancelAnimation) {
	        bar.update(100);
	        Pace.trigger('done');
	        return setTimeout(function() {
	          bar.finish();
	          Pace.running = false;
	          return Pace.trigger('hide');
	        }, Math.max(options.ghostTime, Math.max(options.minTime - (now() - start), 0)));
	      } else {
	        return enqueueNextFrame();
	      }
	    });
	  };
	
	  Pace.start = function(_options) {
	    extend(options, _options);
	    Pace.running = true;
	    try {
	      bar.render();
	    } catch (_error) {
	      NoTargetError = _error;
	    }
	    if (!document.querySelector('.pace')) {
	      return setTimeout(Pace.start, 50);
	    } else {
	      Pace.trigger('start');
	      return Pace.go();
	    }
	  };
	
	  if (typeof define === 'function' && define.amd) {
	    define(['pace'], function() {
	      return Pace;
	    });
	  } else if (true) {
	    module.exports = Pace;
	  } else {
	    if (options.startOnPageLoad) {
	      Pace.start();
	    }
	  }
	
	}).call(this);
	


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// commons-d698821e5bd9f7b5ef38.js